import { BallType } from 'lib_ts/enums/machine.enums';
import { IMachineState } from 'lib_ts/interfaces/i-machine-state';

export type IRangeTestMs = IMachineState & { id: string };

// ? use something like the following to fix the MSS provided w/ hashes and ids
// const RAW_MSS: IMachineState[] = [];

// useEffect(() => {
//   const fixedMss = RAW_MSS.map((m, i) => {
//     const o: IRangeTestMs = {
//       ...m,
//       id: `range-test-20260619-${i}`,
//       full_hash: MachineHelper.getMSHash('full', m),
//       matching_hash: MachineHelper.getMSHash('matching', m),
//     };

//     return o;
//   });

//   const blob = new Blob([JSON.stringify(fixedMss)], { type: 'text/json' });
//   MiscHelper.saveAs(blob, 'fixed.json');
// }, []);

export const RANGE_TEST_MSS: IRangeTestMs[] = [
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'be80a58cea21e2ae6f37c287f1477d7d317a5a26',
    id: 'range-test-20260619-0',
    matching_hash: '5a94ee5c9425af266aaae8bd29989c2fe85bb656',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '084de03525fdc677f3b16f8311802c910336f473',
    id: 'range-test-20260619-1',
    matching_hash: '5c59910feb57128372b7ed7663093a43d03685f6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '1b9cc63fcc506b6a363ac8d1287dc406819bdc41',
    id: 'range-test-20260619-2',
    matching_hash: '7bb5a4c396ae8271f2d5377d3161b73ac5e60aa5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'a18a62754f959bb2874ecd2f9b2efb40920a33f3',
    id: 'range-test-20260619-3',
    matching_hash: '2bf2ce602fe95ba03c1fd84027c3c35111ff4a6f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'b07fefb22f8faab2b6005f803a5cfa4d2f5811a8',
    id: 'range-test-20260619-4',
    matching_hash: '5585ee423dc247576ff58bfbc18511cb594e729f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'e7aaa1663f3e034828ed19f6aac934c7144515aa',
    id: 'range-test-20260619-5',
    matching_hash: '5016227e05adb0f221a7bd1b1d5706f08de5c163',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '33e9a7a05ffbd6291f8bf7e44d7895d5f04b3872',
    id: 'range-test-20260619-6',
    matching_hash: '7f6afd4211eb14180696f039cbcb542e93f1c8d5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '9059fd029e2d2a2cf725606c53c984268381a07e',
    id: 'range-test-20260619-7',
    matching_hash: '1fca7836dd4685c83e3c95397f606c4c537a4452',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'f2aa9e08f04d33cd8735d934e7c217a307a828c8',
    id: 'range-test-20260619-8',
    matching_hash: 'ffbe31717d6011c956a3bf6f0a44d7a5a3fa1776',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '43c4a54e5063d1a87ea68f2ef3580a6223658cc6',
    id: 'range-test-20260619-9',
    matching_hash: '75252a111bb08f8ef8c03cf701874e0a4943c26b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '99988e258fa3cc59378aba9e4314a2eacbb4a7b4',
    id: 'range-test-20260619-10',
    matching_hash: '8cc7b85312003d4402e072165a6582d94c19d298',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '0b541bd83a58689d943ab139db8adfcbfd69c5d1',
    id: 'range-test-20260619-11',
    matching_hash: '158379592e780b6c045bbf57e2dd3d8695c20bdd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'c0a9a23e1d2a944f406f7b9d147125736e214cc7',
    id: 'range-test-20260619-12',
    matching_hash: '18c66ce87362bb9db6e3995a93ee466222e9573c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '1eb58838f0df004d15e62e0c728864df6ea657e7',
    id: 'range-test-20260619-13',
    matching_hash: 'df99fde6aa8dd857991b23e244e52bb0eb9c3e56',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '6332e010c96c3cd5d4bc4c96bd1afe9ce53caffe',
    id: 'range-test-20260619-14',
    matching_hash: '93d42ba7eb59ae3330fc90ea5288fe1c20b5829f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'd02a14415cfdd9032761f1a6af987273c29d8dc6',
    id: 'range-test-20260619-15',
    matching_hash: '94578baf9b7b37605c1b6f2a451811702b1ab64c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '1de77621cf00697fcc0e9dcd794e5bd7ee7f0841',
    id: 'range-test-20260619-16',
    matching_hash: '1c5169edbc1da2e4698c16e7709e5a94af1aa2a8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'e50d1fabc5b3ab22c4f8a691363ea7a0fa949df8',
    id: 'range-test-20260619-17',
    matching_hash: '1ee7f8199d345ad07e3d2efcedcc1f44cf727030',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'ac3600bfbdc0314ebaad12ee0550f4442479e282',
    id: 'range-test-20260619-18',
    matching_hash: 'e92f51af8f388907d75f34cd1bca7fc67a81f4d1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'bc77c33a21524fe9465c0d1b6c82d20ef775504c',
    id: 'range-test-20260619-19',
    matching_hash: 'af959e0bcf18c2689f7f37e692ea5f918dd1229b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '5b9ac686a244966d3b673ab9dd6d5476442e82f6',
    id: 'range-test-20260619-20',
    matching_hash: '382a97ee7146020d7f1f77eb8fd9aae582656292',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'a7d614498439e198e5198b40c5acb42dcf6b4a4f',
    id: 'range-test-20260619-21',
    matching_hash: 'a029d003462e6beca330e5b27a0fd7e03d4d715a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '7ee73275d5dc78da3c2cbde06109f258664167d0',
    id: 'range-test-20260619-22',
    matching_hash: 'f41d152b7399964814ac1e7ad63a5593274364af',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '3ac3936df2e11e55d11857f52bd006dd4e31ea57',
    id: 'range-test-20260619-23',
    matching_hash: '3803181059088f57f912fd568d4545d975f1efaa',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '339e746bfdc1a49ff3dcf3e4fa8f5b5c58893f10',
    id: 'range-test-20260619-24',
    matching_hash: '32a9d7461336d71e52d8a23295ca5a3ee7b04c5f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'db4e9ded9d05d4e0549945fee7ea7ea6a83e7055',
    id: 'range-test-20260619-25',
    matching_hash: '85c96827afec84dfdc57ee09e0c1efdf5068f6e6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '2ade3e18c38762cebc0127cf9e90f62e7e6547a8',
    id: 'range-test-20260619-26',
    matching_hash: 'b41eed0721083372969e165f5fbc68211d30121a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'c8a37c60e3821401ef142e9adb92e9a1149b2ba6',
    id: 'range-test-20260619-27',
    matching_hash: '663a5a43453a41435ad7c3d9351036d40896efe1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'c1ad38c665c039ede4220f9273c3017c096aed7a',
    id: 'range-test-20260619-28',
    matching_hash: 'a1ddf30b0ca3619a729480352e58ca440d0d8f13',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'fe31e060db173aeae9f3442ba6c773d3ccd044e6',
    id: 'range-test-20260619-29',
    matching_hash: '4f6952d40df8f9c4b153a28e44a90e5ca56e4963',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '305599cb95e8c8e11058f421ee4a570748305281',
    id: 'range-test-20260619-30',
    matching_hash: 'd6df35c40c5aac0e6f1ae0542b0dee78c1288ea4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '164eeb4d24ae3fed6694a172d0296b9cc7498c7b',
    id: 'range-test-20260619-31',
    matching_hash: '374dac0803a61a77794760c93f119fa1df9bfdbf',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '99024f5c92e418e7767f1830195ea608abe1a5f2',
    id: 'range-test-20260619-32',
    matching_hash: '57ad022cb9046cf44aa1af9f6c098a9455885842',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '7996b2ca67b3a63e5535a17e06c9c87c62813ee3',
    id: 'range-test-20260619-33',
    matching_hash: '84e65a118d83a67d3a549f791655e1a665f8cd32',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '28e15326875b707cf3468159a97dbc56f48244f7',
    id: 'range-test-20260619-34',
    matching_hash: '00d657b73fe0a4080e7add11bf635b0138dccad8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'fbfcc7066242a156802e64e70eebb92b325af4f6',
    id: 'range-test-20260619-35',
    matching_hash: '7d82eab0232ce2e0dc4348b9e215b2bef78301e5',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '9bda2fade42c8f3e64123e017cd0cedb8a6ae97d',
    id: 'range-test-20260619-36',
    matching_hash: 'ea5438cf8ae494c772e220e6a6e61d525d494b8e',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '13fc63df5d664e2aefb47dfb48aeebcab533dc9d',
    id: 'range-test-20260619-37',
    matching_hash: 'b63340251c21057d25cb479b5c6258d7b04ba3fb',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '2149d91b4f0cf5570f035819e91550a09700eaec',
    id: 'range-test-20260619-38',
    matching_hash: 'c7f5a2ef2ab52100e2b0b8e4c89df4a94940e645',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '82b444fafa50b0b16673c81778531745ac916c24',
    id: 'range-test-20260619-39',
    matching_hash: 'cd2328ae92e53de9b2b30528755cfdba9ff57da4',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '7ad2346434d62d91dd560fecf95614b0f8747bfe',
    id: 'range-test-20260619-40',
    matching_hash: '932a088fa0c12121b4064c29056142b355cc5b1a',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'f2a3f73504d2624144c48dc6a0c9016c2a6b68b1',
    id: 'range-test-20260619-41',
    matching_hash: 'dd1452d48563d8c1d4e38888afbb835ef8aa2bff',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '84828487355df5192ee6ccd72b0b21be20aaf32a',
    id: 'range-test-20260619-42',
    matching_hash: '29b302391b9ed5b8e07a974d2f7baf1b40a5ef95',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '0edd7e44090dc3c425eba83b6f2386854ddee5f2',
    id: 'range-test-20260619-43',
    matching_hash: 'a0904c25675a761b857ad59521a576bce0d19f3b',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '43229a52004d7ad0fdddf608c30ff8980b403868',
    id: 'range-test-20260619-44',
    matching_hash: 'e872f7c55a52e9d467772d12b8c2e8d7e5a0a139',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '3cdb2b84f65885f3c6cd2b41ae92b6fe8359074f',
    id: 'range-test-20260619-45',
    matching_hash: '9347c57528d750f891b34099599f42ef42d54c73',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '2388d79e9f1ba1e065dc098ab5313fa8105de3ea',
    id: 'range-test-20260619-46',
    matching_hash: 'bea559117bddd89eb71da762f97ed40fedf67737',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '4db5c7b6e4600b00daff23feb69b368c5ed62363',
    id: 'range-test-20260619-47',
    matching_hash: '841698e8375cd041724ca5da54e9db7b7e1355b3',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'ccc4c29961ae18a3e2909870b3394a2e61767aec',
    id: 'range-test-20260619-48',
    matching_hash: '08a084d12e22cfb8585213a3054721cbc9323b60',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'dc25dce8c396d2086d20cd59c2f22b24388767f3',
    id: 'range-test-20260619-49',
    matching_hash: 'cb5a70b56af88267c6884bb62edb4efbdacc665f',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'af6e6e8da08cbac484c61142ceb92d36ac319d65',
    id: 'range-test-20260619-50',
    matching_hash: '39eac2a0ff30a6e9db108190416abed9c6170e04',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'd6dbf45e4ab7a9e047ef0d5613911bff9da0b397',
    id: 'range-test-20260619-51',
    matching_hash: '0846792d11378eaae2a11ea349e6c154f30fccfb',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '7c49198d833e3c52dfb52c2dd475026c79cbe71d',
    id: 'range-test-20260619-52',
    matching_hash: '4dc8d3f732220313c99033a4d26bad92a3534e41',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '7f163f73774a23436e42c0ad6c26fc899c0a3e6c',
    id: 'range-test-20260619-53',
    matching_hash: '63c4d2d38902196155406bbdc7402bca2b145904',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '1432278d70fedbb55bf50d2d32fe083489eff205',
    id: 'range-test-20260619-54',
    matching_hash: '6dd0a7962a8adbdcb493ff9b93cefe8ee25b949e',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'cbcbc84ff05c31d3edd3ab5cdfc8d86c10298c0b',
    id: 'range-test-20260619-55',
    matching_hash: '315bd43c5a784b57946881952870290b44441c4e',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'e7fcaffb479397395b54e80fe664efa736603e67',
    id: 'range-test-20260619-56',
    matching_hash: '356d8811fa5e08dd7a9efe6c9ef9f0643b2ac8d2',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'fb16f315a2f5f437c5ecb223de31156fd14f7ad6',
    id: 'range-test-20260619-57',
    matching_hash: '1c1f8db969510f23e70ac3875e960e9d58989e2a',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'ff6be4d5de352d1afe03faac8a41313ef1eeea44',
    id: 'range-test-20260619-58',
    matching_hash: 'd3fce1ae7b6cde370ec0f3521c916c3836e00e61',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'fb384db85c59d3c413d5cd645c9f49a55968fe95',
    id: 'range-test-20260619-59',
    matching_hash: 'e96621874b0d6427a61f4c77d7a9e793b4be3a73',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '95197567254e9b341c13eaf30b25467efbbaebbf',
    id: 'range-test-20260619-60',
    matching_hash: '7dc6e112108cf1e588081ca35f76df4716b0574c',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '4a9d8cb2e6c64d29ff540a08a195744a219d101a',
    id: 'range-test-20260619-61',
    matching_hash: '87d729e84b06b4942c122943ed86e5a4074cda75',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '528be30b587cb34093e1733c10b0acd1c75eee33',
    id: 'range-test-20260619-62',
    matching_hash: '5b6e88776a29be59e9a0a2788b20de942021449d',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'd501f2b8613a840668b705ef16da3a1984f6a8b0',
    id: 'range-test-20260619-63',
    matching_hash: 'f0760eeb7a805788cb3de2b45c2c684516b47d8d',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '4177c87d95b7731984d7515c6f43ac65f04f6f8f',
    id: 'range-test-20260619-64',
    matching_hash: '32ade5610058c51cdd7a755314825ce18ea67538',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'ca62ac8896d048dc617002fb02d51685d30b48bf',
    id: 'range-test-20260619-65',
    matching_hash: 'df3f1ebdb08ffb17149bb3f58bbce73e14b8a373',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '0cddc8141ee1427fc5ea04ec9cdd15ff1a7ecf8f',
    id: 'range-test-20260619-66',
    matching_hash: '79ca58d6bf9bd56ed2cf5f5303472684982372b5',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '4f44a4ea1a55d31e1742bbb04c041f048f3e32be',
    id: 'range-test-20260619-67',
    matching_hash: '11bd8c1e9158b40ebb08c22e4f27a132b801d9a6',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'd63d4a81915ded8083e9a7cd800ed71f90eaf013',
    id: 'range-test-20260619-68',
    matching_hash: 'b629ca8020843cd4aa97004f5d856385b4f5e440',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '5883981eb88a2e34e7716ec711fd7bc09530ae56',
    id: 'range-test-20260619-69',
    matching_hash: 'efc39d96992c5521d420c9074668a2449961b935',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '010b2d80b2ea3abc3e6c78e4e7058822be602442',
    id: 'range-test-20260619-70',
    matching_hash: '2a72415d5e33e40b09f2e013516baf4e5ffc5467',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '32a42dd6a65d87f7c26be83c4dfacd868f3c17be',
    id: 'range-test-20260619-71',
    matching_hash: '70ae8393dd2259e0e36885c6cecb103c0d925dcc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'dc1a6f96cea9f93a6d998b07268eba59ae4815e7',
    id: 'range-test-20260619-72',
    matching_hash: 'fc84fc34c74dbd9f68cda73193569a9eacbc0da3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '851e15d47a531682c2858c7eb94539416acb02bb',
    id: 'range-test-20260619-73',
    matching_hash: '58bf90c25e188e78d5c44ff814f88fa9ff5fe267',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'b079ff46f998d9cd5fbad3f442bab33fad47f742',
    id: 'range-test-20260619-74',
    matching_hash: 'a3def672b528657a145a9774f597b8d2a3cd6fcb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'f42e5f6b331b73a70b2be38fc0c02f0ed5b824d8',
    id: 'range-test-20260619-75',
    matching_hash: 'bdb4e66edd139cbb0b3a94ee27f76d784b7aef65',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '17ebb87c21e58049f4f5d3781485f22ea347f680',
    id: 'range-test-20260619-76',
    matching_hash: 'a377318bd1796fe10a5538aefece042c640441bf',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '7cbae7cf1588477f5fe23bfc245f3babc1e15a55',
    id: 'range-test-20260619-77',
    matching_hash: '4f88350cc60956b1d068988c7d00567d4f5f2567',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '0074f8eb9e857205259c6c58cb23b0ddfa538529',
    id: 'range-test-20260619-78',
    matching_hash: '2481e96f0b3143e1226035ce27cc249f85076384',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '039bb8345c1398a4acc6926e23cc4e7398f520f7',
    id: 'range-test-20260619-79',
    matching_hash: '0b1b62d468deadda4c1c60f726f3372fb5e75b95',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'cba900b68b14a803ae80b562d085524586f6317f',
    id: 'range-test-20260619-80',
    matching_hash: '391809e864c1ac2cd81cff1bb64e24f5112a955a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '6e31943fc63cdd75ac92db08900086a2d5fb1ca0',
    id: 'range-test-20260619-81',
    matching_hash: 'b8ba5bd7f7b8f6e8a212da03364fc90cd2693b1b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'c15b5fc62d87a390674e30f9664f9b53a3c9bac6',
    id: 'range-test-20260619-82',
    matching_hash: '4a724d91bc0790383baae373bd114ae6e2a8d014',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'd45da0142ad5ce7df4d69cf6f92b7a5409cf5b72',
    id: 'range-test-20260619-83',
    matching_hash: '593ffc8dedef408cd350dc2a326e73b305a869e8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'd1cd6cb5c8cf859d8edbaebbb77e3f69b7134ee9',
    id: 'range-test-20260619-84',
    matching_hash: '6b75b6eafe7bb06568b65b9152500cdd99796b49',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'a6f56aeff07e0af80044f1a2a1cd4a4be068eb46',
    id: 'range-test-20260619-85',
    matching_hash: '96c665d72267ccf278b1ea3a5864d9a121cf0981',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '142e0269faf362763206f1ecfe8625b5625de336',
    id: 'range-test-20260619-86',
    matching_hash: '9b4b960d011158d4246fd72575f0cc5dfdae17c6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'f42711cdedcbd0ede6561d55fd1920aed56e615c',
    id: 'range-test-20260619-87',
    matching_hash: '4e5b3a22375ac93e606693116b0757bb01a9d5c1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'eefec129244e15510fb88adbe04c477ef643bf9b',
    id: 'range-test-20260619-88',
    matching_hash: '664c10a67c3adfeaab2fdc81b3a9704c9bd05e17',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '545eb298aa29aa7f55c8e95d21f1a7aee69b455c',
    id: 'range-test-20260619-89',
    matching_hash: '1b92fc48763e75b9f535b627bccdcf7883f55b7a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '063710ec1bf705154bf7117b4a2072f282ad4327',
    id: 'range-test-20260619-90',
    matching_hash: '2578812db98875badf39fdf1cf465c3a8b02c8b5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '1f56b9a3a5fee7de0757ac0dbc2adf8f51777f91',
    id: 'range-test-20260619-91',
    matching_hash: 'ec607efc3fa49990f27e5d62626f5c8e49d3fc2f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '93a28a38616e6351dde2b054b69d6b826e57e087',
    id: 'range-test-20260619-92',
    matching_hash: '6d0a9a454535018ac1cdb7fb05c2ccc521f9194d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'b9506aad0930d0037c12d8c8040bf4ca8f2e6f0b',
    id: 'range-test-20260619-93',
    matching_hash: '379c1c62788f3a6ca2c1d3c3108dae78db3eeb72',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '132105e5d819879c2736a91511c09edadf94669e',
    id: 'range-test-20260619-94',
    matching_hash: 'c122eec22944f8c9b1d5df6c737933cee40b8928',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '307346509d6173cd79f3f366dfdada623d33f664',
    id: 'range-test-20260619-95',
    matching_hash: '0b826998acbab33ab2834083939d8d9b35c091dd',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'fc6ec32225bd224f965f50d64a3df18b204fdc92',
    id: 'range-test-20260619-96',
    matching_hash: '6e6247a90b2333ec3d00471ebde2ebae99290be4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '1b02d922cd4ec18f47f02a04a300e25166b5fc49',
    id: 'range-test-20260619-97',
    matching_hash: '34d1d0ceaccbd78ee83bda7003a8168f0ebceb6d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'd8a2cfdfa4f6702408aaafb6256c9506daca2b03',
    id: 'range-test-20260619-98',
    matching_hash: 'b8ab7af406e76b886c6b67006e1b042d51efd064',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'fe034b2abeb6f83097e84b2e2ab23adff1da5e2f',
    id: 'range-test-20260619-99',
    matching_hash: '0345ec76f5acb271c88944927d4b5141a87e169b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '07e675d3b66d420c8539aaf418cec43d051638fd',
    id: 'range-test-20260619-100',
    matching_hash: 'd5e5ad97ee4d4e207395d03f96c5c49a66ec7f6e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.300011028,
    qx: -0.674021909,
    qy: -0.225380066,
    qz: -0.636310989,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '115bd7c3ffdca2d02bf46cfd4084023da4ca01f5',
    id: 'range-test-20260619-101',
    matching_hash: '123c9f9a34098c0d161f073e3d92d6053c35672c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '2edcbe50a65cb614a9e64e476b1547513d778685',
    id: 'range-test-20260619-102',
    matching_hash: 'd7cc21de12a5495aca988daea5303958674351d0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '145eea39fa3902eb31f3f1e3ba501415f0a591ba',
    id: 'range-test-20260619-103',
    matching_hash: 'ba4f93b1f60af96b4e66c23843ac2ddf581f9dcc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '39e1cffe448f92c0de16a020cd0821b7c3677ba3',
    id: 'range-test-20260619-104',
    matching_hash: '10b827d159e0a88254799375f9dad38c101191ca',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '469a81ab197d849e721150e1eb7a3b909874c18d',
    id: 'range-test-20260619-105',
    matching_hash: '6356019df8da56052d84f9374aaca7e9b110fcba',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '116f66f1809b2dc2b3b2a911b4cdfd7c3444af6e',
    id: 'range-test-20260619-106',
    matching_hash: 'cad5f0a0f84ee45d9d0119301f144faaa9fc7c2c',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '735372341c94abad17fd1518a29dd7e534172abb',
    id: 'range-test-20260619-107',
    matching_hash: '0b314c7d87e683f48d62c8cd4143686a4f8a7641',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'fe43e9669ae0ac63d091fbda01c3526e2c2940e9',
    id: 'range-test-20260619-108',
    matching_hash: '07fcd268bb065469bc935b0a13c9a4f5ce3aaf75',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'f7b61d6d89d0a6fa0410593006c24f46543c5502',
    id: 'range-test-20260619-109',
    matching_hash: '2bbff5557b9976e3ebb0f82139b3406fade45f50',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'cf8404a7a3749c1c8ead0cf03a3c8e078579dc3e',
    id: 'range-test-20260619-110',
    matching_hash: '780c5d6c4f2be867ed126cc2147869755711f642',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '342c9374b77e2e9868d67eef73594fb449cec799',
    id: 'range-test-20260619-111',
    matching_hash: '9876767fe761b93d5f4ee999ae3754394ea61c40',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '02034d795ee89aeb7db936392c875edcd5002946',
    id: 'range-test-20260619-112',
    matching_hash: '194dd3728f7905d5bf5c340b527f69318c8af553',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'f817229bc34b726459c0924baf6189d8144823ec',
    id: 'range-test-20260619-113',
    matching_hash: '04dcf544a428ac677c3be1f3e8f1c9a8c8dfa88d',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '05943677ccfcc1f3c9ef00e89d83aa2f9726a10a',
    id: 'range-test-20260619-114',
    matching_hash: '97f5423eadaea62ca29ed23efa2848bba8c390dd',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '954464e815ac4e17bf562bfa853987fbf7626388',
    id: 'range-test-20260619-115',
    matching_hash: '589eaab66a9d527e019df67c12fc879e0192c5b6',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'ec80fbccdc98e5681372001092c25b1908a687d2',
    id: 'range-test-20260619-116',
    matching_hash: 'eae7b51e82e276a488ba233f240adef231a66bb5',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'ade8977819a5785aeea1eb5cc826aedd75dcc78e',
    id: 'range-test-20260619-117',
    matching_hash: 'b8636f2d2a6781e6c92e1201c9684ca693b76a55',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'a40abc15fbbee9dae5118a347081e7014d7e6b86',
    id: 'range-test-20260619-118',
    matching_hash: '6520cb7a6947bf223a31b7031f48bb53e45bac88',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '0bf4d6fe192f756fe52e162da94632a293bc2e25',
    id: 'range-test-20260619-119',
    matching_hash: 'a6b1ebe8316c286869a000e4e4411982723b1db6',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '8b035f27e93d71521432cd9faaffc2f7b0a4561a',
    id: 'range-test-20260619-120',
    matching_hash: 'a1760a579ad30eed3b00449ec35ff5d0ed719f64',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'a92df6a0ef0014ec5c0df979a324097d92a5a006',
    id: 'range-test-20260619-121',
    matching_hash: '8ec24f51ab7a8189b5387712eca61a35eb295119',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'cc8a3f123cd29d26cc5d190c512bd8a41dde4141',
    id: 'range-test-20260619-122',
    matching_hash: '9da0c29473d35f9de4dc5b523bf672a13ba00b5d',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '3cb6e0a38486a13822dc18d1c882737dec29fdfb',
    id: 'range-test-20260619-123',
    matching_hash: '1a19d8edf03416d9cf1a25ff0358499aef26edd9',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '3c962c3ca3954727a6bf58adac15e9a0ab7fa4c0',
    id: 'range-test-20260619-124',
    matching_hash: '94020ee7408ae4482c85b6806decbd033dad80dd',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'f18a6f1b36ad4bfcc8ab428c5a880bc015018b08',
    id: 'range-test-20260619-125',
    matching_hash: '53d065b0d8293c98bf2a7a1aa7faf03db0ea67b4',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'b25dd34039543a11e5701323ffa705e9f4fadd30',
    id: 'range-test-20260619-126',
    matching_hash: 'abc68c021ad5b036142051940c6cc2aa7aa5c7b1',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '91f08823e3513d2257951975607aa9e18b0b43a9',
    id: 'range-test-20260619-127',
    matching_hash: 'cecdf86144d5e30808970f7465c5ef9df3bf9875',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '101e5f838e3f4cd4d5d702326e3de2887db13560',
    id: 'range-test-20260619-128',
    matching_hash: '29e786ffb08c25682fdbafac843e2474bb466cbf',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'e5c7504a913cffbb775547fe77efff25020b4ccf',
    id: 'range-test-20260619-129',
    matching_hash: '9d448bd3ef0f7fc9a5723720e8d710fa31027d01',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'd479f4aa6a97dd9c91c8e4036a7e75acc758fcc9',
    id: 'range-test-20260619-130',
    matching_hash: '9b8a8fb949b5cbfd68b91e9324a5e321c33ed501',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'e1c69adc92a22dbbe2633102ba455ebb7eede6d9',
    id: 'range-test-20260619-131',
    matching_hash: '3088a2c6aedd1fe340056e6f304ef4075fbf47f1',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '82d1a83b07c4f4ded5063f8923b1ad58ae905723',
    id: 'range-test-20260619-132',
    matching_hash: 'adf501de69d1478b1b73e01338b3a0a127948c17',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '627c3a1c67a53ba2a8f54a0f8cfd79b15c99a9d2',
    id: 'range-test-20260619-133',
    matching_hash: '1cdd0b86543edafa0785fd5075b008a27d9a71ec',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '4cceb08dbebbf46464b1313bbb38a2fa8b865e4f',
    id: 'range-test-20260619-134',
    matching_hash: '0f708997616a050b150308207bbfe70c438d1f7b',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '4eb4445681a70bd6b7b500655985faefec185ca9',
    id: 'range-test-20260619-135',
    matching_hash: '2f792e0746b09ae36a03e8d704f82891c3252f71',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'afa5f74ede9b8aff69168bd6dc537a563dcad8b4',
    id: 'range-test-20260619-136',
    matching_hash: '60f042909a2e13becdbb95c1198155e4b8947a13',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '4198ded92380a815e7481caf157dacec3f128ddd',
    id: 'range-test-20260619-137',
    matching_hash: '62a1ced684c6ff1b58da433ba726e19f8b026a8a',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '47e2485b2f604fe8c9bbc9d86c9efec6e8f58eb7',
    id: 'range-test-20260619-138',
    matching_hash: '6f5c1b631777e9383a6be78d683ae241a8d5de19',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'd5d2cf048102307c8655e3504a6127a39e4bae56',
    id: 'range-test-20260619-139',
    matching_hash: '614c18c36c497fa21e34f03404fde968e9f4d196',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '9b6a77b43d7645285a1c2383b7a31b0129f411bb',
    id: 'range-test-20260619-140',
    matching_hash: '1b6aeab65c81382b3943de99addf847fa124cd06',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'b367f0b053a4c0642a1df74fbdbded804f4375b7',
    id: 'range-test-20260619-141',
    matching_hash: '100554c59947961501b41f30be321d59598985a2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'd41ae0128fdcfc7c5e097f777a84a2f9f8359967',
    id: 'range-test-20260619-142',
    matching_hash: 'de510c4e32d7b60afc53e9ee13ec138165c2afa9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'c14941866df2ae33e414b88e27af44804644c84c',
    id: 'range-test-20260619-143',
    matching_hash: '823eecc7cd2f335309b2da39cf35b836b5d32394',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '3bc0887cb7709d32eb3aab888d8480421d25da40',
    id: 'range-test-20260619-144',
    matching_hash: '4a1216941f14daba00a407e45f44cd97aa2b750d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '5eab50eb89d69d7383043bee832d807cdb45e9d0',
    id: 'range-test-20260619-145',
    matching_hash: 'f36f81bcc746d272a9443fefb66dd63e3666403c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'd15d86964307895d9b01c50fa3bce6e92aea67d9',
    id: 'range-test-20260619-146',
    matching_hash: 'e1a75e3b8735cdbc98efedaf4d17b0162a36f3e9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '0c86b1d4ec1198094eeed329bf3ea05282edf8ed',
    id: 'range-test-20260619-147',
    matching_hash: '741c8073e133d6969da2c709964591731c5cc4b5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'dfb62c1739efbd7868a12e899a4d6cf8776c669e',
    id: 'range-test-20260619-148',
    matching_hash: '27b08546c0349c715d942eb77615f401559b0f0a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '60870ec3c49dcc8afcf709e9041c810c8df67cc7',
    id: 'range-test-20260619-149',
    matching_hash: 'd81f71b7065c3e94ef66580a46de054c6b00e0ba',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'e041ef9d75bfa710639dd6452b6c17b2f8281891',
    id: 'range-test-20260619-150',
    matching_hash: 'fcb2668d8976007b77d367b7becf64d4ddc2aa6d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '25799318e4d7d2dbac93d16fe754ba5a5240adb9',
    id: 'range-test-20260619-151',
    matching_hash: 'fb7cd8eafdea0561a5d376be43c8c17e33405584',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'fdf60cf7584804e6d44d5c3fccd7348deac416f2',
    id: 'range-test-20260619-152',
    matching_hash: 'cf3cb77629281f665d2023304b0530410f92f631',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '7145709b55f3ca0946dd3701aa9a4cffe9e36e39',
    id: 'range-test-20260619-153',
    matching_hash: '732ca34adcf6c44c81d4f8ede40949498d36940b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '2247589f3198d6f981f07531b76fd947d237dd35',
    id: 'range-test-20260619-154',
    matching_hash: 'c814b931aebaace3e27fe3178843b10e4f376e00',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '528bbbbf5da4318d28533e0318f7ba96d5a151fb',
    id: 'range-test-20260619-155',
    matching_hash: '59eef0b69f0642775881e11c125d454835587e83',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'bc739d6720f8132473d95299eec43507f4e2e92b',
    id: 'range-test-20260619-156',
    matching_hash: 'd8d1ed291afc927afd32e38e9e159e94b13538e9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '98c441dca657b69ba24a214e9a6847da0bef2aa2',
    id: 'range-test-20260619-157',
    matching_hash: 'f83d5482247ecc97efdbb904b0d9f17cd9a15f2e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'bb79d33d2fabe985240a24a6adea6da2315168e4',
    id: 'range-test-20260619-158',
    matching_hash: '4a0a2ad1d818bc321c02346eb1d08cfd62db8954',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'ba1d6a8d37a3532ee5d58af3523fe16f74d39d68',
    id: 'range-test-20260619-159',
    matching_hash: '128cf5f4cabbab932b4f48dbbf7b2b8c777d9ea5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'a3ad5b1f93c162d0cd4b1a40317cfb591e7ad840',
    id: 'range-test-20260619-160',
    matching_hash: '9eea41fed17965bc1e877d7d9d211c5b5e1ad0ee',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '5fc9d9a88571c034a4a5667c51ad602820499f42',
    id: 'range-test-20260619-161',
    matching_hash: '06f2cce4c703d03c7e7b8d19122e6eb4935a0fdf',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '50a9a196b2075b4e6d35ff7329ea58d80cd9c047',
    id: 'range-test-20260619-162',
    matching_hash: '3b675868208419006f66b7db1cf419ca416d07ab',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '5e144abb0e4e7eb241cef261c6aa519ee2b66477',
    id: 'range-test-20260619-163',
    matching_hash: 'c39e8e43070aa9879c9acd8037dd737b24c4c90a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '5a8900f212c31e777bc9584f621d3ddecb0bea65',
    id: 'range-test-20260619-164',
    matching_hash: '72ce22cccb53fd0a8d2ff179e59954427bb553fe',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '74f4dc47a0703c1e0ddfb19b492224ff010f672a',
    id: 'range-test-20260619-165',
    matching_hash: '84ab8044f77a2669f7e66248bdb226ba6968d5be',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '30eed28b414b4bfc407410e0f996e999b43571db',
    id: 'range-test-20260619-166',
    matching_hash: '2d88508e05c690f190f5b1c0f6a389a346342480',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'f7bea5e17a61420e3c916def0a92d801bc90d71f',
    id: 'range-test-20260619-167',
    matching_hash: 'ceca41927012ef59978e265ad9d74bb14d16fb85',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '689f96c2072cc596fe7b4bc733835ae7d7b04068',
    id: 'range-test-20260619-168',
    matching_hash: '8c19aef091893aeae11bef1d7134f45896598e71',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '30e3ea0f1a803ef712e0e42d1c334eaab6f6dee3',
    id: 'range-test-20260619-169',
    matching_hash: '4dcf85e227f31a3eebf099604fba0dd37b2e1b1a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '954475a9821b2d5e356e69232d064f35d8a417fb',
    id: 'range-test-20260619-170',
    matching_hash: '9a9646da53dc392981b86fd43ee67137e54849f8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '3e11b95a511787ee1f342ec3052b2500c20b87ac',
    id: 'range-test-20260619-171',
    matching_hash: '99a9527b1382bd0f687e8e8a1fed194879a568d0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '206e895fb7e2e2143b67b6cebfeae458c5850bcc',
    id: 'range-test-20260619-172',
    matching_hash: '06cb7ca9ae497699200c53d2f100c3c5d913c1f4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'd95ea8fd3f2fddaf66ff3742011239b854b8f219',
    id: 'range-test-20260619-173',
    matching_hash: '90659026e659f9f470beef11b3e0021145cf09e9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '777bf7ea66c15122b9768592fbf39e7a0e221338',
    id: 'range-test-20260619-174',
    matching_hash: '3d90c51d272e0d373b29242d931e9c1b56773849',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'b9277418b8d72a1bcb1fb0617637f2785fadd4ec',
    id: 'range-test-20260619-175',
    matching_hash: '6356019df8da56052d84f9374aaca7e9b110fcba',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'ca109b461e7f9c210a038b79092f85d99f1f67d7',
    id: 'range-test-20260619-176',
    matching_hash: 'cad5f0a0f84ee45d9d0119301f144faaa9fc7c2c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '0137a4c63f2b2300c8d5e17d42e4b02e14993bbe',
    id: 'range-test-20260619-177',
    matching_hash: '0b314c7d87e683f48d62c8cd4143686a4f8a7641',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '17cf88b2fa0d971b661a620d124073d2e113501e',
    id: 'range-test-20260619-178',
    matching_hash: '07fcd268bb065469bc935b0a13c9a4f5ce3aaf75',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '7da9437def246459f4037c1c0e56c90d7c7c2f84',
    id: 'range-test-20260619-179',
    matching_hash: '2bbff5557b9976e3ebb0f82139b3406fade45f50',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '3fd230d5e2f00f300b576ce3ea96d728a2e9cd06',
    id: 'range-test-20260619-180',
    matching_hash: '780c5d6c4f2be867ed126cc2147869755711f642',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '32f46df2a0b708103d9e2cf34ac955038d91a48a',
    id: 'range-test-20260619-181',
    matching_hash: '9876767fe761b93d5f4ee999ae3754394ea61c40',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '95a8d1274ead8c91b97698ae295260a5052ccc01',
    id: 'range-test-20260619-182',
    matching_hash: '194dd3728f7905d5bf5c340b527f69318c8af553',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '7cd9bf872d68166fd1b3ec6737dd2b4f87534600',
    id: 'range-test-20260619-183',
    matching_hash: '04dcf544a428ac677c3be1f3e8f1c9a8c8dfa88d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '967236bc7c6ce2e9e620246fed8032a9dbbfc71c',
    id: 'range-test-20260619-184',
    matching_hash: '97f5423eadaea62ca29ed23efa2848bba8c390dd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '2cb19db5ad0e49b01dcfa70168dfeae3ea237a61',
    id: 'range-test-20260619-185',
    matching_hash: '589eaab66a9d527e019df67c12fc879e0192c5b6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '6b61246a836329882c998c35869f6aab5cc84835',
    id: 'range-test-20260619-186',
    matching_hash: 'eae7b51e82e276a488ba233f240adef231a66bb5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'eb3f574d7d4cb566813869ddbda74893aa00993a',
    id: 'range-test-20260619-187',
    matching_hash: 'b8636f2d2a6781e6c92e1201c9684ca693b76a55',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'b2b3e292de8ed551c6d9b3728366159a30204c0b',
    id: 'range-test-20260619-188',
    matching_hash: '6520cb7a6947bf223a31b7031f48bb53e45bac88',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '8bc1a0feb419956ce4b6a67387b83eb32589b972',
    id: 'range-test-20260619-189',
    matching_hash: 'a6b1ebe8316c286869a000e4e4411982723b1db6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'ee736663728c5ea1f05a070dcabf7c0c12f1e2d0',
    id: 'range-test-20260619-190',
    matching_hash: 'a1760a579ad30eed3b00449ec35ff5d0ed719f64',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'f85591620f1dac367ff58945d374b6bf9c8f6b66',
    id: 'range-test-20260619-191',
    matching_hash: '8ec24f51ab7a8189b5387712eca61a35eb295119',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '6a6cb3eff489aff3a6f26265e3a9c103f8bc54d4',
    id: 'range-test-20260619-192',
    matching_hash: '9da0c29473d35f9de4dc5b523bf672a13ba00b5d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'a84dcbd9bd03bb5fe416d92f6869a07bc5822f10',
    id: 'range-test-20260619-193',
    matching_hash: '1a19d8edf03416d9cf1a25ff0358499aef26edd9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '6540dee5c304d2d5f5551adcc406acb91c024592',
    id: 'range-test-20260619-194',
    matching_hash: '94020ee7408ae4482c85b6806decbd033dad80dd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'd767ddbfbbc81bbd4498e8d5ba2b10a83f4c5eca',
    id: 'range-test-20260619-195',
    matching_hash: '53d065b0d8293c98bf2a7a1aa7faf03db0ea67b4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '6f1dab1d947ea67ee6afd0b341c6f3badc410344',
    id: 'range-test-20260619-196',
    matching_hash: 'abc68c021ad5b036142051940c6cc2aa7aa5c7b1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '5a0b1be1252de1308f8328f9d08f4385edf16696',
    id: 'range-test-20260619-197',
    matching_hash: 'cecdf86144d5e30808970f7465c5ef9df3bf9875',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '1630efb0f4f934be3cf44b3ee3a1aed618b0d950',
    id: 'range-test-20260619-198',
    matching_hash: '29e786ffb08c25682fdbafac843e2474bb466cbf',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '5ed7bf22d5c8ae77c097ea3d5892815b4f3c2a74',
    id: 'range-test-20260619-199',
    matching_hash: '9d448bd3ef0f7fc9a5723720e8d710fa31027d01',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'b97a6ff3ab3a47fc0dbe3abb1714c7a364f8c4ed',
    id: 'range-test-20260619-200',
    matching_hash: '9b8a8fb949b5cbfd68b91e9324a5e321c33ed501',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '7fe400e8f7c69c63e8792e3b553483d598c5d6b9',
    id: 'range-test-20260619-201',
    matching_hash: '3088a2c6aedd1fe340056e6f304ef4075fbf47f1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.931838365,
    qx: 0.213043173,
    qy: 0.011980124,
    qz: -0.293506976,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '6abd49c7046be4d5485374653cbe3ebf5b1f61df',
    id: 'range-test-20260619-202',
    matching_hash: 'ba9afd622840dacff2622f6e661721c98742647b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'c5890f3a8301e75546485b06a6ac70e9cc1d99e6',
    id: 'range-test-20260619-203',
    matching_hash: '1d00d090279adb102782a41a0b5b3361e29e9ca1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'cba345c537caa06c0ec339a01ad9ae3238524e17',
    id: 'range-test-20260619-204',
    matching_hash: '7fe4ebd1e1a279337b70edf6c82f7847f7c65be7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'dd9c6cb81356911a4f0f8aa75353ca9de2c1f48a',
    id: 'range-test-20260619-205',
    matching_hash: 'a342fa958b10a43e4c3828d1e59a5ca05172fc73',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'd77ab63add47e5aabf4335ec22f7774e53581628',
    id: 'range-test-20260619-206',
    matching_hash: 'caa9a520a621b495499831e7e3c7adaf27ef330a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '4432c1971807258cfec9de6a73ae5985999a7864',
    id: 'range-test-20260619-207',
    matching_hash: '075ad86dcf38a2089738e62cc4f52338b3972bcc',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'bc8195d14e0848fed4888ce46283a0edc2061d4b',
    id: 'range-test-20260619-208',
    matching_hash: '445742036d9a3f17ce088c5ff32132aec06561e3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'f41ad05d38624318ed0e168edd21842821a14a0c',
    id: 'range-test-20260619-209',
    matching_hash: '336b24f3e89935282dcd4753ce7e4328c26368d1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '20227a09fd933726258e0935f4d00177788f3196',
    id: 'range-test-20260619-210',
    matching_hash: 'bbb453c2e877394b56555bbbf7bfac8fe74f4cdf',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '7ab959332869692dc5b2030c01b6a4957a4039aa',
    id: 'range-test-20260619-211',
    matching_hash: 'ead6ab319d92cb2aa432756dcb7ae159481bd446',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'f158dab79b3e4907050717e13b846dd5d6704661',
    id: 'range-test-20260619-212',
    matching_hash: '29aa67290861cb23369ce4e2b4c908a3f7a8accf',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '08bed00bcf77575417f84cf050cc6316cc8b2785',
    id: 'range-test-20260619-213',
    matching_hash: '54c523047ed80dd57176129abface4ab0736d57f',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'd15d12a7a5e0c40a3df875572ed91016317a09c3',
    id: 'range-test-20260619-214',
    matching_hash: '990e42156955183f90e162d2afdfbcddb57a818b',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'e4eabaf1d7e531e43174b673ee7c6d93f58f26a4',
    id: 'range-test-20260619-215',
    matching_hash: '7ce53961a074c4f87ecb3a63199b6290547470c0',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'b68dcac08d9cc5a0ea88689e86e9a9011c77daa5',
    id: 'range-test-20260619-216',
    matching_hash: 'a0615537c94efffe7866c0f34722adac628ad804',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '5f11ed15d7aeb1131525420912d131484719382e',
    id: 'range-test-20260619-217',
    matching_hash: '06dd93d1b3c6b0a758dcd9ca3886a356052e3d9a',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '4485fb68ad7a8a1e7d1c530bb1630767f6108eb8',
    id: 'range-test-20260619-218',
    matching_hash: 'c9ead3edb464345e60152573aea19ea5f28d0773',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '6f9f2d73e07a8e70c6809dad314c89012bf0453e',
    id: 'range-test-20260619-219',
    matching_hash: 'e7b0d9c3b02552a3302edefa0ab7d2191c1778ae',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'e3f73a07c44217429fe5837a6cc1a6c256ba925b',
    id: 'range-test-20260619-220',
    matching_hash: 'fdddc6d66b9bc24d87a72a467b69cc1e8d14a14e',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '3c74fa22d596608b0b46523f638d70c91df13dd0',
    id: 'range-test-20260619-221',
    matching_hash: '28c5aa62579727f5646200b05e059095e09741ed',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '00d33a0f0e837a2e7def6b9e21e69938ed890481',
    id: 'range-test-20260619-222',
    matching_hash: 'aef1a37cfec496755b21354fb3cd9cb1d9794090',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '843dbd68b650ea9e9e4344df7585b2c43825fd11',
    id: 'range-test-20260619-223',
    matching_hash: '7c46fb78618937434092e5315ec68d3a57cdb97b',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'e100ddd0b19365781ef996b314b74add16c52207',
    id: 'range-test-20260619-224',
    matching_hash: 'a86ad85c33a1ed18963740abc1cbce1fe2e2e3da',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'bfd174a20345444a7b4c4526108a7b1136288ce3',
    id: 'range-test-20260619-225',
    matching_hash: '69d27a9e93d435b07ebf99834a95c546134c8ce1',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '2624fecf5af52a12830e2981e57bdf47be99e0bd',
    id: 'range-test-20260619-226',
    matching_hash: '787a2dac0e0dc3b16ad6aa825caa201fc7782fd5',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'bce708758721a361426ec42a7bf43dc70bb3d15d',
    id: 'range-test-20260619-227',
    matching_hash: 'a165dce5dac4acdf1a936a2d998da16b0e36f8a8',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '12173edc6f02f84e907bba6e131e5f6346547fee',
    id: 'range-test-20260619-228',
    matching_hash: '070bf44e16255fd91c49703402b95b51ac0a66f8',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'a8d72cc0678436d05c84f3021032f1069c9a1658',
    id: 'range-test-20260619-229',
    matching_hash: '93f39e1990af83ec42798de142c2a73632a30115',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'c63c264ba0b128dec04900729b58292904372512',
    id: 'range-test-20260619-230',
    matching_hash: '103b1a54a623a08d61e67f5e8a7758ff33072795',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'e77d28a586073c4c51d57e7df62639ea9e19b9a5',
    id: 'range-test-20260619-231',
    matching_hash: '4e417fe4d9c192811a1a838e6027f84e28190ef4',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '99e501ae11abca13fe89cb3c371c1b3f418a1a08',
    id: 'range-test-20260619-232',
    matching_hash: '26bf9a71234337ba85d07ae1abe7c898b67ab39e',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '8b1222aa2bbfa426f1f167edc1fd12f1d6a99fca',
    id: 'range-test-20260619-233',
    matching_hash: '776db5d0dc7dce59a9af97be3f4037f137e862eb',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '2f35b40544670d26c824a315906716329a00fe64',
    id: 'range-test-20260619-234',
    matching_hash: 'a27388dcf09364435ca9aa695779f7924627bec6',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '519ca07a53caf7e0b4dbfce6c1dbf0188775a469',
    id: 'range-test-20260619-235',
    matching_hash: 'f25ae4ad69156592f438fd29419a12c1d52dcb87',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '42fff8a8a5ed21c6f89aa66ff16790fc81027a5e',
    id: 'range-test-20260619-236',
    matching_hash: '997e04b0d4d10ee2ba6feb7291e7141f0051f46b',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '4d0bea2378e1044d5643f6f6e416bc26a8429477',
    id: 'range-test-20260619-237',
    matching_hash: 'ff31544dc99216859c27edcefdc3afb67bfa4f24',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '751f76dd277fb04efc23d7fc7f0d09c8f6cbe5a8',
    id: 'range-test-20260619-238',
    matching_hash: 'f5063ca6c81f265dceed72fa07d9e55b3e913420',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '87260a916e0dda2a0abf5e91225dc71b4da122df',
    id: 'range-test-20260619-239',
    matching_hash: '9e7473e181317cf7cc5ecd6931e3746aaca7c6b0',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'a80871aed1af101623290b75c4f56aeb4b9fda20',
    id: 'range-test-20260619-240',
    matching_hash: '0b54d6060a61884f8df215c3260b1c2b7e4bcd88',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'ed878a9b6c50e8957002e9a2fc6f2687e67ee1bb',
    id: 'range-test-20260619-241',
    matching_hash: 'b83b0eddb85d0d8e560649e8ec83eac061dc35e3',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '12fc4a8b95a7aa4c4be18df8555deaf56ec49aa4',
    id: 'range-test-20260619-242',
    matching_hash: '826b5dbe764a420b7a1e5e313eb00e98b4e29c16',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'b5af0a5b63a39022cb38c4960ee2f0f5c728fe2c',
    id: 'range-test-20260619-243',
    matching_hash: 'ac52ad3439d14486f41d2d7f2cd760d423571e6e',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'f5ec008a7c5aeb6cfd95c3e83e701f1e9d00d513',
    id: 'range-test-20260619-244',
    matching_hash: '8e4ba7745ff2df37659cceb671010b459e1bcf52',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '6cb47e65c4f93db7d216d2f2c601ccc7b1dc1cab',
    id: 'range-test-20260619-245',
    matching_hash: 'eb736648325e7c8c77cf71aff0c3e80f6c7eab49',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'c8b0b630687f2d9809dcfe2db3bde1643fabf056',
    id: 'range-test-20260619-246',
    matching_hash: 'a41aff2c9892d7279e19b4da68f40c44c8fd157e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'd13f4fbdbda0abf768e4b25a686969bd2dfd07c6',
    id: 'range-test-20260619-247',
    matching_hash: '196b12a01d95490d8f8001a31bba7a619012bbb4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'd9b97217abf0f2264a9f3c791a3e2e25275955c9',
    id: 'range-test-20260619-248',
    matching_hash: 'fa7740509a633609d6626d68ea0ed892659eea19',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '09298851eb8890be6dff7481246971bd4315734b',
    id: 'range-test-20260619-249',
    matching_hash: 'c3925adb01638c8b9b38af75ee1efd67e8889e21',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'f5b9cebf344181d288d72b802ed26acd22c13922',
    id: 'range-test-20260619-250',
    matching_hash: 'd19e1e85f823d0037ff194d6438590e08430ffd4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '56055af614414b38945c4ff0d3629e6950f85c71',
    id: 'range-test-20260619-251',
    matching_hash: '77e497d3d9089d6ac883983b38633e2c89f0edcc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '3a31d6b163b5a41e3e3ea2652be75e741448283d',
    id: 'range-test-20260619-252',
    matching_hash: '74fa88e2e1f99c1bb27c9fa7596bfeed8fd07e52',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '9b1618a883bcf9e3683c83157a0f6349e27528f8',
    id: 'range-test-20260619-253',
    matching_hash: '3a839fb79f1b549bdb3d51d92b9c31a93925bfcc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '0e7b1ce8c979ce837ce2f56b154102377bf975a2',
    id: 'range-test-20260619-254',
    matching_hash: '909333fc1f457a9cc2b2dc3f5101c590a9820a19',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'ea41e12e0c0afaf20513b778b500cb71d6dd6010',
    id: 'range-test-20260619-255',
    matching_hash: '7d1d2dcd1ab44ec940ac1a687f6ac31b5ebb7c2b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'fe1a29eb39f678636e7b70d134ed85ddbf176a72',
    id: 'range-test-20260619-256',
    matching_hash: 'a31196b8deff66f1fce791fd01726082e8ef3dd3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '4455090a645a35755c411c5fc80b7f1cd726eedc',
    id: 'range-test-20260619-257',
    matching_hash: '795a1b1e9f62b0922f56620cc6a87282b09131e8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'fb8bbf57add0eea4a4d0a995fb37757d34ff79eb',
    id: 'range-test-20260619-258',
    matching_hash: '61c98ab9f2a87c331b1cb6d763c8fb9917a5cf04',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'c1e4cf239061e99f56967b4be1e86f93dc1b2a9b',
    id: 'range-test-20260619-259',
    matching_hash: '58638d9362aec16f468e26341fe4554fc4ce85e0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'a4ad1251cf9d434155021eee68ab454b973a2b7a',
    id: 'range-test-20260619-260',
    matching_hash: '6625d60df979073b38273d3691f81fbf40898acb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'd6d0b1042c32cd5a6f53e65b19f859fa6494fb64',
    id: 'range-test-20260619-261',
    matching_hash: '259806a609dfed231d6ce2d309cd2a1eca079e0b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'a786f08ae62ff2cd3616caf11ea9263cd3c8cde6',
    id: 'range-test-20260619-262',
    matching_hash: 'ce624611bc6f8fcc90b1b5fcd173c19323703a79',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'c46f44773cf7f20627beb431cb8e3455e3bf80e1',
    id: 'range-test-20260619-263',
    matching_hash: 'c179052f596038478bc31aa7f1495b50a32af82d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '7580d39ba58d65947337b55f6197f2dde14bc6d3',
    id: 'range-test-20260619-264',
    matching_hash: '8d565514a1529a7636146945b1e6c321ceaab03f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '0ddb1cfa0c8d3df81c089edf926069f651f93418',
    id: 'range-test-20260619-265',
    matching_hash: '0e88fb667d8f350ec52d9f3fb59665caca8559d8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'cbb48b7a4e0691a66653bdf618e361cd39e4ad54',
    id: 'range-test-20260619-266',
    matching_hash: '242e5dcc8e95d1f819073e2e2f512f999d059a66',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'ed816007311155f2b2bc4dee249aedd23f9f0d1c',
    id: 'range-test-20260619-267',
    matching_hash: 'b31f0c22b6f8dd8d33d840dc9dd66efb94572c56',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'cf786515836ba0934cbcf5c423f97c68e71c790a',
    id: 'range-test-20260619-268',
    matching_hash: '1c8f54a320b45a608f1fab4ee6da01796095e9ec',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'd70ae08265f2efb7f0c08d59b037ee79f43b1b7a',
    id: 'range-test-20260619-269',
    matching_hash: '8c4031d0f3066b33d2d518a38cfcc84e809c9f4c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'ca3963445f0a1d58d1e73eeb0e59c5f91a05b2e2',
    id: 'range-test-20260619-270',
    matching_hash: '4fced97082894eff1e87d4e55fe1c711bac543a4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '7a521a74cb8e48822408c697e5e05ba066ed9bc8',
    id: 'range-test-20260619-271',
    matching_hash: '52c162e3a177e72ddf46fc7b7d517b5c73b2c19f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'b273e990d352c658a014af618424c1c473d41f40',
    id: 'range-test-20260619-272',
    matching_hash: '4aab834300f199f16ce25239fb3e7b130ede5b4c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'd0d1b7fcee1e15994e887f74100778fea026b3c9',
    id: 'range-test-20260619-273',
    matching_hash: '5c80025681ddfb614ee2f1aa1aef16e7330f89e3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'dd7de36efaf74bd0f5e9ef3a742e2a2e9c7b9b05',
    id: 'range-test-20260619-274',
    matching_hash: 'f72dfbed5e9576be070740610260ba3f9f414bb7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'bd7e90e2139363cb5342ce50ad24ab05e770daf8',
    id: 'range-test-20260619-275',
    matching_hash: '8b746d2fe7588ef04a8aa21f457622b5b3169c18',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '865db5af134800f0f81c8d798532c415d0837097',
    id: 'range-test-20260619-276',
    matching_hash: 'a9c81b97baa30e1084fe4ec9164522227874861a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '14e4e563e34d9e3f4a38932a497f42f1c76ef023',
    id: 'range-test-20260619-277',
    matching_hash: '0752a7ac4bf965065c05892a84e3d1dd4a6a1150',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '27473b98d2004682b423e7792d5c42387c120522',
    id: 'range-test-20260619-278',
    matching_hash: '5a32b94d6855e2f157e4757de039334a55467a05',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '8694ade1e430453d641c28fb97ea2331a86d2d92',
    id: 'range-test-20260619-279',
    matching_hash: '77488f09f82402f4bf9619d89caedfe5a195ed5c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'b2ef8ef7cfe947fad06b9615f458626524db3f16',
    id: 'range-test-20260619-280',
    matching_hash: '5ca503fbe2c67d1c7b80054af9e7f48fc3b9dd1c',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '13e48d45642e3ad377b39e20629040f287d64ffb',
    id: 'range-test-20260619-281',
    matching_hash: 'd7bcda80f9155eeae8bee09f9b103cd44f88c23c',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '2b8ccad2ba7e2544e25eeb956f2352bdba2db22b',
    id: 'range-test-20260619-282',
    matching_hash: '398fedf871930d562d2d0156896324eb651090d2',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '3b700fb0a67a72cc8a8c6fb6653024463f76d953',
    id: 'range-test-20260619-283',
    matching_hash: '5f3e661b59eafdb6b9c2971128b5cea9ea48396d',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '2a310db68c09de4a908c30974a0aa71b032b3dcd',
    id: 'range-test-20260619-284',
    matching_hash: '5398d59db73aefcf26249e909c018de9bc097bd7',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '2615bb5ad7b379e10d9df7ab4fa55bb2a4356e61',
    id: 'range-test-20260619-285',
    matching_hash: '72cbbbac7cb4be7e7ddb5af063e0e284f4b229f5',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'c4f455f6a392c6ece931465dac90ca3bfe4b510b',
    id: 'range-test-20260619-286',
    matching_hash: '71aa8fc3e573a8a4eb2116a9eecbe37add1866ca',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '008d5e5ab5afa4f0f3936c35e367dcd8bc93b462',
    id: 'range-test-20260619-287',
    matching_hash: '3e1fab9bf5e0bba8b557f9e0aa48b85f050792d5',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'b99d460ec17ad932d10284a5f45f296272ea4101',
    id: 'range-test-20260619-288',
    matching_hash: 'b69fbfd868fdef6815cde5475bc1b9f474cad97d',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '4e6b0b89b4282788128c108f23747d22e4d62ed1',
    id: 'range-test-20260619-289',
    matching_hash: 'c67655ad7fc1145e63705ed660319b0bb46f7bc6',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '18a9777820cac3954c901c27de8553884a7e840c',
    id: 'range-test-20260619-290',
    matching_hash: '14d3e766e84ccd902e15b5c117c114286fc0968f',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'b4d1858468ce48271d66052475d0e395ddabbba2',
    id: 'range-test-20260619-291',
    matching_hash: 'e7754376bbafd8033fe82915b5bbc6c696517732',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '406a0a9c1de96e0d5e108477756210c2364d6e7d',
    id: 'range-test-20260619-292',
    matching_hash: '32046f46d520e08635dc526e892c5b6b4fae7bf6',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '5c0970b4a58894fdf0167774b122f49f0489c401',
    id: 'range-test-20260619-293',
    matching_hash: 'b8baac80534bdbf198b13e745f557ee554297c3f',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '3aa002668fc35c1b1a3bbc9d37f581c035cdfbb1',
    id: 'range-test-20260619-294',
    matching_hash: 'd6d881c8d721a8378ba2cca791b6a48d5443f7da',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '0dd8028ae6e4f2d8b666863b430f1e29c884592c',
    id: 'range-test-20260619-295',
    matching_hash: 'bf50d20f9764a48aab097eddcaf3e072a77ae6a0',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'd3308495e27a47a7b4461b9a5d7a9ada6ba776ef',
    id: 'range-test-20260619-296',
    matching_hash: '2ef55ebdd8dbdd0622ad9ad4b7ffd72f603d45c5',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '8573fb7c1e4f8d8787d8ab6411df789671cad0ad',
    id: 'range-test-20260619-297',
    matching_hash: 'dde820d12e38eed01dad0ce9370a59bc765d9d8e',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'ee654deb76a4c37022276d5521552297b6c66e23',
    id: 'range-test-20260619-298',
    matching_hash: '46c81dfa583178bfcf8c6c88c2e9cb981a2b1fc8',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '8a2670136e40d5234de847f682d5dd6413701b03',
    id: 'range-test-20260619-299',
    matching_hash: 'ceff8ceb96a28d3b28045a59b7d7f502b69e12d9',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '6b76f41f4bb6eaaf87929f3dadea6b55d0bcadf6',
    id: 'range-test-20260619-300',
    matching_hash: '44189af812935161213619cb345d22c9c4bee3a2',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'b29c4bcfd3d12ace059770cf4830bad2ecadb80a',
    id: 'range-test-20260619-301',
    matching_hash: 'c825a508eea20f38ddc3bc8929bd7a42c1243490',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '61b1b889f57f1237686d03bcc8e00a9512845ee1',
    id: 'range-test-20260619-302',
    matching_hash: '64ad5b533d5a875cfd170f34f4b0decc20ea776a',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.741016861,
    qx: -0.348281962,
    qy: 0.462452707,
    qz: 0.340192858,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '2c599121fc4e66a1821098f90dcbaa5b75d8208f',
    id: 'range-test-20260619-303',
    matching_hash: '801b831ee85059fbd78fd16ebd337705e4ed2b53',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '6bb8bf088a66a920817c1abf3be3996a38bd8013',
    id: 'range-test-20260619-304',
    matching_hash: '63f737cc924199616f14404eedce0f59604d432f',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '0e5f50639c8d4940b9bf9cbae094e12dae76bf8c',
    id: 'range-test-20260619-305',
    matching_hash: '12e2d042d84c05db89ff5bd661f036fd88db13a9',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '6b946d7fb4feb525187cfa16ad34c9c9fac758bd',
    id: 'range-test-20260619-306',
    matching_hash: '9d35d4432b6d35da0685666fe9730b7da86818a6',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '8258af38d734f4c2b15644a1986ae2c3ccf2c3c7',
    id: 'range-test-20260619-307',
    matching_hash: 'e683aea9e87de85c427258e82f686e02b69525af',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '84adbe7c092bcb20a53a763dd176538e97582d39',
    id: 'range-test-20260619-308',
    matching_hash: 'cb7dab2201f6909a1cecc8d18a5871435d48349c',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '39844dd13dfff3e23db88bf778bfeaf3e6365bba',
    id: 'range-test-20260619-309',
    matching_hash: 'addc7df5b0089f0e01494fce944627a28501c945',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'b9d1908987303c1e618db7c6338419162a886772',
    id: 'range-test-20260619-310',
    matching_hash: '18b42934ae73ace20a2a18f88fccf962bdf78785',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'b2eaf18ad623c06ae5b52cf673db106b85f2dc42',
    id: 'range-test-20260619-311',
    matching_hash: '785e7b590ceaf4c00b93badb736eb3bd5b6a06b8',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '0664c9820b7f3c7fdb09a8e0571d2ed366146fd9',
    id: 'range-test-20260619-312',
    matching_hash: '1d74d524136cda54d6789e9a7e0a3fe1c3d99669',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '9ba41661c84f7cc0ac8213034e00a71e09dbff34',
    id: 'range-test-20260619-313',
    matching_hash: '2d0db56edfd06310dcdee6b6b0a4e9e0a06a4479',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '6466e255b8327de7bd6dc81c276c5ca0bd1a8a92',
    id: 'range-test-20260619-314',
    matching_hash: '0eba99055f7fb2b6ead2e85d63cdfa29c6ec4a09',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '8c2c759134ec896af54cdb04a44a0510a20af650',
    id: 'range-test-20260619-315',
    matching_hash: '667d4dd4706e00a3b1e3f21cc64e38b10c1bc76d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'ff9da468329ef9c0fe0a6a85c1fa70d746ce6e11',
    id: 'range-test-20260619-316',
    matching_hash: '0bff15ff97879c1b93e2962c82625811fd1d3729',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '27197d86d7c7035096e6d43e8155229d1f054c01',
    id: 'range-test-20260619-317',
    matching_hash: '6ef770d472bb62ba38715bbd9dbe9827158b3267',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '77f18fda15095ae346ae695fa71d5092d1109b76',
    id: 'range-test-20260619-318',
    matching_hash: '8eed0587e426ce8f9d2462ce2f2e725a34017f2f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '69cfa2b2cbce145e731c7aa4daeadfba5bfe40b3',
    id: 'range-test-20260619-319',
    matching_hash: '51049f49e16f38f9e23bb680e42c485eed61d48c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '7b271f6999d592a6ace9c11cae9e44907f26fb96',
    id: 'range-test-20260619-320',
    matching_hash: '600c5e445bb36fadf9e4f4e468778c89f8e42b0d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '57c2c2c866c5391923bbc940fbdfbc8dec31c75d',
    id: 'range-test-20260619-321',
    matching_hash: 'd5f8a8a377c39911e6fe5fc893136d9354771b0f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '5edf5cfdc19af9269506a28d13699dfa86d3f7e9',
    id: 'range-test-20260619-322',
    matching_hash: 'dfabb863beb9f5860f48c20fd70630d418ddf29a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '670e8383184ec6d377d8b6ac666bfa9becd46076',
    id: 'range-test-20260619-323',
    matching_hash: '2f399ecbc40b158a92725a08271b535e175bba67',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '5981663c5427affceb539f9bc53955ed1e8ae6fb',
    id: 'range-test-20260619-324',
    matching_hash: '50b171ca3e96014136dda40e30ad98c65936e4bc',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '30c8a1589f17b773c1e3d793b329f78fe16cfb4b',
    id: 'range-test-20260619-325',
    matching_hash: 'ccecc560d91ee1a2b8373ed159ac0e968d442f44',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '367ec60726034764b38b99c59a1811cce5b34a80',
    id: 'range-test-20260619-326',
    matching_hash: '82ede460092205dd845b85db74fff2a299e9f07b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'cc62373a607d77a382d6faef9bde6384c1189ca9',
    id: 'range-test-20260619-327',
    matching_hash: 'e13a0a03807140af78f3a432702cff38072b1fbd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '2374bbb8e701fca06a43f666e2384d83030b2dc5',
    id: 'range-test-20260619-328',
    matching_hash: '6ada9f682836e6111f57e5bbd952125beacc3305',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'adae1da73b75df5a0cc4763a23c5732c1ae2f33f',
    id: 'range-test-20260619-329',
    matching_hash: 'ee148301efa67aaac2cbf51813e044381ddea60f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'e89faaacf2566f544bab033d0fb53498190befa2',
    id: 'range-test-20260619-330',
    matching_hash: '21e4e1aa09ffda3f3005087fda86f0ed7935832c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'a40c7cb616cb20be02b3b6da84438e70b1c5b46f',
    id: 'range-test-20260619-331',
    matching_hash: '8d0a9d7df75eac31126dc938bffd8a0d81a61a68',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '16a051f46a360ea4dcbb23ebc015c4ccd5bcfcbb',
    id: 'range-test-20260619-332',
    matching_hash: '4fbdc6bd06648fed72ac75baaa17eedf5725d932',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'bb8f6271d46b9f113c8d141b6c623fc36cdc892b',
    id: 'range-test-20260619-333',
    matching_hash: '3735013f14462f7f6afc6fb7a466dbbf4f5bed7a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '802b1698025cd32ae959df3acc012777e93c4196',
    id: 'range-test-20260619-334',
    matching_hash: 'ccc7a487bbb88f749396fbcbf77f5fb71e058bb6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '36dad1d005b88c96a01a124585d3b588adb6188f',
    id: 'range-test-20260619-335',
    matching_hash: 'b1c95090c0c75cc19220bf1468a45d7f34e1cc03',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'f64332fbbf26914b2305248d16003eaa040f5131',
    id: 'range-test-20260619-336',
    matching_hash: 'c2b1290bcead237b3254245c88b1fc8c81d5ff2b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '319132da5e0c956f117640ada98e33f0d2126dd3',
    id: 'range-test-20260619-337',
    matching_hash: '1c28fa8ae7baded3421a9e47bda6c6111417c10c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'cfc8a689c4ba6e61d915c3b517a5eaf33a58618c',
    id: 'range-test-20260619-338',
    matching_hash: '164d5c20769c3722bc418c0884e2e50c02cd601c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'dff39d9a2681c00c73d42027e6f8bf2103a5e1e7',
    id: 'range-test-20260619-339',
    matching_hash: '1cf86ec408516deb361b68dbdd9b33973f6e350e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'fdfadd3abb53247feac8cf583c6cb0c070acae8a',
    id: 'range-test-20260619-340',
    matching_hash: '47c8eeeb46d5966a66a741f54387bdeb64699b75',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '79186a071b65f8173e055bbf3c43523277aa664c',
    id: 'range-test-20260619-341',
    matching_hash: '7ff7b9fce0c850ca860405375538282565fcaf97',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'ac95c8a12d430f0741f28e52d10ab0dcaaf0bb9c',
    id: 'range-test-20260619-342',
    matching_hash: 'b0ca967eafd7f2866c7ec1483a30b2a79bb13f52',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'b2b434b832b074e41d314ab1ad61c87f02871ee0',
    id: 'range-test-20260619-343',
    matching_hash: 'c2a2af05ebe0b0c06c62b22a852f46082e544acf',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '6feb7c90251ce12f77d896e4049cb6e0da8ce77d',
    id: 'range-test-20260619-344',
    matching_hash: 'f581b0d2238f8b8afe7c9e083ef97c5cf8ad08d8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '5a3f5f5c1b145c5cfc6c954ba015e915b75f4a9e',
    id: 'range-test-20260619-345',
    matching_hash: '6a59a8f6617069b9ec4334bbaa6411e9ff2ca554',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'ea7ec56553e69f5cc5d3b299e2fe7ad6859fe7ab',
    id: 'range-test-20260619-346',
    matching_hash: 'c242ef9d670f4e24edd3ad3a533e5b5526af409f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '330146a7d6aa9b0a832403f3b65923dd9e20ec69',
    id: 'range-test-20260619-347',
    matching_hash: '30cf1ba55b517eab08782ffd1df8582112a9531d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '67695f0c2c290d13b37372113f115c6bad00f5e2',
    id: 'range-test-20260619-348',
    matching_hash: '29deb68f0a1578d15cf6fb9ed3fd387721be6dfd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '907c6df762568275d2b944cc1a5f87ae36f6134c',
    id: 'range-test-20260619-349',
    matching_hash: 'b81bc642b347b84835548f871706fcb50724381a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 4.75,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'b62d5df41bd71d07341b855f721c1b748ab21805',
    id: 'range-test-20260619-350',
    matching_hash: 'e6404f75adf1c465d6ae478ee63ad7201b9cf751',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '5646cea44cbb15b64ac3e3c146c3d9183a555c5a',
    id: 'range-test-20260619-351',
    matching_hash: 'af1257332f5f707c0f682f6f056cf909c2bad6fa',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'c62455b270aa13fd3326d6096ec2758235f362b4',
    id: 'range-test-20260619-352',
    matching_hash: '162a4ebae7f9cd1349f9174ba72984dc1f629b18',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'a779a0d941639ac63c89354bc07f503094a972a3',
    id: 'range-test-20260619-353',
    matching_hash: '399ad608cab25e77c452dbfca5d139361d84bce6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '05c326d9eab9559d8221adc612bcbfd180290c04',
    id: 'range-test-20260619-354',
    matching_hash: 'a5bcdd15f1504f8ad46b3faddb13a9e924847bc7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '7d62d982e4af5bd57cf7c7fe83c736bfa05179e6',
    id: 'range-test-20260619-355',
    matching_hash: '38478b16d2905a02b4f43e48f975fec2996acb82',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'f9d4df5c19a37fbcdb7f07a1c85a916283cb11eb',
    id: 'range-test-20260619-356',
    matching_hash: '1680bbd0e4b81d47232700ebe6cf39bec4bb3ed1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '20f02837bd9ec49e7241d780097feac296327a53',
    id: 'range-test-20260619-357',
    matching_hash: '6738ccfd29d6d7c8c22dbee6d5ae8597fd5a94fa',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '254ca32fcdab12d9ceb2d2e5d0b6200d10af34d3',
    id: 'range-test-20260619-358',
    matching_hash: '1099a1567bf518ef342c7a4fff059cb68bb9ac7c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '0b0de4dee2586e426add2a7b87afaca50b243b87',
    id: 'range-test-20260619-359',
    matching_hash: '3f7da95dcc16490b08f94915ba0596a31a5bcc90',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'ce10b824fc5292a2674147ec1a7bb5c7ce954887',
    id: 'range-test-20260619-360',
    matching_hash: '235227d67f85c38b2a2ac4931e732c64fef4fd01',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '394f9427a26a3434c568febdfcdcd34a1810b5a6',
    id: 'range-test-20260619-361',
    matching_hash: 'fafac232a5813f3ec4f53be97accb5644e5f97ee',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'e8e04815861aeef39e63ea4d48e61bec7b0406bb',
    id: 'range-test-20260619-362',
    matching_hash: 'f94d13baf525f74d045a05047d9f1d5155262843',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '4f3f7fb6fcbce90c6b8d5916373fa94a48efcfcd',
    id: 'range-test-20260619-363',
    matching_hash: '12b2bacddb094787eafc1ffa3830e980e5ce71c0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'd535a48c3ac851d4b74611d083933522be8bb993',
    id: 'range-test-20260619-364',
    matching_hash: '228044f54cd890fa6587243926e4504ec4612f63',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'e24cd17f82aad4d258f6019e486f3ad24b154f2a',
    id: 'range-test-20260619-365',
    matching_hash: '25b9fb7d6999b3d586026a9121ceb108d31ed729',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'bdf17b2006ab59297bd8f84773d6ba3912ca5e03',
    id: 'range-test-20260619-366',
    matching_hash: '5d20757313ae08904722c0cc6804c5be0e782db9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '0742797b2c60f10b16325d925f6dcda8dbbeadee',
    id: 'range-test-20260619-367',
    matching_hash: 'bdecb1ae06883150db62c1fe19c1e54ea9dfa4bf',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '6db81926c0504b5b983b3c9b922f33fe17122639',
    id: 'range-test-20260619-368',
    matching_hash: '869d8540147162943be41865d5d0ed8bfa31a0bb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'b66c00ee00455c909f55a20ac5a9833f02652907',
    id: 'range-test-20260619-369',
    matching_hash: 'e5b3c531d19944b3b2158823947026b56984e0bc',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '4dce8238edf01b3850ddac167ba1f6bd5ee93c48',
    id: 'range-test-20260619-370',
    matching_hash: '7080d12515ee17d5a7baaabeaab4db8588ca4509',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '11dd39e9fcb7a208b9612d096c63d5ca60933130',
    id: 'range-test-20260619-371',
    matching_hash: '271d3c8d26396af7ebb634faa01108c8184e6f0b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '238f492dce00e31182feb1e74d2b3bbaad3c75e2',
    id: 'range-test-20260619-372',
    matching_hash: '3a49022f3e0b0baa825f1c7788668017c152a12d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '922cf3808d57c6b0b845dc71cdf2a95defa3d568',
    id: 'range-test-20260619-373',
    matching_hash: 'ed1a721d8ccf9494bfef4d87fbff1a731543975c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '537abf380d6a22753e2c27cfe269d679504a8e95',
    id: 'range-test-20260619-374',
    matching_hash: '013d20afd348f43533491a0f1f4316c19929b1d5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '749b508c78007246de27e28c41e13d765910e883',
    id: 'range-test-20260619-375',
    matching_hash: '277e94d78d3a3239e4b8f7c1896b27565a508bcc',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '1ee5a282a314b38ad1fba2f9b451bbc52f29eb72',
    id: 'range-test-20260619-376',
    matching_hash: '2e6d2f27f2d240a6a31b37b3a7c2d9f00e4a7e6f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '5bb0597faf6e9313e35b8b4ec15974808779107e',
    id: 'range-test-20260619-377',
    matching_hash: '8ace596f4026fe3bf391c127f916f2ffbc46fed5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'fd2cc0de1144b479d47ba9b1427dc6f6eb20a92e',
    id: 'range-test-20260619-378',
    matching_hash: 'e29839eb0c9cc0a377cb318b8b12fe1b6e9b11d5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'bd048bc071bb12ccd54335fa643aac660abcfc25',
    id: 'range-test-20260619-379',
    matching_hash: '8bc956b74107038b771b12b8ec3e677764c8b000',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '5b586d34f870ae0f02cd1471341e8e19665264ba',
    id: 'range-test-20260619-380',
    matching_hash: '4190f9b98316bf3d468b07f9a5cba30f6697d660',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'e28feec5d9585176b7f35b989a23d3776ef8fb64',
    id: 'range-test-20260619-381',
    matching_hash: '634f44d0aba0e7a0fad0dd7bb1744da5c0c0202f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '05fb0787edbff6135b426c2e533eea6a994d0f42',
    id: 'range-test-20260619-382',
    matching_hash: 'd66607b823ca2c86bc42d0830b55850908b3ba43',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '5b74eeff8780025adbb853a42a236972cec3a0df',
    id: 'range-test-20260619-383',
    matching_hash: '2f643f49fd0359e9cbfdd4836d0b3ab3074e6144',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'a4423585e6c265e9025e79c07d6092eacf82eb6e',
    id: 'range-test-20260619-384',
    matching_hash: 'b4a5ccc510e557e0eeef7acc73523ee071438194',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '1f9728ae5a462ba51d7f1e2e54d2ee072bb65384',
    id: 'range-test-20260619-385',
    matching_hash: '86cea861f68a2e66be1c24f03403ff9cec3953c0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'fa5a8f3abbf2a10a2eb167a3a3bbae6a311a4657',
    id: 'range-test-20260619-386',
    matching_hash: 'd3b7787471c732957fc360d46fd77b63a2d7ba38',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'b48a628f21981c6412f8201ca685c02416684c28',
    id: 'range-test-20260619-387',
    matching_hash: '3a3783d94d59817704b4c94ffa7722d0292bfb7d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'aae90c50b1c03809e30a879d3d0de243c1dc1a5e',
    id: 'range-test-20260619-388',
    matching_hash: '79ed3ceb0ba1e5b349117dc4d4cfeac6999b7dd0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'a0d0eb944cbf55dcec9731a23850b82b60a19b5c',
    id: 'range-test-20260619-389',
    matching_hash: '6a060a833f8d3fa8adee9ce6e6c321b7deab647c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'bf833c0af28c0b717c4474373e52940d932fd03b',
    id: 'range-test-20260619-390',
    matching_hash: '257e92296416782d38dcd93729510220f09b01ab',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'd22003d0c913c8500ab161e939d19e2105fee3e8',
    id: 'range-test-20260619-391',
    matching_hash: '241b43a8297796987ecbf1411270892d4b89c04d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'ff9abcae1439db2707c263b816157f7e99b2e015',
    id: 'range-test-20260619-392',
    matching_hash: 'd0c06521711c4bc52c40e57b90357f9a833505ec',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '40da4d841b9d91c14f108dd3d63dfaf4d1f33bf4',
    id: 'range-test-20260619-393',
    matching_hash: '9da4261c07f32e7f4b7783cf49ea7488bbdccad5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '397ce0c9728815b00cc2ca98bbc9f785f7637482',
    id: 'range-test-20260619-394',
    matching_hash: '0601a03d7deac130aad352df774086a8b56e348d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '523f581017d4d2b818444c2c3b4edc8db32e682f',
    id: 'range-test-20260619-395',
    matching_hash: '687bbad7d80aabcdf0cb2860524f774090a8d044',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'e16c49709df18e48b105148bdddef43235477266',
    id: 'range-test-20260619-396',
    matching_hash: '57742849f10a05b3a5b9859b3af5ebe4b3a6386b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '10d498e34ab0f1b8205c1deae66f17f3ce49f69a',
    id: 'range-test-20260619-397',
    matching_hash: '889875b727c38dc2dd18db150c73108cea9a6a32',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '6a233d545ffa20923df0728333678beed404cacf',
    id: 'range-test-20260619-398',
    matching_hash: 'd0600a68e4ab6d6f3f91dd4c54522903b85e24a4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'a43347b9494944d82c48d6aee81c0f0bc7c8743e',
    id: 'range-test-20260619-399',
    matching_hash: '7be67a2b52bdd117dfded7124c87bca565a9c4c7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'f38a67dc6eecbbfe2450b423a6dd0ab09c03f670',
    id: 'range-test-20260619-400',
    matching_hash: 'ca471e910d27a502d7582c0a0cf2efb1e1d30c9f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '2e57f4f5a407610dbad5672a64ab76c8e71b1498',
    id: 'range-test-20260619-401',
    matching_hash: 'ef89505e67964e6a9f4ad81a0aeeb462e991484d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'af9ba28a07c99dc525fb3e94608cf1523039d65b',
    id: 'range-test-20260619-402',
    matching_hash: '3c2323b4491b6187cbc810af29fbf4c0c74f2a4b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '502f2d7acc875d10cab8d57a06520f7080ccb2ea',
    id: 'range-test-20260619-403',
    matching_hash: 'cc7e535bb2e71285d3f110317e49ab77bcc5f4fe',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894258673,
    qx: -0.257228764,
    qy: 0.075249339,
    qz: -0.358430364,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '658634e85cfb815c848752037c7b282f77b70371',
    id: 'range-test-20260619-404',
    matching_hash: '27c82d34597ecc56cd8162ba1759dc257ab16268',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '77e4e436c33d95585188be4775fa465d2de194ee',
    id: 'range-test-20260619-405',
    matching_hash: '209a475ad1fda9aa1bb3e3e323a2074278a76b58',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'e36d25c739800b5e7503d0cc433d2ab8935a75d7',
    id: 'range-test-20260619-406',
    matching_hash: 'b05e881cc779eb82c89219115d5a5b25a81a5267',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'b2149e42a55515de4ab849ccc792ad989c2f6278',
    id: 'range-test-20260619-407',
    matching_hash: '09266b4ee45b7f5d9f0bb47a7c3a38b200848628',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '86352194f2b4d434bfdf7f4395381716b570342a',
    id: 'range-test-20260619-408',
    matching_hash: '82e71090162e2bf598a2c3140a343b5986cc8059',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'b28dd820c45d9f4c59dc69fd86ecd2a14007d18e',
    id: 'range-test-20260619-409',
    matching_hash: '733b0344ed155dacf217c5ddd8aec07d018d2e41',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '415917e3c0f54ee7615f545a07387fc9a78e7591',
    id: 'range-test-20260619-410',
    matching_hash: '12d3dc008ee6c471d16a04db8d8a6da2df3268be',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '56945e8f452b077927cb534e14ce5593d1b4cce4',
    id: 'range-test-20260619-411',
    matching_hash: 'c41b775ba0f3c33d9f978f79721635b88e9ccaf5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'b76ec95b6aaa206209f8672fb8e3db2ef98fb651',
    id: 'range-test-20260619-412',
    matching_hash: 'ad6f3f9e9e9f1b4429bda7bd73080f0fb28344f8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '38e650fa30661cbef159e7712b7120ec8e6448ae',
    id: 'range-test-20260619-413',
    matching_hash: '4c9269deeb473e6ed44705e1f85b7540795fe05e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '4edcd069c989b42d728b8db3b1abb2d1df2767c2',
    id: 'range-test-20260619-414',
    matching_hash: 'd8095c81ff6099831b271466b124226dd1704f40',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '59cdacefc07f4e382c63b0dd2998acdabfbfa908',
    id: 'range-test-20260619-415',
    matching_hash: 'c137ec3d028349116ceeb7fc7ba985dc3fcd2fd0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '431e7832a77700ead3cc725cfec72d22bd1b9da3',
    id: 'range-test-20260619-416',
    matching_hash: '3d30413f1ced6e0b9381e7fd2b8cb3b744a0392c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'd3e83d07ed37a6e17677efc158d9553d95fdc2f0',
    id: 'range-test-20260619-417',
    matching_hash: '048a5247cd57c06956247c88fdac6b6a3aee55c0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'dc11dc63b296fd53a36407b61cb54b28be61a030',
    id: 'range-test-20260619-418',
    matching_hash: 'd8853b724e92ca1eecc44ab25185e3f72ff02b1b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '656397813e3e86846453d93cf82f3ce4d019474a',
    id: 'range-test-20260619-419',
    matching_hash: '3cd513a85716328708406f051dbf4364d8e44770',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'eeeb5f6986c3e9c1a3f85ac615a0ac6c362d6518',
    id: 'range-test-20260619-420',
    matching_hash: '7e242649cfae872d3ae4bfcbae1235d7c8c2da0b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'a19875b3b5ec53241ad30f7c1d5571cf9d532cb2',
    id: 'range-test-20260619-421',
    matching_hash: 'f98d99e96753f7d81937554c4c32c0c02d41cf67',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '8aa3a231bb9587f59e7e68844618ffc2e0e49107',
    id: 'range-test-20260619-422',
    matching_hash: '9497bc66c077c5589dd7c4540c52f0f0ec368e1b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'f15bc6f85dae74ea929b03a6bd018b9e7e4a911c',
    id: 'range-test-20260619-423',
    matching_hash: '091191664d35e2641ee439763096db7717d52b85',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '7dceab719674aaa9d3a175b0c2d2ff5175340e83',
    id: 'range-test-20260619-424',
    matching_hash: '5edfec387e6a49142d679cc65e6f80a5a847b4ac',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '7830f2b03cbe9b8496fa4de52f08a523ae9b25c0',
    id: 'range-test-20260619-425',
    matching_hash: '7cd40cf121e1dfa5039271f120632af4ff5d5ae8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'b6b4fdecdbbac5a30be27a9227c156d4ee2a03b3',
    id: 'range-test-20260619-426',
    matching_hash: '6158daea25733aa255c8c41288a56b439b7dc6ae',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '815907fe86f66745e62854fc4b520fb3b804ef6c',
    id: 'range-test-20260619-427',
    matching_hash: '7e793a32243bba1abbdd1716f67ec1eff278436f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'ac95a3fa1fedb1c9e75d6356a951df453556a8b4',
    id: 'range-test-20260619-428',
    matching_hash: '6e61848bf3e4b15543331bb64806a2279d13e2bc',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '1002b2be7c05d1c5b78fa154708638d388f2621c',
    id: 'range-test-20260619-429',
    matching_hash: '898970c5c7c92abbdee172d729a827a4b32d4203',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '4054be6cc8227be5a2cb4cc342e67ac8069bea1e',
    id: 'range-test-20260619-430',
    matching_hash: 'ad9e32190c6eace437f26e9be63ab59e44aa62ae',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'ea1b295682fa56ff8a4f30ab34d7a99633ab70da',
    id: 'range-test-20260619-431',
    matching_hash: '2eae02d849e7eed3b80be7737e21c42abcb89003',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '980305a73c0258b99512c4ca95a63379c9c8fdc9',
    id: 'range-test-20260619-432',
    matching_hash: 'ed6ce6d4a85a164c31d4f787b141056d9d2af31a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'cb62828eb848d212af5d9c1a0975c7e63c396d74',
    id: 'range-test-20260619-433',
    matching_hash: '6f5ae4e488c2853970ed57a571bb8faddd542dc4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'd5c8898976801ccedd3caa6f1ceba01abd40a884',
    id: 'range-test-20260619-434',
    matching_hash: 'b642c97224638a1c652ec53fa74d571cc26f3402',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'f3d2171623a6cd1ad5a4f79cae847a9ae077ee35',
    id: 'range-test-20260619-435',
    matching_hash: '1385c2180fb6ecb7443a706dca97c51b9f36efd5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'fd549fca71f9e33bcf1bdf5806f1d9da8eb183ab',
    id: 'range-test-20260619-436',
    matching_hash: 'f21dbfab8944ccb18a8be277d1429d7719287b12',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'cd84e55685a0cffd58aab3e8a8903d89ca7170e5',
    id: 'range-test-20260619-437',
    matching_hash: '86197e8120fe428241f92d40677acd048c78fbb2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'd9d9998985f29711ad608856c77413591e1681e7',
    id: 'range-test-20260619-438',
    matching_hash: '45564a3983fad8a29caa023d6656d3228a958a8b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '5a207301fd0a11d1e695db7b07196b9b97598065',
    id: 'range-test-20260619-439',
    matching_hash: '5661ed540637c98ea0a127a5c8927ea869fe8105',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'c093b72ee3ff8648291c52c62314794a10995235',
    id: 'range-test-20260619-440',
    matching_hash: '0cbee3a924035806e06033df6bbe691e7be02263',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'aa9a2b08a547db0497cd4243cfdbe647652db71d',
    id: 'range-test-20260619-441',
    matching_hash: 'd61f415223aa90cbfff27b3d71868e1628e3ad6f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '96dc7c943cef91b9f1e429d36ecb8954c752e65f',
    id: 'range-test-20260619-442',
    matching_hash: 'd242495531bb30ac083078901dd8f0fc927f23ea',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '5392f8934e48c2fa65691297d873a20ac4eb0a15',
    id: 'range-test-20260619-443',
    matching_hash: '5dd8b31bdf45ffa6ce808e03f6ffd6f945f20a86',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '5fea7af72509c392ddfb1996ccf06757f7c5bc27',
    id: 'range-test-20260619-444',
    matching_hash: 'c67db0a91469d5635152c4146a744f91f4a9d435',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '03ca8e6004c1578f4b07b7977882b9e77184cc43',
    id: 'range-test-20260619-445',
    matching_hash: '8ec7ab4a0f946f978b9eac7d3cf86ff18452a948',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'f64e201371be063e95ecfdac3f793b0291c4c74f',
    id: 'range-test-20260619-446',
    matching_hash: 'd54ea6e6ed8a0df2ef4beeef408e8ecb5d8dc69d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'df200451d50758c01607eaa998d10411f26dbc6d',
    id: 'range-test-20260619-447',
    matching_hash: 'e5d8f3a5d931539cc8398dcb970776a64cecd85b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'ed0665bc4d2c8a11d09a88f937f4d159126c044e',
    id: 'range-test-20260619-448',
    matching_hash: '0976769069de279e7a5329554d0b4fa4b53a79f0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '30adc1c18b873a3e03e9e53bf2bc53b9cc79182c',
    id: 'range-test-20260619-449',
    matching_hash: 'ecfb371992823de33ab7e17127e516a4f400adb6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'd7a2b4ac0179112509fb0e8c7a8571727bed5172',
    id: 'range-test-20260619-450',
    matching_hash: '1102ed8d9c19267b1fc7f83b42d261c1a6ac20ee',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '66a6a01e32193c969cf98819e854ebdf7e705c39',
    id: 'range-test-20260619-451',
    matching_hash: '864ad9d02bc0db2217066e75d373dde79dd54d52',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'e4401b81b81364e72a4b29f274ebe4f77232bbe4',
    id: 'range-test-20260619-452',
    matching_hash: '875e5bab881fff91809ca72be6fb27ce3c3bb3bf',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '181350c7a8cb7c308c52edfad7956a98dd79672f',
    id: 'range-test-20260619-453',
    matching_hash: '7acaa3c9077de18f0d1398db62766ffa7b7bbb9a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'ca8b5079c7b21f6ffc8deab402c5077f5d581c5a',
    id: 'range-test-20260619-454',
    matching_hash: '55f07586b5a4f915167bfe0b59cc72e5ac95867f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '360d04318dd3c2df6cb38f7bcc36c92edd3299c9',
    id: 'range-test-20260619-455',
    matching_hash: 'd2d0ba9a98cbb460643e12fd1ded1fcc25aa12c5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '1cdfe2e74eb93f024dd46fb2036b7c6ee84b7825',
    id: 'range-test-20260619-456',
    matching_hash: '4d9a11e37715f2ce75826aa058ec54e00b13f200',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'a6803c1bb853be1d0a1b2086155e15915c98578d',
    id: 'range-test-20260619-457',
    matching_hash: '4aa903a4d5507a6cdc714387286a8cd1bd647a10',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'e378e364133522d267aee73f03d1921a885778c3',
    id: 'range-test-20260619-458',
    matching_hash: 'c31e8e73515aead706a274d5361e4f0f1f57e9c9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '2186b443bcb071cc75eec1c15beb02e8cdda9262',
    id: 'range-test-20260619-459',
    matching_hash: '012a54c9146402b80481fb365f48d3c1e11edf7b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '5c9afdd432d903269fab8506d5284fb26e2982dd',
    id: 'range-test-20260619-460',
    matching_hash: '1f74d242f77b0b2230c601a2d21549eca17a20a5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'fd47bc4befc40913cd2cb1a578f9aaa9724f7833',
    id: 'range-test-20260619-461',
    matching_hash: '1a328b69c4987ad2c9ada58efd9b39067a27f0f0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'c88570f2cb91e8a59de81a133107f995d31a1859',
    id: 'range-test-20260619-462',
    matching_hash: '9d7b922a2e4a3079a31d2b658d5f585c0238edbc',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'c0a4631728b0850c8c3ae0ba0c5f51cbaccb4927',
    id: 'range-test-20260619-463',
    matching_hash: 'cda2f9dacc1e98232aca32cd9aa7f5cf18accc34',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '024b60a39900c81ff7ec7890abceb648a01943e6',
    id: 'range-test-20260619-464',
    matching_hash: 'ae116f0829b6653231fe21f7130d636e6f13ef18',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'd70959942e05f640dbcc8eceb69d77396baea9c2',
    id: 'range-test-20260619-465',
    matching_hash: 'e651297c49158eccb698820e4077003a7d453275',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'a416107dba501350eeeb71fa16b7ce3d9cbf82cd',
    id: 'range-test-20260619-466',
    matching_hash: '0ead8bc8032611a9de264409ee148e023923653e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'f968197a1dc2ff1228e93c6dc73130e58b8b8686',
    id: 'range-test-20260619-467',
    matching_hash: '98e6330ec672cddf0ddf6f5695e34ab79eacdd91',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '77c16734da18b4f50304a1e3f3b9ad1d55bf7f75',
    id: 'range-test-20260619-468',
    matching_hash: 'd0723f75d43aa8eeea2d19846cd05cdd7b399df8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '25bb772d354a680930cfce8bd4b637f2ea20414f',
    id: 'range-test-20260619-469',
    matching_hash: '7d1246e835dccfe88809315b9e24157c709f5db5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'eb217e449f2098c4d334267c99e714c7e868fca2',
    id: 'range-test-20260619-470',
    matching_hash: 'd5caa019f15a1e5a8929e25ea45a1aa296733e24',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'a0bb599f2645b83a20282c17bff5e756624a5663',
    id: 'range-test-20260619-471',
    matching_hash: '261694537dcdec3ad2ad214e71234481c21cea82',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '7056f585c69b4b7ecd49506ae04eff94322e8528',
    id: 'range-test-20260619-472',
    matching_hash: '4dae7dc7f812fbb85fd23cc09feeebb1636f9012',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '95bd8912b89f138b1c9d99c9654bf93a22fcfa24',
    id: 'range-test-20260619-473',
    matching_hash: '7da6d2f57c9e64e1a83dc1ba7fef05e3dec66acb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '585fd1c9f571c54e966393910a5397ef765c0181',
    id: 'range-test-20260619-474',
    matching_hash: '27c82d34597ecc56cd8162ba1759dc257ab16268',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'd4ad041eed65663229ab1ead6ca88efc3bbe077d',
    id: 'range-test-20260619-475',
    matching_hash: '209a475ad1fda9aa1bb3e3e323a2074278a76b58',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '1dfc2d4dd17f6c049fe25833bf29ab79179fcb8d',
    id: 'range-test-20260619-476',
    matching_hash: 'b05e881cc779eb82c89219115d5a5b25a81a5267',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '126061f55e6a979ef64d0042fb8dbbdaf4e8d93a',
    id: 'range-test-20260619-477',
    matching_hash: '09266b4ee45b7f5d9f0bb47a7c3a38b200848628',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '033dd67cf654c52580476e9d2805675c2e512f01',
    id: 'range-test-20260619-478',
    matching_hash: '82e71090162e2bf598a2c3140a343b5986cc8059',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '77b7d729627a6e2585acba8fafddc7d60459d5bb',
    id: 'range-test-20260619-479',
    matching_hash: '733b0344ed155dacf217c5ddd8aec07d018d2e41',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '7dde687243b22e115104ad8f2e3b598fefd7e64c',
    id: 'range-test-20260619-480',
    matching_hash: '12d3dc008ee6c471d16a04db8d8a6da2df3268be',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '793f27d0329308f91aee399e546598ac5b412c5b',
    id: 'range-test-20260619-481',
    matching_hash: 'c41b775ba0f3c33d9f978f79721635b88e9ccaf5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '3b3be9bcf893a709df2df57d1985803c16df49d0',
    id: 'range-test-20260619-482',
    matching_hash: 'ad6f3f9e9e9f1b4429bda7bd73080f0fb28344f8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'a9b9a36be35e8b6491db284ed3bf5986758354e6',
    id: 'range-test-20260619-483',
    matching_hash: '4c9269deeb473e6ed44705e1f85b7540795fe05e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '5ccda8c1163b1846d6ab5772f48b463bd9ec2dd4',
    id: 'range-test-20260619-484',
    matching_hash: 'd8095c81ff6099831b271466b124226dd1704f40',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '463c77c48cdcd5bbe69e791f726d15852dd56b38',
    id: 'range-test-20260619-485',
    matching_hash: 'c137ec3d028349116ceeb7fc7ba985dc3fcd2fd0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '82fa0147d043f7d63c105189d6f0338933587c41',
    id: 'range-test-20260619-486',
    matching_hash: '3d30413f1ced6e0b9381e7fd2b8cb3b744a0392c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '1a8be723b7e4e6f37c1e7823aa4677bac47daf8d',
    id: 'range-test-20260619-487',
    matching_hash: '048a5247cd57c06956247c88fdac6b6a3aee55c0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '601058a5dc011c906372dce67675206bd352e651',
    id: 'range-test-20260619-488',
    matching_hash: 'd8853b724e92ca1eecc44ab25185e3f72ff02b1b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '8e23dbd6ecf2de6c9fec2f270b7c07990ffb0303',
    id: 'range-test-20260619-489',
    matching_hash: '3cd513a85716328708406f051dbf4364d8e44770',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'ec3e6a3e36e845a5acce071fdb2ea6ee660a4a5a',
    id: 'range-test-20260619-490',
    matching_hash: 'c47212925017d4b7d9b9d16dc090b48d1c28ca3d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'ed784a88dc655d3d35df0aaa7aabf29c345f0890',
    id: 'range-test-20260619-491',
    matching_hash: '3478a5e59572a82857cb03e39a11b51e2fb7a1f9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '313e4c3d5bed0d2450481184a0adbf70cd1cf9f1',
    id: 'range-test-20260619-492',
    matching_hash: 'dd940926c80aa15eeaba1dcd9ce27300ae3fb6e2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'e9fcadefc00e5eedce80919043bb784d603bfd5b',
    id: 'range-test-20260619-493',
    matching_hash: '4946f098107738234838be6d64dec4eb6881e316',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '7fb937ebe43bb7e2c8661ea7853ef51999c0151e',
    id: 'range-test-20260619-494',
    matching_hash: '578dd3dc7e3de355f037210dfa1ec6473a6d3791',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '0bbd71c10dfe835b0e708915a28f2fb4131b6ffe',
    id: 'range-test-20260619-495',
    matching_hash: '9d5f3e5388844694ba6bdb625e82b60058c0fc91',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '11dd0283ddbcc7ef1e72d0b82dfeee4c940c442a',
    id: 'range-test-20260619-496',
    matching_hash: '1eb630982074ee8f520c148c4f10ba01815fdda0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'b98f5d7439210e51ee64ca23ca1af11e8e34129b',
    id: 'range-test-20260619-497',
    matching_hash: 'a3db8fdbcee8559bc9656b6c5459896fac9e8eea',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '713fe04119e4d7e9ef93c24be3029112236e7264',
    id: 'range-test-20260619-498',
    matching_hash: 'a53fe1fb1a5a05c484edbcddfb0fcef271a40e9d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '244e4e7ba3cc9e624b9e56599d1ad655683ca05e',
    id: 'range-test-20260619-499',
    matching_hash: '5214162107eb1e0294f349d4b3ab659eb525f6f6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '64782acf54272e8c95e9bcf14c07c3e2e46daae0',
    id: 'range-test-20260619-500',
    matching_hash: 'dd904352870bead5373286ad36b0d0cd140b966b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '678b92cf831521a0fb4da0d431ba81107d3e2aea',
    id: 'range-test-20260619-501',
    matching_hash: '59e24478f6916aaf921722d8c248a8b8bed70989',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '8f593d73935942ccea1ae253626c466ede6e1b65',
    id: 'range-test-20260619-502',
    matching_hash: '05ff12478882f9a22081cc87b33e6b71b5b20d1b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '536f720264398e77183d6dfa5783269d023f2792',
    id: 'range-test-20260619-503',
    matching_hash: 'ff2a4128596c94f3cbf5928f0465594b9237fb8b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '3ae6a2bc857c3dea64e2788ff469f0315ff8a724',
    id: 'range-test-20260619-504',
    matching_hash: 'fa832ea2fcc62e6c5f51d25af6b0122d7c9db0a1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.236258371,
    qx: -0.277680608,
    qy: -0.912250796,
    qz: -0.186745678,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '0088d89b7ab973fa340cccfd7dbaf72d35f24fbb',
    id: 'range-test-20260619-505',
    matching_hash: 'f06797a80be625dc5ba5bb822fb45b890df983b5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'ad09a69edc83cbca8e4f18cc273ae23d94d945ca',
    id: 'range-test-20260619-506',
    matching_hash: '4221ab3975a82139801788690ef79a226ef0c30a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '4da4c8c613da50fdddae188b9d0632c9eb9d4379',
    id: 'range-test-20260619-507',
    matching_hash: '4cc9e50ba6db30f2367b461287a5d35582ffc38a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '260df2e7b4418ed709211022ce8cbf473c3584f3',
    id: 'range-test-20260619-508',
    matching_hash: 'f439de7896fa0042058f94b6f39fb6900eff33ac',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '3d95cb1f96263a7f8130a444fcd39408ba2aba66',
    id: 'range-test-20260619-509',
    matching_hash: '701dc58896c9f17ef6ac9e36a0497862cc19b718',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '9b81f21de39f35533cf5fc13fd37fcc049dedb28',
    id: 'range-test-20260619-510',
    matching_hash: 'bde31b60db38cab4e6b28597737d7825ba6c3a66',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '80d3671b0e721c57ce9dac8ac4e1a37f06b05896',
    id: 'range-test-20260619-511',
    matching_hash: '68c9771ce5a3fc6ee86ff45b47951d109d9bbd6a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'c210357ba9ef591fdc786cb9a0ec8e8a601d49d2',
    id: 'range-test-20260619-512',
    matching_hash: '9c4c543a80ab6b6061a332d3a1bc389851c3d6e9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '9d8d62e57a3eb4cfd7580227a16248517222d7f2',
    id: 'range-test-20260619-513',
    matching_hash: '889179ceb30fc57caf55e561385a0436d610265d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'd538a024473872e2846129d41a7ce2455323b6be',
    id: 'range-test-20260619-514',
    matching_hash: '536bbafcbf91c1833322db8f5ba061ffa1e4c485',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'caced27db4a29a35f9e8af03770af2731eac54a0',
    id: 'range-test-20260619-515',
    matching_hash: 'ca3603ec44fc21c12a54c801024972be7b6fef46',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '1eac93e9b1d4dbe73066ca023ff1a6d78abbd056',
    id: 'range-test-20260619-516',
    matching_hash: '234abc97ccc75de3434e4f30b91430b0cc3c1d88',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '9c3daa516d8a6baa48ff4ececdfbf378f2bfcfb5',
    id: 'range-test-20260619-517',
    matching_hash: '3adf19b3c39c24e4f108ba9a4fe621a141bf72d0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '409bfddc5efc621307f975783b15cbf79ea4101b',
    id: 'range-test-20260619-518',
    matching_hash: '1cb6aef7ee54ea90b0d6af234f81940addc6fd19',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'c7936b92f6a58bc5ade1c1c1e36ca47c1be96fc6',
    id: 'range-test-20260619-519',
    matching_hash: '4ddc46d1732b30cdeed03f135fbdfaefbd05c807',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '3af6e0ac44c15c4b629916f4b18f02a83d0e1b74',
    id: 'range-test-20260619-520',
    matching_hash: '7d236d384642a91b9eb61385e4462f61e06e6bc6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '5c4abc7cabe82cf4da24e251d40f4c7fd8ca94cd',
    id: 'range-test-20260619-521',
    matching_hash: 'baaddfe9924ceb857424c35c6f32b6827c721681',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '8933633bc115d56da054d660f0c8814074da1ab5',
    id: 'range-test-20260619-522',
    matching_hash: '6338eeb783a9cdc20bbc9ce01783ca7c67f4dd07',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '4fbfdf49614c89aa3cf15dc82208ea85b100c73a',
    id: 'range-test-20260619-523',
    matching_hash: '92daee0e3a62fbc95c4de9063cf3b18536d9fca2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '50041aeb79b20205bc3cbfd3602aec953cea99f7',
    id: 'range-test-20260619-524',
    matching_hash: '077ec80589c56544bbff2acd327813fccb474738',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'ee1f707648a64773d8f3087dd266b074e485ed69',
    id: 'range-test-20260619-525',
    matching_hash: 'f2b7fa0a84fea574e963b2816517969b17f60f3f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '28e543c80cec3298aae7329e7b1daf0c65f3ffd5',
    id: 'range-test-20260619-526',
    matching_hash: '7dc3cec1a66aa6ef78be72b159676cfaf77ad929',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '6919ca2e5077851ce0a176e2aab5d6246f1a67f9',
    id: 'range-test-20260619-527',
    matching_hash: '3c710c86cda4427fab3828814fcafef12d4c10c4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '26c1ea28d8d262cd88f38a5b3681d68fca401d06',
    id: 'range-test-20260619-528',
    matching_hash: '0e8c91611ad286f840032fc6de4cdc0d2fc41deb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '02a5295e8b89242d5c660c998a106f9e014fee80',
    id: 'range-test-20260619-529',
    matching_hash: '3bd9175d5c8f3d90f743b3fb9ff8579899c876e0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '94ba8067586ac03ded505dc5e6434a7c33f09570',
    id: 'range-test-20260619-530',
    matching_hash: 'e864005ed7dd45d34904bb3f5979d862c7f87a6e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'c18691d5dfe09a559f7cb36d54157107f2d3ca21',
    id: 'range-test-20260619-531',
    matching_hash: 'fbcf5d64a30db2e6da00df5dc21fb57d8e22cfd2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '80fe916ba12e13856363551b4d4f257b921587b0',
    id: 'range-test-20260619-532',
    matching_hash: '4f59f8c2d2e6dfd6b1d022d52da342151e7fa44a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '41d6ab5909dcf5e0edba8093e4ad9593605e0c2b',
    id: 'range-test-20260619-533',
    matching_hash: 'bd9e508f4e9b294d79ba2441972968f7087e1e19',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'a0b7a4f8527c8f69fbe545ac078b0289de5e2754',
    id: 'range-test-20260619-534',
    matching_hash: '4bad2905910c5dba6f40725ba5ce3eaaee5f2408',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '71839f44c17dca1996ed8b6e23bd0db31787af37',
    id: 'range-test-20260619-535',
    matching_hash: '16588dabfb801dc7f83e25ad51a0bb11d6ae78d0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '5a69d572f4bab5dfaf621409d638601d825e93ed',
    id: 'range-test-20260619-536',
    matching_hash: '24dd934619aa19462ca282165fcc19d8baa61faa',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '9acb339f14d2294077c0d6bd8fa22311759ec8b2',
    id: 'range-test-20260619-537',
    matching_hash: 'e3fbeae6951123f7c04382702e7e56ee2eeb96ea',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '21b6ac094901f2464b2a6da989f4c5f2552d78dd',
    id: 'range-test-20260619-538',
    matching_hash: '65811ed4265ea0194d6e5f8e7fb3de60caf29732',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'f93620f9a4e94f327d8006c80a9d8eaadf1e8974',
    id: 'range-test-20260619-539',
    matching_hash: '3a2c7562231cc5ff027628ca508fad2f7e1fe740',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '0e62d782d0f18dc9ae96b645e0f28ccb5b156c1c',
    id: 'range-test-20260619-540',
    matching_hash: 'acac56ba3b096f8b5c7725367a43f4c673b7b16c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'b63af960664ca2bf00f1f1b1b96a8afa1a63565f',
    id: 'range-test-20260619-541',
    matching_hash: '4f8bceda0d3386f495356e27258dbd75441563e3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '54262df4ed479a0317d33ecba3b39036f0058743',
    id: 'range-test-20260619-542',
    matching_hash: 'd6b4eb5f11bc84fa7c1da9d34e897bd883263688',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '6d12e6ddd66ab1624f05827b238244c33ad4e49f',
    id: 'range-test-20260619-543',
    matching_hash: '404e1c8e3adb3acdc6039d11f83ca96cf05e5411',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'b50b8ae3ac4463040c9ab77b2b517e7483681f02',
    id: 'range-test-20260619-544',
    matching_hash: '7c0d8b709ff0ec57269628f4004209b088b960db',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'ab56a061d5a1a3fbfc4d761c0c924315937148e6',
    id: 'range-test-20260619-545',
    matching_hash: '425ab3a7dc7e3438c935dc1ffd12ee0c5deecd5d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '8095deb7b3cf79da7afedae27feee717e4fbe45c',
    id: 'range-test-20260619-546',
    matching_hash: '94ffe9d3ee7e3bd030d510b5b45d08e98c019067',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '5994a2948cf178c2d7c5fa225969f0c8f1cc3744',
    id: 'range-test-20260619-547',
    matching_hash: '1e76e9baba313f991f30e979c531f7b76ffe23a0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'dd5486eb3296cf0aedbbd63007b8a67d5f1c8957',
    id: 'range-test-20260619-548',
    matching_hash: 'a37c519643a25225c8823304f31c3735d3e115c5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '2b4f2d32567369f816cfa953e8eb8ad0f1509838',
    id: 'range-test-20260619-549',
    matching_hash: '6f7ab605078a893d2388c0c94665f41388f8b753',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '1e80fdfb4e5a4a6f0be01405dbaec912111330b5',
    id: 'range-test-20260619-550',
    matching_hash: '070974e1adf093a1aaa13498804d96090d47e958',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'd495b14216c1fed2e88528f99809274bf646e604',
    id: 'range-test-20260619-551',
    matching_hash: '6605ac446dcdfa3f8a92419bd4a9c608bbb2e1b7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '038a590965f11f4ec8909994e515a349660c1ff7',
    id: 'range-test-20260619-552',
    matching_hash: 'f931b9ad5e5e961bbc55ad2abebf1475c7c46e4a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '37180378ed5c36b108148cae811d9e41c7bce314',
    id: 'range-test-20260619-553',
    matching_hash: 'a63d9042c2536f09496c4d6edcf746a3d1c329a3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'f0bb5218ccb8c2fa77da57b0165bba9ba842a686',
    id: 'range-test-20260619-554',
    matching_hash: 'eb76f013c08910689d9c30dc0cb5c6cd4c259d3d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '965d3ed210660ba7d1514e78e5cb1f508dcabc69',
    id: 'range-test-20260619-555',
    matching_hash: '7824c08dbf22db7a7a16dcc56f6f9f0e60f5d806',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'a482681dc7d5632203aebc9cef8fdc6940943ae8',
    id: 'range-test-20260619-556',
    matching_hash: '0e0be9bbd3b5bfdc9fbf250d594bd69667000306',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'e91640d17655c48e653e585488a9cbd6718fc129',
    id: 'range-test-20260619-557',
    matching_hash: '2825ccfbefa8fa4af5b56df5cbdecfdae25093fa',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '8e8c29aa460c1652e40ad821736413b80d17bc21',
    id: 'range-test-20260619-558',
    matching_hash: '478027291d9d75cbe6e2f111fd75bdabd0e15e63',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '6b644219eb6a122c2f9e1d1ba525e1d357d6dd26',
    id: 'range-test-20260619-559',
    matching_hash: 'd43c4d408075b5a5b8a633492cbb08a3b29aaa5e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '52e1bdbfb0c845099cf2fd196a1abf72ee3967eb',
    id: 'range-test-20260619-560',
    matching_hash: '7e9aa61ace70635d2660f619e6d6633550296f42',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'df661cf92720d4ca9536bc72cb75822c1ae3e627',
    id: 'range-test-20260619-561',
    matching_hash: 'a61b9ac58ae15c02d9010d243d839bf0f7101563',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '97a4003601431d7dcda551fd86a6eaf616c290af',
    id: 'range-test-20260619-562',
    matching_hash: '9f22c0762ac673dbfbc9fee9ccf64912b4be7e0b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '4e1a1dfa5a446fffdc2c12a958f94818449e31ab',
    id: 'range-test-20260619-563',
    matching_hash: '7bbccff27cf4376b5397cbe64755dcdfe09cf3de',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '047dca6102406ef87ff6bda1fa9d02d83a9ee1a6',
    id: 'range-test-20260619-564',
    matching_hash: 'f27e86ef95d23cfb252e7626151978dac1317cb5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'feadadf22a9b50a787dc37187efb43fcf0eba9df',
    id: 'range-test-20260619-565',
    matching_hash: '61836d8631fed09b289251e64ad1e40297cc3b44',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '835c9ed17bab81b9992246d7aa7f10d44f96abc5',
    id: 'range-test-20260619-566',
    matching_hash: '031e7e716d7d9bc5c6e641b276128333d5b291ad',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '5c698fb267860fa8e7490d28886299ea5fa54e48',
    id: 'range-test-20260619-567',
    matching_hash: 'a1516ccc78ba28826967fa42d77cb614930079fd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'c1178a54f7434e4c22cd5ae33a73b30eb6f80343',
    id: 'range-test-20260619-568',
    matching_hash: '2703f98e70eb272630b4a9083ca7279220c49a0e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'f2dca75854f790c04618dbca638a66c0bb618b3b',
    id: 'range-test-20260619-569',
    matching_hash: '675ac33f78e1630bd8f3992074dc28f47d43e183',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '73c5e98aa55cf25338f946b8ac98bb20785eb2e6',
    id: 'range-test-20260619-570',
    matching_hash: 'f28914110472625856e2bea8cb1f49b8c8340e38',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'c67cdc5a781b056a3c32e7eb10f1fbd9f4911847',
    id: 'range-test-20260619-571',
    matching_hash: '11ab1f50e6bfaa74cb325e4a2bc433e903d1a1f4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'c43d99dd632239ffb1c382f2fea4fa951658f75d',
    id: 'range-test-20260619-572',
    matching_hash: '479260d4b17abd4d76aaa9549fe45e60e69d73fd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '15e9c4787f4df46e627077a6171d1ee193e0c108',
    id: 'range-test-20260619-573',
    matching_hash: 'c9cd7da1814619aba9ed4558471345ebb6e6be48',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'a801c8b76dbbc01da11b6775729c9c712e2caa17',
    id: 'range-test-20260619-574',
    matching_hash: '4a5069198912b732687a22cac536f781eea41d6f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '686b485fb37ce6bb145a325556bcef3f36984d1b',
    id: 'range-test-20260619-575',
    matching_hash: 'a3d5801db7bec0250ccf5ab61aadeef909716621',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '573bdda1d455fe02d40e43032298a853a600be00',
    id: 'range-test-20260619-576',
    matching_hash: '28b6cfb013378feb2b3e456e888f6d0fa9642ac2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'fd6d8a95592fbcda835645878d2f6eee5367b55c',
    id: 'range-test-20260619-577',
    matching_hash: 'f8d66a8531e7604c6214dffa72f40ce6be7fce6e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'e39bf0bbb91820e3f20fecaf4b0ccde6a0620d7d',
    id: 'range-test-20260619-578',
    matching_hash: '76128499cef18c57c0592b767b7bb52512fecad5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'f69010fc46b3d57b8dbe0c4bb84e0ce46af75ba8',
    id: 'range-test-20260619-579',
    matching_hash: '4bad23a385ea4060f56cf363ec5293ed3ec85fbd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'eb2946f3a5d6da88a596cefa8207147c298108ef',
    id: 'range-test-20260619-580',
    matching_hash: 'c0334bbc785ab75eca848ea5dec3c6f971e96723',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '884c3b0d2fb95f89f1efc44c576dfb06811a9045',
    id: 'range-test-20260619-581',
    matching_hash: 'ff7a5e23294682a2e8534fa4c894a1a5bdb8ffb2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '58712db44f6de43d2b14ef01dfda65d0d5877c6b',
    id: 'range-test-20260619-582',
    matching_hash: '7fcc17b7ff9969cb1a8e7112f9977d4a23a9ddef',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'fe04b54895e328474f30506ca3c62c1fd528e1fd',
    id: 'range-test-20260619-583',
    matching_hash: 'ea2077808be39f31b7ceb7b0721f0e11b106bc96',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '4e74d495d998c30a13b69fd83fbe0d8926abec4c',
    id: 'range-test-20260619-584',
    matching_hash: '86065cde6461f6d443de98b3c84cd44615c1b9ca',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'f001dff150cbdaabfaf7d2ab093130faa673bf47',
    id: 'range-test-20260619-585',
    matching_hash: 'a7e5c802419d4437189cd9ce93e9db2ce73f84c0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '59f0bfae107c004e60037d43d279076dfa998755',
    id: 'range-test-20260619-586',
    matching_hash: '7e2a9690570aa38089975e6df274b291f3d6d549',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '6847fa5215f7ec32ec1b9db40190ead614c12829',
    id: 'range-test-20260619-587',
    matching_hash: 'da3613c66f4e2a663a1b25b70b758d260a0f5bf7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '3ff60d678ac11248191201cc4eac28a012782b24',
    id: 'range-test-20260619-588',
    matching_hash: '0d8c22c3a0183ba6a0366781f43f80e7f83d6233',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'cd11b3d659b793f60311c9ccb75d49ba2936500a',
    id: 'range-test-20260619-589',
    matching_hash: '27ec1ed1afc128b6f2d2f4cac88f7d9250e18f3d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'd203edf1e7ae57eb3160f506b2a770dfe910abb1',
    id: 'range-test-20260619-590',
    matching_hash: '1ff7bd1dc3c6a0f823df55c95b141f5a03ba2fda',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'b877b45a7f9968d6aaaa796d70cace4d81333913',
    id: 'range-test-20260619-591',
    matching_hash: '1e97d67db595862d41e4c35b71335384bf120915',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '4305119933801c0da26b09ee3ab19d6365c1d2d8',
    id: 'range-test-20260619-592',
    matching_hash: '2ff04d73044964f6e996e15b79240d8fbf470313',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '89a18260a32ba24b83ff7d1eef90f4ce898ed468',
    id: 'range-test-20260619-593',
    matching_hash: '965ce3904bd644676c0fb12813f6ac06cc35045f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'feabd4faaad98fb1c5e5ea812dea9c677a26a3cf',
    id: 'range-test-20260619-594',
    matching_hash: '564058fdf5383214020eed4f9aa976c549883515',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '48dc04346a83749e7ad44b212a2b2fe80a766533',
    id: 'range-test-20260619-595',
    matching_hash: 'eac013e3b4bf8687f8d2a295b5eb59b98f495842',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '38b7f5fdb22f49fa9871f375b9e6511be73c8abb',
    id: 'range-test-20260619-596',
    matching_hash: '6c1257a21a1c2b0b934ff557d74044e63e978030',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '0ea2293778bf550b0230adff0935ba0cb9db6e9c',
    id: 'range-test-20260619-597',
    matching_hash: 'c104d1304730eee0ac90172308c5d08994d36564',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '74ac7abae44f6952dcbf468b245ac2565ff7ce14',
    id: 'range-test-20260619-598',
    matching_hash: '5644ef7c59ac647605623eec90abc4a4d8eab1d5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '3ee9d53287ce18dc22bf45088e109fdd3f9b8b04',
    id: 'range-test-20260619-599',
    matching_hash: 'c1fcd9fd8873cbd36cdecf9a0e202f3f7c8785e8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '03dbdc587caddb607f280295682ae7aa0e948476',
    id: 'range-test-20260619-600',
    matching_hash: '50e3edfc63761e7b2e547ab4152aeb930e16e276',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '27741e4d92b4c300bd79c7d3f2d83052b7d5ca93',
    id: 'range-test-20260619-601',
    matching_hash: 'caf786374e2464b4f0e5b47ca26388c5ca7a19c2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '6b87f4d0c827408128c7d892d8d0cea9e397ee4e',
    id: 'range-test-20260619-602',
    matching_hash: '7bfd17300d2d5eb628a31affbe9f9b5b7dc1646d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '8ea1b9a9ef2d53a9d54be02c55b7f6dd722725ad',
    id: 'range-test-20260619-603',
    matching_hash: '03ff52589818424032705e7f0b1ef5aaa4db4728',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '6a39d2d42623dc44ac7e04e31ad1cea62fb7f57c',
    id: 'range-test-20260619-604',
    matching_hash: 'd13a8bceaa10e9636ebf399a353e6c50a51bd9f3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '0306da32a4de4bfe41e0c3e0ce8aa22e56590bdf',
    id: 'range-test-20260619-605',
    matching_hash: '518e779ab118177586c78942a0d5e7a12f78fbac',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.703830843,
    qx: -0.254325891,
    qy: 0.387565721,
    qz: 0.538268797,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '089105b2a04749f5bcd3945ab3e577c3ee7569ec',
    id: 'range-test-20260619-606',
    matching_hash: '9dde94b6ddef8ff1b583755c6bcb6c1d7da78e01',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'e336db9162e4850bd832bc78b34992743fc0a09a',
    id: 'range-test-20260619-607',
    matching_hash: 'a8d50d3157bc48da91dd9af96a22a61523b69a7f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '74f1de1fe4d4f77624906f3fed650c479e8ee954',
    id: 'range-test-20260619-608',
    matching_hash: '549ea996a540fe47b9916c246c3545364059b936',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '45a35204d5a45e7600e44ad619818459e9a56dcc',
    id: 'range-test-20260619-609',
    matching_hash: 'aeaaa5f09845efc07d77cd57f80a23381d7a4646',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '42b8f8a9e7aa63cf1666e8d1b23f770e11999724',
    id: 'range-test-20260619-610',
    matching_hash: '0fa12d14f9fcd3d2760dde536c9a3673d176dc02',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'e6a4e23f36685f1118e269bd2dae547c71c9d0c0',
    id: 'range-test-20260619-611',
    matching_hash: '023094d3f382349ba6882bd2e68db478bec4a39d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '8b02dee3faee061ace4de9c20c8886a223902738',
    id: 'range-test-20260619-612',
    matching_hash: '2a7f7095ca552e18343678f392a31207f33a2bad',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '9912411360bac0b9dd3efed637bdb255e979781e',
    id: 'range-test-20260619-613',
    matching_hash: 'b8409dca9a9babd7ca0cb41a8c12b4b387e0ada3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'b1b1398917c4085c36ba6cb6f7da9b845acf91be',
    id: 'range-test-20260619-614',
    matching_hash: '06f6e5ef846a0bbc8398c1d7cabfadf3901a06e5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '39807593ae4f85905365ae1c85780f78abce406e',
    id: 'range-test-20260619-615',
    matching_hash: '3a0de837d37caa7f71f8063cb4caf2ff3c0b6a65',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'd11f4888e6705db57dabf2e640fa1536b3309847',
    id: 'range-test-20260619-616',
    matching_hash: 'f62d8da6a0ba47f961404e2bb76604c3bd85c280',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '5d0ab9421e5768d279ae0ca89fd2c34046ed6e9c',
    id: 'range-test-20260619-617',
    matching_hash: '2865b84f2827ec7756c6d1bbb02eba8de3dba8fa',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '9292600961d7a833ade75154bf27984be22f5b1b',
    id: 'range-test-20260619-618',
    matching_hash: '448bb2c69a6318ccab2b038a2794b2aaa8419e50',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '89d72882ef8c7581deb5d66fc750848a6f54e643',
    id: 'range-test-20260619-619',
    matching_hash: 'ab746d3eeb17eee913a4c810ab19edb65bb6aa14',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'a6cbabf9cc4662802d3a8d2ad22c9a8286e32035',
    id: 'range-test-20260619-620',
    matching_hash: '83a301ce9341e1ef050ebc2fd9a9e6f162137623',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '7720917dae1fd6a635dc6fba9eaf379928bcb8a4',
    id: 'range-test-20260619-621',
    matching_hash: '8d3c20a9d3a974ab58626d0538ef95c0cf1789c2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '4553968b352d15db0b1ebadfd018de092989d2fd',
    id: 'range-test-20260619-622',
    matching_hash: 'b2e7b3cd71b52a157365fe002829bc4e763eeff4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'b9c3320bb3b4d34119a2deb1ca28a0a960086ebb',
    id: 'range-test-20260619-623',
    matching_hash: 'e9260e6fd5a24dee3b4b17e2cfe7db28ac845afc',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'd0ffd6037af800f2f3484931f6a86e6b21149db5',
    id: 'range-test-20260619-624',
    matching_hash: '2c1f33fe1bc215f6254017d0f1675d2ee80ee7d2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '234a7be54329f31ede8fd708c03d393345f215fe',
    id: 'range-test-20260619-625',
    matching_hash: 'd77eac1deb4b00f1c589c54ff6b21007410362c9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '2dd24da80a12732df25cfa61f809b50054833bcc',
    id: 'range-test-20260619-626',
    matching_hash: 'a29be26ae4ac0465a141eda3a4ae8ca38ea80548',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'b02cc90f0f4ba94c436ec98788ea293089876907',
    id: 'range-test-20260619-627',
    matching_hash: '04143ef42c4c0b82f90b7371eadc5ae1d85f268a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '8d77a18df1e9b7eba7101f7adb4844e2244a4a11',
    id: 'range-test-20260619-628',
    matching_hash: 'bd2fd830a69096ddfe70e6dc9f892cf517a71ab4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '8ca5b5f198fb3372ef05b9bb7489429d43048e9f',
    id: 'range-test-20260619-629',
    matching_hash: 'abfee3741673d0ca71dc5ff9402cd08d93dc4437',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '61d992bc9ed5b9d780fc4a847b5edb6e57a65a88',
    id: 'range-test-20260619-630',
    matching_hash: '4eefe4a9c72caaea7f43addbe7f385db5aec1c03',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '6b92fa452455af9ae92013696c231cb48d8781d5',
    id: 'range-test-20260619-631',
    matching_hash: '6cfee4b47e18d511ee81ae93d6b79f9c92987514',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '75916c66e23dfc5ae1ea48a0aa3c2c515aae6c65',
    id: 'range-test-20260619-632',
    matching_hash: '7cba4aee03bc127b86dfa42465a93b41625aa5c0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'ca77f1108471767b99eac07dcc889f4b087ae197',
    id: 'range-test-20260619-633',
    matching_hash: 'ee170cfd42f797706f8f42c5a5a93d2fec801623',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'b4ac1ff02f640a70bcf14c654f2ca4d5e18900f1',
    id: 'range-test-20260619-634',
    matching_hash: 'ebb5d7ddcd2bcf7a636096a11ef5c6a2080aa44f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '08f89a025ccb1e6b1dda2621116ee566d7bf08dd',
    id: 'range-test-20260619-635',
    matching_hash: 'ba5cd368c6b1c95c5320e463612d7daae2ea1bc0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'b1fcd9f927d9bf40e60898085e36b8dd2bfb9406',
    id: 'range-test-20260619-636',
    matching_hash: 'adae62def9eeca2eb72f2c049a4cebb20a558421',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '59cd2a70b025733bc179094d1e21c1e76418f9f6',
    id: 'range-test-20260619-637',
    matching_hash: '4dfb556caabb835bbe6cd89d8b204990be19d078',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '9ad675b92b04268e58e384456fdf1ba1396a7a36',
    id: 'range-test-20260619-638',
    matching_hash: 'f33a5e7e56c6e4bb80d9d2d8dbee19c8eec43a5c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '20aa35503416cb75e8dea0525c9407be9f0b0f52',
    id: 'range-test-20260619-639',
    matching_hash: '1ddcfb527b8f288092c0dcbaf06d6cabb8e195cb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '395a25658d869e14618ddbb1afad8f959af9a245',
    id: 'range-test-20260619-640',
    matching_hash: 'fa8795d298a2d2a0e71b8d404f40b85d9ebb7828',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'bb9118166feb2508c9dcefbfef5dfdca5cf94b5e',
    id: 'range-test-20260619-641',
    matching_hash: '4602e5a97d8e8d0572f9c5fafbd461bb3ae7f4d9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '1e264bf4f6fef20044e29f5050c44af63777937a',
    id: 'range-test-20260619-642',
    matching_hash: '410c082104356f5f50d49c27a52be1a7115b38ee',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'e60f331b9bf5346a24f9d2eeb25a6e95c4e8716a',
    id: 'range-test-20260619-643',
    matching_hash: '6951e91c3ea4ac348f67369494035f986c7d53fa',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '7c2af7247564a7412cc1eebaeef2f29ed1b94a95',
    id: 'range-test-20260619-644',
    matching_hash: '470a755e5b44286d50be519eda4717c062a4c5b6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '1fd2ae0353d4fa932604abdb7dc55f6446d8e58c',
    id: 'range-test-20260619-645',
    matching_hash: 'd694e012b6afc97c2fa8c824b053a93ea14a6625',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '6ab292a4c8bba6989bf7fa66e91585d2d5bcd09a',
    id: 'range-test-20260619-646',
    matching_hash: 'f76fd4cc76a45bdb88d6cc2767f6fda437ef6332',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '84ad4429a7a5ed4b7179e38a6fbc25c1c40defc7',
    id: 'range-test-20260619-647',
    matching_hash: 'b77d448c45c5c17921fbcfd6c668380e9afe5db7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'c8d44c67578db2818dd8ea91de75af46829bde24',
    id: 'range-test-20260619-648',
    matching_hash: '3930cb8777085006230e39d65e229ffad7c99f81',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'a9fbc86d5ca4b95cf50ba83439beed0616c55853',
    id: 'range-test-20260619-649',
    matching_hash: 'c0e3fa9e7be3a7ebda4c18c8199b40dc3053b5ee',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'ad5993a488fa49b60d4bc16bfe5bc4b895926dd2',
    id: 'range-test-20260619-650',
    matching_hash: '7fbdb342dba5b9c37a726cdb41693d4beb2c0765',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'b1226efe8cc646bce2d4561a166c3a23ff90e7c0',
    id: 'range-test-20260619-651',
    matching_hash: 'ede492c114e8f7934ad760d665d9170f3312abf6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'f90a10a08ef2b38f53c8e8c6e4b23e7608494aeb',
    id: 'range-test-20260619-652',
    matching_hash: '19e9b924cd0ec5460042daa5a9e126acbefaf61d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'aaf1dfd949f7d9e9b584e70d8bcbc3491d12628d',
    id: 'range-test-20260619-653',
    matching_hash: '14b5f9ad56b0f7e77de73154e4955663f1846f52',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'fe18ec32c7d1e9cd525767d226c4979ebec2f43f',
    id: 'range-test-20260619-654',
    matching_hash: '523ecc4e130e031f15dc1b490ed0deadf662bf54',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '4bebbaf168a2cc98968e4481703a18f9f57f4653',
    id: 'range-test-20260619-655',
    matching_hash: '3afa522a81709965355226be29ff2615e2699e04',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '48929c544674f3bed6f111ed4f0129b6fdfb3667',
    id: 'range-test-20260619-656',
    matching_hash: 'b1aa94799218fb0c7087181218dda9a965419319',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '0ace5e65a4f00ccf77732a6b06721df2783d7509',
    id: 'range-test-20260619-657',
    matching_hash: '8cc590dfca4d0dc7f1427cd9aa1865dd667d9d0f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'c0de26ab28e60cba26094313de7b8ac4d0d9b1ac',
    id: 'range-test-20260619-658',
    matching_hash: '2e9df9421d6f37804d43006cada157ecbde9d44e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'eb5f24bc651c24bf555b3f434606f7e64fafcc6a',
    id: 'range-test-20260619-659',
    matching_hash: 'e9df29bc41b79219c9dd911aa5a15b93573c2031',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '8f1fbb320321982181fb0e5399f39c11979fa5d4',
    id: 'range-test-20260619-660',
    matching_hash: 'c74f2b45dbb410a033cda2da562dcafcf8a2533f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '7784ad6c72faa35b0e1d34415cf3bc9bf4d2f0e8',
    id: 'range-test-20260619-661',
    matching_hash: '2b64fa759ec00872e26a98bd5595fa9430f0ab39',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '2e98587f7f9c9594929380c3d613af87fb30fa9a',
    id: 'range-test-20260619-662',
    matching_hash: 'dec66c94e7857e612d2e8baa9aee8b7fcd8c2841',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '1a6f07b388a0674e4a0e433e245df870daaf374d',
    id: 'range-test-20260619-663',
    matching_hash: '2f361720af86ae43f905c343583c7ecd78f52c33',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '80209450b0262ef5dd23aa846d5907e350a259a9',
    id: 'range-test-20260619-664',
    matching_hash: 'f02ac56ee76470759e72faddfeba3cf9633ead34',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'e0d332142911392c91dc3f6a09198f05b0d19b7f',
    id: 'range-test-20260619-665',
    matching_hash: 'c95bbdc1a45694bce9ad425adbd482a230111a65',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '7a8ca04704e8bb74b5d4fc0e761afaa962f39e76',
    id: 'range-test-20260619-666',
    matching_hash: '01f4818b9fb6cd429408e95decbfc7f7e60b51d5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '6e24b16d327cbadc37b20f5c5d49541559109e05',
    id: 'range-test-20260619-667',
    matching_hash: '789499bba45c0821669b09306e887a6fda5f9e44',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'd3e4ec6c5caa0cb3888e835baeb53466b03f13a5',
    id: 'range-test-20260619-668',
    matching_hash: '9e1105718360c4de7348f7bc54e50ce912a19532',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'e9b95ad1d0adfaa27272599e5a9b5cfb6bbdfd0d',
    id: 'range-test-20260619-669',
    matching_hash: '8e6374362425b3b90d2851f00767612b1cc8d949',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '82cb2e58bcdaecba64082106752e62afd82a5f74',
    id: 'range-test-20260619-670',
    matching_hash: 'b172fd48e3a64ab16e71e57db00a9be41c9dda40',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'aca3ca93999e8a0c9c24f4f3eb3be41afc787b6b',
    id: 'range-test-20260619-671',
    matching_hash: '15f6a567e04203414937996482bfb3b984d1a3b6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '967d485d69a9b84ed9fce2036202ca174a7e19ce',
    id: 'range-test-20260619-672',
    matching_hash: 'bb832930895fd766ec1e5b1221ced4c96b9a219d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '5c229499a848e9710f11acb5871172cf8263d440',
    id: 'range-test-20260619-673',
    matching_hash: 'b02f3eb9c1080e57bf23abd9d946cac522892924',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '3f3ad7d99cf5d8b2c38f83627a2000f53c6853f7',
    id: 'range-test-20260619-674',
    matching_hash: 'e643617dd9e0980b04b5e6b99ede31c56f5fcdb6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '9464930d6fe77b295331f2f3c9095d58cbe1982e',
    id: 'range-test-20260619-675',
    matching_hash: 'c4918cc10836d76ae795cf055cdf2de4f701ad50',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'ed890ec93c61eb258fe509f76734610c1fc6a7d5',
    id: 'range-test-20260619-676',
    matching_hash: '5e1524725b7151f60375519602706c56d945f031',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '2471d7aaacf757e2eab4f7e716e5f5c0b6c56b29',
    id: 'range-test-20260619-677',
    matching_hash: 'e17b05fcfa03158b2b5de2b06eb0b75348760b27',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'efea82e0a900d965ab8bcc2eee68134f43ff0f59',
    id: 'range-test-20260619-678',
    matching_hash: '120f93e4ce007d4c1f65120f59b0fb8d0daee277',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '9bc6223e11e7ecf4c58de21d14e9408595d348ba',
    id: 'range-test-20260619-679',
    matching_hash: '29fee821db16503ea4807d95f80fdb172c9a2d4c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'c5c76529898b596b4a939b5bd9f4758c2966c9e9',
    id: 'range-test-20260619-680',
    matching_hash: '7e0ee2a65a538905e554d1f5306823fe008edec5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '51c45f6fe40705a34767739fc7bb79c5c863a300',
    id: 'range-test-20260619-681',
    matching_hash: 'a03a5c6bbc4c10f2858eb699138a2a8ce005e1cd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '90606543664480cb6c6787b03b6f48184954b6c5',
    id: 'range-test-20260619-682',
    matching_hash: '0438401d3fbee14c0a301300a62c0b60f909f85a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'b3571382a554e68838f846049489d7e40e078270',
    id: 'range-test-20260619-683',
    matching_hash: 'b6d724daccfb13bc582fb44f21cfbabdbe549e13',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'f87b8be11275e61009de4b08424f7d070499e501',
    id: 'range-test-20260619-684',
    matching_hash: 'a099639e3efb293b72a2c4aab9392d458555f915',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '3b5538ce4fe81594b13ab9a09659682423756353',
    id: 'range-test-20260619-685',
    matching_hash: '9687abd77c6fc4e6e11a258b53506ea50e9faa84',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '3a871eaec5cdc31c4421228ff6ed6e17f8d7b30b',
    id: 'range-test-20260619-686',
    matching_hash: '15747efa3698087983e079377b9b30e07d56c8c1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'a133cc20b078530aed5cc861b9d03b32b3edbdd1',
    id: 'range-test-20260619-687',
    matching_hash: '080d8fef8699811652b981745c7831bbcc1711d5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'f09ec9e848825cac98dd3f52fe1e0031cedac737',
    id: 'range-test-20260619-688',
    matching_hash: '68a3cb4c0575122d5f8f38a5c8f4431906b9dac5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '53da60a75a16a730c7151ed8c5cd511a1c4fe26e',
    id: 'range-test-20260619-689',
    matching_hash: '9bccd058bcfb8949cb252c06182b0cda0e81816d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '39a357b1f58bb2e0fa20341bf4edca84b7da45ed',
    id: 'range-test-20260619-690',
    matching_hash: '1fa492dbbc1963e292550056e63ee4c86ec29b17',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'dea99b303a858570346684b3ed9a36755f322554',
    id: 'range-test-20260619-691',
    matching_hash: '88c58ab7ab32628c49004db1bd76d029446b883d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '7824153e19fe3ab083fb93e33cb6e640579b8fe9',
    id: 'range-test-20260619-692',
    matching_hash: '357ee2d23923bb63a2de8cf75cca2a4240fe8977',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'ead2f4c4eb8c0bfdb4a766f1773f22af5e991a50',
    id: 'range-test-20260619-693',
    matching_hash: 'e923498b54230138566a82254679413ffe1be944',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'a336c8188ca350c3fe063f9edf2d6d704aaf2dba',
    id: 'range-test-20260619-694',
    matching_hash: '1b26dfe617800dcf38d0348f2fd77fc974cf1b13',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '3d879b977e2f99a048ba63e7413a49d71e5e5f62',
    id: 'range-test-20260619-695',
    matching_hash: 'f5fd3cf12a94ae14599729fbf25b8dd4d0488b47',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'd74d7032b65bc19ce3f253e44ef888f9119a3c16',
    id: 'range-test-20260619-696',
    matching_hash: '7bbfb2e73796d7a90897e79cd95cde3fcdd137d5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'cb57fb34cf82429ece2768b3d7272a3843cab817',
    id: 'range-test-20260619-697',
    matching_hash: '3f09f65ce8a818df8d850778e993a749df94c25c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '610c6549c74fe6ed215cd4480a684a7c549c7e31',
    id: 'range-test-20260619-698',
    matching_hash: 'aaf75780a2a0bd72bb094359b00acf78cf670b6e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '683ec46bd3737e07efeaf177026d51aeb39522c4',
    id: 'range-test-20260619-699',
    matching_hash: '4b5a89ea58ce60dfd9688ca6a496216df044d443',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '78ee389a09b1ee5cdd55da785a566a3aab6d41ab',
    id: 'range-test-20260619-700',
    matching_hash: 'f2a5aaad960692b93a7e93fca19e79c456bfe586',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '66c4004fa8fa61be17902f88ce815d702f55ea29',
    id: 'range-test-20260619-701',
    matching_hash: '5c7fc1db30963e5daf1a6a0b60b821190577b758',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '5459e4f550233fd994a39375e36a6b36c641926b',
    id: 'range-test-20260619-702',
    matching_hash: '9bd5bb470aba66516699a7456d7102b1aa03cc75',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'e335bdaa290ae4b8a848dcfae76967fc1f1a36de',
    id: 'range-test-20260619-703',
    matching_hash: 'fa4e164aed5576e1d5f63efcd116c8a5fadba0b3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '98aad9480fd6bd7a450d27b56236819234644b20',
    id: 'range-test-20260619-704',
    matching_hash: '6080aa4c48890175fa2143d4c457cbe632d100f6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'b69559fa30a9081be795a37b8ddadf5ed33668d3',
    id: 'range-test-20260619-705',
    matching_hash: 'c5f64fb6747fb478b737344e5dba429ef7ce57be',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'd35fa8162ded3b098c7278fb9cb771f07602eb10',
    id: 'range-test-20260619-706',
    matching_hash: '90f278017bd312921f7798f78a2f3e8c33de987c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.9843248,
    qx: 0.020107446,
    qy: 0.010547233,
    qz: -0.174897499,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'c685a9cd4972f3f68e352f52d00f3bcf6f900292',
    id: 'range-test-20260619-707',
    matching_hash: 'c89cfd08f929ef399d1c17906ae493a66e8216d1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'ebd63ec58a48f06587e40bfabb371c483ebad6f1',
    id: 'range-test-20260619-708',
    matching_hash: '1bcde283e44f4cedf21580e196a65089ceb0ecb8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '422896f641807d84cdbaa4ffaf66406d4e608346',
    id: 'range-test-20260619-709',
    matching_hash: 'd2e49fe6c2663bf3f8a4b320a9f9c7e5030aec60',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '6b937a88174443e59c17dc4821529bdb4446c8e8',
    id: 'range-test-20260619-710',
    matching_hash: 'b3ca3781f6f8756ed1b915b1a9b1dd1fafeb09cf',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '95f5a882790736bc4968ef21d4198eee2e83237f',
    id: 'range-test-20260619-711',
    matching_hash: 'd012bc9d7ad0e48f3ebcf3ad69c072c8f2e640a9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '5e3f5b10d50f078667abd4edd940575448a8687c',
    id: 'range-test-20260619-712',
    matching_hash: '78a708f35572d8c35530df22eb88b601e69041f5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '42aa1eaf92e80be091f622b14eb73c559e35079e',
    id: 'range-test-20260619-713',
    matching_hash: '7e56f007353db45307c084d4f05b14f4bd3439f9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '3146d2370b9450f410d642c180a1a9c68b6cc1bd',
    id: 'range-test-20260619-714',
    matching_hash: '474eaf693999ca91a3a16757cb6bf80fca6af6f5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '6f2a6c0b596a74bcfeec7dd6c3c021b8f6307930',
    id: 'range-test-20260619-715',
    matching_hash: 'f708a1385cb5bb6793463652fbea7239483d41cd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'a8a8636d633c9a3b0ff62af06c8d8caafc295329',
    id: 'range-test-20260619-716',
    matching_hash: '3ae91d9c2398d6572005ff156417dea3d49a1e4a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '0f3ae648e7173483ff72b9f59a6e8d1fd8292407',
    id: 'range-test-20260619-717',
    matching_hash: 'a49caed24aed034671d731e878fad8875e705b6e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '016f2205ae347be875cdb15149b64b1cf33351f3',
    id: 'range-test-20260619-718',
    matching_hash: '1e3d1a142eae24a94f062ec84c80ec08d0361208',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'b56732e511a333d9b9560013289dc2cce76515cf',
    id: 'range-test-20260619-719',
    matching_hash: 'd518352d6a10413d93ca4b50f1dd8dd75cd3dad5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '5b9fc79d885308bbced5237bf44397240d1c0467',
    id: 'range-test-20260619-720',
    matching_hash: '1419102494a40b408d7361c0da7502fc77c31ed2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '6afa7e0cfa2579e666fa70840a1a9c95f8eef675',
    id: 'range-test-20260619-721',
    matching_hash: '25806039ecdb66c59425d2d53c9b113a79a85bcd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '99a414556070fd00a7a213aa8f97bcf43aaff8e1',
    id: 'range-test-20260619-722',
    matching_hash: '6869d116416febd0854cbc97056f57c21ddf55a5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'dd9b91ccffb35ccd3bad52c2f99e268a9e438699',
    id: 'range-test-20260619-723',
    matching_hash: '92148569b44812fb7d9fe8bd72a1549acac45059',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'c4377857b91ff8621e732ddb47204bfb2ef49658',
    id: 'range-test-20260619-724',
    matching_hash: 'b00084141371cb7de1ad6741e33109aaa1f52376',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '24bf8e59dbf64111f5d578ff4d7766e13789bd95',
    id: 'range-test-20260619-725',
    matching_hash: 'ab2aee2bd2188aa744d97a63afc33337c892956d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'd893f8df2d85ff1932ccf3b3733577c9108587fd',
    id: 'range-test-20260619-726',
    matching_hash: 'ed3a8dfc6ddb4aa50be8f89035686e2a50c72b28',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '55bf74624e0083002816931139ae5aca0fbe434d',
    id: 'range-test-20260619-727',
    matching_hash: '5d22453ddd1698d18849a484f53a732f534fc3b7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'f29d3ed20326136578cb71da30b05cc86922f9ba',
    id: 'range-test-20260619-728',
    matching_hash: '7f973bda93c6ac850888362f17a8794e22942a3c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '7dbbbbf1d2da064dca7c5715359bbdfb5bc5f596',
    id: 'range-test-20260619-729',
    matching_hash: '3ae28f18b374647020bd0031de29370fdd590635',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '0481c5642722fb7f18a00d0f1ce23090650dbafe',
    id: 'range-test-20260619-730',
    matching_hash: 'ec81383bd48c51d89020fb16bf0b7fc67078054a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'b1f23db0f305e277c7c2b04d724404b55e1ac31b',
    id: 'range-test-20260619-731',
    matching_hash: '10fa72061311e39e8865517f0326548a49a774bc',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '6e76cfdf5a4a1ffe08b692348836fc2175760d5c',
    id: 'range-test-20260619-732',
    matching_hash: 'acf6cc6d1527ad1962d74872c679b0cfd52d1336',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '1250036efb7794ce76f859770d483ada2f5589aa',
    id: 'range-test-20260619-733',
    matching_hash: '80cf406b2ba8a7ce1bc40085f0b45739543e175d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'cc9613d9950c80383c1107bc6f14bfc3da4e03a1',
    id: 'range-test-20260619-734',
    matching_hash: '49e34fe5dfad07466b270353c7c28fb7155e1e2d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '46fbc28888622996409cfe8ab1c0ec83fcab196e',
    id: 'range-test-20260619-735',
    matching_hash: '1ce26a7d19a61e58f8af0c1db08ae4b4c9211945',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '3ae054cfd96ee7d53efdda94c2c788f6213edf6b',
    id: 'range-test-20260619-736',
    matching_hash: '908b37b277ffa13d14b3c9df3c6c49fdc825f701',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '81496319f79afcb1a5e23ab5290746a76786b981',
    id: 'range-test-20260619-737',
    matching_hash: '449753515303835192d0ba5914776f03da60e1e4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '1331780556aa9f027cdde38b59c3899b81d81eba',
    id: 'range-test-20260619-738',
    matching_hash: 'f5dfda1328a2e7f7c7d9bf8087e28fc062913772',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '09a22dc12e36690d4b0df3af29532302f1b98e17',
    id: 'range-test-20260619-739',
    matching_hash: '19d67fe4953d0df6c2746977a64a99168287a83d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'ed3eabecbd0587f62d200051d254039bd545c178',
    id: 'range-test-20260619-740',
    matching_hash: 'cbd3049d07d3c2ee1d6955fddc59a6b60c6c2e7b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'b68327eb907568211f8a1ec252f92080f62ddedd',
    id: 'range-test-20260619-741',
    matching_hash: 'cc289484a8cc396152ab18941851d4eadf71e002',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'ec36588ea9c903344601f794f235e81bcebf2ced',
    id: 'range-test-20260619-742',
    matching_hash: '5cd1bd608872986ec86c5dc6cc3878a519282bd2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '6fe38c8e4d15842d10baeb8e454b4b9ffa59b41e',
    id: 'range-test-20260619-743',
    matching_hash: '6789b8ebc9332af1dc67b2e98840f15ab4cf83d8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'c6e47c5c4aa96f2fe2bce281e7f1816482e230d1',
    id: 'range-test-20260619-744',
    matching_hash: '7e31f0efa5f692eabd86b6fa7c13bdc2011d1692',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'fb09a1d7d0a5f067b34e4a80739db41f10c9a968',
    id: 'range-test-20260619-745',
    matching_hash: '5bf75e07cb5c03d9f8f0c2e19fa70ea574ca9b22',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'a60cc8eb64bd029bb95e68580bb65e3f15b4a25e',
    id: 'range-test-20260619-746',
    matching_hash: '560f01d51e9f95ba7a5d77b6cbb1423248066325',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '790058a78da691fccb6377349f956c170e7949b0',
    id: 'range-test-20260619-747',
    matching_hash: '28759b6746ebd9efb5b9adb97807eb8e7be707f3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '507c56fc9133cd0306f57726ec137fc6e04ae291',
    id: 'range-test-20260619-748',
    matching_hash: 'b944be2bb98ee64a3bc451a175a4feb3b88da5ac',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'd379af383a2af0a8c3e6f042c1f3179cde9e66d2',
    id: 'range-test-20260619-749',
    matching_hash: 'c74676ea52dc20ea95757eab3d826d4b3bcb051c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '9fd3135aeaee64f8d8d6e9510c66dd5e48845094',
    id: 'range-test-20260619-750',
    matching_hash: '6ce175c7611098e6c1bb1cffebcf0be5d9b469e0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '85dd9f6e73603bbf949b0acfcaa89edcb87297a6',
    id: 'range-test-20260619-751',
    matching_hash: '2d465ceafd677482616970140bf42416985e33f4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'ab2be8d8afa8ea5c376faaa91396cc6eebaec694',
    id: 'range-test-20260619-752',
    matching_hash: '2cce7c906d751fb1feb1fb565521628f11a95709',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '0caf149f4a183431106950bf69a330a2ecf44879',
    id: 'range-test-20260619-753',
    matching_hash: '25710264bb538a41e65b9b273f7034d3df424923',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '1e295206db1e9b35ee90d28d5132ba8df424107d',
    id: 'range-test-20260619-754',
    matching_hash: 'ba45991c0a92ec4565a9c268ddd01c05d5bc9761',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '1fc6f92095c92a3589d7e0042eb924ad6e8f6b7c',
    id: 'range-test-20260619-755',
    matching_hash: '4c41f2273b0bee410f57ae5b45ac474cd583a517',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'b1f73b77f02db3d1a089a128a7338a36cef10cce',
    id: 'range-test-20260619-756',
    matching_hash: '83a26cf4b838041f5393ce18017b10e7af674636',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '6c74585192d8baefeb249405186b38a34216f7d6',
    id: 'range-test-20260619-757',
    matching_hash: '2db3e55a139e8053f8fb7a9d4d67204d822cebca',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'ac2660d121bf1c779650f4eaecb6abc4bb6ee2c3',
    id: 'range-test-20260619-758',
    matching_hash: 'b76952d5e6be376a07375c473de3c01a1b9709cc',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '2c0ac8e40bb8b73b278b44d775c03707d41b595d',
    id: 'range-test-20260619-759',
    matching_hash: 'd9c6b77a80fa40c283e995dc65bd29ace25a6b14',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'c0f3e612a3710beb37707ee6c256476b60590f14',
    id: 'range-test-20260619-760',
    matching_hash: '9b65b9d2a6b6bfb75bad5680c1f72750c1bc8ef5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '4377c76132f1498bf982477b2380e9ff2a9f795c',
    id: 'range-test-20260619-761',
    matching_hash: '8cd94a739786eaa4b41025a238161ae47fe7e032',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '9f3f064b57e8934f53d0f72fba9408ee2f937029',
    id: 'range-test-20260619-762',
    matching_hash: '562299c0a780b34eac6664ce42ad1d1ecd9035f2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'dec5b6ac473649efcffac13ab4f2cb841c361302',
    id: 'range-test-20260619-763',
    matching_hash: '95580aa3338955fe1566ec7241c49db0a80ae818',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '6e319d8f80dd6174b77be9a24742b7cb1d5b15b7',
    id: 'range-test-20260619-764',
    matching_hash: '1c963cd358296a4011dec64b9ffa78ecfaa1f42b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '659b83fcffe148a83a398a2ef4734799758a1c01',
    id: 'range-test-20260619-765',
    matching_hash: 'cb1a7c244c618de977551d3053ad5c17d9208db4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '2d66a0adcee2031b123192b647401afa68ea96c0',
    id: 'range-test-20260619-766',
    matching_hash: '70a52571615d7994bb2f1ccbd00bca91096faf5e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'bb1a5dd0fe712df6d4256cd6a2c469b0c051dae3',
    id: 'range-test-20260619-767',
    matching_hash: '67d24b6121e06bd313e72c2fdd0ad49a4cbd0dd5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '96ac17a930c0eb36dcb02d36ac8309ccc27a9279',
    id: 'range-test-20260619-768',
    matching_hash: 'b8d47a95e44b5aaee0094d6d1698d90d207f3b66',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '7e7c2f79acffac0e7b5555e1cced1a029320f7d3',
    id: 'range-test-20260619-769',
    matching_hash: '44d9fadba9f2a3fce448993fe6b71dea9067586e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '81fcf5cf26bb5eea2645dd2d24510c63125af176',
    id: 'range-test-20260619-770',
    matching_hash: '18a62bdf97e2560b368e2c2a2b4c6d132bf92aac',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '6dfca4f36a7ef22bbe97b8f258a9038acf28b081',
    id: 'range-test-20260619-771',
    matching_hash: '2edbbaa0ace1764a0f34d28085b6ad547b7bf422',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'be2721d789c6fc8c6887820ded0df6bf4cbeec08',
    id: 'range-test-20260619-772',
    matching_hash: '262c2ccc40c5f572064b2e7eacbb64407ea5be1c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '61ec0f6a80cb09a622dc9664c64097c321299c8f',
    id: 'range-test-20260619-773',
    matching_hash: '48dc46863ce113323914b32f714f233cf17bccf3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'fea8164b4bee9ecabedda0d7a2699d8b93cc99c8',
    id: 'range-test-20260619-774',
    matching_hash: '6f1827f5bb469b63bf3006beafe5908375ff9531',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'bf198e89a3d030c198feaca6ddccac94995a1a06',
    id: 'range-test-20260619-775',
    matching_hash: 'e75b843e848f082063e017552e703600b5744d0f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '46fc4c982cc2c6f5d57e1464bb0a1845ca91810a',
    id: 'range-test-20260619-776',
    matching_hash: '49ab5c6c5912087194a65ce104ba8a9ead8b5b5a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '9bf4feca4ca4eabde549077e7412998a4f29a0b6',
    id: 'range-test-20260619-777',
    matching_hash: 'f6b0d77ba98caca2c8b7666c12af2fc5937e62d4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'f2a7bd71ad2b2b7e013e0c2ce359d67cd700d9af',
    id: 'range-test-20260619-778',
    matching_hash: '3eb9827686b2eead01f48b2f4ca7033c0c24b132',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '21392f2f6798287767141afe3c637f7d386fdaca',
    id: 'range-test-20260619-779',
    matching_hash: '3b457cbcc5fcd19c4cba082b66cf30a3339dff61',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '559b27db234286c8641a99371a83091d169db9d0',
    id: 'range-test-20260619-780',
    matching_hash: '4506a9de72bbd07b0128f80173cc41d194969ff0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '6f174414a2ad99ec5e0c2a2fc5d48c1a0bf7418f',
    id: 'range-test-20260619-781',
    matching_hash: '6bed08a87e8161285eff39b9666593a53a7b3702',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'de4acad40679297af3f21a4d0be5a20459d482cd',
    id: 'range-test-20260619-782',
    matching_hash: '1b660c4c373ba080a193caec56fb829aa10565a0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'b3e667696417524b860c3c3d5b1d1f4c6c7856ec',
    id: 'range-test-20260619-783',
    matching_hash: 'fce0e5337bf198da45fa981f5e6d06ecf94e694a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'e6ef04a8600ba2022a9321e15878f6cc38e7a7ae',
    id: 'range-test-20260619-784',
    matching_hash: 'd8107bfa13bd27257ac956e2c50f3f7220d8a816',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '72965cd84febfb3c3820697efe58e1476572af7c',
    id: 'range-test-20260619-785',
    matching_hash: 'd714ef06c4c148f8a1f7a54772276517f286af08',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'a8557172ab2caacced230f31732761a2d3d868d5',
    id: 'range-test-20260619-786',
    matching_hash: '3bce03409b1462a0c742420ae0b01d921d94fb47',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '15b079eda2fed36ed456585393a3af037c2c3557',
    id: 'range-test-20260619-787',
    matching_hash: 'ed18be9c25765eaf6f7f1fd0fa5578a93d1054a7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '79b9f27c73979dbc2c5a6efc30e73ed8aa04df9c',
    id: 'range-test-20260619-788',
    matching_hash: 'e840c971733207e1960e5de67f276147d9ef4c86',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '1437b09711ac2161aedc574558dd5f40b062254b',
    id: 'range-test-20260619-789',
    matching_hash: 'c81fbd48ea0cd5c9fb3d079878cb6f84af6b92f4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '0c8bc93dd0ec62d3bc506cc91b5287e234f8f391',
    id: 'range-test-20260619-790',
    matching_hash: '09ebc45a9cd0b4c94358cdcecf487b6e0b442633',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'c39fc90cb447e4b1e79628db80977f8b07156666',
    id: 'range-test-20260619-791',
    matching_hash: '782d89e24411fbb92e24700cd52886661bbd27df',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'ba5c365e3bdf2c5e11a9dd7b4fcb3697eaeae2e2',
    id: 'range-test-20260619-792',
    matching_hash: 'e8d8efc91b3fef91498c7618a0d9f554e4653d05',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '024e21d272a78667172f88eb3347cc93c60c6f95',
    id: 'range-test-20260619-793',
    matching_hash: '67505453d6fb9244cc7f8acd504318d278574d65',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '44b8a7128deddbb9ae2e86dd917102b2e31ac5ed',
    id: 'range-test-20260619-794',
    matching_hash: '719956b0a3362a9e1fedba11a78831c3e9f0f7cf',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '55bda22425738021f1375aeb56018968e5657f6f',
    id: 'range-test-20260619-795',
    matching_hash: '356a4b6bc5b09d1852dd50bf1a780fba67dba98e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'faedfecb5a42a7632ef30cf50a0d9038b35583da',
    id: 'range-test-20260619-796',
    matching_hash: '9706b43f937138b0cdc64df208e0b885795657f3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'f4c51987f2a66a6b116dc9674e3a39110851fc97',
    id: 'range-test-20260619-797',
    matching_hash: '25f26bdd41122bcc7699ff0893d92183246b2b34',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'b09ab1311d49145a50f1017061ad2416ea0b7448',
    id: 'range-test-20260619-798',
    matching_hash: '8e3a214b498a27059844122692286c9e9eb6cf45',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'f1f0382181aff65c527a2a22c40b44c49b023ab0',
    id: 'range-test-20260619-799',
    matching_hash: '4f1ed8211ee6f4254ab30cd70eb87a3974a6b067',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '71e0b720482af3936757c197e0dfbf2f5c5fd12f',
    id: 'range-test-20260619-800',
    matching_hash: 'e3d76ae557f3d7acb12df6470ca632d3239d1ab2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'a98b506a4505e467e57053b15e8db60301e46911',
    id: 'range-test-20260619-801',
    matching_hash: '23cf91dbac487fb1ca2fff939add5b6230554189',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '20ea85d2e7324ae378972ec950e5152a24a3ab82',
    id: 'range-test-20260619-802',
    matching_hash: '4df3bd46e53838fe7feffbeb1660290c5a9eea8f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '6893545c12af8c018047f75a88348bc11ff6379e',
    id: 'range-test-20260619-803',
    matching_hash: '25b1828911783562b69d52c2a4606be08c0a9763',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '3ce4911f7238794d67151fef842fa94ad5b05d5e',
    id: 'range-test-20260619-804',
    matching_hash: 'c1ee100ba1cd79dbf224b5bf2a782eb7f13c1533',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'df079afa4f470f1071c283af76e66d64e42e5d9a',
    id: 'range-test-20260619-805',
    matching_hash: 'd2a518e7e9dd0983563c47e99f9e606bdf2fb702',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'b8bbcbde19918906c32ad2296ed8f734e0b24357',
    id: 'range-test-20260619-806',
    matching_hash: 'cf396088687c6a3a7b2aac8e711863050673ff9f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '8519a8272d4f0ed498896566b32404e0e72aa2d9',
    id: 'range-test-20260619-807',
    matching_hash: '707fdd338e499cfb66841c8004328b8268214f79',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.614395969,
    qx: 0.214652417,
    qy: -0.283780892,
    qz: -0.704209016,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '36231efcd1b315df12ea0193bebbdb2e1f4a1861',
    id: 'range-test-20260619-808',
    matching_hash: 'ea183f94ac13791c59ca6e3d951551500c91c58a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '95869027a522cf561a10ca13fb414d51bbb91506',
    id: 'range-test-20260619-809',
    matching_hash: '137c32e908db9da758fbcc2571b7bfd545c15ecf',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '5e03a89ec45e54e487fe43c64516df92a4566cb1',
    id: 'range-test-20260619-810',
    matching_hash: 'f67fce2c3d18fc11bfa15ab6c097d2c04cde7509',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '0d88d5919cacd137a4f1b25f587e3cd4f6fef74b',
    id: 'range-test-20260619-811',
    matching_hash: '251b98fa7bd5873ef5b2bd22f5e5b5991c5f9bd0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '6ce47df732a5333a1db73900a7874dc2fc401e99',
    id: 'range-test-20260619-812',
    matching_hash: 'a75818a42b0e3bc65c3f47eabfeb13e375ee029c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '5b0ac492db5cce6cee5759aadf6080d4614ac822',
    id: 'range-test-20260619-813',
    matching_hash: 'dbacaa69a2657b5c6dca602ac0367f6673093656',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '3f4864d00d5bb1bdc2aa639b47d7005e94a21cee',
    id: 'range-test-20260619-814',
    matching_hash: '25d0d71e5e137681862fe3cb667970f43412ceb5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'e730c8f7fb5e4fb352187610b6f0724a448e9415',
    id: 'range-test-20260619-815',
    matching_hash: '089f3a460cb64fa20b7057dce974f9af860650ea',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '24daabc41dbd1ca71ae6c8439abdde5e6c8cd412',
    id: 'range-test-20260619-816',
    matching_hash: 'fc437555bb31654933acfcf7317d659d8423be26',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '98adede499b5b5ef072bb71b88aa7f9c81ca2255',
    id: 'range-test-20260619-817',
    matching_hash: '1a3a208cc6e7005c15ac0594174eb3ea84b70961',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'f56033c7a689eddaf3126df54a7ca92205bac102',
    id: 'range-test-20260619-818',
    matching_hash: '6d4e71bd03fff3537b829c371227c2b06bb77832',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '425ae566c49956d945d8e8391bbf30281c4bba38',
    id: 'range-test-20260619-819',
    matching_hash: '5dc642d305f1ef6b862d0000142f544b20fe2141',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'c2a77686ecd8b268c1e0810b3d1cb1b6aff4a0c6',
    id: 'range-test-20260619-820',
    matching_hash: '329a6cdc7330db85d7de11fe8370f63564d37303',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'f20f92ab50a5dedc493a860a00c00462fc13e952',
    id: 'range-test-20260619-821',
    matching_hash: '3397062df71c554cbdcc1839d61fdcc82c354a68',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '096e95d412e4cd4b46dec194f73baee4de951e4e',
    id: 'range-test-20260619-822',
    matching_hash: '89de0d9c4f27f411eec153010853415bffae48aa',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '4ae02f3423a3df9646ca44c6ccf043f89ea00a2a',
    id: 'range-test-20260619-823',
    matching_hash: 'fb6a8ec8dc144f78c5a460a2e4e9e32b34d814d5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '96e09b0f24b64aa08d535631c200f69d52e7a3c5',
    id: 'range-test-20260619-824',
    matching_hash: '417bd1de7494b798ef6a7ae59139390c0a70fc59',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'ef90ff7cfd579edebbcde107e192a8635adbae13',
    id: 'range-test-20260619-825',
    matching_hash: '1051502fed467e20ce6f98d2a8a94cb87ef18db7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '710120486e36a8e71dc94e80916cf01ae132c294',
    id: 'range-test-20260619-826',
    matching_hash: '1bcb68308ad061e7204f5be986c113e280c1533a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '4a052ded58b5f098594947ad4d9a9b53b7cc6beb',
    id: 'range-test-20260619-827',
    matching_hash: 'c6626bddbcb49ef5024a190f975cc5dc937ca774',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '545dd9d95d087459a65c3320f341652f84343918',
    id: 'range-test-20260619-828',
    matching_hash: '6327c46a811dfb670e78e6ad8cec002683277152',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '61c89bd844cab128633453c0dee52f48d7c6f062',
    id: 'range-test-20260619-829',
    matching_hash: '5a963cc9edb372a6417c0f8e503954eea4afdc9a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'ab840d344cbe3e995db2945cc69b32feccdefffa',
    id: 'range-test-20260619-830',
    matching_hash: '80fb169786cfe2324caf9724e3e0992f614e343d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '7a51a6ac59d228f9bc08974a07ebe63e67ce1946',
    id: 'range-test-20260619-831',
    matching_hash: 'd674b319db16834f3abbb92bb6f99ea91fa0e162',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '506ac0762853d3e454e6708e7404f8dd73727e61',
    id: 'range-test-20260619-832',
    matching_hash: '0410d1b14696bba4e5458ffb2077ef389eb8d3de',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '917ab00e0ee0c0153f81fc682acf948a4ceb966b',
    id: 'range-test-20260619-833',
    matching_hash: 'f3643c16979f5a05bb8772e03eea01ad77b29a9a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '5215c831f0228344cf630517edd9d5aaade08c1d',
    id: 'range-test-20260619-834',
    matching_hash: '3bb5d0636a44ddfe025133b51e830d7e86f6c72b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '76d82579f6509b72b866e106fe3b3731deccb17d',
    id: 'range-test-20260619-835',
    matching_hash: '48951a37ea7f10de366bfff9200c56e2a48653f4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'a46480aefc0b64e0e3d2167f46d5b053668435ec',
    id: 'range-test-20260619-836',
    matching_hash: '0266991bf5390fdf6c55ac36af6794bb65ecfd2c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'e886da630d2534b1251a911716a352a7cea5b010',
    id: 'range-test-20260619-837',
    matching_hash: '8104de00f2920f89a6a03140dcf995f7e77575b2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'a84fb31b62fd69b8180d45a862313dd6aff74e0f',
    id: 'range-test-20260619-838',
    matching_hash: 'b3af51231299c744107d1d892ff172f36e39f502',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'ead430bce2e5523f80c37157e91a8a8fa0cd9ace',
    id: 'range-test-20260619-839',
    matching_hash: '8198d5378252b26bd2b855f6e0cf48f185bedf68',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '97cec61c676caf6eddff1adfd0944ada40863d85',
    id: 'range-test-20260619-840',
    matching_hash: '51398d7f2a8509c4c38cfa303df8785ab64e807e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'fafad74e311a5600a2337b4c96b9ce1d0cf668a4',
    id: 'range-test-20260619-841',
    matching_hash: '7047c3443e6f9daf28d1061b6dc636e531bb6a1b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'f5ba2da3665d34d26466eb9a5737d71cb076014a',
    id: 'range-test-20260619-842',
    matching_hash: 'c60bd1e1f26531ba6533f74939edfcaa2d24b8ca',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '25f069e22b9d72685216f796341b8aba1e6ed3c6',
    id: 'range-test-20260619-843',
    matching_hash: 'dad0ef1cfc911ce937c70db3204c98ea578b9dee',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '2f50e5b9e70750e7b4450a32f90f314be14de19a',
    id: 'range-test-20260619-844',
    matching_hash: '033406ad5a426dd1f6f5a8701c3f86a75eda6bba',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'e9b7c6ce5e6f5299452c6e4ed1a2db47fcbe6086',
    id: 'range-test-20260619-845',
    matching_hash: '1940d73af7418c7b13b871798a0cdcbcc5e89ce5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '27399b720c3b65d5e0c6bc0785f91bcb7a398ac7',
    id: 'range-test-20260619-846',
    matching_hash: 'e44d029046acec98107f05038479f44639cd0bf1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '3f5867da99a03921aa3bb74356c9fbb99624a0c4',
    id: 'range-test-20260619-847',
    matching_hash: 'f93f86c3249cd746af256f3ede062d770874eb36',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '5d438bbd11b7241dca2d609d1f3e94a3555d03a2',
    id: 'range-test-20260619-848',
    matching_hash: '41bf891c2f40c9566a7984ccaa6d468ca71c4df9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'e088e91e6649c1f30aeab31786498681240c93ed',
    id: 'range-test-20260619-849',
    matching_hash: '9e67f377da45d536f28115fcfb37050216cd63cf',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '332f57921312a5a1106431c49fdc3ed2e84963e8',
    id: 'range-test-20260619-850',
    matching_hash: '6b754a65e8229fe8e3e7a242d44da7abb9953c27',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'b03233fef076bec1b3255eabdd02f69dfac58d5c',
    id: 'range-test-20260619-851',
    matching_hash: '960e86c7a1e2bf30e0e201f91ce812ff872512b2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '6fa238bef63c737de8ceb355b1a145d7aaae4ebe',
    id: 'range-test-20260619-852',
    matching_hash: 'a3aea56d968452cb19b0591b94bb64a907516b7e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '9adbfb31d41cdeb4f8498bbb394061e2cc522aef',
    id: 'range-test-20260619-853',
    matching_hash: '1fc7ba705f1837f5935f14cf7ccdac555ea11112',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '303991a344a5cb818c66d93e5d0ab47233c30e93',
    id: 'range-test-20260619-854',
    matching_hash: '4038fead683560e1652b5293e402f7a33daf9087',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '309bf4502d6edd4768d2aa81b78c4d77f2fb26da',
    id: 'range-test-20260619-855',
    matching_hash: '54a6a2cf23702f949d2567ba22fcab11db03e94c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'ef09d7a877f79e4a18fc27a226609ac287f4f85c',
    id: 'range-test-20260619-856',
    matching_hash: '577969bcaf977e14724b18fb1299a1f724ebac5a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '71b2b71d7b2e5309af6fc63092f1682ac3e41384',
    id: 'range-test-20260619-857',
    matching_hash: 'b826d096e28f181d7c733f67c92259c714d52738',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'b2f9fbb3605072e521af9d6c15c33b0b696c0d64',
    id: 'range-test-20260619-858',
    matching_hash: 'f5f9b8bdbd2149e359b60f55c2bba4e8ed98dec1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '7656ee61b1f369cc8d67d5e9f2bbd08a0e655ac2',
    id: 'range-test-20260619-859',
    matching_hash: '61fa00a10ca0376c0eb8c0f6208c4d4da3839d09',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'ce7cfc908fb152d5d4a118602756fe8302eaa4a3',
    id: 'range-test-20260619-860',
    matching_hash: 'aaf225e5dd7f97b993be2868db10031dbd5529aa',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '2c4fe2006f37445dfcc81afbe34309ae2dc608e2',
    id: 'range-test-20260619-861',
    matching_hash: 'a5845978beb0c8b75a90060eb145c26bf89aa008',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'cda9127f8e9e3890991a0398fc113aed14ac0ecc',
    id: 'range-test-20260619-862',
    matching_hash: '83addcf344ef78495bd0b4f509d4b2482c9aee58',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'bc109875835a73b4c5fab8af37226ec26d4a8910',
    id: 'range-test-20260619-863',
    matching_hash: '474c27b43087a1e707c306ce8c1edfe25fca0ae9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '6636f4f7adf8a0d6fb1e05d251d78958762e44fe',
    id: 'range-test-20260619-864',
    matching_hash: 'a219ac5ba195f31422b0ac35ea74a19e030e3a58',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'f6f434f20b47f3620318098140c707d37fcb7222',
    id: 'range-test-20260619-865',
    matching_hash: 'bef409c5cdde744fddd6fdc7aa38c8f3b9bbb773',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '2e6cb35a5cfae876939ee7533976072788bbf669',
    id: 'range-test-20260619-866',
    matching_hash: 'd9a20192c2a21295fc43f2ae178ddfba5ab39d32',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '7103a5c0ae348f76c7d2c2c16cebc65987847e94',
    id: 'range-test-20260619-867',
    matching_hash: '877350227491607f3cda76330f1c41a5a65fa2b4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'c648c30713d1c2f40e4878b993565e34dcd9fc5b',
    id: 'range-test-20260619-868',
    matching_hash: 'bb0aba3568412f4e800369bff1d0194fb9675ace',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'ea4f46fd2a7d4b30a35017ba1c67dfab88763f4c',
    id: 'range-test-20260619-869',
    matching_hash: '9b7c20004fce3f6774111e972ee065253e238f63',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '316952cf0088f711e6b62cc979cea840197aebb4',
    id: 'range-test-20260619-870',
    matching_hash: '2eb12c0d498f1a6c9bb5998886d43ece84fc1d00',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '823bd4befa0eda719a988cfbb50197e95096ff94',
    id: 'range-test-20260619-871',
    matching_hash: '66bb19d27ef96117af8ae6c5433128c64b82fbe2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '106d18c266b8f6770a34e33d19f78310ceeed8fd',
    id: 'range-test-20260619-872',
    matching_hash: '0810e2d0bd123eb62f39fc78f05060e465636b68',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '6c10d956adb83de173967069f3d1dc9bcda4936f',
    id: 'range-test-20260619-873',
    matching_hash: '1f8d1aa148802ff3c2754ddf16eca262d15b6d8e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'e64b7e0d754fa48d3a4ba42a91c0ba7a4e23ef75',
    id: 'range-test-20260619-874',
    matching_hash: '77e23a54594613a9a922edefe0572c66880cceb8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'a088c9ccfc281269ed9847a266871b958e1273b4',
    id: 'range-test-20260619-875',
    matching_hash: '8f1722dbedf9f1f821850246c2869d6829b59744',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '1a7fefd3d442c261d0db27a52b49417c642e04ae',
    id: 'range-test-20260619-876',
    matching_hash: '6d71a318b3bb9e92fcc98f3ff31f003f4ab94f16',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '26cb519dd7bb265e78d33ca5f0f15fb11210efb9',
    id: 'range-test-20260619-877',
    matching_hash: '62d1846084d6b4ee89533db6c7f5488de262c22c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'f93886d51639e9952c9852f1159fdcfd03772283',
    id: 'range-test-20260619-878',
    matching_hash: '33844481f012d90540514760ca5e69806199a2d1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '61925dcd05cccff1520049551db494f5d7d7d3bb',
    id: 'range-test-20260619-879',
    matching_hash: 'd5052f4c1de8d8edc7e1af4c782c4f068a0ec4cd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'e8ca959f0e730dd1d59623b8ee63599864883551',
    id: 'range-test-20260619-880',
    matching_hash: '9d6a5b0444c6fd5bc4e4385330567ce7efd0001c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'f5d0e886b9878f18d294096af641ad5b22ab589d',
    id: 'range-test-20260619-881',
    matching_hash: '6896cfd4d1bf54fc2203fd47466e57f4b26ed96d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'f827c1f0c66c51f57c99dbdc0ce47f0ea775eae4',
    id: 'range-test-20260619-882',
    matching_hash: '4e4daedd5bb232d3c5b685aa026eff87bad850d7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '5d4659bc04085b896b449ad35e97c5c6cd73ce96',
    id: 'range-test-20260619-883',
    matching_hash: '1e12aacce3fba4b7336c5ece6a4f4388a93cfd16',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '82565f0b7746caa58d38b070690faa4ee4e19d2e',
    id: 'range-test-20260619-884',
    matching_hash: '134e60d4283bb74860f08483b392e382a162376a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '3a83e189be641642e216681eea2caafbdd5a4fbe',
    id: 'range-test-20260619-885',
    matching_hash: '541dc595b82731b2fa556cfe435f5902fa3c4bdd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'abec30397842eac0b0a037a558b814b7446d3c7d',
    id: 'range-test-20260619-886',
    matching_hash: '5fe3944e30e5d5ed802fe1e9d1aeab104e2b32fe',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '829eb5e0b5000f64d33e28d168e7ab2fc7a927a0',
    id: 'range-test-20260619-887',
    matching_hash: '561079e8bded82ca7c83e32a95268a2508d6929b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '6f1d28561468ff941491848b7f2edc9aa63e663c',
    id: 'range-test-20260619-888',
    matching_hash: '7097f432fd01930cce04ba101a4dce2d3c30237e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'bea01ff83739d77c51dcb7a96d8aaa9491ab1ebd',
    id: 'range-test-20260619-889',
    matching_hash: '84987fe5d3d26e983668036afc3474dc64298083',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '33899a8771e42078e00435e7c9b900350f18f7e5',
    id: 'range-test-20260619-890',
    matching_hash: 'f69106b74063196f1b0b0d2cece27d5ef4460334',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'aa3e24277943572795cb7344d820a28bb9010b87',
    id: 'range-test-20260619-891',
    matching_hash: 'd3fba381b64b2cc34778b8bccdf65dc7ea13b84b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '3fa871866298f0f171cc8f5a40af776431dcaede',
    id: 'range-test-20260619-892',
    matching_hash: '62175bc63b3821675149ec0e105aa2639d6e8feb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '7382b0a85f9ecc26213ade39c5e00425f96afafc',
    id: 'range-test-20260619-893',
    matching_hash: '5a7ee6d753eb4ee5767426c11df706dff5830bdb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '5a3e22645b0948d83d1e4ebb7b9e4bb1ce947157',
    id: 'range-test-20260619-894',
    matching_hash: '5b7786e8214c0cdb2048db1124642551042b87da',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '745692fff4c5bef3b10a09b8b63ffcca7ea1c755',
    id: 'range-test-20260619-895',
    matching_hash: 'a29dc3528b847986145a6aba736462c6c5add181',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'dc5a25177eae67299dddb7cb567efaaf3ce7fdad',
    id: 'range-test-20260619-896',
    matching_hash: 'c5bc03c8453b9ecad0c8aaa4a91237edf9b15645',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '67436c96f544416d1a8a011e07e06b5dca276ff1',
    id: 'range-test-20260619-897',
    matching_hash: '601af516acd3d8a11372da13e6924a59b8a8c384',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'f535c1867484b4a58e27a7bfff4fa963ecdb9594',
    id: 'range-test-20260619-898',
    matching_hash: 'f0bdadff03eeb3db667a6cb231104b153ea9343e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '77b6558b1a5e50e56f9ee9182051053f3f398b37',
    id: 'range-test-20260619-899',
    matching_hash: 'b09398b55ec8cd74a677fc8ce2af0bd4b32733e7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '737d82bd107bb80d46e546b75d086ec64ae75eae',
    id: 'range-test-20260619-900',
    matching_hash: 'a681d15fbc08a2617655c8cedcd4ffaf79a35a5a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '3f4d3b649cd9dce79e40841bd0679fa3f6854d5c',
    id: 'range-test-20260619-901',
    matching_hash: '8157d487b94ad5e4968b4d3b0b855806ebad5c38',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '53ec7b696ed1175cb425147a503d215d1326e0fe',
    id: 'range-test-20260619-902',
    matching_hash: 'aafb913f7e08627b6e38da2ea915ef3bed14e1c2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'bc76c5b0bfa447fc21ae7764abedee4de3382de4',
    id: 'range-test-20260619-903',
    matching_hash: 'aa84238f38e163c6a8ad42afa33d2ceb449d9220',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '94b5239595e2f16790008e8d497cd632a0b69540',
    id: 'range-test-20260619-904',
    matching_hash: '67e76dc844edbaa741ea67480d0e9513c94e14de',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '10d6be9eadcc671226bb88d05658ba06e1a5ccd3',
    id: 'range-test-20260619-905',
    matching_hash: '86276ca78f25b84b1eccff67a3e3a6b46c64bad4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'f7e3397e0b1693f3ecfaead75e1e5ffe31d670fe',
    id: 'range-test-20260619-906',
    matching_hash: 'ea7d4069c4653d30ba28b84c450012f4ebd7e360',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'd42aada697add0459b703da864054608c255527b',
    id: 'range-test-20260619-907',
    matching_hash: 'a4d01729cba38c0a3c880a6099d91b3859f9ddcb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'a31319d194bf081fe22b7a6f60a25e6139713235',
    id: 'range-test-20260619-908',
    matching_hash: 'a1c157ea48565ebe56d18c2c82cd2071a51a60fb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.962142272,
    qx: 0.130403557,
    qy: -0.019389985,
    qz: 0.238539702,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'e7eec0cfb43f8bcdab129325a07e597471cff6af',
    id: 'range-test-20260619-909',
    matching_hash: '7bfa1cfb2c5aeb8b9fc3faa0445969ab62bb58d1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'ddf8be82ac4657bccd8f231c03406556f2d3023a',
    id: 'range-test-20260619-910',
    matching_hash: 'a13203606473360e96ced58dd016fcffd1b8c34d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '6ec451659387383d98eb7d617311fa6bcb28f3e9',
    id: 'range-test-20260619-911',
    matching_hash: '2ae5c9e2948b1bacd38911a6def99346755cb257',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '72574507610b38a8389cd5281f73239994f114e0',
    id: 'range-test-20260619-912',
    matching_hash: '995c67652e74f47c82bde53ffc1ce006ec46c4e9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '73f7a745cee208d185b6b4580e5545d21654a632',
    id: 'range-test-20260619-913',
    matching_hash: 'e4c564c82862b325d6ab949a7c60269519b22d0e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '3fae4a8166382d9fc5c70135d674fe75bb296c1a',
    id: 'range-test-20260619-914',
    matching_hash: '052d89978f81caaffc416bf007d4464833ebede1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'ff5f3b304ff5b0c96a7862be010c633460abb6bb',
    id: 'range-test-20260619-915',
    matching_hash: 'e8924789728075e3b1493625e95b7c57874950c3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'a85ee9f91dec41b9f1d1bd47acca121e2eace9e7',
    id: 'range-test-20260619-916',
    matching_hash: '94ef8a132b1e917b453787b2861633b318663f23',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'a9e4b6852b07b953867d45b8e380a5d79a18cff7',
    id: 'range-test-20260619-917',
    matching_hash: '377a92d8994f216388f7bb6048a921ea0ddce2a0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '52d78042a6c578fde7f44d684801ea6e4ea3d7f6',
    id: 'range-test-20260619-918',
    matching_hash: '215b4a35df9c69cfd5fa85106e31b7dfe9ab3727',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'ce036ccc175a4ad63f09c39eef7870bfa2c81eae',
    id: 'range-test-20260619-919',
    matching_hash: 'ee544d6d9c70398ec7fae88d586c8d673e6056dd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '0f1ad0cbb96739809ba0b32fc0cef976fcc55117',
    id: 'range-test-20260619-920',
    matching_hash: '61213b38484e67b838b24efaa85056194fba084f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '46cdce0f755ea70e1c7a3282f78e689e69c0c2df',
    id: 'range-test-20260619-921',
    matching_hash: '8ea2eaf19978b465a11f5b2ca75798001378ca1e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '5d7b007188dd376c8143d4201285e0f458c6d523',
    id: 'range-test-20260619-922',
    matching_hash: '744f4d77903848102375f41481365f7faf113446',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'b3e7b443052a9ac389e0eeb2cab0cff3cd73144a',
    id: 'range-test-20260619-923',
    matching_hash: 'ef5aa09961af282c509ae49ccacf7468d71df1a0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '6f981fa3394f997de3d485870f8289c11ac27676',
    id: 'range-test-20260619-924',
    matching_hash: 'da3d33db4bfe1f67aeffbc0e7d0640ec5866d643',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'a1c2ffcbabbc2b5ab44978a3cfea1decda253442',
    id: 'range-test-20260619-925',
    matching_hash: '312ed953c4e4611a268b71646eb8189a951ade57',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'c5ac9916c639d19f38486fb78a5fb973945fe678',
    id: 'range-test-20260619-926',
    matching_hash: '11ddb2d676aa51310a541bec2230fd37050050bf',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'f57b8fbfaf1f04e25ccba4b6843c67b9d0cfe3c8',
    id: 'range-test-20260619-927',
    matching_hash: '51abda1dba3b1b60f8bbfb0aa52e75c568c86db9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '626273abd6a5636e4b77a98890fcf3ea4281c220',
    id: 'range-test-20260619-928',
    matching_hash: '9db8cbd905bfb80f19d3f7e70c3d7e62580f72fe',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '23f8eb1f4168f7b13f031f18f4a58ac9b8f04606',
    id: 'range-test-20260619-929',
    matching_hash: 'a4e9da4326d77569f5e47b792ec76116cc3cb168',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '6a63450545c704642ed1ee1bce91f27540dae494',
    id: 'range-test-20260619-930',
    matching_hash: '82c10cf6c9389c63fac70a34e9a0b85f1cb9d906',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'bd04899a3471bf2ffb7dc51645a377f5d11564db',
    id: 'range-test-20260619-931',
    matching_hash: '018aee658e4e8a4adf85377fadbc1e655db2c4a1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '309fa3157dad480562c7e22423517e6a8a9cc52c',
    id: 'range-test-20260619-932',
    matching_hash: '21333754d4037c6c9893e1d8f12aa031d0a7a754',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '84247ed497bcceb3b56d4a123c853ddaa736b5a6',
    id: 'range-test-20260619-933',
    matching_hash: '61a219ec8e2384b20c0b04609f432297afda699c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '2db3848fb587ee358050f5362057fefc7a2f062a',
    id: 'range-test-20260619-934',
    matching_hash: '2ff1b78ee2d6b44eff58307496b62b81027c60b8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '5e112eaf6c50d77a81c55389f66c959d51705f64',
    id: 'range-test-20260619-935',
    matching_hash: '3cbd8f4e8f7c23ffae371edd0f06d5eb63070489',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'a894da8238b0f732cc9003b3da1b3b1767a89c82',
    id: 'range-test-20260619-936',
    matching_hash: 'bab42a540452bbf30bcd12be32dbeec7b4f4e9f5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'fc4a36e213539048c5be85595d429eab5c760705',
    id: 'range-test-20260619-937',
    matching_hash: 'de8c73e8a37041968c534530ac0a5064d885f0cf',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'de7e153087a6b99482751591de26250b482279fe',
    id: 'range-test-20260619-938',
    matching_hash: 'a11e18ee3c2f3dd0ae5060ebf6a5558b74966cc0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '998f5c43e17e378c9915cbd99f93b6bda23d2221',
    id: 'range-test-20260619-939',
    matching_hash: '353f5f3779803f272d93f4d2d2634150fd108c56',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '2590eedd0c113d4b1587d626ce663a900ff8de71',
    id: 'range-test-20260619-940',
    matching_hash: '2d96e8b6f8acb9aa024a142c2ecabe477f3905a7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '1a0fb7c29fe96b98b44056621bb64b0c0e43b85a',
    id: 'range-test-20260619-941',
    matching_hash: '3950c62e13925698b77e8778da825da800dd2694',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '26bb0758924ccf0fe2497b875567c94d0856d6e1',
    id: 'range-test-20260619-942',
    matching_hash: '36cc8b544b37b92514cab63c31ae3cd246dbc66e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'bad6e9543441f963fb83171aca5d1a41abfbd0de',
    id: 'range-test-20260619-943',
    matching_hash: '7ca57bd73efdf99dbda66e7e478beb087efa9f3b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '17a2acece3b3a28c5df1722879159793d2d03340',
    id: 'range-test-20260619-944',
    matching_hash: 'f958521c087fd2442bcafb326ad3bc9073d9d707',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'f4378dba2ce2ff6cda752750ebdc220000764f2c',
    id: 'range-test-20260619-945',
    matching_hash: '8ecb26716879965cd3047615a64506caa3656c01',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'a077faad5611e66d779a5262d4a083016c31e455',
    id: 'range-test-20260619-946',
    matching_hash: 'e6a743d9a5ebe4c62ecd5e9acc523b44acef45cb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '201f87368d3e8d0a659a34b631fc25841eeb7f80',
    id: 'range-test-20260619-947',
    matching_hash: '3e611dad2f942e73f51d4a09b6f549c4d2cae87b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '6099b28131ab066dda3b7beb917ede75114f12d8',
    id: 'range-test-20260619-948',
    matching_hash: 'cb45b45d5d1b52ff8790d760e975a38c982314c7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'e81fff53d512d92a01241530781bb58b0869c75c',
    id: 'range-test-20260619-949',
    matching_hash: 'ffcfdc124cb47a417550d2736e05d450b6eb67d4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '66739d2dfad33688ed1b914783e21dc731eda2ef',
    id: 'range-test-20260619-950',
    matching_hash: '03b64d415d1ec26114008366e8c3102840e317c9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'a6f715f9b9cee4b3e8867d793e66703d6473d53e',
    id: 'range-test-20260619-951',
    matching_hash: '39c1094f6af235428678ac05af85ea5860384a9c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'd9b6cebeaf63b5f3f5845859d724142e7f1a9eef',
    id: 'range-test-20260619-952',
    matching_hash: '58a7978191bfab7f08b29540842297db3ba3f7e1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '19a99b514c11c76ee5425be3f52447f9498bbbb9',
    id: 'range-test-20260619-953',
    matching_hash: 'b4c42160f1e4c47bed17a048dfb51bd2fbfccffb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'd72ee5e820224e5418268bc9ce405ad1b4b2b235',
    id: 'range-test-20260619-954',
    matching_hash: '78b0d783294dc21a4deb0f3a7fdb7762c4dbb2df',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '8c8e02c556e39b6eee09f4e7b0eb9fe8207a6a49',
    id: 'range-test-20260619-955',
    matching_hash: '4cbf1e12848ae95d3c2b5aee94b47fc0e5430a72',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '180b019fea0a798b9d7978739e45534fec27533a',
    id: 'range-test-20260619-956',
    matching_hash: '43e0547ede4164e54a2ab84b6a592c7d61a695f2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '2c57d1ef7f2dc934195c8df467ff347d6b16e229',
    id: 'range-test-20260619-957',
    matching_hash: '90368fc8ece3deb557ec893f8c0f00804c0ede64',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'd1a2d79c1115e65f0ec6eaaf747a3d84e57bd641',
    id: 'range-test-20260619-958',
    matching_hash: 'aa3ce1c21bffef93a6651373e047076222e7acf2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '4de0bdbc681969cc0652b1b939bfc3f9710f880e',
    id: 'range-test-20260619-959',
    matching_hash: 'dc97106296ef733bbe39f3552d5a2019993e9ba5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'ab0190f3cf5fc9dee4182ad29c0a4bc70fc0f436',
    id: 'range-test-20260619-960',
    matching_hash: '41e2fb8c58e95bfe8106d6df63dafdfecffb1bd6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '553e4b0cbed73f184456eb596a749de3a4be3ba9',
    id: 'range-test-20260619-961',
    matching_hash: '7f9cdc021cde51d2bebd0eac7f53b2dc6d6659b3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '7ea63dd857bcbc9c26efa2bab503a11dee657595',
    id: 'range-test-20260619-962',
    matching_hash: 'fe60f66e8c60af40b8ad138466c483b21a34b257',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '068a948088449bc5d76f3b0ac197366fb0c08007',
    id: 'range-test-20260619-963',
    matching_hash: 'df1150466a6b8c2dd2a74b72e5a3b5c68024b060',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'e28e405b3de8cf87ebb3358a1d600c04162c1abe',
    id: 'range-test-20260619-964',
    matching_hash: 'e2dac0a99aac975b1f0636cd7b49d7ba23c52c46',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '22915a616644472d7ad624823f9a49928617db0f',
    id: 'range-test-20260619-965',
    matching_hash: '59fc9f10d296982c7d2ef9259ad8c8c902037e2f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '4e5d9e6da2d0939060a5b13f39d24cb4bc21cdf6',
    id: 'range-test-20260619-966',
    matching_hash: 'c0d1bb120ecac1e2ced595ec746b7bb7c72267e7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'ec23a593349ad06361878b2f9e07ab8fddc275b8',
    id: 'range-test-20260619-967',
    matching_hash: '04ff80a26dbd00eee33e18db32adba134b58c9e3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '2e938aabe98a8e2aea6e435e105beb9073521a3a',
    id: 'range-test-20260619-968',
    matching_hash: '270792b44b29b27258ddb1291a227640cfed4d5f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '00163b593e7e05fa161073619e3dc5d298f6bd02',
    id: 'range-test-20260619-969',
    matching_hash: 'ee7677f2230fd747e8030f6c1d0194f4f0da79de',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'c649eabb7a16e8b003f79c78067cdc45c0f78baf',
    id: 'range-test-20260619-970',
    matching_hash: 'eaa5bba9e21098fa592ff025dce2ce8d530cf5d1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'bcf9ef857f4d9f29eb8543c5ec2c77b516c43831',
    id: 'range-test-20260619-971',
    matching_hash: '42c0568088a377f0d346f29035929e709ed1eabf',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '51930749cb415b48185faf7bb9a7c8da26236802',
    id: 'range-test-20260619-972',
    matching_hash: '2bd4724aac26a8743f052ea98e0117c4661da3a2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '22ee5f73e95d26e0a66f58a0247ab97d7b356d4e',
    id: 'range-test-20260619-973',
    matching_hash: '469520a4957375c60d07d5a3408b110961035f09',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'c044e4d09d96cf5c9c3167d325cc63d77488e86a',
    id: 'range-test-20260619-974',
    matching_hash: '118118e5e468bd404dac7c8819c6b949a9be2a91',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '661c2887ffaa87f2536a7aef115b0852f5bb9bc1',
    id: 'range-test-20260619-975',
    matching_hash: '4e314f97b2b5f586cce0b2b192bd08c53857ba87',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'f45135fcbc599f0dbc7f9731aa502ef6322904b1',
    id: 'range-test-20260619-976',
    matching_hash: '73cd4b5ce1411b6b2995bc690d97987a8e465df2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '0203e048953b81ff5cf857b6bbac7f56b80a183a',
    id: 'range-test-20260619-977',
    matching_hash: '604508284481698997619fa3c888363ee01d4347',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'd742209ccfc7593dbd2ec9ec2d2b9e3b432b45e8',
    id: 'range-test-20260619-978',
    matching_hash: 'f7b35722cee795a3256d5a182d5f1cd4b37997e2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'de227a6461200edd91a54fdf669a6bba29a19692',
    id: 'range-test-20260619-979',
    matching_hash: '1b3f14280fa2651c5df53b1c8e9ee439ae87819b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '18b2540fec96edaa120e29a2e65f6f1594ea6ca2',
    id: 'range-test-20260619-980',
    matching_hash: 'fb8e23fe32d60f99d41df8765748b93ba6db4e8c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '1b312bf56fd3dc1e0aa5a2cfb9daf7c90de9a7ae',
    id: 'range-test-20260619-981',
    matching_hash: 'd0c9d6b7f359ca5c5c7ef4cad66d7cc2f0572fd3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '6717ec8a4af365dc346bad964e48dac3ba99d481',
    id: 'range-test-20260619-982',
    matching_hash: '7af5c3bf8fab7f9716b6aea5c68eccb7a3842e87',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'e81a40dcff32bea1accda16a82fe66633aabe46b',
    id: 'range-test-20260619-983',
    matching_hash: 'a8b76c8c5b7e97c5d4dc3a051e3bddc6db95f288',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'b547b056bbc327954b1dc79694fc18c084642379',
    id: 'range-test-20260619-984',
    matching_hash: '8822f64928f2d98e606c0cf4d529345bd9de8ef9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '8153c90631eedf2a35790c0a9c1536c57e5b135d',
    id: 'range-test-20260619-985',
    matching_hash: '82c2d2f6684658c8a26f00ce74a0e680337dac5b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'db84693e6f2b094d4c5c950e9df448498c4af6fe',
    id: 'range-test-20260619-986',
    matching_hash: 'ec18eb3ee06f0972f0a04f58d42f5895811e7dcc',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '96681021dcbd05ee4219daf3ef8e6a7d39d42a36',
    id: 'range-test-20260619-987',
    matching_hash: 'c5d91696a0f4198031e3d4e2e90478cb2beaf02e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'cb7663c50664c7be4b1c0c27f1730d71d79cb484',
    id: 'range-test-20260619-988',
    matching_hash: '2c74729a73d4992e5d471705762d33e84fd0a194',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '8629cdbb8be0c099e03578c8e029afd708b66233',
    id: 'range-test-20260619-989',
    matching_hash: 'bdedba2daf3c7e7f5f73b79ec887cf549dc50bd7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '398465402262ede46a992f30404721429f5562be',
    id: 'range-test-20260619-990',
    matching_hash: '002e84da76617c93f91cd8b5ceefc50cac853f70',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'de2c31e9ad58e537bb5d2fb4208163ee1710bf09',
    id: 'range-test-20260619-991',
    matching_hash: '8faf42b4d663df41140a8254d5c5889bd1af07ff',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'db6c26cb4d9c9f6fbce29cb49364fd240919ec4e',
    id: 'range-test-20260619-992',
    matching_hash: 'dd9adac0a8c7d56132c66b65df028f096d70c428',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'f6ef07eb9eab320550d5ccc99a082aae697f7c83',
    id: 'range-test-20260619-993',
    matching_hash: '921d59fa84150dd5f980857423f6bc07923c63a2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '2e22627f426048b2f2e118e86aeee7191676cb8f',
    id: 'range-test-20260619-994',
    matching_hash: '45f506f838c43b66979720d131abb83a4d5fe9c1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'e2e1309471ddfddcd501bbd7e84c0779d91b434b',
    id: 'range-test-20260619-995',
    matching_hash: '2d5d105805762cdb6efcea8d5142508bed947ce4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '8ee481b35386a61b2ec7a1e5c1130168d2615d76',
    id: 'range-test-20260619-996',
    matching_hash: 'f25d3e4a45e8d83cbc70711ff9d2a74914eea0a5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '79a87cfc2551732526a74a19bf0b908d7bc19ce4',
    id: 'range-test-20260619-997',
    matching_hash: '6a4aa207d3a61cc4195ccca4c6054785c2c6f673',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'e393f7182276fc14291faac98ba1e55b0751926c',
    id: 'range-test-20260619-998',
    matching_hash: '87dcd2888a9b9aa91d7ee60692c2fa0a6b2716a3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '1d3b02347360d978e1b09274fb32b9969cabd316',
    id: 'range-test-20260619-999',
    matching_hash: 'df4e21598ff18a6f170956d6dacba356c0f4d6fc',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'f1b1f0442ae45834bf9e87553a8659a44d60274b',
    id: 'range-test-20260619-1000',
    matching_hash: 'a839792c0371b294199a32c135d930a23540a2fc',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'ecc03efc1e2f5e57d65198f2405a93d049aa445e',
    id: 'range-test-20260619-1001',
    matching_hash: 'b1b3c1c98e2fc4ccace33a105a78a62c8c2a75a9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '9fe856fb5b1514008325515c35971bf32f7ca9ba',
    id: 'range-test-20260619-1002',
    matching_hash: '3a3fd8dd49d709ae0ff08aeff1d26953cadd0b43',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'ffcc270a120a1a454b339f10a63aeec5a3afe52e',
    id: 'range-test-20260619-1003',
    matching_hash: '991c1ef23aa6e09333b5bd1152fa39a1e242a9ac',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '4b7f8f3f8c1340c7b5a0ccbf2bfde7d82b8dee4b',
    id: 'range-test-20260619-1004',
    matching_hash: 'bf8cdde2c6d89e8b10c5b5679a86d872be604777',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'ee3bafc7e8b246ffaf2c9fbc3384b073f699a187',
    id: 'range-test-20260619-1005',
    matching_hash: '1f1bf2bdbdf4590ffbf58ecc0a297b9d1bbf2621',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '0d4e4fa6499d32af237c25b9e293954e94f0cf73',
    id: 'range-test-20260619-1006',
    matching_hash: '395ceb3bd7179ac64e40f141955d70b4110c307b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'e9304ea837c9a5427a278d6060c8f113b9a6b860',
    id: 'range-test-20260619-1007',
    matching_hash: 'b1967540e47dffd676d61b5e2c9dfd2863ef336f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'c58fc70ac1966f966a42fea36928851f66c15607',
    id: 'range-test-20260619-1008',
    matching_hash: '8d4a9e8573f1f9c4b3f23990d7905c15a06fc1cd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '83a542b3dd9a5eed652b33451e0a2afc5b954a81',
    id: 'range-test-20260619-1009',
    matching_hash: '4279a2fd94d2989b79226eefbc90a2d158e8fffb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.079494879,
    qx: -0.788040109,
    qy: 0.440157666,
    qz: -0.423006596,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'd52266b1e8f23ecbfd082c62064c45768ae9b977',
    id: 'range-test-20260619-1010',
    matching_hash: 'c1e3553d5491d6517e493b00cd6a1a3b8ac2576b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '387bd708d6bc5925cb1b7dae86e958fad66011e9',
    id: 'range-test-20260619-1011',
    matching_hash: '878e3d31fbe4aa4d472a38afc4c3a5e10f9462fb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '7d003746efb1f7cc94ce7455aec7ce4100b69ecf',
    id: 'range-test-20260619-1012',
    matching_hash: 'dac05175c55c6aa1a71a54060710280aea8f7ef9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '67ec7dc9f2eedf51cce29397203b0367ab245a36',
    id: 'range-test-20260619-1013',
    matching_hash: 'a9ab1d22ba29d09798cfb6c25a2f4c009bdb2cb7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '26470ff8e7a60dfe61cba1875b0b51b386759e80',
    id: 'range-test-20260619-1014',
    matching_hash: '7eab7bb21d26c72f19ce444a80a4d587beba685a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '965a7050ec98528ac9d753ed6ebdad6685136c41',
    id: 'range-test-20260619-1015',
    matching_hash: '1188c717f12a9efe270110353570379aa501c31c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'b9faf2c1c190941698391c9d2c5da1775e3b5418',
    id: 'range-test-20260619-1016',
    matching_hash: 'ce54d6af585c5d0e4b4291a8343c50021d0c6d1d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '588206bdd8b64384087d5d19fd533ac3622be9c4',
    id: 'range-test-20260619-1017',
    matching_hash: 'd89bba24ddb193654654090da08d0342b14747bb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'dbaa2ae70f39f891ea508e5c73cd36fa091509af',
    id: 'range-test-20260619-1018',
    matching_hash: '191ccd83f48661243b06a2299b894c19ce3e444b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'd082d8ded495c6e31d3cf9cf84849ce7f78b8781',
    id: 'range-test-20260619-1019',
    matching_hash: 'ad711e614055e405f737dcd4c8ab3d5ab4dd1a99',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '0b70b60e3a6599c595d08ce0921c3a72898e1509',
    id: 'range-test-20260619-1020',
    matching_hash: '2770b1bd304c76abff1ee3a69a786301bf1184d1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'd9f35d0e22dcfc43abe1b4b8b5a8fb498bf4e212',
    id: 'range-test-20260619-1021',
    matching_hash: 'f2c36fb6ccb3c3fb4cd3ba7914da107b4865cbc7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'c9129b11ad9e046775322af158e785f75fda6f12',
    id: 'range-test-20260619-1022',
    matching_hash: '0fac9efc8984749227e76b8ea1925bbe3572b353',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'd8773907caa47fbd12ed5200bbdbf5d1cdd7d9f5',
    id: 'range-test-20260619-1023',
    matching_hash: '1da6f5121ca879b53b7065e2cc698e115f98aad0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'b167f1d2c06f26729889325d32a988e835d3f30a',
    id: 'range-test-20260619-1024',
    matching_hash: '11dc50efb237dc2dac0df594176ae3e5446bc5bd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '0b960030b728d7629e4a7751b718d170a36e80de',
    id: 'range-test-20260619-1025',
    matching_hash: '585bb81f49801ad4dcedea0059ddad842f5777fe',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '3172985b11cd024112add44b883b5d9f6a9f3541',
    id: 'range-test-20260619-1026',
    matching_hash: '781afb46df11a524e1f9979cf17853c6af683e56',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '82d470e56170386bf6921b67d4ef853013e4eed8',
    id: 'range-test-20260619-1027',
    matching_hash: '9514b6a187f6552a4c6f7ac4c4f0a858aa76bad7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'bf37e28585413b8e653993271d44d9f552e2e39d',
    id: 'range-test-20260619-1028',
    matching_hash: '6c157e10e9de3bcda9ed91712ca164b018ee8de5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'd8b253ead71e2ceda8160569aaacff5c4c2d8e24',
    id: 'range-test-20260619-1029',
    matching_hash: '5c2ef2a724b80cc519ac568e514c4bf706b942e8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '4968b0c27a1424570ad81c4b72bd7d0be8a5f333',
    id: 'range-test-20260619-1030',
    matching_hash: '7c102c545e9c5d57fb54e3e15029294a92a9a4f1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'be96a32063a63d9579c0792fa32685e237e871f4',
    id: 'range-test-20260619-1031',
    matching_hash: 'b1f9a8415aa861c540f47ba190d2f98d66e6e5e2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '57b625c535a7092f0a9d798ea5c2c74d9241b71c',
    id: 'range-test-20260619-1032',
    matching_hash: '035faa94a87d3382173d63ad17f90e3876b59b1d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '486b08fa237b9ab0c6ade1c237400f14a55a72d0',
    id: 'range-test-20260619-1033',
    matching_hash: '228ffc0dc27263b486143f0029781bea119fe8f9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'ea1194848986090d0e3a4230c66274979f019b12',
    id: 'range-test-20260619-1034',
    matching_hash: '06be1a1b4529e7020158f93b197294285f6a85c0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'ec8214c64968c93f797e97062bbd41db4de5deba',
    id: 'range-test-20260619-1035',
    matching_hash: '87d7d9508dfbf5cedeacb588a40a19e2173a65c9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'b740062fc47456c92987de758ae4856b563b91de',
    id: 'range-test-20260619-1036',
    matching_hash: '2609f513708181ad6d9cdfd65ee071f9bc7e4aca',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '5e4c85958c002971b8f2934c255c14c02bd7c11e',
    id: 'range-test-20260619-1037',
    matching_hash: 'a09150feb5f14bdf2453ef025e6f6f1caddf1d5b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '703dcb6939832f4e545dda675da3390000fef5f3',
    id: 'range-test-20260619-1038',
    matching_hash: '8f12a2800660be6d87b2f03818744f859e9f0d29',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'baf634372b2dbe3e88bc4a11f6e16af9dd2c3e58',
    id: 'range-test-20260619-1039',
    matching_hash: '73a72468d5770cd365e0cfa661c72f465832deea',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '434a8087b00a1d0ff5c307089944655dd8275a6a',
    id: 'range-test-20260619-1040',
    matching_hash: 'de3ec35d59a1ca1b65a85b5aaad4e81ac8e90df0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '46c96fafa13cc338d06dceb90929b974d53f1008',
    id: 'range-test-20260619-1041',
    matching_hash: '754b02a820d34db09228a586a35d8c7374e5da98',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'de617b45a2eccadd79b2d7a91c0974c929127730',
    id: 'range-test-20260619-1042',
    matching_hash: '5127c404b7f1ac333161938c4db306e5d09cf239',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'dc51e79b947ef5240f8294f7290d5c72fd8087b5',
    id: 'range-test-20260619-1043',
    matching_hash: '589acd511cb3d37a13f8ecf3f180f95257bace86',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '92557b6f09da3a8f49de8b3417f41694f46f7b8f',
    id: 'range-test-20260619-1044',
    matching_hash: 'ef9b575525e9e43716be8ad7ad44cdf677013bbb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '7f66c6677aca0e68aaacbdf2fc9a0894642f3ba5',
    id: 'range-test-20260619-1045',
    matching_hash: 'd77f0b571130808a44dbfc108529d4b468a26d17',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '8431e32c5c6d8e837819ec3fb6175d74f1068cef',
    id: 'range-test-20260619-1046',
    matching_hash: '11ebcaed376055a9b81b649edd34cd0a681254ad',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'd36e06ca52dca76408458de8e3209352844b361d',
    id: 'range-test-20260619-1047',
    matching_hash: '9e71982a2bba31c031632aa5cfe19b0971cfaac8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '5905ded42b3ccafd0cb43ed3392812a9e60cd2d3',
    id: 'range-test-20260619-1048',
    matching_hash: '6a8f35244adfc9694f0f634d47dab047cb409df7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '08b8f163cf54eba8c7036ac3192673894e6dacf0',
    id: 'range-test-20260619-1049',
    matching_hash: 'dc12cdfa3dd534c3d54d596405af99b9dde4a132',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'd97c1401c28bb7dd2e0779f5845eab48c5d9ea82',
    id: 'range-test-20260619-1050',
    matching_hash: 'ecb5b0a3d9f5610a72cf4a7cf598a41af05b9836',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '1ab7c4724c7d81502daecb72747acd52e168289e',
    id: 'range-test-20260619-1051',
    matching_hash: '14b6a53422c1dec0d2c1a09dc6061d129e5be6f8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '3bacd4379125b9cd913f626a5ac2c1fdebd6db94',
    id: 'range-test-20260619-1052',
    matching_hash: 'ad19a4344e18a09d1c479e5bc56f8cba48359220',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '1d8e07d1162d8250ec9650944236baf8e8685d71',
    id: 'range-test-20260619-1053',
    matching_hash: '3e9edda3507d36e1078f8d01aa3d3a8ba5423435',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '38465901e0ea6f92de92fc7dad1e4a1cc23b0f54',
    id: 'range-test-20260619-1054',
    matching_hash: '592f7444e404dce09b64360cbcc57d9ab0c0c42d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'b9deb504a2830cde82dbfcc8e9a044e5ccd55f92',
    id: 'range-test-20260619-1055',
    matching_hash: 'de374febc82bf64aea66916de505dde61192d5ee',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '4f6068effca13c5787874f17c52b8a530269ebd5',
    id: 'range-test-20260619-1056',
    matching_hash: '63f69d8d3d890f6044bfcf90cb0133908ccfe39c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '6e65a5b99da71f3b6aa23f940e03a6202bbd6e7a',
    id: 'range-test-20260619-1057',
    matching_hash: '8d7fd90c854c1376b7c0068d2397b5ba2d40dcb9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '5a4086bd9a573e3e741badd569701772c1f1f6aa',
    id: 'range-test-20260619-1058',
    matching_hash: '3c3db72c4dd1fa792dd79aaa33a5fff5ce177572',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'aa7d2d7718837a11a29f3e02a6dcf25016c3edfe',
    id: 'range-test-20260619-1059',
    matching_hash: '3d480040d35e50890732eec88575b1d0837b2a83',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'b51d530f85e9e289718bbb0b1b9b4cea2882041b',
    id: 'range-test-20260619-1060',
    matching_hash: '5ee6d6372443558f4b9a55705a8519a8067996ab',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '76f4df514153b0972249f95b2dc94f867cd9540c',
    id: 'range-test-20260619-1061',
    matching_hash: '918cd8c4077424ade9639ec0bc90b4b1275f4dd5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'f0d247eb52ddf76aa91250e8432ed19dd48998dc',
    id: 'range-test-20260619-1062',
    matching_hash: '84bf81c335319bacb646e1c8c11b9fa49edd204d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '4c383380b5863f14410ec903a52cd2a8bb73ce82',
    id: 'range-test-20260619-1063',
    matching_hash: '10a8b625ad48bc1ea3c2baf25707c7e3eb02e1a3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '37a161c7b097a6510db0484a823f750706c74c4a',
    id: 'range-test-20260619-1064',
    matching_hash: 'efb8e2e26e30d5d651b44f47f65b3b371244f676',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '8f3cb9d3e800d7efb8828a6d85541116442b5ebe',
    id: 'range-test-20260619-1065',
    matching_hash: '9e74681f38a5f0bbc06794b79e91d99e6b3e69d9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'd0f0fe3eeba2113dce009a3c150f9eb8ef82dd30',
    id: 'range-test-20260619-1066',
    matching_hash: 'b36e233ae07b59b5c56ea4576b5f9be4e668805a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'fec7c53acffdbac71a36aaf2d52b3df11ee678dd',
    id: 'range-test-20260619-1067',
    matching_hash: '0b3d62767e4f6eaf837d9157b1c5b105f142d169',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'cd4426fdafb3b1167c264a37ac4e42b0d8c5b1e0',
    id: 'range-test-20260619-1068',
    matching_hash: '7b3090e2975bc0f3cb65c502de9b33cd66a8111f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'e5e5807b111bb4a46b12a1392e7a005b49c68341',
    id: 'range-test-20260619-1069',
    matching_hash: 'eb5aa57f4a8059387ffe2200807d74c6f13af44c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '43c3838ff168bce9cd5c853a9e695a789dec97fb',
    id: 'range-test-20260619-1070',
    matching_hash: '9a85c8a393755b64578c1622d911bfb725148e13',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '30e7c4653783e69a898cd2396e9f67679680dcf1',
    id: 'range-test-20260619-1071',
    matching_hash: 'b7dbc16978cb0d2147f77f71d17eaacbdbd3acfe',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'aba6b7565db45bc8eec813b3845d9d1d4826de96',
    id: 'range-test-20260619-1072',
    matching_hash: 'f2918c9146595b06d45330eb02964b0885c5f347',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '7a86266931f7733bc89f98aa494bc267ada2ce1b',
    id: 'range-test-20260619-1073',
    matching_hash: '7655952dc70f4a07e388134e566abf4b6c8eef51',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'e61b27930f6ef78dc78413a6441349cb74b1ce75',
    id: 'range-test-20260619-1074',
    matching_hash: '08b2729ff67831e9a5640a6d4fd467309fa28470',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '106a063de8a621bb3af077544fea42ea8dbb7402',
    id: 'range-test-20260619-1075',
    matching_hash: '9d98c62dafdeec4ead99675b454f44938ff81940',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '1c1ea05d009cce7910109e55d15247964c2536e8',
    id: 'range-test-20260619-1076',
    matching_hash: '8ca16555113a1699ab8e5bffbb5a7623ed078442',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '937ba3b59176accdc4c460231a755f07a0aeb92b',
    id: 'range-test-20260619-1077',
    matching_hash: 'e5765d58677900d68c84b91b45f90eb1175bf87f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '91aab788110995908113b962ba34cb1df9a16b9e',
    id: 'range-test-20260619-1078',
    matching_hash: 'c97497dc6582b3678b82f79565cf42befae22906',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '81ac15fc58f915f3528ea11cbac1bb7451859f83',
    id: 'range-test-20260619-1079',
    matching_hash: 'd7ccf1574e20d263735259296a7ae31de1b099f6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'ca9349ea7426e27e9705a48e3599b936380fff30',
    id: 'range-test-20260619-1080',
    matching_hash: '11405df05843e33a0f61e39b783dc80c8dec949e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '4a77a4987c5c40b142fed14eb88450185580aa8d',
    id: 'range-test-20260619-1081',
    matching_hash: '0644ee0862f29150e62e4b5ad04f657201c01a37',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '6915d632487d6754de6521e36934d17e458af6dc',
    id: 'range-test-20260619-1082',
    matching_hash: '81b2f9eb67c17025045552cb8017ce39432beed4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'c9077f8018026f2a2af2c9c6438e89d145eba089',
    id: 'range-test-20260619-1083',
    matching_hash: '9d6058c62231799518e5968d8f66d17c45cbd8a5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'e83c732e147df5707f391319b98becf05d2c402a',
    id: 'range-test-20260619-1084',
    matching_hash: 'ecea60308abcbbc6cb36123d61efe9a584ca0fb2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '945283464631dfcd3cbeda1122456997a16b5e5b',
    id: 'range-test-20260619-1085',
    matching_hash: '50c4ff7be8f0d16da5528c8ab2d63577bb3bb826',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '71be7eba596e9cc89bfbd431ee83b4328b0f4c2b',
    id: 'range-test-20260619-1086',
    matching_hash: '6cdb64cb16266439c8d920583363aedb3e71a059',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '65f9bfd6f5bcce6af6cc5bb69272f6fbddf2fdec',
    id: 'range-test-20260619-1087',
    matching_hash: 'e331c9b0373633fe61101879168530a067b544ea',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '74a212eaf6392782cf3dafde9d2737b2aa490755',
    id: 'range-test-20260619-1088',
    matching_hash: '4be4f68a88864b746bd4096d504261cbcb8e0566',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '1d12bd07214b5f6f891e290da5dffd6494281cd8',
    id: 'range-test-20260619-1089',
    matching_hash: 'ad313f5517da13c575fe63b037537b462ca95ebf',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '2cd121ef13fd7d9d9d6fc7d8d332a0720d10a27b',
    id: 'range-test-20260619-1090',
    matching_hash: 'd4a4f13bf7ed242392d839396d720589c67040f6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'f15b7b128bfd1b3d9c141eb90a0cc9d312cd157d',
    id: 'range-test-20260619-1091',
    matching_hash: 'da0be66810675d8ae29adb02ec9fd7537b56a879',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '8fb2c027148cda8726d4b134885f4955876ecb81',
    id: 'range-test-20260619-1092',
    matching_hash: 'cd50b61cb78a22418da1f7e7addaa63372a65a95',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '17dfb87d50fd1a4e8394ddba568c69cd01e486ab',
    id: 'range-test-20260619-1093',
    matching_hash: 'ecd1452078cf1030c243151c07a901bf73c5fe1a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '209c1ea54487e3b39d8bdca5c906111e0313f4e1',
    id: 'range-test-20260619-1094',
    matching_hash: '6e8505a63aa1f6df37913e6e7b2ae634bbc52b2c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '00ba9819ea04b544cae8c79a2687d8d3241d924b',
    id: 'range-test-20260619-1095',
    matching_hash: '3ab4e52916897733254e42f4efe74ecbf410730f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '885717176d74f422d5a4d7bf2e5f6a18a747bbd3',
    id: 'range-test-20260619-1096',
    matching_hash: '25d2681258dcbe93363ac140bb2b5aa595cb17a5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'c41381419b3c359f82fb1f4e2e6d5d3487708610',
    id: 'range-test-20260619-1097',
    matching_hash: 'c773a43e103d72d9bc9e7aa72aac4c5ddbdbc876',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'dd6a9bfa604a7fd535d77ccd363ddd9d8b90e58d',
    id: 'range-test-20260619-1098',
    matching_hash: '7590283615921016c9bebcce5dd42cffe0f74e03',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'c37b741d48526ab82ef3eaeb35ed38ae90cbe79c',
    id: 'range-test-20260619-1099',
    matching_hash: '57a9fe62b83483f7743bf0f98a665c7bcdc19d07',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '0d76e365c92a8712148adc59813c8c181d556d25',
    id: 'range-test-20260619-1100',
    matching_hash: '2c22f607a22f663c1683f1b3655698cfe3cebfe3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '8357f7082650cb5054e0ee653f7b21b4fbb7e9b4',
    id: 'range-test-20260619-1101',
    matching_hash: 'aa8a8b67e424fbe89772b3a596c96a3e2a10fd47',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '9015db20fb061d2a844c7c3d12250a0f18dffdc4',
    id: 'range-test-20260619-1102',
    matching_hash: 'e5fb4b886429fc9fc094e244900b97f732a2bc56',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '92802a0541e9a83074983676d9f6ffe4cb79d606',
    id: 'range-test-20260619-1103',
    matching_hash: 'c2ba01d86d9fc8f41a98a13e681ddd00b0b21905',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'e8ab23560a4412e67ee500aeeb1995b1138732a1',
    id: 'range-test-20260619-1104',
    matching_hash: '20e5096d3b8251a15e98e667b1215e5da508e343',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '637eb46ba22ea67b27b1e5c914fab04b753db1f6',
    id: 'range-test-20260619-1105',
    matching_hash: 'f353c36010ab92e6678f5d39fcfb9a4481837294',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '3160d8b70063609228842fe717156d113e8b7075',
    id: 'range-test-20260619-1106',
    matching_hash: '7657e2491ad56f3fb857f8586ddb889f67f233c5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'b55c7514bd0f32b3f737e6e90d2a4366c86ae81d',
    id: 'range-test-20260619-1107',
    matching_hash: 'e0f2481cae072a103d8caa41584eb186836bf9a5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '020786b9d832fe28e9ddc8287de19a5627d1ba3a',
    id: 'range-test-20260619-1108',
    matching_hash: '1d73a00d637b179227de9b62e84b0158f3e8fb29',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '1ec66edebbcd2d8294ad97f3067a8db82c08148e',
    id: 'range-test-20260619-1109',
    matching_hash: '5d8c2dd850fa7968d6c8d6a0062e9c8d6f321e93',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'b0b182a9a20df6db177e57b8d923d777d36fbae9',
    id: 'range-test-20260619-1110',
    matching_hash: '95055509d612c7fd9e1bc4fa3ddf0388382fa49a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.731115138,
    qx: -0.202357936,
    qy: -0.2937084,
    qz: -0.581598914,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'decb06ad4e84d9a81f1d994829c1545e95cff574',
    id: 'range-test-20260619-1111',
    matching_hash: 'c0747337f10d0de271c3acc9651a7e0a762ba71b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'f226ae15a7fe613136636c1904cfc0df0a411551',
    id: 'range-test-20260619-1112',
    matching_hash: '3b533aaea6cc88df37f18d7e2bbb74053122f2df',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '759006234265b1a524ea29889f2fd49db3adf8f9',
    id: 'range-test-20260619-1113',
    matching_hash: '1b697141db1d398556490022b9b551601a2956cd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'c40d78a80dddcad60672ca8c423bb0dc97621c54',
    id: 'range-test-20260619-1114',
    matching_hash: '6b731cb20e0ba6a561181e32045d97a0f3fcef43',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'c0a65967be74c33df1a02e448b0f50cc3311aab2',
    id: 'range-test-20260619-1115',
    matching_hash: '5d18e0376dbca2bb588e6f6d3dfab969c400f2a1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '403b2d962e3106bc7d2e9e5d8af0d33c8bd252b9',
    id: 'range-test-20260619-1116',
    matching_hash: '21119145543fcda1a1b7f11b45edaa4f1c2a9f95',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '96c2b2636d94d7495d98fefa4fe173c70bd97347',
    id: 'range-test-20260619-1117',
    matching_hash: 'c8cdddaa641059c5c8c27345774171be0c6d7d7b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'd07d849bcb7e513fc78318d9422dbe02fa255310',
    id: 'range-test-20260619-1118',
    matching_hash: '4d55696fc2a226932f3fe89f76e083d98beb8c9c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'f7f4858aa07e451998cd6e93938b5e76ae8d0cb1',
    id: 'range-test-20260619-1119',
    matching_hash: 'e632414325aa3f255628bc546d6042fca3594a13',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'bdaff670fb187ac930e8d7143f18f3d8cdf0cee9',
    id: 'range-test-20260619-1120',
    matching_hash: '9617fd38f439bd5214ba651aa5e346af64189530',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '890757f18599b04828589d5ef0ce079822caeb80',
    id: 'range-test-20260619-1121',
    matching_hash: 'e6cb490a5c40dc186432e76b42d70ab6bdbce421',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'f92931941372fce26ce7221e6c7d715441b622d8',
    id: 'range-test-20260619-1122',
    matching_hash: '20835d7d5e534dfd1d6a30279b0fef664499ac2a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'c4d74ddc2cab07d7d98ddd4b46fd9ce31b278de2',
    id: 'range-test-20260619-1123',
    matching_hash: '402b1dda6740117a898507084a587c0cc74ec766',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '987ac6f702dbd5e0ce54c98e6cd55b74e8ff1132',
    id: 'range-test-20260619-1124',
    matching_hash: 'e7cbbf06065dccfd44ea709ad073adfd46120880',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'f82b1dc80ed6d58a7d0677693e2b6810aeff3ee4',
    id: 'range-test-20260619-1125',
    matching_hash: 'c97106cd36f6bd84b4736f3abbab0459dce76fb8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '86bd69d62f76522b6a0451fc866ee49e3e69c480',
    id: 'range-test-20260619-1126',
    matching_hash: 'a4fbb79b9ecd0e5fa278279c5153771837ba8103',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '7c13c3b1d5d2741690e1ff47210cc282b056c859',
    id: 'range-test-20260619-1127',
    matching_hash: '2c5316dd83ea011cc10e340263af9cef6c916648',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '66146a4a6e8680e43a260144333c6fe0ca3152e8',
    id: 'range-test-20260619-1128',
    matching_hash: '560da8d97a88d111d04ee026e893347337a82124',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '2aa5d5c21a2fcc4972a4168a920abfb44070bf2e',
    id: 'range-test-20260619-1129',
    matching_hash: 'c58860d2efabe73e81498d0c217b181eed5021c8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '20e6c927f117da488baf6311ddc4a153b7d4441a',
    id: 'range-test-20260619-1130',
    matching_hash: '38c4a32bbc79a7c8d3b6b94e9bb759ade82377ae',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '9a0a612498e7ace5f4094e84fa9437deea2a99ae',
    id: 'range-test-20260619-1131',
    matching_hash: 'cf3339d03f0c77fa4209c1873f0a1e389ec00309',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '16608c6639d775fc2ff1cf258872ea3db307a87b',
    id: 'range-test-20260619-1132',
    matching_hash: 'fa1271c65cf21759e22109f9ea55a39dc15dde07',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '578005b7336ccbeeae60bfaa58a1d46af13ab09f',
    id: 'range-test-20260619-1133',
    matching_hash: '2b1e388b121ad070cd98aafc42ffb58838ab124b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '0cec1a9c945f9a500788e1e3acd3d13ff27978da',
    id: 'range-test-20260619-1134',
    matching_hash: '09b2fe745cab9bb57fa8243bd3681f6c24e31bfe',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'd66ebc523d5c07ad1f14bac5170b6c2ef341e229',
    id: 'range-test-20260619-1135',
    matching_hash: 'e1f7267f3042d5b192db9e79cf4d2423a524645e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'd8700da5c61baaf957d487597b19e5de1ab5d4b6',
    id: 'range-test-20260619-1136',
    matching_hash: '814b0b3efaa436c6fe26c981b72d05f23f5b4d4c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'df62e765dd4ce03fb93af90ff20e611c3fc9b48d',
    id: 'range-test-20260619-1137',
    matching_hash: '167572d17f4ef78c5e1641dd2a233ff799680943',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'eab7512ef47e8cb5d95144051149545875b837bd',
    id: 'range-test-20260619-1138',
    matching_hash: '38e3c762d8f605777d0296754b42f30ef61909c0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'e3320aa433e12a2ae45020b0435bdaa567bba3a9',
    id: 'range-test-20260619-1139',
    matching_hash: 'b59ac79b37de722356bfe599d83c6b6f17706ee9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '6f642d80ac3e337851a73ab37a9edb31f33565fb',
    id: 'range-test-20260619-1140',
    matching_hash: '58f6903bb6f031ad3c33f26439d1cba477380665',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'c33f8a33d651d64b3ddd9f022fe8e15eb31cd560',
    id: 'range-test-20260619-1141',
    matching_hash: '0471a563a1d20a52725431b969b49f04b3a78ad8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '823b8c929c06214f33fd135a911328ad4683909f',
    id: 'range-test-20260619-1142',
    matching_hash: '90c20d8aba0c75821131da230e682dd55464a681',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '1eb4897353e5b0b1a619c6db04ae3d30ea166489',
    id: 'range-test-20260619-1143',
    matching_hash: '336e478f5adb5ba50813c08c97f02b792da4e293',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'f8178bc1598785651b9067f6df04ef7dca4b6f69',
    id: 'range-test-20260619-1144',
    matching_hash: '774ed843779be6d8840b107229a1c85de9310b86',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '9e136db71a51bd5b39763abc204e4f40928a570c',
    id: 'range-test-20260619-1145',
    matching_hash: '2626d3e9353be6776116f1326874a9c2b26d8968',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '3a2f6a2dbbc83124e764a686191dc4d9bb854584',
    id: 'range-test-20260619-1146',
    matching_hash: '76f8fa5e17f730e1fd98984350b03a66fdf89d09',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '23cfb8e7ce4b80fbc726635a40267bafdd31745b',
    id: 'range-test-20260619-1147',
    matching_hash: '22ed25c3cfcfa89a5c8f8e72b9527a3db7f13801',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'cc457191631701aad6ae3199d78b375da9d0c429',
    id: 'range-test-20260619-1148',
    matching_hash: 'e271168812e980ac235ce60c459df9b0a86f4b0e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'bc98efb5bf06a531ad919fd933d404c0b1531e4b',
    id: 'range-test-20260619-1149',
    matching_hash: '7c9bb420072d8d610ca0fdd0b428e61b06ef7dce',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '2de1fad1fd1d5b8dd654f07faefb347085ab476b',
    id: 'range-test-20260619-1150',
    matching_hash: '5268c14a5d19126374f6e529ad959f7092ebcf01',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'cafb4aacadba62872681b6419b1b344ea9c03063',
    id: 'range-test-20260619-1151',
    matching_hash: 'd9fd43ab2867cbc5f7d039a015c0518bd2fb6c5e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '3299fc9bb40a924f090f46a6ab58fad49c935210',
    id: 'range-test-20260619-1152',
    matching_hash: '997a59a1f0bbc31d0c6eb795ca84c99b7d9762cc',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '55adc26627f5e19234bbafa7187955345d125f9e',
    id: 'range-test-20260619-1153',
    matching_hash: '583d8cfaec673c52fb35b0dcd716d459e3b323dc',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'e7482cfe95917264b8ce80136e1b436141c43a0f',
    id: 'range-test-20260619-1154',
    matching_hash: 'c55d1e0ebe06705d0744e861c392f2322cde940d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'f2b5e25b4bcc0bbe4269a9e3116d603de153bd08',
    id: 'range-test-20260619-1155',
    matching_hash: 'f8e5f65d7f29705993407237339a1077288bce85',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '457cc452a365343cd8703bc6d7748a0157ed19b5',
    id: 'range-test-20260619-1156',
    matching_hash: '2b0705c64bb5b30af37f162af9530de4ae0d08ba',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'a17e163b018b0e9882c27324ce406cd80fb62908',
    id: 'range-test-20260619-1157',
    matching_hash: '1e4b4bbdad48a049596b081652349b3a1c0701d9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '8ab75f90cfd49243c5f0b353b17a64b4d18e746e',
    id: 'range-test-20260619-1158',
    matching_hash: '5e594e67d20cfe571cf43cade3e485c9ceea6c53',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '4e09bb4d97809b315a521392595701de7e411dad',
    id: 'range-test-20260619-1159',
    matching_hash: '211ef4bf5ae36a5c3e12ab3d78bffd8e7d45991c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'cc9b0e8284d0bdb50f00cb00f4dd79e2d48cc218',
    id: 'range-test-20260619-1160',
    matching_hash: 'e85b7f8a16744fcf8b4ff816bc04e26f2025c988',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '2741ab6ae3aa31ba810952a6e56179d576d13cec',
    id: 'range-test-20260619-1161',
    matching_hash: '4a447cb1d1d02dccf27db0f9a55b5452838d8fca',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'f47cd59841d54a2031a717781d475a84f490000f',
    id: 'range-test-20260619-1162',
    matching_hash: 'ce4688cfada98624dd3b22687adad888f78752f2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '63260db43e40d96c6470745306c9a899cfc05379',
    id: 'range-test-20260619-1163',
    matching_hash: '6b55a01500cc058f7df5cdd9ecd2208df5715360',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '5f905b69cd95c8eac88a97eaade67222a2b9495c',
    id: 'range-test-20260619-1164',
    matching_hash: '546a0ae7a8faeff5153a3d2887881af3eafe6134',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '5fa867edee7d9eff05d2a95f87411350542d00be',
    id: 'range-test-20260619-1165',
    matching_hash: '88448e26e9138bea55a282d1c25319c3572884fa',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '957b45423cc57d5b63d168b179f9f8dab465e9b4',
    id: 'range-test-20260619-1166',
    matching_hash: 'eefba112b7906299c466f3af8ea978654b54d5e4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'd1a71586797e537a1db676d9d335e32f0d4ad71f',
    id: 'range-test-20260619-1167',
    matching_hash: 'a90e1ada6864c9830533fac50ebe6e85d40447ec',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '9357a8f1d0e5aab7342115ab99042469aa92b8d4',
    id: 'range-test-20260619-1168',
    matching_hash: 'c7ae07f77f6c8afd2e9222c7097b005584bdace6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '523e3084bf78235cf93cd983804c16ad15345891',
    id: 'range-test-20260619-1169',
    matching_hash: '12312160c6ab4b6ec1da56ba497815e1398360e5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'f18e375ff8c4aa68ccaa72d26370384bbac36680',
    id: 'range-test-20260619-1170',
    matching_hash: 'd85bb6091addee339a9fd21d6ec6eae6caf058d0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'eaed707bb3e479a954c16070c4c48535b6c43bb5',
    id: 'range-test-20260619-1171',
    matching_hash: 'a395bb1a19f7a8b7aa57c12bc4fb62c4d3a6af57',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '4045267e1500ed290b4239cdb5cd145686087a70',
    id: 'range-test-20260619-1172',
    matching_hash: 'b4accf19cd98d0725ebb32ea3cde2e3790dc800e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'a5e731f9c7a76118a5cdc54512ba6ad106ef7492',
    id: 'range-test-20260619-1173',
    matching_hash: 'e8fb5e040ccc01c9aaa70793c939d9089025dbd5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'b21fed73b41bc8e7fadbae0e1ac3591be62ebfcf',
    id: 'range-test-20260619-1174',
    matching_hash: '167d74cfcc2d39bc39663eda71ded4fe0c601cb3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '990e4ff49408af0d02e8533602cfd55a563d885a',
    id: 'range-test-20260619-1175',
    matching_hash: '077808381674ce02328c979aa81967fa41020c35',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'dab65da9738fed07bc33122528eac1743ba0caca',
    id: 'range-test-20260619-1176',
    matching_hash: '367eac6a3b96215d66a4c7038ebc1d19bcc2907e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '3f29011ca8eaa5496320707eba4570da740b6929',
    id: 'range-test-20260619-1177',
    matching_hash: '4dcdb709922e0720bc4ed428fc7bbeea5edafadf',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'a1dea15a5077a66203c0e2c2a4a3bc4a2527d3a2',
    id: 'range-test-20260619-1178',
    matching_hash: '7364e534fd740f563007cc053b6a0f065dc1ebe2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '19d8698fbdbbc1a742a848533fa4ca78551884af',
    id: 'range-test-20260619-1179',
    matching_hash: 'd708f925c8534db980ad66aec8aca43a88e2a0ef',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'aec3a7d299fb455adc1315b410a596ae487e5b28',
    id: 'range-test-20260619-1180',
    matching_hash: '9fee14fc20063e2b8fb33f6ac95f5ef3c1f4c00e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'f3b850e5b7b6fa3e3cc919afeddc6b1111882b8c',
    id: 'range-test-20260619-1181',
    matching_hash: '0c2539bf7f1d224a452e719040f3f7e4e4a8ff99',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'a0758fb641d398624c9a7cdf6568c46365e03191',
    id: 'range-test-20260619-1182',
    matching_hash: '3abaadb415cf5df96143325067a264daafa439c9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'b365ddde82a72ad66e51a043f8a04931948719ec',
    id: 'range-test-20260619-1183',
    matching_hash: '148d46925426d63a6a37edcdffbc0a15407b872c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '063847a2b936b143e063aa5ac4208329d53361bd',
    id: 'range-test-20260619-1184',
    matching_hash: '6015bf565e9329edf6af771d6972b253fa39e817',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'fb87c5ff6583673b3ed82691ec5f3ad88e1e0d8c',
    id: 'range-test-20260619-1185',
    matching_hash: 'bba95d7ceb9c8feb549948f357223c11596e8ea2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'ee11a3519ed3e4b62bcd877d19fe8c143d6911ad',
    id: 'range-test-20260619-1186',
    matching_hash: '8265b2f27493edb6517e13be96d85f97a0967680',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'daf0744c3e12268ba4025727245c59c09976fc32',
    id: 'range-test-20260619-1187',
    matching_hash: 'b0b2c66d5b8531c1a956c56048de8f2b5fec833a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '5ac9f46cbdd5a4d5ceeeed252db29c28495856a3',
    id: 'range-test-20260619-1188',
    matching_hash: '402ef9e15ab60e57a26d72aeab10a989cc4d95e3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '18b9eea018f9c8ce0d4a3b9d69691eec7cc20ace',
    id: 'range-test-20260619-1189',
    matching_hash: '8cf51690bb307b5c8e81bfdbb42fa3e805cf8c2b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'fbf5997c5ce9b3fd578cf38b5497b98ca9a2caec',
    id: 'range-test-20260619-1190',
    matching_hash: '715998d22e5aeaa6f85c762953aa2e5fee3bf076',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'a4c9bee7b7716f926b1b929fcdfb9a07cf3d1a43',
    id: 'range-test-20260619-1191',
    matching_hash: 'e92602eb49aa60e8f47c734edb4e1236579f2c93',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'ac76f5400908359a082627e76bb6b113d553e1e5',
    id: 'range-test-20260619-1192',
    matching_hash: '77b2bd7f45f3937cfb22b3f019e36a2b1af6e5ce',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '2cb634f278437d948c6f0b2c3e858742dd7a6a7b',
    id: 'range-test-20260619-1193',
    matching_hash: 'a140448a25e0c84d8469fdd17a5452e0a1615f30',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '210e4a203413e7cb8c78b5e8b5f61194dac50b07',
    id: 'range-test-20260619-1194',
    matching_hash: '12f238f66d16b0c408074f07a65cbf339a74b4a5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'ebffc7d329ee1c70a224519b32cd7a80aaf7e33e',
    id: 'range-test-20260619-1195',
    matching_hash: '87bdf6e57ce6de1f3423348a9b9fca09b7faa222',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '0c7cdb6311c26b68702e9d6acdb45dbf3f9afcfe',
    id: 'range-test-20260619-1196',
    matching_hash: '2f55276a11fe60556a8b5e2fea66d4f2a18c94d1',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'e17a3fbee49abe2976e30ba7468a16a0b1aba022',
    id: 'range-test-20260619-1197',
    matching_hash: '725ab4e014489b1c30f45b1806d8505b6a61c481',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'f71ae82a4eccdd0aa1577f0609335465afc6f1d7',
    id: 'range-test-20260619-1198',
    matching_hash: '8bbf972fedbdf7469e59c8f8428a0e32f4f34ded',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '8071a16b08ad2358954ab1a53d711f807da2ada0',
    id: 'range-test-20260619-1199',
    matching_hash: '2a63fffc4ff0a1f9a38a5aead3f9fc49850b3fec',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '410e684f8e0b904fa1f4904fe5cd8ca47401f9d2',
    id: 'range-test-20260619-1200',
    matching_hash: '0e48767060079d37f305d5095e723f56866ac0a0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '3dd2c1043f48f081b4ce103f38abeae3f8f0f56b',
    id: 'range-test-20260619-1201',
    matching_hash: 'ba24be214098336daaa1db255111f8b5e2f4fda0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'b6f8310516aa733e48d2fd2f66978666b3dc03d5',
    id: 'range-test-20260619-1202',
    matching_hash: '6fb4c46d959b456278cab6e4155f57e1c84fb3e9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '6e9dddbd5103c9a36106d1e04d280b3ca551f988',
    id: 'range-test-20260619-1203',
    matching_hash: 'a0364dc75fd239616a1e1fd34aee825b9b723777',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '82d7ca4ff49a0fc58ddb2d627c15f4a611f42b4a',
    id: 'range-test-20260619-1204',
    matching_hash: 'bfbecef8898f923599bcdedf479b2bb7b4d59da9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '26a98c29fc471f485e7bcdeaf6dd1951fd107c0b',
    id: 'range-test-20260619-1205',
    matching_hash: '63d5fec38fe9f1100ed6749002e5ce94cd576a3f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'a0af93c40cfdc2e36360787611781fad386a825b',
    id: 'range-test-20260619-1206',
    matching_hash: 'c9ff2d8d64044a95cfcbc522ca6751b9c5b18e02',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'df437b6ff53bdf2f3b9531ab6747bd207dd212b0',
    id: 'range-test-20260619-1207',
    matching_hash: 'a8af6a10b2b87da3f61c4a3225adc0713909fd25',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '99745194f11fb6ddbeb155a72387301099458dbe',
    id: 'range-test-20260619-1208',
    matching_hash: '71e0f15e38830f0700bcdfb92436266cbf0c15f9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '777603aa6b29378ac05a8aa0a8e5395842b7e842',
    id: 'range-test-20260619-1209',
    matching_hash: 'ec9363c6e66f23db516878e04d030025a3ab34d8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'c5f2f285a4b4d50ebdd480602abfbe2bc8bcff1b',
    id: 'range-test-20260619-1210',
    matching_hash: 'e954698c58a3d07d52f1c28fc29d88805e1473d5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'bca6fbf1bfc1b5770ac11ecd290a87624910df68',
    id: 'range-test-20260619-1211',
    matching_hash: 'e919b3ba66385f8a3d47514bb84b56171bbf20a2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.471519444,
    qx: 0.011322802,
    qy: -0.274016167,
    qz: 0.83812669,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'ad29f06cf60b86124845a1fabb67cc974c90fce7',
    id: 'range-test-20260619-1212',
    matching_hash: '8c92214dcff11558712327da252d61bb669823a7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '3c7f298beeaef1d7662991c9e62fbc9e1fc4d646',
    id: 'range-test-20260619-1213',
    matching_hash: '9e2e8a3d4daf0d671e4a1def2d0157cb942e63f3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '7e6d3ea8769f921d5a5248968907f9cd63c01dc5',
    id: 'range-test-20260619-1214',
    matching_hash: 'cd126c1b7e6fbe4bc7c16e1758c5a7f2027bf360',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'f2403584a08a41ac03842003dec8a709334bdd84',
    id: 'range-test-20260619-1215',
    matching_hash: 'd7bca59959f412ce855e706d4fbfb968663d249f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'e8cb47cd4fc05be7dc3914f305e4ee9369abc879',
    id: 'range-test-20260619-1216',
    matching_hash: '0f8bd9466765999ee9e8dc76339eb816a9fed76c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'd44362fe5e9e7d8c037604f2bd963bb543497397',
    id: 'range-test-20260619-1217',
    matching_hash: '7bb4dfef6828a29f38fca851ede7cb7cd7a149be',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '1cdea022f5d182ec4f541553a05407585b64e8e8',
    id: 'range-test-20260619-1218',
    matching_hash: '30f2920d032d8b828e65d9661c7681ff0c24ef35',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '27eec20de20de7ba298ddb470e915ec025b1a056',
    id: 'range-test-20260619-1219',
    matching_hash: 'bd26bc5aec846d93b4e6da8a4259952600366890',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'd2706bf2d3203cdc41b5a477904805bb3d8102b5',
    id: 'range-test-20260619-1220',
    matching_hash: 'e2c220d6ec791fc5d4d1a632e2af87001b4889d6',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'a9260e1f2d21b4f25b2924c718dfb7d5e6da8933',
    id: 'range-test-20260619-1221',
    matching_hash: 'c731bb19fce7fd1c12d41a796ed330ec1d022d1b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '1d8b359a34dd4d21e089f7d0ddaf217c240fcdd3',
    id: 'range-test-20260619-1222',
    matching_hash: 'e4412b39513b39561dc7996ced351267fedd325f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '63ca1ae1e3c09c0a595c157c855eafc2dda1140b',
    id: 'range-test-20260619-1223',
    matching_hash: '1e0c6aac12cb018b0e496fb2c9538ff79c123494',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'c146b3a7e3f8edf6a3bc05ec0ad0cb1815b25254',
    id: 'range-test-20260619-1224',
    matching_hash: '7a9ff5e75230f55e9cc369ef50a3d53c14ef7be0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'a3d5d6152f1a196beb942fec7c010b854c6a45ff',
    id: 'range-test-20260619-1225',
    matching_hash: 'a40a5d2e9fc934258669a6d1ba656cdf415484b1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '452656a287ed2dde1fc9176afcedc499b7a3ca8f',
    id: 'range-test-20260619-1226',
    matching_hash: '9b1679d8120feef8d905d19184fda125da4463c8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '7ed73618ad778ef602efe6a6fe11a51713217fbf',
    id: 'range-test-20260619-1227',
    matching_hash: '8decf7c0b5406308a592caebf1e3dfe4e57f0616',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'ec501f1687a2dd302bb341472aa8809635583a05',
    id: 'range-test-20260619-1228',
    matching_hash: '61fde6cfd3162a8b49ba61fbc6202798e4536b5f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '597bb56d54c51fe508c39584263dd06ce3e06076',
    id: 'range-test-20260619-1229',
    matching_hash: 'e3b0a6418a4883c30b63a2788aadefd954241b49',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'ef7411d7f1bb0e5ab4ae3e05565ecb96d3cf785a',
    id: 'range-test-20260619-1230',
    matching_hash: '9e06b69d6bd6af3290fa92fb50f608eb9f5317c3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'eb108a1e2788a34536de8e6824f792ab4a3f9e23',
    id: 'range-test-20260619-1231',
    matching_hash: 'b0fc41a22f1e857945780dba8f71b3feeb57deae',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '52a75eff101348cb287ca2362f88d11949ccb8a5',
    id: 'range-test-20260619-1232',
    matching_hash: '3c7e68195d225f2a47a69354a2e4bf46e6aa1cfd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'e61c73207d9daea4d89f5e472c4729c5a2aaf067',
    id: 'range-test-20260619-1233',
    matching_hash: '6b48d58295e939661e6d5192a23bc7f6290e1fe3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '6eafd4ccfc0cdb75a4f66be991853edc20fd6a5c',
    id: 'range-test-20260619-1234',
    matching_hash: '230c9e1584f3ff809a0a8fd04359aa2c030557d9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '13fe814ffb1e01409faa16a2946cb7802aec6dfa',
    id: 'range-test-20260619-1235',
    matching_hash: '3a6f7d76037f81dfbcb8b3dd79687811b9ecc21f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '597582fe16df1518f7071ffa00d6711feb54741e',
    id: 'range-test-20260619-1236',
    matching_hash: '998c99a2a05879d765374091c9fcedc3ed48cdc7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '4a117c43344adbe261dc1b323fa812038d69d7a3',
    id: 'range-test-20260619-1237',
    matching_hash: 'edeb92c4b1eb97beed9f49bae3821c11b819b6ea',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'a085731ce758c6aa56c0cb44d42e25b7c98a5e44',
    id: 'range-test-20260619-1238',
    matching_hash: '1e7dcc61cb296f35c3b42490c0f4e784077988e9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '3c914107638635b4b2b045d00b374dcc0d82a395',
    id: 'range-test-20260619-1239',
    matching_hash: '2941f59974550e5befdfe1770e45d9b0d13dc019',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '37a59452e7921480b71268fb6cc7e7a454ba0162',
    id: 'range-test-20260619-1240',
    matching_hash: '4ffaa62f4c91fe25f870f04a01b53e53900ba689',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '955905f66e72650de4825c75245609eec0f5aced',
    id: 'range-test-20260619-1241',
    matching_hash: '622d99f05cf79380d17f8370d31e803ac8324c58',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'ce08416e835c2545f17971079c0516a5f41fc51a',
    id: 'range-test-20260619-1242',
    matching_hash: '5fe37ed7f1b380d03f7bd327ffbba65472fc146f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '6c1c72686dbe3c3a9b3f570fdd21cd032efa8be5',
    id: 'range-test-20260619-1243',
    matching_hash: 'b9184d94093f463e41397580a6e9feceb1001d99',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '8eae8a178db2b2729d1fd5101c123b2368c35dce',
    id: 'range-test-20260619-1244',
    matching_hash: 'f6d18e28ee95ff0bf39c035cb2c501358c51bda9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '412cbd507e0e49db03a6d2f0b6caedc421637f8a',
    id: 'range-test-20260619-1245',
    matching_hash: '9bb20289f3656376bfa2d45a59c5fe92bdb27190',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '41e272b86264a258fe6eae700cc92098fc36e367',
    id: 'range-test-20260619-1246',
    matching_hash: '416e8cb20c85813a44cf17da06c721536bed56d0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'd56b7cffbad02d49c037149c5f40762afe38d549',
    id: 'range-test-20260619-1247',
    matching_hash: 'f0a384942415992d04c2afc915445b40e25ce6a9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '186a1daf19a810e48840b26a579e3ca7a0b714f6',
    id: 'range-test-20260619-1248',
    matching_hash: 'b8c730f33cc452dea5c45eb27854ca8afc30673d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '068706132f2ceaa2994779a7f6188673753958b0',
    id: 'range-test-20260619-1249',
    matching_hash: '936175da1862e37047fc6f1487e458b94464ae08',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '42180dc936da88f4355e7ff7139ed78dbbcfb8f8',
    id: 'range-test-20260619-1250',
    matching_hash: '5d7166b51cd81c7ef6ecb986fd70782c3589f686',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '35662097056724d71b53e6487382dbded081c16f',
    id: 'range-test-20260619-1251',
    matching_hash: 'f15642a1b53ed1316ca614325a138e0599856255',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '88521ae3111c2aba1ab5d5ddea217269afb2d71c',
    id: 'range-test-20260619-1252',
    matching_hash: '3d551cf6922990ae65b6c79cff0ea630b27a2b4f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '6ea60e1b43cff0e010cfc68a4a16ee006fd4896d',
    id: 'range-test-20260619-1253',
    matching_hash: 'bb9211631e2b1474a40b74b4a6ceb419ae004d3d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'c1b84d881663ae62572221326b7a3717e1075e4a',
    id: 'range-test-20260619-1254',
    matching_hash: '03906fcc35f61f03a7a51f136039de5b9ff500a3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '841da5150effd6f964ad3b74893250c23950e292',
    id: 'range-test-20260619-1255',
    matching_hash: '229c5fe79d5f7f0110d8d1e3eb9b6a50ebc8229f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'e8c92589f726680ca7dabea7e6d121c95ca68113',
    id: 'range-test-20260619-1256',
    matching_hash: 'ec64bb171d5d7b4b81f4c7941a107a8c3948508b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'ce432fc64ea631bb951b2007e993f87a7bc5f650',
    id: 'range-test-20260619-1257',
    matching_hash: '6e02db32c3e6e963b458ae0a408a3fc225164438',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'a04fd9970438c5fb7acf4ca7f90532055143b03e',
    id: 'range-test-20260619-1258',
    matching_hash: '583d86b7cbcb77e22caa0206e1acab06dc54b34c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '199858a23d174bde5589ec8678eed3617df6a8da',
    id: 'range-test-20260619-1259',
    matching_hash: 'e45fa4c68e0e1b0b25ca5a5a0ba86f5b26a3599b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '356b440fd46da2e73d16050f7b798ffc3b3767b6',
    id: 'range-test-20260619-1260',
    matching_hash: '780c23a21291dae2520aa602441cf522877cc453',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'e2bb1ab75237150ce346bd3ce2f7f66fe6d9fddd',
    id: 'range-test-20260619-1261',
    matching_hash: '6d79283d47c44bf2fecbf2251207a17dd3b44067',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '34b9b7847b902c7dca8f3f04bf7895abfb18c347',
    id: 'range-test-20260619-1262',
    matching_hash: '9347f6733ac00d93d3b2431642bf6d8a28dd8882',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'ff6642b49d9c66c8975c327bddca9e40aee51737',
    id: 'range-test-20260619-1263',
    matching_hash: '9ba3ffb1f55448e7879f3ea64929ea58d29f973e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '7910b6316de2129378c5aaf45ee4265cfd6c3606',
    id: 'range-test-20260619-1264',
    matching_hash: '5da825fda4150a071bc30a2e9cebc79e4549142b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'eba501528fd431b1d8b427274752d67186830a43',
    id: 'range-test-20260619-1265',
    matching_hash: '01c6c7898104adbc9e11cecb08e77ee7fb563350',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '1d79a05e715e29538d1befeed947da25ef178873',
    id: 'range-test-20260619-1266',
    matching_hash: '2706e3015aef1578427ad735ed3b8788bc09faa8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'd55c27604d207eeb7e86345db1cd6b367538e1f5',
    id: 'range-test-20260619-1267',
    matching_hash: '97430a42ad3aee8bdc29c440e38e87b6854dad9d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '7e22fda4c8a0a90f856fae26ddbade6459958f78',
    id: 'range-test-20260619-1268',
    matching_hash: 'ee9c97cd8a9be4f1816209d4c0df1d6e9bfa2a45',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '8116aab98b715fcbb5258e0502efbc561ee65641',
    id: 'range-test-20260619-1269',
    matching_hash: '63ab810267854a853b82be3635b9cdc26d6fde14',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'd704794030daf869c0f7d17f5f1399c99c375cfa',
    id: 'range-test-20260619-1270',
    matching_hash: '62e2a9a1ec4df0b28ccbaa88afecfdb2c562b1cc',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '78c9bbe99edf93b6733c27a644feb95da606025f',
    id: 'range-test-20260619-1271',
    matching_hash: '6822955c01f2fb8493dab1278fa02a2b6a607992',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '37b4f49d4db7a594d2b706522f8b02f29b9efbc1',
    id: 'range-test-20260619-1272',
    matching_hash: '0819e08e26cc48747122283de8f0d06fa2542136',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '94ae7d48ef588e3e55a6523c993c0ebe0441f926',
    id: 'range-test-20260619-1273',
    matching_hash: 'b1f666409fb3a99893b513705ecb7d030072d5b8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'a4b4b1cdacfda0fcc486647f9c267bc2a611af3c',
    id: 'range-test-20260619-1274',
    matching_hash: '8b6bac4b78d32302250e46b8c56ce611049ae3e0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'eb9ca22dc824b7a7ca4f2a83d8a72f53e729cec7',
    id: 'range-test-20260619-1275',
    matching_hash: 'f1f54321db31719eefb1dfeddf3d9ee4a42070cf',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '0aab40ab3284dd46ce0f091cbf66e94963649695',
    id: 'range-test-20260619-1276',
    matching_hash: '1f6da158e8a0b44b4b54371e2ae72242650fa1f5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '843d1497d819cae4b0fd018aca6436997897f663',
    id: 'range-test-20260619-1277',
    matching_hash: 'bbc3cc600df0a44d91890b2352a01d847d62aac2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '1934790e5bf47bdfbf68978aba8ff5e225877986',
    id: 'range-test-20260619-1278',
    matching_hash: '564d928571e80a94adda0f1123f1998131b7a72e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'db072c849cbb74b9636e571cb23cd787f0e10e71',
    id: 'range-test-20260619-1279',
    matching_hash: '9e0915dfdccb6983134cd664faa2a1d9e6b57f83',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'e8fd84931483c23f965972cba85a4ab076545cbc',
    id: 'range-test-20260619-1280',
    matching_hash: '07af82bd35b018b2e9fdd6b3237fa67878ec98d1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '853f727a4809043f15e324ae22a74fdc73acd2b4',
    id: 'range-test-20260619-1281',
    matching_hash: '45bc3ce8ed63d8635eb7e9127e738fe1cfa1d49c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'd6fa87b20219536a9f95ccaba61e1b32a0d8942c',
    id: 'range-test-20260619-1282',
    matching_hash: 'c93cf7410203b98b1ae543bd106628650d2c3de0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '083bd583ff4ac2abca53099a49e5968fd8930bc9',
    id: 'range-test-20260619-1283',
    matching_hash: '9d2e82389da190f7cda3ae2df49945b0ec34b1fe',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'e09000d6177da803819ca81f6cfe0606335a4178',
    id: 'range-test-20260619-1284',
    matching_hash: 'fcb92fa560ac5c88ce2189bc6179b6e153d13192',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '86ed28970cec83a7584fc9d2caeca41929534b8d',
    id: 'range-test-20260619-1285',
    matching_hash: '190f1fbdd484ad61fdb8c0e7df73603ea475eb00',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '9a0a27314fcd3168f9ad27cfe23eb8a8fe1426e0',
    id: 'range-test-20260619-1286',
    matching_hash: '5cf4a42e7972da3e1892ade203b6ec8a119fdd93',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'fe3ec38d5666736080854568312db6acadf80ba7',
    id: 'range-test-20260619-1287',
    matching_hash: '7323ef3005c54fc34a4436701dd61ae765679a5d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '3d7ffe3bb50405248fb2fd5f4cece6ab70b1bb11',
    id: 'range-test-20260619-1288',
    matching_hash: 'dc645d596a5bdb48419c1fab4f7ea2bff5453f58',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '7a3f6698c802d7857bbec0488f6c0c3252ef7e35',
    id: 'range-test-20260619-1289',
    matching_hash: 'e12fad0a1b86580b620d166ace53f2b85603486a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '461d4218c87327b370880c9375553e7225e14381',
    id: 'range-test-20260619-1290',
    matching_hash: 'a4e5b55a8b84249095d387ca6a313e7637c6c55b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '401e3bd4b5c8224caa9bf085806abbae815a8cc0',
    id: 'range-test-20260619-1291',
    matching_hash: '3a868d67b90d735bb4dfe36f2fb4ea5e3f3d21f6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '9884af7365ccb1f96418e81713b89a8197809abe',
    id: 'range-test-20260619-1292',
    matching_hash: '631e38007fe3d7c7e852b0389173a9b89a6e95e0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'cc240ac5cf496c71a88cd28899efc462b18ebb8c',
    id: 'range-test-20260619-1293',
    matching_hash: '3ca8065fd172ef9edd6ab5cbd1adc11af5107567',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '28cb27a0c1c166aabf0f94df1165c5aceb19a731',
    id: 'range-test-20260619-1294',
    matching_hash: '39a10f7abba44f341279a95a2e50654cd3127224',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'dc440f0304c7d74575e727f83236a5498b26fb9b',
    id: 'range-test-20260619-1295',
    matching_hash: 'a40a5d2e9fc934258669a6d1ba656cdf415484b1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '582aa6ac41b5b5aa9a73d0165c07bb4bd8333e6c',
    id: 'range-test-20260619-1296',
    matching_hash: '9b1679d8120feef8d905d19184fda125da4463c8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '6f8bd71ce279c05dbc92fc5599a850054de7e76b',
    id: 'range-test-20260619-1297',
    matching_hash: '8decf7c0b5406308a592caebf1e3dfe4e57f0616',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'f9e739ad619f700e54d9373dbc1dd3cc9c8ec41e',
    id: 'range-test-20260619-1298',
    matching_hash: '61fde6cfd3162a8b49ba61fbc6202798e4536b5f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '3b504c77f90521e4dccf5eb508a997b49ba33ea2',
    id: 'range-test-20260619-1299',
    matching_hash: 'e3b0a6418a4883c30b63a2788aadefd954241b49',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '9d7af849fc4d4372f29f0fc6848553722f7720da',
    id: 'range-test-20260619-1300',
    matching_hash: '9e06b69d6bd6af3290fa92fb50f608eb9f5317c3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '05b84fbde65ac4b7946a590572f9a88dd6ee0ee5',
    id: 'range-test-20260619-1301',
    matching_hash: 'b0fc41a22f1e857945780dba8f71b3feeb57deae',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '6de129103a70c24244d3c81255f4a32c929829ad',
    id: 'range-test-20260619-1302',
    matching_hash: '3c7e68195d225f2a47a69354a2e4bf46e6aa1cfd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'ff82252f7fab68583adf47b9359de8b0301135e7',
    id: 'range-test-20260619-1303',
    matching_hash: '6b48d58295e939661e6d5192a23bc7f6290e1fe3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'ae01e75cd856eb1f41adb9ae6dae80deb8dffc59',
    id: 'range-test-20260619-1304',
    matching_hash: '230c9e1584f3ff809a0a8fd04359aa2c030557d9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'e836cdfd6d1b51950d911155f9e09cbadec83522',
    id: 'range-test-20260619-1305',
    matching_hash: '3a6f7d76037f81dfbcb8b3dd79687811b9ecc21f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '38545495a392ec912605bd6d44389144fe34f604',
    id: 'range-test-20260619-1306',
    matching_hash: '998c99a2a05879d765374091c9fcedc3ed48cdc7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '41a110c465c163fa7667799775bb8d1f35b9133e',
    id: 'range-test-20260619-1307',
    matching_hash: 'edeb92c4b1eb97beed9f49bae3821c11b819b6ea',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '20054d3ddfb3a8e64f23be48628237d67312afcf',
    id: 'range-test-20260619-1308',
    matching_hash: '1e7dcc61cb296f35c3b42490c0f4e784077988e9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '0cb56a45434f65934dccafd654bc1ef3c6beff64',
    id: 'range-test-20260619-1309',
    matching_hash: '2941f59974550e5befdfe1770e45d9b0d13dc019',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'b763aafd9e29011f94385f9bca0dfb53abc4dafd',
    id: 'range-test-20260619-1310',
    matching_hash: '4ffaa62f4c91fe25f870f04a01b53e53900ba689',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'eb66299c79d70cb8d9c44675ea5378d3cbe47e5a',
    id: 'range-test-20260619-1311',
    matching_hash: '622d99f05cf79380d17f8370d31e803ac8324c58',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '575e8bd24845bda94272b4648da73208969a9425',
    id: 'range-test-20260619-1312',
    matching_hash: '5fe37ed7f1b380d03f7bd327ffbba65472fc146f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.135714107,
    qx: -0.65238417,
    qy: -0.16616323,
    qz: 0.726888132,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '43a1047128f485d2a7084bb8c4df5bb616cfc7c2',
    id: 'range-test-20260619-1313',
    matching_hash: '9d7c39c566865bb7207199092652a6bd07cb76a5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'afd675838541d70e35df66859c70217bfbe506e6',
    id: 'range-test-20260619-1314',
    matching_hash: 'cd72023f785d8be29b0e02839a67a60656ab40e1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'c6b818da3ca3d08808d180ef333d5bfbb4043102',
    id: 'range-test-20260619-1315',
    matching_hash: 'e231f5a4ea43199fce81d4eb4186268a6a51b365',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '3a94fe7def262788eabd9f862f24796bf0f72c6b',
    id: 'range-test-20260619-1316',
    matching_hash: 'c8dd965492de531e256d3dfcd21daef3bd398243',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '701f5c8c80ffdc098748cbadcd0ff78c2521cd59',
    id: 'range-test-20260619-1317',
    matching_hash: '2889a1a594e584bd889f2f4934c4b0cc627fb99f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '4629189fa95144ca6e12ef75e654b766751a7151',
    id: 'range-test-20260619-1318',
    matching_hash: 'd2ce07161aa638c1c2089054ca3bf5afebe71e40',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '93dc295fea70d2c88e30e9b623a9991de4981779',
    id: 'range-test-20260619-1319',
    matching_hash: '86a6891a00da5fbb124418c871833bf4ad330dfb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '416a69788c67778da182cffae920b5a0be3ae4fd',
    id: 'range-test-20260619-1320',
    matching_hash: '30e04e0772cda839a65bedb0b8db73922a8898bb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '90ff45edcc6b853a109aa035ff93f4f377df231e',
    id: 'range-test-20260619-1321',
    matching_hash: 'dbaa45baac4b5505bce331e8ce5c13951686fdfd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '4ecce44e5cd49592a13e6b1c366fb7c8cfde8b5a',
    id: 'range-test-20260619-1322',
    matching_hash: '0240395da7b49bd9aa6c630c56ff8ff665dde285',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '3c719254f050b08a101c8575682b9e85307e0a99',
    id: 'range-test-20260619-1323',
    matching_hash: '0b5406cc4aec74fd88748ad23d53aec0b43b39ad',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'b29b5f25617c84a3460146a184b0b8d53560c3b1',
    id: 'range-test-20260619-1324',
    matching_hash: '941d3b58d01a143f1147016bfc7854fd2f39b886',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '40fd33d6419fe1848591801db67e475f699ffc84',
    id: 'range-test-20260619-1325',
    matching_hash: '3db1a4c4e8b653a73f1df434a3932e957f2ecd2f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'c09139e4f0e1b6f396cfcf54f7c1a43c69b3d565',
    id: 'range-test-20260619-1326',
    matching_hash: '2d7a8302471070adf3f9903f0b6cdf35b66513aa',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'dff565dd9faa809fc715e3a5850b6264a7f349f2',
    id: 'range-test-20260619-1327',
    matching_hash: '4c2f8d71f26885e4014f326d553657ce48e57da9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'b91e934ed57f4ecd596c0f986301c59bc0b0b868',
    id: 'range-test-20260619-1328',
    matching_hash: '02a4c540c5a7e37db429729c4867695b01a2e92e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '9e2ae834ed36ec9fadae2738a8e750c0906300de',
    id: 'range-test-20260619-1329',
    matching_hash: 'f28e69f4cc477a2979a134f850585b522ad58f22',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '9f52725e07432291c41d0275281d174083a23298',
    id: 'range-test-20260619-1330',
    matching_hash: 'a22ce3c8cef5c7f4b154702e71a6e76f240f0e75',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '7964a4498b7915c53ff5c1706ae0a7a05bd4cda5',
    id: 'range-test-20260619-1331',
    matching_hash: '2fef1ba2fe3302af73ad6e2d0d6bb410db9381e4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '09d81ac8b7a94abc02d82694011632b61b9c19ff',
    id: 'range-test-20260619-1332',
    matching_hash: 'b1ba383d4a10f087fec93dcae39daed6caefb303',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'a753842ff830eb60669d78543167d3ac6f6462f0',
    id: 'range-test-20260619-1333',
    matching_hash: 'c9217c22695ed754652e325545cdb7e449392540',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '035fbe769b1fa26a5f8d159b8f09677b6acfd8d2',
    id: 'range-test-20260619-1334',
    matching_hash: '92462386f02b27a60f302fc56bf912f78495809c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '6b4de03ca9e018988fdc42ff4ed7dd170c585409',
    id: 'range-test-20260619-1335',
    matching_hash: '470156fe6fd36f006322ee187c3c76123320a23c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'e37847028c427790e5a8db0ab266e6d7f8f884f6',
    id: 'range-test-20260619-1336',
    matching_hash: '995aaf1fbb890f288846abc0524add15a58dac82',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'd66f6aed19b8577c17473875dbdfbacbec54b6fd',
    id: 'range-test-20260619-1337',
    matching_hash: '5ae1d11914aec6b79f57d4b195e9059f9fb26242',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '1cfa867b7402f789ebeb8d1bd906c1f9073db936',
    id: 'range-test-20260619-1338',
    matching_hash: '1a6194d9188944c971b387928a8052a7c1ef78c1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '16cae9f974e022fc1dd3919c916670d8db63afb2',
    id: 'range-test-20260619-1339',
    matching_hash: '5bb8b73fbf03e4d871d172e5ba634d5ac80b22d4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'f5536fb2a63273f49de2c8d68fa980bcf54d7fbd',
    id: 'range-test-20260619-1340',
    matching_hash: '0375629af5365f4680bc2dd849db148d1fcb8b27',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '1b2fc51949520f85f84844710ca6be44e48e00c1',
    id: 'range-test-20260619-1341',
    matching_hash: 'ed905437e7f67e46b1d84aa40337897778d2bcb6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'd63bf43010d1a6a373130bed0fd37ba15e5fe285',
    id: 'range-test-20260619-1342',
    matching_hash: '484df81352d32fc4eddb4e8651196982fd7f0269',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'e73ba79921382c6a26c3f87d585c8cd2163228e9',
    id: 'range-test-20260619-1343',
    matching_hash: '69297b9f4b8def909ec3fd825065814415330be2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '4fca14d648a3de868deee6d2aa667548e730d750',
    id: 'range-test-20260619-1344',
    matching_hash: '0a9bf960f000884fe4c44c3ded5817f0285829bf',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '990219ea7eb525f873bd6558782792a2e9d663ff',
    id: 'range-test-20260619-1345',
    matching_hash: '3869996c800dcbd738d067ebd29a5f6ffda5c697',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '5770f67455883bcd7939588269ce0331ee5676fd',
    id: 'range-test-20260619-1346',
    matching_hash: '855301da71c4b5d6b816d7a32bc24936e400aaec',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '15a2241ef9cff42042b2f382e28ff375a51203bd',
    id: 'range-test-20260619-1347',
    matching_hash: 'f6be9a871f3b8aeca9ef5607eb99648e5fe57352',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'b7f2cde3f6b565c960d84462f36fc6b3493861f8',
    id: 'range-test-20260619-1348',
    matching_hash: '69b92040ae78af78123cbfdfcddd95de171dd566',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'e576d8426e122197db3a7e621e35d68f52f5b200',
    id: 'range-test-20260619-1349',
    matching_hash: '52c37cc5b8694a9293148baa8dac0bd5c7c07336',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '93d3e41e9b8c506a8046ec551359d3d355e9c2ed',
    id: 'range-test-20260619-1350',
    matching_hash: '7d5b7e62957d3f3dff3abdd378297aab1040c8b7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '62b38e0eb1d5722cda772626c5d8b22373da937f',
    id: 'range-test-20260619-1351',
    matching_hash: 'b9f16607ff0d2c53c998a669c835ab35931d0743',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'a799cb9a78032bbbca7828a10dd54c143d84dcb5',
    id: 'range-test-20260619-1352',
    matching_hash: '3c5cffee7c3820ab3c6a434c06dda5a44e05e9ba',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '94e08c593966f2d0acb11132c527bd9eaf77d657',
    id: 'range-test-20260619-1353',
    matching_hash: '1a086ac7f878e55c35d09c9681a933d9a1897e8c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'a719b026705229e5d30487dac161f64c9a430b7e',
    id: 'range-test-20260619-1354',
    matching_hash: '4b1b4aec27554c310174ca1f8459ad3e996c3877',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'f8280d1a2ca3ab98fb9c729f769edf9c0c18bae2',
    id: 'range-test-20260619-1355',
    matching_hash: '12556d685f183faeeca9ea5a2c89c1d79e563252',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '93fc4cec8724318ab756a454db8a162d31033d91',
    id: 'range-test-20260619-1356',
    matching_hash: 'c2f3baf176d25a9355278ce12c34440c6bbad9fa',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '8d83dcf2fac6551ee0a1814b42998ee94b815aa8',
    id: 'range-test-20260619-1357',
    matching_hash: 'c443e6270182e560b8b2c80cf4b6a0cbdd57438a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '2fa17fdb2e7b03098f32ea0caace8eafe6b651ac',
    id: 'range-test-20260619-1358',
    matching_hash: 'd716cc766d04d44d093a2ad80ce78887f2c3de35',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'b471c41643cec345058ce437c0aedcfa2a736f8e',
    id: 'range-test-20260619-1359',
    matching_hash: '7a2d4f5fe12d50168e639c5920e3497a1eda1fc1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'f94c3a7e1c8e6ed434ca17393b721f4caef042ad',
    id: 'range-test-20260619-1360',
    matching_hash: '4da177b32f934186be502c09e0d7309e6ee55674',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '17c12ddb71fd29206c7904fa1828e9f69c920c30',
    id: 'range-test-20260619-1361',
    matching_hash: '00fba54d21c3409c7c4d3d1bdd112b265af17b9f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '6bbbc410c586aac974140794fd8f8d497e12b786',
    id: 'range-test-20260619-1362',
    matching_hash: '9c92193283ef4c6aaac0264a90e7a1fc893af706',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'b4c3efeee3cd070cc950b289c695307c5d83797e',
    id: 'range-test-20260619-1363',
    matching_hash: 'de68eef53788752d83b1dc1eb5e6fdd0b6ee6ebe',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '8e712f35a675d0d6d9c096b36bdc3a5eb997baaf',
    id: 'range-test-20260619-1364',
    matching_hash: 'ea43b3f52f58d76e9aa54b90a10e5c11605929be',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '240069d5ebf0426bd8c7ecaba3273c3aa2693bed',
    id: 'range-test-20260619-1365',
    matching_hash: '50cee1ae364a932af94c3a990a29684236c9b8b9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'f4feb43b56657dc52e61e76103dbbb1d8bdf3016',
    id: 'range-test-20260619-1366',
    matching_hash: 'ebca8bc9bfed39f2f43a4323b2086704d4e04a16',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'e8cff5e2a20aa401d623fbb5f06b5a11b5a6fc21',
    id: 'range-test-20260619-1367',
    matching_hash: '67c6eae3f465fa54dc396406ecdf8650af52bec8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '11c9d39e7e136510593987d1c2a2fb8d7dacffd8',
    id: 'range-test-20260619-1368',
    matching_hash: '3420ece3386d32706cc7d6bac6a6f5c6b6b63230',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'fe909f3dd72363aca2dbdf63fe3e9288161edb5e',
    id: 'range-test-20260619-1369',
    matching_hash: 'bd6bc8631f6a3a82ba19e42d21f3b35d437c8eeb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '1004a24f8ee2579d215a8845e20413d875576ac8',
    id: 'range-test-20260619-1370',
    matching_hash: 'b8ed2244bb076eaa386b17e317240db18d0f0036',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '86e363d019a761c97c616d470f5c331889b7ec49',
    id: 'range-test-20260619-1371',
    matching_hash: '43e1d5c8e54fdcc9a305aa951d7dfe3115a01f30',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '320a5697c36f59fd596aee7cc0e1ae9eceb3a593',
    id: 'range-test-20260619-1372',
    matching_hash: '3705aaed43e4533fd21e30fd14af6a8f0dc94bb6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '27220fa8a32c36b34c7744ffa36bb35b3f725ede',
    id: 'range-test-20260619-1373',
    matching_hash: '64e25649172a273e8318ca027e6fb4b75cc64bc1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '065828d3efd71c880b91116b4aa62522bc1c99bc',
    id: 'range-test-20260619-1374',
    matching_hash: '2eec99e0053bfb290d31c17d4eccaed2e2bb3bbb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '3cf5943255d02c93aa5e46dad8b2bf87193732f4',
    id: 'range-test-20260619-1375',
    matching_hash: '8170525900b438d8891d7cfe4d9d5cedace0074f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '4997cebd78aba82289e46f5a8f1fcf702b38eaa5',
    id: 'range-test-20260619-1376',
    matching_hash: 'a767c229f4f0f7e4e7446e1a5b366c244966a486',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'ac145b8e94a9a8b9aed3641590a23a645448a53d',
    id: 'range-test-20260619-1377',
    matching_hash: 'b7c17d4ae5bbbda9ca105f21dcb99e9ee0465774',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '6006999d5390db80e1bdfa9e8a34c91afa145d44',
    id: 'range-test-20260619-1378',
    matching_hash: '505946334318f6491c1249d2074d2ca1e4c856d9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'bb4868a485161e6ebc899bdf84a2dff50854921f',
    id: 'range-test-20260619-1379',
    matching_hash: '7195981ddc7c0e99d023b68fcdeafb5739616815',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'c803bf42c2c527cc38b3d26d143bf9383ebe9af9',
    id: 'range-test-20260619-1380',
    matching_hash: 'e9acf9c1097f869d54fe82decb15f0b001dc4729',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '440f484631d799b6edd3cba92f80fa2ca280d865',
    id: 'range-test-20260619-1381',
    matching_hash: 'b65415b74707a16593bdb9cddf8b7fd2551b5f61',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'f4bbd5b3a0d7bfe0d1664ca36ba161fb51469d1e',
    id: 'range-test-20260619-1382',
    matching_hash: '39c5169ec3b84fc1837cca1993db94432327b644',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'd5782b85e870e675a82b526eb5892d5412cc5c37',
    id: 'range-test-20260619-1383',
    matching_hash: 'cedfe4768650a5fb665e284b071a4f4e4e2ab6be',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '8dd9fe95ac3bacc4cd4846fa1c7867d6ca4912b5',
    id: 'range-test-20260619-1384',
    matching_hash: '825ae2cd0810d1d0b5e89c8c843dab4a9b662441',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '44dc6e61af320731474059fdb486e092755b612b',
    id: 'range-test-20260619-1385',
    matching_hash: 'ea34934887a8f2ceb028e4087d9fcf1891873b21',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'c5d1e0a69ad617aa797ec18f8b47d73d8b1dc846',
    id: 'range-test-20260619-1386',
    matching_hash: 'ce0dd610c96c0e750d9a5077086fdd4931b0a21c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '092a61ea06578aba656d91a893329b80360ed253',
    id: 'range-test-20260619-1387',
    matching_hash: '6af8dd0ee55eadb1dbe53feeef35da250d123e4e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '1e89493b3155055605d86e5d27468c4c4b4fa547',
    id: 'range-test-20260619-1388',
    matching_hash: '3bec638d6d89127a96bd029a0bf230b988ddebe2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '46201222c7ffda052935eaca36647a697ab9e2d3',
    id: 'range-test-20260619-1389',
    matching_hash: '4feba425a0d436dc4214709880ded14ecd64338e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'a3638dc43b568a41c549b293ea40b252be3d141c',
    id: 'range-test-20260619-1390',
    matching_hash: '30696541ca12ddfc2dd5076bfa1157a0cc438c32',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'bfd78652419abe5a369f15c2d4014410b7b65c32',
    id: 'range-test-20260619-1391',
    matching_hash: '343489f18ef5c2118e49841e03d880419ab28671',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '1ed10c8ee5cb89d6b668d76247e39efe79f79785',
    id: 'range-test-20260619-1392',
    matching_hash: '6d66f6faeba7508f2d110488f0056a3779db6478',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '649af5f12edf49ed291890a0d4b1091a93c22496',
    id: 'range-test-20260619-1393',
    matching_hash: 'a9f707c2bb493938a6d94d31e4c8f23546ef1234',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'd10690e60c2a31b6757be38acbe4ea0afde89a3e',
    id: 'range-test-20260619-1394',
    matching_hash: '20ac9e9492da33461805f01420074f0771dfb668',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '6506c74543fd9fb86bbafaa7ae5774492d7ba8a2',
    id: 'range-test-20260619-1395',
    matching_hash: 'ac0a150210ab1f98a038b2a06ccdc6f426fcd57e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '2579637cb961a9e7c3b6d63ff173e7d0f92ef0a6',
    id: 'range-test-20260619-1396',
    matching_hash: 'ebfa5c3312eb6f6ed458b5611b100a4e87d5fa22',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '7507ea935ea033205a826a9a6ff307d2b5651d10',
    id: 'range-test-20260619-1397',
    matching_hash: '027f82fbce7ae94cfe4d33415e031b14326aa7be',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '94d1b03df407273fc1f5c4d7e5c82dcdc10a6bd2',
    id: 'range-test-20260619-1398',
    matching_hash: 'f189c446d575e6d7d2a6b8826138c7d0d9c5466a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'f788cb094a82f16d23fa91205b60856e113e6210',
    id: 'range-test-20260619-1399',
    matching_hash: '4661afd53a88cae6fc598d44efbd48deeb47469f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '01db55bbddd27e124fb200782d13f49a261422b7',
    id: 'range-test-20260619-1400',
    matching_hash: '7fda488f9987e44ae9ad0687f6429add56701651',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '399c3f51b6ac3b9b212a59f6c0a8a5e42909f0da',
    id: 'range-test-20260619-1401',
    matching_hash: '87f7ab2fda9a68b9b20b8d88766139de8f1af27b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'cd617a647f54c168cae5d63d69578e470e97128a',
    id: 'range-test-20260619-1402',
    matching_hash: 'e3c0ebbef90bd2ee2d58edeaca250acbb6c3a167',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '4a95a2a430ad07447c31d13def619c0346b95ea7',
    id: 'range-test-20260619-1403',
    matching_hash: '5667a5f8fc67298d4db6405447c4cde114a74453',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '821048b1bae5906161f5c9dc2c075093efc1b2b4',
    id: 'range-test-20260619-1404',
    matching_hash: '75e913e8d402e2924e908075e87b258c94421ef9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '900e13afe911950aa6952bd69663ffd88a220e7f',
    id: 'range-test-20260619-1405',
    matching_hash: '98540dc2c35ec5b799b4030af4271056d8a24840',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '1560231de2af659b14ffbf1194ba2607c4151011',
    id: 'range-test-20260619-1406',
    matching_hash: '81cc77ff0bd23508e2089c16c39421c5a051c44f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '1fc6ef2581c09112e02039763719c218484f2c4c',
    id: 'range-test-20260619-1407',
    matching_hash: 'f11e8774cf0e8679772e00b1be0520c70cbcbd0b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'f9efc768da4916a04f12a3ff191d629dcfdcd94c',
    id: 'range-test-20260619-1408',
    matching_hash: '18af0f9bebcfef691672b5079f93a95046b17e9e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'fbb504c555221706191db9ef7b94e07f8819a512',
    id: 'range-test-20260619-1409',
    matching_hash: '32e85819adc5320e69b0acf13bdb54793ed7fbb1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '0b1b2a605743b75e9eea973079316704445e81df',
    id: 'range-test-20260619-1410',
    matching_hash: 'f684db3b2b4b026b770db630b4b77d7d4a2cfb67',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '27163a1fb762ad692a75872edde98450b026ca30',
    id: 'range-test-20260619-1411',
    matching_hash: '4ac20fefd2e880b56f02c5bb03bdede89169f436',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '4489200048f6c8918f9fb7a44d30fa623006ae1f',
    id: 'range-test-20260619-1412',
    matching_hash: '1893007ab88c397ae2cc816b34ccb5721c519738',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '9e7ce2b44da0ddccff546e7379cbac27e2190e6f',
    id: 'range-test-20260619-1413',
    matching_hash: '10b09f60915926e7802fcc7b1a2c5bb2bc7af86d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.904449162,
    qx: 0.307996453,
    qy: -0.03760397,
    qz: 0.29273852,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '999062bd9674f9ff96e08091681d0503caad1c89',
    id: 'range-test-20260619-1414',
    matching_hash: 'f0b9b7448ac2823484efebca4715b1c6b09870e8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '89ad30f677c868c34537cca043e52b0fd9c6634c',
    id: 'range-test-20260619-1415',
    matching_hash: 'c315595772990c6fb50c7315535201e67a8c6ddd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '67229c00b1ff1c8b60b839aafe0b551a50ddfa82',
    id: 'range-test-20260619-1416',
    matching_hash: '0bbb35e77209bd55d54aa99412e6247d7b480795',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '07e31dacac5e47d39957748f1e20b5a984b5beb7',
    id: 'range-test-20260619-1417',
    matching_hash: '3c59525f7d40d379a307e9afd9022d8ba204fb88',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'd9ee4bb3692460be5a8a89e73798e0e984672b0c',
    id: 'range-test-20260619-1418',
    matching_hash: '1988a1a03429f54cbb97291c9b744654d60312bd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'f6a2e285223bb697d0eb294c5b81debac35ade80',
    id: 'range-test-20260619-1419',
    matching_hash: 'ba458e707e9010736786dc2fd815392d977c602a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'a02d7ed3ee01fcb3dc80817aa14cea1e948e5e97',
    id: 'range-test-20260619-1420',
    matching_hash: 'cf0c8ee0935a6253048f22b40e0e8d7d6e971694',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '2a97cf47b6f7a6562f734badf411df9845f3c97b',
    id: 'range-test-20260619-1421',
    matching_hash: '979eab868e310c936191e22ec5bf12d4790483b5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '231e136201e6b44963da7a2f7528040d1966d8ee',
    id: 'range-test-20260619-1422',
    matching_hash: '3f64f4bf12edec88fdd436ed4c3ee67c9a2dfb34',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '69e8d5b25533239521b2c89d3f569775ef520939',
    id: 'range-test-20260619-1423',
    matching_hash: 'c444420128c725d0fdb6943feb6e584b30c3b205',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'a8be21bc63bae5374463061259f4f716b8939113',
    id: 'range-test-20260619-1424',
    matching_hash: '386c1a80d540871e368f22802631a7c7abc507b6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'f04d39fe8826d4ef3cf8ecc25854ea61ecff384f',
    id: 'range-test-20260619-1425',
    matching_hash: '6aa639c46eae70a9f761930ec248ee797a667992',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'a5235925fd40eb9ab1b30fdf759392a32a387336',
    id: 'range-test-20260619-1426',
    matching_hash: '4b14ab03890d0ebf578e01fc8be200d872878530',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'ac2679365c1b3b8eed71938d0cc23b8f2232dec6',
    id: 'range-test-20260619-1427',
    matching_hash: 'd518c370e4d7d7539877dc897a49702ce3ee69b9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'e8474d78d8d108bf4fa5bb97e034bb0a5a08b9d0',
    id: 'range-test-20260619-1428',
    matching_hash: '2a7c5e7531e0cec97412e97aea5e98606c12c488',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '3bd02198dcb684402103c4012f3d47e7ed14b2b6',
    id: 'range-test-20260619-1429',
    matching_hash: 'bc5ac39a29b8fab2cb7a6b1c4f7b88f28c43597e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '675d80e4466ee49450dfbf7ef2d5af6660414f24',
    id: 'range-test-20260619-1430',
    matching_hash: '2cd475caa57cbdc665708b7578a395f43360de86',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '5c01e8ae3ecd2e7b83f7287e4d1da82107153da3',
    id: 'range-test-20260619-1431',
    matching_hash: 'b75d72a0c3946e24193112422c90b645038952df',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '819e0b0a67bf850e4c8d26e39ccc6684e9597a11',
    id: 'range-test-20260619-1432',
    matching_hash: '710b3b104f908dd6c3db9be0d91c0c83aec181e3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'c2f4a58cd5c0f0b82bb7678ec9f17db1d5fc17fe',
    id: 'range-test-20260619-1433',
    matching_hash: 'abc886accf01fd323a5eea6b8c22576c2c07c591',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '8709211ea997efb6519730e03b1a3ee77c908e56',
    id: 'range-test-20260619-1434',
    matching_hash: '772d1788d7c403e55b09ff8488beac30bd468837',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '59bcd0819d0a436c257a6163d37ec5b91c84bac5',
    id: 'range-test-20260619-1435',
    matching_hash: '1be2f82f669bbb38ade373f403f349e5ba45308e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '4e928abb8137fb89093217f067b74e4c343d8fe8',
    id: 'range-test-20260619-1436',
    matching_hash: '38b22614bfce10d71af4772d88f4d123fbb353c8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'caa49f57b68dc58aac275bddcb564eb370dbc603',
    id: 'range-test-20260619-1437',
    matching_hash: '181bc28b22022a4d778c5e181084f2a95e33a582',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'a61c136c07affb9762915c776e6e84115fd35406',
    id: 'range-test-20260619-1438',
    matching_hash: 'e9ae9b9a4eb49ad3182f5c8787b58c36313fde6f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'b737547f69c47845d480ec50d761027e7f9c9ea4',
    id: 'range-test-20260619-1439',
    matching_hash: '453634378618017f78e8e167ad851743045f158b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '0912485cb62c93d63c7d594bd5d694bb1b36afc3',
    id: 'range-test-20260619-1440',
    matching_hash: '14fd10e72f1c16f07132d89c95c1bbb9393153e3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '4934b75547f9ad0e816474b256ae9ad2c8f760e7',
    id: 'range-test-20260619-1441',
    matching_hash: 'bd091bed31a0c9a146fea29a8e63c77a2e51861f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'be9fe7ed4ec2092bccc1b885230c0a0c059e5356',
    id: 'range-test-20260619-1442',
    matching_hash: '278b3b8adfcb1a4a5bf8897dcbff5f97cb09c06b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '2c560ec98ca50302483bf9fbc5ba581ed9f37561',
    id: 'range-test-20260619-1443',
    matching_hash: '2a153a0e9bd2259e4bab2099b7a1dcfd0dbd10b0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'f1636144138c3c0147667649dd1a55f04b4ce44f',
    id: 'range-test-20260619-1444',
    matching_hash: '7b8dfea10c8c7d386c2950eaa9be59900b9a234a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '4e0b8415e2e58b3edea6b37da50bb91345023055',
    id: 'range-test-20260619-1445',
    matching_hash: '8e9b23c676d53a10c313aa68c375861ac1feb7ff',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '4adf80ab93a8b3e6290b2de262c811e1d265dddd',
    id: 'range-test-20260619-1446',
    matching_hash: 'df29f96452a151a0709db8f4f8ed1d252b40d009',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '5f474f92271f74308159e773e900c89ac8c0ac4e',
    id: 'range-test-20260619-1447',
    matching_hash: 'e7eb7d8ab043f0af3b671582cace1f1a2d2c1b91',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'd97557589df0d86e936fc79dd33999c0c44ff2f4',
    id: 'range-test-20260619-1448',
    matching_hash: '5cfb8b19eaa0c792d99d51608f1f860cc012e6e0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'a340a2f85af5dc029a19cfd858acf1705ac51a51',
    id: 'range-test-20260619-1449',
    matching_hash: 'e990fe383e81796039e12d386887879ea450511b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '98c5b98d539e7e030fe8b1e4376d5d1fda66369b',
    id: 'range-test-20260619-1450',
    matching_hash: 'b86f1ef689296e97436329e83d6ed5c3b5161043',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '49881fe6dc36e10934405a78a74f316d5453da8c',
    id: 'range-test-20260619-1451',
    matching_hash: '70aaa42463075a6fac5963fbce41dc752c779fac',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'f0ac4b0d3158d91e778ea6f9b3c91c6b7bf3a7c4',
    id: 'range-test-20260619-1452',
    matching_hash: '7571c319dd2ba9898b015a5b0f2d933d01bb0df9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '12ad902a58f9447d711eeddf3155a43d0ac5198c',
    id: 'range-test-20260619-1453',
    matching_hash: '3ee69afbbc38eedd84dc099d2f38372fa558dc23',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'bf1d5792217c8cb19ad070ee80394fd4edca22a5',
    id: 'range-test-20260619-1454',
    matching_hash: 'ad57489fe911e3e483132c96cb03a1898ced2e7d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '687aedf8c549e5b2d4a2685b6b3139ada2fcb7fe',
    id: 'range-test-20260619-1455',
    matching_hash: '775364e79c02b1c81bc0f0498f6bd6aae3d81813',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '5aaad59bdb360ea72a97a3b845d08c103e152713',
    id: 'range-test-20260619-1456',
    matching_hash: '3579071d10ec9207790347cc622797f0b3d04250',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '47cfd663ef2dd375c4d3eb65d32d5d3c85a2857f',
    id: 'range-test-20260619-1457',
    matching_hash: 'f4764ab51b5618a954caad73b8c6eff18a3da73d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '4ab99cb54c36044ca2006b0346a2d9c91494a9de',
    id: 'range-test-20260619-1458',
    matching_hash: '97c8e3027dc25adbc35004dcfa3935368dc75039',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'a61f628168cd27ee3e6a2b5e3eef4b6ebdb88e04',
    id: 'range-test-20260619-1459',
    matching_hash: '0b6352f6440f2a75431b142bf1f72dfb1dea957b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'ea31050484ed637aab3895bcc43b18f74eba4a02',
    id: 'range-test-20260619-1460',
    matching_hash: 'a74d5f2799011910ea6fa8a54e7b9662dbcb5818',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '8f7d55a07a62deadee7e29ed8b9d6dcfbd625a29',
    id: 'range-test-20260619-1461',
    matching_hash: '3e160a46ef04f32132228bd445075185027d432c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '81677ef885a93d2796475c48dbc98e9e5168df65',
    id: 'range-test-20260619-1462',
    matching_hash: 'ca5c9f870c403ef8608d5ee045f03c4bc8c3405f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '04efe7a9c3e34f01e8f79369ff8973f7a8fe4af0',
    id: 'range-test-20260619-1463',
    matching_hash: 'e9e8070c2ca6fedbfa2f8228bcd022c8f729a189',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '6287c2beab0d775cb9263b3d6d89e233dcfa4a22',
    id: 'range-test-20260619-1464',
    matching_hash: '7c4ca3a8d1e9b9e33c900ed2789a2b23dd3db185',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'f2aa12e086a12b649b0b399cc176e25e160b8260',
    id: 'range-test-20260619-1465',
    matching_hash: '4e2d7c43ec41a71f2844824d4df5820b21ba6017',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '1d576b36132c9dd0caf6eeb0a4bd7f8633449c28',
    id: 'range-test-20260619-1466',
    matching_hash: '07007744c4f219dc112b885dcc73a046ad6dcdb0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'a8ca2f97851bff5df49cdfa8d93c66b0e4b82f6b',
    id: 'range-test-20260619-1467',
    matching_hash: 'c2d83b1d4c70137df9d841d9d2ba5097f8a72453',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '03c2a8a10b2a27668329e48af3c98b9d0274340b',
    id: 'range-test-20260619-1468',
    matching_hash: 'a836a1687d2af5db3017ad712e29d2ffc1d2a7ba',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'baa3f236a41c93728b46653273ec1b15b27d3168',
    id: 'range-test-20260619-1469',
    matching_hash: '527108ec47f2b5aafbbb5562a94b84b555d17c58',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'c0934b9c93cfe380b5b9a3c5880fc890de46c983',
    id: 'range-test-20260619-1470',
    matching_hash: 'd0a6e7e3e387bd81a03c563f193787f40794359d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '4c350a7c84ae13678b5411f062c39387e80616d5',
    id: 'range-test-20260619-1471',
    matching_hash: 'a7f331076306956ad1a1c025787fcaa4e575d834',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '3eb58282a1df4593c377fd81d67849cf4dfbbd2e',
    id: 'range-test-20260619-1472',
    matching_hash: '82c32a0b19ff97a30d7dae9437e16d3300fa3a09',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '73a0b0686d43d7b4f2d2aa26bd2a2a374f25aeaa',
    id: 'range-test-20260619-1473',
    matching_hash: '2d76fc1a6d2f9b54721727dbfc67f533660e66d4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '0522ba99f121294b35320e330dbd668232bd6f67',
    id: 'range-test-20260619-1474',
    matching_hash: '93aa20768a9f93b65e09c0d38dda7ca96ade195d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'f314ceb826a79995c1d21aa54581770eeeb5a1e8',
    id: 'range-test-20260619-1475',
    matching_hash: 'bdf7e4d1c7a26a38a4dfdaa8d43ca2a75dfa1fe1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '136d0e705a8492ea5733025dc4f1a3a482119a0b',
    id: 'range-test-20260619-1476',
    matching_hash: '9d0bfc5ee7e503ff38ad6f898255d13ab52de6af',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '7062ca46aa4a8878e3089ef714a7c211ca4480fa',
    id: 'range-test-20260619-1477',
    matching_hash: '6f145b62ba6aba1648468a9e0c5a8aadc343aae7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '9236b5f162cc1bea2fb95c4b060ac23027971ff8',
    id: 'range-test-20260619-1478',
    matching_hash: '6a320be9b11da9c9f0f74b28956338c2e6671739',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '45e3a312b1a9ef4b32d7229211bad34e41dd6ec1',
    id: 'range-test-20260619-1479',
    matching_hash: '8df4e29e6dc3b79c1ba48b61e639ae887112db7a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '7ddb62525db23746113e314849c5f2bf0553b546',
    id: 'range-test-20260619-1480',
    matching_hash: '5a6fd03552568c886052a43aa3fdf3a55d1daa0b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '31761308848c5f5ee3b71047498fd83ef0ad6301',
    id: 'range-test-20260619-1481',
    matching_hash: 'd0e2973bea4e682b36bb669bef490e2ca0c002ee',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '5bc3cdc1803ac376b6bfb313fe9d029d2a5afd73',
    id: 'range-test-20260619-1482',
    matching_hash: 'cbaa0ed6b186682af77b3844c689d04bdb494a0e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'd87d905bea0b830bb58bf6c00e419a6881e998dc',
    id: 'range-test-20260619-1483',
    matching_hash: '8d216aac62eb1aa14d6ff95fa32d013bd0379fe7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'b18bdb5bdfba78f791c2e615b3539004b14a08f1',
    id: 'range-test-20260619-1484',
    matching_hash: '94da59b34a0a3bb56a500bd3f84da1529ca82e05',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'db48e5867e127e4407ee01a22aada2edfe3d9f09',
    id: 'range-test-20260619-1485',
    matching_hash: 'cda0b7587bf246a2c55af86648b62b2a71903bc5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '73f1a88cf19e2f572c6893267a31863c90e738be',
    id: 'range-test-20260619-1486',
    matching_hash: '731769eb59e339682a5a146178eeff9f6c6594a5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '75007ee97ad8edfbe006db4e9aac8665930b4457',
    id: 'range-test-20260619-1487',
    matching_hash: 'a29a05548f1d44743c0e271bef47de3916ff2e7b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'c3d112d14959d09bb5bd7a29ec64f2fbf9ca2acc',
    id: 'range-test-20260619-1488',
    matching_hash: '4f5c6d77a656eb085db09ec242c05c9719bc77f1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'ebdd95a9eadd1df46dd0da1810eb54ae54122984',
    id: 'range-test-20260619-1489',
    matching_hash: '2a19544b3503bacf7eed017fa93ba3a10f77a412',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'd530bb54b9064c1ada23fbab97f63aa682632317',
    id: 'range-test-20260619-1490',
    matching_hash: '4f0aa4268ada007860519d64825126e5d29240e0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '4fda49d1ea14c46ab77e99e9d63dcc7d567b0cf1',
    id: 'range-test-20260619-1491',
    matching_hash: 'bba63c740ab0ab48fccc92083e6ce2c53dba1408',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'f84d1736a26255e17a333cd67c5dfb0fb94b205b',
    id: 'range-test-20260619-1492',
    matching_hash: '699a475597e3d6668983c9054b4e404dac813354',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '09a19790e2faab37ca1ac8517b6e803b4f27923c',
    id: 'range-test-20260619-1493',
    matching_hash: 'bca1ea04075dd85eb1a05619310470088d65a0bc',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'da057809f33407feebbdff04c2f80824137e3782',
    id: 'range-test-20260619-1494',
    matching_hash: 'f1896f7be56dc9aa988ff1b93ea89702cd783523',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '503ea75f6b2887d662fde140514e36dce4065ef9',
    id: 'range-test-20260619-1495',
    matching_hash: '69802c30b1c3252830ede07f5bd57b74995c2f40',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '3e007b17af9809b6b47a3e4721e807f64a3e4c7d',
    id: 'range-test-20260619-1496',
    matching_hash: '9a59f2ea8b2286bf6af192e0addd0c4e30ef172b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'ac66e85a9ef7547623543802574386aa94d6462d',
    id: 'range-test-20260619-1497',
    matching_hash: 'caa522a6ce775405bb714bb85a287cd8ce737eef',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '84c633b508334a86f3ba026916a160514d69169c',
    id: 'range-test-20260619-1498',
    matching_hash: '0dda2b933c629f80237a97b5f1a5ad62e129206b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'c83b72a07c85f85c469a197d6f124f534ace209d',
    id: 'range-test-20260619-1499',
    matching_hash: '9d1fd90b6f002b3265f7120667bcfd6016f151ac',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '8e1ec15b33c6bd7bb4c319821d3aa88bccaa88b7',
    id: 'range-test-20260619-1500',
    matching_hash: 'b32bef996f70731dd5bfc35b466ce402b3f2525f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'db42bfe0e1c80abeb249fa62a7440f4a2c64a126',
    id: 'range-test-20260619-1501',
    matching_hash: '6798bc2585f9e4eec57a52aa9c8577a4726bcb8f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '35bc613a26284f5e799800be843136e34cf63409',
    id: 'range-test-20260619-1502',
    matching_hash: '7bddc6010e9c8faeb7e5135174b2f83ebadfb8eb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '7356895e732958a4633f216e61c840834ee9f599',
    id: 'range-test-20260619-1503',
    matching_hash: 'cf839046dc62e166af89ad335cb39febca8bd69a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'a61ddde5df51fa516ce1da09bd82a14338d8d23b',
    id: 'range-test-20260619-1504',
    matching_hash: '7d44ce868738e540fb6e1f2063ef5f2924058232',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '5f4e8108dc0cdb22e5bb2f62036e53a3a71de1a9',
    id: 'range-test-20260619-1505',
    matching_hash: '348c9827b86aac9cf09e484d859675869f904b28',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '6bc96a68e9ea3fc1aba5a837a10a4da740f883fc',
    id: 'range-test-20260619-1506',
    matching_hash: '5945b77ff9c3dd7c95e5511c4063dc08e74a26de',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'f927113232f8fe80e86e39e7d31e11f296865883',
    id: 'range-test-20260619-1507',
    matching_hash: '92f45f46f64882a35b7f7ac8205669f9d8cda85b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'f90f4b73442ad28e14a1faf739c5615b30881a8f',
    id: 'range-test-20260619-1508',
    matching_hash: '58cecb96ede9864d6f9cbe62ae820010a5b24e2c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'afa5e2b8fc3c5923894d8141f7531903cd51ed20',
    id: 'range-test-20260619-1509',
    matching_hash: '8c20552380a4e516362a6cf3146870714460bdf5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '0936d44240097737cf3f8a063103902bdc024666',
    id: 'range-test-20260619-1510',
    matching_hash: '46bd3ab01db316f0f19ef9a4eeb1ff3ddd301faa',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'e7022097c4ab9fc54dfa15204b390c9df87a36ba',
    id: 'range-test-20260619-1511',
    matching_hash: '0a111ff40daa394ba83e77bcf2afd9235053ae37',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '3c8451b31e665b83a552db4b33ff8316aa36b0f3',
    id: 'range-test-20260619-1512',
    matching_hash: 'be8e057e461df71ced3495bb36cfdf9adaf5ffaa',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '3925a39532e0d05ccb93e61a9b5b7c634c9caf2a',
    id: 'range-test-20260619-1513',
    matching_hash: 'c850f30c0d32a54c8df139fc65122ff373755f1f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '9b9abf7dfb8feb339b78edeb223ac12181bdcd58',
    id: 'range-test-20260619-1514',
    matching_hash: 'fe90d5ae3f58e27a115ba730a794abe0ac27bb94',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.248354777,
    qx: -0.294146331,
    qy: 0.914193715,
    qz: 0.126679487,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '8ff1672781e025cf11bab16ce40187ad0790f99c',
    id: 'range-test-20260619-1515',
    matching_hash: '195d6a78534dd2091ebac6f846f3b65d775558a3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '6429e8e755e1f77257699b475b545485dd57e799',
    id: 'range-test-20260619-1516',
    matching_hash: '225f64adaf65cc1ca7c85c6842daeb3a4a0716a3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '12fd551d0c8bca5632acd0fb7a58442fffcc3d40',
    id: 'range-test-20260619-1517',
    matching_hash: 'd8c1ed41bafcc71dbf56f09d17322d7490f11ce8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '8c845b3eb04f6e3cc5283634b0892f7d433efe0b',
    id: 'range-test-20260619-1518',
    matching_hash: 'f8b2ad51de9be659b54b0f021f371935ed77444e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '0eaf0db5e1e622728a6a0dc03c862a2c3dedff2b',
    id: 'range-test-20260619-1519',
    matching_hash: '2bca0d53464eba4bd9dafc27a78ad12ea97ba2c8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '256febc2812f095186e72f474f9fc7ef0dfaf84a',
    id: 'range-test-20260619-1520',
    matching_hash: '0b20c384f611fb565c68bf886da4463c9aeaab1a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'fb3f6a0075d665f9eaf1adb083b800466dfe62cf',
    id: 'range-test-20260619-1521',
    matching_hash: '70b23ed6b10b0088816050105e5920144ca72d40',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '189bb8fe3a46d7e7709e95962012dc7fbe3a19c4',
    id: 'range-test-20260619-1522',
    matching_hash: '27fe168f37fddf847e9cbba747267330e225771e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'bcaa21461ed5efdb76b9a2a0905f22cf68394cb6',
    id: 'range-test-20260619-1523',
    matching_hash: 'c2d4b4fcb470d2bb7f279f2a29b962ce84e7bd2f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '08e48f96a4157a68a40b15818d70cb575bb09b87',
    id: 'range-test-20260619-1524',
    matching_hash: 'f5199a2f18823724b3c86f181ba5a5c6a22ee3ad',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'ce58d1bad91b6b8e4fc94376f86481afd58e114f',
    id: 'range-test-20260619-1525',
    matching_hash: '7c051ef8b060729759507a6b4ca40b8e4e4e1636',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '1e6fa56592ef186af0fdffb06c60aeb4e530b492',
    id: 'range-test-20260619-1526',
    matching_hash: '768f5295dfd2b93f883ad5557e24c61ebedbeae7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'a2a36d28cf75cd0b10334470df9a37d26fdb6f09',
    id: 'range-test-20260619-1527',
    matching_hash: '15f297b85642f8b19c3c13443033937ba06f5f4f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '49a2dca12bf69b264f589b5c7b2f8ad5ce0b8374',
    id: 'range-test-20260619-1528',
    matching_hash: 'ef9b974afb2585eb05b17e4166ce851fd79bf4c3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'b4cf9b4d6c951f5f4145657f9e4a7be1d5f8c1c3',
    id: 'range-test-20260619-1529',
    matching_hash: '574886712a343b312dd92043af0e3de6db5fbd12',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'b59c207497be6623907ec2a4d10f3cf2b417c722',
    id: 'range-test-20260619-1530',
    matching_hash: 'd082171e528da088745c4d71b86cfaea109d5457',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '2d512fce812dd5bc14bf31c12fa146b8f053521e',
    id: 'range-test-20260619-1531',
    matching_hash: '39bd211a1d9e5bcb6e9925d830b44cefdfde3e28',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '3b6e2a91286c7a961d3d08c3623cd3c3e4e943e3',
    id: 'range-test-20260619-1532',
    matching_hash: '15c2db7cb82fb4a4c5629c60dc11f1d072ca32d6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '04bc098ea39c3f4493b9f3496108c7acc2f93bdc',
    id: 'range-test-20260619-1533',
    matching_hash: '1456024b5b3171b68d8a3e0b80e5b9d04a243325',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '75e0038e1e3a855d5abadaf93d718c8a6198a3ff',
    id: 'range-test-20260619-1534',
    matching_hash: 'aa75163b8a1177d3ce1fa23d1b029339e31da392',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'a51fcf3fb528a4f1dd0e50ffb3a02c630b2e332b',
    id: 'range-test-20260619-1535',
    matching_hash: '712e124d309e59284b5bda1142a972cdac5d7b08',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'c273f545a9e1c857273d7bb6f04328faab5511e2',
    id: 'range-test-20260619-1536',
    matching_hash: 'f18bd232f056d58ab04a24452b3f5dc1bb6cb57c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '375b63b1a3671043695214e5a13fc5c879299242',
    id: 'range-test-20260619-1537',
    matching_hash: '078beaefa7d7ca09ed3b8b9c4000963cae9b83c0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '4e00b33c373d2174497e6a9603b6f6734c4859e2',
    id: 'range-test-20260619-1538',
    matching_hash: '9670781cc9462a950fb4c234c318608336ec5ee8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '57420b767e82c51be000c216559ceb1c162f0cb8',
    id: 'range-test-20260619-1539',
    matching_hash: '6ee9ea1ad83ae1d23c8438057040cc72d18a9acd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '71d1160505d1d1cc983027152b6d256714553b34',
    id: 'range-test-20260619-1540',
    matching_hash: '61eace0a1fdd09353c0f1491c9c693b1f6ca7107',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '7c6df883d37c54a7df482b96bc8839a3ef3e370f',
    id: 'range-test-20260619-1541',
    matching_hash: '9f7a4f340d5f6cd1aa155d4f19c19e6583455301',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '49d48acd4a26093327e48d76a91b7c6965aedb1d',
    id: 'range-test-20260619-1542',
    matching_hash: '7ad13e896f2430e9614aeb3f6b07002f8c882847',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '130bd6c6b831d984d7a1305f609866131716b1dc',
    id: 'range-test-20260619-1543',
    matching_hash: 'c5a04c5c70101312adcc83dcab031c1d8c163895',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'fcef4c78610b0288b2b9d8982ad2041c135dfb96',
    id: 'range-test-20260619-1544',
    matching_hash: 'c830e5ba1292649630030e402ab950ae0a4039c5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'b6dbd98bc3efc0d59eb4d14db0c84489e2d85f5e',
    id: 'range-test-20260619-1545',
    matching_hash: 'bdd0788d62e267c554df391404a1de9ca7da52bc',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '4852211f397999c75e287639926b1726fb4e3663',
    id: 'range-test-20260619-1546',
    matching_hash: '5ee5e120c63c17ae7edf256bfcf9846f9cd5f7f7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'f5a699cd7fbcd65cdf612fd16c050e920b54ce32',
    id: 'range-test-20260619-1547',
    matching_hash: 'd91b04b53c6db220ae6bbd86369d70d1d3581268',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'c154513856d167c6f4d1b83c2797d09e7d9636fb',
    id: 'range-test-20260619-1548',
    matching_hash: 'ea47f37f4e2488d6a0272a9130b0b868638082a4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '9ddd5891da25535277446d01290f5faad85d4b8a',
    id: 'range-test-20260619-1549',
    matching_hash: 'bce4ffa0a35f98c48b03859e165f9e972ff14df5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '7bff59143b84072fcc24575c21bb91332ded5336',
    id: 'range-test-20260619-1550',
    matching_hash: 'e3dc5f1a2b3d89300ca395f85ca168be6efff4f6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '36445a56035f474cf6c9ec97d15064d8b001b2fd',
    id: 'range-test-20260619-1551',
    matching_hash: 'a23175f807895abef1203b4de217e0cadebfb9a6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'fd42b31588688292a4f1a234e0cf52ebee40df66',
    id: 'range-test-20260619-1552',
    matching_hash: '70f5901180ec9c737f1b2e6ed63b9d9341de75cd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'e80962eb801ed8b344d0451e9b65a1a51aa9cb69',
    id: 'range-test-20260619-1553',
    matching_hash: '7d5a4d970c6139330da9dece6ac26ee2f2be4d80',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '1e5801838f544f9073105235d9ca7cd28a9c1e21',
    id: 'range-test-20260619-1554',
    matching_hash: 'ed29f77ffda0a87ba1015c5a3f3553e877ec8954',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'd4f0a8852f3f06e71ecf9031bdb0c85f42cfdc64',
    id: 'range-test-20260619-1555',
    matching_hash: 'f60c6bd0de077af5a9a55c00966e0789f7bb4199',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '7d8bca734d3a89d2a02883e311473e86c54806c2',
    id: 'range-test-20260619-1556',
    matching_hash: '1b91f37d132e2e1a323c3f259bdbd3690ebde341',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '0bc8178643cb83b5f7474de591f35cf0a005d0dd',
    id: 'range-test-20260619-1557',
    matching_hash: 'bb2990969a3dddb79b5bdfe54f20c76c94d7d1fb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '657e6f21018f782ef628450c4c9b065280a3242d',
    id: 'range-test-20260619-1558',
    matching_hash: 'f56925eff408198748c9d4a3cd7a628e0d502db8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'a586ed1787f7446419afe683c65a84879cb9cf14',
    id: 'range-test-20260619-1559',
    matching_hash: '6310f2b1d021948edefbde1fb8352c5156b2cda0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '1b96b2facd6c3d4b4990464a514d866679405dd1',
    id: 'range-test-20260619-1560',
    matching_hash: '790f27b76cbd6fa93b0f8f34637fc5ee28055e65',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '004da7df2f676fe6e386f258fbe43f3fb3b5a16b',
    id: 'range-test-20260619-1561',
    matching_hash: 'c866d6deaddb22b867c582940d603bdcb61eba64',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'd39d77ba9b331daedf40496f6a0ce3a0a6909bfc',
    id: 'range-test-20260619-1562',
    matching_hash: '96e9a6b042600d06f127e98d39a78e83e2c9de78',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '7e7eba3913c237b905fec980b314930308807c6b',
    id: 'range-test-20260619-1563',
    matching_hash: '99fbd79d0807ef5cbc3284e60ca4144ae9a8e2b6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'cc5e8b2ee8a18107f2f1a03f2b721790447da27c',
    id: 'range-test-20260619-1564',
    matching_hash: 'be251f8df6e258493a263c24886c1b82c69a9d7d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'ba5302c5569c33c5470c83823996d2703dc18698',
    id: 'range-test-20260619-1565',
    matching_hash: '404a4efde6b0c481a9a4a0860fe341157bfad95d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'e568578995f0c8f3670952481e61b9d261b9b5fb',
    id: 'range-test-20260619-1566',
    matching_hash: '5f4b93a2b9e048a1c502ac56e2a97d9af73ce413',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '483d4c12c905558856f252fa8e5a61995bcd5159',
    id: 'range-test-20260619-1567',
    matching_hash: '5fada91bc0acc8e18c79a0447f3a70f9d4575e78',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'b8776d6afd1c7d10801fcb789907f0ac2d0e47fc',
    id: 'range-test-20260619-1568',
    matching_hash: '96e057df9fdc77e86f3d497a1dad17333790d647',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'ff6b1f9380f2f05b50c6f3023a0c2db64f75be9a',
    id: 'range-test-20260619-1569',
    matching_hash: '969db4d451d0d0a7fbfa729d359bbb160acda05e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '731effc960c846ec800fdc395cae0abece351d97',
    id: 'range-test-20260619-1570',
    matching_hash: 'a0deab670880ac939396ceadfb18244713571933',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '528aca85d3eb056bb25ce47d1abab52deee2e1e0',
    id: 'range-test-20260619-1571',
    matching_hash: '3a405cf717ef6f2105aed06830b2e5148c93d594',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'a0f16e09ce4eefecc891653e3744b3b7f79c76dc',
    id: 'range-test-20260619-1572',
    matching_hash: 'ecdeb57955a5bdcf31e04c72a1b9af912f497969',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'a25b37eaa0335409e205f78240b57e63740d4447',
    id: 'range-test-20260619-1573',
    matching_hash: 'aa86ea7e8c08f92e8231f73a8e7d1d21e172a5fa',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'b659e5edb7e01a6dfe1cb5e13eb84836078ac2a0',
    id: 'range-test-20260619-1574',
    matching_hash: '976226b1e9436fbfca640e5bbf8e9afd219c368c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'aa0bcaa272d4f92b50326bca1e181f7df028c2b2',
    id: 'range-test-20260619-1575',
    matching_hash: '469ccd6a89756b46f0f3b38b48280f0529b09bbe',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '641cfd15fe84105805e7dca373fa7e316f0565b2',
    id: 'range-test-20260619-1576',
    matching_hash: 'd62bd16a57facb32e464bd0ce2eeb80abcba80a1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '7c4f5d9cbf654d630f75c71c5bd852d685e75822',
    id: 'range-test-20260619-1577',
    matching_hash: '42f67b93e987d942cef2827b512092d7e7340f44',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '96d2490a4c5b75c83f478ab5b3fe576339f431e1',
    id: 'range-test-20260619-1578',
    matching_hash: '352487b368a36e00113aa01d51cef53ea797e453',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '65d7033086c10dc6acfb584113c6cc86b82e14bd',
    id: 'range-test-20260619-1579',
    matching_hash: 'e1755ace6a154840e04a753e14eed49e48ddfb72',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'cdb7114b708f7c9daf8556ff5fc702f36121059a',
    id: 'range-test-20260619-1580',
    matching_hash: 'ab521a3c33bea0614c3baa88498ebae6694e32df',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'e82defbe75d44085edb7188fe4dfac54e010a7c1',
    id: 'range-test-20260619-1581',
    matching_hash: '94cad7dace490613a92d524ed5b83481d00d8dff',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '8b782849e4a285d14cec9102822f6c05d0df66ea',
    id: 'range-test-20260619-1582',
    matching_hash: '6849838107d1f55f7ad2cb8fa780a352afea8ef5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '64892259a0f94c56b2ae65ca2233bd9e43f7fcfe',
    id: 'range-test-20260619-1583',
    matching_hash: 'e0f8da26a0a4b27224aa7f298f003e3e0f80560f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '8f4dfb2d8fac242bcd782408abbe2fc126096133',
    id: 'range-test-20260619-1584',
    matching_hash: 'c04e7b92cc80f618dbae7e1adc0f8d95de49726f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'bd6378909f860732e39b3bf307478654e4496d80',
    id: 'range-test-20260619-1585',
    matching_hash: '195d6a78534dd2091ebac6f846f3b65d775558a3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'dea58f4a742824c1471f197498f8bab36e9de15c',
    id: 'range-test-20260619-1586',
    matching_hash: '225f64adaf65cc1ca7c85c6842daeb3a4a0716a3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'f5bf1e7b1cfc890e9674e5dad8c954b6afea04d8',
    id: 'range-test-20260619-1587',
    matching_hash: 'd8c1ed41bafcc71dbf56f09d17322d7490f11ce8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '9f69700c6d760b83bcbbe63cda6c60db2959629d',
    id: 'range-test-20260619-1588',
    matching_hash: 'f8b2ad51de9be659b54b0f021f371935ed77444e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '169fe9720331b38141bd65c6a092e9c3263fb4bd',
    id: 'range-test-20260619-1589',
    matching_hash: '2bca0d53464eba4bd9dafc27a78ad12ea97ba2c8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '625f802f97038699ac352eee2ec0da9a8f89a8ee',
    id: 'range-test-20260619-1590',
    matching_hash: '0b20c384f611fb565c68bf886da4463c9aeaab1a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'c52e05ea2be9fa9c1151ac1568c74cd73ba019b0',
    id: 'range-test-20260619-1591',
    matching_hash: '70b23ed6b10b0088816050105e5920144ca72d40',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '8bc691e0c35b64f351e2c760113c657316e4157f',
    id: 'range-test-20260619-1592',
    matching_hash: '27fe168f37fddf847e9cbba747267330e225771e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'a392284a60b6eca9f6b5901eb27cd3ed4d71a15f',
    id: 'range-test-20260619-1593',
    matching_hash: 'c2d4b4fcb470d2bb7f279f2a29b962ce84e7bd2f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '1099a0c1de35270e96f82bd3f33469d50b92e5c6',
    id: 'range-test-20260619-1594',
    matching_hash: 'f5199a2f18823724b3c86f181ba5a5c6a22ee3ad',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '9656a0cffbce2d9dabf3a448153720a23d531b16',
    id: 'range-test-20260619-1595',
    matching_hash: '7c051ef8b060729759507a6b4ca40b8e4e4e1636',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'c731b1be3cc6591a839d45178dbc7defb4f7278a',
    id: 'range-test-20260619-1596',
    matching_hash: '768f5295dfd2b93f883ad5557e24c61ebedbeae7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'ae2b07c5d456c3cb4bbed8fff840284f8b8dbba7',
    id: 'range-test-20260619-1597',
    matching_hash: '15f297b85642f8b19c3c13443033937ba06f5f4f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'a8eb600981657513aad9639a59a7a9278a373309',
    id: 'range-test-20260619-1598',
    matching_hash: 'ef9b974afb2585eb05b17e4166ce851fd79bf4c3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'd6bc5cd00c082f2b37e4f4b81d0fd8ce3951843c',
    id: 'range-test-20260619-1599',
    matching_hash: '574886712a343b312dd92043af0e3de6db5fbd12',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '9ff64ba7125e1f71b3ac4ccaddcea6a4c86c5545',
    id: 'range-test-20260619-1600',
    matching_hash: 'd082171e528da088745c4d71b86cfaea109d5457',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '6cacaf4acb5ee3fa8a5a257fea4171c261031de4',
    id: 'range-test-20260619-1601',
    matching_hash: '39bd211a1d9e5bcb6e9925d830b44cefdfde3e28',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '0527ab96039fb5a6a5707389c621bf150e74f2a3',
    id: 'range-test-20260619-1602',
    matching_hash: '15c2db7cb82fb4a4c5629c60dc11f1d072ca32d6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '265fa90f5daba167ab95702a1d44404e85d3643d',
    id: 'range-test-20260619-1603',
    matching_hash: '1456024b5b3171b68d8a3e0b80e5b9d04a243325',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '5d3a8e498dbdc0d46bdc09dc0b7d17249a752e02',
    id: 'range-test-20260619-1604',
    matching_hash: 'aa75163b8a1177d3ce1fa23d1b029339e31da392',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '8c7388a2d078f96802b85319107d75173f1f1a34',
    id: 'range-test-20260619-1605',
    matching_hash: '712e124d309e59284b5bda1142a972cdac5d7b08',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'd4806f726be92b89fb43e888f2013295f97dadc1',
    id: 'range-test-20260619-1606',
    matching_hash: 'f18bd232f056d58ab04a24452b3f5dc1bb6cb57c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '51b0f9e570dd8b3e7b1e70839555fa09b4dbe129',
    id: 'range-test-20260619-1607',
    matching_hash: '078beaefa7d7ca09ed3b8b9c4000963cae9b83c0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '37ae178ec9f1ad0e0e85ba8fcfda072fc9994c4a',
    id: 'range-test-20260619-1608',
    matching_hash: '9670781cc9462a950fb4c234c318608336ec5ee8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '8ecda8d095d2abb074559c5086b830daef742bc9',
    id: 'range-test-20260619-1609',
    matching_hash: '6ee9ea1ad83ae1d23c8438057040cc72d18a9acd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '8160a5ad29957ee1fabc2cade58a754f9fbfbdb1',
    id: 'range-test-20260619-1610',
    matching_hash: '8b7ae2c99286721f98cbc9e62de78e075eca0512',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '772a34a08441c2910ae576c6f7348643064f159e',
    id: 'range-test-20260619-1611',
    matching_hash: '10806b9f3ffb48d0631de89a07c8ba66ae1df71f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'fdcbbf5df8f5740e3750ed89890cdb24b7fcbddf',
    id: 'range-test-20260619-1612',
    matching_hash: '3012a376ee9b0951f3622d6d759cf257367e332b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '2cebd29a12b9e908e96e4859001364b602226dac',
    id: 'range-test-20260619-1613',
    matching_hash: '1ea0f7796e394dde6e90e90ee09bc137781187a8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'ce36437fe9c4d260d5de323503111687401ac379',
    id: 'range-test-20260619-1614',
    matching_hash: 'c1a5e8142e8359cac68b57e8b2c8f651c52234a6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'b27769519898975e93b84283c240558a023e8717',
    id: 'range-test-20260619-1615',
    matching_hash: '44abae6027cc9ecfc31ae50469b154fde628559c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.617379702,
    qx: -0.058490601,
    qy: -0.567775839,
    qz: -0.541342545,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '6bbc9151e6dc0a8b554b6b67b9c0d9e6082903d6',
    id: 'range-test-20260619-1616',
    matching_hash: 'c3d2ef2fe524b3f777c725392e088772ac76be36',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '3dda0342bc6d07e66b2391606512570d4880ed2f',
    id: 'range-test-20260619-1617',
    matching_hash: '0755d4b5da61d0c07961332f5be848666e3c8bfb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '4731099cbd69b1ec0815cfd80d171fe13499df51',
    id: 'range-test-20260619-1618',
    matching_hash: '60439ba105f7ee5bc6570a3a219e41644c15e41a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '8f9670fc070773a45532b331e31b298502c0b9cd',
    id: 'range-test-20260619-1619',
    matching_hash: '11569c51e2a473070188097609bc4a73f2ed355d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '8138c4b680235d84aead799e3e26adb568147104',
    id: 'range-test-20260619-1620',
    matching_hash: '39790bde34cf5a07ed7f49aed880d96d4f302a27',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'e880257a88cb5a449594487706a6760181cbd2e8',
    id: 'range-test-20260619-1621',
    matching_hash: '8b8d204cf7af6dd39b9569f032172c1d155d728b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'cb3a301ee6977e2ab4215ed269e92a634ed35c00',
    id: 'range-test-20260619-1622',
    matching_hash: 'cf628a02d72c785f800b99cc33de9c1cf0b243aa',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '0a2d730196063793c129fb02929566b30b5c8c6d',
    id: 'range-test-20260619-1623',
    matching_hash: '54c90314e2f03ef6211beb971d491d5493f5deb1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '0232f8a65ddfc1b34681b462eb2e6bb7cfdd7627',
    id: 'range-test-20260619-1624',
    matching_hash: 'e1d1bf04782f76b5ecc8ac286a0f358adfd44c3d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '3b04060674673050c6af3730b08bee30a92f02f2',
    id: 'range-test-20260619-1625',
    matching_hash: '802f77e9ea2f24e3a51bcb385ee4c75cba3dc95f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '4600464a796807c97e35c7c9ddeb012e1ea77421',
    id: 'range-test-20260619-1626',
    matching_hash: 'dd06ff34edbc7c1d88f7e1386882956496f22bbf',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '680a829d6e40cd901ccbaa36590307cc216d6ddb',
    id: 'range-test-20260619-1627',
    matching_hash: '61dec512762c2ef369ef7b4fd8c116a5aaec28dc',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '06430516c6aded59c70c52344574616e63376b3f',
    id: 'range-test-20260619-1628',
    matching_hash: '99bc75136a07c572aaf2ed0fbd0e54b3db74ba9c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'ba0723c78221416b07edc10cecf88024ce3a69fd',
    id: 'range-test-20260619-1629',
    matching_hash: '1eee5498931ce6c0a04f77bc454623cb32970e9a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '92919f07136f26881d22e04fe5ded33fd9f841ca',
    id: 'range-test-20260619-1630',
    matching_hash: '10663ebcd31dd693f6f95e00b252fcc5e74c6e4f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'b8e26f65a09767aab936b1db312b7e4cd8f6947c',
    id: 'range-test-20260619-1631',
    matching_hash: '312c8b58aa5ba9b059f201eb8de527ef3a9c45dd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '44aa455af2cc3bff1270d1c676f691a408015b3a',
    id: 'range-test-20260619-1632',
    matching_hash: 'fc3eb7e58cf0a932e9c33d4c0e7026ec5d716faa',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'f53424ebd589b01420bf936b484f77361168bf3e',
    id: 'range-test-20260619-1633',
    matching_hash: 'bfb454e08354af907de155baa55524e1fe4a01c6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'dda4359f43238ccaf965b1ea6688f1295f9a057a',
    id: 'range-test-20260619-1634',
    matching_hash: 'b45a36f4159ef958098182f10d5ed231e62583bb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '8f85ddd4ade3faa2870aa552c0058595de75a89a',
    id: 'range-test-20260619-1635',
    matching_hash: '85dfd82d8327864ab2fe1a7056ede845a9a8b520',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '928f374ed8497591bb4b99c0c05b1608ecda237e',
    id: 'range-test-20260619-1636',
    matching_hash: '893e29236f06a937dc3f3ee7c33bb72d23deba3d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '6f62966c8e1aca85b03fb5909791aaada5e84431',
    id: 'range-test-20260619-1637',
    matching_hash: '298d53bc08238d6b9b8830b4c929bb44c40c086d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'd1fcb783049505a77fd1a8b9b1aa96b9a84ac4e0',
    id: 'range-test-20260619-1638',
    matching_hash: 'd0dc20340497fc6624dede0c13eaba1ecfb41e2d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '5cad14e20b6c223943057c65cc3658ad7caeaedb',
    id: 'range-test-20260619-1639',
    matching_hash: '96538977ba083783f746b84699b693f99b54a6fb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '85b3615d773586adaa847e6660c9ae3b4d68e753',
    id: 'range-test-20260619-1640',
    matching_hash: '3239ef387bbdc69901f2dac989d32b0e408b14e5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'f49936b14c44340372cb5718a0d4895f6863a656',
    id: 'range-test-20260619-1641',
    matching_hash: '1dc19a2d6fc08a0aa955680d0b1643785166a346',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'aeff81493ad9ca4608f31123cd8586911057ad05',
    id: 'range-test-20260619-1642',
    matching_hash: 'ca771a6d9581af4bad36422c06611ecfb3cd44c2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '76edfd0d3d0503131791989d198ebcc6b937074d',
    id: 'range-test-20260619-1643',
    matching_hash: '0d64b0752913645189907968e40d7f55579a3b34',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'd7a7c8b7c66d278ee8551fa9d90b254f5c8c9697',
    id: 'range-test-20260619-1644',
    matching_hash: '672d9d351c4586a49c9f1aa6e21fa70459a35724',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'fb6dc1dcf7202d5c0d77322cfe7bc462201ed57d',
    id: 'range-test-20260619-1645',
    matching_hash: 'dfe93a9b1c499c8c743bceec2a6700e5a459997a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'ec90943e5862b7836d3ba54da4934104f23b522d',
    id: 'range-test-20260619-1646',
    matching_hash: '9d19d76fcfe38c83456ed6ff5bfe2fb2e1edcdfa',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '775ac0c65c8069e7c03a6457396b54f803dab1a5',
    id: 'range-test-20260619-1647',
    matching_hash: '409c032f79adfb31edb29b77f3b66a327b6aef0d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '27a89370404c768c37e9c72faaf740abb970d15f',
    id: 'range-test-20260619-1648',
    matching_hash: 'f4dad69a70d6f682664d8796bb05234f608b1466',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'c9f6f91ada2d665635559ad8ea7209e37bc7ccdb',
    id: 'range-test-20260619-1649',
    matching_hash: 'dd2286a44ba0a88c5d5154f9fc3014c56191bbf5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '1caa16023c2ea515dac84f9f9386e109a9b06e76',
    id: 'range-test-20260619-1650',
    matching_hash: 'd19796e809e539ba8aae29bc6233f51756cd43fc',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'eac4b927bf674f4741c8ca83567ec8eb668aa473',
    id: 'range-test-20260619-1651',
    matching_hash: '626567390e141c6146ce8dcad84b953bced7842e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '8b4d3cb6eef5260ed102f8712ee97ef23b32914c',
    id: 'range-test-20260619-1652',
    matching_hash: '2cd7a5daa6d1a0db01d1fa66831c4964d3658843',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '99674c1d73d9b2f9f598d4f1cb1a646e963aac20',
    id: 'range-test-20260619-1653',
    matching_hash: 'a0aabc2b27fb068f6d1ea4ba99ec950a10b4c779',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'e45aa8f03bda9a63f22e77f011b0a620c64534b6',
    id: 'range-test-20260619-1654',
    matching_hash: '7b04ba7e885a0fe231c0aa27a7e99514a49de959',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'db8442534a0377f02f53ec67d6c01dcd86254be9',
    id: 'range-test-20260619-1655',
    matching_hash: 'c843f46f23c43119594ec24465afbec8a827cc65',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'd9b5d251c803b4fcbde82b66b35e9c3062a2a2cf',
    id: 'range-test-20260619-1656',
    matching_hash: '3fcf8997de570ca53e3568e5685ec7f76dc6e071',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'aef31148d314c3e8344e5f121af9a9d9d075badf',
    id: 'range-test-20260619-1657',
    matching_hash: '42c81f2302c092d6a6fd738e5087676f74fd1eb9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'f0da51d068687356419d936f522145a50ae55188',
    id: 'range-test-20260619-1658',
    matching_hash: 'e18f28e1e9a26cf22a8e933965ffd4872b0f1277',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'dbd67b8094103dedb4286261cfece32fa4c4b459',
    id: 'range-test-20260619-1659',
    matching_hash: '13cd719ecec9d07ae36c85a094d987bd7dd5cabd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'a6dc63084005602a0dcb862e8372fcf0c0ccad2a',
    id: 'range-test-20260619-1660',
    matching_hash: '2bca182471627c1cccc4946a273a1dd3b9add76e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'aa86dab5ac08b8a34857aed0cb929f85b746a4ec',
    id: 'range-test-20260619-1661',
    matching_hash: '33ffe2e8f766946cd56bbeb6de826fa2172895e5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '571ef6071e55d47e1ac7dfd4aa4e92669cfc8475',
    id: 'range-test-20260619-1662',
    matching_hash: '137e3280e11027c98633cbb2cfa096a3cf7a96f0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'a3069b90b8701ccf52a8c3dddd277e8f7a96b952',
    id: 'range-test-20260619-1663',
    matching_hash: 'cc7c97ef75920dbf2f5f173a43a0c082eca5a684',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '6cd89d09e6e4b1be0f3c6f76d0f0cb837b4599d0',
    id: 'range-test-20260619-1664',
    matching_hash: '166a99b7c995263550d26e06973df83f6fe5f8f0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '4da91725a44d58e3f185c6c472dd677759e14703',
    id: 'range-test-20260619-1665',
    matching_hash: '742f5579541593fb7511cb52f860f1c8e48f774b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'ab9958ea908856a77724595ecf11f1f66f1bd4c4',
    id: 'range-test-20260619-1666',
    matching_hash: '3df351c7a293b90c5199a5d32b2e9c1d20e6ec9c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'd518878d0703fc1cd45d9af8b0bb94c28ce23e32',
    id: 'range-test-20260619-1667',
    matching_hash: '892b95b86905f78ce0dc51eac361da99db91db43',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '8b4f309d890f5786eaee28c1f633a3608c13a565',
    id: 'range-test-20260619-1668',
    matching_hash: '9c959635e5ac0a7432bcddfc0283e2ee8da441b6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'c96a9664c76869c55c5d15c469b69e3d5dc676aa',
    id: 'range-test-20260619-1669',
    matching_hash: 'ff9beab5f77dacfc7a365c314f85377073360102',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '211f36e2a38f47ab7159443031f5930518de201d',
    id: 'range-test-20260619-1670',
    matching_hash: '60f8daf191d2d4486d329bcf3fc824a5c99a76e9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '927de8040c9cbe3ea3a009953fdf7815a1404504',
    id: 'range-test-20260619-1671',
    matching_hash: 'e490e8210e8475e989a6be6b07fb98cb264c2f60',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'b85c266893e62577e2de70993a7d2eab34f5c54e',
    id: 'range-test-20260619-1672',
    matching_hash: '44340e8cb884e9c775a896746f05b9238d9fc1d7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '9e3f7088475ff70c16005e9add43c6bf2f077366',
    id: 'range-test-20260619-1673',
    matching_hash: 'fd99902d480287e02634b930b4a60a2854b64a70',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'ca3c84b0947731f945b15672060194047318ac89',
    id: 'range-test-20260619-1674',
    matching_hash: 'f13e9becbc840481984417a95ffec962ac77d897',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '0567913e6c8d526c48cbabecca0cbc9ff6138b5c',
    id: 'range-test-20260619-1675',
    matching_hash: '28315279f3baf46f981aa377808d036bff0a17e2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'c408f1237031128901ffc2b71304537fbc454b49',
    id: 'range-test-20260619-1676',
    matching_hash: 'd9c299d25f65b8262ff9217679adbfecd8880161',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '987249dd73d081738461b0d1f1511edc465eb694',
    id: 'range-test-20260619-1677',
    matching_hash: '42257e98b4b741903ce71180477837073b41a70c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '8d9ac8348f57a4cd0c49369aa2f15ec22f62f1da',
    id: 'range-test-20260619-1678',
    matching_hash: '06c5306620f590229c4bc628da346aaec1b340ac',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '66f41d3fe9fa0efcb14574cf2f5c172e2ace9e76',
    id: 'range-test-20260619-1679',
    matching_hash: '7ee900b356be54bc09f89599ec1e3c35542487a8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '5649729a926c06aa3e9ef6204b11225e4f8f87f9',
    id: 'range-test-20260619-1680',
    matching_hash: 'a58966f5c92aed7a90ce8766223e9ed59207ef6b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '7663fb48c1f7c6f836d90d03deb0fe3660d5a147',
    id: 'range-test-20260619-1681',
    matching_hash: '08770855419c23972999e9b9886e94fbbe05a747',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '1b7d9a7052857706f0c28ead94047fba51073bbe',
    id: 'range-test-20260619-1682',
    matching_hash: '31cbceb1a14f595c9ce36bf1d31e63d6692121aa',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'cc318a40749beb296fb377113a80036496f5c4e4',
    id: 'range-test-20260619-1683',
    matching_hash: '2825b525cd777ba5f46be356a2d996b112f1aab2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '37eee6fe886b75d4f474413a76f64779e51b962a',
    id: 'range-test-20260619-1684',
    matching_hash: 'd5e2ee6829008de79caf6ea30b84c06c14ee3cc9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '04c665a455b66752cbbc6f23ed99870872d64d49',
    id: 'range-test-20260619-1685',
    matching_hash: 'c4d6bb614c7c88acb50b9dce1af2e5271ab7dc4a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '0beaeff680962747e7b47fa444e932c0c54a780d',
    id: 'range-test-20260619-1686',
    matching_hash: '5816aa462d9cd1e84dfd00cae06da58af0c17c07',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '9c0169531f73e1ed313243c92cccff03220c4f96',
    id: 'range-test-20260619-1687',
    matching_hash: 'c7d08cda5ad52ca0609189a9d44e5124e0955c7d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'cc2004f4aa9ba8f45fb9f94108b1f053b3a10ac9',
    id: 'range-test-20260619-1688',
    matching_hash: '35a3ddcc9f1965ac0a62c37efab5da2fab45420f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '6d33ff68d614da08c02f46945192b2633f593441',
    id: 'range-test-20260619-1689',
    matching_hash: 'c3aac246ad91fdf1a248a213cd19f7f632a74197',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'f60a7ab9364fe64bb61e6780a10816493175cf76',
    id: 'range-test-20260619-1690',
    matching_hash: '873e4e9567612184472974251a2c0bddc21cb907',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'df39c0e0f6db873d84b717f3052c9a00d8aaf006',
    id: 'range-test-20260619-1691',
    matching_hash: '2fe0b8d0117744d21adfba7a4e914ee13bc9395e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'a6c0f8047141c63f0e90e8ec40f6162c40d945d9',
    id: 'range-test-20260619-1692',
    matching_hash: '36259bcf9e762d57abb22ccaab05f95b1bc9515d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '03772095e35afe0ec14c95ec7214327a96f89f4d',
    id: 'range-test-20260619-1693',
    matching_hash: '5ae95f6296cd0711eeb8efd42e758626002ae746',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '3496957a835dc5b0e8efd64f4ef8517becfa2057',
    id: 'range-test-20260619-1694',
    matching_hash: '6ae6945b681fe916ba984a6a32e7e421cca9ffb8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '2673a4dffc12643c12c1ff0ba3a9fea0dfd64399',
    id: 'range-test-20260619-1695',
    matching_hash: '39584881d844cd0aee1d48aa1c28128a3132e23a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '1754754cdeab8e7eb24f3c910c11803dcc708234',
    id: 'range-test-20260619-1696',
    matching_hash: 'c290019dfa3d6d9a36f16c32cf5778415daca005',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'a214df0e2d903416aaa68dd3e4f8ddc5e4717c24',
    id: 'range-test-20260619-1697',
    matching_hash: '4baafd8ccf6efaeca381d594ad95bee5808c7fa4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '46834196dee15efd36d61bbf685431454ec5e494',
    id: 'range-test-20260619-1698',
    matching_hash: 'ef8bc28547c3aa4d788fd67754de79a51e2abe0f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '9915b597419bb7b18d99f531a2d84f317b236288',
    id: 'range-test-20260619-1699',
    matching_hash: '71281ffdf3929a549029f044dadadf2c97e82d2d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'a7eda114ba2ae8e097b64b801df75e37de0d6378',
    id: 'range-test-20260619-1700',
    matching_hash: 'f9fb35dc4b7342d96cd735cc98190f0dc1b45898',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '76f45e92e3fb27f1fbd494600980ee13f38cae56',
    id: 'range-test-20260619-1701',
    matching_hash: 'f7a6cf58d2ffa19deef24b0bfa3c0b9601ce4051',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '9f4858b2ffe71b015aaa1b858ce7a58c9152921d',
    id: 'range-test-20260619-1702',
    matching_hash: 'ca8d67a389de81630f97a2849266ba912f2dd600',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'a83dde80083599904372afaea632290ef5a31fcd',
    id: 'range-test-20260619-1703',
    matching_hash: '937e27858c7b184b332cf35c5c9737bc39d8e94e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '5bff895db6cc62b6901d3c78029113259c584a13',
    id: 'range-test-20260619-1704',
    matching_hash: 'a8da44d7fefa5f9c5b914aee74d372c2c766be41',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '0998625c84cf178a3d20f1caea688f8c59d0e371',
    id: 'range-test-20260619-1705',
    matching_hash: '59475006e3d8ec55d3d220525e938a535701ef87',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'f59982ea6fee1e64fa55836c978017aeb2b61ebb',
    id: 'range-test-20260619-1706',
    matching_hash: '24780a7c2e42910e4055790357c3cd69c566f73d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '879fa40622fd59f1a670a5457328a434da8d3f5d',
    id: 'range-test-20260619-1707',
    matching_hash: '4b21244f9a81ea7d67ad088e2756de25f24f1212',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '2b8e6e3f3730e12856548557a19ad2cc6f16d885',
    id: 'range-test-20260619-1708',
    matching_hash: '5a174cab6f02e0f7fb1b0178dd528539e4bf1f7e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '18d727c7161bee11e2c1aec972ff9083e7ba9457',
    id: 'range-test-20260619-1709',
    matching_hash: '3a3e2024dac26a59d224fe16a26c72b0e21f9e82',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'dbadae623325b6bde5de4894321c63d0b87bec92',
    id: 'range-test-20260619-1710',
    matching_hash: '71b5fca63aae7c5dbd96a5a3526502f99320a473',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'd13e4a25ce0c50b9ffa565ea390add3a48945125',
    id: 'range-test-20260619-1711',
    matching_hash: '928ebf176efdd1004378a749dfab4338bdeea216',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'fe7a0c01bb378542cf029d58f04c17f264a79e16',
    id: 'range-test-20260619-1712',
    matching_hash: 'af074b6ea1b1f36565be2e5ff7b073dfc76db7e9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '54cdc9b570112820727de532c20f4114aa5bd5be',
    id: 'range-test-20260619-1713',
    matching_hash: '6d5e5d50c5d8fba2105d8b614e541a276c337680',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'f6aaa0bc439cf3290e5e1dd1d105821560a7d0a5',
    id: 'range-test-20260619-1714',
    matching_hash: 'd0ae15feb14b3b793582a71c8a82b4f79ecf2dbb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '31302e0a07a14ea257db36de169347529bfdfbbf',
    id: 'range-test-20260619-1715',
    matching_hash: '4b50efd296d354cb939cb1f1425ef5850efc473b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'b29c602ec64570e9aa985000a204d8f4c4f29fe7',
    id: 'range-test-20260619-1716',
    matching_hash: '41b90e76ab27bb7c0944d91016c680ce78de28cf',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.834596725,
    qx: 0.355551064,
    qy: -2.58e-17,
    qz: -0.420751408,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '02d7474f1e9aa8c5023f01dc12ce509814aeb387',
    id: 'range-test-20260619-1717',
    matching_hash: 'a13397beae2f01e993f201d2cc07346fe8e2f8e7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '9e57ebda3b97dacead575bf5aa6547505e2f1d31',
    id: 'range-test-20260619-1718',
    matching_hash: '8be91dd2fdf36e41215124495b8fa0cf228f4b1c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '98760277482f5e9c7d6d01058d6433255d63868a',
    id: 'range-test-20260619-1719',
    matching_hash: 'c063337072536183256b718feb3e485013f3b292',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'd5ffeeb469f2e9955d0876e5c667e1d98b33d5ed',
    id: 'range-test-20260619-1720',
    matching_hash: 'c67366f17d5caf2d63a4ed1ca5337e1b088b45fe',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '311b883d29e085b5812f1d745659622a13dd8a9f',
    id: 'range-test-20260619-1721',
    matching_hash: '9ffd523f385b7b5b64a38e9a6e7eb6efe2d4e93d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '17a498dff9afe6f8ecc9001954f986c5c4258ba8',
    id: 'range-test-20260619-1722',
    matching_hash: '89cdb9b92c553d79063304084b1581298e18b8ca',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '9f675f271551bdb2afaaedaf8c4b13009c0650be',
    id: 'range-test-20260619-1723',
    matching_hash: 'a9db98507810b4b5551ada4ef489f0ffbbb04682',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'a61128e0279f158c272c4761273e536fb4bbde5f',
    id: 'range-test-20260619-1724',
    matching_hash: '4a0c0e035fc426ee829a34fcd0e863500da20099',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '9839a98ff229f113100ba6ae4c67d2442b426117',
    id: 'range-test-20260619-1725',
    matching_hash: '2c326ef11ed6b478cc1f255bad44f39762e142d0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'cd5fa05c0b40a104bcb354a1e6e264d4412fb648',
    id: 'range-test-20260619-1726',
    matching_hash: '59fbcd75cbbca3045752ec7600a0f90803a1b37b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'fba2111b09e88010b93832ab7323357308a754f6',
    id: 'range-test-20260619-1727',
    matching_hash: '0b495c896c70b072a2c30c0f8c20ff1149c9aeb4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'b0fa90f72ed6d8e4c1a43038fb75e420889d3819',
    id: 'range-test-20260619-1728',
    matching_hash: '077ddada34f875dbb34c92e3822cbeaaf5b2c931',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '39446d95e16e8a07549225e6f79bb6bc6a5c0f8b',
    id: 'range-test-20260619-1729',
    matching_hash: 'dbf3f410c48cbabd9b298e6cfbf9d08ba23102e8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '82295e112a57cd3cc57021954ec603303fc59e68',
    id: 'range-test-20260619-1730',
    matching_hash: 'ac8ad6546c2b181511fc5fbde0b1e147c615c803',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '602b84040fe4943c22d243a76805b07c344c9822',
    id: 'range-test-20260619-1731',
    matching_hash: '3cf70df48ee89801023d56a161ac810de26c298e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '795f3697508da99a17b1f78ad5edafdb23464599',
    id: 'range-test-20260619-1732',
    matching_hash: 'd04f6509ea4a28707edde3bb8453ba64bb6f4564',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'd56325940e822623c1a0a5e938e709df4a54e2be',
    id: 'range-test-20260619-1733',
    matching_hash: 'a7dcc5ab7071869c8878a56ed19fa1945c6ab2e1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '5a8e0a30fe49d852df2f31db11dd33830d02eac9',
    id: 'range-test-20260619-1734',
    matching_hash: 'e30e7ba2eca666fbf0da8a11128b29854518adaa',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '6888f199fd7777901138c87e47dda7bd24b3318e',
    id: 'range-test-20260619-1735',
    matching_hash: 'b72ed90f32f48b44b26222e8bce600ccd585c140',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '60ecd3b2afe53c9950bd479970218da0c3fb93c2',
    id: 'range-test-20260619-1736',
    matching_hash: '46909f0cd481058d102747728864f0f594f4c002',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'd24cb021aa0169c304287aab552758dbe3e2688b',
    id: 'range-test-20260619-1737',
    matching_hash: 'b47223192ef5a4fba900c5518cb9092e6b54c2cd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '05c5a847ba4259847455304ef997175ed76b118b',
    id: 'range-test-20260619-1738',
    matching_hash: '4c32a00c615b28b9c7aba579f5d1f46c551cd59c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'de48379f8559d2f79ab10071c81e1fc9fdc3f5e9',
    id: 'range-test-20260619-1739',
    matching_hash: '233e1f9ad5e09572fe3367136a0a7ac298b7a8c1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '7a8db3fc9b5f087d0606acf70ec3a14b143a6b9d',
    id: 'range-test-20260619-1740',
    matching_hash: 'af5ce2bb239c9de044b9b95f3dbc3368a194d0c4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '3d9431a80a9e42777cc738189e70dc0ecb289e40',
    id: 'range-test-20260619-1741',
    matching_hash: '32e78cec69e07c7d5538946b8a9b5a650689578d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '191152a581cc8564f788c6ab51f9a975fe9557bc',
    id: 'range-test-20260619-1742',
    matching_hash: '6a64bb34e2691810ab52dd8c10f198269982533a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'dcb1e2d610e051c7e50cfdc26c538335d96402f3',
    id: 'range-test-20260619-1743',
    matching_hash: '8175534daa27976c277949c1c38433a2d6256060',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '7b511d47a861c21b0285098794532e33bb259f20',
    id: 'range-test-20260619-1744',
    matching_hash: '2cdb1345309c3dceb1154db1907b3a9ad40e12c4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'b5364b66298d7d2c73cbff6aa71c345d986ae124',
    id: 'range-test-20260619-1745',
    matching_hash: '24602c091f7233171d1fd24a1f1188a71b70beb8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '508841ac463c0a4a2fcd7933d9aa9d756e069031',
    id: 'range-test-20260619-1746',
    matching_hash: 'd63f6623e4c4e390f83fb04ec9de9d5a330f7300',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '20651cb368a6c002e35578ced4171d0f7d73d292',
    id: 'range-test-20260619-1747',
    matching_hash: '1031c084e9efc6a82d1c711b4fb87c3647ee7a94',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '6a7c47439dcc495b66fc8b06d302ca49e781a71f',
    id: 'range-test-20260619-1748',
    matching_hash: '6f4b3d85b061622ef0574f233610885e05469dd4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'f9737a009dc0931641c3bb2637c618c46c34c69e',
    id: 'range-test-20260619-1749',
    matching_hash: '6d326d9fc61f41daac801db90444bc2a89bd15f0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'ab462dfc1d1c0a501cc5b1ce5776f9db4a0d2e4a',
    id: 'range-test-20260619-1750',
    matching_hash: '07c9a86c59a2fd015b2a04c823eb802e98ff7b75',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '2c3ddfd8e71e48c6acecf9f3f8c5326dc6b0f4ca',
    id: 'range-test-20260619-1751',
    matching_hash: '3fd8edfe2b605d8aef3d6016c002d156abd19964',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'd552c67e5435d0e2b10eeba5fd8d4d60aa0a2a29',
    id: 'range-test-20260619-1752',
    matching_hash: '847d56b1e802db52ca1cbe152715299517b5849e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '4d771a2c29acae92c90b8f8766848f82ed960540',
    id: 'range-test-20260619-1753',
    matching_hash: '98c3e367724912ac6e10bff5ab8584ccf75612d8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '9eae107df3c0d4fd199ab66c7fa1905f98e78498',
    id: 'range-test-20260619-1754',
    matching_hash: 'a8653b64f20b70a95f18e7a55ef8e7e0b2859a32',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '053792bc0b4d80a2571e1c47b5dd693569b9ae38',
    id: 'range-test-20260619-1755',
    matching_hash: '1d20afbd7f2c63e35d17240c1fedeceb5efa67c4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'a37b70949a62de73213d231eebd9efcd86b1f7db',
    id: 'range-test-20260619-1756',
    matching_hash: '0dd3e3d02c7e2af98c2c24fc76235993ea5bca5d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'f7e5ecb9fca785985e6a33abc417c1177bb43246',
    id: 'range-test-20260619-1757',
    matching_hash: '66086f428ca431b616a67bdc20e929bee7fe221a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '8e5d812a3dd223221660cdcf4d1ba3bdb576fb3b',
    id: 'range-test-20260619-1758',
    matching_hash: '5192b36bfa6430e0fea9bc42cfd4573737ac91ee',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '22aac979c16d55110532125236d6908d0356b587',
    id: 'range-test-20260619-1759',
    matching_hash: '308dbeb2f2fa263ed27472a2d3fb766e6d69a805',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '63888974e53dc73e66b79ae2030f07e60bb444e1',
    id: 'range-test-20260619-1760',
    matching_hash: '911e5b97e4f658fbca53615a04ff049a89a719d3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '6d1f8302490bfaf2792f9c024c611bc81374264d',
    id: 'range-test-20260619-1761',
    matching_hash: 'a42f2c9bcb0d304c4b299cf9287b650f19d5f623',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'fb6a422f750bdb9ddac9d667f49cb589b0fce490',
    id: 'range-test-20260619-1762',
    matching_hash: '593f9f605ca73b394f50ae1e3720459b98a3f2c9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '8e89221e70660b540339f87b55e57a00fdfaed97',
    id: 'range-test-20260619-1763',
    matching_hash: '2dca91e36d02e82dff97224f20995b2756910c40',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '858812a8aae0a73b536a247411d698c68a26d72c',
    id: 'range-test-20260619-1764',
    matching_hash: 'dc3b81b3e4967cf9f929407bf8bd68ab23e4528c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '699a89eaa5646c53c465b5788dd0b7353e10c9bf',
    id: 'range-test-20260619-1765',
    matching_hash: '2a550007b29b03b668801d6f329938fd5989493d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'e6119f43575b0f627aa31c5adcbbd2e7e5111356',
    id: 'range-test-20260619-1766',
    matching_hash: '769dd254f81a8d3cb76e2db0117e9f9e5448e895',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'c0ef9d646883d6eec4d2be2a59916fd2bf208600',
    id: 'range-test-20260619-1767',
    matching_hash: 'c3b2bf9b0eefb8ba928b9b9dcd593019cd4b6e41',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '1afa8eb50060fd4944c911f773ad8283d18f9f6b',
    id: 'range-test-20260619-1768',
    matching_hash: '307c2646b71f94efcee900a70d2cec2e0c970ebd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'c89d78b77450f3bf52304320988d4390f2a0f57b',
    id: 'range-test-20260619-1769',
    matching_hash: '24f210d45775f420ecf7dab0cc72c34a18dd4395',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '7bde1d1ef5cd5ae4e494f70e633d530c70ad6832',
    id: 'range-test-20260619-1770',
    matching_hash: '59e424225e148eff2140e6fc90414674a62a93fb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '56ae59cea989ae3171968b717c8041a7624bbe63',
    id: 'range-test-20260619-1771',
    matching_hash: '42b995e71c55e3a4f1f667b07c17a47a32462468',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '24fbfc6aa2fc64ce96977bf9c8d447d79a966c1a',
    id: 'range-test-20260619-1772',
    matching_hash: 'd395cc4b609fa22e82721d428454a4b2a42dfc14',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '7e4444c5add10cedcb0e8241b3f59dd40a34898f',
    id: 'range-test-20260619-1773',
    matching_hash: '828ff7d14a9bfbfecf35be82bcb33a03211e81e2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '1fa0b56228fee75973adebdd7cc52c626c203908',
    id: 'range-test-20260619-1774',
    matching_hash: '6a87ee3bbb66cb562e076c0ad9e95ca7d3f24160',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '77e2d871af8c11bfa4c23f15acb9d38f34a2e342',
    id: 'range-test-20260619-1775',
    matching_hash: '38e51c877331c94ec15d7f3b372a5b880c7b7d06',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'a9d61c866bf00f5712e4f8b12f7798ad511bf84e',
    id: 'range-test-20260619-1776',
    matching_hash: '7a838f1dd14f5599004af11e87216f6de6957b41',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '883da5a4feb769fd8aff1bda25847c0fd3993edb',
    id: 'range-test-20260619-1777',
    matching_hash: '55b2caba9136f33ba404a2968905acc8b6c6e5f8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '6dfd5620ef2daa6cbdb61013743877c3d363e56a',
    id: 'range-test-20260619-1778',
    matching_hash: '94c6074c40a5c9b45d389924c6dacffa1c571ca7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '66216d34ffc36e391fda56c790189156ba43646c',
    id: 'range-test-20260619-1779',
    matching_hash: '43cc61e55b9f35e8e1c77aaae386ed0f7c8a3d0d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '54cc93d84bdcec5006f194eed1673948883f7c6a',
    id: 'range-test-20260619-1780',
    matching_hash: '9f9b6660b3ac1e586718dccc5d37e6e93caaff05',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '99adef5fe47733fbc42b0c2c042533a681985fd0',
    id: 'range-test-20260619-1781',
    matching_hash: '505cbda1eea34ea77a5cf747fa69d3effbbd9a69',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'f1c6c11ee5dd9b820502cc0191539c98ba3765c3',
    id: 'range-test-20260619-1782',
    matching_hash: '47c7104e61d25f14d0ffc2b253cab55ce0e8df79',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'e777ab389f30b7f9b9d07c47641ea8dc67bf8caa',
    id: 'range-test-20260619-1783',
    matching_hash: 'abf799db8036ad2667aa886d3d49063425501a13',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '3e39080f5a468cc5b79dc14b89ea5f4ac25e41ab',
    id: 'range-test-20260619-1784',
    matching_hash: 'c5a1bdf6cbe1d65139c56a45d82c91bfcd5d5307',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '880f00b59ca38eb208dbba290f63202516fb966e',
    id: 'range-test-20260619-1785',
    matching_hash: '1393d793ba0c821729d2625d8339bf7e8ad233ad',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '8b584b1648735c1b93a4ef89a36c855762e2ec8e',
    id: 'range-test-20260619-1786',
    matching_hash: 'cc87ebb5ff395304a11535e2205549f6d73048ec',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '6b751ff0d7bfd03efdd3b8a13d0da0f2d6820b87',
    id: 'range-test-20260619-1787',
    matching_hash: '588e37d1776ee18ad2928fb143e5ddaef4f3db09',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '7444e3b71f8d66f9b10771384ef19f39c64d3e50',
    id: 'range-test-20260619-1788',
    matching_hash: 'e4a0f29143e2ffc44db42ba578b5a0f864b269fc',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'dff72758e3f4f49528165f4851a0ad615edf4be5',
    id: 'range-test-20260619-1789',
    matching_hash: 'a4a8fd04a077c760dc1ad92b0bac327713c8c426',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'e6462b7af4f2cdafe20bc036e71d4c737a42afbb',
    id: 'range-test-20260619-1790',
    matching_hash: '855a06e49e3e36a911d302a2cfaf02c3574c0deb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'c3057cb345dbc7c348333e18f904076d92b38aec',
    id: 'range-test-20260619-1791',
    matching_hash: '16806af921ca99268ac9f6abb91ae9d19184d3e1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'c524339437f34f86075df2d3680b6b1a03bc7571',
    id: 'range-test-20260619-1792',
    matching_hash: '3281cc42398a3032dfb4f9324c53513587cd3659',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'c007bddefbdc16e74c6f851aa6413160c3dd9c97',
    id: 'range-test-20260619-1793',
    matching_hash: '425c529270ef38bd40b23b8ac41ee3439232b108',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '40b685acb39c4a4a6199481d345856af3fae6dfb',
    id: 'range-test-20260619-1794',
    matching_hash: 'e14a48a8c9c2991654e4a9890b12768d8527269e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '3a295db59712dcaab912bda5c915641b4df3adb9',
    id: 'range-test-20260619-1795',
    matching_hash: 'a372819feabf7210b2bb750c24ee12440d12c1db',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '14d0589c8628fe9a6e4bcbe3083c1b52d46c3648',
    id: 'range-test-20260619-1796',
    matching_hash: '818b6fda84c8e177d1162e0b9117805b21469415',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'f811b59eeb114e35f48916828cdb6cbda182dcd5',
    id: 'range-test-20260619-1797',
    matching_hash: '7f089a860a572238fc5f1de2e3988d098cc34fa8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '0208b390fc9f347b458d47a7d1c54164ae07feb5',
    id: 'range-test-20260619-1798',
    matching_hash: '5e9669a6acd27095ed78d9459febf91808b6a67d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '3c2d97784d6eda9b937a58f4ef35c33e3916b224',
    id: 'range-test-20260619-1799',
    matching_hash: '59df85f4734c6955dec672efa4355e29c868aa14',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'caeeb388d7508cc2e5559d4adc0bdc1fafc96832',
    id: 'range-test-20260619-1800',
    matching_hash: 'ef8538178be2a8d424909770fd5daf07a3cb03d2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'd7fcc7a1846e5491dafebcdad95e5376259bef8b',
    id: 'range-test-20260619-1801',
    matching_hash: 'a9716a439cf775bf40d16089b40f2148f600533d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '4e66545a8958eeb9d3423ad19a2416270704e1b3',
    id: 'range-test-20260619-1802',
    matching_hash: 'd08b15443c6a98d4092922065f09f4a9cd5304df',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '8294e5ef9c3b29093f906875e28063ad175476e9',
    id: 'range-test-20260619-1803',
    matching_hash: '06fc36c6dec9f195eae86f64e428a5589af82c01',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '5d10b6c28842fc4cbd511264d6eab3721731db0d',
    id: 'range-test-20260619-1804',
    matching_hash: '3dbe1f5bcc1567a11b421cf47f386a065e5bd518',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '0081c6be4f574cf2a6a477c6ef58b303ec58f2cb',
    id: 'range-test-20260619-1805',
    matching_hash: 'f773fd11c59aaac408063a26e8ca5efaab7ce536',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'f1248f0217c762111c6d3a3812a2a4bb5d4ab0a1',
    id: 'range-test-20260619-1806',
    matching_hash: '0dde3d5badd2949addf1bf84e8c68ae78c618f4b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '7c97edc049a73c5fb04d27e95328b91175a0e062',
    id: 'range-test-20260619-1807',
    matching_hash: '54cff24be25a04406c3ba0cd512b43498e24036b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '9556524c254be19c9fe74939ce2e97b380b77310',
    id: 'range-test-20260619-1808',
    matching_hash: 'ef555cf442f0dbb36468fdc3f622f32a30571954',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '2a4ca57c411941543b6e27389d1ef31341c4dad6',
    id: 'range-test-20260619-1809',
    matching_hash: '86982bf0936d4ed370a7f81645ebad80b8186199',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '6b6206e7afad97c5368dfb59a272b53bfe283e22',
    id: 'range-test-20260619-1810',
    matching_hash: 'caa60e452c923efe960abea4727d01dd708b71f9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'b4536a5e791838751d7721fca593bab554d52ecc',
    id: 'range-test-20260619-1811',
    matching_hash: 'd74b06acd78ecb7bbb6c9429c85fb2b1304830b2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'f8e1fcfb7b1337f4eba196ed0feec7673222981d',
    id: 'range-test-20260619-1812',
    matching_hash: '2993f5007c71cb94a087d4348e97d57c01a8f95c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '7fca8f1281d62226ad894cc8cccfb83671a38e96',
    id: 'range-test-20260619-1813',
    matching_hash: 'afe4de70c505dc0fbe6dfe9f1a061adde271590a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '35d5f6b01968e2a1a4863c212fed9bca7a609bf2',
    id: 'range-test-20260619-1814',
    matching_hash: '01adce384c6da9de9c786aa87f49a888c80e9326',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'fc2ef79aa0278d42fbac31ae7934692f14d64826',
    id: 'range-test-20260619-1815',
    matching_hash: '3bbd6982907f7d6f651f73830d46100db869d7d2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'cc0c3fc9dc91fa63bdd74ccb5d9138a7010b3de9',
    id: 'range-test-20260619-1816',
    matching_hash: 'f089ba2db89dd5576d73bed06d72ff1af802a08b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '072ecb2fd6b1d30e92cd239ec2479b48f6064076',
    id: 'range-test-20260619-1817',
    matching_hash: '049848e402e564dac3d1eb040722febc547e51f2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.943277548,
    qx: -0.203348744,
    qy: 0.229578812,
    qz: 0.127162592,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '2106bac63715ffc2c0c84bba7bd398ed9ed4d4e0',
    id: 'range-test-20260619-1818',
    matching_hash: '44db40b1f79aa352e685b9c29da945f120d18711',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '8275d5fe7dc0a1608dc3e5c338776edb4b6dd2a0',
    id: 'range-test-20260619-1819',
    matching_hash: '9750915cd05dd64dcb288ba36b5c6a4cf6651f19',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '9dbae01a86c11df931fa107271ab33200c032ab8',
    id: 'range-test-20260619-1820',
    matching_hash: '46e6fb08dfaf2a27f26e7133f2b6664e42ff455d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '851ff92a06991667682e30935c9109332a77f79c',
    id: 'range-test-20260619-1821',
    matching_hash: '4083e1f1f83ba85f1b90818b35e3a0da2337b65d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '3fbb63c16bedc08945e75b10a73edbf2aed82262',
    id: 'range-test-20260619-1822',
    matching_hash: '818f4f76e0dcc51414f6d605a277ba3ae13b4c94',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '4c3e078bc2a36ee58d266457e265d035fd1726b0',
    id: 'range-test-20260619-1823',
    matching_hash: 'e7fa237d04ebe502c5c89cfb29b24c5d2daa68c5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '43674382cf814279f58f8eac7e9ab8d6753a9e83',
    id: 'range-test-20260619-1824',
    matching_hash: 'af2832a1919d76d00704a6fb25c658cea5f3160b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '98607610bb80561d66b47fe1bcdf874324043495',
    id: 'range-test-20260619-1825',
    matching_hash: '0c1949be454385c1640ad1a85d848ebe3b3b3592',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '705d14a812a3cd899d999057a5b868bb8522b403',
    id: 'range-test-20260619-1826',
    matching_hash: '8558389107f60b34532d34425e58071d711d61d1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'bcf6f5be4dd8177ff0aad1ce031d9af869dead94',
    id: 'range-test-20260619-1827',
    matching_hash: '4108ba5cebcbac45a562dc40ca889a3b94bea874',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'bd57d975567f5e98a08cea82c97525c491ef8c99',
    id: 'range-test-20260619-1828',
    matching_hash: '533c40186715a6f647fc219d181c19eb64465e00',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'd4b81af8626d721470442203dd5738344918e558',
    id: 'range-test-20260619-1829',
    matching_hash: 'd996dbeabcdf83bdb0b4ce93c03b8df059c960ab',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '8860eaf921f1f0d9df89d798938af7cfb3d222cb',
    id: 'range-test-20260619-1830',
    matching_hash: 'decfe85cda24b9c9d994d6b972b91f858eaff47c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'd44dd0a744f89301d7ceac776f4169a247ae809d',
    id: 'range-test-20260619-1831',
    matching_hash: 'c86829f1d35b3763951245c5e22c0fcf205b6f69',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '0eee6e4ad9b3daa71cbcc6777d25abacfe684f2d',
    id: 'range-test-20260619-1832',
    matching_hash: '2979305bb7dd189fade628869450a0540acdbac1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '8516f8d36bfffbcf67b238ab4581e43d09ca7891',
    id: 'range-test-20260619-1833',
    matching_hash: 'a500fb1f32ee47f8f6189e72bf681fd5cea6a03a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '291ce045156e4a85992a739669e4422a98239049',
    id: 'range-test-20260619-1834',
    matching_hash: '1ccf1bb07ba6ac46bd3a98bd51c2d873e0bb8ba7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '2fd15837b93a61bf140fad206180c64bee318c11',
    id: 'range-test-20260619-1835',
    matching_hash: '7c7573084f54bf548ea345c125dce9549a79c1f7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '5107709614b9b35b9d014e52bb06451e0eafb418',
    id: 'range-test-20260619-1836',
    matching_hash: '6c39431eda96b0baf2398400245abbeec8dc7ab1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '57d1bd0511e63180694f4ac0690e8235e3f72065',
    id: 'range-test-20260619-1837',
    matching_hash: 'c4aed9de3cfcd10f77ac1129a242ad5d89d6ecc4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '66a4f4e046816d1117952fb900dd3136f0025a3d',
    id: 'range-test-20260619-1838',
    matching_hash: '3409835a4fe2820f91533c702b9082b623732d3e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '9ef9f3387d6ccd38e72d0bd136357cec4028339e',
    id: 'range-test-20260619-1839',
    matching_hash: '5f186040620017eaa900f4f001eb0174817f04f6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '7940d0e99b4859dc442772fc9805c0ccf1a8444c',
    id: 'range-test-20260619-1840',
    matching_hash: 'c64805a812b0897d4f9ff469d7273cc51ea07663',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '5df91a58f4677da2d22a52770ab205d6c63a2e7d',
    id: 'range-test-20260619-1841',
    matching_hash: 'c292bf1a5e77fe1a893d35bba76dfe8b60ff7dd6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'a7ac313c09d33a3b785bedb64097f258ed2ff842',
    id: 'range-test-20260619-1842',
    matching_hash: '1739d9e2df222dee7e2395a5a55337e261cb29e8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '77462dbba0e167f56e7fc8ba7f74333f7dd7a1f8',
    id: 'range-test-20260619-1843',
    matching_hash: '8dab92a8bf07edad00e6a4e9080616ff6d9d3aaf',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '3e206812ed4ef1a8c3c7e05a661b50d879a65e9a',
    id: 'range-test-20260619-1844',
    matching_hash: '3cc2d4d199cfbe5a72adedeeb0897d9cd3359d81',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'dd441dda7bc7b76f8fe88aa95ab601508774809f',
    id: 'range-test-20260619-1845',
    matching_hash: 'cba9969cddf15e34da071e4a0d41e25079f062a0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'a2f8c7684a83480b016bc6ea5190e3b2d745ee2f',
    id: 'range-test-20260619-1846',
    matching_hash: '12b4fb6d61ef78df89d9f04af7b0a813924c667a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'ecaa469937e2b1db6d02c2677228e4ec52f7869f',
    id: 'range-test-20260619-1847',
    matching_hash: '0004bf18d99ebaffb4c2ce199a5d9767cd83c8db',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'fe7944e90daab4c473ac56e7e7e61890270c50d6',
    id: 'range-test-20260619-1848',
    matching_hash: '3c8efffc3d65e79c461acfcda2329e654b424930',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'bb291a2649e0107aa82dbe4ab8925b077ef141ab',
    id: 'range-test-20260619-1849',
    matching_hash: '1a0191182d2974b6fa6f1c9896e75bc28fee7a24',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '64a939619b1abe486285da2a75378b31e1ae56b2',
    id: 'range-test-20260619-1850',
    matching_hash: 'c2ab9f24326135ba932f9998621a2d8d62611534',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '5a4ce5bcdf4e33c076a8f92fead32eec1782589d',
    id: 'range-test-20260619-1851',
    matching_hash: 'fec200ab525b2ece404bbcce19c8d1bc53f5ccb6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '806cd2713da011208a9a3dd44042941685c460bf',
    id: 'range-test-20260619-1852',
    matching_hash: '9af287ba46da865d845d745c1f92c76348fa5ffb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '0c39df609586fda587de0d6beea265a23bf159e3',
    id: 'range-test-20260619-1853',
    matching_hash: '8ca8fab62509e901ae5dec7370fb53b02b9b48e5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'cb588144c97f721b75414154a04a6dd248644417',
    id: 'range-test-20260619-1854',
    matching_hash: '8c4cbdf59cf880658c5db55fdaa1d3f4b8c0852a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '0464c0ed19a8cda725e44ce26208a88f70b9e600',
    id: 'range-test-20260619-1855',
    matching_hash: 'ec9af2d0dec9b1b588b74b2e5f53b5c4211d234f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'f36ed8d9f7cd8e93e2333bc979508700c4bcbc08',
    id: 'range-test-20260619-1856',
    matching_hash: '20aa744d91a19d63813095b62d9d50a276f8e93e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '8a785c89174bf4d30bf225184de63f0e61f26373',
    id: 'range-test-20260619-1857',
    matching_hash: 'b33879da5b0f10461fe6a4c403a901bdefd63378',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'b6dd29e614f9f52d5a167c6872900e1f7da6682a',
    id: 'range-test-20260619-1858',
    matching_hash: '4fc68a3cd39ba0aca28895c61190c89ebc497e72',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'f72d2e517cf5ac2ce3cb0bc141274d4510ccc350',
    id: 'range-test-20260619-1859',
    matching_hash: '27caf842fcde6c708d76ddf92b55c0cc299b902c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '929638c5ecf2c987973ac9c63b30d773c09b868a',
    id: 'range-test-20260619-1860',
    matching_hash: '3dfa80ac8fa3beb389d25816ef75d8a80b258d9f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '2489597984f553b9c8518ca7f8352db84a45206d',
    id: 'range-test-20260619-1861',
    matching_hash: 'f2bb9a70e43f70f6b0a98ca03dd650cf6d614867',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '77f09bdc79826e2a5f73b32b222e19123a8dde54',
    id: 'range-test-20260619-1862',
    matching_hash: '4d6088e5dacba1a9ac977b742a39f564c035b3a9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '38cdee5d4cc28f64a08926e460d13bf81b17749e',
    id: 'range-test-20260619-1863',
    matching_hash: 'e3a8f698a8874734440f7fcb45dc19c8e955cdf4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'abf90fb98d63846d8c9e7b9658af785d4246d5ec',
    id: 'range-test-20260619-1864',
    matching_hash: '9bc6c007c26a12feddab8c9e0b320d7187dadb06',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '4e281601b4bc0bed8177cd9213527f5849d32467',
    id: 'range-test-20260619-1865',
    matching_hash: '813c425a1ea81c33573687b17ad8f1c471235c6f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'b6abb20ed46a3634194281cbf1b25c447cdb2ec8',
    id: 'range-test-20260619-1866',
    matching_hash: '79f7a579e72d2f68ee60d6ce95de315dc4cc9f46',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '39f01554c8371468d78e9e6c457cc17a03de5f0f',
    id: 'range-test-20260619-1867',
    matching_hash: 'f4c888c1e04749b917f8a67a5e434aad76aaf4ca',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '3bfcf3fb009cded933b676d787cd473aca610fdd',
    id: 'range-test-20260619-1868',
    matching_hash: '13e10f57e7ca3de690ad550633c0af79eb939c39',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '1df8d85dd74e71fbb085458c24ae651b9108f10e',
    id: 'range-test-20260619-1869',
    matching_hash: 'e12dde62427373c86569f62831b7b5ee99f1fa63',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'af7e65c3bff9562ba248c47b211728882e33cee4',
    id: 'range-test-20260619-1870',
    matching_hash: '60f2375211790697eb2b16b11fec7f11d70bfecc',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '7435f7dbf1af0881c2425f6ee3e2cf0f6c0577a3',
    id: 'range-test-20260619-1871',
    matching_hash: 'ce3f63eb6d24b19f8974274ec08f2292e0c8119e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '2fdfcd2a3d62eeaca153f921ef7b24cf85e72ca4',
    id: 'range-test-20260619-1872',
    matching_hash: '740f9305e2fa20c2107ac692e92f6e84b72c1820',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'aff641623a43f0c7064801c15a199d9314795c90',
    id: 'range-test-20260619-1873',
    matching_hash: '04ec4b3a5f005863411ccc4a77dbbc778a25a4df',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '6eb8c14f1261d72e6f66bb0b4c9462180ffafffa',
    id: 'range-test-20260619-1874',
    matching_hash: 'e0e7a9ff489d5913133eff1935e8b5c23533e6a9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '2480c63607537d22599db64acbc39c625944e5ba',
    id: 'range-test-20260619-1875',
    matching_hash: 'edf7a3f622a0e7a072284a10a3fc38823e33c953',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '92388ab6b744fcdbdd508c2b917939879058a65f',
    id: 'range-test-20260619-1876',
    matching_hash: 'a3eb32f05ef03d7e061f87c5e0caa5643e3260d7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '4933a7a9d8b3a2b5a7c980b2522b5db555bac79a',
    id: 'range-test-20260619-1877',
    matching_hash: 'e9a8ac6acc145e30727bc143994e21cb73a5619d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'd516399af6a85f165451b34fe41b55a89138bab8',
    id: 'range-test-20260619-1878',
    matching_hash: '20e66df1ee88eeb9aca2fffdf97f34955a6ab5d7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'a04e1f9af4b01f51cf0707d9dcc815bf34858ccb',
    id: 'range-test-20260619-1879',
    matching_hash: '44d6c6ed37e556cb7b914bf1aa74b0955b80ca23',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'c486a7d68a0c11fc7cf41eced3e8f35a5cd14388',
    id: 'range-test-20260619-1880',
    matching_hash: 'd18fa5e720aca390928ef114168797b5f085d476',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '683add04cc5a9e67de0f36e87d3d8462d0c15f5b',
    id: 'range-test-20260619-1881',
    matching_hash: 'faf508234617ded14f4891d044242861a7c6cf44',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '6f9a8da733edf25a6ea490ca4514c8a97e13029d',
    id: 'range-test-20260619-1882',
    matching_hash: '66542d28b516e587c85b1d3f8aa55c7a0a7bf25e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '8ed6e2b57773656d7167dd7fe647e957460730dc',
    id: 'range-test-20260619-1883',
    matching_hash: '68a52162399a4dbf66c0ea9441fa1d7fecc21c1c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'fe6b347f05f46f43beaab06a350d79456a176a6c',
    id: 'range-test-20260619-1884',
    matching_hash: '19a9aece8635e84ea75ff0cf69c2a758355358b6',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '4600dc9249910180b6f33fe041a12fe44496670d',
    id: 'range-test-20260619-1885',
    matching_hash: '0ac8694598c238df4efd67de4229d2b3c86f7d5c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '28cbd28bcc5e49b03f304d7b29ff2c3b8d2e7622',
    id: 'range-test-20260619-1886',
    matching_hash: '0440379f4e9f13f3ad252ef44107f5b49bf2cb47',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '2b3a3174e9f1475190722835be8e3c69837ed7b7',
    id: 'range-test-20260619-1887',
    matching_hash: 'e344728aa2db53214b408b679c0c315c58a40998',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'be41f8af7acc2962eaf5d6bbd562aa39750cb115',
    id: 'range-test-20260619-1888',
    matching_hash: '44db40b1f79aa352e685b9c29da945f120d18711',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '8944028dcc1a4c2c32ea81c80bfdfe87166f73a0',
    id: 'range-test-20260619-1889',
    matching_hash: '9750915cd05dd64dcb288ba36b5c6a4cf6651f19',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'fe32b831bd111e4dc58fd6ae66b285e43bdc360f',
    id: 'range-test-20260619-1890',
    matching_hash: '2bf2983401305126f14b33161ed284c6b5535084',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '16a490e51ec2b5bdfe28fe416b49b7c62745e876',
    id: 'range-test-20260619-1891',
    matching_hash: 'c0184523c47814158406c098c91d2d53507993a3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '94889113feb7d942098a6e120a0c3fcf7ce4d089',
    id: 'range-test-20260619-1892',
    matching_hash: '79ae9208ce74afb85190c1192ec04eb2fed8048a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'a255e31aa2e396f0ae7b9ca96248d1ef1f7a9967',
    id: 'range-test-20260619-1893',
    matching_hash: 'd5af4098a7f854745ece61a7ab64d2a5f1fcfe03',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'b60fc6ddbdd6bf9c224f271b2fdf313efd8736e3',
    id: 'range-test-20260619-1894',
    matching_hash: '95002ef66b9b1ec801e3fbff64bcad8a9a7669e1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'c415984f12461a67274a0f6cff71f4862e2e6f9a',
    id: 'range-test-20260619-1895',
    matching_hash: '4d31b85758ab310411add70715d95cf75698aafc',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '101050b6d0eb87f3d87fd09ff868926773af32f1',
    id: 'range-test-20260619-1896',
    matching_hash: 'db0a3b3675b88889d762bad0578a6f238da66074',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '688537f746d80f87d07c48dd2e87283e9add7cd4',
    id: 'range-test-20260619-1897',
    matching_hash: 'cf876bb49c37eb99e9281cb538971b4b75039033',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '3f00a9e4c313a44a4920c22d19b019f8200fc28a',
    id: 'range-test-20260619-1898',
    matching_hash: '7054cf9580d5f95493632029a83094e95e444c4b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '5c82d1d57014d602bf82860716ea1a40b861d385',
    id: 'range-test-20260619-1899',
    matching_hash: '5021bd49670be9e21b674d2b6a93fb34097b465a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '6ab2d6fc3a41aef563deea118b9a5bc5a0ed0d9a',
    id: 'range-test-20260619-1900',
    matching_hash: '389764906c80032ca41a750de6407d37815bb247',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'dc3df5029ce71bdba8770c40135e0e63f628592f',
    id: 'range-test-20260619-1901',
    matching_hash: 'ef90963ff819e4a80ab137bb4cb7dede012fa293',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'dfcf63c3ff94490fba63cd202f2e494749746e46',
    id: 'range-test-20260619-1902',
    matching_hash: 'f778e7d439a721a8127f6a5a6a73b8aa51f535fb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '3d54164a86bba6ba17274c8a24d8c366ea0601a2',
    id: 'range-test-20260619-1903',
    matching_hash: '28ff364096ae1d482b9ba2bc866512703ee2ecdc',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'e10408ea9623dd3029e3e993f1d8d6f89ab04e10',
    id: 'range-test-20260619-1904',
    matching_hash: '09a0117301977b8f0e19a5d80bf00e7f02b9f1a9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'e370bdc641f308c79e77ea3f7ccd40fb92ede79a',
    id: 'range-test-20260619-1905',
    matching_hash: '4aded89d3afd98eed4ef026ec0da1f1f7b59c12a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'cbd1ce9e55ab4ed337aca862e17b8186cff13550',
    id: 'range-test-20260619-1906',
    matching_hash: '8eea33bf9a3f9f8166513967472aff90c65dc1be',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '66e06046dba53dc3c94397581c3c3f56bebfb6b9',
    id: 'range-test-20260619-1907',
    matching_hash: 'f866f7b9f299bcbf1d559f444cd48c3caff22443',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '1202f056f4f9fb78683fb57ae0464c3fc43fef70',
    id: 'range-test-20260619-1908',
    matching_hash: '1a4348dfe28e4fc3d3dbcf852c23afdb333d63e4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '4bd06433cab031b3b7951a9581c8b5d9c8d30a66',
    id: 'range-test-20260619-1909',
    matching_hash: 'c263b2b58d817fd541cfd1f6c52908b3dba9db14',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '793edb577c762eacde560a20020d716d3300cbbc',
    id: 'range-test-20260619-1910',
    matching_hash: '064e95ed2db165198578804da6e3e2d7c0ea6fc7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '39bddd3ee3ddeb4f8e9f52020ae75d88dd1e4fd9',
    id: 'range-test-20260619-1911',
    matching_hash: '5345da05e34aff8691e3da52b5af6b392e5e913a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '3b5400ff756d1a4182e37a219d2138fb371953c1',
    id: 'range-test-20260619-1912',
    matching_hash: '38a9fbf6b125b9a8c04e54bc8f15a8d44f823e4a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '91a55a4c596cee8147006cbe6c72f0324a28fbdd',
    id: 'range-test-20260619-1913',
    matching_hash: '6498ba97def7f928e732533275c02cfb0fcee12c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '6df3414684411047ed4985e3c720636edce69519',
    id: 'range-test-20260619-1914',
    matching_hash: '734e279ef7b428122359f02ce4f8fbd657e20a46',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'b0926cb243efd15c117e265ec06232ed4417b734',
    id: 'range-test-20260619-1915',
    matching_hash: 'ce026e3c17a3d6bcb83a7fc40f196be286d5b97c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '64e7985de5c41930aa5ef44379aa04b68fb34ea6',
    id: 'range-test-20260619-1916',
    matching_hash: '053423993e06c21f11e3079382a913c2543766a7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '6b09d662ebdf8bf261f42409658e9267b521653f',
    id: 'range-test-20260619-1917',
    matching_hash: 'af65237e5bf7abfe4aecbcbbf47148fed8dd1b51',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '4f277820d32703490476cb06aebf5d645d0d32b2',
    id: 'range-test-20260619-1918',
    matching_hash: 'c33bd280d56c42a2e2707eac12dd3ece8c9f176d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.542902082,
    qx: 0.336529343,
    qy: -0.12688145,
    qz: 0.75888499,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '1576b49824bd6e8f1586d247537075af50ac7ca9',
    id: 'range-test-20260619-1919',
    matching_hash: 'b43fe844373a35ff4678a5ac3c311b0896a6246c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '522e0945511408dd2541e46f6665ea65e6d481dd',
    id: 'range-test-20260619-1920',
    matching_hash: '7b7a17ac34cb5a8036ebeaf30a4a2a73e06dc441',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '2b11de3c665be669c8e8b828e67bb2edf14e8fc4',
    id: 'range-test-20260619-1921',
    matching_hash: '5cdce0fe391ed664beae9bda24b280e8e933255b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'c89f7d15cbff4023cb1dde57a582fc8d6e07772a',
    id: 'range-test-20260619-1922',
    matching_hash: '80240df41bc1e237f5dfb7a496c988a8d1d9d620',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '885860fea2ea0f43d361ab59d51a902e37fa7af3',
    id: 'range-test-20260619-1923',
    matching_hash: '964e48915c6be6528a371f968e134135804052fa',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '2ce353e4986d37929860db311af275cf94efe587',
    id: 'range-test-20260619-1924',
    matching_hash: '4e8ec174d48f4da161d2df8968da71d267ac7312',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '8c22e168ffacfe53613e305f193cd1ca999a5ad6',
    id: 'range-test-20260619-1925',
    matching_hash: '91b532aee9b33acdb1a1a09dd1efe038db7d4b0b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '45d4643ef36c7df7414fd3657bd402fb955c4a54',
    id: 'range-test-20260619-1926',
    matching_hash: '1bc692396c100367cc8fd74ed48824ec8c3035cb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'ac0d64e25eb6b67cbf19b8afde870ddf255e8eb1',
    id: 'range-test-20260619-1927',
    matching_hash: '1976eb3fe0278fd1a9d14de5427c7052db9c9d95',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'b4741ec74154abceddb5ae071bb637fa7fed1493',
    id: 'range-test-20260619-1928',
    matching_hash: '85ac83abf9c4cd3cffaad1e1a0715bbfd89d7542',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '563f72654a61773940949a115f813e61156011b3',
    id: 'range-test-20260619-1929',
    matching_hash: '6464af67fae328ecfd3a2419ab1e2e191eb463d4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '8ac23233c76ba70ba688f8ddff0d75a7e1a641bb',
    id: 'range-test-20260619-1930',
    matching_hash: '7e3dd1988f7125793e6755f99e083a3339ecc197',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '8f3e56ebda97335a6bff09766f87276db80d289a',
    id: 'range-test-20260619-1931',
    matching_hash: 'b1a3a0735e1782cf7624aba6fc4f87a47db38b95',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'a40ffa37772be13657ecfc8166c9dd52a9bf32f0',
    id: 'range-test-20260619-1932',
    matching_hash: 'bb39d8893cef1b841bb0977af8ae1d567a09d753',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '59adb9d940226de86b43378bc7a575fb237c4691',
    id: 'range-test-20260619-1933',
    matching_hash: '806459f2fd3260e42cedccdf312c4f2186967a59',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '354f8510f082cfd2de795147ffe0e168df77d891',
    id: 'range-test-20260619-1934',
    matching_hash: '9a840ea4c0a250857898e0b5c704359760360078',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'db4b976b830a68df2a7da55a9c2878e6fb0fe65a',
    id: 'range-test-20260619-1935',
    matching_hash: '29f696cd010c7b51af5e58bd43df90d0c27ff0a9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '1fd18db0d97b23546e0a0d554547ef3d130e47ff',
    id: 'range-test-20260619-1936',
    matching_hash: '649dafc37f87089f72576480f9b3634dddf1052a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '0b9f99287d496da5147687af31e43c3d07281880',
    id: 'range-test-20260619-1937',
    matching_hash: '9c772fb61d350f7fd56c45ba66ce8d79af0528fe',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '42840d2a4e7869ccfa1d654572840aeac8a914e4',
    id: 'range-test-20260619-1938',
    matching_hash: '56a5f821d96c012c3a899dfc2470e97f5e2f04a9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '17dff392f2ca35d81b928254559456715eb65c0d',
    id: 'range-test-20260619-1939',
    matching_hash: 'c0737fffcbb8bc993b8060642fc58b4c71233340',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '0aee6956b4e546ca5e38fc7e5b194fce5147db07',
    id: 'range-test-20260619-1940',
    matching_hash: 'fda0dbf7f21aa2138c5757209b6ee637231a7cde',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '61d981b7e888c70558d00d70df33f3a574b82df1',
    id: 'range-test-20260619-1941',
    matching_hash: 'd476737471b23e1a653fcf036c14983a590c26ca',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '6b4d0009babf3d215a13cc856e2d51f1d9231669',
    id: 'range-test-20260619-1942',
    matching_hash: 'a900cacf5102b756c327e72a8c3ee87e2e120d53',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '5440ac542e922f4dc1e4afe41bd86b7ce218e765',
    id: 'range-test-20260619-1943',
    matching_hash: 'bd6b79a3a1c10670f60ebc10a8ac6fb6dda52b67',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '492463875d1797641485a5cd88f16f89f1ffcb18',
    id: 'range-test-20260619-1944',
    matching_hash: '8704dc264754f38caf14bd0b34b251b7354d5120',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'e3ea8b39a6730edca11ad1686c10417c87d99df3',
    id: 'range-test-20260619-1945',
    matching_hash: '4a985babbbeb12870d652ba34ca253991012490f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '40f1c1eebd07419a169268be101c891053ca5b60',
    id: 'range-test-20260619-1946',
    matching_hash: 'a0fe8fddbf584b07c7cf827d8054cbe2e3cc54c4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'b80c4a4214f87ff6ec9c38f0bc5edbf8fcecf2e2',
    id: 'range-test-20260619-1947',
    matching_hash: '3dd8f38334796b72492de8418987daf44361ad16',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '193879e6318ec14d727a06bc0a8efd188b212e79',
    id: 'range-test-20260619-1948',
    matching_hash: '0d7ccdba27ed253c37e072d2ad4660b87e27f663',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'f82c81e635a3feb8f39c2390b3b0b0a0a72360e0',
    id: 'range-test-20260619-1949',
    matching_hash: '5f12041e4cdec1670d297deae7111ee217a84a49',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'c1c5e276aacb3d12b80b03c18755385be7f2f991',
    id: 'range-test-20260619-1950',
    matching_hash: '5f27aa4a7209b3b3fbe4c1d7f934070740bf8ac1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '8d0c6ff38d93ea724b2354a75538fe6f35f0a1da',
    id: 'range-test-20260619-1951',
    matching_hash: 'd2c4c7924f8392adac4eec8509334df05ebf395a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '6fd4c7210569dbfa8a35c41a41ed1d7c1f6b8b69',
    id: 'range-test-20260619-1952',
    matching_hash: '3fc571253b1f818fb183a5d025a3f419af8efcd0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'a74e79fd50db077fdf06d09d2d769655d575e7b2',
    id: 'range-test-20260619-1953',
    matching_hash: '418c6c5742dde68e0c5cff8ed4ca631cc5aeb54b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '3b9ae294220d7cf464e35cd50f2b838ccf4091cc',
    id: 'range-test-20260619-1954',
    matching_hash: 'e8400cab59ec76382e13010606845cbf1a46cae2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '919342d2c70fce2292c52b8207df386b1c3da8d4',
    id: 'range-test-20260619-1955',
    matching_hash: 'e79f40f43143625b03813957afd93c474dae7c26',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'eb90646a19ac4f055a580fafa857cb94e558598c',
    id: 'range-test-20260619-1956',
    matching_hash: '0d8d538fa520cf638610ca38e587f3ad7003c666',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '7e4092e325881eb7f41a45c93064151eb7cdb8a0',
    id: 'range-test-20260619-1957',
    matching_hash: '8a7d77898e8afd13a9f439a18c0b48c14e60fea5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '137b574154833f4f91fd760cb9e8c38b118ffd3d',
    id: 'range-test-20260619-1958',
    matching_hash: '8402fa862be4a252833bcbc5d15d413a94444d86',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '9db0ff590493f427bfb8b12e9dc80593e8e52c95',
    id: 'range-test-20260619-1959',
    matching_hash: '8ff34d75824fa08c792b42cf635cf39bdfd6a602',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '12b3463fb9add0d57d9bdf3d70a9d4b45b587f34',
    id: 'range-test-20260619-1960',
    matching_hash: 'cee67579214e22a23d84c99e04c7d0238ca908d5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '47b5a3bd81c80933302d40abb164b06eec09f86b',
    id: 'range-test-20260619-1961',
    matching_hash: '61bd113f65cbae5ff4afb7a98562480509adf35c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'eca858e995368d9764a198e2dd95d4e229e30779',
    id: 'range-test-20260619-1962',
    matching_hash: 'c16e3fa86c2c6484a4e067085308e0831648eab8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '4258b6eaba7e26d55911c1c6bc9273616acdfed9',
    id: 'range-test-20260619-1963',
    matching_hash: '82b9bbc377cc332ddec26aceb54fb8f995f481b3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '18e4490dd5d2ac5729dc64831ddddd9e2d8fbb39',
    id: 'range-test-20260619-1964',
    matching_hash: '3f2d2b872419ee2e7c7cb14ac8c77c8d19ac03c2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '01ef7312e7bbe18e9af91a62ca714dfd81df4ab3',
    id: 'range-test-20260619-1965',
    matching_hash: '504a071dcbfe0ef0b63754d9cdc0751591d2b095',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'c123095656a2c6009444a1deb8cb05fab64dff1b',
    id: 'range-test-20260619-1966',
    matching_hash: 'fa49f26e3fcb9f045f5a5b676cf0baada7e801c2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'c44e645da1a49b1006700c527670883d852579a2',
    id: 'range-test-20260619-1967',
    matching_hash: 'db342e19215b264f02a59105c05f27c996f0becf',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '30240fa0c70a8a2082d12f49b158d676cc8deb74',
    id: 'range-test-20260619-1968',
    matching_hash: '217eb24ad4dbb026309173938f59e2539da65079',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '6472d4f5413ea55e00b248284ecd656337495612',
    id: 'range-test-20260619-1969',
    matching_hash: 'e805135688700276327d33b9b633e929a6bf49ba',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '10f1d4717f18096cd7c067a1a9811078231b98dc',
    id: 'range-test-20260619-1970',
    matching_hash: '9adf64e3903423a380c43a496de4484555841ffe',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'f24c41c50463494454bc1d44f7a0558adada21f2',
    id: 'range-test-20260619-1971',
    matching_hash: 'a30e51e7eb5973d2f0720eb477791827b131bdce',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '1c94167e53345334a22786634f26889ebfc30779',
    id: 'range-test-20260619-1972',
    matching_hash: '6abcca896a0107e1f78ca7b4b6b110db95b96679',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'b109b6ae9833195f1b3380b76c22cf7fecccf35b',
    id: 'range-test-20260619-1973',
    matching_hash: 'ca8ff82b84c34867d8480a8b1bdae7de4e559966',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'edac3f4fdf8278ea1137f417876be9d8f9cd67b6',
    id: 'range-test-20260619-1974',
    matching_hash: 'e8e8de65fc7393dd68c11def2ee79e8b69c33a6e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '14faa86230adcaaf68816a4ab50da747cb9e3d3c',
    id: 'range-test-20260619-1975',
    matching_hash: 'b36d5b83c145fa7ec71018ed479c5d49f5c95493',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'f822c98e6d6c5bf87bc968147517d639221aea7c',
    id: 'range-test-20260619-1976',
    matching_hash: '776e8570afff03e4026c166db6de6c0b1c89f3fe',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '0b60a409b16c835d8826d8c08a11d9c90f29e556',
    id: 'range-test-20260619-1977',
    matching_hash: '5c179f87aca306945e67ac5a89879517015df3b0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '6e45b573d4ce61b25a5052c04eac15873a61d37b',
    id: 'range-test-20260619-1978',
    matching_hash: '040319f88e3be96638b554af3210ed6838b8753e',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'b958c834bef006cfd632c131942a64c0c06fab8c',
    id: 'range-test-20260619-1979',
    matching_hash: '1d363344bca1f186fc26fd5da839e3de9047747c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '942d116b5c16d39d397e4d24e6810ee4390aba4d',
    id: 'range-test-20260619-1980',
    matching_hash: 'cbc96f42f7a8330ff69d112bb2fe1b87b33cb442',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '8d248ea5e287fdf71f808ea9f0094a9cf5f4a3c3',
    id: 'range-test-20260619-1981',
    matching_hash: 'dbf15092b0419e7f22b1bbd9601424d455bf7894',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'd0ebe6287f1fc74fcbd4d7cd35e0a868e0cdaa11',
    id: 'range-test-20260619-1982',
    matching_hash: '398332e175d0d247aa47131b3e0a40167ce96afa',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '22170ef15456914b2c045fa3de47e95a13a06829',
    id: 'range-test-20260619-1983',
    matching_hash: 'f093f151dbadc3ea2cd4754915e4bab8e2ff1eb1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '0b6879607851d662db95497e6d633b1d4488d9d5',
    id: 'range-test-20260619-1984',
    matching_hash: '9b84324936584f48673c68d0d135f6a9cfd1b257',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '3d74c2c6f6d575188f1739160645d97b9da2be37',
    id: 'range-test-20260619-1985',
    matching_hash: '69c56a6c2fb079b6f2f1103269b2a33756c6ca44',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '473dbc0fae025dd78b60550efe4d320225bd7e94',
    id: 'range-test-20260619-1986',
    matching_hash: 'd50c159f128d43e1a8ba4621c75361f332c9a3a3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'c6c5d5bf3036d1222a57676a5101e8d0e87c991d',
    id: 'range-test-20260619-1987',
    matching_hash: '53e4ea22dc12f70326aad102da0fd5c836e137cd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '26aab73c4f3953b6453f1c5455da0b2e93a7d1c7',
    id: 'range-test-20260619-1988',
    matching_hash: '47f36b1cfab27967b35b05d366fd17d33e0b6aa0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '427f12d0c4ab1e57e491cbf3bfb64adba7dcd475',
    id: 'range-test-20260619-1989',
    matching_hash: '632aaa6c52d4fc872ee08e98ffe79abf5741abe7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '4f1e2e7467648c4ef431f4bfb8d11fe0e22f3da9',
    id: 'range-test-20260619-1990',
    matching_hash: '1eeca605198a8ee81e9f2cb75f639039a8c7ab04',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '8e508624e8b3da88bbdaa6fd9a663b13b672028d',
    id: 'range-test-20260619-1991',
    matching_hash: '38068edd733ab32e68ee001779f1f24259b02b44',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'b1a11a45e2aef65c9ab3af1af18cf148ec363c0e',
    id: 'range-test-20260619-1992',
    matching_hash: '6604737797ec4482540f2ee9a266152f2d96a141',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '10f683fc9779aefbc5b8731013ea40863e779b99',
    id: 'range-test-20260619-1993',
    matching_hash: '15b03d61eb2cd3a401093cd50654aa175fde59a9',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '50cb24821f73a3b3cecc984402e7a87c419a3888',
    id: 'range-test-20260619-1994',
    matching_hash: '370886d3bd42e0ad946d5d6136af6375a6564ce8',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '78d69513470e9169e6e35b8bb80c02e49012f8b0',
    id: 'range-test-20260619-1995',
    matching_hash: '986e9f88bcff43205cbc035f2586d26cb3a5d27b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '0fc75f4a461e4a576933c21c93eec73599112c1f',
    id: 'range-test-20260619-1996',
    matching_hash: 'bafc60a43cd247186fb09a9cfa4c9b64f3ac225c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'fa165c4d535ce65d25849880a9410e1f08d4f0a3',
    id: 'range-test-20260619-1997',
    matching_hash: 'a0a94cbbe53649f21cf4ec5d8b6a8e4b66c133de',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '52150798b9f59f63aab23f4fdf6c1b4e2c757b47',
    id: 'range-test-20260619-1998',
    matching_hash: '42e040324c7607ce8688cc9259304968b7a7c9d1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'a54dbee34c9f9ce01ad6b6f53020e89ab6c03f37',
    id: 'range-test-20260619-1999',
    matching_hash: 'b773532589ed6515a060052351b9f6b9f432cc73',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '38b88959b0824c3441ca1235b179737a2b98bc7e',
    id: 'range-test-20260619-2000',
    matching_hash: '4ce89f8fd33110ad6f0aab1cc13d58f0b7896144',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'dfbdf28714df2984cc38470366acd8ddbe5f213b',
    id: 'range-test-20260619-2001',
    matching_hash: 'f4edaea5a99876c09a8586b211b2d14a1fc8ee83',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '0aa077fcfc7d0d468187d7e3627ad7bbf6662c13',
    id: 'range-test-20260619-2002',
    matching_hash: 'f4241d366f76c5e87cf785c6336c2062d7a07f59',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '61bd51b65bdfe125777b195be84fe8e762cf9350',
    id: 'range-test-20260619-2003',
    matching_hash: 'e7c4b38ce206182005320878208177c9282ddbad',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'f1668efdf709d355ad1b370913015f5658dd5072',
    id: 'range-test-20260619-2004',
    matching_hash: 'd642016bc6ca86fb074316923d01fb9403356bea',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '2235d6e4517e16e3b57579541d6e44b25164631f',
    id: 'range-test-20260619-2005',
    matching_hash: '550f4ee5179893c1be31350b2dc25900aff22409',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '5a6aed0726076b965b38f3244e952acc444f0e0e',
    id: 'range-test-20260619-2006',
    matching_hash: '9a4cd9d1c3f586e14baac638613667adef5dd103',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'c78c09c6b33ff4c494c80e4142ad1f52eab94a92',
    id: 'range-test-20260619-2007',
    matching_hash: '72fb9744a5156a67ee79c824f5f74a66a8ba10a5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '46d509135131d15f4ebbb8d730507b4cb5e6f2df',
    id: 'range-test-20260619-2008',
    matching_hash: '2f845e7c4a0760200c69c425ccf6d18cfd8af76f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '273bef1da5d97c47fb7aab30df2b94175d8fb6e0',
    id: 'range-test-20260619-2009',
    matching_hash: '52e9b85097cd111c8afb698dc534621b5c954d9f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '7cc8376877667c4e570fff6a69761eb7ed13b73e',
    id: 'range-test-20260619-2010',
    matching_hash: '04323fedd1d3685bfbe551fd07bb7e9baa396050',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'b9ee40dd7264c2e515e2b2bdabd50add9d1acbc7',
    id: 'range-test-20260619-2011',
    matching_hash: '280eee4fa92becf2f85cceb7135ea5e59bd5f247',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'd034b3bb1e4a655124c2303f5fd5db40af1ad8d0',
    id: 'range-test-20260619-2012',
    matching_hash: '8d7c236f661aaad7c840659e09b5843b90de5eea',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '4489f41aed5d235e831d87a024655d1c0262a0d3',
    id: 'range-test-20260619-2013',
    matching_hash: '703d44f96ece0eb3cc3375ef27d3ec5e9b498df1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'a89761ab63377c234eb6fed9b00b240f627f6b23',
    id: 'range-test-20260619-2014',
    matching_hash: '966b0e6214954dc4950f94277a8b2864d933ab53',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '667cc799dbafbce135b46561146e5592e044a9b5',
    id: 'range-test-20260619-2015',
    matching_hash: '74ed2b3b315cd71b747016b3efb6aac39883cf99',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '835fdc63575c6980b98f7747d1624ecef174efd2',
    id: 'range-test-20260619-2016',
    matching_hash: '6eef1be0e0eb2ba2c96ece19c1ae10f8da6ad194',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'd048e74750fd9edcb63556197261eb8f15b8da30',
    id: 'range-test-20260619-2017',
    matching_hash: 'd157224b8fd46b49fba730d2a0703a6eebb5e0ea',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '0b16a9736d5ead3b3e150365919817a4f4014f3c',
    id: 'range-test-20260619-2018',
    matching_hash: '5976b3b177218dc5a7a18c6010f21d3cb9e0b941',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '3fad145be96e2721e1ade3b73be28d4fecd8491f',
    id: 'range-test-20260619-2019',
    matching_hash: '4674840f547aac435a52801c76d66400764a0e68',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.304775659,
    qx: 0.36030871,
    qy: 0.027744194,
    qz: -0.881203547,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'e902e0c6296ee211ebfcc681361b9e2d1bc79001',
    id: 'range-test-20260619-2020',
    matching_hash: '06fc077e05330523d97365dd3ba07d8ba40283c1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'bd1e709752a48c7bee762e38be94ed1cd1d457d6',
    id: 'range-test-20260619-2021',
    matching_hash: 'c9e568cf36abd36ce502e60c12324940381062af',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '0ec7559f5265e427a7f3ac35a7814d4d62ef9dff',
    id: 'range-test-20260619-2022',
    matching_hash: 'a6ec721bc3406a8f49af651cc17778564daa1f92',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '2eabc0ba37cf245f429c49765e4d8ebed267e031',
    id: 'range-test-20260619-2023',
    matching_hash: '4f092e2412f9f51bf983ee7ae500a1c9d093a3e2',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '9bd35fb0a03db92b3580e6b80025e65d0986bd7e',
    id: 'range-test-20260619-2024',
    matching_hash: 'ef4e30175e6efae6e30392ade5d5faaab09cb379',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '27dd367c478e3a73fff65dd16e8f60637a0ac924',
    id: 'range-test-20260619-2025',
    matching_hash: '541ca1458b7554baeed3f32aaa910ab2da0b6f52',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'eed79cb3e3bebec99025ceafb4497ab8f1022da8',
    id: 'range-test-20260619-2026',
    matching_hash: 'e6bb6b614a6a999509440592b54ba52351826c7b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '3ae919e5523c0e2ae3f09efc157bb60aa8a3a13b',
    id: 'range-test-20260619-2027',
    matching_hash: '7e424727f1cd5aeac44fb596d38c055e8d91d6c0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '143f04e82a0f0271906efead3d36a5e2ba1c156f',
    id: 'range-test-20260619-2028',
    matching_hash: '1786c9e27d8533c8de7d23f5268ff05921fee9ff',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '20a3c282df5f8bdb9c391960e9a0d7a8efc393b4',
    id: 'range-test-20260619-2029',
    matching_hash: '9789e3f7cfc1de21bcae91e15fc7dc8d7c536fdb',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'aa630803d839649e104234d1baa53a980659346d',
    id: 'range-test-20260619-2030',
    matching_hash: '402f34ec4e48ba46a222a84c388a39162729342c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'af6b35ba25ddc0695a405bd68e61921b6b48ed6d',
    id: 'range-test-20260619-2031',
    matching_hash: '8bebc68d939bc613b4865151d774f34f301244b7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'a934e1c08465861bb7da9b2c526bc632cb114df3',
    id: 'range-test-20260619-2032',
    matching_hash: '1edc66681d4fcc9deb9316da6f7c924404151aef',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'c794e7f577123d5f2f2b8974b781835e9306595d',
    id: 'range-test-20260619-2033',
    matching_hash: '3d243fc5371c5b7a0398f265814a015eddb7f637',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '5da3b6d38771698551c787145e413d1eed6d252f',
    id: 'range-test-20260619-2034',
    matching_hash: '328e1f620f96da2480bd2b818ab6b396a6462afc',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '4ad5a3203d8c850adf0b4d458fca10672691339a',
    id: 'range-test-20260619-2035',
    matching_hash: '6a6db8272e7cfd6fe90630f2f0534b5dc7d3eeec',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '23708210582bbbd61aa9804c262d32c3a97bac59',
    id: 'range-test-20260619-2036',
    matching_hash: '90b89160d2d00400194b130daf91d341a35b5935',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'b88b68b3ccc98be7c46d164a89acc92d0cf5855b',
    id: 'range-test-20260619-2037',
    matching_hash: '897933d5a70591b33de2509c9baf07e631e24a49',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '65efdd8611c9aab425af8c91df457c22ff2436bf',
    id: 'range-test-20260619-2038',
    matching_hash: '91b681dbde510d958e2a2d651f01b0f763d7aeb1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '2cc68ea41bf11176d8b9959e5ad45b58cc07642c',
    id: 'range-test-20260619-2039',
    matching_hash: '60c44b7c51367b0134114dea73237181a01f3915',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '8e4296b937ce51a5cb15599ffa7aa3560b1174af',
    id: 'range-test-20260619-2040',
    matching_hash: 'a7a9910e35092abbbcfb21c0e9acf3285cf819d5',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '42fda59093982bf3f210a8dd1a2e129202b58861',
    id: 'range-test-20260619-2041',
    matching_hash: 'daccde77d07735e35ce4bd2ef140964dab8be796',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '6bbbae44d319b06f2506a67236736cad067a6e4f',
    id: 'range-test-20260619-2042',
    matching_hash: 'a14684d56e53f5feba9967296d2f2ac123f2b5ba',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '1de207486ba28c7681420afc20ccb6a71d13ae07',
    id: 'range-test-20260619-2043',
    matching_hash: '1783b50b50ce9faf191af93441e03a772708ca7d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'b8fa42819f6cb7c00a5bc1595078f04d6811991f',
    id: 'range-test-20260619-2044',
    matching_hash: '259a4bbb5d6663b394ee1e2d0b5566290bf1f12b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'a68d5714b54da5678d4e002311bbe30b8df9c573',
    id: 'range-test-20260619-2045',
    matching_hash: '5cccf0ddc980c5e79573079ddc7620e011194727',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '88301dec8e911c2d8f7263a9e6221af0aa61b37d',
    id: 'range-test-20260619-2046',
    matching_hash: 'cfc482e40d3cdf8963eae6552b05225aed03ece3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '9c9f4fc37cbd82caa04b105fcbb5d5712a5a0f4e',
    id: 'range-test-20260619-2047',
    matching_hash: '6a69ab370d3153bf9290f87525edf41ee1473599',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '26620451408ac54582deaa14e9bb5e61c8c9b321',
    id: 'range-test-20260619-2048',
    matching_hash: '021aeec714b3c50914debd0cda7068e156a7887c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'e115137b224b4a4d52863d460c88dc9a3da7109d',
    id: 'range-test-20260619-2049',
    matching_hash: 'ffbc2f2a862bbe31094469c4d9b3008f47be0cde',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '1e4423822c7bd54e369e65739c00e7905a4e5b5c',
    id: 'range-test-20260619-2050',
    matching_hash: '448fe7a265a5b4e84dd9819142b096e42fec743c',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '466c69122d149146a31f62560b4a4b3cdedf5564',
    id: 'range-test-20260619-2051',
    matching_hash: '9f84bf536141699299a829c5d80d2e805253a216',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '4b2b8df80d40b86f14c75a853f070223252d0abe',
    id: 'range-test-20260619-2052',
    matching_hash: '3bc17b7a979736b8712d9bcb4377b508747fb9ce',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'd3dc82e1c267a1bc4d301a336c2c71b5339167aa',
    id: 'range-test-20260619-2053',
    matching_hash: '994d5964dc7ba1df55d8c6f7d66cf0743052c93a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '5098bec66498e222f3009a3e97bd252bf23e0f74',
    id: 'range-test-20260619-2054',
    matching_hash: '17163a0a016f0c89f0831792673affce682c0040',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '7a6cfb161f43589fa3fd1ac7e8987fa48a38ee8a',
    id: 'range-test-20260619-2055',
    matching_hash: '8bf20fa858fc9360ec8a1ee167a93d3998f99b57',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'd63cbf8ac7f333d5cc194494f2ae0ef171ba4eeb',
    id: 'range-test-20260619-2056',
    matching_hash: 'f4530b3f027a596bbc92695b76e5930b0e9e57db',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'a66598682f6826d2ba6a8ef9e846bc882458c6de',
    id: 'range-test-20260619-2057',
    matching_hash: 'dd09f7b3d06cc97b04c28f39ddbd44f503cb96dd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '0204475c78a88554c2a7f715486ae064c9b611a8',
    id: 'range-test-20260619-2058',
    matching_hash: '66ff2f5fcccef432ec5d1f61036857f6c2859668',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '8882a4942358dbdc7eee62d40662ce1334d98f08',
    id: 'range-test-20260619-2059',
    matching_hash: '9f707e2bbb21033e895be01982b48743be3207e3',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '770c0284b560b004820b81ac2e869bf36e173d04',
    id: 'range-test-20260619-2060',
    matching_hash: 'da344cb829b0976676c764b16b46452c953f8c28',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '9efba0ecc7bca1490ad9294457ee35e488196761',
    id: 'range-test-20260619-2061',
    matching_hash: 'b208506e6c7e40f89216d7187dd6c1aff485f792',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'a09a7835baf0a31b559d21e00b8c38b76ca0873d',
    id: 'range-test-20260619-2062',
    matching_hash: '909d537e85fbebbe62bd115f20581c3759ab4c56',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'e27cdb3848046d70d87a5814cdfec28f5a8a3780',
    id: 'range-test-20260619-2063',
    matching_hash: '41ef4c64acea307bbd979c2469c01274fb127159',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '16f98f7ccd33c2bd1a5024c067bd9687dc6f68c9',
    id: 'range-test-20260619-2064',
    matching_hash: '96cb1dbd52adc3c606da73385643b0fd87664edc',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '6771b039756f2072e802ba97840e11c239fc8290',
    id: 'range-test-20260619-2065',
    matching_hash: '72cccd9c1b7fc902d4de68f47d9dc331c95b3311',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'e62e78d29425c564d06977c00424f1f8c3f16ea2',
    id: 'range-test-20260619-2066',
    matching_hash: '035027ca20e84f1d2d5d861e6e971a23965cec68',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'b69702b49cb616931ae4422cd8e61c17b0101a9f',
    id: 'range-test-20260619-2067',
    matching_hash: '0044369006599ea58cdd1064e214debe2ceb9f75',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '7a1a29ba7699e3575453e48ee44c23220910ed41',
    id: 'range-test-20260619-2068',
    matching_hash: '810f153554461981cd87db78ee8a6690fbc756c0',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '0853929826f31d35461ae36ecb76bcdc6640697c',
    id: 'range-test-20260619-2069',
    matching_hash: 'd21de2054ce75c9df94caf7435068efcb61ba13a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '1f972d985952b7a1410f628b014145bb42d97a63',
    id: 'range-test-20260619-2070',
    matching_hash: '6fa33296abe495703941e92da7de1ccd39c741b1',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'e5f97952e5d36e75c348a4afcba640fe0460008c',
    id: 'range-test-20260619-2071',
    matching_hash: '86abd6a3bde40c3d8c0b90b0fe43e957841b5ddd',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'cb6e096c828a70a549083f2cdbb9d1259a99c1eb',
    id: 'range-test-20260619-2072',
    matching_hash: '3cc57b593ea9122cb81e3fb05ee9f4aa78cfeb16',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '4c3ff3b0fbd7ae44722f6af8cfb4b17f2adae0e5',
    id: 'range-test-20260619-2073',
    matching_hash: '1778d03df6f16c7859d046cb80797e9fa54adcfa',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '864e83f1968d5b6c920b9966dc9fc3178c1faeb6',
    id: 'range-test-20260619-2074',
    matching_hash: '50302d330968f483b2a975d330ecb95526acc201',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'a0754752bc53d02475077e435f2728edfa7ad591',
    id: 'range-test-20260619-2075',
    matching_hash: '640a10dde54bb3e3d1fd68fbd02c689fe8f4a86f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'eb113eb969d88e8f784057db90341a05221e21f2',
    id: 'range-test-20260619-2076',
    matching_hash: 'da99a6c71c92f7c0df5033994e8f495387c3f45a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'b236f0a668e760366e110ec4e5f7b5e730728c84',
    id: 'range-test-20260619-2077',
    matching_hash: '86c922797fc040bb72a52c826e2a0f798ac3af07',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '1a2c02db5643f2c81aa5038c2f974701fd85f2d8',
    id: 'range-test-20260619-2078',
    matching_hash: 'db907427da48a7b9ae3f81da1bbc5ce0b1c3ef56',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'b8e489f83357ddfa7221696f3a278e47059117d7',
    id: 'range-test-20260619-2079',
    matching_hash: '9799d02da4d3e3081c1ae7c8ad4f80278026c2f4',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'da352a95cc0d0d77272b4282cdfc3741a8aa0b2c',
    id: 'range-test-20260619-2080',
    matching_hash: 'c071328f5e47d7b21bad436b185bb13521fc1411',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '743fad19dc315c8100e2b904a6806323e5545ceb',
    id: 'range-test-20260619-2081',
    matching_hash: 'd100dc89182e7fdee25f7bc74e31792b8083bafe',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'b8fb341e5bc60d29cfa901276c85c4d71dfeac2e',
    id: 'range-test-20260619-2082',
    matching_hash: 'fbc8b5cedaa53283fe836de1a0340b17766f3c03',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '59db0a9f0113abfba4407a0eb5d69d65ee9807de',
    id: 'range-test-20260619-2083',
    matching_hash: 'df7be20ab78b8e76ecbd2baf5b4194cdb567b82a',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'ee878a8a6800c2a604e08e04f3f2779085767d3e',
    id: 'range-test-20260619-2084',
    matching_hash: '7e68183a121104d6bbfe47cac7e358c3e6295b78',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '5a79badf3d908fc63595c518407821813e5b3cca',
    id: 'range-test-20260619-2085',
    matching_hash: 'a929e128cfdff6506638fb705d39cc25222cfc88',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '57cbfefc01f576dcab2ef66d9d604f96eed5f404',
    id: 'range-test-20260619-2086',
    matching_hash: 'fa9b8887523d7a0513a2cec5e861e7b46ab93670',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '06adcab97eda18661fa3a1f6692a543e1527849e',
    id: 'range-test-20260619-2087',
    matching_hash: '55146fff55276a974a971fbbc3d38e8ed7111e42',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'ce27a07fb874b33bc9a5704a4303fca7e7aee986',
    id: 'range-test-20260619-2088',
    matching_hash: '474b6e4a77a7e1a2c1dca4d95d7a1ba092d1b17d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '781f4929b9dcd231f37c6dae109d324257954318',
    id: 'range-test-20260619-2089',
    matching_hash: '55f86f88e15ad6660b8cc2bfb4ca0bd496d65fb7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '6d03d889e130bedc20528652bced99a2dd21a3ab',
    id: 'range-test-20260619-2090',
    matching_hash: '6fd9df0390b3582b85977d466917f459791ce70b',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '31518ab8987f7c34131557ab148020ae3f19bb64',
    id: 'range-test-20260619-2091',
    matching_hash: '3843234de3cc8bf929dbcaa440dc8a59d26667fa',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'ae1fdd271585c973d79e8a25830527b71403e950',
    id: 'range-test-20260619-2092',
    matching_hash: '9d18504e8c04551d2d07b648d0df619518eaf71d',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '4cfc17655854565ee0af6b9c7881954c19c5d783',
    id: 'range-test-20260619-2093',
    matching_hash: 'a92e03c74f9393bba35241469e588631979a0dbc',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'a8b4ba36d5720dd69801003a568a5350611c880e',
    id: 'range-test-20260619-2094',
    matching_hash: '2a8011939ca3d9fec3b2644db3ca54a28976f444',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'a41e8ca05a41d054ef0c55dcd4b56c580d5684ec',
    id: 'range-test-20260619-2095',
    matching_hash: '6bdba74bb2b97de84ff82e5658bb484e0899856f',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '0499ed5bb10012f4e0b3df76de92d5a6f499c1cb',
    id: 'range-test-20260619-2096',
    matching_hash: '2f84fb52a9ca90a71b6245a1e253e0123efa9483',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '459d452c1d6d30dbe218af8c3e45c1fb70ff7e4c',
    id: 'range-test-20260619-2097',
    matching_hash: '939526b7ef629bb6276cf7fe4168fd23108ca6e7',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '40ca2035b30659e43061de633e1971e61c6cc897',
    id: 'range-test-20260619-2098',
    matching_hash: 'b6789608b57a64610a2582b33e62c542d65e3c53',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '0c099875c72cf3dcd4cb1dd198a7564a7ecd83be',
    id: 'range-test-20260619-2099',
    matching_hash: '3af2de82a5aaf54f2d979197ea6e7fd9de009b60',
    model_id: '',
    model_key: '',
    px: -2.4,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '9a879595a9cac6000663cde2a2c6bcb47e4abc1f',
    id: 'range-test-20260619-2100',
    matching_hash: 'd0e06387cc9d64a43e90e7fb4bd6873bb9da2751',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '3b103c904131a0e0ad938680344f689694a37d11',
    id: 'range-test-20260619-2101',
    matching_hash: '476c82a214dfd308f6be6b679333c671a47128a8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '4d6cfa131d3db639753bb96d3ac803219a1785c6',
    id: 'range-test-20260619-2102',
    matching_hash: 'b493c7f34bb2b8c441d6b7ee864907b4018769bb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'a9f28c53b4c6ad903612ff2277ea08f51c7d861f',
    id: 'range-test-20260619-2103',
    matching_hash: 'aad355863fe6b00d34fd2ea4626b587622c511d0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '5ab45f036e419b016f0a74e3db6a69c2d3bd6661',
    id: 'range-test-20260619-2104',
    matching_hash: '2cff90fd4dd3b8b22ccc03cd6d67aa7b84ce8da9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '48384df60cf82637a8918af1529b6730a9176134',
    id: 'range-test-20260619-2105',
    matching_hash: 'e5e71d728748a0ea5b1ad5a4f41e132d391be8e6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '4d5f8ce0f31ed61f56d05462a3108203083615ed',
    id: 'range-test-20260619-2106',
    matching_hash: 'a517540f8cad64fb23f6b522c6e6f3f290009685',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '9d9ab41fb0f3ecdef0f15059ff110702d3d8ac01',
    id: 'range-test-20260619-2107',
    matching_hash: '8f2575894b681ebceb2f7d1485d789b5673e4a66',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'c27ffd1a05e796e8d96868e568b8c94dbf0087fe',
    id: 'range-test-20260619-2108',
    matching_hash: '1d1a038134e05a50820ff6cc3328048d957e0229',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '7ae89abe1c265664bd7cb1b8fbb9de9373a9cc78',
    id: 'range-test-20260619-2109',
    matching_hash: 'a72f0bb36ca3042a6893d229f36ac9f77eb62798',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'aa1cd033ed55f7c4704b6bed2f22100653ba84b7',
    id: 'range-test-20260619-2110',
    matching_hash: 'b232cc8dcea383238d5b2fa289f86d2365b06373',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'abbeb350eaa2abf56ca3fad2f9b68012a8a45b6f',
    id: 'range-test-20260619-2111',
    matching_hash: 'edcd7d161cb8ce5ab79f126858fa86c0d0e55355',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '3543ff268819d469ad2f63a3438f4eb4f4bb038e',
    id: 'range-test-20260619-2112',
    matching_hash: 'e81632079eb5e8e03495bddf786d1f71563733ea',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'bbb3edb7b2b238cb15879c15df9c0efe3599f13f',
    id: 'range-test-20260619-2113',
    matching_hash: 'd9bf7ac0e3b55f2e814c4f7010c9ff66c5b32825',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '111673257c517594d2fe9b2b686f3ef061f1fc2d',
    id: 'range-test-20260619-2114',
    matching_hash: '520ad3cd8392cc57145254283e074b8296986b94',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '10e09f3ac049023343988d81f287a1dfa8c72abb',
    id: 'range-test-20260619-2115',
    matching_hash: '417f6b6df2b3e727e61ae79dbe6a23b48c281627',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '8b99b16e4c0d7461d2a32aa575dcc27f8ee5e146',
    id: 'range-test-20260619-2116',
    matching_hash: 'de72620fd2f3b6a65d4b3d8f727aea5523940b86',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '089bbbfd958e2cc58b5280efa0b7f13c0bcd4733',
    id: 'range-test-20260619-2117',
    matching_hash: 'cb315a9cda1c034e267763841f2f726bf7fb35e6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '6094f9c686fd97aac81b6dfbe2a975947241dcd6',
    id: 'range-test-20260619-2118',
    matching_hash: 'c0278617c9047ac55e2887ef534aa293b7f69d72',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '60f2dca39f93d1d50157a803a2904c8a035c39aa',
    id: 'range-test-20260619-2119',
    matching_hash: 'a33e5c3a85b23217c88b3e0d76904d37db09b0b0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'ca4227184fa1bd236eb2fdeb87debeb429db790c',
    id: 'range-test-20260619-2120',
    matching_hash: 'be9ca0e617ea39935d15dae983702a4bd96041c1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.350011215,
    qx: 0.503891059,
    qy: -0.173037598,
    qz: -0.770482926,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'f6abbd89843f38dd6a59c61c64036674e8ef7161',
    id: 'range-test-20260619-2121',
    matching_hash: '398f1eb1c259bb6bc0a047351d0889d7903def0b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '79aa2f51987ef72a1f4efc61572d565356a0e199',
    id: 'range-test-20260619-2122',
    matching_hash: '92a1aff47d9d08d332e6b8225180b8353958df31',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '5af91a897434c8bd9b5a66d5a16321cbe66702f5',
    id: 'range-test-20260619-2123',
    matching_hash: '8683c2284ed8eee6035fe58e2fe064115ff6b174',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '92c359d7b424ab0bc539c9d069b888d77ea20d04',
    id: 'range-test-20260619-2124',
    matching_hash: '540c8e1d0667ce14e1e526134a2aed6cd3c14b34',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'bcf6882439d961b69b40a5a87dd1a8bb87f2a3b0',
    id: 'range-test-20260619-2125',
    matching_hash: '501c766e4392931990279983fa1230ead05051dd',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'c0f44cc9c145e55e06f944dcb17c9c29c401b5e3',
    id: 'range-test-20260619-2126',
    matching_hash: '7d01dda2d105dfbc00fa10a577e25777aba129c6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '8b5ccb1d1f4d2659614e22e847fd6f92bf555033',
    id: 'range-test-20260619-2127',
    matching_hash: '76ba56c3b62e6179243c1576227c8ac790910a0a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '499bcb18c4842c7fcc3334b46df99a3556e94c36',
    id: 'range-test-20260619-2128',
    matching_hash: '4ab3278a1b4db0be5a4002f3661fe10e578bad4c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '0da5e339ba580e99ffe47e7c9e1a3408c423cc38',
    id: 'range-test-20260619-2129',
    matching_hash: '21c4fa64f1615fc39d8a8a92c73b844df189f873',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '1d0e16b2155afdc8a98698079b66286b9b84f2cc',
    id: 'range-test-20260619-2130',
    matching_hash: '7ae870508fe6bbe351a6e06d5acf4d648de8cb63',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '091d717ed732143239f86dd595ac83c08a01d074',
    id: 'range-test-20260619-2131',
    matching_hash: '2208fcf0cefb9513b8c09c2b0660b65cadaa300e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '8bc3c278802dbb315e8ae2f3d34db4c49b47748d',
    id: 'range-test-20260619-2132',
    matching_hash: 'b4e3a29d2bb9980502e366c6694d32732ae891fc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '18f250edcda64df633744f98038e2658ae02f96a',
    id: 'range-test-20260619-2133',
    matching_hash: '7c787fc372bff34547c407d30cd942063434b89a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '281a329758775e002d857ed83072cbf7219f0d96',
    id: 'range-test-20260619-2134',
    matching_hash: '441801cc5c3fa0a3817bdd8470082b411573359e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '06bb1248c6c86075c18fd31e42e923804058418c',
    id: 'range-test-20260619-2135',
    matching_hash: '94708768641585e16eeadfc2edc5ae349c38e139',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '7e7037923e79c1140bb57be0ed79c1a8ffe3f8b1',
    id: 'range-test-20260619-2136',
    matching_hash: '343601e0bf3778ea95681d4b387900cd080e5740',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '66c3b32898bfb44b2d794e209fd2012f033ea367',
    id: 'range-test-20260619-2137',
    matching_hash: '45b14c56cbe6005056a06b58f7f4049c19dc4ad3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '4ae47d81329e666badd2225f99eaecafbd3c11d9',
    id: 'range-test-20260619-2138',
    matching_hash: '72138f84a989e7d610bcd1abf4fddc5ae1fbb214',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'ad39f71185b582d44c7edf8517e91ab9ffb721eb',
    id: 'range-test-20260619-2139',
    matching_hash: 'de180c2bf04fb02752623ac653364c7bc5e3804c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '906a2bc57f769a86e39350ba574082a7ae047461',
    id: 'range-test-20260619-2140',
    matching_hash: '997010f2b14c15c5ff5819bdd5cf4ee0b793716b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'e9eef95d748eb70c6d401a48c7f35acd496ef2d2',
    id: 'range-test-20260619-2141',
    matching_hash: '91564e89fb6dff8eb8c1909132597a758c37e700',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'd9d71b7cec3e2231ab268af2cc44d2df82c98280',
    id: 'range-test-20260619-2142',
    matching_hash: 'aca51673d7994a8f7e4b60f354768e8e56bc0aba',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'cc6c0a8cc9a38e0d39b1d802ecdf077aa2a1979c',
    id: 'range-test-20260619-2143',
    matching_hash: 'eb0a69479fa2445d73887e1c5c59c508b6799f55',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'f87ae3a57c8642dd0a26b67de20111e768d37bfd',
    id: 'range-test-20260619-2144',
    matching_hash: 'a76c61bea17cb8c6bed1422dbac3d097e045e61e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'd0df5bf1bb5dc28834202ac8775117dcf78583b5',
    id: 'range-test-20260619-2145',
    matching_hash: '0a828e9b6c38b6651af13a0e606bece2f55fddbe',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '139ea6db8826544c4e6b57b5126679bcb1dc186d',
    id: 'range-test-20260619-2146',
    matching_hash: '56c855e2444f82d9ed1d39b8179beaa9b5f25d42',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'c02a430487b9bf0299d2b600ab45cd51955d6d4b',
    id: 'range-test-20260619-2147',
    matching_hash: '57d14e8d2e8647f9fa8a7c727a99b9972788db44',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '5d5126476f0a864c38211805dc4b40839840404a',
    id: 'range-test-20260619-2148',
    matching_hash: '359cb98756678a0a9e4e92ead2139672bafbc792',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'f705ef306a4e72685e932537748b3b34e726afcf',
    id: 'range-test-20260619-2149',
    matching_hash: '585c53cba5fd83b54fc45533c52040111963e234',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'a52ebc9caab0c2f4726e6d1c7d7a9ccde1640170',
    id: 'range-test-20260619-2150',
    matching_hash: 'a618f74ebf87d82c0ac7d0c33e46324337d14950',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '0f45d03597d9be212d21d0eb87913d349a8cb7af',
    id: 'range-test-20260619-2151',
    matching_hash: '863a2e9de828c214836cc14085f70909e0edee8d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '9c245a1519e917ca70b1f5128659371afadb2648',
    id: 'range-test-20260619-2152',
    matching_hash: '5cfcb4a8a3767fdc2297e654a497e30d173fa0a9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'c2c47d7b9290259bfd420b6293c3d282e88cea03',
    id: 'range-test-20260619-2153',
    matching_hash: 'b87c3c4cd522ad5059e69353ea12c0ca1f9debfd',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'cd4d3b62b74e52eb95988637642361fdf0f1c92b',
    id: 'range-test-20260619-2154',
    matching_hash: '4a47dcd276d37a9c6e3bf24086493f2127d3a231',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '8b2ff6ca66b6145435091c34a33aa053ef8b7def',
    id: 'range-test-20260619-2155',
    matching_hash: '81bd63850e3c69147edaa76bf5c64bf3854e1a19',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'd2514a00a9743b02ced38c44f0d899669b115f94',
    id: 'range-test-20260619-2156',
    matching_hash: '5676042eec7f6b75bbeb2550eb33223ff22abe57',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '6aed425540dc05f688bb0b4d14aaa1956458e511',
    id: 'range-test-20260619-2157',
    matching_hash: '78cb4663992c8d4d98b0be266a93c26a5a8f99a0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '00d97d29607f93cb8f02c44346226c7b2f171cdd',
    id: 'range-test-20260619-2158',
    matching_hash: '2116e1cfd24d4b669666fb62af21086b466a70d2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '6ee291ca6af1dbe33239ae85803902f0966c735e',
    id: 'range-test-20260619-2159',
    matching_hash: 'f6213c2c47cefad20c9dfb83f06ba8d59234ba25',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'c80bfb65c65abaf850311896c52963f1bdc43299',
    id: 'range-test-20260619-2160',
    matching_hash: '742e852e6b854a10998f189716a9e8ef1ccae2e3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '5047e1705bd2b91afc79296c4c3ca9a876b304f0',
    id: 'range-test-20260619-2161',
    matching_hash: 'ba4f14b022b02c46e7b2976dc9a534a385beb1a0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '7acb7bf157f421bd1a2b42a53342d4bcddae4c91',
    id: 'range-test-20260619-2162',
    matching_hash: '3ddaa1d5948528a7f9b7ad193c0a18d29c1ef05c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '3de45cf59f3522e523c329eb179290a1cb1f0694',
    id: 'range-test-20260619-2163',
    matching_hash: 'f6620186ce014fd40fc3216cb024d7aba040e5ce',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '39f63a0f449010b75337f77b9a980ffc531dc5a2',
    id: 'range-test-20260619-2164',
    matching_hash: '9b0220aea7baab4d886a065b2edd1490f604c58f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '5e0c6446d99017c2b7fd45377edaa6f303717beb',
    id: 'range-test-20260619-2165',
    matching_hash: '4e3677b7506e62fab6bd83fadc4e33d7d0974a16',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'fac8287c32eadcec446406f1b62df235e651409d',
    id: 'range-test-20260619-2166',
    matching_hash: '2862c2d767cea36c16fd8bfdf1b4b5a75e07f8da',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '2d15c1ae50e74d650f3059aaf2c52673510a1288',
    id: 'range-test-20260619-2167',
    matching_hash: '6ca8342b715f5ed5c7d729027a9ec6e9bf8facbb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'c78b8115120eefe89ed43cef8faaa7d8bde66755',
    id: 'range-test-20260619-2168',
    matching_hash: '7624bf337d707b8acd162f095812cdd1adc94f72',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '1978860d3233d3a51e3469fba6d322eff80128eb',
    id: 'range-test-20260619-2169',
    matching_hash: '727bd3ce15ad069a43b025fbcf3068773b4d61f8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '29860719ec35264120c852f40e13f8aab95d62db',
    id: 'range-test-20260619-2170',
    matching_hash: '069d13d5a6134a5074809421c31f58ecaa0c32a0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '46f524fb4f71c6d70671fe70abb410c97fce3eda',
    id: 'range-test-20260619-2171',
    matching_hash: '4cdeda733e40dd5d76d23e4bf179669b2e5d8af5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '88f081aa35e1a85a2ce272766cbfb17b53908ddb',
    id: 'range-test-20260619-2172',
    matching_hash: '2adef892761e38168eff603e79bdbb2e435785ce',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '75ffb46d6bdfa562ac28eb09fbc9ae6cf57e0bb5',
    id: 'range-test-20260619-2173',
    matching_hash: '24c6df2457e56380ac54ce4dd68f06296148484e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'a11c97ceeec5ec9bc19cfeaa3fdabc97040f4acf',
    id: 'range-test-20260619-2174',
    matching_hash: '549780eeea02e8325d7205cbb4489d8228caede4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'ac7ee3c05de192d26271c766ac13f47095112c63',
    id: 'range-test-20260619-2175',
    matching_hash: 'c1e109cfa1cf2b7cc2cd86e73eb19ee67e64f318',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '811c5800979bf232d13e31eff54d67e4df1eea50',
    id: 'range-test-20260619-2176',
    matching_hash: 'ce8143627bb0faf20f2afeddf02f023668e0d3c6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '720713ea73bd9bd861e89b84ae348dc8e7f7304a',
    id: 'range-test-20260619-2177',
    matching_hash: '2c3c2997a21e663f6bba2500e36b51ea9f218c44',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '0604cc7538632f9ba73cc113a8143d944d5202f7',
    id: 'range-test-20260619-2178',
    matching_hash: '4ad23d32c6940f143f374710bcea61b90e2820dc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '185ba6994f32b9c7c1f78cb4b8df5db3b0303736',
    id: 'range-test-20260619-2179',
    matching_hash: 'efd408940adaf14b2a16d0f3264bde6b4e5ec4e1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'b7ab82eaaf4f9a252fc6a7c085a9835615d378e3',
    id: 'range-test-20260619-2180',
    matching_hash: 'b6856f23e9c5180ff6214efca8e16b9942110752',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '1b6544236e681e14112b1833a246d00e3cf11f8f',
    id: 'range-test-20260619-2181',
    matching_hash: '91a72a0796871359bb57154c9e4f72983a38a758',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '399387966196db335c46cbbda6d92ccb365eadee',
    id: 'range-test-20260619-2182',
    matching_hash: '79f235b92562e16b111fc2d237145129280cb2c4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '6c7f317c29eb001b2de90ef88c2f70eecd2c8ee9',
    id: 'range-test-20260619-2183',
    matching_hash: '1d8ab2497aeefae5ee3111caeda4cd50da863872',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'e773bfaddf4ba32773e06ffeb55960efa4518169',
    id: 'range-test-20260619-2184',
    matching_hash: '83694d64276215830effd72fc1f68c0410002cfe',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'a8e03575f128e42cde47e276f03b03b02980944a',
    id: 'range-test-20260619-2185',
    matching_hash: '83114e4c89b1bec3393d7f317dc4687ed5a872d4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'ce37d9064527db5a1141cd3536bca486489e2c5f',
    id: 'range-test-20260619-2186',
    matching_hash: 'ba42237689b39065947ee4a13ee6c0bd8ae553e0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'f814175ddda9a8483a4697c798109f4229875bec',
    id: 'range-test-20260619-2187',
    matching_hash: 'bb7484a37e44155c4e66f8f0c009534d37684083',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '5643f2321cba05b8a7b314b92472b1b12b254f55',
    id: 'range-test-20260619-2188',
    matching_hash: '7498a87b1c976ececee9ba4298103ad88967a231',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '9dd1bd427ecb064963d704d756f46ae4a1a31152',
    id: 'range-test-20260619-2189',
    matching_hash: '246e30619a068275b9ab55d1bf2bad3f54f07477',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '06a7c292e8686413799dbeb70f5c7c0516d51c7b',
    id: 'range-test-20260619-2190',
    matching_hash: '86407ca439afb09573401a952b9f95dde0c18df3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'e769efb1fd49821bda34e14a7b48571589552fc6',
    id: 'range-test-20260619-2191',
    matching_hash: '5051867e9f9f6990297e1f146d3fee1e9627a15e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'b0d838189e9651ca8b50d5f0dc3c405f5325a0fd',
    id: 'range-test-20260619-2192',
    matching_hash: '61d5d7cff54447cb1f934b8f7f3e902cb50f7225',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '2654841a36c8ba2a14752f66cbcd8f9f126b315f',
    id: 'range-test-20260619-2193',
    matching_hash: 'e1620ec856a626a2a52e3fa33ff9c66621f1bba2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '655d016c7fd22547c885cc6f474aa7692015c51f',
    id: 'range-test-20260619-2194',
    matching_hash: '362ca1d9e50652b3065eca8b0faad04fe069d1b6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'f474bdd4c50ceed552b06e45c4842e2e5975d4f7',
    id: 'range-test-20260619-2195',
    matching_hash: '603c87f23f5a03d3706906c206125d850b6c0a9a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'c48dd4f922910e9a317561e8378e01aa9bd1e3be',
    id: 'range-test-20260619-2196',
    matching_hash: 'a59b3764ac81fa39ec41ea0d19ad89858b8565e4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '71e94085528a3dce3fa536cf35d48e2d8d9ea937',
    id: 'range-test-20260619-2197',
    matching_hash: '916600d1610a17c8c825d50ff6ffe031548ddb73',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '5d118bf7149b028eac6d738eeb26753e20401876',
    id: 'range-test-20260619-2198',
    matching_hash: '82d9e235df0e08836424f7c866e9fe6412e2fede',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '51cd0e03876b142dd533a02490bcebb3c3319392',
    id: 'range-test-20260619-2199',
    matching_hash: '94a3155043da7835e43ac4281e7ec54d99688e88',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'cf1dd6c850c0af06c36530f91754c3498296d80a',
    id: 'range-test-20260619-2200',
    matching_hash: '60640f6d1ea0e38dc6428768e19cd742078a83a7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'd028ef062b7e79a88b345da2b8def492c44a07ad',
    id: 'range-test-20260619-2201',
    matching_hash: '14892a6eeb2f0a275e74bdb58ec35359169f466a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'c21a96cdcdf95ce3bdd4ae16599c16d52796a181',
    id: 'range-test-20260619-2202',
    matching_hash: '4c877be33f7ab09cff3c6de23b14309aedef9637',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '9ec2442939f814e93958b3c22d5214f408c81cec',
    id: 'range-test-20260619-2203',
    matching_hash: '0b43a6192dbb2c782b918460729279a893f0e9b2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '712f6613082a11843141978df1a00a060d9536ec',
    id: 'range-test-20260619-2204',
    matching_hash: 'd98dcffcf3578aa4d320ebf02a2816931cba27aa',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '26fb51f29b8ba29536964fa2464593a487ab4b8e',
    id: 'range-test-20260619-2205',
    matching_hash: '99033355b4f4566252499087aafb2ec5c219d612',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '19c847970bb4f877d446b60a6ff61efeef15bdaa',
    id: 'range-test-20260619-2206',
    matching_hash: '23882966bd1363fe58d71039bdd0e56601467231',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'a4a61e2577a0ca9267f56c68d2312c185536a158',
    id: 'range-test-20260619-2207',
    matching_hash: '4b4a848cf2c69de7db37891542ddf50a52ad754c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '2ff391d7652145466df64f9f10a2598741dd0f64',
    id: 'range-test-20260619-2208',
    matching_hash: 'ca67600e6701bc81ac5280791ca8fcfecec69ee7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '5d908c822e7b5283876d406852538732b7013cc5',
    id: 'range-test-20260619-2209',
    matching_hash: '3043198255b13d76b81118dd76450d2a93201e3a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '8f7ed5338b54610b330201722bc09a9ea34479ea',
    id: 'range-test-20260619-2210',
    matching_hash: '02981f469fee8078870912386c4a4f2f65c0ea82',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'd4fde4322f99d686370b421dd9f172f6558a7a14',
    id: 'range-test-20260619-2211',
    matching_hash: 'daaaaa6291ac89869308e3170ae698f2dee68033',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '053ed7e9fc35a8487c91a350bc5206ea1b272566',
    id: 'range-test-20260619-2212',
    matching_hash: '4f5508238bafeebf6b8353bbad83e4e18966a0e6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '06061ba46cf84b4c96175fca73c4db97fe1cfedc',
    id: 'range-test-20260619-2213',
    matching_hash: '45407b1bc14002bbe7f1bbfcdcccd44b37ce13da',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'd0be5791a3c62ecbc3c6e9ecde7f1699ec208ebd',
    id: 'range-test-20260619-2214',
    matching_hash: 'e8d13461dd73e52fa78d92a364300fecfa552e62',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '273542d486129740c03800ef2fa632e61223267d',
    id: 'range-test-20260619-2215',
    matching_hash: '1841e2b6b82eababf5e33958fbe3bcbf41203204',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'e0b2f4e825c7b02930adab8ac7f15804b6be8fdb',
    id: 'range-test-20260619-2216',
    matching_hash: '53848b662543280a3461b869058b52015d30b4c5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '7bfe34362460606aa15c60b96c4f854b7313104f',
    id: 'range-test-20260619-2217',
    matching_hash: '9fd06e85f8c5cd58971e7030f22950270fd21b77',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '64d6717bea031072d5124cc9ef4041da05236e98',
    id: 'range-test-20260619-2218',
    matching_hash: 'abdb9be83e4a7640e346f356a47223ffc7483368',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '3d9168b7b8a653589173db3ba21704ce510ca7f2',
    id: 'range-test-20260619-2219',
    matching_hash: '0977828c76e0272fe1b4f33a0258197899bf67b6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'cd131866a084f953a796ddf0a194d847617276dd',
    id: 'range-test-20260619-2220',
    matching_hash: '552094bca830573e066a80c85cd741a99a5ecef8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '3565b3b3b688aa6140d53f45260eb23b7269b997',
    id: 'range-test-20260619-2221',
    matching_hash: '353d74f60df9830a86d7f3f5d5af9a8d4901da15',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.080570638,
    qx: 0.489553974,
    qy: -0.009741077,
    qz: -0.868187992,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '9b3d6e1622f36d9d247c25947be4f52d250bc84b',
    id: 'range-test-20260619-2222',
    matching_hash: '1a5f8dc6817da1503a7614a0213ff02d67fd3e8a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '3cfd6726d64c34b21dcb123202cb35d553286ca1',
    id: 'range-test-20260619-2223',
    matching_hash: '5f33ce5df7c2196be89ca2b18be4460aa1761426',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '63b851024f5b03bacde20b1f02fdeb1d1484660e',
    id: 'range-test-20260619-2224',
    matching_hash: 'f60e132e5a1f6983e7b8ce5a585df7f85f439f73',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'b71462324ef1b92fa828b2529baa67a4a8095651',
    id: 'range-test-20260619-2225',
    matching_hash: 'fd947ce14602adaf4ee0359f286ba7546cd4fb81',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'fb9f03fe9180e52b9b5d973cd12ac9613a03807a',
    id: 'range-test-20260619-2226',
    matching_hash: '4a541ae20e92c369b0588558d0252315238839ff',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '91938f2b490a00de793f048860344d12c52c0ed4',
    id: 'range-test-20260619-2227',
    matching_hash: 'fb90d2e9ffd4a280fd375025e4a35929b53a5f82',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'f29e6c564e75ebe8d71c3e2aee9229d5bf8c6fec',
    id: 'range-test-20260619-2228',
    matching_hash: 'bcd84a68fc6fd2b146c6afd902559522964e20a4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '5bda02180bd7a7ec277001eb898dd91cc3c506e6',
    id: 'range-test-20260619-2229',
    matching_hash: '90982c3a8b60e8028645f3a749f47782cbd94aab',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '098ee66b0efff525d92284364b85f72944ce096d',
    id: 'range-test-20260619-2230',
    matching_hash: '4e852a08e7ed7eaa19af17c6b778d9f3de0370da',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '7d47ded152665bc3db56c0feb8f7d08692b0bcb4',
    id: 'range-test-20260619-2231',
    matching_hash: '6c2b26eb07399823c0a777e9ba174067f658d280',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'e165c7adb50da84da740708eb4004cf30d84e43a',
    id: 'range-test-20260619-2232',
    matching_hash: 'edae33c86649c21bd865828bc74331a947a5b6b3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'bfcd2f25d1daafd0dcbe0571e92113bb48eeea23',
    id: 'range-test-20260619-2233',
    matching_hash: '5bd801ba387bcd52d1d235221077c91574564a0e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '424d9f6b4216c60ce90a7e341df1dbf157c487e0',
    id: 'range-test-20260619-2234',
    matching_hash: '72f50312d242929c75ba3a83509a77ffe57fdbbf',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '1ca8384d71b948221c8418b142a5c18cff93d86f',
    id: 'range-test-20260619-2235',
    matching_hash: 'd3f3d2cd0762349284a44701aaef0232719aac16',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '1c19949ac3ebf9343c1b43c63ca279f120dbcbff',
    id: 'range-test-20260619-2236',
    matching_hash: '5bd1b5ee278d40e697b968621b484637f9d051ac',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '9cec3ba9792a695cf46dc500ba98fef56a8e56c9',
    id: 'range-test-20260619-2237',
    matching_hash: 'ad56565f5148ff8cea5aae56b229b242d4ad1736',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'bb8cc632a3e96932dc72859e170e301b43f6554b',
    id: 'range-test-20260619-2238',
    matching_hash: '41eb531b99b93f3ebf8f153f11875cdac3c99a62',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '92b5e60c710806241e026f3be12d9d3e71555978',
    id: 'range-test-20260619-2239',
    matching_hash: '5365d7fd99b3463cff05fa0bcb738968c6932b13',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '41a2c429de64ab5a339af4f3beb575c9c4b9b34a',
    id: 'range-test-20260619-2240',
    matching_hash: '98a7e39cf639b3fd61e2eb8a9054f86461a43286',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'c4a62c8ca8f69733979e589e80b98eea4da9f082',
    id: 'range-test-20260619-2241',
    matching_hash: '311d8b472f15f882fad2cacb7c0a8facd92b2781',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'ed85d4a4ce51aaebc885aa873d5c871e87c4a3aa',
    id: 'range-test-20260619-2242',
    matching_hash: '6e35b2c5af9a9aaeeaf24cc82e2b2035104c4419',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '91cc3db918253b4854f3b2422b8b6b96162c489b',
    id: 'range-test-20260619-2243',
    matching_hash: 'b82db42c5fd098d36295406cfc5e18d093d0ff7f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '2909a6ddbcb7302890c9ee9a209fc066a5480ff8',
    id: 'range-test-20260619-2244',
    matching_hash: '2a25f1ff4c212beaf30a3a1bfd33249018036290',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'd6ba13507d216da5ed2acf7b85afec74a35757a6',
    id: 'range-test-20260619-2245',
    matching_hash: '29bfddb0c29c10874f56cc848d50ce4b5be55891',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '2180188830b29224fbbea7a7a7876cb79989c19d',
    id: 'range-test-20260619-2246',
    matching_hash: '26b6678167402b735ddd2c6fe7293c366702c08a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'bbcc5e3232b2cd80dc690dbc2575ee66417869f0',
    id: 'range-test-20260619-2247',
    matching_hash: 'f815f9892d2a33bad2bd557bc59b2a182f74fffe',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '92fe1ca1e41727fcd6514d3553c8d7a6020ce430',
    id: 'range-test-20260619-2248',
    matching_hash: 'a95930474083c7c394b3208bcbe521066cd72b5a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'ac2067963579b958174ba32b9fdfe58be0a75fd6',
    id: 'range-test-20260619-2249',
    matching_hash: '70ed99cdd5c026bf481e11a079c8348fb223fae5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '3017652eb010b09fe686a76fe79f47ba229d1307',
    id: 'range-test-20260619-2250',
    matching_hash: '2b72d39aafebbaf4cd4273f80662eaf61166bc83',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'ffa156a0eaf6df13b03b533d5b0f989b54dcfafb',
    id: 'range-test-20260619-2251',
    matching_hash: 'c59516451e98f213909f23b999f9326a878e3066',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'e00b3e1753f015e63109c209da2b271e42dc199f',
    id: 'range-test-20260619-2252',
    matching_hash: '66e06b9e937ae0a12d561d7dbb84aae5389c03d1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '4da528a15596f5702dbf322a8ad0124b44168ed1',
    id: 'range-test-20260619-2253',
    matching_hash: '87558a8a3f4520ba3d1bef8f4e87879ae7946cbf',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'e7052c6abefceb75cfe387476bd89d5c9b488472',
    id: 'range-test-20260619-2254',
    matching_hash: 'c197c8933d6b39ce80a30594ee479b7ec00a7ef5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '5c64b55ac882c6689f7307003761dca7d0c7d5d7',
    id: 'range-test-20260619-2255',
    matching_hash: '9257ed8bdc7b94a3f0462ff930b57bfb50d53494',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '7b674fea1b895d6bc12cbdf8630cf12a5123bb41',
    id: 'range-test-20260619-2256',
    matching_hash: '485ee02de3ddbceccc10addcb6f74d818f683779',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'd9e3d3df322ff0627df0fdd858fe841ca7723e67',
    id: 'range-test-20260619-2257',
    matching_hash: '090cfc16dfb97b2e654220562fadef43796529b1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '10e0459bad94b337adef2473348e052e2aeafc5c',
    id: 'range-test-20260619-2258',
    matching_hash: '9b3a519937c7c671445cd5855919d471ca9d6a45',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '70f8e38e4795030ed42c310aafd240002a9535e6',
    id: 'range-test-20260619-2259',
    matching_hash: 'f12f417a3cf0119b9a8bfd4c9839a16bcc2eb4de',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '4a3a5523231085735bce9c082c50ca7a8b7fe833',
    id: 'range-test-20260619-2260',
    matching_hash: 'c512cdd1bbe6a6842d77a4c0f67b2bf6b6c6c61e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'c2828cd7b60de43efecd072447e9d914bd032ec1',
    id: 'range-test-20260619-2261',
    matching_hash: '4a01ef00812c1287638a2f15c3d2e7ef10b3d616',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '397a694992001b20bfaedc97259332c6b37194f3',
    id: 'range-test-20260619-2262',
    matching_hash: '563a9606db7995355310c5bcafb46a6e9b45460d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '0fcacc74a3060390432b129d3d90cc0f028f12f1',
    id: 'range-test-20260619-2263',
    matching_hash: '6c49bd0a6f31ed8a3e143f30dd63da8c21281524',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '155110f91562d4fa2760032e18fe1ec1837d5ee1',
    id: 'range-test-20260619-2264',
    matching_hash: '56cd235ca952c094d797742c63fee90bdfac3cd3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '53e6bf3ff5eb32721baa88c93b9d555a75a4a067',
    id: 'range-test-20260619-2265',
    matching_hash: '978da8d8c7b74f658fab112766f273241fa37e58',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '6b0a213aae1fa1a137503f953f35b9dcdaf0b0d1',
    id: 'range-test-20260619-2266',
    matching_hash: 'f36aa1830832a170f0b62d1bb426506df25910d7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'a06c4cd340e4f4d61d04cd5d4354a08ef294ad98',
    id: 'range-test-20260619-2267',
    matching_hash: 'e12462655059cf216d3cdb7284c89014f5a9b701',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'cd7afc345b65d2fe3563196f9bb93ae193aeaded',
    id: 'range-test-20260619-2268',
    matching_hash: 'e3d8a0dd9136fb620bd03703e55b9afce0fe9ada',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '670fcf7d7d1f11b0218f10c0e211979d364a3c77',
    id: 'range-test-20260619-2269',
    matching_hash: '45cc5aba126698b9588caaeb62f6620be95ae152',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '3d963c883608e7c4387f0b754a41e4e71b3cbe62',
    id: 'range-test-20260619-2270',
    matching_hash: '80222277d4bce27320c2f29b8f2c73bd93d678e4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '720ee420c591b553b37ba058ffa96366c7205c8a',
    id: 'range-test-20260619-2271',
    matching_hash: '5316905d6c2664f79772e588993dca7a2a41b37c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'c5fb56e9e9df9fd5e29bb39e549f636b9570a86c',
    id: 'range-test-20260619-2272',
    matching_hash: '53c753ef25c1f268ff999e3ec2d50c4db7f5f6d0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '2acf60eeff712ceaf7dec10e7a2f0d5d6dcefae5',
    id: 'range-test-20260619-2273',
    matching_hash: 'ef513c8b8a28e16e27ed7dd1971f2dec1a8c537e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'c9c494e580d9b147de4651d647f5a957ef925182',
    id: 'range-test-20260619-2274',
    matching_hash: '0219a9449200842c6d1bba45af37c6181135bc7b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '5801f82a4af6968e1ccd2dc5ccbdf01fa233ea62',
    id: 'range-test-20260619-2275',
    matching_hash: '5a93d8945d82a81c1e7ed04cc0bd8270e968b124',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'e6b3cf20389be3618bb4fabc247bce11c538001c',
    id: 'range-test-20260619-2276',
    matching_hash: '9135f65da89a2c0741afa2919f870193e00f3862',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'be511810f3fe1c027973eb6662015bf9a600610c',
    id: 'range-test-20260619-2277',
    matching_hash: '9b31c992aba7662399b9058fed9de751ea23b2d3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '99e83ccc7ba0f90ff25e7a6875c01f2d19d796b0',
    id: 'range-test-20260619-2278',
    matching_hash: 'd1d14506a976e5dd1321ca14c655d692ee87bf67',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '0fa7af73dd30f0b9c04684f9c9dfb9fbe74c58b7',
    id: 'range-test-20260619-2279',
    matching_hash: '0608c431af63fb48fc7c0bf698cc94694346b777',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '572d51755658db7d9880a586a85b3b1096e4fa96',
    id: 'range-test-20260619-2280',
    matching_hash: '88358399e6283a455dbb0ccf124595ee4f0dbdc9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '04af4c7c925a3a97525c55b73fa44fdff3782fd3',
    id: 'range-test-20260619-2281',
    matching_hash: '5179f1e19899e289052684329b4e1d7fdc8923f5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '1d2962be31737b49adb9e3efc7c64b544902db2e',
    id: 'range-test-20260619-2282',
    matching_hash: '0830ffbc12e8d7f0f12e991ca95f0b7969a79991',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'e08e429ec05d4a3801328ad824a6b1d8b1fecefa',
    id: 'range-test-20260619-2283',
    matching_hash: 'b7eaf7a4e68b90a30e2fc89fdc31022675582761',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '3ca448be90260162e1f8ad0dbbaf3780ff2de407',
    id: 'range-test-20260619-2284',
    matching_hash: '247afb7a2eb8b9f28bf0f9bf657735c987797edb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '62969b41728ca3e02bc4dd2572af41be50c8c9fc',
    id: 'range-test-20260619-2285',
    matching_hash: '4c60f472c62a9099ba658da960538dfb9052bbde',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '14aff0fe6f8a0009d7088e0b2d96e5e07b1be6c4',
    id: 'range-test-20260619-2286',
    matching_hash: 'ad74e09a02fc1d9a3addfdbb27bcf118a7b75b21',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '5e284a24c47dd4b3cfcff30046773f98aaa9dce4',
    id: 'range-test-20260619-2287',
    matching_hash: '575f6dbf8df31d5c9fba2a91e402266876b24358',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '0eee54a8b6a0f06f03940cbce6e855692d9aecf5',
    id: 'range-test-20260619-2288',
    matching_hash: 'd73bfec462dc7e507a81f05de083a171c361acba',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '8f1cf2b14c149b4976a1b3851d7142695fd67814',
    id: 'range-test-20260619-2289',
    matching_hash: '97cbec3b63f3ffbef20de41e1377478a6fd3eb9b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '12ba520a6a6fca5c6bcef9aab97ccd5fef228341',
    id: 'range-test-20260619-2290',
    matching_hash: '89da7f92a4cf28c156d69781fc26c32270a6676d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '2c29305018bcaa2995a233d23b4cff550be024a1',
    id: 'range-test-20260619-2291',
    matching_hash: 'd680b69179d855633a6d0e084145180b12153cc6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '2589bb5b351388cefbd67719cd0aa4f9c9ddd373',
    id: 'range-test-20260619-2292',
    matching_hash: '2370bbc0251a80ede8c10456d0bb21a71dc31764',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '894b19eab68267ad8b8bdd22648d4111d8899a21',
    id: 'range-test-20260619-2293',
    matching_hash: 'b13ce391a4aa4edfa52999f28b042b0f9611cb62',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'f9f17a46c3cc5292ad7a02d89cf40fcb895a4caa',
    id: 'range-test-20260619-2294',
    matching_hash: '048bd2d478e79fbfeef4b0d146a70afeb83bdfd5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'f2a9f39f9dffe24730115624f0504c62d5c7a5fb',
    id: 'range-test-20260619-2295',
    matching_hash: 'd0ecaddb1e5bea10499b1a5648be925cb0bb688a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '745d4ba0d56dde167040de433904147cf4c99446',
    id: 'range-test-20260619-2296',
    matching_hash: 'e7e27140c42bcd28a5d4122af6a06830578ddff7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'aeb66071a2911bc1c6eeca5fab6d8ebea36838ad',
    id: 'range-test-20260619-2297',
    matching_hash: '54284f5b56fda842bb131a7d3848c0253e25d88f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'a812ea159eca641d6bd8aeaf4b68e69a7d6dede3',
    id: 'range-test-20260619-2298',
    matching_hash: '0fbe6f175f4d0deebe320d1906f807869e40f8b8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'd141bc508f3a4689f08828ef812fa80f8c457269',
    id: 'range-test-20260619-2299',
    matching_hash: '18092bb67251458398c2b0b053937d5792c81ace',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'fb5fc737eea7a23f509574cfc0c5f178e1bc7502',
    id: 'range-test-20260619-2300',
    matching_hash: '010255e9d14731944763ae9287ba7e0d703211b7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '1e7899e1011d92e875961a49fa1dd101cc38f4bf',
    id: 'range-test-20260619-2301',
    matching_hash: '02a16ddde802a2fae2f5692e58ee02e21b114398',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '18b20010f0687e3ddb00995bd11b74e6e3e29fa5',
    id: 'range-test-20260619-2302',
    matching_hash: 'e6feea040e91dd8a8387506a946c83e1986c9f36',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '04b72230016a3bb98b504665181e9661ace1d95d',
    id: 'range-test-20260619-2303',
    matching_hash: 'be233ba43d824bf79d53b44b3ef4d6c7c8262163',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '7338ba34f9e31f6e5dddffd81c9e8105212324b2',
    id: 'range-test-20260619-2304',
    matching_hash: 'a80bbf64bb52293c4aad481eea14dde44c49fea1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '16cc53b180f7104ed141832e5a5aac1e48739d19',
    id: 'range-test-20260619-2305',
    matching_hash: 'd7ce4e8417d852099509ec62bc2018c814e7d1e3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'b71767a5267dd89724095628c1b1463ea280dc79',
    id: 'range-test-20260619-2306',
    matching_hash: 'ee377fc8bee0b4d526a652ad9095666a9f761684',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'a76cfcc42a46ebcf7a4dd1d2cdbd89bc97676471',
    id: 'range-test-20260619-2307',
    matching_hash: '918af4a610653c8d27cdb7e07580764c7d564f55',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'd61dab907e49726e44164aca83c352ccbc94db70',
    id: 'range-test-20260619-2308',
    matching_hash: '41e92ac4d3dab5cca3a1b6640d69a3421dd865fb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '840b4ac14160d0be2e69881e39b824bda56de541',
    id: 'range-test-20260619-2309',
    matching_hash: '9474069b872af04e9c567d4caa4dcc1313c9f2e5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '9fa9bc5f57339375eebb921935734cf7a8e8480a',
    id: 'range-test-20260619-2310',
    matching_hash: 'cc0b99cbbcca7489fb59ddbe2bae5046f76389b8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '785956703a73a81b638fef9b81021853c440b730',
    id: 'range-test-20260619-2311',
    matching_hash: 'c387a5fdf55b16ac3b6d215a3dcd9c63c97efd37',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '54826cae8c177e9b68f0cf99212fe8a65ac25c26',
    id: 'range-test-20260619-2312',
    matching_hash: 'd02820ffe003ad33225ae1b8117c038593430678',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'f40cf7c02bf14f711462fe15d3be50216932867d',
    id: 'range-test-20260619-2313',
    matching_hash: '222d5eb8443c647537d25d39f48b049942d57077',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'dd33000662028f33a57841226ce2ba622d1ca654',
    id: 'range-test-20260619-2314',
    matching_hash: 'cc9a07d72bc880637c0256f684c958884c48dbb0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '8518c376afc9f91b30dd73992ca7ee941f6a267c',
    id: 'range-test-20260619-2315',
    matching_hash: '4b0fc2d3817e8cd7c94ab216fb185e6442cc4e01',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'b7624b64c47813c1dff2e9d029dbbff12db65d5a',
    id: 'range-test-20260619-2316',
    matching_hash: '7a0932a30bb4771846cd1709cdc7ba8e95487396',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'ff29f32145f95aaecc45555fe634b47100c9082b',
    id: 'range-test-20260619-2317',
    matching_hash: '877efd2e35234e372f9ae44fa8af1d02c245f3c7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '46280a612eb5b0c8d3ee22c36a76bb4f25cdac51',
    id: 'range-test-20260619-2318',
    matching_hash: '980b2d58585d138a548cbe1da4016ca73637acda',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'd7cae61564fec66d4f66b202fef5cf7ea6ba604b',
    id: 'range-test-20260619-2319',
    matching_hash: '2b22c8faa117928786409eaab6f347c97abfa210',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'f727763cc7545a349ef1539fdaa389ae8cd37978',
    id: 'range-test-20260619-2320',
    matching_hash: '1c6e39d01d1ddd5cf20809a0d6ea61c72c1536bf',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'bb394c3cc751292c479e06ea2dcf5e460fb3e817',
    id: 'range-test-20260619-2321',
    matching_hash: '0e6ee3df1ed500c375af2e901c3d89c4b4daac38',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '5f05c81102ab5d9a5492a01a8a49e7d43434471a',
    id: 'range-test-20260619-2322',
    matching_hash: 'd228186e2151a96744899935ed9e1f0520eb4896',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.217125889,
    qx: -0.552878078,
    qy: -0.474619602,
    qz: -0.64955247,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'a7702d7b5590fefd91470e43d8b6b58c9e472971',
    id: 'range-test-20260619-2323',
    matching_hash: '132fd56eacbdfd82ad5b8e8c8b011e27f63b689b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '80b423f2dae7a9024525d23255f034f1fb5419bb',
    id: 'range-test-20260619-2324',
    matching_hash: '3e1a6ee177413e8b266af8a0e7149a8a308f8d35',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '1727f2838b900a226adf048e88c318ceb582c47d',
    id: 'range-test-20260619-2325',
    matching_hash: '36c5d713a718a2253c1222311487a1b7778f80be',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '5bdd934d1e747849f1dd827bd77dc756a79bba4f',
    id: 'range-test-20260619-2326',
    matching_hash: 'de1a7ee13f11b44dd1f8361a279048011fabf19d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'f5ea59ba9ed5e26f1f8a4263df0a1efe800ce48e',
    id: 'range-test-20260619-2327',
    matching_hash: 'f45dc9723a2db39022c083da00f3cc3510410eeb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '1aac0ac5ed78b1c5c3b8f176b725b9c924e68ced',
    id: 'range-test-20260619-2328',
    matching_hash: '4211d98701d51fedf664f80a13be331b93258814',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '49255e4d072b34df12fd6a748dcf0e0f6a875f22',
    id: 'range-test-20260619-2329',
    matching_hash: '3340f8c9cb70767e6ca151f4228e0cdba7d7628a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '7c0c59f01fdacb3459ed0cb4abd198b58a5f7e59',
    id: 'range-test-20260619-2330',
    matching_hash: 'a85f0e8ff72f1f1007a35131e61defecec9b5692',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'fdda092fbe7c69e91b357db26526db351fa6290b',
    id: 'range-test-20260619-2331',
    matching_hash: '1d782f12329844b638eb3e27f59c89083dc37278',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '0755e2e50e9d03b7a0579465a83a1b70a4652adc',
    id: 'range-test-20260619-2332',
    matching_hash: 'e8bef8d32f7235e1806fd20f56d6074abceb23b9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '4093935e26e7608e48fd627ee6866ba06bdfcc46',
    id: 'range-test-20260619-2333',
    matching_hash: '36d4baa1b6840d13a6f95d116c77d5070e640b22',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '861eeebc7bf8c08e64165e6d7ac1d310e79e7fdc',
    id: 'range-test-20260619-2334',
    matching_hash: 'd2c55f23803f6feb5fe6ded4c1ff010ecdba3d90',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '42f9c2e681076994422343e0666d150da200fed7',
    id: 'range-test-20260619-2335',
    matching_hash: 'a1fb6c5c726726dceda172ed32a512bb61869e31',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '6e695d2089d9ab2391369d737d60e1f8daf08bd8',
    id: 'range-test-20260619-2336',
    matching_hash: '8cfff65f5cf1341f1bdb54525cfe43b296608bec',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '83acf49bdf80250a933c1b0bbbcc2e0313e32e39',
    id: 'range-test-20260619-2337',
    matching_hash: 'bc4f7abbbff32d0c90b912b8066c60d935d13370',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '599d9091fadcda31c9174e86c3c4b9613dc166c6',
    id: 'range-test-20260619-2338',
    matching_hash: 'c9ad12f181ee1690f3fbc0e1f14ee00b19ace901',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'dac924076f7ef67c6551baa52ec197501ee51406',
    id: 'range-test-20260619-2339',
    matching_hash: '1d7d4334d3d8ece0ed7f0a9c9cfbbec651924542',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '3ab69e7dd226be8be3ea4920596cfc914a8aa235',
    id: 'range-test-20260619-2340',
    matching_hash: 'db8f8664618a7a7d9cd3610cc16098721403b56f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '65e9df8be30e6b8fff18cab877be84da6d4948bc',
    id: 'range-test-20260619-2341',
    matching_hash: '5e6be0cbe93468142570765680b68be958228be5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'e9cd516c7f2943505d311c2cdb509ce7c322e7ba',
    id: 'range-test-20260619-2342',
    matching_hash: '24bff4fc8f29cae40cb156314e98c2514e7ddb3e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'ff3cdd869dd8c4d86db01bdf34641b1c20a3dffc',
    id: 'range-test-20260619-2343',
    matching_hash: 'dc09a5128a22e4e790e33f89a461b6119162b3e8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '20239d68cded14935e7b23b188debcc4847aad0a',
    id: 'range-test-20260619-2344',
    matching_hash: 'fd77b35f0eefc7c1780e7d74d22a16c0750317e2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '0ef32a163e1fab7ae35c7fd8a6b830d5e0120231',
    id: 'range-test-20260619-2345',
    matching_hash: '375d11e16cd44f6b942f794ea3d7bd5a6d7e5621',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '19bf29840eb4e4e3b5082354d505aa0377eb38b7',
    id: 'range-test-20260619-2346',
    matching_hash: '0c4befe83365594d3363d3d3e40851e430d8470d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'dbe558c82b3fcfcd26ff4c85428fc998041bb0ab',
    id: 'range-test-20260619-2347',
    matching_hash: '66b2f8c3b8bd6f7e29b97cdeafc132b17fe7a0f9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '764afbd570b3b7c5844bfa46847d41e1d818bfc3',
    id: 'range-test-20260619-2348',
    matching_hash: '08274b3cb4078ef824b31d88e6091ea5a80c0fc2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '7ede187a499dfa92253fc2e91c17e4cda57deb77',
    id: 'range-test-20260619-2349',
    matching_hash: '76339e95b660a585fdd9d77ac7e8bfcbbd74fcf3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '168c7d4c9f3cd39861ba89a74bde3b92882b088f',
    id: 'range-test-20260619-2350',
    matching_hash: 'a42a2c128ad7d8e8d351de689624d0c2dc0b4665',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'ddfed2c85a51bce6892c8564191297869d437c35',
    id: 'range-test-20260619-2351',
    matching_hash: 'f69f54aa9d36d1f21dafcc1acaefef52c7a918cd',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'f47c08db9b9553df7071cf8dc0dc6c1b46c10441',
    id: 'range-test-20260619-2352',
    matching_hash: '944e48d24a0e52f54180fcb2f78b77037e12c6f7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'af453f83eb52402b2e32733fcbbf4addf0468fc6',
    id: 'range-test-20260619-2353',
    matching_hash: '39b776452d8e375f76f079d8a2288426b9fce146',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'd361b4450de8d3d2be80d2b736d88516ac4593dc',
    id: 'range-test-20260619-2354',
    matching_hash: '863494211f4fab0bdf3bf79f475c074c9afd5d06',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '598685966aa717216877d2a4d212f7952be0f8f6',
    id: 'range-test-20260619-2355',
    matching_hash: 'cc4b974fb220ca7e982084524f93f4e2bebd8629',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '465c6afa20a600d1936a00c1c995f63f77d7d099',
    id: 'range-test-20260619-2356',
    matching_hash: '4e320e12c18c59edfd457e0a0079b344e3305634',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'fb19c2d537edbb690750f19ed6a22023ff624ba8',
    id: 'range-test-20260619-2357',
    matching_hash: '407018145f979e8615175df6b67ba62ed5f1a4fe',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'fb3f285f2e290f3d68fb68ddfe5ad5f068b49c20',
    id: 'range-test-20260619-2358',
    matching_hash: '9e478afa25b9ee4b1e704eedb2e0f13f64c01cb2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '2d304d5c8cbd4c2b6b6eabf38c88682a9ec32bf3',
    id: 'range-test-20260619-2359',
    matching_hash: 'e97e00323823b6ec5a33bbd3118272c257726cd0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '02aeb5fe69bdcc42a030a0364d3d558288bcaf78',
    id: 'range-test-20260619-2360',
    matching_hash: '193c30d57f5cd0e43186624d3fc550bf64e8338a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '55f5436c7fcef245b82486107b530d8567e11003',
    id: 'range-test-20260619-2361',
    matching_hash: 'f98574995243b173c66bdb08ddce90f3eb39d86c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '2b795415b121aa7eaed2604acfd60292d992a1f7',
    id: 'range-test-20260619-2362',
    matching_hash: '302589b18c5330e16eef7d789964ae7e6d4a8ecf',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'd00ad4405978e42b1ff567b29c31d70d903d61e8',
    id: 'range-test-20260619-2363',
    matching_hash: '1af739aa7a25f359200e076a10045ddfea854842',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '181ab08a4ddd226c80eb9aa9909100c491f5c93b',
    id: 'range-test-20260619-2364',
    matching_hash: '6f253bafdd9b9af09143e63cb657a6168f6b906c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '7aa43f78cf276953004ca738ec3d71f17fea3636',
    id: 'range-test-20260619-2365',
    matching_hash: 'd075cab68ba9c462a2d98374086bea574a47d2ec',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'b64c5f08590c7a746d2a4f5e91a46af704789966',
    id: 'range-test-20260619-2366',
    matching_hash: '9a8d1a039a8f6091cc21452c046afc8d56c4fd68',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '5c7e26371b0c5bbea119e5a605ab962a3358b431',
    id: 'range-test-20260619-2367',
    matching_hash: '2a57c1a168e2a842afcf70514cb21fce3d7a739b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '4f8ea167dcb9f05b921e42de549487fee3c6b239',
    id: 'range-test-20260619-2368',
    matching_hash: '588015130e0cffa25b1e046644f5df0c29f8988a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '398313e0f08c4133686ea1c05f516a9118739890',
    id: 'range-test-20260619-2369',
    matching_hash: '70486f2a72e08c856ae8416d608e34b9a16efd2d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '89a214e353f752f07b2e4369515e1c97ee555226',
    id: 'range-test-20260619-2370',
    matching_hash: 'e9dd2d929be6f0bb39836ce05a7dfe0d26f278f5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'a8a3abbecfc59604e79b9d081aac593472041b70',
    id: 'range-test-20260619-2371',
    matching_hash: '765f584a31f049026c3df9da8e6dc0a6e085ea8b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'b615b54b89cd40edc805d6fa2965a315bd32acc9',
    id: 'range-test-20260619-2372',
    matching_hash: '5458ca769c33a94f58fb447eed08fe7887e843a0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '896dbbe52beacf004d4bae9490449f6fc2e9e496',
    id: 'range-test-20260619-2373',
    matching_hash: 'd2a1593c9777277d8f23d45a4a38a9c419addf08',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '77188bc306dde001a849b34a3f68b060a64e40b4',
    id: 'range-test-20260619-2374',
    matching_hash: 'fd51052c58c1844a16754fa848eec58dbdb794f3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '659ea97e2a97df4025d6fbfb743b4fa4f1cfc6d3',
    id: 'range-test-20260619-2375',
    matching_hash: '04613d5b9eb6d250c6ebfd4040a5ca416a644a42',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '99a3996e3c2f017babd207739282d408b4d2ad6c',
    id: 'range-test-20260619-2376',
    matching_hash: '09a8fbf1c4cfd8880e583c9d11b2a75e58e72ec3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '4d60e290938b8d073b5735e53ddfa0a12fae7239',
    id: 'range-test-20260619-2377',
    matching_hash: '1cc56f8b3209429b67c44d80377a15359c8a5455',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '759f8723418c243c6a5257cdfd7ffb0dd4a4dc39',
    id: 'range-test-20260619-2378',
    matching_hash: 'df916b2d57f89ed3bbeca757c3522795162f57c8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '215b7857a8835674bdc85f9189a8b6247a53d912',
    id: 'range-test-20260619-2379',
    matching_hash: '87b5625aac198f13d2b48f8aff810bbc20f09a14',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '0806554a9027c10c69a18e8f563b6aaa9e665016',
    id: 'range-test-20260619-2380',
    matching_hash: '8b2e9c9d4df932b3a41d202fc5bcf29cbdd6c73a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '09105cf3f510d047cc4efcbcef0326fee63a709f',
    id: 'range-test-20260619-2381',
    matching_hash: 'cc9ccf68860506f8b0723bb9a948c502677533b5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'dd88a456a02350145751dcd18f021b2ec5663bd3',
    id: 'range-test-20260619-2382',
    matching_hash: '0a10f9575777edc931cf274320bd808c7c4845ca',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '68f17ab647c5de442de2e9e32b8c044f158a2e54',
    id: 'range-test-20260619-2383',
    matching_hash: 'd53ac8200cb9cea787ef698d4f0b221c64c78897',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '449326f24ab2e02c60d8add247948255dc500877',
    id: 'range-test-20260619-2384',
    matching_hash: '076a0573ce4da48d9d4846b7e4ea613e215df919',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'dc7b6f4a0b7e8e5832381808748d9a4a01e1a1c4',
    id: 'range-test-20260619-2385',
    matching_hash: '2fac6518df3dcaad47c82310f074b64955748417',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '136d6eae4a9a99223c7410a86d809455b682b2f7',
    id: 'range-test-20260619-2386',
    matching_hash: '8d7923bea38c6630e78dd8fa04bd701e13532c21',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'a25fbc5d0293bc00126b28da46e283be6400b570',
    id: 'range-test-20260619-2387',
    matching_hash: '3a5e6894db9b89341408598b8d4eb410fdac10c3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '8049bb1a4888aabe2aab046eb42d17b79c7b6894',
    id: 'range-test-20260619-2388',
    matching_hash: 'dab2ae877423788c5e7fb1133630871457eeccd0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '5cf1a148b51b66a7aef4d764b9e0dd1615a37db3',
    id: 'range-test-20260619-2389',
    matching_hash: 'cf573c6e63ae6941d47c654201aa63f0f6608766',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '51181cd9a5924e8a7ddc497051846812c5a4443f',
    id: 'range-test-20260619-2390',
    matching_hash: '4034e1f8effe12c98a379fca505f46da84ff9f51',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '3d74dca0763fef9c6136fd37d96e02a5865b0a5c',
    id: 'range-test-20260619-2391',
    matching_hash: 'ea4dc59e82584d8cbac77c5d5667f2db22392784',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '849c036e20e7bbb3dd9651c73f3c2faf0be5baf5',
    id: 'range-test-20260619-2392',
    matching_hash: '749c9e69191fad0236f89ce8077f2628891a7455',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '7431bf24ace215e593d163c05340d67b7ddbc6d2',
    id: 'range-test-20260619-2393',
    matching_hash: '68b430703ace65d3f4f363f66bf8ac5060e7c958',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '81a864f0cd3020080b44e23ed87974217a184eb6',
    id: 'range-test-20260619-2394',
    matching_hash: '711e3b80a10fa4dc0d5a323b5d72c264c34383c2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'ff62eea94e705dc260de7b35886f18088779c48b',
    id: 'range-test-20260619-2395',
    matching_hash: '0f16d66e0be9fff1a3f13466fbaba4e1668ff5f4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '6f5dc6771404da39a2a97c375527f20cf4440851',
    id: 'range-test-20260619-2396',
    matching_hash: '47e11e7a6c4d27e9ef26cef58c175508be4ff549',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '02e4cc3f7bf440547833afa53e26625afe966873',
    id: 'range-test-20260619-2397',
    matching_hash: '0343b9c3894e144c7fb627756a8c2c97b759edf8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '786f2497667922ae22d6d15d2197067832aef3e3',
    id: 'range-test-20260619-2398',
    matching_hash: '2b8e51e93f761095950fd492fba3912109870c6d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '694416e1c316c7c64aa514f0050f23eba1817cfe',
    id: 'range-test-20260619-2399',
    matching_hash: '4deedb7b9bbf3afbc17d2de95b242ff3caf9971c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'b19d8f6a26410d6269a9f063d9c3b41b7a6b3780',
    id: 'range-test-20260619-2400',
    matching_hash: '67ab8d75ba27f42aeed80694762a6ca3667ea5d4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '339fa2fe1ac37a0f17eb1e2c6ac83061189b8632',
    id: 'range-test-20260619-2401',
    matching_hash: 'b39010bf6d1652f524ce14aa5a14c0bf259776f9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'd202828d25cee2dfa76fcafe14598a41986c86f7',
    id: 'range-test-20260619-2402',
    matching_hash: '4ee08bb58f10232db9df24d8ec25c51af5436d8b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '23cf95535d8f22d9d3c8cdc1ca467455756aa9da',
    id: 'range-test-20260619-2403',
    matching_hash: '4e9019de961e88ae6c1ce28c39997db7f5e3befe',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '5ea6e5eceac5546ba99e751935978269a76fe08d',
    id: 'range-test-20260619-2404',
    matching_hash: 'b482479169d043bca18c00c0b5e6bb867325fcbd',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'fbe6510a50646e5ee94d57f22e918d6c091eddb3',
    id: 'range-test-20260619-2405',
    matching_hash: 'a38873c931a499e671278d141a20f96949de4979',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '9bdbc6aa21db7effd1826f548cff05ecee85ba89',
    id: 'range-test-20260619-2406',
    matching_hash: '3617fb6209d01e7d502ffda5a4b2037695f5a4a2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '12c9ba8960b503ac6bb294932653f5d0ce67af53',
    id: 'range-test-20260619-2407',
    matching_hash: 'd831259d33d67fb0bc67271aa47d7e07a69245f2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '9236a306c898cd21af9d80fcc46b05c9d7abab14',
    id: 'range-test-20260619-2408',
    matching_hash: '588cf9f48c3bf6ff46d6656c303f8dec9a3ca96a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'facaabfde03f335f6ea4a67d3fd8295a24a6fe58',
    id: 'range-test-20260619-2409',
    matching_hash: '53d40b68c8a119509fea4bea556fff77bcbc1b1a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '47ff41cde87bc92b906081b7ef8fc9c52b698507',
    id: 'range-test-20260619-2410',
    matching_hash: 'f990806a9a11d7fdb058d69356adf91f95bf64ac',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '7fb85f065c93ffad96518edb1741e8e6ac63428d',
    id: 'range-test-20260619-2411',
    matching_hash: '9fc985e40be6310cff3fddad5a81ef8d19226a86',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '87a9f7116888b26fccae58fd9ea11f285f9bac06',
    id: 'range-test-20260619-2412',
    matching_hash: '3f9b48348ed967819b95e01ee2ced287ac2366fc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '46cd35ba8f4e7df3bcc435e0150b37cbd304f67c',
    id: 'range-test-20260619-2413',
    matching_hash: '99f49423c250396e6039934ad51c9df25ec18298',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'afeff699107d5a513c7b32fa3f346c48edbc209b',
    id: 'range-test-20260619-2414',
    matching_hash: '55897d3e7a5872c6e2c41cc79c07d26a5b0d4403',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '0aead009a31937429cf5c58c601b3d5584719389',
    id: 'range-test-20260619-2415',
    matching_hash: '375d11e16cd44f6b942f794ea3d7bd5a6d7e5621',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '2e36c8e2391c23eefc2fb2840cfff51bf13b8b2d',
    id: 'range-test-20260619-2416',
    matching_hash: '0c4befe83365594d3363d3d3e40851e430d8470d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '2787e812ab570e95d90a723c5a5b15fc0a6fcf28',
    id: 'range-test-20260619-2417',
    matching_hash: '66b2f8c3b8bd6f7e29b97cdeafc132b17fe7a0f9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'b408b3b54759784c47f679dcdc7fe0d9e531da28',
    id: 'range-test-20260619-2418',
    matching_hash: '08274b3cb4078ef824b31d88e6091ea5a80c0fc2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'de3c41998c8d7ef1f78f0d4543908e38bf48a244',
    id: 'range-test-20260619-2419',
    matching_hash: '76339e95b660a585fdd9d77ac7e8bfcbbd74fcf3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '516f08fd9132f7b835339933827363efbd135bbb',
    id: 'range-test-20260619-2420',
    matching_hash: 'a42a2c128ad7d8e8d351de689624d0c2dc0b4665',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '2bd61c7a1ae590294a08d9e4db04b4b10004988f',
    id: 'range-test-20260619-2421',
    matching_hash: 'f69f54aa9d36d1f21dafcc1acaefef52c7a918cd',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '86b3280e48bc3e78d58b367e79c1c2f05f130212',
    id: 'range-test-20260619-2422',
    matching_hash: '944e48d24a0e52f54180fcb2f78b77037e12c6f7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'ae4323ec5a479c1dad9eb8611bc92889248f5f3e',
    id: 'range-test-20260619-2423',
    matching_hash: '39b776452d8e375f76f079d8a2288426b9fce146',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.506387637,
    qx: -0.808484278,
    qy: -0.294733209,
    qz: -0.055290773,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '6b47576f42d3f07f3fc8d60f76efa802eaa9de42',
    id: 'range-test-20260619-2424',
    matching_hash: 'e71285805da3fd3b6184e58dbc612618b968cb9d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'e2a9afdf116a10bcee010be6bbf4e50a601280af',
    id: 'range-test-20260619-2425',
    matching_hash: 'c235282edc4a130b90230c65a0ac17c987f23f44',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'beca6b9bdacef17dd09a9493966ffa350807c75d',
    id: 'range-test-20260619-2426',
    matching_hash: 'd48347d358b94dadd86f1a033d66d0871eae8282',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '1d6671ec77e007a0e6161906afa951921499ecb2',
    id: 'range-test-20260619-2427',
    matching_hash: '0d0cd63357bc3b325c912b78b33b9a7ea78becaa',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '966a5d2cf179d20870bd631c20167ee6f04e9deb',
    id: 'range-test-20260619-2428',
    matching_hash: 'fb13a6f7696d347d05f33c8da56deba374b06acc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'fc718215b38dbcffe6a65db507bb7c22660a81e3',
    id: 'range-test-20260619-2429',
    matching_hash: '3a17894c61668c25014c46711407f85d7a23b491',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '1a943645137e101c824ffe23123ef448a036cbad',
    id: 'range-test-20260619-2430',
    matching_hash: '6058551b4b78f01d7f95d24138b89dc3814b11e9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '63019f204870f647e1107dd3450d781875234544',
    id: 'range-test-20260619-2431',
    matching_hash: '3d9cba6f04dbef4342571af73790bda6541b6d3b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '194fbe82f3d6409a544133797d0bb390d53e0a5e',
    id: 'range-test-20260619-2432',
    matching_hash: '3b94cb0ca878f080d30ffbbb96ffac922e496488',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '93551a4804987ded9f7abb24bd48c67fd689ae69',
    id: 'range-test-20260619-2433',
    matching_hash: 'd1a3e04e385b30a24a4ca33473e0deacbac1c6df',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'efcd438c01e2508b2cd18dd6037437d01d08bc70',
    id: 'range-test-20260619-2434',
    matching_hash: '3d24f3e4e38d08ca899c80da9eb652d11e0c7399',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '19f51cc9862b26a6195d6201f96426e37984ae22',
    id: 'range-test-20260619-2435',
    matching_hash: '1d3918664e8e1e16402ce342a97f0a079b068859',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'bade9f3c4ab1747c88093c344b01ae1f3ec11d2c',
    id: 'range-test-20260619-2436',
    matching_hash: 'bb9901def4dbd96120c2d63f5c8f70f33120a044',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '40cc45e7783ad1a80dba73715b6a001b1ea3b10c',
    id: 'range-test-20260619-2437',
    matching_hash: '90ee23cc7f9e39994b6558c8e1d5dbb1f3fd88c4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '23a75a1ea8e2141a3013f4df368c8ff6a6f2df69',
    id: 'range-test-20260619-2438',
    matching_hash: 'e41b63d3d12969e4637c8650d4b9b4cd74a6d260',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '0fbf571058ea50cce110078c44f1e9b78fb2a696',
    id: 'range-test-20260619-2439',
    matching_hash: '1101ea4d544277c146d0b54233b4caa2ec715d7b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '3b44684ba52300814058b62275056930df1a6e71',
    id: 'range-test-20260619-2440',
    matching_hash: 'd77c626f839c7b3876605a058b08e05cc302fdf5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'a1ee2ebfb437ae7da0ea6acb65c8b7f56111049c',
    id: 'range-test-20260619-2441',
    matching_hash: '1bf87b9f82964127d0b69aac3de40c7b677cb00d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '9791226465dca51df4be9f5d5adaab8c5978b343',
    id: 'range-test-20260619-2442',
    matching_hash: 'a63b0eed61f0c456509ef1e0c3116d50cb962c31',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'a116d34dbbc6133da49256f24da68e284a890ad2',
    id: 'range-test-20260619-2443',
    matching_hash: '5d27dfd6f31bc2de4547c51eb419cc7257738c5d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '24f733f8278a7cb8c244c872a79c04f1e2afbcaa',
    id: 'range-test-20260619-2444',
    matching_hash: '25ae55288ef7471b3d889b645715af6de23c11fa',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'c061117bb952d4e64581a807b1e6b4abe9fd2078',
    id: 'range-test-20260619-2445',
    matching_hash: '15364c50c17fada1781a7ec5d0d8d859b20a9fb8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '0125396c8b03b79f08c386394387eda0fd27590a',
    id: 'range-test-20260619-2446',
    matching_hash: '1d703cd4177c540016032628003599fe67f8928f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'f2f566f9a0281cc5d5935cfc3b5e601a17eda195',
    id: 'range-test-20260619-2447',
    matching_hash: '64d33070fb56799607c176eba2f623bb4bc8fdb4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '8bf74755aa31f0ef0a4f2c57ca4f51c2aed6418f',
    id: 'range-test-20260619-2448',
    matching_hash: '3b895c89ae502b0733c0c6014f47fb0f1c63d27c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'c107a71cbac9b7cb573fbddfe4f11ee1fb50d48d',
    id: 'range-test-20260619-2449',
    matching_hash: '3f896c92e7197712e4a1e50f594d00f0dcf8e4d8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: -3.1875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '4748b57e8d3d31318f3265fd94069fbb6ee6a91e',
    id: 'range-test-20260619-2450',
    matching_hash: 'e5dea3780f77dea4bf8229070c4cef0afe3784b9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'd78d4772e2095c4901017f2af1f6b7625fd34dc9',
    id: 'range-test-20260619-2451',
    matching_hash: 'cd890555af519d11a671616cf3cdc58399972e9c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '729d2db2d8927346cd8ba10f2a3b70328bfbd169',
    id: 'range-test-20260619-2452',
    matching_hash: '31999200554ed2cbe45f9cbe0b74b0e5e9de5775',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '5c0ea6309513a412083cb3e40d0ee0d28a107f6a',
    id: 'range-test-20260619-2453',
    matching_hash: '17b68cc4859268cdf9b4b4de4f49837ec4e763c4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '21f1663df9f1095089359011731c650270fb0c8d',
    id: 'range-test-20260619-2454',
    matching_hash: '2b5d579fea013cc90a0e8be70e20a1a922c0e559',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'e6d70ff41ca09b23f6f643bf4d9349ae551ca17a',
    id: 'range-test-20260619-2455',
    matching_hash: '7bc4e1074e5c0ce7978f2a5212f8c00e437cfa83',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'a1e002bdedf71b615c1344b2e28b5dad1db4bce5',
    id: 'range-test-20260619-2456',
    matching_hash: 'ec8832a08f6fb31dfb13da21655e840de3888d3c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '3d68f3c7df49e18f34a790641346d45ea71e72cf',
    id: 'range-test-20260619-2457',
    matching_hash: 'a5dc9768bfc650ab0ed172a405a6c0d871866cf0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'b34ce28180e6cbeea0cb19fc8a4ada4adeecdab3',
    id: 'range-test-20260619-2458',
    matching_hash: '5cea4fae4d50b92dfff27cf98b9c290746f7918f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'f8d8525161752b50b1f5a52e1739dc3ae30be2da',
    id: 'range-test-20260619-2459',
    matching_hash: '6c675f72b040fc8b39a59ce328755ccedb335b2e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'da9fb442ca692b99f6d42465c25ecb657a19379b',
    id: 'range-test-20260619-2460',
    matching_hash: 'df0b9a8c5bcf79a4d43924700cfcc29aeb9f011c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '54306ce05b75f7b92e44ead78d4cd1c4b56e5e7e',
    id: 'range-test-20260619-2461',
    matching_hash: '42fcee4922451f80f926ee5ffbc1cfd681b7afa1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '3782382aa99c7628042dcb7fbe7e8aeb2d16b074',
    id: 'range-test-20260619-2462',
    matching_hash: '123dc88311e35328da08ccf6cad557ef40015f14',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'cafe1b2d0ca8fba6ff6bcddcb0390c6bc894866f',
    id: 'range-test-20260619-2463',
    matching_hash: '1d334ceec7b5890decc573ff7a45e8335021f567',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '689e7a35e7cb89381045982216ddc7f3a3756f03',
    id: 'range-test-20260619-2464',
    matching_hash: '5ac81ebcbe9172fdb8bb6ef69d230aba01d8f538',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '09a1003568d18a6a882b993838d77cccbf78202f',
    id: 'range-test-20260619-2465',
    matching_hash: 'b190c6655c85d4617e8d0f7e6eb9a71619842a02',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '42d11b19dfb76cad00144d45165ced18945f7c50',
    id: 'range-test-20260619-2466',
    matching_hash: '35c2b19e85d8f095bdd20b7c06095c3c80994a92',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '5da3b225409e219aaa76fa9f7f15d057dad8a44e',
    id: 'range-test-20260619-2467',
    matching_hash: '8ac7a71ff379717720c60cf73772fb2efaada0dd',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'b3939a91923c0a74c894f022040ea1e0b5b5e598',
    id: 'range-test-20260619-2468',
    matching_hash: 'df8bdce48b27b0ea0cb8d025195cd9d68b36614f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '5f4d8d07620d101bcedf6caf1836051d6e16cd0f',
    id: 'range-test-20260619-2469',
    matching_hash: '70e42e7e10a02d8beffdaefed26c20dd7f423cdf',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '69aca87d8ab1e0fb8362ec65be71cdc4df64bacc',
    id: 'range-test-20260619-2470',
    matching_hash: '6a86b33ce5d60b1b5de98fe98cc12dc0f3b60f8b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '0ebf3b2abfafcaa1a82978cf1bc2b39f66fa113d',
    id: 'range-test-20260619-2471',
    matching_hash: '1d2c51940feff330b2ff59c48f519f523da6a0fc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '72d9211cea52f50348e01b18a6c8e7126313d865',
    id: 'range-test-20260619-2472',
    matching_hash: '1c3729903e040ede1d187531dbdecafb2b12fff3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '4dac30ae024ad4caae4c0ddb9c01e8524f3e1065',
    id: 'range-test-20260619-2473',
    matching_hash: '87f01575dfc844a6adf067c72b67be87a23f518a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '6cf735ac919bf00071e5485bccaf469f533a160f',
    id: 'range-test-20260619-2474',
    matching_hash: 'dbb44274a757cd5cd2f313e2a00cfc94183cbe53',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'f1420894b3ad0de9cdef6788a9b5074a402ee809',
    id: 'range-test-20260619-2475',
    matching_hash: 'a0f119eb680de438a3234a45ae4f33604a084c9b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '088a13944572f8c6f695b394cfd3e912ca28b40b',
    id: 'range-test-20260619-2476',
    matching_hash: 'c815caf1b25539aa54b7e1b261b9fbf125e911f0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '6d4f54a1a6fee36e40e907a4b47fcab3064c336e',
    id: 'range-test-20260619-2477',
    matching_hash: '6ef7def0f45a05895e3ababcc4e0366de9d7d8ba',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '2ab30b58444b9c4863226c6ef2889f77725404a2',
    id: 'range-test-20260619-2478',
    matching_hash: 'd7e46d3cf6d52567d1a8c7c6eed139f93e03c4f2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '2bd39efd76e11c0d8dda5afac52d276ff009f29f',
    id: 'range-test-20260619-2479',
    matching_hash: '556583a13f8d6f94c81ac1ebac0de6027383c103',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'a988091542eb3bcfe56f0339111a78d2a4251510',
    id: 'range-test-20260619-2480',
    matching_hash: 'f8d4088559680f90cf723be06f9e9315d8d14764',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'de742b70eb762d6b4a2720ea7933dbef8d239c2f',
    id: 'range-test-20260619-2481',
    matching_hash: 'a2eedb68fc032079b2d04db56709821002ee384b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'dbccf6dfe69925e655c696b1906375046d8c8779',
    id: 'range-test-20260619-2482',
    matching_hash: 'a12fc564352380ceac91cd2ed8e8bad0d5ce5aa6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'f2d2cb4a9beda89047690728372a909d3179cdb3',
    id: 'range-test-20260619-2483',
    matching_hash: 'a2224e7db8f47144e32adea30bafe36c51e54853',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '703ec36ae3adbf7213ed7404b0fe1e3a57993ac1',
    id: 'range-test-20260619-2484',
    matching_hash: '6dab1114f1d4f08a5960ce3d0e0224736be7c772',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '70ee6eefc3847b9c12d2bc89307377da8242dcf9',
    id: 'range-test-20260619-2485',
    matching_hash: '939f978accaaa84b91c05778a69ea725223caa88',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'f6e6322420796b68e59dffb348564544ea6faa18',
    id: 'range-test-20260619-2486',
    matching_hash: '52fc26c8c0d89211eb362db5ce3404c70906fca8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'd24e6daf9532f61ea5bbd14bb9479a4a4f55b951',
    id: 'range-test-20260619-2487',
    matching_hash: 'a67594ce7530553e8a5f603cbe75ac597f0776a7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'edf6a5cbaaa8eb72cb256e956136ac077e817c13',
    id: 'range-test-20260619-2488',
    matching_hash: 'a3e40aae30e9b6625188798753fcc5a8c2e84a7f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '07e8cf7b1fa57796090e15dfab2f7014e882ea93',
    id: 'range-test-20260619-2489',
    matching_hash: 'c534083b6384f43547bfa2c5524ec3bb842e39ef',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '8a8c616617336a5ad1dc3d5ddcb098c61138172a',
    id: 'range-test-20260619-2490',
    matching_hash: 'a6c931edabddc34186d10b19c84a9533dd33c71b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '0c29a700b1cccac7dbe736bbfb68ee15722e599b',
    id: 'range-test-20260619-2491',
    matching_hash: '3e7fd25650c005b4a40f6f9dcd6e44bb39db5c27',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '2773502d33eeaf7d1578645f98e320ef1239467e',
    id: 'range-test-20260619-2492',
    matching_hash: '8389aaf068dca60dd0e3140221b91bbb0bb13891',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '821460d475c58fae026cfd87484b54797670e540',
    id: 'range-test-20260619-2493',
    matching_hash: '6928af6c3a58b2a412db37963b21e298523c6a81',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'c33fa7309de01117f7f293baeabe6f91d8e49eca',
    id: 'range-test-20260619-2494',
    matching_hash: '48958dc10643ef61ed771f5ba7d212cd4d0c6d33',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'ffe215e611ce354ac10d772a21c46bc61e5ea32f',
    id: 'range-test-20260619-2495',
    matching_hash: '26aff6401630edc0d93976641cf546fef2a1b867',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'd68c135d50073da697bb826d707e111cc6e006db',
    id: 'range-test-20260619-2496',
    matching_hash: 'e043537e1f19a9f8b91e70f5141186878119bd15',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'b3ac6a8512ffdcf35fe3366888f35b2c35bd843a',
    id: 'range-test-20260619-2497',
    matching_hash: '47bfd43fefc491d5cdac22acad817daff2822500',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '010e69a0bb2a2c09f0a89bdc81a5c2d3f276c7b2',
    id: 'range-test-20260619-2498',
    matching_hash: '3fbeaeb04654eda0c57e8719678f6c07b33f7177',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '04ac0657097e659d260b503def43d59ffced673f',
    id: 'range-test-20260619-2499',
    matching_hash: '736f51ec5820361fb60cdf789552e91968ab1563',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '65db2161a99ffb33dbe0bad875f7c27fd7114f50',
    id: 'range-test-20260619-2500',
    matching_hash: '6a82a166130ff0f23ace3a449d8d5b967ce555b2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'ce0a04b03154a2f5b83d7a085ba211ccbc33adc6',
    id: 'range-test-20260619-2501',
    matching_hash: '6c02e93373b7b4430066fda6d4416750bb8ca939',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'ac47a0691407fc45d64af2b9583cfed79e1cad48',
    id: 'range-test-20260619-2502',
    matching_hash: 'c9a6991dd47d9d8efe10659e01ab289b578c8fed',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'aae1b59bc41afee908eb8c7a65986ef9d084bd07',
    id: 'range-test-20260619-2503',
    matching_hash: '990091e622cd4ace2d4946fd0777fb6628e3516e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '86ce266d738748412b85ed79dfcda6c9aa6d7490',
    id: 'range-test-20260619-2504',
    matching_hash: '838e39ce3fec405fdb49b2fc6e895f53006c10b6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '446a50b5cb2534dd9ddb6d2cc6dc33cd00e39e46',
    id: 'range-test-20260619-2505',
    matching_hash: '57919a9c8a2e8174fac503f48260337f9e3bc54c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'b63d947d25ddcb94731b3fc92bbb177c7d4f1fa4',
    id: 'range-test-20260619-2506',
    matching_hash: '66f15cbe98de4438e878df99f8cb39152a6e66e0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '52327d04a725cd5e45a2cd7b17730e1f10e7e846',
    id: 'range-test-20260619-2507',
    matching_hash: '9313ef8946dc1e5e512302152977863915bb70a5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '7a9908a0484b810146a18876db5d55267089ae23',
    id: 'range-test-20260619-2508',
    matching_hash: '45e429049a730bc02fc880e7923c7120aaed286e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'bab8b484cea05fbaea6864a0cbd816647eaa8859',
    id: 'range-test-20260619-2509',
    matching_hash: '5d62c061c9bf5c2ce29208e4040be1f13ae9c269',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'aec41746ef65121848b4b57577fd1a54c02b51dd',
    id: 'range-test-20260619-2510',
    matching_hash: '069916b3e4933058d0dc7c5ff6ef3765825162c5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'a2aa2627b8d51a294a7f6eb06fb7cc39a222dd10',
    id: 'range-test-20260619-2511',
    matching_hash: 'a6801f3fed6205ceaebf877e3619f67a722084c9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'da5d6424d029b5b08b603dceb4bbb3aa97e3fb71',
    id: 'range-test-20260619-2512',
    matching_hash: 'b812e08e5720687858af301f43dcdf263a7c0f5d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '6f845a6b0920f12bf696e38ccf9c2a0c6d0d999a',
    id: 'range-test-20260619-2513',
    matching_hash: '66a51481dc1495285e3615684b140631d2d077d3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '56dc5cc43cdf6876e617755580b8fa84c51a6926',
    id: 'range-test-20260619-2514',
    matching_hash: '3e4a973b7bb67cff1fa348dde0f025a60cc39a95',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '922e3618088270db1b8da884939fb29e49ce46bb',
    id: 'range-test-20260619-2515',
    matching_hash: '406dea98cf698ce3d8f2c345f7fe14758c2bf083',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'd72282053ed8714d69b668f88efacd8ddc01a494',
    id: 'range-test-20260619-2516',
    matching_hash: '5cb8f9339d36e8d0c326ed812736893994d4ca6a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'd8d117cfdf632c533bfae13bb74fd319295e6035',
    id: 'range-test-20260619-2517',
    matching_hash: '24004a9d889f490403167975fe6eb6d8aa78e66d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'a2be9c599f982d8dbb060ee97f64c8a86a789935',
    id: 'range-test-20260619-2518',
    matching_hash: '5f3378efe43b9f71ca9c08c006051a580d053b03',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'a0283cf8d2d00241590f16a6dad470a9c21e60af',
    id: 'range-test-20260619-2519',
    matching_hash: '7d716b7f13c7a633527aef736d8799874e129c1b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '7bc7105d22bde4160a0c2fbd0f17d14940359d08',
    id: 'range-test-20260619-2520',
    matching_hash: '962dae82be7dfdfff2771d1dc89308f08fd47421',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '2f67d32a3d4210d1eb3f1d2933d7ba4840da8b25',
    id: 'range-test-20260619-2521',
    matching_hash: '5dac48e00cd023146ec59fa56e71d31e9c904725',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'ac3769f1cb700d20d8f3f9a9d109ec69eb6b82cd',
    id: 'range-test-20260619-2522',
    matching_hash: '134d9cbcb4281a9f80f460a1d4314d309e388356',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'd146cdaee26476944115c9e554b3fdfbdbedc180',
    id: 'range-test-20260619-2523',
    matching_hash: '96feca56feed3a5f16c45d6c006d75e138b4b589',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'd607adccce22cfa49b4dbf26d3915ef431e353ab',
    id: 'range-test-20260619-2524',
    matching_hash: 'b46cf8a7932dc89606f98e3a5f240827166fcd27',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.641956094,
    qx: -0.332720216,
    qy: -0.690309814,
    qz: 0.025729202,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'b4afbea11d658614edba6281dfbd92e5085dcc81',
    id: 'range-test-20260619-2525',
    matching_hash: '4390ebe7a1efad5bc003b1df7beb9167ece8eeaf',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'c4e3bd7f03f7c1ceb92f5066b1fff52d018a188c',
    id: 'range-test-20260619-2526',
    matching_hash: '079f633bb5b18ee2a7738a925d3919c0dad603e1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '0188871b99f2f4363502528f041216c64f0bd598',
    id: 'range-test-20260619-2527',
    matching_hash: '4cf8ca84b9827843fc9a5fb30ae113d95a54dad6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '8f9c613031ece4df1f90517debb8dbf04c8258ad',
    id: 'range-test-20260619-2528',
    matching_hash: '3d21f82c67b95d90da2cd85adf8db72876903e35',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '531573675631109dd0005346c9e9919c479bf028',
    id: 'range-test-20260619-2529',
    matching_hash: 'a8eb6f7b666249301657a7d64a4e093805578066',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'b2136fba960972eb326eff6e64ded04c410e7990',
    id: 'range-test-20260619-2530',
    matching_hash: 'c566269f162e705f96a78efab1ff873b8407ac16',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '8b1311c803cccd9bb4add217e071308f9b7a3eeb',
    id: 'range-test-20260619-2531',
    matching_hash: '42ce0ba60cd936ee19441c818a357af6cf7bf58a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '3b1b74da7d613beb433262c80886925c0cebf999',
    id: 'range-test-20260619-2532',
    matching_hash: 'f335071d73118355b62c9dd66b1705e5030ac624',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'e00f13164d68f987a006071a7fc7e47843bbd79b',
    id: 'range-test-20260619-2533',
    matching_hash: '98e2875f91c432869cb7062ff577dfd58dfc279b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'b41ab6be34a87842409b7940271927ec63b37fb9',
    id: 'range-test-20260619-2534',
    matching_hash: 'e0db83286350969429bfb4098848e0ff7e283a47',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'd9396f49846b51f273eeeeb44d6fe7e8f4e96dc7',
    id: 'range-test-20260619-2535',
    matching_hash: 'bb49e186dd4cad53c31c5e7ea808d2d11766c223',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'd65ef7d14c31c05042054a0c85b00f3ff800550b',
    id: 'range-test-20260619-2536',
    matching_hash: '552e848eb7f205fc406a1d32a77eb98558f6179f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '046e28b2ee8649aedf69d2f9060814f2992ee5c5',
    id: 'range-test-20260619-2537',
    matching_hash: 'd4b125b97a947635e826b634922a1af0f4b257da',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '7d106c42dcad1b49443ab82d671ebfc7fbf3f877',
    id: 'range-test-20260619-2538',
    matching_hash: '8f860af1e379b575380aec9a85092f08308f6098',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '1c324da5ecf9231f2375c4cf92e375fb5e3b2df2',
    id: 'range-test-20260619-2539',
    matching_hash: '4fa456ba49c4ecd19170dec5dbef4ca6052a9ece',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'ba64de0bca61a4bdce90f3f20ac30564332f26f1',
    id: 'range-test-20260619-2540',
    matching_hash: '25960a8417285bad347ccdebbdbbe012d18e386b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '57f533446d10c7f65b800d064bba959eb4f6011e',
    id: 'range-test-20260619-2541',
    matching_hash: '2e00f9d74e696c46455126b98b860b3a2ab4962a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'ff9eec29413f0ab5ff6b64314a7b0975af9f0c1d',
    id: 'range-test-20260619-2542',
    matching_hash: '4f6d1dce164ff1694abd1a9812097157d13162bd',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'e8eb950ab487553f4ec4a64e8ebbed4353a24922',
    id: 'range-test-20260619-2543',
    matching_hash: '3a1a2d42e7f98f197d4aad68810b5a5ddff797d1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '136f71e5354e22515d4566a9373678a5601906e4',
    id: 'range-test-20260619-2544',
    matching_hash: 'f44db97f350c5974ac0bab62512ef808d53b1bf4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'a8f9bf63c3f3d7824094393d3330eccb68496af7',
    id: 'range-test-20260619-2545',
    matching_hash: '4960b70cb7f0c062d2576729dba0219109aa18b3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'ee43d03ca5d9d4503b5cbaa169d74b54dfb30940',
    id: 'range-test-20260619-2546',
    matching_hash: 'f8d7fd6316021f60932fde723830e1905be52e9d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '3305c1841a78ad0da28933fa7e006d93ca69f683',
    id: 'range-test-20260619-2547',
    matching_hash: '2ce24ba9ffef010c9526d5163768424c9ce1fc58',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'c836c9ac14c4264a1fb7f0e60a4e7a8776fff0e4',
    id: 'range-test-20260619-2548',
    matching_hash: 'e85d2d946276ade94c401258c2befb3ec26467c5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '0880a5335ea1afab8a232a3e31ce2fdc8be0d320',
    id: 'range-test-20260619-2549',
    matching_hash: '24a7ef5eac5bb3b74bba8209caf5d19171b124b2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '0a58120327300a8dbe832c703ccf9ced5d20d21d',
    id: 'range-test-20260619-2550',
    matching_hash: '3eb9cdc3d6491350d86a244fcf0588e88ca56f9a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'aa196756743a1dfe0e0f66990d52e5187d18a6dc',
    id: 'range-test-20260619-2551',
    matching_hash: '0a20d8374468126baeacd4851baf564d3e2bb2aa',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '01cb99a235b16773ebfe42c554123487d8393c74',
    id: 'range-test-20260619-2552',
    matching_hash: 'a6e07d969bdcccf7ff05c4c615bb569b04fc78f1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '5cb2c55ae1e2bab35d10955d40006ca181347f71',
    id: 'range-test-20260619-2553',
    matching_hash: 'f3e933ee6a3e6c1302620f86b07b24a09bb64478',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '872bfee62090bc65ba8d17c64607f2e5b8fb1330',
    id: 'range-test-20260619-2554',
    matching_hash: '62afa2e3e1937d4513bcc49389cdf535a8da5b66',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'c078a9edcfbbac4933acc784c0d048e53396c600',
    id: 'range-test-20260619-2555',
    matching_hash: 'a9574a80aac8a03ded8b9f23f45ce2d83afc29fa',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'e09b19a7d49de610508c23766098cf3c9e2becab',
    id: 'range-test-20260619-2556',
    matching_hash: '896c662d63d91e71a97f202fd2428084ea3ed1a2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '58fc5cd2589f38901fe0b8f3174a686eebbb7ded',
    id: 'range-test-20260619-2557',
    matching_hash: '487ebb535a782a662e91f411ac7aa6c52469b3f5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '411fb08a55f53d1c4ed483e657e6b921532d5c0d',
    id: 'range-test-20260619-2558',
    matching_hash: '6da57d0f1005577b3653a0a824b365f3cc0a67a3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'fb2b738c4e20f13d27386b7ad793710dccde0672',
    id: 'range-test-20260619-2559',
    matching_hash: 'aad69d3321fe7cdfc96858b3bfdcdf151ab68f27',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'a233e1276bf8335b011b63e22095f1d663ba2256',
    id: 'range-test-20260619-2560',
    matching_hash: '65573a645487666087712c02d8d2204745ae6bc0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '9afab34bd656a6f3d1af27f7f3b8d7a1b26c8e34',
    id: 'range-test-20260619-2561',
    matching_hash: '612cc67804b5f3a468fd916d7a636309f53678ca',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'fa8172c013327d84bd61bb1af8710ea11c7733cd',
    id: 'range-test-20260619-2562',
    matching_hash: '485050b639e3a2c9d18ce816aacbb225f9debdfe',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '2cdd388c6c1a47868ee9fdcb61d12dda14eccdaa',
    id: 'range-test-20260619-2563',
    matching_hash: 'e53e1eadb5c0046d44207c58f65b0ba39ad6c70e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '8d8977e47c4ec936cce03a2c322f1aec49121ff2',
    id: 'range-test-20260619-2564',
    matching_hash: '781f7ced2a210cfaf2031bbe7675eb99a046a635',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '40df2347463b42b492c9665ff93d8b257c7d4b30',
    id: 'range-test-20260619-2565',
    matching_hash: '1baab6cf321a18f1d646743b70aee659a617beb8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '15e902f7bd063d0efff033138ac67d889771bb11',
    id: 'range-test-20260619-2566',
    matching_hash: 'e79d580956a1feebdc8de4f24f296e39890dc4c6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'bc698ae34a5893436b7fa399dcc50499f50c1d54',
    id: 'range-test-20260619-2567',
    matching_hash: '17de6c1d4f34224fbd3446bc45cfc7dc71c28d08',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '2c695ac0e24c9e2687f0182792bef04b1d4697d6',
    id: 'range-test-20260619-2568',
    matching_hash: '87c4edaac8fd99a63ea0d2b290a2dd79c3dde9b6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'b13bd8b84c9df45f3a11585ad496dd3ad406a6a4',
    id: 'range-test-20260619-2569',
    matching_hash: '4f1cfae4fc98b8bc2320495c87cfce7b5e99acdf',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '4c879fc2405cec619679855a3bce679a31f849a6',
    id: 'range-test-20260619-2570',
    matching_hash: '5d0bff27efa5521029802d166502ed42a80591fc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'da1a36487061406e72d751a4fd145b7c6ecdf55d',
    id: 'range-test-20260619-2571',
    matching_hash: '65e7879c9d92c8e8ea3380def622bfd90dc1d7a2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '92feae3a1705880fe8eb11c2b8ae941ca402a69e',
    id: 'range-test-20260619-2572',
    matching_hash: 'd0b7e810da02caf20367a9f0ea4a0a4eeebfa5da',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'dd94ea960f860ea361be4a86acd16ce52592565f',
    id: 'range-test-20260619-2573',
    matching_hash: '339ff8528b4aaab53e19a54a3a7063e5cda03891',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '55fc1d55262ec51cef3788d6a26c62d52046be9c',
    id: 'range-test-20260619-2574',
    matching_hash: '9bac1b0185de2c0a41e2020b3b9afa6e7a014b72',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'e54c3d81e39217a0b54a3b09163c7e327eccd2f4',
    id: 'range-test-20260619-2575',
    matching_hash: 'db7fc00b6c4c9858a36c5224feaef9975fb4e02d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'cce50bd361d21d0706016290ec73736558175002',
    id: 'range-test-20260619-2576',
    matching_hash: 'e9e99e6017e8125feec7e9fcc397617f9e6f6528',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '6bc60dd01751cfbb62a6fd009f6c50648b1b9279',
    id: 'range-test-20260619-2577',
    matching_hash: '4dad7a864534d4c695924c3873d53acd92201ece',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '67b1f4f2f300486efcb71dbd042384a366618006',
    id: 'range-test-20260619-2578',
    matching_hash: '219c92bd360db247ed67dd17370cf3ca0b295640',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '3f86b13735bca16e390e22876e9f31961aa16db5',
    id: 'range-test-20260619-2579',
    matching_hash: '1c162645210d4036bea628b5fac21c0ee6f81d6b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'bbbcc4858b08a7ec5d8bffbb2085983b827d87ef',
    id: 'range-test-20260619-2580',
    matching_hash: '93b8da7631bfd678f9d295ad61ac84bb8faeacff',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '521ece8a18a82613d021a17c28dc53632bb2884a',
    id: 'range-test-20260619-2581',
    matching_hash: 'c6711a2b5e730ce1339622621e85178cffd86348',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'ff4fe3177c28f76bac51ce172f91306b65564839',
    id: 'range-test-20260619-2582',
    matching_hash: '9f8c09ca5fbd360b7b17188c5c6b58b42c8c95ab',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '9e007beb8e79df44c47b8208d07577b9a2c3e38b',
    id: 'range-test-20260619-2583',
    matching_hash: '33071cf40371a8ae0059372f53175c3f7cae8247',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '276ce11f4dd35810c69a662378353873f6fe08cf',
    id: 'range-test-20260619-2584',
    matching_hash: 'c2b1c4d78bf3031934265af30cc5dae6dc95b40b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'dc72b06ff2b56393dbbe3b76fcb2ef7d3c47d67a',
    id: 'range-test-20260619-2585',
    matching_hash: '5b342cbc63009a69bb879d4a608c82cae4624504',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '7b5941fdb09527238438237cdd16c2b5cdf3fb1f',
    id: 'range-test-20260619-2586',
    matching_hash: '3338264fc44956efb8a79d7105ba834e095d735c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'cd9c2e8a4bd96bebc0dda739f49ba3bf460c1acf',
    id: 'range-test-20260619-2587',
    matching_hash: 'a1b70c2d1f759051a09ee10cd448e7d35b690297',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'e532ccb26cd9002937966df26505fcac4305f430',
    id: 'range-test-20260619-2588',
    matching_hash: 'ee9ae62412397b9ba32856e6c3a82cd7ccd4e017',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '62d6a59181b696891cb11aa1b5753cf26c9e7a16',
    id: 'range-test-20260619-2589',
    matching_hash: '0fde611f699a125c48786f3981ca53db742dcc58',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '11856ffd1e1e7788dd9894f6ec82346c55d96ee3',
    id: 'range-test-20260619-2590',
    matching_hash: 'e3febdb6740bcf55c1554dac8e11446e3627b422',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '3e5ec1791fb4ca2501fc3ba3acd9b597383dac23',
    id: 'range-test-20260619-2591',
    matching_hash: '62bf9495a9cccf72e3c63999497873e57e42fab1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '9028eab839e0091ff5517552c93c955537b3fbb3',
    id: 'range-test-20260619-2592',
    matching_hash: 'c8f9e051d28770dc3a96550fe4f007e872777926',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '85946a9b7b65e2fd3aa53e4fd8bd81ece697affb',
    id: 'range-test-20260619-2593',
    matching_hash: 'b2c38d54faacd5b149fa9c63016029d9b8b3ddb7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'fa6df6d5cd038209d7a7738cbc710a21cd2c3f94',
    id: 'range-test-20260619-2594',
    matching_hash: 'd3d3d10e4866fce7d29cb9cd3da3ea83a98dd410',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '1a33f091439f038816aacbf5c2ef6542257aa846',
    id: 'range-test-20260619-2595',
    matching_hash: '5901a7f6f04148c7403ebc26967e6ccf8f2cfd87',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '5c9c23346feb38b52c1d158e6de5c8387e8ef32e',
    id: 'range-test-20260619-2596',
    matching_hash: '955f995ecf19ef2e7a654632594883ab74d6ce75',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'df8f25efc907c12397654d201caf536af4c2035f',
    id: 'range-test-20260619-2597',
    matching_hash: '81876a1f5167ce32a276416aa1bb1658db74a657',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'b06a2c7448b3d440fb4b726ca46c557d5f45469e',
    id: 'range-test-20260619-2598',
    matching_hash: '162f6201aa87b6ef9d57258a81e3959f4a58e2a1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '604e656c363f04115b75ad0a1c26b21a3adb2760',
    id: 'range-test-20260619-2599',
    matching_hash: '30eb53327147e91db04f64b1e12255be35e84b85',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '58c81bf9cbbe952f3004cfe137189d5a7ece01fe',
    id: 'range-test-20260619-2600',
    matching_hash: '980d738f9b7da951da35b9013811237f8931c1a5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '6b23b8e41d44c2826c9fbe62f3b4ebd255d28b5d',
    id: 'range-test-20260619-2601',
    matching_hash: '5781d5ab5dc6f1c382483072e20ece9e5f1ba5da',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'fa404b9c634e3a9d95636608dd647534cf02ba0b',
    id: 'range-test-20260619-2602',
    matching_hash: 'ed534422ce2499c12387c58a1c50e17f92aca026',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '2053901035f9ded8d70ce0e72a6b4e4ae9af0d3f',
    id: 'range-test-20260619-2603',
    matching_hash: 'f471aadd2b34e3e5fe845964af9068f7dfc8b577',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '23082ef48af5718ea1a6ea26e4fd82775b6f4760',
    id: 'range-test-20260619-2604',
    matching_hash: '1617c32bacf166a36918f0ab009e0ca0a0348812',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '4b31e4753bfa01546a34afd70ed6fd142870c066',
    id: 'range-test-20260619-2605',
    matching_hash: 'b03824945bd5b114cb0b9e6bf92bd78af70568f6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '44f9f890c34cbed813a2fac9b40811a5db7b7a8e',
    id: 'range-test-20260619-2606',
    matching_hash: '92461b7f85adba1aa8a9b6d39768ae12dcb5fba5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '7cc6996125ebf31ee7a71b7452dc87fa49f45371',
    id: 'range-test-20260619-2607',
    matching_hash: 'd688ce24a02cbf5f0f743c577d6b00a2485442e8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '544d6f3fcaf960b00f70d0f5cf8453dee6f89c9e',
    id: 'range-test-20260619-2608',
    matching_hash: '6474c67070c8ee989db14e6451e8badc17e278b4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'f21671fc3f05c78e267f0cd3ac14ab7908ddc161',
    id: 'range-test-20260619-2609',
    matching_hash: '26144530a262466bceb8a0a0a01dabf3859a03ca',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'eaa6c874a585225a7dd2fd5826bff4f18a26ed51',
    id: 'range-test-20260619-2610',
    matching_hash: '78644030618fedba274398ad2034fd0dea0f055c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'f31483e20366dcc52a947d1abd0a785ae76dda53',
    id: 'range-test-20260619-2611',
    matching_hash: '7fd4d7578a5e0b937b541fe69e924160e593826f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '17270f0c172deffa1c44d8b2de0a01f1b6979ed7',
    id: 'range-test-20260619-2612',
    matching_hash: '4be7d188fa02850e75c43b16c216c0784de115ff',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'e9467ec4cfa8f1f0ec237e9d275a55bb74b3e69f',
    id: 'range-test-20260619-2613',
    matching_hash: '78050008b00c6b4cca3d48272098b392e09f29bf',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'c60551e65c46c59dcbbc93642dd0d3890b2a72f8',
    id: 'range-test-20260619-2614',
    matching_hash: 'eb796154a71f97fad5e361fa0cb8ea02380e2c34',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '6371a54e2e191b4f7e29f96f76adf8b4735ac207',
    id: 'range-test-20260619-2615',
    matching_hash: 'f1e898cd1e183894b785246f2724bdb539ed545f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '8ceebc7c3e6d219ac30234eb37337d85a98c7f8d',
    id: 'range-test-20260619-2616',
    matching_hash: '44e5fe3c1afe8ea3aab86f6533d9365b39d108a0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '9352453ce8b1e15dadbbf67bf5d12202e213d1fc',
    id: 'range-test-20260619-2617',
    matching_hash: 'e11e921a10bf6a4b5232e0d5f434ceeb6bed1969',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '97abca61d89d32fa03df4d5c1b67ffceee3e9d49',
    id: 'range-test-20260619-2618',
    matching_hash: '7f7b975067ff35499889efbef36c935115d71bc5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '704ab163f1c109e86d59c9464041efd7f9711a3a',
    id: 'range-test-20260619-2619',
    matching_hash: 'd4cf179b14493a9890a693a0d934432baa5eba0b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'ea0aa711947c3529bbf73001e7057e2268577978',
    id: 'range-test-20260619-2620',
    matching_hash: 'ee936d39408a7722937ad95f7dbbf7917c649a2e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '09e89488bacff75d382ae9ae47e142d6cdbf2ab4',
    id: 'range-test-20260619-2621',
    matching_hash: 'c91f84a8f1267dfcd28b3c6b3f9cf08fd09be9dd',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'bc115a3c06b2d3eda9e5d1fdef0df4f3b9df09dc',
    id: 'range-test-20260619-2622',
    matching_hash: '1cc09f6aa16dca6f6cf92a1bbbafa31de2996b90',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'da88e2ff5c3807b429b86c326f3304192e3d1ddc',
    id: 'range-test-20260619-2623',
    matching_hash: '942c6336fce44cba9b39ff43f10a4e639c2c9e52',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'f7815ddfd15c51ddf5df80dbc40e7a03a7d24383',
    id: 'range-test-20260619-2624',
    matching_hash: '04238a2ae4914865a7c090702488e712c4216fda',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '00c724ab9058f679f1346ec8be158258471c3bc6',
    id: 'range-test-20260619-2625',
    matching_hash: '96d74c7e885a53d7d3aa1752376c67428b7dbbf5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.830451585,
    qx: -0.295305167,
    qy: 0.04936928,
    qz: -0.469795377,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '67df44fa766b2759c8aafedf57f10b3dabcac9b0',
    id: 'range-test-20260619-2626',
    matching_hash: '126e08b5baa1ea736af037db2c66a52b296642fb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'c266d046fb658f12415d412d2543cb3a1472c409',
    id: 'range-test-20260619-2627',
    matching_hash: 'e6b55a0e32a334ed4491c1f6fa82fcc6a5a02a20',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '9fc31abd924c2b89ab97c1b68151f91997a9d658',
    id: 'range-test-20260619-2628',
    matching_hash: 'e327245f63a44b38342754d3e080a29063198c56',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '1730dd8ca43b6b2d0979ebf3ce661e8f349eec37',
    id: 'range-test-20260619-2629',
    matching_hash: 'b38140eff14c00f8174c75da9ddff96c191781b6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '8fd9f65e1b6af998f0dcc77487122348348e9d1c',
    id: 'range-test-20260619-2630',
    matching_hash: '476b20d9ccd1fef9185125af397020d12b513ad9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '03e2d40ab0eae1d59a906059ad995cad618a8329',
    id: 'range-test-20260619-2631',
    matching_hash: 'f1fb68e3ee3964dc95746677bf85308d6cf88301',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'a9da5a7ac70933745881e267dd959882548f7acd',
    id: 'range-test-20260619-2632',
    matching_hash: '5b80a6de97e76c90b2ebc0341c686e9b1e145644',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '25406bf47f375960bd97b15f9a3279ea63b33400',
    id: 'range-test-20260619-2633',
    matching_hash: 'ae8c084495115890c5abdbbef17f1558c69a50de',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '94bc14b7d29f0cf5ab8ab2b997e887415f423044',
    id: 'range-test-20260619-2634',
    matching_hash: 'c92b40a9c547023c5d8811d07a9abe9aa826a321',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '3e26f9ab91c26ed8dec47be19ba97dc4edc6b852',
    id: 'range-test-20260619-2635',
    matching_hash: '36c02bc88f1ae7ffa1af922d98d074590ab38ded',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'ceab30365d8f576c43654b8ceed79f7bc477e427',
    id: 'range-test-20260619-2636',
    matching_hash: 'dce5e1c5863119f9637bd8580e12bf28a1a06a84',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '1efb638e08da1ef58c074999b571e59443517766',
    id: 'range-test-20260619-2637',
    matching_hash: 'f60a04918f37d699e60681f3fe379614fbe4543c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'd23190be20c1838093c77d1bba3a0c10634187fa',
    id: 'range-test-20260619-2638',
    matching_hash: 'b240e026805a53f1d7f2aa078d86859e2af92b97',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '156ec29405eb94cc73b3cdf7c6ceb922e294a9f4',
    id: 'range-test-20260619-2639',
    matching_hash: '7483a4c4784839c31210bb1c0882e2f983cbfe71',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '040741ce1b039a9d123cd72bbbeb6065ec4dadf6',
    id: 'range-test-20260619-2640',
    matching_hash: '2ea49a1592ae1898d69048d74b6b3900b3afcfdb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '82aadfecd468cff4cd94ddd170561a0d57709546',
    id: 'range-test-20260619-2641',
    matching_hash: '9d7bc13ea921c15c0af26b78c62e93b75bcfa9a1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'ec47459149ccca61a714954c86791c5e3ddada69',
    id: 'range-test-20260619-2642',
    matching_hash: '1b77592a1ded98835fdc799263363f740b8139c4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '9d7c0262e69e2ef1cf21d80b8c1338fc30fc2a87',
    id: 'range-test-20260619-2643',
    matching_hash: 'f84a03b3ce8e39a94751e64313f96b955524819e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '8c4c4310b91ca7c73d938161c8f199a70ec3ff0f',
    id: 'range-test-20260619-2644',
    matching_hash: '9646c924d8d5a394f589dca1bfe53be125b055fb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'ff801b61f487c895f240d12675d2aa06f61afc4b',
    id: 'range-test-20260619-2645',
    matching_hash: 'e519969978f625fe9ffc647bb81319ad4126c0f1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'f13a4d28b2e9460755103ef748abdb73ed798e3d',
    id: 'range-test-20260619-2646',
    matching_hash: '1eaab5e281fb07858c804cdbc61a0ce9d86cef76',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'fb4348044242ef33608243b2b84f56cf2e65a46a',
    id: 'range-test-20260619-2647',
    matching_hash: 'ca5939c38bdcd78be726a43035d4167250ce8ae1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '082eebb7c758f6d24085ff88fef6986085bdf331',
    id: 'range-test-20260619-2648',
    matching_hash: 'fce6442e48ff7332c9cab4bdc7795f966c4c9a8f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '953f49fa13b3aa63a627aaa4e9c81644260d504f',
    id: 'range-test-20260619-2649',
    matching_hash: '17017ce16b58d3755ce06f453027bc2a61f8109b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'b720765294cfacfc8e341532563b21d349ac2992',
    id: 'range-test-20260619-2650',
    matching_hash: 'fb51f2e905a9763712f087361cb1c9e03c35946d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '4caea866bcdfc3d68f1a427d82796781cb1f5560',
    id: 'range-test-20260619-2651',
    matching_hash: 'c45b4061f673d75a534ddfcf608011fa8f7e34a3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '87954c40f517e9bdd88efff5b1591664156c14aa',
    id: 'range-test-20260619-2652',
    matching_hash: 'd1a01c7549d1b712abc1c8a2a93288bec7863561',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'bc124f06a43d008ccbf4a971ec54cbf5bc3b2aba',
    id: 'range-test-20260619-2653',
    matching_hash: '2a6fb168b65ef7714acc9934f59c4b51511f8a4a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'cce428a42171bd4298284287c0856b22fea22022',
    id: 'range-test-20260619-2654',
    matching_hash: '992ebe9a01a3222a9537b7b3ffa3fcad23aa0856',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '9ae3ff8b89aee6484b698d148d0af89646850777',
    id: 'range-test-20260619-2655',
    matching_hash: 'e28b36dfe3d79762a274e54ab21a9798175bcf8f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '1a7eb3a04cbb65fee38f45832b0be35deb1c1cdb',
    id: 'range-test-20260619-2656',
    matching_hash: 'b64980f2875f20fb68ef99e40673daa0e26d72c3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '8e9342b6dccc6ad151bd2f37c6d0107f0a0c2937',
    id: 'range-test-20260619-2657',
    matching_hash: '090280e4823eacac053105bdc0db1ebff534f6ab',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '952baa7e4a6ad8d26703ba064264d9c478bd93ad',
    id: 'range-test-20260619-2658',
    matching_hash: '57b8d4372e2a877aa68f02409cac67febb3bbf45',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'e3b3fd47bca0afbc290b39a1c1f1d41900ead1cc',
    id: 'range-test-20260619-2659',
    matching_hash: '7cadcd95ec028b2c6c4f4278f743358dc91a5a4c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '362c52c9fba6f1af99ca852bd2dbdfcdac76396f',
    id: 'range-test-20260619-2660',
    matching_hash: 'b5a8b46e49cdefd3ab18c9c9b79ace157cc39fdb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '73a12e48b1742e6941f07f4417537eb734520e04',
    id: 'range-test-20260619-2661',
    matching_hash: 'bab4bed137e4cc249069eeb0e84a2130658068b5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '3221649ba49a04efaa63ac8bcef7148ab4251d97',
    id: 'range-test-20260619-2662',
    matching_hash: '56197140cc9f021438c35a6c92dbe2588ec93fb7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'bd63390fd4835d5a80c0ebb3df4f02665809120c',
    id: 'range-test-20260619-2663',
    matching_hash: '8f9e0a1c307b868ead4af5aa0cdb4a976842356d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '3850e8b5e11a7833792fe30638dde85d61277b31',
    id: 'range-test-20260619-2664',
    matching_hash: '0ca1656ba77cbbbfc2565cbea3205428738833b9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '0558653196339b63e8922e98383ee4acad3c74b0',
    id: 'range-test-20260619-2665',
    matching_hash: '38a6523a623eedd00610a1834d608ee33003d973',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '657aff6125b897986b74e7d21c6c01ab699ff935',
    id: 'range-test-20260619-2666',
    matching_hash: '98f3b844f34950f32d2c166dd9e5cd2f5526e06d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '03a7f5679dd61f09bc960c6776a662ee32d7ff52',
    id: 'range-test-20260619-2667',
    matching_hash: 'ab9b9faecda356d8eb0d1810bda83d83814161f3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'daeba8c5e6a4e12e6701046d4214545afb3d4eb8',
    id: 'range-test-20260619-2668',
    matching_hash: '6712aa0d0a501dacb3f14808633e96423a04ba84',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'e517178bab3431ee9d190dae992044e0e6d4ccf5',
    id: 'range-test-20260619-2669',
    matching_hash: '7ef33de71f81e1f4b06c508efbfa816b8e13d947',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '2bf6088eb2795cf535efc4bdd7b62ef722786d9a',
    id: 'range-test-20260619-2670',
    matching_hash: 'e50e4e2386399d550234b675a3a2ff7214f88d05',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'fc20174f44ddee4a47445ed855d9108096cef04d',
    id: 'range-test-20260619-2671',
    matching_hash: '8187e4916f74df1f301856d43023a29827a67b40',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'adcc9b2eb72b1a7e9125eae5d21f57d1544b0fcd',
    id: 'range-test-20260619-2672',
    matching_hash: 'ca147d4b1314170008e133f31044fe77840b0698',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '8d4b94ba69bea98b7257408d9ea4582c23a642da',
    id: 'range-test-20260619-2673',
    matching_hash: 'f3f8443367c2cb1420fd55dffd876c16b5c04363',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'eb5685fdadbdb62acad94be7362e0314a838c15f',
    id: 'range-test-20260619-2674',
    matching_hash: 'f4027f30eddcf40b0530c64ec84113567ef6ae2e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '81f151d183acf0af147b31d5f0cadccd86d511f6',
    id: 'range-test-20260619-2675',
    matching_hash: '6070debc5c889682d4cd76f3b3e6f27dd85a7bbc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '8f7be6cccd54ef07ecc1e926f1b6b2c2b3889ade',
    id: 'range-test-20260619-2676',
    matching_hash: '2c8ebe3781483efcc1981afb7ff68fc80240267e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'fd4df6ed1fd3786c478c243b7a4dddb61ca2df1e',
    id: 'range-test-20260619-2677',
    matching_hash: 'aedc211aff801f038fd186a546f967070e40e561',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '3b2dc380dca3708dc984039a7111f4a6d8a7e446',
    id: 'range-test-20260619-2678',
    matching_hash: '177dd10d9e3ee01b7439412c387b0674401270f2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '06525b7ac456ed528b5c595f9cc053f30b063cbf',
    id: 'range-test-20260619-2679',
    matching_hash: 'b72341b1d000801ab85c0efbb8dc816c05392d8c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '4ab78d740c5b5793779330b26bf8b656a49d915f',
    id: 'range-test-20260619-2680',
    matching_hash: '61ee674b2bcd4ba28b38af95fd51646bcc83af34',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'f66065b6a9af8d7b90fe1f51067ce0fe2a1937dc',
    id: 'range-test-20260619-2681',
    matching_hash: '5915461b6c0246fec21d797d72c21a4bb494faef',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'e8e2ef2d9e7b6ba8aad8be975d734456b17a1673',
    id: 'range-test-20260619-2682',
    matching_hash: 'bc5ff90c0b7f7741bc0994cea2fac848e5d528d5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'db4d2e9ef974a936715a7e1e5efa6481c0f125a7',
    id: 'range-test-20260619-2683',
    matching_hash: 'a0ea537f4c9a2effe4316cc66d1e2c7dce906ad3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '8cf7928d8ef56f04f8137e10bd277e3acd5dee4a',
    id: 'range-test-20260619-2684',
    matching_hash: '0d8ed4be5339960482a31dbc785cb1c8705b733d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '229a932612db6b2c29c3af21d576d9ebd2109cd3',
    id: 'range-test-20260619-2685',
    matching_hash: 'd1513dff3d5aed8c962a77f11be1581512b4a97b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'be654bea36d5ec68be943e558e6d98aa32b67830',
    id: 'range-test-20260619-2686',
    matching_hash: 'e35f5c1d1f00dd926d343e9a3c9b935d6cc758e4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '849aa34e0bfb9abd56ee79ae93237a0d21f6d34f',
    id: 'range-test-20260619-2687',
    matching_hash: 'dcc8323e7ff465aa559dcc3a9de724e24b1ddc4b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'e699d7b4917b41a0afc0039b7d1b66701394e270',
    id: 'range-test-20260619-2688',
    matching_hash: 'e3592d10c2d50ba6360608f5b293ab9ef56201d3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '19b003702caa1dc24734c43e6bb7a8adb019ef60',
    id: 'range-test-20260619-2689',
    matching_hash: '5e4d3be251baedeb8bc4395ff7674cba62f1f89b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '90e082abcd7d54d9060af3a828c1665fd8655edf',
    id: 'range-test-20260619-2690',
    matching_hash: '7525bee13a925092e355a7223ff07511158c3334',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'e269e29f5d42b0681858ca8611e57016be7f6ba2',
    id: 'range-test-20260619-2691',
    matching_hash: '10b27b95cf638d8dc960745adc285473aa1c5f4c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '5f3a64288d6110274b4164e2a195299b2024b925',
    id: 'range-test-20260619-2692',
    matching_hash: '15e7126008ab09c92d39de0b7259ab2fd30a3dd3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'd89a790c5e3a53d0ef6d8e846df2909fff0d2fc6',
    id: 'range-test-20260619-2693',
    matching_hash: 'e3a2d013e4cddb9b0ed7af9056be5920c5190025',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'df24f5c7f7a8d2a1d6344e81228788eb2fae6adb',
    id: 'range-test-20260619-2694',
    matching_hash: 'e0e459d0b8dc72c231ff7ab668963b7f223b13f1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'c396b1eb000c843ad95c94306d326cfa404a40c7',
    id: 'range-test-20260619-2695',
    matching_hash: 'e1d1eef2f4e6d9d197cee172289599e819f9e744',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'ba5b16cd006e631f618bcd51c9b6bb28ae2cb49c',
    id: 'range-test-20260619-2696',
    matching_hash: '126e08b5baa1ea736af037db2c66a52b296642fb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'c42e34f84853f811629bb3950a31fe50e9c273f1',
    id: 'range-test-20260619-2697',
    matching_hash: 'e6b55a0e32a334ed4491c1f6fa82fcc6a5a02a20',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '4667c880f2afb378ff79a7e3ba7f10d9912ae862',
    id: 'range-test-20260619-2698',
    matching_hash: 'e327245f63a44b38342754d3e080a29063198c56',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '1bbf6f39fbef1451e7fc1180058cf5d3c046b8dd',
    id: 'range-test-20260619-2699',
    matching_hash: 'b38140eff14c00f8174c75da9ddff96c191781b6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '39cb82b30355a8309a100caa5121cd7efe3061d9',
    id: 'range-test-20260619-2700',
    matching_hash: '476b20d9ccd1fef9185125af397020d12b513ad9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '535643904b66fc288b1ca98b0e0eaf26f921c006',
    id: 'range-test-20260619-2701',
    matching_hash: 'f1fb68e3ee3964dc95746677bf85308d6cf88301',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'b54806a3c08fa3d4decd63e50cef52339b78447a',
    id: 'range-test-20260619-2702',
    matching_hash: '5b80a6de97e76c90b2ebc0341c686e9b1e145644',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '936be1eeaa2d62c295a0c05e971e8edd0e4bdd23',
    id: 'range-test-20260619-2703',
    matching_hash: 'ae8c084495115890c5abdbbef17f1558c69a50de',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '12db867227fa359ad2f7c6e10071dfbf262ecca0',
    id: 'range-test-20260619-2704',
    matching_hash: 'c92b40a9c547023c5d8811d07a9abe9aa826a321',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '9d500fb8d35b29b72419bb4e83fa208ff7f9bb90',
    id: 'range-test-20260619-2705',
    matching_hash: '36c02bc88f1ae7ffa1af922d98d074590ab38ded',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '3e01c2ee4011519f69ae9a0321e5b51ab98f9789',
    id: 'range-test-20260619-2706',
    matching_hash: 'dce5e1c5863119f9637bd8580e12bf28a1a06a84',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '5678a6446cbba25e735fe14107debebde79c47e1',
    id: 'range-test-20260619-2707',
    matching_hash: 'f60a04918f37d699e60681f3fe379614fbe4543c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '2fe2492857e1aa313feb3a7486d0af18c100a597',
    id: 'range-test-20260619-2708',
    matching_hash: 'b240e026805a53f1d7f2aa078d86859e2af92b97',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '7ca49aceb2b2bd145e8fa6a153e9b377e8701436',
    id: 'range-test-20260619-2709',
    matching_hash: '7483a4c4784839c31210bb1c0882e2f983cbfe71',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'dcd12f70c3fd716440a36d0fbd6fb48f373dc84a',
    id: 'range-test-20260619-2710',
    matching_hash: '2ea49a1592ae1898d69048d74b6b3900b3afcfdb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'b0191a3560467194ac2481e4fa88231327d05d09',
    id: 'range-test-20260619-2711',
    matching_hash: '9d7bc13ea921c15c0af26b78c62e93b75bcfa9a1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'fec3a633b0b26c949d6671dd251eef68949cc641',
    id: 'range-test-20260619-2712',
    matching_hash: '1b77592a1ded98835fdc799263363f740b8139c4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '8b58b2d3df19d9cce0e5c47f4bbb8e8dd8d0d298',
    id: 'range-test-20260619-2713',
    matching_hash: 'f84a03b3ce8e39a94751e64313f96b955524819e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '0b873a7f00b6983398e3a2f621203f649138aaa5',
    id: 'range-test-20260619-2714',
    matching_hash: '9646c924d8d5a394f589dca1bfe53be125b055fb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '9a6d75bd6b465ea574776f0fb72981039b0a1cb1',
    id: 'range-test-20260619-2715',
    matching_hash: 'e519969978f625fe9ffc647bb81319ad4126c0f1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '50d603409621d0c742f5a7582ae927ad2f90e058',
    id: 'range-test-20260619-2716',
    matching_hash: '1eaab5e281fb07858c804cdbc61a0ce9d86cef76',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '721cb7fd442ae73794461fd92c738d424dc73c8f',
    id: 'range-test-20260619-2717',
    matching_hash: 'ca5939c38bdcd78be726a43035d4167250ce8ae1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'dc87ad445c7177cbfe384116634fa55c66ee3e80',
    id: 'range-test-20260619-2718',
    matching_hash: 'fce6442e48ff7332c9cab4bdc7795f966c4c9a8f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'a501edb5555968af14736c825a4d9e1e0ab4c7bd',
    id: 'range-test-20260619-2719',
    matching_hash: '17017ce16b58d3755ce06f453027bc2a61f8109b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '26740b92b02073adaa1c2a69dcd9c700f23023b2',
    id: 'range-test-20260619-2720',
    matching_hash: 'fb51f2e905a9763712f087361cb1c9e03c35946d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '477166d08c430cde52a8a910207beff81ec2d554',
    id: 'range-test-20260619-2721',
    matching_hash: 'c45b4061f673d75a534ddfcf608011fa8f7e34a3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'fd08d2ef89034b155b04059ddba57a085566214c',
    id: 'range-test-20260619-2722',
    matching_hash: 'd1a01c7549d1b712abc1c8a2a93288bec7863561',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'f73ccf80e81ec0b17eae078786d8acebb798030f',
    id: 'range-test-20260619-2723',
    matching_hash: '2a6fb168b65ef7714acc9934f59c4b51511f8a4a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '4d2caf0a59f1f7a4342c8732ba7981845db369ce',
    id: 'range-test-20260619-2724',
    matching_hash: '992ebe9a01a3222a9537b7b3ffa3fcad23aa0856',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '359077edba8664a46d09eeb8742356222e38826b',
    id: 'range-test-20260619-2725',
    matching_hash: 'e28b36dfe3d79762a274e54ab21a9798175bcf8f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '538d91530cfd26f34418d4c8093215ff16f31147',
    id: 'range-test-20260619-2726',
    matching_hash: 'b64980f2875f20fb68ef99e40673daa0e26d72c3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.225006017,
    qx: -0.57245669,
    qy: -0.512961585,
    qz: -0.598778792,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '3fd275f5fc054296a1b7ba59e1217f4fc7538bd5',
    id: 'range-test-20260619-2727',
    matching_hash: '305bfa91f225a8334f2f28d92929d8b93ea48981',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '420e7e51432828006575e7a8c669d43fbb315f23',
    id: 'range-test-20260619-2728',
    matching_hash: '8de8324ebb1f7606dc7c55b1a97ec7e789686280',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'd314bebb36c8f3f51340bcde7e520766173d28d8',
    id: 'range-test-20260619-2729',
    matching_hash: '454c3edf3ab667ee051da809063a8aea374b35b1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'b0354d9f6fb5f7c486a1ed0059cca97a1311e038',
    id: 'range-test-20260619-2730',
    matching_hash: '6851b7bf7ddf430d98fe6fb57fac0933abf868be',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'f5db203bba70cfb60de34a52ccb32a2f8a211625',
    id: 'range-test-20260619-2731',
    matching_hash: '2c2a5a97da9ffd125ca7433eb8c348281f26a967',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '661644a83a496340a31d76e3ccecdf5c501e1e5c',
    id: 'range-test-20260619-2732',
    matching_hash: '80e2fa054ce1056e887e198e3bad369e2a460b31',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '186c34e28f4afb46b6936518082a69f438b8032c',
    id: 'range-test-20260619-2733',
    matching_hash: 'd80d7b61df099fb21411c7dda8ef1ae3920205e5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '38c08a14a10a5a9c41dacaea750a016a88922a81',
    id: 'range-test-20260619-2734',
    matching_hash: 'c5cf7c0fa9af3c46734ad6c49917e1e7f2340aec',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'c5aa36a958f97cfb1d1e6756bef2ed6f116c128a',
    id: 'range-test-20260619-2735',
    matching_hash: '1ac093cc3945f6023e30d96fb8eb2b14003b4efd',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '0ad1118e4f4a02bc92fe7003baa0514ce760634f',
    id: 'range-test-20260619-2736',
    matching_hash: 'bc047e7e7b8d49393ebd353ebfa24fcf4cc5a107',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '5beee568f18dd0da0159f08c21ab9601e966062d',
    id: 'range-test-20260619-2737',
    matching_hash: '7724cfb5746a1d23e5fc1326ed693712c74aac14',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'e441e34e7a570b1e7c7756a5b09d588833c76d77',
    id: 'range-test-20260619-2738',
    matching_hash: '55b934db6b7c34113320dce1e38095827c0f53ab',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '08bbc57d11f7f5b4b86de330693ef0c1a033aef2',
    id: 'range-test-20260619-2739',
    matching_hash: 'dbb44e58fe403e3826a79f0679836810d7e3d3b0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '8d1045a576d54cbcd21a54bc5391840d81f94a9b',
    id: 'range-test-20260619-2740',
    matching_hash: 'f189cb6df3e853af672ea81c791e2d041798350a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'fa1f5c512082175f0e1788e0d6707a869df509d0',
    id: 'range-test-20260619-2741',
    matching_hash: '83f4d05b19a1ec16c0f470e7f18f2e08351b1808',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '5820d4ca4949e28b75fb998322b962f20401ff23',
    id: 'range-test-20260619-2742',
    matching_hash: '84e13d39b8e6b0795bc376e434eaba45446405bd',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '549ea8c04da92e48225dd4d9822ef356b0a02150',
    id: 'range-test-20260619-2743',
    matching_hash: 'c2a27137ccb28e144fafdea5c13022ff317c522b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'd6f44de7c36a4eb16e7b70250dee58e48c9dba2f',
    id: 'range-test-20260619-2744',
    matching_hash: 'ab522601462592408e320a3b5dc6a7098df5c0ca',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '4ab01246fddb4cb9387d0ea8e90b7426c3117cd6',
    id: 'range-test-20260619-2745',
    matching_hash: '7c6e76a483ce4560e7c445194bef26ec44c68a84',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '4e566f7f44bc41f4f8b957a017fdb2cfd29bf26e',
    id: 'range-test-20260619-2746',
    matching_hash: '15da606a1e3997dc9b8a5638301a37dda5969bc3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '2bf39d7b4a4663089d4087d67b0d53d4316e10d5',
    id: 'range-test-20260619-2747',
    matching_hash: '75416ffb632b15b88fe8426dd068acb02e5acb5d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'cfe0aa998eaaa67c64eeb7f79f04318f9bad6979',
    id: 'range-test-20260619-2748',
    matching_hash: '896e06439c907506926bd16974c3efd50391c655',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '8f4e59ea206b2d1ded75624ef98a165723099cfc',
    id: 'range-test-20260619-2749',
    matching_hash: '92a9105a3b22eb8dad4abfefe261663a2dcd0dca',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '2e935d2039a62b6a75a48d7b76b04f50798bb390',
    id: 'range-test-20260619-2750',
    matching_hash: '5d849953c64e5217ce3ec6b04c506001964f3e8b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '45edab2a5d2315b9cacf9847aac44352f7145694',
    id: 'range-test-20260619-2751',
    matching_hash: 'cb33b6d26d6659d8b926d4eb8549b2c080ce8744',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '41725200fad4e796b843d7ce3f18b0b6aa59e457',
    id: 'range-test-20260619-2752',
    matching_hash: '206fa569d7d56bd38a718282802c55f88195a686',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '383c80d6f0d117e145907b9b57cfd495ea752504',
    id: 'range-test-20260619-2753',
    matching_hash: 'ba958cdae2f8c3b78754964f7a7fcf4a9b7f0dd3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '4a87bebc6aec6a115810887fcfe8d1c7eaaeed9d',
    id: 'range-test-20260619-2754',
    matching_hash: 'c3650469223e440975986c0961205637f4acf35f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '4c2e9a76557a0662ad2643e348791b265b6a51a7',
    id: 'range-test-20260619-2755',
    matching_hash: '7807702a73a1ae338bce792f925584a6f49b42e6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '0d54779780b2ebf209ee17899e8b209cca247e65',
    id: 'range-test-20260619-2756',
    matching_hash: '7c4ced4e4833ac93c6c705dabd85122846536383',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'ae5ea235e3bff139c5c4d44186b2f029b08d77ce',
    id: 'range-test-20260619-2757',
    matching_hash: '5fbb28bb430899e1d4bf8991183914e66d150dd2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'a01a854db5707e1aaa3c43005285b0b1661daafa',
    id: 'range-test-20260619-2758',
    matching_hash: '8c0f227b775b3da8fa167d9959072afbeade5dd9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '9bfaf71a194e37363805200a38faa2cfc0b1be6e',
    id: 'range-test-20260619-2759',
    matching_hash: '532ad7d17da589a603c7763347a57b4cb842d6ee',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '5e7216e477d61b143bf4b8d9523b318f864a2c9d',
    id: 'range-test-20260619-2760',
    matching_hash: '9f1e2db95ea4cc4de8b42d5ed658b9b4b4c64652',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'cbc8ae32a772ffee455a866307104dd7d5e2a973',
    id: 'range-test-20260619-2761',
    matching_hash: '465983b2bc2997f7a67e71db0d3893241ebb052a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '91e14608e10a99051a9aa271602b42655a86e4ce',
    id: 'range-test-20260619-2762',
    matching_hash: 'b2afea2c146a5cde05774f2144dbdd39e42436d3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '6d6c5c4633c0c273260edc3090d760c9ba396551',
    id: 'range-test-20260619-2763',
    matching_hash: '181a09aeb3785e38d7be13bcbfbce2e865ebdf6b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'e8c7227290a8e99f454429d476f495dd0e7bee4d',
    id: 'range-test-20260619-2764',
    matching_hash: 'b855f85e1becb6ae1bf70e1c600d3660330ee0bd',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '9d95a4f1867f2fa858184efb57562f07aafbcbd8',
    id: 'range-test-20260619-2765',
    matching_hash: 'ae16d34999e408fab05785d4105317c5f91e6858',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'af68e98df7a2349b341227d6eb0a0c8510a6ad9c',
    id: 'range-test-20260619-2766',
    matching_hash: '6019d8deddac219c9137480757fda944a140e7a3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '8cbe0c9eeb185b9189bbd0389430106bca9f20ae',
    id: 'range-test-20260619-2767',
    matching_hash: '0b53a8799a10551ec001ab9330adb1672e73a393',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '11af2c1db682a6b26cc2c6a7c91a9f57e0fa25c8',
    id: 'range-test-20260619-2768',
    matching_hash: 'e84480b14021c041761dfc2740e7c74b84d60d6e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '206ed008bbe2b32647715abe29bc93c7b398bf66',
    id: 'range-test-20260619-2769',
    matching_hash: 'cf0ebe11633ce4a3f5c65fbc22aa3d9b45465f69',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '257eb4e6bc2a6cf932bc364d1c7bce0118545eae',
    id: 'range-test-20260619-2770',
    matching_hash: '5672a7e6b715ce2aa0858cc98c9fb7a3b1f4be7f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '69a350285472d31bf2219def237eb6bb9e9d46d0',
    id: 'range-test-20260619-2771',
    matching_hash: 'e33fe71e6c5eaeb03d283a1129bf5dd3f7bf3d82',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '36b455226819c4ee56b78fa55ae52464d8474a46',
    id: 'range-test-20260619-2772',
    matching_hash: '0cc59968685a92406b79296dd8ed72642e1905d1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '81afae90c9e42ae3d8dede6164c43e61423b572b',
    id: 'range-test-20260619-2773',
    matching_hash: 'd62e3f8551885eec5e61f1e2ef64502a0d4a7777',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '0926639f634c6f816c02a1ec79443917665a0c82',
    id: 'range-test-20260619-2774',
    matching_hash: '803e273da86a774bd15e29557a757a7953a042bc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '4052373279cd1e6aeccd86f539c16b90f6ec71f9',
    id: 'range-test-20260619-2775',
    matching_hash: 'bbc5bd30a0331aadb6ab35a7700b5c24d5fd3975',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '916640c896cb3fe9ea68184407b07440197348fb',
    id: 'range-test-20260619-2776',
    matching_hash: 'd8253ccfdbbb0d9323990a2cbff679253efecafa',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '56b814ffb6ad9e0f59f62b8e89652982ab7a8af0',
    id: 'range-test-20260619-2777',
    matching_hash: '1ad55b4ddb5c0e902916139a2283ade3323070c8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '8c2448277d379c55e8cc8168674d4b048cb92eca',
    id: 'range-test-20260619-2778',
    matching_hash: '5be711783e24392a9b8127fdab42a5040105ba56',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '912cde9f75fb5b8f7f208951930677c566a5ccbb',
    id: 'range-test-20260619-2779',
    matching_hash: '71154d1d7d74c3c106656e63f2a8ee6b3c74db95',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '20bdb9fdcdcc583e281c6d03dd4411fc1ae76480',
    id: 'range-test-20260619-2780',
    matching_hash: 'e767728d8cf526ddad0603162f03c22ddc0fcc75',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '10c90dccfc48a169b492090def43a2ec5f7948dd',
    id: 'range-test-20260619-2781',
    matching_hash: '378ec293b360a7084790d4b312efc110d0bef71d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'cfaa0a0ef4f9b06a67eca79a533eca295517932c',
    id: 'range-test-20260619-2782',
    matching_hash: '2165defd87bb691dd255228d10e55b70898aeaa1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '1e2b4b00fcf1c6aaf9e41d59f62eaf651bdf75fd',
    id: 'range-test-20260619-2783',
    matching_hash: '32c9a4862275a9f3aa18988ec706d2a71cdfe36b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'a2e8c0a6d948f7e903af62436b2cf49d7bb52e72',
    id: 'range-test-20260619-2784',
    matching_hash: 'c29ed1a368064f78108ac16110792683bbafe49c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '0731d918451d17d474173023f826a6d113280c4f',
    id: 'range-test-20260619-2785',
    matching_hash: '24310fecbd61c9a8ffbd83ba4520f73895716df1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '8c81e42c4de938a07d519bb14169fa0f023d554f',
    id: 'range-test-20260619-2786',
    matching_hash: '1b0e247d0e85980840325000669de269f57b1c1f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '1c809809aeb1f28f28eaca66d35fedf047b608d2',
    id: 'range-test-20260619-2787',
    matching_hash: 'f9476b42f0f40459c6867bbe552ad01132272bcd',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'a48b6a8f15d81d6c9a7be647128acbf053a2f412',
    id: 'range-test-20260619-2788',
    matching_hash: 'ef987a2b16efdb289aa2813275ff785f05bb1290',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '838786606b56e624e8e4c351e844885747287a04',
    id: 'range-test-20260619-2789',
    matching_hash: 'd6250fde1fc701d50f0a053c9ab8636d78517b7a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '3f125847c42c2b70fca2ab2d6c81b3121fabc35c',
    id: 'range-test-20260619-2790',
    matching_hash: '6780e9a49206e1598a916a301002fc800b41e0de',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '58b14f3230ab1bf89e2c70bb57aa6264c35c5a8a',
    id: 'range-test-20260619-2791',
    matching_hash: '4c29a10ab300730d5067b03b311481a6b7359ec7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'b78d4a41d36e9c6cc492496a0ea9388796fb9d4a',
    id: 'range-test-20260619-2792',
    matching_hash: 'cf0598eaaf7c904633c5f38350d0b6e150e33775',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '1aec20d84d541936f1c1424417531bea3610a379',
    id: 'range-test-20260619-2793',
    matching_hash: '144c0d8f416f02322683eae6291ff827caf32845',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '4402a6a6b3cae7cc5cbd7c8badca398c333de88c',
    id: 'range-test-20260619-2794',
    matching_hash: '44be1e433c0d2d77f326050af28d7f31d1e47e9b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '37ea60d120480f8bd7461fea48c3c63619cb1dde',
    id: 'range-test-20260619-2795',
    matching_hash: 'e178c52cc40de75926d4e6365bce1599305c6733',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '86d98c95ee5bc1dff7f83fd7fa53c58806da7df6',
    id: 'range-test-20260619-2796',
    matching_hash: '639148a2a78df05b56ed31ac0e3b04c186dcc730',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'f39b6f68b40f152274d8139814499921ead16a98',
    id: 'range-test-20260619-2797',
    matching_hash: '2b3c0636b556c1677660c983a17a26660928002c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'cecd54ac7dab6e4ba5c1c9445cdeeb1910b53052',
    id: 'range-test-20260619-2798',
    matching_hash: 'd1d3d93528e7c05e36938387f34bc58d6037a956',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '47b5b83631b88435a5d60ce89734e36aa348a8a0',
    id: 'range-test-20260619-2799',
    matching_hash: '7f6a68656bbe97065082601924a4c2ee990abd5b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 4.6875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '8289b98e60e6b918643aff89b7b1dda45602956d',
    id: 'range-test-20260619-2800',
    matching_hash: 'cf6437fc49ee6d85d809145ffdf777d1aafa0220',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '0957d22d6ea79f03299a786479fab46f79f6b27f',
    id: 'range-test-20260619-2801',
    matching_hash: 'b1343570109d9eb02738e6f7c56368995b13f606',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '8daacff356583a85003d79ce5c4325d01823b348',
    id: 'range-test-20260619-2802',
    matching_hash: '4ed52a4b3dad966440fb160516e632e8f0d81043',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'b1acc69984ff065e6d5863af92431e06a0161205',
    id: 'range-test-20260619-2803',
    matching_hash: '2a144309bb4d635245596154c64cada3090695b5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'dd4f36117e25573d3f102098f21a9d0f7a701fd5',
    id: 'range-test-20260619-2804',
    matching_hash: '9b28363ee24435c4fb2c2b05a90a6b4e5d11c5e9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '4e189841c895ac15f4530f9a1b49b667a865ad8a',
    id: 'range-test-20260619-2805',
    matching_hash: '20c20a39aea79ac5eeace97144845e3272606d39',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '67c540fcafbe4fb2bc849da706a290725c8168dc',
    id: 'range-test-20260619-2806',
    matching_hash: 'f7ead9ae1d6a3b2cdcf77a6accc4d8ee254bdf90',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '1792a9a21dd85727fe428f36e155f4d10a31856c',
    id: 'range-test-20260619-2807',
    matching_hash: '7aa5016b2d23f2b8c4c0e5f6f4ad8ff18bcaf718',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '52fc76cc6d6d747c1d905cfebefd9a985d288a80',
    id: 'range-test-20260619-2808',
    matching_hash: 'e701d444cd11852cc99e058bcd3a7d7e3e48e360',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'b133490104ea4dcbe53dd2d517c2f45a1d934ffe',
    id: 'range-test-20260619-2809',
    matching_hash: '4f117653a32e05e73120f18eebb910c2e57d867d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '6a226a0b9ba8805420fd2cbd396e279355ff2868',
    id: 'range-test-20260619-2810',
    matching_hash: '9b97db957580e0ef4b5c6eb9c642bbf0e9924d54',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '3529caa97eb364d04d9b447c36f6eb8b0b1b931b',
    id: 'range-test-20260619-2811',
    matching_hash: '200a29963b28de47e6aa319a0d9541118654d078',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'aa15f6b5594b1e195f2fa7118e3bae70ca735f4b',
    id: 'range-test-20260619-2812',
    matching_hash: '7a894ba9bc84fb3f5b7fabfa9d23121b300fec90',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '1849bf00b9fe259d5e8d7e086d78aa113039c90f',
    id: 'range-test-20260619-2813',
    matching_hash: '0e69b5fe93349efe642fed4d7080a46c1839e8d1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'cd65f997cdf119610ba80abbfad67aeff5794924',
    id: 'range-test-20260619-2814',
    matching_hash: '1a08257768c15a27414fbee46568a78e7a756704',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'af776fae2dbe70b417ace086e3da0b4457753662',
    id: 'range-test-20260619-2815',
    matching_hash: '0d136923eebae0115de651554faf316c9dc92a27',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '05bcf6040f8a9bf40b237761b7a4c9ad7a3ce222',
    id: 'range-test-20260619-2816',
    matching_hash: 'ffb66f46a1d0f24d57272cd6faf0378e5a60e9bc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '981791002f93dfaca896a97b3242efbebdf19a52',
    id: 'range-test-20260619-2817',
    matching_hash: '7ccabff74b14d97a5c4a09a97db66feaf81d70db',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '04085c010ee88dd21b38db36e2a61179c0a59a6d',
    id: 'range-test-20260619-2818',
    matching_hash: '3ce115d7d35d44cda2bc5793111571a9dc32d3aa',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '98823bd46a3f991830485266226553ba81a19ce5',
    id: 'range-test-20260619-2819',
    matching_hash: 'fdc3c0afa886e3f2354bd8ddb6376183dca8c734',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '4008067df34622cc5c7f81a00e55db580f3b167e',
    id: 'range-test-20260619-2820',
    matching_hash: '28883b8907cb01c0f0ec7e14ab4fda1c161c99af',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'bfc3be7625213dc9c5d585a1f3f79aae86265439',
    id: 'range-test-20260619-2821',
    matching_hash: 'c5cb2889408afb4b9af61e60397ba7b8f00c6896',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '09f04b99f3b4d30e508978737c92a38b5276e56f',
    id: 'range-test-20260619-2822',
    matching_hash: '343305176093186b8be93ddf2d3157014242439d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '1fd231decd36253357ede88ace55ef72c237b747',
    id: 'range-test-20260619-2823',
    matching_hash: 'c9df63d1bb34db780780f3cf0107639355d23e5a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '63eb00137783a3de9b466bd8c4438a33093acb38',
    id: 'range-test-20260619-2824',
    matching_hash: '73bc7e006481f1e39c114ae3eece7de8591ae2f5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'aeb9937b0260f0fada02ecaa9f7db8cd268448a2',
    id: 'range-test-20260619-2825',
    matching_hash: '84270145eb186287589cd7cf2397c5031120498b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'f13f75ab93b734a378b7e04a650b9a7394adec6a',
    id: 'range-test-20260619-2826',
    matching_hash: '4d53e168298e6881e309178b36191b8f42893ef0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'aeedf78dd8abc5a798f784ed44361614b910a573',
    id: 'range-test-20260619-2827',
    matching_hash: 'fd78ac1cf2daae72873b375595d82fe77e602e51',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.941682658,
    qx: -0.064998161,
    qy: 0.043018583,
    qz: -0.327350595,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '68c0b771894da9497810ee336f3da6ff920783fb',
    id: 'range-test-20260619-2828',
    matching_hash: '81140d7f93cf5af322b50c33c85b97e0f4478a65',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '9423d4aafc1199609aa326e0abde59a35e477adf',
    id: 'range-test-20260619-2829',
    matching_hash: '0f00dac173ea0ddd1566bf8da52b823616b2ffde',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '54a2408c90dad6c45e7032b15b673d1f002b6bea',
    id: 'range-test-20260619-2830',
    matching_hash: '875397fb3ede0cb7368ffdd9f88ca6822fe5288e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'f674c33b57ed25ca4bb83708894bc69928033da1',
    id: 'range-test-20260619-2831',
    matching_hash: 'fabf362e8e0f66b8f5cfdd5465f9ba0076422073',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '93e40c8a4501bc6ef4ff30851b800e9ef4ac759f',
    id: 'range-test-20260619-2832',
    matching_hash: '16f2c77cdd07214deeb59852677e360957f05d4a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '99ca48a29f2373876a7ac5c8797134981fad4684',
    id: 'range-test-20260619-2833',
    matching_hash: '2291f0789f1aee774689f73d0305c31e2ab08a44',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '09362039271709b5964172ad5ef80e1657db6c34',
    id: 'range-test-20260619-2834',
    matching_hash: '2bb2a0247c7bc714e8c22ae6ee9fe6e21616f7a8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '2bccdef6703ba606547d7b7558dc957a96f53acf',
    id: 'range-test-20260619-2835',
    matching_hash: 'bf16d5c3dc4ccdf54a70cb7fba3a6e9d9841f1ed',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'b4518166ba14dc045f91d42ebc0e24a9f2444d66',
    id: 'range-test-20260619-2836',
    matching_hash: '9c6a54c6f533f48873e296f4fb8673c206177340',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '129f8007df050afe33ffd682d7f248ac961ecac8',
    id: 'range-test-20260619-2837',
    matching_hash: '4358f296bfcc43b4d9c5af3b4d80fe157d276aa0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '23c47b188e8932f36c6b5ff15a586535b2e519c0',
    id: 'range-test-20260619-2838',
    matching_hash: 'cd21a7b69c92c34b687d8930852a2b13ea367a98',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '4e030a52a037c2a862025f2150f0cdd8516a2ede',
    id: 'range-test-20260619-2839',
    matching_hash: '9ca68938c543e072038b370588e4bb843a171b23',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '2c3a18a210bc42bfec318e84aae8b4dea9153649',
    id: 'range-test-20260619-2840',
    matching_hash: 'ecdce6ddde614a306e9f07e5a0d5f9f3090d20ee',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'c0587d50f93934c7d176ce0d2cc86d3ddff15357',
    id: 'range-test-20260619-2841',
    matching_hash: 'e06b49f9be1ee311e06607ba7187f38212adb822',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '92a16591d5725505d29fd0f1e9940d1037c2e087',
    id: 'range-test-20260619-2842',
    matching_hash: 'fb1b89a7d2ab33b945b8f4c3f5751e547cd45c74',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '24a210dffa5e8a0086492e881b3d7d71ea86c661',
    id: 'range-test-20260619-2843',
    matching_hash: '632737e12affe29d099fcb44d7290a4ac799303a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '4691ccef4b5bc7a08b5169c1c3071b14ff69fd51',
    id: 'range-test-20260619-2844',
    matching_hash: '1093f580f26e47ab633b6507c72e279186ac9ba8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '15ec22d933c3e9ecea2101350da4938d8358fbe0',
    id: 'range-test-20260619-2845',
    matching_hash: '98cb2997d7dc678ae13d5436b4fb68fe9f40d58a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'fd439f7151c6b2b553f7ecb44f6fe03d6888b32d',
    id: 'range-test-20260619-2846',
    matching_hash: '51611647955964bf800833f8c674a8a54f6f410a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'e8468e7e14be51990129039f4cec6f1305b57d6a',
    id: 'range-test-20260619-2847',
    matching_hash: 'd8499e7773cddcb3d13a71e4aa1d63027a9f2556',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '29b45ae057134588f0d6ccc7f368b3471c884937',
    id: 'range-test-20260619-2848',
    matching_hash: '55855ca7ecaaeba88546384a39af0c628157f640',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'c7a52c51378858b1a82af64885566b7d0dacadd0',
    id: 'range-test-20260619-2849',
    matching_hash: '552095c4b36440b9253892762d7b20ad04f1b2b3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'fe5ead4c67f7f4adce17d91bf8fe286562f28bb2',
    id: 'range-test-20260619-2850',
    matching_hash: 'ee3f028958f22df816adf6ea0d3538b805e32c1c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'c2df56420a098f815a85e337c33dc891c2732a2c',
    id: 'range-test-20260619-2851',
    matching_hash: 'f4db8bd8f247e05ee454e944cd11874c802a479a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '1a0481465485db0c8df0774f020c6c0d778d8249',
    id: 'range-test-20260619-2852',
    matching_hash: 'ae28ce11f76a8b710ed03b69badc468f39cd62f1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'a792b108e94e54f8a89ca1f1a20df89d26c883f6',
    id: 'range-test-20260619-2853',
    matching_hash: 'b67401300ec3c3343871cf1f738dfbbe00d3dac2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'e257fcebcc8b8e6c2aa8cacea87a66b3005bdce1',
    id: 'range-test-20260619-2854',
    matching_hash: '18c739e5aea45b404afbfc6ff550384de0a0518b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '97b7174818bff1edfd2fd8caf450f3f8bce3831d',
    id: 'range-test-20260619-2855',
    matching_hash: '4e33dc041e9ce6b1896065516a3a506215abd49e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '4198ccc089d3dd65ecc65ea7a873f896b2bafe38',
    id: 'range-test-20260619-2856',
    matching_hash: 'a28216401507d2f104a166eb601d84848834b2f7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'f998db511e64262d84360391e43ee2f17c7fd9eb',
    id: 'range-test-20260619-2857',
    matching_hash: 'a99c3f50ff533438e795e92e227fc2cf2960722b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '71ffb9b4ed73442e210c185f9e66b54a75dcfa94',
    id: 'range-test-20260619-2858',
    matching_hash: 'e25b42b5e0862c3e55e7e64d4dc91e75c54619d0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'af093e9949c48a6cd06660022489d57bf2cd87c2',
    id: 'range-test-20260619-2859',
    matching_hash: '86dd3ff4d96546084acc9daab06ffa0493e8e252',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'f09f752ce28f0aaefef95ff60415a6d65a722d27',
    id: 'range-test-20260619-2860',
    matching_hash: '1979d2a5ae492fa24407d2d345e0f02eb93ac1b4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '48048e9a4a1f464e6d972816644b3177d61d9cea',
    id: 'range-test-20260619-2861',
    matching_hash: '32f08bd13e4147b62b797a4f1233ad8f933ea998',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'de04f19904170aa914b0a6f29e4682e2a65876ec',
    id: 'range-test-20260619-2862',
    matching_hash: '800547a4691805ca9830a2c9c9bef1970e3001e7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '81ec4a04049562dd4bf1f4e8d505a5a97ca020ad',
    id: 'range-test-20260619-2863',
    matching_hash: '8f22e3876a3c0b26cc6445cdb15c54b70afcfdc1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '3dc1b2218856b5a6cfb40c03880dc0e8c0f60bce',
    id: 'range-test-20260619-2864',
    matching_hash: '1f85a8a1cd500f4f55930584fe2fd077e53e08d1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '4fb52b52bba6cc6d4bb9c7c6b9d8a9426f435fb1',
    id: 'range-test-20260619-2865',
    matching_hash: '343fc601b24fb310752642b3cc3219273ddf6230',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'ce20966da10e36680a896a8d25c405b086c53093',
    id: 'range-test-20260619-2866',
    matching_hash: '49e73a8503fff76401fc7025cafb968c7dc79b1e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '1e1c493a933f1ade119de6e0c4f2cc54c1c3024a',
    id: 'range-test-20260619-2867',
    matching_hash: '05e64e5e29e2ae83ad1e7f016af2931bfd1cca73',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '089b9fcf58522bae16f1b20bacc07440d0b43d76',
    id: 'range-test-20260619-2868',
    matching_hash: '75453111517b6079d95defc42be687674dc26ea1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '37bde58af23b26883ee744373dd01a63a287343b',
    id: 'range-test-20260619-2869',
    matching_hash: '035a2eed6b05af1ec5e0664f63da37a87ecfc8b0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'da9495b2df15c6aa2ed0554bb9cab61e0d915ade',
    id: 'range-test-20260619-2870',
    matching_hash: '20d081893135db1906bef092a04633031c3d9d7a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'f5824e147cf8e3be2ef74469d1a8759587e4cb94',
    id: 'range-test-20260619-2871',
    matching_hash: 'ab7a19d8efed08564da9ef6d51bac6a0d27e5e9c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '70a876bdd13530d1a06dcdc0ffe870ee3af752ca',
    id: 'range-test-20260619-2872',
    matching_hash: '9966f38b1d51aacd6edaef9cdb5155194d47c8c2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '45cb6e5ffadf8328f4360b0aa9b6fceaae439c3d',
    id: 'range-test-20260619-2873',
    matching_hash: '46c83371f0b839c21a5f904c306b82fdd43fb5c1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'e1900f13c59fa6e3ab1e737e8ecf553b6f7ef442',
    id: 'range-test-20260619-2874',
    matching_hash: '570521a78055c7b4b29fff0a69e30ec87091e93c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '644c1de94e301efc0cccc541ea9a4d14a4dfcedd',
    id: 'range-test-20260619-2875',
    matching_hash: 'a593bb06a6708166063044ec30ae521b92c7ef46',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '4501c51aec3efbdccb47bfa4cee944cbdb0edd93',
    id: 'range-test-20260619-2876',
    matching_hash: 'ed3dbeda817a4352f4ca8ac07f64c2bb6f15cccd',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'c1c873af6d745bd950272d6d83d620f887e2dc4d',
    id: 'range-test-20260619-2877',
    matching_hash: 'c3151bf150c39d35355b242db6e4bc0ef34f4622',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'ceb8fb4b02303444b828b738e4d623f0a3cbf7a9',
    id: 'range-test-20260619-2878',
    matching_hash: '030b00af7a938afba5465f28fbadef7e0026313a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'd4a534b2d6a85bd7cfb02641342b5f98f0b4e864',
    id: 'range-test-20260619-2879',
    matching_hash: '7e2d4de7962915565cbfeea4004fe4d6299cc774',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '63421362b0efc23a48ed0e5737012eca487ed804',
    id: 'range-test-20260619-2880',
    matching_hash: 'b16d25b2a3c920c3a7621eeaf1056c48716ce41c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '4874fd43a4e58d6ab3c3c0baf036a099f2fc07e3',
    id: 'range-test-20260619-2881',
    matching_hash: 'db663b61a86b1c39b4fa3519c55ab2c73b30e077',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '3b8e6a48acce0a4a1beb9c43bfc11cd10eaa5672',
    id: 'range-test-20260619-2882',
    matching_hash: '92851f90424c674ecd934c34074d657136aca333',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'e6be2fd562080d4ef705089e83fcd4071b8c9136',
    id: 'range-test-20260619-2883',
    matching_hash: '6cc7d51efcb717067b1342ed055a0886ed1c0590',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '895d34d450a7ceef18bde21b7ee20f6fa99ae9ba',
    id: 'range-test-20260619-2884',
    matching_hash: '54d7d9a5e735a28bd21920fe7110313ac1ff51cb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '9f92822a6c4873a6702af925c24a1da39673277a',
    id: 'range-test-20260619-2885',
    matching_hash: '079d46a0fd7fbe4ac9e976eebc74b12b7b2d30b3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '3a1c624168fa9943070a4210d193ab0890d393c1',
    id: 'range-test-20260619-2886',
    matching_hash: 'a5be4cedd16a05a2477bad10d610b074ec6822f2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '9085cbdebc64b16c2137cec2c9a114c6d6893bb0',
    id: 'range-test-20260619-2887',
    matching_hash: '04ff3de648636f23dc6359247406727e2d6234d6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'c5581f14fe4f56800391a20fbb3271001c8a6075',
    id: 'range-test-20260619-2888',
    matching_hash: '2a957e77b52e79b574cfebc22f299c36eae32c53',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '2dfa6163d8b2685c18ec093626bdcb3ddda9103c',
    id: 'range-test-20260619-2889',
    matching_hash: '6134ea396174bcad2a6b092f8d156c003fe19d6a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '618bb64bbca38e1ae7dda80d850f6aa3f6bc1e96',
    id: 'range-test-20260619-2890',
    matching_hash: '9ba11ad8409776b0e32b8512637c985837a0ab26',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '7d74b36225f6b4bce8173dceb5877c6b1f6cb874',
    id: 'range-test-20260619-2891',
    matching_hash: 'f56813642c9d39d1f3dd17a84d5a8f29e564a4bc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '7ea5bc91db4c21d1019524d07583e12ad548c725',
    id: 'range-test-20260619-2892',
    matching_hash: 'd1642722ca5175f869a70256ad6f27ced316555c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'c4733b0e5186c1d1ef04ee3834bb93355ddc7090',
    id: 'range-test-20260619-2893',
    matching_hash: '10f359c5d876f3efca70421509b00bd0fe137ced',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '9856058fb6a9faa93b0c7583ae3b3490449ee179',
    id: 'range-test-20260619-2894',
    matching_hash: '1367680e317a57549912c10ec9bcbd579b99b150',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'fc3f1b2da9576ddaa1b996a5bef68404be2a46ae',
    id: 'range-test-20260619-2895',
    matching_hash: '901d54409634df381338250fb827aa3801ddd18e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '8376cf76d16364ca6f0396a8e952f2fbebf73db5',
    id: 'range-test-20260619-2896',
    matching_hash: 'a63f0940edf4348e21cde3ebd59f1560207343d7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '8e24af0facb2617e411aad7b05b5ef6f511d12f0',
    id: 'range-test-20260619-2897',
    matching_hash: '58301d73ca95bb369dcaf9ae34198529f6aff793',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'd12dc9281a2995588fdb4b6d5cebf721be88df77',
    id: 'range-test-20260619-2898',
    matching_hash: '348a7371dec7e0fff0b54b44ae420cd6eb96ffe7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '3020e8b82a07907757b1778a8bc4f3537df93319',
    id: 'range-test-20260619-2899',
    matching_hash: '863d900b57db1bbd5261be64e75a2fb0765ad602',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '2b674f1268edbf6fa745594e6562d93b153de65d',
    id: 'range-test-20260619-2900',
    matching_hash: 'bf230f353d2ff4602ef3d8c3368aaacfa9ca45b9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'a136f655a8d6c201fbfb9871a1ee98f779bb138a',
    id: 'range-test-20260619-2901',
    matching_hash: '84f9e99dc83e67cc34a69fdeaff9adf33cdc5bcc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '6404a96de2999c316daf5a4471c45f4ab2f32598',
    id: 'range-test-20260619-2902',
    matching_hash: '3d3513f8ba9901c0af27ecd887aedcbf3e2360b5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '7219355276ff8ce2a6f9375ea7f2447c1b6ff0c6',
    id: 'range-test-20260619-2903',
    matching_hash: '1e6d9b3f93606ff12935c648f94d91aa1a8695f9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'e4c92629cfb048c3933485ee97e766cd4e461173',
    id: 'range-test-20260619-2904',
    matching_hash: '18ed161b4da3a97bd1075ac87006bc30fa4401b6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '62394cf26697ed09085f94488d52cd9d2ecb0cff',
    id: 'range-test-20260619-2905',
    matching_hash: '5ddabbaac354fba45029591f25618728962e2a9a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '841fad45c9f671b288d569695683331186a6c07b',
    id: 'range-test-20260619-2906',
    matching_hash: '70b2539e8ff8dc981d2008a8fd066524fd10d834',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '9610d8859dcfa986f4cc858fd9a1771c8d2de7fc',
    id: 'range-test-20260619-2907',
    matching_hash: '25161b061525171fd0fed75656a47a5447ab2aa5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '5367c2d658da2596b50c2f2d1352fa3d73ae95ad',
    id: 'range-test-20260619-2908',
    matching_hash: 'e3368767dba8716c37a717d0352bcfe12d945e54',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '0db67c1b046827774f4a319730c2e70cc0f5e7d2',
    id: 'range-test-20260619-2909',
    matching_hash: 'd1ff07cfd967b9fd20e755c47b5beaa64143ff4a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '57f3dae44bace7453dd082c51ef3d9fe11a27955',
    id: 'range-test-20260619-2910',
    matching_hash: '788c1305fe0582f55c3c7290a8fed5ca9a787f74',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '7571987278a4bd5138c0f097df40053f6e7efabf',
    id: 'range-test-20260619-2911',
    matching_hash: '124fa4cdc6907d24611e6e3091a01be3130f37b8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '354b3ccee8a5a225f4cfb6456bae8aee8f39ae9e',
    id: 'range-test-20260619-2912',
    matching_hash: '59188ad9a5ee3d40fbce7697a7fcb7ba239c0c67',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'd2aa8a31c496e65f781e2d0247492fc4c6d0d5ff',
    id: 'range-test-20260619-2913',
    matching_hash: '542e1532dcf2f666198859dea8ecc09fdd172bce',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '107db8ba5d57f3dddea16e6e687959636210bd93',
    id: 'range-test-20260619-2914',
    matching_hash: '241e9d98c2eefc299dcbfc391a254f0d98c1c8bb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'b866db1be76ec6e9b80d023e181c6e1343dbd9cb',
    id: 'range-test-20260619-2915',
    matching_hash: '399e774657e183b2b2f04bff16c65d9b159a820e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '5259f6c0c397173afc0e79aa73f032cfbe6f0c56',
    id: 'range-test-20260619-2916',
    matching_hash: 'c76f5a0d5a929f4743cc45b0f8a54ad79a3cb687',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'cadaa8c19fd1c84bd03010fcb724064d3c0c7de8',
    id: 'range-test-20260619-2917',
    matching_hash: '03e40c6f0a15e82339e95a8ffac351fdc0eb7648',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '3e53eaf57c6146762f6e7d45cba38e52681f2082',
    id: 'range-test-20260619-2918',
    matching_hash: 'eb287142d42033dc0f337c99bf3856b2dfa3a066',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '3fa9c4a5fb796a043e915624ba95b3c7499dc7d9',
    id: 'range-test-20260619-2919',
    matching_hash: 'dd12c33be0592442deeacf0435a3bbf5718ca219',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '024f3a690e0fc72d41e961940e1328aef432aac1',
    id: 'range-test-20260619-2920',
    matching_hash: '028f00ce4d3b49f055ac6c765bf7653d14458e25',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '1aac478a2656f925eb8efeefe3b68c892998a255',
    id: 'range-test-20260619-2921',
    matching_hash: '453e9012c1320473ad16392da069891a8083a659',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '43460e16ddca4808facb0f971871d732011ea23a',
    id: 'range-test-20260619-2922',
    matching_hash: 'e72102000ca7fa51f35e61f50d134f9059b6d686',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '4f0fbbc33c869faa7259dd05581e9cc18c81ab87',
    id: 'range-test-20260619-2923',
    matching_hash: '8374c77d92677e25aacb4ec5fe8bbe8f333841b5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '6f608e488afacd4287a78673425202ccbd2ce142',
    id: 'range-test-20260619-2924',
    matching_hash: '198cbbe6734fc758e1cac7339273990b1960fcd6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '3b9d436f61dcd75c8b7f76aaed570d86acb309c9',
    id: 'range-test-20260619-2925',
    matching_hash: 'e0ad4b67f545ca83004740558b8eab7537ead8a0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '1360e6098d4e3a8c38a6e27fe735a4779f12c07c',
    id: 'range-test-20260619-2926',
    matching_hash: '474b4c42f0af1ea34b57b5c19be92eb83d8640f3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '4c3e150d202ec2d7ae9c65a6cd24233c2509d37a',
    id: 'range-test-20260619-2927',
    matching_hash: '47e758e98f4f81359e406b2cbec86dd409e11feb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'b7974b063b55d2ba61b03fdf43205e75dadddaad',
    id: 'range-test-20260619-2928',
    matching_hash: 'f46e8d77d902d33832c0f075b87e67c1da8db3ca',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.427721124,
    qx: 0.168184946,
    qy: 0.019429315,
    qz: -0.887913828,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'f0e051432d4885bf8dee46cf0c0e12e7d4064421',
    id: 'range-test-20260619-2929',
    matching_hash: 'eecf46c9254441401e3cac8e3113e45dcda4492f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'f5b5598c0e910f695fff02a9a9265b3951660298',
    id: 'range-test-20260619-2930',
    matching_hash: 'b2a94182c3db13a831a4506d099f1a2c8636379b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '39221ea4d318a3a82b76d94f412beee378a50de6',
    id: 'range-test-20260619-2931',
    matching_hash: '0e1ec311d9ab9e05c6fa3cbfa63a72bef28fde16',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '4d0364a2664b100d5bb8e68bdb2eb9d8981646c8',
    id: 'range-test-20260619-2932',
    matching_hash: '123c4e7d1018af35c679ae6e408f071a735fce17',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '519fa0fd0ba4956b80236efa4a9e52cf29688aba',
    id: 'range-test-20260619-2933',
    matching_hash: '87ce4f09a372773bc19e0886eb2fbfde224a5e0c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '7c651521c02ca45f5ac2cfe30b17aa49d3521f5c',
    id: 'range-test-20260619-2934',
    matching_hash: 'aefb885ea47db25c6bd6f3ad87eece0b52a2a9df',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'f48ca922d3231f51ed3b1a674cafd30153d8c6e4',
    id: 'range-test-20260619-2935',
    matching_hash: '6d1112784d2c3e8c18dbf18a10f9d61b7db46964',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'a512304279e11ff314c6dde72787212b6977a3ea',
    id: 'range-test-20260619-2936',
    matching_hash: '2547b17ca9407b2b9724936827be3a7a2e92e7d5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'e1ed3a9a671aafd8e2827d4e7dcd8281b3aca405',
    id: 'range-test-20260619-2937',
    matching_hash: 'eade3de97bdbd25cf70bc41ca16f55ad62877988',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '47de183990f5a5f45d6a6510b000670f03edb1e0',
    id: 'range-test-20260619-2938',
    matching_hash: '80c395fdde424a17b61ee901844723e8624bcb8f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'bc830f500150fa97cfa8bbf109431ec5fd48e783',
    id: 'range-test-20260619-2939',
    matching_hash: '2817afa680d6d08234b22265cd70fa83aa43e99a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'ce1fce7b36f615418f52b655b4154d57cf5b7e3e',
    id: 'range-test-20260619-2940',
    matching_hash: '7ad7c1a92b39aaca9b5214598671d6afba495823',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '2d590b9365984fe7769df82d34019278cfd0b8cf',
    id: 'range-test-20260619-2941',
    matching_hash: 'b46c4a9df3266b92c8095f8f67897946ce95fd1d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '2c884873f35fb1ee1817904a47d3d1afb5bbc27f',
    id: 'range-test-20260619-2942',
    matching_hash: '12d20d86cb76e20265e2991e5d11baecf1c83a6a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '256dc7c122c6d28a1dae0fbcb3645709551a140a',
    id: 'range-test-20260619-2943',
    matching_hash: '168729bf46b6a2ce94992fa318706fb5a1b26c23',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '94bcbc3a184127611225f724c416185cf184cc86',
    id: 'range-test-20260619-2944',
    matching_hash: '6639345993d69205200aaeb4d21b7fd2e5b53587',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '4f6e683d135f193722d8f4418d4c218485997301',
    id: 'range-test-20260619-2945',
    matching_hash: '4aba1b9b8d3c583af17505366eb1aa80d45de320',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'ee65053ed2fecd68d46ea5a1b440caa7c6857350',
    id: 'range-test-20260619-2946',
    matching_hash: '2a7a591fde2d096792d29b21110e7c0ee9ce0a8a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'd8b17dee8a90cf0232746d001fe2861012833611',
    id: 'range-test-20260619-2947',
    matching_hash: '6fecc26e34a094ed0f8924568311976847b37429',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'fc13826bb1ff9ca08c8dcb2f960b235b7ce30490',
    id: 'range-test-20260619-2948',
    matching_hash: '5a5b051a8fca2eb6dbb43685854a88bd80d12bd0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'a9ec03f331fc6d69146317071c46ed2022f4e8ae',
    id: 'range-test-20260619-2949',
    matching_hash: '8768aeb7339065aed8c34cb10d75d8968bafc7f2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '71c9815aa791e7b9eaf84522e99e993a68aa9700',
    id: 'range-test-20260619-2950',
    matching_hash: '8d507463886d14dfd8b46cb264fdfd8067a6ee76',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '003616214593337a356867fb568f416a09b4ead1',
    id: 'range-test-20260619-2951',
    matching_hash: 'c3125a239685da61aac299cf5ea35cccb256772d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'b5d3385b93bdc3af6f16037676b2cda6e0cb59ee',
    id: 'range-test-20260619-2952',
    matching_hash: 'd82545cb22837683f0034fb6fca134bb8dc8d5d2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'ad1344d57b205709ecd1a6e008f2345d288c5829',
    id: 'range-test-20260619-2953',
    matching_hash: '48102ec0046dc4a5a7ff92fe710a383364dc0c8b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '55b68c3878dec52331a7eb76cfb04b35bce1f88d',
    id: 'range-test-20260619-2954',
    matching_hash: 'fa56c870161f0825f3bc9f46c4de850af36f5f88',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'a2696ea77d56d6f791043115a766bb66a630cf0a',
    id: 'range-test-20260619-2955',
    matching_hash: 'f4f1eddeaedaea25f4a5f722b3ac344d2b1bbac0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'ce869a7fdc07e9e7bd28cd375eef11ac103c80df',
    id: 'range-test-20260619-2956',
    matching_hash: '32a4d5f0d4d1738ec835d6cc665caaa9f6e33a80',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '6e757e88cadc59032e5f739946bc465049844f8d',
    id: 'range-test-20260619-2957',
    matching_hash: '6f5a233a5901f9c7df623d18ea607bad18c3c187',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '922fbfe01d031443321796b8c11d6094192c24a5',
    id: 'range-test-20260619-2958',
    matching_hash: 'e0a56c12451b33056d7dd7b6bc5394b688557dc1',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'ced067c8d5e67c5d8fb739e06028654c1aa84ed6',
    id: 'range-test-20260619-2959',
    matching_hash: '46a16afc426f2fe8b37905ea12184aeeab917b4b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '6b72f0d834773817e095f1bce2592be52b4ae2b1',
    id: 'range-test-20260619-2960',
    matching_hash: 'e731dc2b7b9dca00b63f03b01657f234987a410c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '5f47c0a97c81cf4f8ec9edeadb91a98824cbbb2c',
    id: 'range-test-20260619-2961',
    matching_hash: '88a08b59229740af715ecf9d8b9d3e0d1b55d117',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'fbda1d238050999fc6381a95ae97aaa3209c4184',
    id: 'range-test-20260619-2962',
    matching_hash: 'ac7d5011d67add0cf4559dfdc09e8ba08e5c9ad2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '9bca11e0e1400d516f2e09f7790ebacbe2e12e65',
    id: 'range-test-20260619-2963',
    matching_hash: 'c473ac2b76f65dd717190c9c24beed7d1e98bb0a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '9c744f73082e62807d304471bf0d1ef268950c45',
    id: 'range-test-20260619-2964',
    matching_hash: '1083a2e76eadb2a68521e22087526af6da8a9691',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'b75bcdd31f220975ef1781f90a7fc4a6b515dff3',
    id: 'range-test-20260619-2965',
    matching_hash: 'b002f502c1e831891edfb02b0c40ed79ed7ed03d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'd102637297a2e479c4471fa68d9703d9ec0d68bf',
    id: 'range-test-20260619-2966',
    matching_hash: '0591312972853301546f1073d9ee389d75f3c453',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '2d941449c527bff179f859bc6d15ce7abc16c34b',
    id: 'range-test-20260619-2967',
    matching_hash: '9357aa6c959c580b4619b411af826c492ce0282d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '17edb3fcef3f0ba331b287160a1b3c07540e263c',
    id: 'range-test-20260619-2968',
    matching_hash: '4da83a4a3ab58f45f6f7c3ce9a7fcc1e8420b260',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '1d35308ad64501bdcf1c12bddd01831be36e405d',
    id: 'range-test-20260619-2969',
    matching_hash: '40a5683fa1c5cd3f12e4e76c917693c78e10da88',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '57e39009705bea3d76ffe246234c7cf1a842daba',
    id: 'range-test-20260619-2970',
    matching_hash: '4d3b0c0c78c5c992eb3555c5e35c0b9111126743',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '0f67768a0ad6479b0a97e6602301db3ab9ec813c',
    id: 'range-test-20260619-2971',
    matching_hash: 'f35a67d358e8b72ec3b6e29d24892d97b31ceb61',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'c30f7baca5f565055f0ecc68ccb93370906a1918',
    id: 'range-test-20260619-2972',
    matching_hash: 'b88c4e2b3cd4b87a03e172866b7341ffc6c47e5f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '51dd64dd23cb254f482b543708e0839b88c7c4ef',
    id: 'range-test-20260619-2973',
    matching_hash: '00752ffe759b80c33bed51fa04a328cdeeca2602',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '7ea3166c60b3f66cc7c7b3dbdf344eed7e308ceb',
    id: 'range-test-20260619-2974',
    matching_hash: '0e8fdb4a093db0e21f7d7a5d1361dafe5c82b3ad',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'e1fee249adfe53120c8d8949fb54463e8f35fd4f',
    id: 'range-test-20260619-2975',
    matching_hash: '34b1817a01af0419975aea2f4b90c74e9aacd226',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'd5f8bdebe4d52c44f2f058da36af118f5bd0f1ad',
    id: 'range-test-20260619-2976',
    matching_hash: '0bf347ded7b0a569911c63080ee876c3481694fb',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '4a61a1f9d533fe43bdfba1b0073be952c896d002',
    id: 'range-test-20260619-2977',
    matching_hash: 'a11572618c32da273c199020a2bc7e026abdc881',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '43214cc6d780c41bae3bed055093cb8474ff0b02',
    id: 'range-test-20260619-2978',
    matching_hash: 'ff2c909a4647400725b70591d1b0cebbad4e8fe0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '0e7e6db42a158a94309c803ebc7c041f4a1e2ea1',
    id: 'range-test-20260619-2979',
    matching_hash: 'a0756740c35c04e258201bca154d5c887d8a939a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'beba7e0b52eb038cd3124eed0066a0f17f3720ae',
    id: 'range-test-20260619-2980',
    matching_hash: 'e60a0706aa1cb49fde873fc0614c11fe9d0a716e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'dcb5df8512125bb2b522d9d133f29c212a463e58',
    id: 'range-test-20260619-2981',
    matching_hash: 'cdbbe5c1b146c5d9f2b03df6fcd72970d9684b41',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '71026992594f4c78a0f4e6768181d3053a424466',
    id: 'range-test-20260619-2982',
    matching_hash: 'a5064e2eb40c83167635e5c9c2de95768f729afc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '564bd0df40d5fc70007ec302aa6d51f577b77993',
    id: 'range-test-20260619-2983',
    matching_hash: 'cfaca7a6ba0c93a584d5521334c9e1ed9d3cfc64',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'ad10a09d88bb95893311c4ea4bebb8eeabc97c62',
    id: 'range-test-20260619-2984',
    matching_hash: '088fb3757318d32dc128ffe1bf8c72833508f88a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '9d62fc5214a109ca66589d6bd9d24be7b3ef4c65',
    id: 'range-test-20260619-2985',
    matching_hash: '110e05960b354c5800bd43e041f7711051492406',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '8bf2e592f5a620eedc31eca5c9744e883378f9b9',
    id: 'range-test-20260619-2986',
    matching_hash: '147ede2720e93e4a6dff5437cb75b8d2a0ad51e7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '0650ec54c4ccb2bd927ae9dca2ade122bfa8f166',
    id: 'range-test-20260619-2987',
    matching_hash: '2e2f99ef825f47a748182e61dbf8bf859ad8e240',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '56892f7b32ebd4da1c1a417916c314fdc55b0897',
    id: 'range-test-20260619-2988',
    matching_hash: '09c4bf368ff3f35d5852470a9f6a4627e56254b2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '7b64d10491c7fbc19b0217c4f2040973f338dd03',
    id: 'range-test-20260619-2989',
    matching_hash: 'bdf9c88e2bc86ec4eeb93a976c09cb4d36e57262',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'abc50428ca036e4d2041a673d66f835b02baad28',
    id: 'range-test-20260619-2990',
    matching_hash: '50d7540fe8b2430387bdf38baa14c6a47b57f726',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'a8eef844411518109187e7873c4c58951c28de44',
    id: 'range-test-20260619-2991',
    matching_hash: 'cd843eb6bbe0b712fce7dd58ec1becdbdf386d66',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '007ca8d961ade08c22837e6d8e3d81969bfdd0a3',
    id: 'range-test-20260619-2992',
    matching_hash: '686cab30ead05dc7a3028584008af8a99edac317',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'dd1fb00f31c77bdd9563eb60b86b669469a11784',
    id: 'range-test-20260619-2993',
    matching_hash: '5ca4990eace1183ae25d3f8f8276a085e664e186',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'e9b3f824d7ebd79d4d01293bdc9a55232eecb595',
    id: 'range-test-20260619-2994',
    matching_hash: '6f7dff6155114fca33ac6dcb22a54d2be571a38f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '8f9e8fb690a8524b41b4ad3915cd854137114ef9',
    id: 'range-test-20260619-2995',
    matching_hash: 'cf67a462c6c843cb5b62b836e5b5561f9895a8a8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'e84a5dac7d8e8fd83c32bc465ec70f67ff0fee73',
    id: 'range-test-20260619-2996',
    matching_hash: 'af64ec595d270658516f6d8b951e69f512c3fe13',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'c339d9a33904bca9bc9abe54093cc10dcd29e665',
    id: 'range-test-20260619-2997',
    matching_hash: '593cde924d7fda8a0552823744306b27de7cbdc2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '8a7fb487c84f3670f8a28eb8f2fedaef46e30569',
    id: 'range-test-20260619-2998',
    matching_hash: 'ed5bd53a5ca83800929c971f3ff08ffc73949695',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '367f07ec4a0e5b8a35ce5f4bc38221410358a5b6',
    id: 'range-test-20260619-2999',
    matching_hash: 'eecf46c9254441401e3cac8e3113e45dcda4492f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '38fa0a3d5f5e7491649f962bcd4e84a6cf56ac7a',
    id: 'range-test-20260619-3000',
    matching_hash: 'b2a94182c3db13a831a4506d099f1a2c8636379b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'ff54d4f91f9d8c6ed969b7d576c350ed47028e5d',
    id: 'range-test-20260619-3001',
    matching_hash: '0e1ec311d9ab9e05c6fa3cbfa63a72bef28fde16',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '221a83553ab4cdf3b8b5055e5812ca2bb4a756c9',
    id: 'range-test-20260619-3002',
    matching_hash: '123c4e7d1018af35c679ae6e408f071a735fce17',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'dc9b0825b1e71e62b37d020a0d8dd444c43fcd15',
    id: 'range-test-20260619-3003',
    matching_hash: '87ce4f09a372773bc19e0886eb2fbfde224a5e0c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'b249c27baaa5ca73ca65a0a3c14e531cdd5edaf6',
    id: 'range-test-20260619-3004',
    matching_hash: 'aefb885ea47db25c6bd6f3ad87eece0b52a2a9df',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'e4887562fcff91cbedb60080ac337c806cfedf22',
    id: 'range-test-20260619-3005',
    matching_hash: '6d1112784d2c3e8c18dbf18a10f9d61b7db46964',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '266a56b47703f885f8f0497955f7034f568fdc4c',
    id: 'range-test-20260619-3006',
    matching_hash: '2547b17ca9407b2b9724936827be3a7a2e92e7d5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'bf8b1ab88aaf8ed60441c60b2c1dd71c37acf1f7',
    id: 'range-test-20260619-3007',
    matching_hash: 'eade3de97bdbd25cf70bc41ca16f55ad62877988',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '1537372eec4517eb26ee0736e91b85f5c037c018',
    id: 'range-test-20260619-3008',
    matching_hash: '80c395fdde424a17b61ee901844723e8624bcb8f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '4891b36a6ec7d3aa8119e34217e5ed5d1a39b431',
    id: 'range-test-20260619-3009',
    matching_hash: '2817afa680d6d08234b22265cd70fa83aa43e99a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '9f122affd792f85532e53f4f4e6444a4efe7a93e',
    id: 'range-test-20260619-3010',
    matching_hash: 'e342152e52d812f7b838008c9a6401d5397e848f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '59f5b40517f0e94fd2ec4d9124feea6bef05cab4',
    id: 'range-test-20260619-3011',
    matching_hash: '1a1e8bc4b2c7428a23714767736cc868ca3e5224',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '946b5b603deb97a438799b06249e16e96a4be732',
    id: 'range-test-20260619-3012',
    matching_hash: '992f9fb33b15414a10d6d16c4386e78d78437ea4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'da21aca9e09935acbfa35bdb160b45202cc849de',
    id: 'range-test-20260619-3013',
    matching_hash: '862f50d385acd8778b5f241235e81746ede86c7d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'b542c133dddc84ec513ee7b51811ae92ee05659f',
    id: 'range-test-20260619-3014',
    matching_hash: 'daf2913561c5a67284845671a06c27ca9d8ecd03',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'd3aef9da102274a778355817366b6920195eba73',
    id: 'range-test-20260619-3015',
    matching_hash: '3d7f55790f64cc7303801f0a8226dd410360b2fa',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'db6833f906979f808febcc3ff0403bdc034ef7b7',
    id: 'range-test-20260619-3016',
    matching_hash: '4d9fd7b10066411672e8277f0caa7c18f0c4a08b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'c6d8b4ee746f44271ac80ffb2d91c43bed6caecb',
    id: 'range-test-20260619-3017',
    matching_hash: '66a92113a10aab38ebfa0ecf6ae820381a21bc53',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '442bf098304b5f2daef0d6285effaf9a7fdf6259',
    id: 'range-test-20260619-3018',
    matching_hash: '72968294b0045cd9f2c0cf8753050917c4fca21b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '639cbec1ce1792c950db1c90ddaa9fcd134cdbbe',
    id: 'range-test-20260619-3019',
    matching_hash: 'bea14e10742b091e56377d174306d7d0e84cc1e5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '1f3dd1486ceed2e3d66f2447df08a1ddbd46a150',
    id: 'range-test-20260619-3020',
    matching_hash: 'eaac9bca7ba3da2f9691d872c4cb7ee8c7d90538',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '97935634bc67cd7bd5e27fbbba8e6087d31854d9',
    id: 'range-test-20260619-3021',
    matching_hash: '08e859d1942c0dd9a8cca370f0f717128738607a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '25cd64d8f8e725f0530a467980ae061095276dba',
    id: 'range-test-20260619-3022',
    matching_hash: '7624cb71955807d31ae3eb01e99baa5c3e20b59c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'e39605f37bec7aae2e9645fb2a3d129be7ab61a0',
    id: 'range-test-20260619-3023',
    matching_hash: 'f93925957861536f634c69cec7709da658053a31',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '5040750c73136caa8084ee5ef6f5cc420846b5d7',
    id: 'range-test-20260619-3024',
    matching_hash: '83c761859101d5c87cb784141dd4426d5f1fdd2a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '4a0959d0b01b4b374e3060421acce6418ab3ef23',
    id: 'range-test-20260619-3025',
    matching_hash: '8ce06a002ee527c51ae0d64b0e9bf3518546d474',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '9dc7fe8dced4dc4b09fa44fe23702f08a255d438',
    id: 'range-test-20260619-3026',
    matching_hash: 'b72395f4c8340fc6acca25c73a5fcbf142b335be',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'c7adfa1f73deb2f38c4c8e0b487f666ce18d03d4',
    id: 'range-test-20260619-3027',
    matching_hash: 'f982fa8062508683a11d7cf1bdf636ac26490b8a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'dd4223c5c09c395b98c8434d531ea9715c09e168',
    id: 'range-test-20260619-3028',
    matching_hash: '77a62ecb93b7152b8d127b53e8e5a4c2af022927',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '19309012585a23f19ebf1e8766f5a8bff5de4a0c',
    id: 'range-test-20260619-3029',
    matching_hash: '13803c3686d25547c857393366291bb908ad42d9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.776520791,
    qx: 0.414202854,
    qy: 0.027475218,
    qz: 0.474021696,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '6c7d61d691e139d08ab8d693655477613fd58c43',
    id: 'range-test-20260619-3030',
    matching_hash: 'a85b69fbaffbedf0ed2be715d0badd6204e6df31',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'f37f0fae530da43f5984e380ac0dd34e8fb7eea8',
    id: 'range-test-20260619-3031',
    matching_hash: 'd3e035003ecdf159603ba828d2d341e9efb76c68',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '73c4133759a9e2090fe4a3820e9a14d5949c3b56',
    id: 'range-test-20260619-3032',
    matching_hash: '2c238a0d8fafb90755c9ea02d9da175d678d1fd5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '96fe4913f55c9bc327d9e5f0b8c1372377865b1b',
    id: 'range-test-20260619-3033',
    matching_hash: '86c1e96fa5c5a4f1298523f18004389c79da94fa',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '0ae33261fcf6d88450cab547135314bbd0bb2235',
    id: 'range-test-20260619-3034',
    matching_hash: 'a45438dd58268bb6bf52be58401c93f2dffe0bb2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '65b71f368b46125c99231ea5cc7c58d5d82858b2',
    id: 'range-test-20260619-3035',
    matching_hash: 'bd914daff3692da8c5cb4bd12bbb574014cb48fe',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'fe0ff1208551204f0010314f668e38e04afaf8d1',
    id: 'range-test-20260619-3036',
    matching_hash: 'ab508747f83a110d1d4f871ce60c3d665a50db8e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'f69166268cf4c1421ff209ef070183802c3ebb51',
    id: 'range-test-20260619-3037',
    matching_hash: '2b6b8bb32295cda66dad26a16c7f07facc77246c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '91adb38be6708043bac96c038a9336a38ab8a97e',
    id: 'range-test-20260619-3038',
    matching_hash: '45664e161840194cfcfc69c83ec8d8ade3d4ef28',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'ffc4cbadbcef1344dd7fa358b00f131721fd1c8c',
    id: 'range-test-20260619-3039',
    matching_hash: '0f08652ac83dfce45bdae8dcf59a9a2e030f6284',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '5297c042f5e8c34540da15289bbfc8e37c4c62d1',
    id: 'range-test-20260619-3040',
    matching_hash: '94f8bda4f03f85562dd36611f1496147a3ec0eb2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'c031826d0817125c31e19d3b54f16501ee8c3388',
    id: 'range-test-20260619-3041',
    matching_hash: '0eea65e2f461b6ff5bb77f14ec7efa7d8f06acda',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'e66c84dc0b09173771443a737da2702e2ab4ef01',
    id: 'range-test-20260619-3042',
    matching_hash: '64bde195d7616fce9c086a285666c786fb540391',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'd5d3223c6b6514da4bee467a8fa54deb020457d4',
    id: 'range-test-20260619-3043',
    matching_hash: '5ef6cbff276ac4b4cb3a6cff622123cfd5f570c7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'a6b98f12143f7058e77d49273b880d01ea1140d3',
    id: 'range-test-20260619-3044',
    matching_hash: '1f9090967c47a2c00fafffd42bca053981f03989',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'af3a8c76f0447f819e063ac3a9bba867dff1744d',
    id: 'range-test-20260619-3045',
    matching_hash: '9245c7381f7eb4f9d2869c6a544e7681782bb1c1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '9b01686880312e5163cef895bec0a4ae414319a3',
    id: 'range-test-20260619-3046',
    matching_hash: '89d3eb24fdfb79dfac4e4150f323f1c5b69e8d42',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '0f9148765f8b4d0dfd01e4b0439295673d47a01f',
    id: 'range-test-20260619-3047',
    matching_hash: '2871a45c8f1fdc6b10e30ffe9c9f1d65869d3755',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '5f3783e0245415c6dbc1b280360a16e03b014a55',
    id: 'range-test-20260619-3048',
    matching_hash: '58e675c66529f290e5d4d82b59ec9575aab426e2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '0a2693d62c75096c373dd80286a1154386652c4c',
    id: 'range-test-20260619-3049',
    matching_hash: '8b9a64531a8fc9582d1be7ef0246f129696e6277',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'a939b149d2b28ccc6e196d658619fb59e22ddea9',
    id: 'range-test-20260619-3050',
    matching_hash: '495dd37c6ee0f08eb6f6a4c1e2ef5b0928bb2b56',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '27bdde886ab85c6e4ff3c0daafbaa6acf14d8282',
    id: 'range-test-20260619-3051',
    matching_hash: '3c4da97573436d5722588d9770ad6c6fc3054812',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '1f61da1f7733d74299bd162883bfbd4470ebcfa6',
    id: 'range-test-20260619-3052',
    matching_hash: 'ac04ef67b21c9fa536e0979260729c64254a37eb',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'fece2c5532e86fa8483af5adc53de2fd2e9b198f',
    id: 'range-test-20260619-3053',
    matching_hash: 'ba4791b4687fafc88884becde943fadb55db4323',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'd610af921ec18dc779dbaae278ac832e8538273d',
    id: 'range-test-20260619-3054',
    matching_hash: 'a7280fbcbc74be7bc4bde2e916fafde61be9592c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '92ae5d096dd9d270894c029536ccc03980d49436',
    id: 'range-test-20260619-3055',
    matching_hash: 'ca0a4abf7e1b9dbb5d35b79ce2d00e128faade4e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'd32897d88c9def831531e7d50247d83c4a3b9ae9',
    id: 'range-test-20260619-3056',
    matching_hash: '63b292b1987d9be0130448c6fab32e6bd25a6e6d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '3469a866ff0b7b6faa5fbddb371e9ab6a0b7ecf3',
    id: 'range-test-20260619-3057',
    matching_hash: 'bf3932ea04aa22667bdc661f7952f2b96c50b67f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '409fba5f3e333beee06b6ffa9ee3728bb74a424b',
    id: 'range-test-20260619-3058',
    matching_hash: '60ded1e4b3c836a484d03341daac0ace8107f67c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '0d1846e60c62ab49cb49c71b2c374d4133257296',
    id: 'range-test-20260619-3059',
    matching_hash: '99568297ebf71fcecdbfe750851efa0133b2745e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '1d44e4f240b2b6e3a658239ceab47b28796126bf',
    id: 'range-test-20260619-3060',
    matching_hash: 'e5f387bcb188bc4fac1e8b0108e1ca5f2d582e4d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'ebb6ba4b1e07fb4b389f0babc8da9caf96eb650c',
    id: 'range-test-20260619-3061',
    matching_hash: '52d32a217218ddec9b4df3dcd00ad3483b57d885',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '87512e3509a3f841fdda7cfb88b82554c25d9f1d',
    id: 'range-test-20260619-3062',
    matching_hash: 'cf98f29e912dee574f3098d79b93c1558547f2ea',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'a382a9640df07fabebffcd7875e4d4c484cdaed6',
    id: 'range-test-20260619-3063',
    matching_hash: '2d443471c4834b4a38d0db1253f268666d576978',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '1fc47c4b4e01f6bb556450e2274f694822ed3ab5',
    id: 'range-test-20260619-3064',
    matching_hash: '7abb26f59eab153da05a838114e9daf9d65e74dd',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'c2af3408613126988cc426eeb3da51ffd6e2819a',
    id: 'range-test-20260619-3065',
    matching_hash: '54d05951cfdf5f7bcc3600fadd6674c9a9ff2ee0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '863d5e21615c9fd7c3a5bbf62606bbac8e3cd85b',
    id: 'range-test-20260619-3066',
    matching_hash: '71214830506148100ef6f92fc9abfd6884a75173',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'a5e9ffd725561b040dd7530a7db97052f380e50e',
    id: 'range-test-20260619-3067',
    matching_hash: 'f2d787944623682d2ef20f552307442a3210ef6f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '20b4161cccf42b3b4881595107ed95c36b17b09f',
    id: 'range-test-20260619-3068',
    matching_hash: '346b7513fdf8e108d70a7d977598ff15d8c334d4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '88c0a3863d8f0ed040df5a2cb823f48b4c0cb209',
    id: 'range-test-20260619-3069',
    matching_hash: 'fae97cb61afab2973a54eef3d3c1cc952bd82400',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'f9d413113018141dc745ee2491f6ee8cb0e13d3a',
    id: 'range-test-20260619-3070',
    matching_hash: 'f8268e5e0f479a211a539dd461ae28bed4fd5970',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'f1e0db2fb196145e38f9c84e773611e77618af52',
    id: 'range-test-20260619-3071',
    matching_hash: '8d62490429475647c9df8eac39169c63b6a47b06',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'c6226e81c6683eb692e809ee8effa53b90b2693a',
    id: 'range-test-20260619-3072',
    matching_hash: 'c810cf44e1901552c948bf369c77ea29cd76c08e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'a58b265bedff2f9986ce596035496a33cdaad5c9',
    id: 'range-test-20260619-3073',
    matching_hash: 'f78da7a7a93be7381dd0ae27e28b4d333802d501',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '495f0dc25f36a6b943127e297a8c0ae27024187c',
    id: 'range-test-20260619-3074',
    matching_hash: '5dc605de47b3d0a92c3fd43ea4192396d5cef25f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'eb704482134d93697c5b8aacbce8768bf95b36d7',
    id: 'range-test-20260619-3075',
    matching_hash: 'ebbf79c8fd262839a4e4a6a0c4c6f1c5f5189113',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '5328039a29b1600d063d85c13cf78524e9335087',
    id: 'range-test-20260619-3076',
    matching_hash: 'ced71b14664f336ee119b06fafc33715c9a8fa52',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '9d7fcdb7668126d9c8e28ba850c3bfb41116d314',
    id: 'range-test-20260619-3077',
    matching_hash: 'c0242378c3b595a37b464ca728b61ee26789130b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'eeb6acd75d36403ed4ed77195b6c7e8dfe4aed45',
    id: 'range-test-20260619-3078',
    matching_hash: '10066b0fb40d6c7b4d6bf85f34ef441adfac9bb6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '784b5858c93a8902c82d05b5920f962af6d712c8',
    id: 'range-test-20260619-3079',
    matching_hash: '3f7c09a792a9226648808027c58b68479f4b2854',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '80102076878384e0659b81773b3ca0b4c7f74989',
    id: 'range-test-20260619-3080',
    matching_hash: '7fcaca9aa3aa73c8be6f970afe8e552b6038f312',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '4f45d1492a1a10013b56ef5338ba923f8f349fd4',
    id: 'range-test-20260619-3081',
    matching_hash: '626bf83e1ce6bcd3f252ebde4717acc9646502af',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'e0baf4b3541c0a025e77b4141682766497f0c283',
    id: 'range-test-20260619-3082',
    matching_hash: 'a26e621c2520872a5a8a24422024cf97064e9c86',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '4bfbc2a0e3b64295b76852f31821714abec02b64',
    id: 'range-test-20260619-3083',
    matching_hash: '1478b7e59965331ff5ea086bedd40b973158a047',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'ed0dd7399912f369a7c697f161e2b38197777ac7',
    id: 'range-test-20260619-3084',
    matching_hash: 'a94a151f329959bc9fd9f21163314d5095f4e131',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'b1340a293658a885e2da469e93b0090af81c9c02',
    id: 'range-test-20260619-3085',
    matching_hash: 'c8a43daf7136a2d33968608fb406f3259ce26ac6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '6d6fbff0371c0e093caa929c39df9a5922ff1d3a',
    id: 'range-test-20260619-3086',
    matching_hash: '4ed734cf6a91298fc72d290a90f44921f9fea6a5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '73ea5cd748d75daf3868ed530a1d2b7b71a22808',
    id: 'range-test-20260619-3087',
    matching_hash: '9c1f35dc23df43b3dea687381a917eeb3bc0b90c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '6132b3fbf1b93ed6e1b1b4d09687946e7100d031',
    id: 'range-test-20260619-3088',
    matching_hash: '2a68895534f501f805f3468f418b4b06b586c908',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'dfae1224331bb0d084decc40bbe406b03ae6f589',
    id: 'range-test-20260619-3089',
    matching_hash: '492d74102a9a52e335bdd34519588fc62064a8c0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'ebfea4dbd6b92be7cb3a258f6d70f19cc34d1cf9',
    id: 'range-test-20260619-3090',
    matching_hash: '9bbf5a8830b3f2003539db8e60513f56916644ad',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '2b491b14d52ad5bcfadfe763641bd6f9b671bf9a',
    id: 'range-test-20260619-3091',
    matching_hash: 'f4d3493c8f6105c017ca673926ff6843d496319a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'abda3666f32f789462971b866265b00384a048dd',
    id: 'range-test-20260619-3092',
    matching_hash: '4dbeaf9c44bae15424936b1012104cef5d0cf597',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '22265f9de35d7b4efae527440911a887eb00fe2f',
    id: 'range-test-20260619-3093',
    matching_hash: '3cacf6b671bcb1cbc97952d799a16b6c27475096',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '7a14fe3453fc63d4690d2d5621344f29d349c9c8',
    id: 'range-test-20260619-3094',
    matching_hash: '518db4fdb2da25b44bcecec92ad543f88d02615c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '2b0b857ef271fa933018bc6ac24428f85af237ad',
    id: 'range-test-20260619-3095',
    matching_hash: '617dc27fdaef420da4774724a6d801652a2bdefe',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '49e6b7b03b0e3fb8bc447e44e5feec56c8a64bd8',
    id: 'range-test-20260619-3096',
    matching_hash: 'f9c6d1191cf73a593aebf0386d40c41a79951379',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'be8d26b040f4a582eb0003abc06f90f6f968581b',
    id: 'range-test-20260619-3097',
    matching_hash: '3dd40af0dbf6157881a4eae1aca485977805019a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'fc44bb204e65a591523b20f382bf42e286dd5efd',
    id: 'range-test-20260619-3098',
    matching_hash: '34ae6ea1528b6058035ffb352a7ac46b60070bbf',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '726ef3f1a809690c7c8f0ca1a5c35e7b181e7b58',
    id: 'range-test-20260619-3099',
    matching_hash: 'aa2b6056ee1100762d03636d3f7a56b4ba15e005',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '7e795f588cdc543314da9392b5bbe494b80306c2',
    id: 'range-test-20260619-3100',
    matching_hash: '198a8c9da68731fc92168659cec68f7dc5334485',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '54d894c9c18cce36dc6183d3d4453b37702cbc46',
    id: 'range-test-20260619-3101',
    matching_hash: '739e9289b94a141a776782a9eca4cbe56e325bfc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '1435ce312b4d2bb3b830553b26cf49204a67c9fc',
    id: 'range-test-20260619-3102',
    matching_hash: 'f45d46ac4065ed9dc86fbc6f358c48be1e69524e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '1a00247b3006459c6504b6d14dbc64fd94c95f58',
    id: 'range-test-20260619-3103',
    matching_hash: '8d53ecdcbe47b86fab9d140fbe405090f70db847',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'd3e16041d663992bb4b02918c807e65f8b073032',
    id: 'range-test-20260619-3104',
    matching_hash: '7a11377e39ea70de2b4e30535e954d8953d7068c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'af6b56684199019b95153e16687bc73a336aee8f',
    id: 'range-test-20260619-3105',
    matching_hash: '590a684a0b030fdb17c6cb89b956386ecf758329',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '6153e5ee1500cd81fa33e5906904b16277fcee04',
    id: 'range-test-20260619-3106',
    matching_hash: 'dec21156bdef04b0ac3b464caa93e886a1772d2f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '004ccf3223842019859bc281d341d3a619c1e29d',
    id: 'range-test-20260619-3107',
    matching_hash: '330ad974426f62a78d0d425f90409dac86fe31c5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'f2d0650b7dcce65a0eb507fc90f2ef566db3e360',
    id: 'range-test-20260619-3108',
    matching_hash: '60eca6ae18ec96f67a401c5985ae4bc0c0b2e397',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'd55919da6695b972f88e78d238b3f9354bfa8c39',
    id: 'range-test-20260619-3109',
    matching_hash: '14ae92bda324ec80e0cd65bcce83f61c31da7e9e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '876930ad76192d954f413fdd1933c7374f2bc071',
    id: 'range-test-20260619-3110',
    matching_hash: 'd6ce1765613d86ae741838a912b8e39cdd1a290e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '65acf3cd936eee46bdfe533d9c78fc2c1d4f8cde',
    id: 'range-test-20260619-3111',
    matching_hash: '801984290dab0f738bd6f5c0d041aafaa82644f8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '081520dfa6a63ed5c2fe8a6acfe6ae7dee123645',
    id: 'range-test-20260619-3112',
    matching_hash: 'c6ab407ac76f00672fbf5aa6e8e19a7614568fdf',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'b3d265538ebdfa71e958d6081fe81d691266e5f8',
    id: 'range-test-20260619-3113',
    matching_hash: '0eb699102daaf15c2a0e9186980bfc541f86014f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'be0e5ffad19862b214705a52099c7f157c90f0b3',
    id: 'range-test-20260619-3114',
    matching_hash: '89a833583b70bc8666a165809024fc6bcb0234ca',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '946cbe153f8930c3c28b9295194a1db90e412196',
    id: 'range-test-20260619-3115',
    matching_hash: '3d5d010ee4094fd6b622ea59c298b136263f884e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '64d8e472fd044d9b4a7351791a3876f7a574a48c',
    id: 'range-test-20260619-3116',
    matching_hash: '2e7bda41d77ec88f91d69b525918832d4e3cc543',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'e4be4edef0a469eb76936dde3d913fcaefddf441',
    id: 'range-test-20260619-3117',
    matching_hash: '5441036b2f59573834f1cbcd38a3069ef8b49db2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'd9a701a9b66d66f8802ed88fe54cb4c37c0307de',
    id: 'range-test-20260619-3118',
    matching_hash: '5a908d0b540aeb6006eb0847b76adbcd647a2dab',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '288770df616c66f4140655bbba1353db21d56e72',
    id: 'range-test-20260619-3119',
    matching_hash: 'dc2a9b4270c20186d11e140f4ef7c441e1bfab10',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '7a1fd591e8416e8d18586e6e5229467dc29afc9d',
    id: 'range-test-20260619-3120',
    matching_hash: 'dfa7ae01b6e4b26a688eb2cb0f5b77c45ed53615',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '8bc26e2729215398b84d059ab6896953e951cc39',
    id: 'range-test-20260619-3121',
    matching_hash: '03503fe1b3b864823d4d8886f3c07278eb9a9b0f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'cba0dafcb9bcc6c30e2c89cf2733839c81bc2e85',
    id: 'range-test-20260619-3122',
    matching_hash: '0ccf6140ba4e224513431f897865e221c3468227',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '9e34b305858c83321eeb89d4b3f340d2dc5a45d0',
    id: 'range-test-20260619-3123',
    matching_hash: '5a0ca7d7c00adb2a73925f24817d7c36c3af32d5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '1c349f4bf1a58bb095c5a1c86106823bb65d4374',
    id: 'range-test-20260619-3124',
    matching_hash: 'b2c50949d7fe81dcd38f60a66ee4ba10bbe83680',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'bc52a688bdd47c1935b1445de89acf2e50c96b02',
    id: 'range-test-20260619-3125',
    matching_hash: '3625d27e09adef613351e763e207d5115eeea70f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'b2a4697a34cb74d2948248dd5157653299b8d5c2',
    id: 'range-test-20260619-3126',
    matching_hash: 'ab7536ce92a0dafe59d207cdf7de64989ebc4462',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '2b9362e0233cba7652fbc33031526a742839f94b',
    id: 'range-test-20260619-3127',
    matching_hash: '3509cbde946ed41696c9feaef17fb7bb3d6b7dae',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '39ab5dba905c5cd08abc229f55d8d5b98ea2a01d',
    id: 'range-test-20260619-3128',
    matching_hash: 'cc67c498416d937b1d481fa1197810d2a4bbbe38',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '2c9f640a04305447a5eddc1ae9e6a2864a5c9ee7',
    id: 'range-test-20260619-3129',
    matching_hash: '04409d0b4e07f4f0911028e216d317772e91eb51',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '76df2354842996316460b70e2baa747b54902b51',
    id: 'range-test-20260619-3130',
    matching_hash: '4b635f0c8589939c9cad87b3829bffa135e2b4f7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.824477535,
    qx: 0.273142239,
    qy: 0.242871282,
    qz: -0.432022745,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '8b2c5441361854e365f15d5d1e8b7d945ed029ac',
    id: 'range-test-20260619-3131',
    matching_hash: '8f196992be920d38265fdec30018a99b1fde13e0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'bb63b5e361e1693ffe9622ba97d5288f022f1a8d',
    id: 'range-test-20260619-3132',
    matching_hash: 'eeceb5fc63ae0e4c2a7b12d8610e98eb40e3fec2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '25803c9a7d06a1305a1338db6305f621f060e39d',
    id: 'range-test-20260619-3133',
    matching_hash: '7f9ece462ad59f9db4df2be81bd6d9effac206dc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '6f29e858c9e486e1ad6f8344c0abc3dc3f59af2d',
    id: 'range-test-20260619-3134',
    matching_hash: '4a7ac5381bb592718d361d570bd5fdca87e87fbd',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'e1e41070088ed8b0976d0b4688bc37fc055915fd',
    id: 'range-test-20260619-3135',
    matching_hash: '8448deb0cbaa2f8c8387a8c22bf4f329b2b179bc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '54e2edeff5c6dbecddb7ae39433df3b864600d9f',
    id: 'range-test-20260619-3136',
    matching_hash: '37a13f9b747861caeca59280034529ee793e19e8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'b794126e8dabd2719c662c422b962e8dedd6eb05',
    id: 'range-test-20260619-3137',
    matching_hash: '2848fcca3796d11d445f92a5e74212c0320a9136',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '3b52ad08434d71022003ebb94390b274f644d9cc',
    id: 'range-test-20260619-3138',
    matching_hash: '267cad1cbc5d390a9591ce8b7c35af8d5980a6c5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '8a84d5ca029a7c2f31f727258113aff5a9c5f1fc',
    id: 'range-test-20260619-3139',
    matching_hash: 'f7f6177144f2b2a3de0845de6bcaa162d372c862',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '9bdaab0816887958011a1bcef2787ddf793324a7',
    id: 'range-test-20260619-3140',
    matching_hash: '07121cc6f1e41797d220129986b138ee13fdf2d2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '8719dd684822dd8b0eba623ebd587cc69fa69006',
    id: 'range-test-20260619-3141',
    matching_hash: '59e45d17cc2ad816d4843351aef41f80d3cb9d2e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '4e242ecd49cfa07c515853208c333b8a29e55ab6',
    id: 'range-test-20260619-3142',
    matching_hash: 'c1a842f09bf19f56696f26d0c245c33cc98b6ef4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '511aa4b7f032871a8465db5b15f78c22e187cb46',
    id: 'range-test-20260619-3143',
    matching_hash: 'bb8c0a1ebba93288107cf0b994068aa40040050e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'ae50a2a2ec8b8396496be8c067295c1679a65f5e',
    id: 'range-test-20260619-3144',
    matching_hash: '854c30bbecd25c8d9488e33e44ea6356011ce0f4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '7dbc05542430bc3663f6634c9e06da87b6bcd5b9',
    id: 'range-test-20260619-3145',
    matching_hash: 'cb5ec529d168a72c6853fd6df48e98a5876618e3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'd6f408c2043e6b2dfa71ef742dd0db14edf28a53',
    id: 'range-test-20260619-3146',
    matching_hash: '8d9c4b7faedd80c44b57d1c9cd268031a5a5a669',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'a007b5b81483b6e65e740b45a26e26c05b7fd2e3',
    id: 'range-test-20260619-3147',
    matching_hash: 'c1c822e3bd4856576f7f07b2592f7cab8c993128',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '2450512ea6dd5d07d4ecfd3c273d8dc9e39de892',
    id: 'range-test-20260619-3148',
    matching_hash: '4ef79e3c251664d9d06b7a3fe8db69479e3133a2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '7c8f9a190f161af88ded6c666406549b5bf46b81',
    id: 'range-test-20260619-3149',
    matching_hash: 'c6cf9fe4475dce0a8bc48291022d8d6395ad27e3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'd59e27a6ff378db76768d5abac14fe8ed0d98920',
    id: 'range-test-20260619-3150',
    matching_hash: '01d119929a0349144b6871d08ac636ede55d5267',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '493053de9a74dabeb69d7f146f3548fc868ba0df',
    id: 'range-test-20260619-3151',
    matching_hash: '772989ebbbb59c1b8454c8da18f8ff6af12d296d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'f3b6359094ebd4dc17f4e5ee02e3f9082b407783',
    id: 'range-test-20260619-3152',
    matching_hash: 'e583688f2c8cddd68c8511759cad77a9ef7c81ec',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '816b9a56f349947f1ff4166808c87c202323a008',
    id: 'range-test-20260619-3153',
    matching_hash: '2c0db85440930d3104fd2cca579f1a9216fe87ae',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'face52b360a8c9e50bc16b11e9ffedb138afd57f',
    id: 'range-test-20260619-3154',
    matching_hash: '17edeb075f88941ee987383dade7ea76598831bd',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'fdba135245a52449ef1d09a248229259b5f5ed4d',
    id: 'range-test-20260619-3155',
    matching_hash: '508d25cb6008e96eeeda90f02bd68a48c50822c8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '6f625a453ce3a82f34f05643b617ec3fee8aff5a',
    id: 'range-test-20260619-3156',
    matching_hash: 'd070fa1c9eeba9091d42b9e2fe72830aa1027fc8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'ea891ac69086b8367127b33680130999b0e47ff8',
    id: 'range-test-20260619-3157',
    matching_hash: '8caf8a90f06499f54118a7e4f8967b7a0b72c10f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'cfb5de22c2cf7c8f49f2103455bdefcfdd2deb17',
    id: 'range-test-20260619-3158',
    matching_hash: 'd23d35568f5d88a7c696887172ce94838103c1f1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '966ea089c353a45be88d91dc1825b0f80b9cd640',
    id: 'range-test-20260619-3159',
    matching_hash: '27a1eb8dc9257402f1c809780eec2c7b36dc14fc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '167d5cc9f5dd0ccd659b27068816dd637a61ea74',
    id: 'range-test-20260619-3160',
    matching_hash: 'e86352243e673a70ee8305378ff439774e355791',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '294dcdea4f683f0985665a36941d8754f5cb15e9',
    id: 'range-test-20260619-3161',
    matching_hash: '5b11509f210a5294d18d162be2a78c245872d0c4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'b1112d1fa6104eca360f9cf7bd3aa53fa42706f7',
    id: 'range-test-20260619-3162',
    matching_hash: 'a74ae8891b2478a6cdd62134be16db8b49567239',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '351720da63afd21bcd145a14c8a8cfb506903372',
    id: 'range-test-20260619-3163',
    matching_hash: 'a03106372bda2dd3da16da455631f60da4120008',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '244649203d92125b4e9671eaa212940dc6f45280',
    id: 'range-test-20260619-3164',
    matching_hash: '0fbb76a60ae3baf7b21427e9c6eee638177f8172',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'baefee43a1bb46ab5fd0e97d5f168d8c1709d772',
    id: 'range-test-20260619-3165',
    matching_hash: '65863fafe28e3e45d5daf507d1583357c83396dd',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'c6aba5c6b28fd5333ca4719b57a227b8230272ad',
    id: 'range-test-20260619-3166',
    matching_hash: '98dda6573e0fbd80aa729fa79dfd8a8dbfed7c0a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '76218c0176bf00a93db12b137cfc47fe97d7aecf',
    id: 'range-test-20260619-3167',
    matching_hash: '37615df0827fe5521e9732c8b8c3e0c13a6e9221',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'eef0fd908aa71d8e41346b1cafc841b3e1969142',
    id: 'range-test-20260619-3168',
    matching_hash: '7ff899e6d620a46f3c2dce10187271f5164a5e54',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '70ce1682ed0e3e5211a37817b005f887bee2115e',
    id: 'range-test-20260619-3169',
    matching_hash: '0e34be9c7f243d76e247ab02bb6b325e8b12f753',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '5b8316108141591ca060de56f34f190ee6f14f99',
    id: 'range-test-20260619-3170',
    matching_hash: '519ddf4592b2a1fd71799a267ffd486b65f44fd3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'e70f8c47238f0cda55e13cb1ea197f07bd190099',
    id: 'range-test-20260619-3171',
    matching_hash: '70fcd9018c80c7f3afd7ba54265840fcc9ce48b6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'c8970542cfb964e0dde4ff41d16567aab23f6458',
    id: 'range-test-20260619-3172',
    matching_hash: '5a51ad1ede643c2df6746dfb194ddb75b7301bbb',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'ada2bdd69041ee81dd4ff83bb7dfd3e82bb8d576',
    id: 'range-test-20260619-3173',
    matching_hash: '24f84ea8503b26044948bcabc0885d3bfe86b1a2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '2b4504b8ea840f82b1ea301f894cd329c2a71155',
    id: 'range-test-20260619-3174',
    matching_hash: '104d086531fc9a0761fe249d5cd49b0f23e1e4af',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'ab5e3e7afa6f933ea48b8bbbe739bb30eff12ee3',
    id: 'range-test-20260619-3175',
    matching_hash: '802c2ee9c3f5258786f3e195714d828a0b1db7cb',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'aab30061fdf0930da3fe2a130c6361593dbbc6cf',
    id: 'range-test-20260619-3176',
    matching_hash: '1ee217adaa2804d13b951dd2c5e1883e30d1c5f6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'fdc54edcaec560676c43003e981eb10f7b2a2e40',
    id: 'range-test-20260619-3177',
    matching_hash: 'b3893151c9b817c6404b75ffb51f53b0824ae33d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '38680863ad0ae726f450c45cf4136432b60361f8',
    id: 'range-test-20260619-3178',
    matching_hash: '68af337cf68b5accc42c6c2a919ec644706245ce',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '15fe1ba61b0273677147b274c90ade79d61250a1',
    id: 'range-test-20260619-3179',
    matching_hash: '70a92bc917634f84113a1cf3ec4801aaa34f7711',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '4b332f0744f0dc84677f36f22b746db913dcb200',
    id: 'range-test-20260619-3180',
    matching_hash: 'aefdcce37712b2bcd4c884d0ad8200dc460f26d9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'fd275e463a7846cf70c6c292b97f4b88d179c7d0',
    id: 'range-test-20260619-3181',
    matching_hash: '933a58c4bb7fad24ae269234eb03e6449d1f5431',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '98273f86b9bd973657c0d57983008245b3b70197',
    id: 'range-test-20260619-3182',
    matching_hash: '6eb67b3e79e0b99b5ef36f7abbb0ebc0aef9f049',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'c96e45e236039dc04818553a730c5ad1ca991c06',
    id: 'range-test-20260619-3183',
    matching_hash: '7938620ff92fa8e57011cc9cd90ae934ffa5e673',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '5bd127d1dccf87b27cc9d1287c49c851a21d5d16',
    id: 'range-test-20260619-3184',
    matching_hash: 'd8c9a71f9887ac537f2a25c4197f059b9ad45cb5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '1894e27c50e0d871bc746d3ac72f297ab7008fba',
    id: 'range-test-20260619-3185',
    matching_hash: 'e0e873bd64a09c3b2a27b2082c39ed422a52fdb4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'de35ec6dee6cbb2c3a8f0521bcc2e9ed58d27cce',
    id: 'range-test-20260619-3186',
    matching_hash: '1889bb2cb889afc9c870a13425e9876a9c5437d2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '9b6dbac43bdef11a5e318bd635c2957ea83e2860',
    id: 'range-test-20260619-3187',
    matching_hash: 'b0b5eaf9f3c2f9d75b293d36c9886a658c6a6f46',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'c2b0f65edadd7cdeae075e94d70910968eee7409',
    id: 'range-test-20260619-3188',
    matching_hash: 'ee8747be292287e26b42cc531666da7a96db630d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'df2d73c5451b1a1756af44cc80368de9e8c465ca',
    id: 'range-test-20260619-3189',
    matching_hash: 'ebfb185c3f5519a654cc1619f045a71400fbdf2e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '1cf8aaacc4a9ba94b9be1c62b1a4f440e08a2ca4',
    id: 'range-test-20260619-3190',
    matching_hash: 'f3b1510aab474ee887e95e5ea556ec5f0d4a4db4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '7cc4414725d3d90e1248e0ec19893a3cec6ff6a7',
    id: 'range-test-20260619-3191',
    matching_hash: 'c80c1e56bc8557057d274edb360d60a5c6e04473',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '624d4cc4ec143d8ad929e21b5461e1e55d76f412',
    id: 'range-test-20260619-3192',
    matching_hash: '5be6b312f3de9ce3a4c6c81e2b6eade4879653c9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '29aba56899749dca2cfd27f07e486d5b8c12226d',
    id: 'range-test-20260619-3193',
    matching_hash: 'f4ac415a2044365b6bdf417b43f74c98819a0bab',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '49b0f382183e13c2f54f780a16a698ab495970f5',
    id: 'range-test-20260619-3194',
    matching_hash: 'c52fd5fde12b40a8d570b8374de1996d876034c6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '3afba7f3a0d1ccaa21318e8b58ed455393cb0c52',
    id: 'range-test-20260619-3195',
    matching_hash: '9b6ae321c27f29f1e9a596f725c5bba269af8e56',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'bb8f88a2de1363ea5acc396332a6f409e2a0a980',
    id: 'range-test-20260619-3196',
    matching_hash: 'f191d810766b0df020ec9c00bbc633cde9f15d9f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'acc013e2993a05e2e466cd6619e85be198229170',
    id: 'range-test-20260619-3197',
    matching_hash: '2260c697d22304e134627e67e21caa3253ca6567',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '63e228af974885751fc71218223e62ede37b4479',
    id: 'range-test-20260619-3198',
    matching_hash: 'd8ac719ba0c7fb549a32f85b754f6de3eebb342c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '08f90abf882516814684dcfb6643c3bedd9b87cf',
    id: 'range-test-20260619-3199',
    matching_hash: 'f69d444398326cd8edd757a087d2a5049ad9f7a1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'fd8821fa2212697faa877ebe6dc858ec66a788a4',
    id: 'range-test-20260619-3200',
    matching_hash: '058849aa65890bdaeca9e6c9730685ae526e4fd1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '6eb5662f6eb8d8b8131e7b9d9fdd99968dab9307',
    id: 'range-test-20260619-3201',
    matching_hash: 'c983658e7a38cfd4d6386030162c41923c117894',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'a060f11caf1867f811e632b67e1a296fff90bd1f',
    id: 'range-test-20260619-3202',
    matching_hash: '6df45dda9bbbf8cece4edf7130888cf2257e051b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '51da25dcd34cbdab7ad30c4968757cadd28c1b32',
    id: 'range-test-20260619-3203',
    matching_hash: 'aeba6396e54b8e120e4302fb8cea7e838909e49f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '1a0d88def0aaabd127ecffa4f7799a9b95881663',
    id: 'range-test-20260619-3204',
    matching_hash: '9eb75c46efcff66808ed2b97310f30948c19864f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '3340afce677c0d7f25df0a4544b7bc256db469fc',
    id: 'range-test-20260619-3205',
    matching_hash: 'bb56defdef83b07411c9997b885abf88038a46f9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '32ef12198739f5bfa555bf378c6d80b0e22b4b63',
    id: 'range-test-20260619-3206',
    matching_hash: '1818ef3f5c2012a3c9746a0304a5e52f274eaf7c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '4c83a9950f7ecab45d33ef41e4e513505ba94b76',
    id: 'range-test-20260619-3207',
    matching_hash: 'c4746794b2b11d064458f11e6c2742679dcb42f1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'de1ea951e93bff0ec66ce48cfffb6c6f0d2ea64d',
    id: 'range-test-20260619-3208',
    matching_hash: 'de880fba2e63f60e57bb52938e4051f87ccc1c9f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '659fb6f8a6e321a8e029bafd5fbd36791a556b15',
    id: 'range-test-20260619-3209',
    matching_hash: 'f1b51db16b2444312bf51b1cf3389e5724fa6abe',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'b2f81b1945ff87286eb18a9a79ba1f2e0e09f623',
    id: 'range-test-20260619-3210',
    matching_hash: '9215a3061ef5ee62300dacc409fd83d62d8c59e7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '78bd11afd941ff5e48b953967dd04d1ad9e30d79',
    id: 'range-test-20260619-3211',
    matching_hash: '22a2fcfcc83e669b23a3f1f7a6c513e53fe8b7ce',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '24755a7fa29950c2d028f18612cbce91fc9a5baa',
    id: 'range-test-20260619-3212',
    matching_hash: 'bd647649f1aced275799b4c2883d076c44e64894',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'a5cda0158df78d472f14583ab5d2ca74d72aee7b',
    id: 'range-test-20260619-3213',
    matching_hash: 'f2a362eed8e3a01a9795bc10ff865d66c6017901',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'e1f342a846f4cadcfa696cf02426a8e0a6abf641',
    id: 'range-test-20260619-3214',
    matching_hash: '84759348e1502386705cd0528cd6f73447c09f24',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'd0e59d8e7ba163f11549b1d02d2d7bc8a2ef7113',
    id: 'range-test-20260619-3215',
    matching_hash: 'be206b20be86211d20324157c633c43edbceabcb',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '4e5f1ebd7f0ed3f61f05d47973aadacb7a6a006a',
    id: 'range-test-20260619-3216',
    matching_hash: '3be73f6054c39b446bc74a22716c5e2718ea9cc6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'f390d4f9fc466b56174fa3474847e337f77fd2ce',
    id: 'range-test-20260619-3217',
    matching_hash: '396a716337f7317fff073fae5a15e6768b0671fd',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '5a50d47cfa6c7a597200d8af1c238d20675b246d',
    id: 'range-test-20260619-3218',
    matching_hash: '50f7bf50dfaf62c186f9bed1134f9b78c0a6e942',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'ae4c50967ad95671e429ef3de1352a5135379d0b',
    id: 'range-test-20260619-3219',
    matching_hash: '3622e1932bffc77af42d07e689eb4abca9cfb1d4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '6e17724ac1da356980f4e93bcba45b17b5bcfb7b',
    id: 'range-test-20260619-3220',
    matching_hash: '7164278b49e2b1bcd31a1b6c7181db1685f2352c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '639cebf4eaa30fc0ec9cb01e5cca24d447a11571',
    id: 'range-test-20260619-3221',
    matching_hash: '9eb09e518cff1280c05fe800e170e411c10e9fbe',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '1f0a4313237a63bcce439bfd5ddd0852cd6b030e',
    id: 'range-test-20260619-3222',
    matching_hash: '34b33e20e15f203e78fbd7fa3f0272ec123882cf',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '86dffcf9f9f6d21883322551fecb3eb4be9b6e20',
    id: 'range-test-20260619-3223',
    matching_hash: '1f8e0f5725e89a882e776b34cf9586ec9651e590',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '4759c71da007e3d8b22356df06ac798266761f6b',
    id: 'range-test-20260619-3224',
    matching_hash: '6566d3a894a791fb0042a971fb4d55b43517e10b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '96f140e86c08d62bf4892ca16c23acc1bfe50c7d',
    id: 'range-test-20260619-3225',
    matching_hash: 'a3c695a8e6b4cddbaf4b0368c83a822e31563559',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'b94a928f4be0ecd12cc80cf8940a20aca09ab6cc',
    id: 'range-test-20260619-3226',
    matching_hash: 'f4f3de03be2cbb34555ec6e92ce51cce6c313589',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '77256706a94518a988bde499d9f0e5fda9c08fa0',
    id: 'range-test-20260619-3227',
    matching_hash: 'b5a83726e24278ee14cf16f85558e6fefa7b3531',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '69118b4db40a1b9646366cbaa0d807a29976a5a6',
    id: 'range-test-20260619-3228',
    matching_hash: '20ab00c6186e1c4f11344a423bea7f4d3393f585',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '2aa6ecc063f1906912cbdbf9a5f1cd53d5ba4f41',
    id: 'range-test-20260619-3229',
    matching_hash: '4576e642de25bbfea1970208b859f6ed985e1514',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '7a4f02312728be8b1744161fd37e016055966a07',
    id: 'range-test-20260619-3230',
    matching_hash: '68e3202bb6f33e82dbf3ed24d0f35e23e3595156',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'ece0e90c269d98adb29ecb6f0f81050d67d2a046',
    id: 'range-test-20260619-3231',
    matching_hash: 'bd472912887f786d4be11828ed6a0d6d36afc156',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.552584326,
    qx: 0.437146813,
    qy: -0.063118442,
    qz: -0.706802156,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'd5c00c4c53f4ef79a7fc2cedd57a5b5c3dffdd0b',
    id: 'range-test-20260619-3232',
    matching_hash: 'ca886913d6498214aafc85b8c80f2dc5715cb0e5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'f3deb4ae4c54ab3fba49afa08029839bef6c6ec6',
    id: 'range-test-20260619-3233',
    matching_hash: 'aefb26d396e71c4452e2b26de2a79f0e3cc312f3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '94013b19270c53ee7ff6e789b2367ed6d396d30f',
    id: 'range-test-20260619-3234',
    matching_hash: '1da6d1a484eb528c1851484444145e94b54263ba',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '8c9696938b8789a6d7ccd73c19f496ea7a23858d',
    id: 'range-test-20260619-3235',
    matching_hash: 'fbc720fe02c5fc7ca452127f00209b3aab48c08d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'b272ac2193effa97640d1fa6d0bbea9de599d56a',
    id: 'range-test-20260619-3236',
    matching_hash: 'f8f1379413a1c42f96473fa78bf795eee10b7bb1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'fc6bf70f187c63abd6d2e51d17478b14ef997189',
    id: 'range-test-20260619-3237',
    matching_hash: 'ea865eeff499fad6313667bcd6aa923439585aae',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '95a82b78cf767b0cfa9ff975647ef8992954782e',
    id: 'range-test-20260619-3238',
    matching_hash: '94a4ae533b45ddd7b546f9b2f02149ec9cecda2f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '375b77f06b9f30a6ebbe7770ccaa0ddef3d85585',
    id: 'range-test-20260619-3239',
    matching_hash: 'ab815a4f76a958619405fbf0e03d313a83c654d7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '47a049ffd140edd665d50a14ae185fc084f8f0fa',
    id: 'range-test-20260619-3240',
    matching_hash: 'e5cbf8b1b5889f2aacbeccc53de5cc865180c119',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '36f234347358b2685134c6bc96b360818b08b472',
    id: 'range-test-20260619-3241',
    matching_hash: '00a6c24e6c613f39a1cd83c2ec2c56a54acb6f0c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '921dcbe9487852c02a625a9bb0b0d2264a5e659e',
    id: 'range-test-20260619-3242',
    matching_hash: 'd31bb359d64a8f06d60a4de2c62ef0c845848fc0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '43200135099466473b160035d7d7e1ebe880dcbb',
    id: 'range-test-20260619-3243',
    matching_hash: '0358e2439ac4e48cbf18212301c8ba8f86003678',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '7b61921f2513a0af113645ee3fe393fad3e7814b',
    id: 'range-test-20260619-3244',
    matching_hash: '7ada6fc711345a786ed54f12cc3e76304ea0084f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '28dbbd4ee1637d369394be87e151d8335a35de6b',
    id: 'range-test-20260619-3245',
    matching_hash: '6ae9ef24bc004eae6990f9061b0048d97134493e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'a1bd892e0a42efc83096ea57ebad9f6ca136766b',
    id: 'range-test-20260619-3246',
    matching_hash: '57776ad4abc2261c98fa8e36a08fa8c9e0ba9a32',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'ddfb49f2e52bd96c470ce88206cfbff685415988',
    id: 'range-test-20260619-3247',
    matching_hash: '99028ba80e40ca85cdb8d213cad27f7e9dacb501',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'f256d6b6fda95ca05fd32339f76108b2c90ba692',
    id: 'range-test-20260619-3248',
    matching_hash: '8440d5960c6164d2262941959edb1d16e758a203',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'e155e072e7324959b914f30f5795b81544949345',
    id: 'range-test-20260619-3249',
    matching_hash: 'c9c2d928fac9c9f85bd24e2ce9bfa2ad29f1b231',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '9104fecf5baef350f33ff8c19384075fd930ff45',
    id: 'range-test-20260619-3250',
    matching_hash: '0b297d9c879787a8256deb3bd9596a9fe6599c76',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '66bd268f849316ee02bfe5fb0a159ccf145aa3d4',
    id: 'range-test-20260619-3251',
    matching_hash: '35b2f8c509349c15b44727d67fdf65486507d98d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '2084bfca0a51d9a65dcde5f59d3f1d42e4cf2170',
    id: 'range-test-20260619-3252',
    matching_hash: 'd2c8ff45e4cba7b5ead8507f1b09b9622311e5ed',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '02c9c2637f7250bcb5a269d623938a6ee1aa09f2',
    id: 'range-test-20260619-3253',
    matching_hash: '9ba99c2a4c9f2fd1c4d78a7ed2664ddb48287da3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'd257f4968d29c3ca05a05f876b3be5bcc8a94638',
    id: 'range-test-20260619-3254',
    matching_hash: 'e154d886db1f3f7528d11a20bacbb4a2ad2cfcc1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '895f913b14375b679d518aa1d48350d2366f09d8',
    id: 'range-test-20260619-3255',
    matching_hash: 'e6ef1c390ed279f7fa01749e6bcdd228d84a3762',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '349f9723f5c993974f6632d2df01aaf53bb8d7a3',
    id: 'range-test-20260619-3256',
    matching_hash: 'faf4f4b4b9d2b5eeba1a50e9ca5b9203440d03b8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'ae2517c49a2588568d8835cd67f12180b5ba997a',
    id: 'range-test-20260619-3257',
    matching_hash: '5869219b4a241118d16237c0cf355fff09efe971',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '4f1932b5e077e3775e448374a8c5ef4bfef2bd08',
    id: 'range-test-20260619-3258',
    matching_hash: '58160f37f7786eda35946f4ad40d74e6e454d6c0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '0f49064bb88f1506cf1646526ff5f3567b20bab4',
    id: 'range-test-20260619-3259',
    matching_hash: 'c834629fc96420a37a6b8008753c5e30b2dc5dd2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '715f3046cc96d5b5e93265fd06f95e89149d9d5f',
    id: 'range-test-20260619-3260',
    matching_hash: '99f75e15f809fbf8177393a02b7e98c3b6564787',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'a760c2f63b2cb83477abcf69b18a573e77a4231b',
    id: 'range-test-20260619-3261',
    matching_hash: 'c38de658d448b71c88c0a683192b186a9cc18e34',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '2d70181e25e8df4d6365f8d938ee268c56bd3cd5',
    id: 'range-test-20260619-3262',
    matching_hash: '4282dca1080533a861dd59dbda4ad9b42b396d0b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'ca1ac47d812f4b52ccfe6dc21406948dc18acd64',
    id: 'range-test-20260619-3263',
    matching_hash: 'b7704456ada8302a4a3282fa297274d304a86a46',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '29d74a820ecdddd45aa116cfe77db983230afb39',
    id: 'range-test-20260619-3264',
    matching_hash: '0b8a7a9627e19e45f2bae2c6eda5b8db04d10f9d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'b079fa2a79655c32db06db6a2b58fa3a26fba55c',
    id: 'range-test-20260619-3265',
    matching_hash: '3db96fa5e319b78c6299567c482e8a08ae287919',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '0933560b4e0d08c2295d2f374939924619016060',
    id: 'range-test-20260619-3266',
    matching_hash: '70f9a8aeb067b11218a975ef3233187d3c5999db',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'c989f2f1c910ab70fa9408652fda182e8dd2c684',
    id: 'range-test-20260619-3267',
    matching_hash: 'c7e22fa9821fea70b22f1e427ffadb5903135144',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '364ce74db9b1305e4c6b919c2e140e5268258c79',
    id: 'range-test-20260619-3268',
    matching_hash: 'b658be7d2477c1c5422b7928c57f44671b18f942',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '05cb4526b29ff2163a48f25a5ad415583555b5d3',
    id: 'range-test-20260619-3269',
    matching_hash: 'a4f25862b9847b67700a18bf2628f247b6b21c43',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '306c97c543eaf265ab81846bd2357b48e0f6b67c',
    id: 'range-test-20260619-3270',
    matching_hash: '8d0d92ac73605d3641549511413b7ffc66784ae1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'f9cb2500e7e13f4e37c428fb72c5d4fe38250e45',
    id: 'range-test-20260619-3271',
    matching_hash: 'fe9062b575cea98d2e5616dff873b98e3c0ee4cf',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'f264327d3f972b3b98f03dcabc1e5c886574966a',
    id: 'range-test-20260619-3272',
    matching_hash: '4562b0ab9f19e2943107c99c266d059878601c5b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '9e236158fe9581aeb226ae17f21be60fe7c6c8fc',
    id: 'range-test-20260619-3273',
    matching_hash: '0f3cf0861e3d9157dcbf56fa2fee19c884b0b7f4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '53dc76fc79321e149c66c14804ce022ae8d87861',
    id: 'range-test-20260619-3274',
    matching_hash: 'b71a08507adf00b523aaa1942152f9b3b38364db',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '73ddea2fee66ae86498276f03a8af61a819fe01e',
    id: 'range-test-20260619-3275',
    matching_hash: '49b7da94652b140d20a3e6d6f78ffa3ade824587',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '701877c46406a179ecde73e3e68c187fd8d98f61',
    id: 'range-test-20260619-3276',
    matching_hash: '2b51d54ead21763455ee59b2c9fcfd8350961501',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '2adb4b1bfe1b7fe524752d322493b9a101450742',
    id: 'range-test-20260619-3277',
    matching_hash: 'd9219af64e83eacbd0bbc86eb609f30a3bffd82d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '5ed13697a206aef06ad6db7d55d9ead8ca35ed9f',
    id: 'range-test-20260619-3278',
    matching_hash: 'ad81c966fc644747fb6dfde82b71c378287fe29c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'fefd68b8f45efb9f19847633ecf2abc31198daac',
    id: 'range-test-20260619-3279',
    matching_hash: 'bec54ad38eefe0d64dedf969d637daedc0e22a68',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '02d829d5f8822929899d674671512dd41b973ade',
    id: 'range-test-20260619-3280',
    matching_hash: '7dded8ffa28b320e8cc5ee52122dfaf7a339705d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '81e772d04dd64b5e29d4d71063c961657027b3a4',
    id: 'range-test-20260619-3281',
    matching_hash: '20f9e0ab102d1c677f8fc1a6c3ddc4404fe9bd9e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '2b174c53e070f5ca43bf9a8d1ae4a76e2fa53cdc',
    id: 'range-test-20260619-3282',
    matching_hash: 'e01d533ec533f905daa5a7153fc6c7a6772f5cb2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '22f09bd58dd0d9319f13fb4f61a2246eea7e13cb',
    id: 'range-test-20260619-3283',
    matching_hash: '13ada114f6fc58a7496714f3f7174a71a997cea3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'f717d370e250628a8c1301a24cd910317a9767be',
    id: 'range-test-20260619-3284',
    matching_hash: 'a84dfe68de89e3cb86e75829c07c9fae1b6c85a5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'fd18f95d604ae667b5625a7afbc853106562701b',
    id: 'range-test-20260619-3285',
    matching_hash: 'c28725d2c06d2473ef063935ccbc36e861974bcc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '339e43b49616a9bee8424639903a039a6862b3db',
    id: 'range-test-20260619-3286',
    matching_hash: '4bbf23a87bbe434e632c885e218ae7a1408007b9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'b41940f55a9a58a491553f24098aafb47069f00d',
    id: 'range-test-20260619-3287',
    matching_hash: '473ed783ae9efa2603d7f2a93425d317c7c5b8e6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '3a52611ee65f19a29a238930827f4d20ce7b23c4',
    id: 'range-test-20260619-3288',
    matching_hash: 'bcec577d0eb4a3870eda12817e329fc541104665',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '3cdacd8a018f252efbd0022762e6597534a88e98',
    id: 'range-test-20260619-3289',
    matching_hash: 'cba55fd040c7fa2885ee50b28b3de321ce91b465',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '15e2464f1552a5181137a5d7f62bc2cb5010b3f8',
    id: 'range-test-20260619-3290',
    matching_hash: '3c44bf9288ddd9d3a8b6991b9543c6663572988a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'b82cc9e8ac8bf415b4066ac83915e892544a4f83',
    id: 'range-test-20260619-3291',
    matching_hash: '865e2cd3d60e505dc6abe44734d2eb8aad2b41b4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '652fa81e325992593a4208ce63f000ca2549620d',
    id: 'range-test-20260619-3292',
    matching_hash: '713696a63ee4ed9acb5580359eab26605a6d3851',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '25992712c3e50318f98ebab8eb8afb217a3774db',
    id: 'range-test-20260619-3293',
    matching_hash: 'b2ba7bcef5758265f95ed9f1596564e5565d4220',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '31ebdfc6d7e96ddb989edd4b4e7400a2687c0cc6',
    id: 'range-test-20260619-3294',
    matching_hash: '4770abf7f464366ba6b91251f56952894501590f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'b669940d860a32ae9ee488a1e79307bdf7012b23',
    id: 'range-test-20260619-3295',
    matching_hash: 'f497d867c6cc9ac814493f4676c6b62522ba886a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'f3dc6f8bdaaaf27a564a0a46d378bc0ae98507e7',
    id: 'range-test-20260619-3296',
    matching_hash: 'a30b08354c14790a94842b54801e23b2a4383117',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'd844adebeab27fbda5c588ea3fdaf7839378f252',
    id: 'range-test-20260619-3297',
    matching_hash: 'dc71fdd828610cd183fca56b6130f84c32429666',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'eacc7d911b821b7dc5af67f9102c24195c72315b',
    id: 'range-test-20260619-3298',
    matching_hash: '2a75f5ca54592b4cd18582d5a2a8c51dc02d3061',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '074febf376b3d894ca2cf902808299f6dd878dee',
    id: 'range-test-20260619-3299',
    matching_hash: '3e4ca7b939a0cc88dd0c8e3390b01f5a4fa79ede',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '19e0456f86a0b89404510318e33329dc50857ae5',
    id: 'range-test-20260619-3300',
    matching_hash: 'd8163b6613647adffead92e0f98144dbe9a4f6d1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '00247d1bda551928f2aa9bbdaccf6d234e08384e',
    id: 'range-test-20260619-3301',
    matching_hash: 'd1e1133f1e9a21f5ab612dcfa1718feb79a199dc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '5bbd240564b312dadfea3eb91b465c873dac0110',
    id: 'range-test-20260619-3302',
    matching_hash: '3ef1de2b4823d3f4a3dcdb7a67ac78f6f19b2dd6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'e79a8edc7843e01a10cd87425fa7db909c398ee1',
    id: 'range-test-20260619-3303',
    matching_hash: 'a3b582d166f1fb14858fa11030e04d70e045f8d9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '76656488f54b8b36e85608435d0c0aa6c05d44d4',
    id: 'range-test-20260619-3304',
    matching_hash: 'a65dff53ca34034a9f3927c39225fb76949bc528',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '29cead19ca21620051bd7e772ad2ed4242456531',
    id: 'range-test-20260619-3305',
    matching_hash: 'c1c58e1727fd0342767a4cef8f46e7c64b094ab2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'df0b7cd1440621e412a00ea60c94f84da5389f1b',
    id: 'range-test-20260619-3306',
    matching_hash: '15c8e665b3b2cd7d6108d7e144ffc921d8de97a3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '25fa63acdc9b89ead8fb67eca01818ebc4a0ac1c',
    id: 'range-test-20260619-3307',
    matching_hash: 'fa2e7b32a380f684d7c7bb8ba22bdbd591ac3219',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '0b86a0093b111d46f1a43d0f6fa917656ce4e9b1',
    id: 'range-test-20260619-3308',
    matching_hash: 'e55e6bcde774253ba1fb032c7e72b4d28ef5ab69',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'b39e8a298a315076ed48d46074b8f8a7f4135e74',
    id: 'range-test-20260619-3309',
    matching_hash: '2c2c3f78c21534502298c6b5197e145a7af2adbf',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'a17983428280efce09f87fd957c07bb5d96f2d51',
    id: 'range-test-20260619-3310',
    matching_hash: '8ba96e440330e278d6166c7816fb02f1b5f7ac29',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '453194f91d9356c025980834d1d2aaa033fe1187',
    id: 'range-test-20260619-3311',
    matching_hash: 'f3e3174a54ce1aec4fb9e630e0b80d88526b0688',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '323a68c071a78f9c901bfb852c53dcd141548e8e',
    id: 'range-test-20260619-3312',
    matching_hash: '65377ace1e0a78e00b5b8200ca857aabb73609b9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '7e26fe2d4c749935fe11f0d7cda8c4a3357eac7e',
    id: 'range-test-20260619-3313',
    matching_hash: 'f4006c99030891b225757442c361d579cf0c48c0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '1101f0e77228462305c5d0e710c27a6f9aa5d145',
    id: 'range-test-20260619-3314',
    matching_hash: '267a988e93635ced2c248e3afbd1aadd590c496e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'b9006343dbef2641c9db5e66e5a6c1f989656a79',
    id: 'range-test-20260619-3315',
    matching_hash: 'ec7489cb319dee87350b1c22936d0de4e2605a91',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'a0e4619eead46cad7debf175a71b2686949ee0f1',
    id: 'range-test-20260619-3316',
    matching_hash: 'd673898a220b8120d078082dc94d78a241462502',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'a95d25d4e4c2c1d9dbc0626f28958452cc0c5071',
    id: 'range-test-20260619-3317',
    matching_hash: '70adcecd37a45a9039012fcaf021f2302a48ea62',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '53c87025ee6259a62db3aafe4ccae18551cbcf7e',
    id: 'range-test-20260619-3318',
    matching_hash: '66bb61d5b9180ab8dea456dbadfcf2cec3667f21',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'b4ce634d6e8ad57e8ed7416bc9a8004a2a18ee8d',
    id: 'range-test-20260619-3319',
    matching_hash: 'bbeae040c84ba72364b72cc2412a3097d9043d46',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '764e3cc8fc3b494e6e31b6edf5eb74133f680b39',
    id: 'range-test-20260619-3320',
    matching_hash: '9a4a999fc0bc849f6bcd34fc39a9792bdce96bbe',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '77b01fd6fa69016b1a146f4af711315a724405f2',
    id: 'range-test-20260619-3321',
    matching_hash: '9b82a8b41fc1fd662bc077f9b9f924d5b4f48e1b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '518fd1eaaae4e9ead8b26e6933a7159f9c525f7a',
    id: 'range-test-20260619-3322',
    matching_hash: 'c4d38d05a970b5ee440be6de15b708491a74568e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'b538549ae335412c2e1c2f5943e160e451d29afc',
    id: 'range-test-20260619-3323',
    matching_hash: '2479552166190cdff184f3eaa9a38b572855b333',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '7d1fd084a2cc0aeac09d6361fa8212b5a338ee47',
    id: 'range-test-20260619-3324',
    matching_hash: '416c5e0215bb6053600eca36ea2c742ed4d69492',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: -2.53125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'bca8dfd0c73b2eb313ce4f6c39d3131511ab327d',
    id: 'range-test-20260619-3325',
    matching_hash: 'c00d1d62f0cadc981606ae54df8ffc31951265f9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'fd642c4f52e04565cf7acfc0b9344d728c4a53aa',
    id: 'range-test-20260619-3326',
    matching_hash: '07a195803bf827ed3253ab4d5f2d4206bc853b1d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '0e921f690fe64960c9c8484a4ae01582efc59d0a',
    id: 'range-test-20260619-3327',
    matching_hash: '74898dab5804576807fe6f23d028bd71b4319209',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '0827caee77537ce657fe443f3322077dfae09ed3',
    id: 'range-test-20260619-3328',
    matching_hash: '2f76611969669bfded84e7192b3c61adbbe0b1b5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'f27f566292ce55e79fac928cef48470919bd3a2e',
    id: 'range-test-20260619-3329',
    matching_hash: 'ba42e90f7c737f25481274292eaa01335e4db673',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '6788c26f419390aaebaf67d10586044ce3f11c5b',
    id: 'range-test-20260619-3330',
    matching_hash: '159cce5590fe04c06e59c65e7311e28fb0a28de1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '5cd5b653877e270d0c7a5c3c24df8516fec63bf5',
    id: 'range-test-20260619-3331',
    matching_hash: 'ae8700e9639ca54cffdb4aeb9d9059916c40c167',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '6ca92de148cb887885178a63cead41fa804f5fa8',
    id: 'range-test-20260619-3332',
    matching_hash: '23a4220e673638a069105c0275443840018c294c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.791368192,
    qx: 0.340042148,
    qy: -0.164918777,
    qz: 0.480530456,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '56e3b850b19b1a6200a2550188679d92f5a077f3',
    id: 'range-test-20260619-3333',
    matching_hash: '04dc4be02c2d4453ce5eafd6160a9d05cdaf17fc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'dabd66b67b71eddc4c487fd033fcec58c4ac50aa',
    id: 'range-test-20260619-3334',
    matching_hash: 'a15fd7d00055f753a40f810235a376151449c797',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'a5c75c2e502d57c6cf1e88c6a0e63d77fe926c2d',
    id: 'range-test-20260619-3335',
    matching_hash: '6fc42d0575c42a6ed1247bd337dd6612a6d977a9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '7b15eda53b1a2ef911162ef9c8411babec9d46f9',
    id: 'range-test-20260619-3336',
    matching_hash: '8c85280fb14c285cf833e8c9b9df1b06c6e87dee',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'daba4ca339af323f0f5d446d2e4a4bdfaece03b0',
    id: 'range-test-20260619-3337',
    matching_hash: '33cc4b7621779fb848e937f20432cef6c8f503b0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '07258c662b558a6d09eacfe49158c1260f507d75',
    id: 'range-test-20260619-3338',
    matching_hash: 'ddbc2352f1e6f983db1e861509c295bd62f1bdc8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'f041cfb10e3492deab1ce8903f41eb5d5ba0202b',
    id: 'range-test-20260619-3339',
    matching_hash: '7ae8e347c76bb4b63f935e754ef05602f51c93c1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'd330c8e1786dfd12c3e93537beba455fb785aac8',
    id: 'range-test-20260619-3340',
    matching_hash: '6a918c671e872811545ad82df491bce850869799',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '02b16af4ca12398d2420f825bd565aacd03f0a63',
    id: 'range-test-20260619-3341',
    matching_hash: 'e104bcfeef94a02ddfa0532b0b5df80cd2307641',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '5d57d8a171efd72bdde9d005d0927780cfe2b25e',
    id: 'range-test-20260619-3342',
    matching_hash: '52884e5e71dd14a502d8cdbdb3e39d4c6493b6a1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '16efaafe0f80f4818b9d53086e483416f1c94a18',
    id: 'range-test-20260619-3343',
    matching_hash: '068b948e8fb6ff3462b98200a350b11fa4a81435',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'a5dc3969e2297905e3fed375a9c7b14714b59974',
    id: 'range-test-20260619-3344',
    matching_hash: '765248b1bec94e81f2fa02c81fc2532698b80550',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'edf2d6e7eb8f48b5589f6aa37ae4d0c860ecd3c5',
    id: 'range-test-20260619-3345',
    matching_hash: '99b13f89c74c1bf131c22ca9a9259b7ccdb11d64',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '3c2b721b077575a0416041e3aeaf9474fe703ece',
    id: 'range-test-20260619-3346',
    matching_hash: 'aacc4f0e4ff20e113d7bc74c49fedffe8bcc1eed',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '46617140b65ba32f01d23c3ec4a3f88915430c83',
    id: 'range-test-20260619-3347',
    matching_hash: '99ef69896f6f4f26df4cbcffffa3c0341741a0b3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'bba5c7e19f46387b642e181b1adbe65c157fc24f',
    id: 'range-test-20260619-3348',
    matching_hash: 'b2b368d72ed9ea635c1f67e25f42ae2cf0b0a34d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '87a0be05b219d15f1172ef535bd673ce3b1b7979',
    id: 'range-test-20260619-3349',
    matching_hash: 'd7be638c6f458755f2843652e7cc161afc02f316',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'c7a8401499aeaa1c49a8790dea73cda54153978f',
    id: 'range-test-20260619-3350',
    matching_hash: 'b68d82b385320b4f372b8e077c8194435466e0f0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'a60aa6ed863509bf515251961d69308eeb82dff2',
    id: 'range-test-20260619-3351',
    matching_hash: '7368b54da495e5969d10d70bc39fb4783e6a0f7e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '80528c34929f1fd0f3c8875d5bd0f47b2a4032c1',
    id: 'range-test-20260619-3352',
    matching_hash: '51517bdb2b0a185483082bfb819a676cfe264ddb',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'd17590eb636b2d90d40e9c9e2b5ad36b45fe4de7',
    id: 'range-test-20260619-3353',
    matching_hash: '91b646a1c87ef7bfe6a7e57036dffda9a2b01ff3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '56ee383f88e5e8e4a6475ebb28345ec6d6f7481b',
    id: 'range-test-20260619-3354',
    matching_hash: 'fba8aeed888cc27cffcb2a0507e199d2cac96733',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '9b7a2838101c7eccfde04d5b289a01938851733c',
    id: 'range-test-20260619-3355',
    matching_hash: '7c0260833a4854e39207e303678116804040e968',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'cd7de157a948a2fcb30684992cb2387d08da8555',
    id: 'range-test-20260619-3356',
    matching_hash: '0a52db8f4730f229b8ca34382783f0f5a3a4e479',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'd8aa43a230d98853db34f053070d55199a3501d2',
    id: 'range-test-20260619-3357',
    matching_hash: '0ea7372ea30d9f7ca35e13ec06a900d07a941e8c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'd99fecaf1f5bf3f70c17c08939337da8169e631b',
    id: 'range-test-20260619-3358',
    matching_hash: '43abb296129dde8cfb803c3fa80e3bd3ca7c9aef',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '20485cbd75f30d975d40dfb8bc26a79576543a8c',
    id: 'range-test-20260619-3359',
    matching_hash: '090396c78b36d858b241541210c2de0165434ef7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'c7e998ef8477245377d5c14645d3233794df2d83',
    id: 'range-test-20260619-3360',
    matching_hash: '39c0332dd90e32ba4b5e231c573e8f61dadd2b77',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '9eeeb7043a30a64a8e84f24b7568271be37cf9ec',
    id: 'range-test-20260619-3361',
    matching_hash: 'c56da99d4319d5bf055ffb50b22f25413c9425dc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '57e5b6438281026f6340395d3a16276710b3eb32',
    id: 'range-test-20260619-3362',
    matching_hash: '4ae9ccbb7ba4b357ff5868f06897b775306ff8ee',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'd0117811c64123de309278c992fd7c7572e73a82',
    id: 'range-test-20260619-3363',
    matching_hash: 'b7450154fd775ae9e8b2c286b8c7760d90956e55',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '95c79aed21c992761666f45bc5fee37609bdd1fe',
    id: 'range-test-20260619-3364',
    matching_hash: '151779e2afd249884233230cbaaffde4b5373aac',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'ec446f96c3e02ef439ec26ec10fb6ac3fe102d47',
    id: 'range-test-20260619-3365',
    matching_hash: '0490704d0aa749b1c60aee582d0ec67f20705b3d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'abb739c4e047fa2e8a8fa07b7117718b3be1cfb3',
    id: 'range-test-20260619-3366',
    matching_hash: '90331b2351019d27a10ebfff65233351aa9238af',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '0f3b7de28cfd57bc550ea241b1db651c7e26ba89',
    id: 'range-test-20260619-3367',
    matching_hash: 'c74b408c94826f55ab7c06f344d6ef4cf9a4667f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '4caee2a61898859070ca4192c43237805c3b584a',
    id: 'range-test-20260619-3368',
    matching_hash: '79747fb0e5663ce947c452c51d09ed285e44d14b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'd3b590fb6622bf0133da9ac85460494033cdb7b4',
    id: 'range-test-20260619-3369',
    matching_hash: 'f923a59656cd547611d6ebcbc3db9032ec3593a2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '38b36a144bfea3f8b6b950ee07ca91adc9301ef6',
    id: 'range-test-20260619-3370',
    matching_hash: '4b136764351fc0ed7b71c9b67ded2f75846b9da6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '0d7e7bbc81ca0295331116ec99e0177e46d91f90',
    id: 'range-test-20260619-3371',
    matching_hash: 'f0e5f297b41c43ff04dfc33eac0b88f33e257a4a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '29f0f0bd6123ac3a4b1af076e6f15310e0cff89e',
    id: 'range-test-20260619-3372',
    matching_hash: '61d4289ec5f21c91efe0cbe8a8f2807a5351dd14',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '2ad8b4fe02aa4099d1496e2966e49aee64166435',
    id: 'range-test-20260619-3373',
    matching_hash: 'b5cddfc334beec786d670849108d85f572d6e2f1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '6812b4d259638d7d0115805397c4b08c3b6c383a',
    id: 'range-test-20260619-3374',
    matching_hash: 'c9fda5b237ccf564058a218698d8b4e0adbf20f3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '30736e1612ad54f608de2922fd8463c6588db415',
    id: 'range-test-20260619-3375',
    matching_hash: 'df04a98368a94e320c582d31b3b0b0be78c565db',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'b8738d209205176923eb73f413c0887aeef9daf6',
    id: 'range-test-20260619-3376',
    matching_hash: '383d0be4905faae5367a1ec780e25634e256284d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '55bcbd3baa075287118c83f3a0c4166d45773431',
    id: 'range-test-20260619-3377',
    matching_hash: 'cc4d55ebd5881b4dc6dacab48b47c4daa51d796b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '152eb014f2b0b194334ff5a85d47eec9cf9a3dd6',
    id: 'range-test-20260619-3378',
    matching_hash: 'a13518ce3a90dad31be3986c00fd1d510a0abb95',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'e7da6b55eba896a8c100c8c8715c858a6239b0ea',
    id: 'range-test-20260619-3379',
    matching_hash: '992b656c784e447fcc57d7352ecfc43dac5341f0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '5efb4dc77fabd856c1f0bddb2b6f8e972ec8a0a6',
    id: 'range-test-20260619-3380',
    matching_hash: 'fe12ba6faa8f6345c654d78688ff5074fc4a0cab',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'fc4f51e8aa00e91522a0630aaec32ceee1b96a8b',
    id: 'range-test-20260619-3381',
    matching_hash: '23141c0232fd3965c23fee3bcb9054a08e9ed71f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'c63b6dfc47799bf7aba3cca770492b85a3c10730',
    id: 'range-test-20260619-3382',
    matching_hash: '7271250b9d86e68055b087d1bc101ccc247559ea',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '6063f83f3f4033f20fd73bdcb21057f12ab8d5df',
    id: 'range-test-20260619-3383',
    matching_hash: '88da1c6fb8b9c61c93018925b94951237e9a54ea',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'f00a6e9aced20ddd6a3056743448e5ce64697869',
    id: 'range-test-20260619-3384',
    matching_hash: 'ed84b6372114924e8394371dd769435b8ec784ca',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '009e4d6e8fd14ef23e3c3e7339de61ca6a408188',
    id: 'range-test-20260619-3385',
    matching_hash: '6d80944b039ca3c7b988bafa23927b57f94ce9c7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '45050b488612c79e5fd5c4564c4400e5cf598ed8',
    id: 'range-test-20260619-3386',
    matching_hash: 'fb21088d5f7064460672db7b0fa811b66bb8ac77',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '576b4e2631e45eb6126e65de7590dfe30f7a867c',
    id: 'range-test-20260619-3387',
    matching_hash: '7e3a47bd7af104337156cde91e9ada0030625d0e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '3cb3112a1f806e63881c00c7aaf18b493ec2000b',
    id: 'range-test-20260619-3388',
    matching_hash: 'f0901af727eb6b2f17b210afa608294d8f522aa2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '76dbef5d8ed41be69be7b4b75d999c81c520b682',
    id: 'range-test-20260619-3389',
    matching_hash: '10be45b469913f2543dd53c44d20c38606b149a9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '548f0c32eec8aa10879d57b9da94643d8f464c9c',
    id: 'range-test-20260619-3390',
    matching_hash: '8386a02040a5f0698706cd42e058208e8f95076d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'fcd72f6699b7e72a3f6ec00e2c5b98c4f257dfbd',
    id: 'range-test-20260619-3391',
    matching_hash: '1a91810cd9d39f5fd313354698d7c7ecc31db925',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '3c5e8adf28c4868d994b3fc44cbfbaa377677ba0',
    id: 'range-test-20260619-3392',
    matching_hash: '6ffd88cb692320b7383198103c903fae5ffb6a3b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'ea5a71eea184fd4a5bcd379a1d754d04fd6460c2',
    id: 'range-test-20260619-3393',
    matching_hash: 'fbe61921493f671bac18f3f1bf584a728a20d980',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'd3c0e2877c8976752a517e7d8be8561e07047c22',
    id: 'range-test-20260619-3394',
    matching_hash: 'e8f643dcb74f984be508ec4fb14a161792984e54',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '282205d2033b9fbcb7fd7466e2cca7341328aff6',
    id: 'range-test-20260619-3395',
    matching_hash: 'df60be79c4b9b35add7009a60526b8efe2875293',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'df2f2a4b7131349471fb4ebed17a4b8593a7d1f3',
    id: 'range-test-20260619-3396',
    matching_hash: 'bbcfd8e0574ef8bc193b6808dfdfc4679a1d0c4a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'b3a6b63cb9895e4d081a709777d3291c3dade816',
    id: 'range-test-20260619-3397',
    matching_hash: '920c8afe88c407696243d2439d4e88e8a80bc55f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'df52c0bef4dfe2d1332058c914079198ed9e7008',
    id: 'range-test-20260619-3398',
    matching_hash: 'c72fb6cb4849debd5dc80c37d2dabb5ec9307bbb',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '77e16a6002e8c328c102e3a2a1b039d82ea271db',
    id: 'range-test-20260619-3399',
    matching_hash: 'dd916672ff1af12c4926e56609e60f49f7539f47',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '8588753ab035be643882aeaad225bfdc77a55815',
    id: 'range-test-20260619-3400',
    matching_hash: 'efb6babfe140273e77baae01aef11c2e3124a76d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '80d1e29bec94c426ea04cec99cd0b5ed9944f1ba',
    id: 'range-test-20260619-3401',
    matching_hash: 'd1a319702fea332e3f6d798daffe1d8986a0d95f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'fdf8b582d5801a26ceda6915825ce1abecfda8c4',
    id: 'range-test-20260619-3402',
    matching_hash: 'c5d12ffc0f64093cf68fc525b9def4b4ed388b61',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '39a5c7eb428338b7bc7f74b799d26f4a39e33423',
    id: 'range-test-20260619-3403',
    matching_hash: '7f2af712be91d7db926b6b129f9a53d814ed30de',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'f8087ab142ca26434e4c16a4ec1e5aae76d4201a',
    id: 'range-test-20260619-3404',
    matching_hash: '2868821701fba4f467a4f322b4900d1cb932c1a0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'e19700eb7f412b5ed2063b6a70b399da3b8df11a',
    id: 'range-test-20260619-3405',
    matching_hash: '3adb8633dc0f861148f6abffdad8788fad451c1f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'a842d3191a3f4465aea3e2486cce053f2733ce57',
    id: 'range-test-20260619-3406',
    matching_hash: 'a69d8ac929347cedbcc674e51a4e07b16894c0c1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '5de84a12be1c56025ec333138147acfa8362d44d',
    id: 'range-test-20260619-3407',
    matching_hash: '6872d0e41f7eab22e8127ae83c05c0dcb8eef362',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '066d477284a158419f9db92f37eaf9e57bfd69b9',
    id: 'range-test-20260619-3408',
    matching_hash: 'e2bdc1c76f6ecb09da870e5250abf88a40cf16d3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'adfe902a2785f2e84f427ad2fad3e61acefc3bac',
    id: 'range-test-20260619-3409',
    matching_hash: 'a2ecd4482cfc75bbeee36c769e16c9be81bd0698',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '641e3c6c2df20e1b7999a8f1db24f505fb380fff',
    id: 'range-test-20260619-3410',
    matching_hash: 'f42409d32a6c8ef2e65fb9710919f5b61c6ae34a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'a3f17eea35bf91ec5e521e11f172d2d38f841773',
    id: 'range-test-20260619-3411',
    matching_hash: 'ad7ad23efa21c11ee23b6dc6c38828a5e733ff0a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '05277eda383cbb8155c7f4d7021763ce08686cfc',
    id: 'range-test-20260619-3412',
    matching_hash: '6318eecda7fa9c51bb3f039f6ec7efb8beef680e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'd74a6172c091b01ae76f42badbcbb188e43c1900',
    id: 'range-test-20260619-3413',
    matching_hash: 'c2d31d339e7a44fe2b684c3807f0a929bce8926e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '01f8c6bd7dc47f28d1afe45f93094bcff8d0e503',
    id: 'range-test-20260619-3414',
    matching_hash: '34b5e000e4d151567e3044979647491e6f9c70d7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '0c09d6e8d1c4407a259977fad7c81905c393c9c5',
    id: 'range-test-20260619-3415',
    matching_hash: '89ae1383ea710c3a0b0e3334996956f8e83b6e84',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'd13261466073fac6286f52f37a147508e74abec1',
    id: 'range-test-20260619-3416',
    matching_hash: '127a74014d1eb700daee2e3c2fc9a4e9c9baaac6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '0c37b32a9befece9c3120fcb95cc0cf8aebc4331',
    id: 'range-test-20260619-3417',
    matching_hash: '9c47e9c679f6d887760e9bfb189fd57b69d44afe',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'dc256915abdeca91d41b2b9a8bd8b8898d9a174a',
    id: 'range-test-20260619-3418',
    matching_hash: '151d59633fe117701624a65675e27e5f545aeeb1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'acf0c0b9794ebfd11acb0ad202814c0bd88e2127',
    id: 'range-test-20260619-3419',
    matching_hash: '2935428495156064a6bddc7aa9e5e7beedc42eb2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'c102873f50602e4cc9b134d40b39cf52033fe7e2',
    id: 'range-test-20260619-3420',
    matching_hash: '266df9bc1a83906158e51da0960f2829fb55ed18',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '78b04050942dd9e329a1b26e0e636d56c4d81727',
    id: 'range-test-20260619-3421',
    matching_hash: '176533e3a7ead48d3d6b4ce8149ce2270b53ab76',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'c589e74088181824a059605ed2f4ce9f6fd21719',
    id: 'range-test-20260619-3422',
    matching_hash: 'ee437e9c75934b8287979f750b04c9eb34686fbc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '20921ce39b967dfbe21cf5bae5fa8b3100e876ea',
    id: 'range-test-20260619-3423',
    matching_hash: '551ce499dd70737f7f1d9317bfda03ea4cb5290d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '4d023359966e3bdd4d8225105c04894497c57576',
    id: 'range-test-20260619-3424',
    matching_hash: '8beb0285583b9420465b23d3a6c0ad340d2237cf',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'd9130c6f1176940127beb590bcba0d275c26b097',
    id: 'range-test-20260619-3425',
    matching_hash: '112bc182b9732c38caf273a3fe586f32ffcba283',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '4331b55c2f67123b2d6161c34da411967e7b3aac',
    id: 'range-test-20260619-3426',
    matching_hash: '1d752397ab4748a7546326f4f38b9956c129cbab',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'b1d8e7fd020bf062a7c52d655e0656369f539abf',
    id: 'range-test-20260619-3427',
    matching_hash: '1228cc4b3d41316002b310cf8d864c2efd0f60aa',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '488afae3adc806247165acb24c38055c3d9fd772',
    id: 'range-test-20260619-3428',
    matching_hash: '4236106b996708de43c64b70ad040b444620a912',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '5719ac2be46427f5603a1fe6ed414f26be000822',
    id: 'range-test-20260619-3429',
    matching_hash: '635b40edf999f74b4c06e5c36da5ecb0bd950b8f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '4b0e18ab2081910e0170e9f037f15bb1f2d70c0a',
    id: 'range-test-20260619-3430',
    matching_hash: '88d5884d1b0817138e14ad8eaac1b6e4d59f50de',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'b5426275dfa5a8aa083ec6f07b8abeb8a34cdeff',
    id: 'range-test-20260619-3431',
    matching_hash: '423ffd8e02454511d59ce7479d4b2e8bd482c759',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '87473e40ca0cd1709f946950551f6d4816526375',
    id: 'range-test-20260619-3432',
    matching_hash: '750a895839cb2166616073b69d9d10aec1bde93f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'f5d79753283c7042ec52ef1db52e05ad499020d4',
    id: 'range-test-20260619-3433',
    matching_hash: '2bf192c68f4aa7f38ba940fd0e04c5f61ea901ec',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.691038365,
    qx: 0.561855734,
    qy: 0.004934358,
    qz: 0.45470844,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'd527230a958fc815ffe4d247dbae5eca06a57ba0',
    id: 'range-test-20260619-3434',
    matching_hash: 'ebb5d7ddcd2bcf7a636096a11ef5c6a2080aa44f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '949ad9032bad82745ee8e6d1c1d75fde3c9d6c74',
    id: 'range-test-20260619-3435',
    matching_hash: 'ba5cd368c6b1c95c5320e463612d7daae2ea1bc0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'f339cef905506971a199e1de1457773391dd66cd',
    id: 'range-test-20260619-3436',
    matching_hash: 'adae62def9eeca2eb72f2c049a4cebb20a558421',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '68ddb0322ceb62f16389ef998b928242631279a6',
    id: 'range-test-20260619-3437',
    matching_hash: '4dfb556caabb835bbe6cd89d8b204990be19d078',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '149337f5dad4d313d7ec22fbe055afedaac45348',
    id: 'range-test-20260619-3438',
    matching_hash: 'f33a5e7e56c6e4bb80d9d2d8dbee19c8eec43a5c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '3d8f2aadb9d987cc73a0ce2f83beb75f021a0291',
    id: 'range-test-20260619-3439',
    matching_hash: '1ddcfb527b8f288092c0dcbaf06d6cabb8e195cb',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '36dcca238a357db82b19375cea1ff7d90bb18c5e',
    id: 'range-test-20260619-3440',
    matching_hash: 'fa8795d298a2d2a0e71b8d404f40b85d9ebb7828',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'fb87cb0f402709304d25409cd76496c5d4df36c6',
    id: 'range-test-20260619-3441',
    matching_hash: '4602e5a97d8e8d0572f9c5fafbd461bb3ae7f4d9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'f1918445b92a76d7db99e0c03e3f2a1a080fe7e2',
    id: 'range-test-20260619-3442',
    matching_hash: '410c082104356f5f50d49c27a52be1a7115b38ee',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'fe5b7dd3da93e2fb5c39f65716fafe72e970171b',
    id: 'range-test-20260619-3443',
    matching_hash: '6951e91c3ea4ac348f67369494035f986c7d53fa',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '6946bb29d4ebe407752382ea04d72b96177875ca',
    id: 'range-test-20260619-3444',
    matching_hash: '470a755e5b44286d50be519eda4717c062a4c5b6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '7604a58b883ff8f623235d7cdd7afb4faf1a8a9c',
    id: 'range-test-20260619-3445',
    matching_hash: 'd694e012b6afc97c2fa8c824b053a93ea14a6625',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '8f6762207ba2d54a5770a6f48b7ed07eec056b31',
    id: 'range-test-20260619-3446',
    matching_hash: 'f76fd4cc76a45bdb88d6cc2767f6fda437ef6332',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'a9ee83ae0f832219b4f0847f0f22143743074478',
    id: 'range-test-20260619-3447',
    matching_hash: 'b77d448c45c5c17921fbcfd6c668380e9afe5db7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '08550cdc732fb8935f7bd41f70042750cb0afb9e',
    id: 'range-test-20260619-3448',
    matching_hash: '3930cb8777085006230e39d65e229ffad7c99f81',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '2a2125b495b7c9be9584b35c17606c5cbc981dee',
    id: 'range-test-20260619-3449',
    matching_hash: 'c0e3fa9e7be3a7ebda4c18c8199b40dc3053b5ee',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '828f5df8e2075caeda09173648cc18e061239a14',
    id: 'range-test-20260619-3450',
    matching_hash: '7fbdb342dba5b9c37a726cdb41693d4beb2c0765',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '277455a6b8e17c3e36682156f3462896976641a7',
    id: 'range-test-20260619-3451',
    matching_hash: 'ede492c114e8f7934ad760d665d9170f3312abf6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '672c17754e75b2cca36c2f361ca208b90df7f89e',
    id: 'range-test-20260619-3452',
    matching_hash: '19e9b924cd0ec5460042daa5a9e126acbefaf61d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '8b5ad153159beaec269a5a66aa8c4e171d2ea741',
    id: 'range-test-20260619-3453',
    matching_hash: '14b5f9ad56b0f7e77de73154e4955663f1846f52',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'e5e0562bca113df772b936e709965b0416880854',
    id: 'range-test-20260619-3454',
    matching_hash: '523ecc4e130e031f15dc1b490ed0deadf662bf54',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '9cc34ad514f0913c9e772faaf7c7c0e2fd380203',
    id: 'range-test-20260619-3455',
    matching_hash: '3afa522a81709965355226be29ff2615e2699e04',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '867c577a97ad75683201f341b6b2d060ada33904',
    id: 'range-test-20260619-3456',
    matching_hash: 'b1aa94799218fb0c7087181218dda9a965419319',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '1045de527c69c359cdcc1734b0c9e9e26a5e727d',
    id: 'range-test-20260619-3457',
    matching_hash: '8cc590dfca4d0dc7f1427cd9aa1865dd667d9d0f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'd3f7cee09cddeddd1a296aa2234ffc8e7e334390',
    id: 'range-test-20260619-3458',
    matching_hash: '2e9df9421d6f37804d43006cada157ecbde9d44e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '8687209baa75c39cf51dd4108d463b28d49c9e10',
    id: 'range-test-20260619-3459',
    matching_hash: 'e9df29bc41b79219c9dd911aa5a15b93573c2031',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'b699dcfff71b693aec8b2d16659e0b1373262499',
    id: 'range-test-20260619-3460',
    matching_hash: 'c74f2b45dbb410a033cda2da562dcafcf8a2533f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '142818bb776106dbb9705d693730d69e24f4666b',
    id: 'range-test-20260619-3461',
    matching_hash: '2b64fa759ec00872e26a98bd5595fa9430f0ab39',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '3e5d181894267c9cf9f463793361e2a4752f7fbc',
    id: 'range-test-20260619-3462',
    matching_hash: 'dec66c94e7857e612d2e8baa9aee8b7fcd8c2841',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '7de055810c369629810ce619f2275a00aac237fe',
    id: 'range-test-20260619-3463',
    matching_hash: '2f361720af86ae43f905c343583c7ecd78f52c33',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '89d008616a472c14a464c6593e2d469d0d2c9519',
    id: 'range-test-20260619-3464',
    matching_hash: 'f02ac56ee76470759e72faddfeba3cf9633ead34',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '95a3a026843f021b8076d4c68c5dc820ac17589d',
    id: 'range-test-20260619-3465',
    matching_hash: 'c95bbdc1a45694bce9ad425adbd482a230111a65',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '0e108db89d3906ac8218bbf191dbca92997f0195',
    id: 'range-test-20260619-3466',
    matching_hash: '01f4818b9fb6cd429408e95decbfc7f7e60b51d5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '82088d7007a759d59bea99a510d9987da3caf2a5',
    id: 'range-test-20260619-3467',
    matching_hash: '789499bba45c0821669b09306e887a6fda5f9e44',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '354e68b59885d51421e97c16a60134d2b9762249',
    id: 'range-test-20260619-3468',
    matching_hash: '9e1105718360c4de7348f7bc54e50ce912a19532',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'c0563771a6b6b912556d5abaab0c0e4d651fdab2',
    id: 'range-test-20260619-3469',
    matching_hash: '8e6374362425b3b90d2851f00767612b1cc8d949',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'dbd32b1039b027a00bdd1bdb2433fa4fcefbaa36',
    id: 'range-test-20260619-3470',
    matching_hash: 'b172fd48e3a64ab16e71e57db00a9be41c9dda40',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'c28d9bf4cd4fd45e1a236951962a8d1917d3914b',
    id: 'range-test-20260619-3471',
    matching_hash: '15f6a567e04203414937996482bfb3b984d1a3b6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '775e02ff2cef64a094bae067396223843b632529',
    id: 'range-test-20260619-3472',
    matching_hash: 'bb832930895fd766ec1e5b1221ced4c96b9a219d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'd0634b2b31f852855908ebe3ca46473cdf6d4031',
    id: 'range-test-20260619-3473',
    matching_hash: 'b02f3eb9c1080e57bf23abd9d946cac522892924',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'c6ab8b9df3db2151ae5679ff59eb58f080303b0d',
    id: 'range-test-20260619-3474',
    matching_hash: 'e643617dd9e0980b04b5e6b99ede31c56f5fcdb6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '2eff65c74140cd089987b9fe29c4d36127e5a0ee',
    id: 'range-test-20260619-3475',
    matching_hash: 'c4918cc10836d76ae795cf055cdf2de4f701ad50',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '0aaba9cb5024385748c18cebfb91600b5715b467',
    id: 'range-test-20260619-3476',
    matching_hash: '5e1524725b7151f60375519602706c56d945f031',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '9972f125684cf615000ba94854b8141b78db9bcd',
    id: 'range-test-20260619-3477',
    matching_hash: 'e17b05fcfa03158b2b5de2b06eb0b75348760b27',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '8f296e1a357995a21afdd5c745cdc5917c3aa7b5',
    id: 'range-test-20260619-3478',
    matching_hash: '120f93e4ce007d4c1f65120f59b0fb8d0daee277',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '847404727de210c57cb7065f7f1e25d5d6131998',
    id: 'range-test-20260619-3479',
    matching_hash: '29fee821db16503ea4807d95f80fdb172c9a2d4c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'db763d86ff7636208c865cba309a1b3bc5a18ce6',
    id: 'range-test-20260619-3480',
    matching_hash: '7e0ee2a65a538905e554d1f5306823fe008edec5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '1b859e199c9530f9cc556a9ba43567c7a5c568af',
    id: 'range-test-20260619-3481',
    matching_hash: 'a03a5c6bbc4c10f2858eb699138a2a8ce005e1cd',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '96db87e728fac286e8b8641341cb0738f5e5db1e',
    id: 'range-test-20260619-3482',
    matching_hash: '0438401d3fbee14c0a301300a62c0b60f909f85a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'c4443e9d5023f514981ee94aa7777779b063d33d',
    id: 'range-test-20260619-3483',
    matching_hash: 'b6d724daccfb13bc582fb44f21cfbabdbe549e13',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'f4333335366610515f4efdf5df09c5d10cef4269',
    id: 'range-test-20260619-3484',
    matching_hash: 'a099639e3efb293b72a2c4aab9392d458555f915',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'aa616ba76aebd012e699b6e106f80c6faeb41014',
    id: 'range-test-20260619-3485',
    matching_hash: '9687abd77c6fc4e6e11a258b53506ea50e9faa84',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'b4d78a6e166a69f5b9bec97d7eff3e6d716748dd',
    id: 'range-test-20260619-3486',
    matching_hash: '15747efa3698087983e079377b9b30e07d56c8c1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '02a3f83a42594a5bdd01bb6dc806c0d96f2d27be',
    id: 'range-test-20260619-3487',
    matching_hash: '080d8fef8699811652b981745c7831bbcc1711d5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '1138772cc5e9a328d2e67981313a21cc3c4755aa',
    id: 'range-test-20260619-3488',
    matching_hash: '68a3cb4c0575122d5f8f38a5c8f4431906b9dac5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'feebd87fc5b9f0b8d7ceba1d0d5802c6dedb69d3',
    id: 'range-test-20260619-3489',
    matching_hash: '9bccd058bcfb8949cb252c06182b0cda0e81816d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'ff782e91bc77e194f46166e6e209578e6980488b',
    id: 'range-test-20260619-3490',
    matching_hash: '1fa492dbbc1963e292550056e63ee4c86ec29b17',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'b7a1318d3e00aa1d6c8ab1e0379d67d4907196ba',
    id: 'range-test-20260619-3491',
    matching_hash: '88c58ab7ab32628c49004db1bd76d029446b883d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '46f13ff76de8fa553002e18a70cbfc4e994a7136',
    id: 'range-test-20260619-3492',
    matching_hash: '357ee2d23923bb63a2de8cf75cca2a4240fe8977',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '8f751ead13c4634d6574717c436c772fcb406b59',
    id: 'range-test-20260619-3493',
    matching_hash: 'e923498b54230138566a82254679413ffe1be944',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '44f4f74658575e807b77b7ae592e815453887d0f',
    id: 'range-test-20260619-3494',
    matching_hash: '1b26dfe617800dcf38d0348f2fd77fc974cf1b13',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '1c0caa98306e6951b3cad6a4c9221594396af57c',
    id: 'range-test-20260619-3495',
    matching_hash: 'f5fd3cf12a94ae14599729fbf25b8dd4d0488b47',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'c20ac0ba862c4900fc2c43c11972068bebc7b4eb',
    id: 'range-test-20260619-3496',
    matching_hash: '7bbfb2e73796d7a90897e79cd95cde3fcdd137d5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '0b1c879e7dc907b15ba25323882ffe0d7987a52a',
    id: 'range-test-20260619-3497',
    matching_hash: '3f09f65ce8a818df8d850778e993a749df94c25c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '71bd9c8b34e9f4dcd69bd768224b69fba4bdd577',
    id: 'range-test-20260619-3498',
    matching_hash: 'aaf75780a2a0bd72bb094359b00acf78cf670b6e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'f90d6c7d9405b5c5a256a2c68f84fa6d2815d7a6',
    id: 'range-test-20260619-3499',
    matching_hash: '4b5a89ea58ce60dfd9688ca6a496216df044d443',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'cbf72d3efb3ad47ce8f92bd3bf9b9c9aa308f55b',
    id: 'range-test-20260619-3500',
    matching_hash: 'f2a5aaad960692b93a7e93fca19e79c456bfe586',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'c1dec63b4ee3af093b2529f187238467a469d36d',
    id: 'range-test-20260619-3501',
    matching_hash: '5c7fc1db30963e5daf1a6a0b60b821190577b758',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '95667b430ac06b15aa3a88ac16d2e0f93f0c3587',
    id: 'range-test-20260619-3502',
    matching_hash: '9bd5bb470aba66516699a7456d7102b1aa03cc75',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '08943cbd89d4def7becabd96641080f27635a22d',
    id: 'range-test-20260619-3503',
    matching_hash: 'fa4e164aed5576e1d5f63efcd116c8a5fadba0b3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '14488261a876ce532651b564fa76c85ddcaed209',
    id: 'range-test-20260619-3504',
    matching_hash: '6080aa4c48890175fa2143d4c457cbe632d100f6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '47c81711780c55c99822d8eadef954a971b977f6',
    id: 'range-test-20260619-3505',
    matching_hash: 'c5f64fb6747fb478b737344e5dba429ef7ce57be',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'b8d071e3a74b4e47bd714db1277fef684c3f78e2',
    id: 'range-test-20260619-3506',
    matching_hash: '90f278017bd312921f7798f78a2f3e8c33de987c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '6d01c0b9856526d25099ff7f79cbe44a60a5d1e9',
    id: 'range-test-20260619-3507',
    matching_hash: 'a9bb244830235594f5de037c5a3904fcbc9f4e13',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '82dec4f16639f0f687a6c4c5ada375cb499d42f4',
    id: 'range-test-20260619-3508',
    matching_hash: '59b8c53f50d915e6141cd21d710f2b725e0633ab',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '6731ed663188d2db7aae821fdedef172cf3cb326',
    id: 'range-test-20260619-3509',
    matching_hash: '86fa8662872d893861e3d0475804a0b99ba60819',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'fb74127bad3fbf574ad84db87bc4983389be4a87',
    id: 'range-test-20260619-3510',
    matching_hash: 'acddbebc42ab287d88fd261f9bfd158a1780cb35',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '33f67fc163ff911e44fd85c5bb98fc3179a782b4',
    id: 'range-test-20260619-3511',
    matching_hash: '580e2d2b150ffd1a64fb7fb636a188daba00e017',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '1ce9309aaec3e91f459976a7d6bcb9f34a5735d1',
    id: 'range-test-20260619-3512',
    matching_hash: 'b77c16904d76f8c0cc6f98abef4c4e809220f4e7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'ed0e62ae9e023a05ec7f2162fd838d7dfdd221a4',
    id: 'range-test-20260619-3513',
    matching_hash: '6047a4ded2cd0d1b7cd02a6baa8634a32403871e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '1f3bf954c3ec9da6c30d4aa7dd5ee075df1bdf42',
    id: 'range-test-20260619-3514',
    matching_hash: '0ba47b38c55529d39145159b5d7dc2a54af68891',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '52d487c7ab5f13e16902cb8ef9d4db504895782b',
    id: 'range-test-20260619-3515',
    matching_hash: '6a1ee074376cc68e49a0c64ba6a758f5243ce3b7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'f1cb3e9e676e44056c7bd8d503e41b48ba2512e8',
    id: 'range-test-20260619-3516',
    matching_hash: '36aafa8e0ac0dd179bcc9ae657d1bf7c2365fb8b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '406a4b1f8195aea92b696b69f6c02d5875e9942d',
    id: 'range-test-20260619-3517',
    matching_hash: '5fa05b7eb5170c9df54fca45f00093512f1b224b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'b74f6cba6039aa8c6e7ac039ee02120c5908e1f5',
    id: 'range-test-20260619-3518',
    matching_hash: 'd0c8b3dd38a110fe1cbaef410eb02220c37cb886',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'e53395cea2914382bd2079bc185b0e7a48249964',
    id: 'range-test-20260619-3519',
    matching_hash: '53d3063b6bdd22dcef1ed5544a6dfb2027f751e3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'b06e571e5bd10fedef7acf1a9c89397a165b0811',
    id: 'range-test-20260619-3520',
    matching_hash: 'f7424e9474004cd5470c959364c42816c7638e4c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '84e600ee041aeeb517c76a31204d4b557b76fa09',
    id: 'range-test-20260619-3521',
    matching_hash: '91ff483744604f424bdb69e7d42d2dffd2aa048a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '5009e63bfc7a0771c4a6e48fad04516e745c5fab',
    id: 'range-test-20260619-3522',
    matching_hash: 'da8eef2c288c13a1250cc07e2648c58b79eeb996',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'f0794ddfdfb98201e85e4065bcf8dfe9f27bad1b',
    id: 'range-test-20260619-3523',
    matching_hash: '60e172a66647774396b88b5ff1a0994eb6eb02a2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'bc73490c25493158edfcd667d94e8b05eefb10eb',
    id: 'range-test-20260619-3524',
    matching_hash: 'dce1dff28396be92034ea9314d1df4fe23e17188',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '45ea0750a2c5c9f73251166787d426e415d43d35',
    id: 'range-test-20260619-3525',
    matching_hash: 'c167c5a7f9255adac8ca60dbad7f0e7d122a7ee2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '705ed236612e3c27273e539a19f54c083a8d0acb',
    id: 'range-test-20260619-3526',
    matching_hash: '6bb9183d3bbbc8f10706039bb37eac6819da7fa1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '1ff922087de9e16dd52989578db9a770bb0c4686',
    id: 'range-test-20260619-3527',
    matching_hash: 'a993f93489b5ceb7469713cc40681257c910478d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '619a48e30d6e2a96814e6d4d19d37df7c348ede4',
    id: 'range-test-20260619-3528',
    matching_hash: '165d1e10205af854584e31d1f94334ba1e9be439',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '32095e256996f6f4ccbb30e4f87e1e8d7fd91de6',
    id: 'range-test-20260619-3529',
    matching_hash: '2f727bd0560d7539770060dcec20ed613b09de93',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'e94493e149f85758d96610b6516f2810b9a3e791',
    id: 'range-test-20260619-3530',
    matching_hash: 'e9c443619a04025698a37809b3c8d84e6ca18ab6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'd866b1bb162f5757ec0210804d9a1944ec03d05e',
    id: 'range-test-20260619-3531',
    matching_hash: '983876fa0208a0a46e14d889d78a18f68017f85b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '247633ef5fed39af5248066337a3a5b522f2ab16',
    id: 'range-test-20260619-3532',
    matching_hash: 'fdfabaa72a6dd22884f197fb874baaed4eee2f93',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'e455b0af58684fdd826f3bbf368b3d53cd09c95d',
    id: 'range-test-20260619-3533',
    matching_hash: '81ed20cf1f450464ef89928ef3bdb88ad72d624a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '7cff073cc50d19aa214e079ca9973b8433318f85',
    id: 'range-test-20260619-3534',
    matching_hash: 'b2326efaf88a21c3ccbae35c974060ea057283c9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.978126785,
    qx: 0.01345307,
    qy: 0.031185334,
    qz: -0.205218134,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'b2d7a37f8ed361d106ec5ff6d4e2c5110a6f3b75',
    id: 'range-test-20260619-3535',
    matching_hash: '13afb72952f9437cfbbd27663f1e586746036dfe',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'c5c7e9e8b2c3b3af406b0048d92f990acd0a9183',
    id: 'range-test-20260619-3536',
    matching_hash: '7a4e29738087c18c7bcdae6ecc9ccc26d2a5fed5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'c37b54de6e42bb278ffae12e98a99a0da9280ca1',
    id: 'range-test-20260619-3537',
    matching_hash: '3a6d8c30db2a6a32396e29fe9a08bc85e0ce37bc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'a47d5af7da428f86cbc437ade876dacfdd7f40d0',
    id: 'range-test-20260619-3538',
    matching_hash: 'f83b322f3d0598d6d2c271e3e85b769cdd0d46ef',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'ae12e9de9b789535fe0c092da290363f1a37dca7',
    id: 'range-test-20260619-3539',
    matching_hash: '86f3b30be7e2ed09d61a7ed4dafe4848d29b5c8e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '0eb865b53d5b1eb6b4864eb3b799e1430c4a1d42',
    id: 'range-test-20260619-3540',
    matching_hash: '80227d580444042cea46cb3a6155e12c08945e81',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '8abbac0b60a3ee226da4757f9230822905ad7fc6',
    id: 'range-test-20260619-3541',
    matching_hash: '94abe5a2dd7eb8d545f289ebae2a625c9847bff8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'c5e9fcd23cd2a8dfdc4eb8403053d7c116d48cca',
    id: 'range-test-20260619-3542',
    matching_hash: '6bdf1856085a4049e48c3915ce096c7c2acab609',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '1705fb8955f917f057a0cde942e15477fddbf483',
    id: 'range-test-20260619-3543',
    matching_hash: 'eb64e95fe7ef0954e6528890805f92bfaa02f79f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '7a79952bc69b945dcf495d5f6a1122e18050f02d',
    id: 'range-test-20260619-3544',
    matching_hash: '8485daf6477833b6ce1bdb6b3d757b9a6db27db7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'b659d1b5f0a0b63e52c9c9419084ad64ba062ff1',
    id: 'range-test-20260619-3545',
    matching_hash: 'd65edb33d45b4a24a29c2c746c3d130f595e85b9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'd1fe96193af57445004f5b64c4506a71a882eb95',
    id: 'range-test-20260619-3546',
    matching_hash: '6be883e67df6f63f3fa75d362c69722ad0695406',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '65db8510f5d2e148f3448182a963e06aee5cb8ad',
    id: 'range-test-20260619-3547',
    matching_hash: '27db6c72f62c797cb7a0d90323cdcabe5e438ea7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '25e21d88d350a260eaafcfab1ecdaa2b44e41183',
    id: 'range-test-20260619-3548',
    matching_hash: '599afceb9b214dbcd71ad534fdfa7fe1baff6cd6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'c8a2827b80eb23497720fbfb309a89c820b1aeb2',
    id: 'range-test-20260619-3549',
    matching_hash: '7813429cb346c09eed810cddb7e671cac944f230',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '7d53fce38a21c8246d3ef13145ed187f59d0703d',
    id: 'range-test-20260619-3550',
    matching_hash: 'b0cc3c488689a250144fa892a6553c72d88c80a8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'fcf91b5ec64ab98fc1527da3655a87ccf5407226',
    id: 'range-test-20260619-3551',
    matching_hash: 'a3c54e598302fce1863b193521dc4f7a9f158220',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '5a44f3a001fefb1e28ac2c44a28b6d0e9397a9d2',
    id: 'range-test-20260619-3552',
    matching_hash: 'fe110edfc77fa5b0812f314ca1f0ba1b44e2e980',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '87dfa21c4632f91e42c00e2324e116ecea97e36f',
    id: 'range-test-20260619-3553',
    matching_hash: '23c8623dcc1f2ee3f7a48ae49ac583de7def604e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'a89546159362c5382b2323c29974cd9c71c49985',
    id: 'range-test-20260619-3554',
    matching_hash: '859c06391ab4022fd54aa0117fb672e4191cb43c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '549ed09ca9a656b467c0984b4c795f9ab6f6330f',
    id: 'range-test-20260619-3555',
    matching_hash: '6a721979577e6f5a9ff1f86d12b9935cf07115ad',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '0e69f2ce90bb66fa4845f4de63d1fb3fc4043889',
    id: 'range-test-20260619-3556',
    matching_hash: 'c8eef5dafbe4703a6361a2b1506f5ba3d7672289',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '1b3ec80ef05492b8b527c74940521e76c3fec23c',
    id: 'range-test-20260619-3557',
    matching_hash: '764e4c5b59ea8e4f50d12c4eb7b24244404d388c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'b02b25c84a8f2f2f297f0c44cab36e9dad84adf7',
    id: 'range-test-20260619-3558',
    matching_hash: 'a8c0ab97f0129cea562bdc50ed18ed35af396534',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '066ef48a01768149cceed00ed53a5cff20986617',
    id: 'range-test-20260619-3559',
    matching_hash: 'a30c94d9210cc363978f36c6eb6cc1e2c4a346d5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '2be234e1c50d0f956567b5193ef82fdcffd55000',
    id: 'range-test-20260619-3560',
    matching_hash: '0128f435cf3156a92035a03014a362fb40478f65',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '47f5517392f0814912d80a1b8daede9ed865c320',
    id: 'range-test-20260619-3561',
    matching_hash: 'e98b4ed50565648f57a01c1859199b83c0590b16',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'fbfcd296d52d3b751b900f9e0b002b0e6f06c6d2',
    id: 'range-test-20260619-3562',
    matching_hash: 'de24b73dd58275dd42dd12d675999c17bbfee945',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '6b8e9577653d8ed3d389e3d7a14dd3f65b353020',
    id: 'range-test-20260619-3563',
    matching_hash: '90562e775f6837e6ecaacb950cd155674424ef8c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -4.25,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'fa6e27d2a76ba77d47f248effed979bc354046f5',
    id: 'range-test-20260619-3564',
    matching_hash: '7e42b157854c78fe19953efb2659d30aa59ec2fa',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -4.25,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'a542cc4fb277eb26250f2bfab0d0235971b5b725',
    id: 'range-test-20260619-3565',
    matching_hash: 'bb69cede61a1e22a65127eece4c5998c8fbb923d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -4.25,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'd97ccccef27042688f230ef0a7fb1cd1eb9c81cd',
    id: 'range-test-20260619-3566',
    matching_hash: '0e37149dd47a2dda64191500f61d5a1a749dc583',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -4.25,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '752d87dc0406cd8ab3f28e90fdf74442a3e2075a',
    id: 'range-test-20260619-3567',
    matching_hash: '2fe3683917f175de0264383c8383c357f596a9ea',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -4.25,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '580d57ac4c885df6c18a216305cbd8843509f8c4',
    id: 'range-test-20260619-3568',
    matching_hash: 'f484b812623d8f0cb7cc15bd0b169ee3129624ca',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -4.25,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '16a52ce12c3ea10fd0b4bf56efbba9a7a1277030',
    id: 'range-test-20260619-3569',
    matching_hash: '1fcfc5e9972319100ef6da5c4e024e6d9ad6a7e9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -4.25,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '1c0752b6ffd71dca397e15316ea49d7103b4330d',
    id: 'range-test-20260619-3570',
    matching_hash: '0a812051c5846ed795c771e6d37176949cef32a7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '1b421df80c112446acc5dfa6c39db4cd335f955b',
    id: 'range-test-20260619-3571',
    matching_hash: '8f2d3ba9edb05328b81a0203a38adc3def4dc440',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'af816607723d1e2dbab064e7fd10efb8a964473e',
    id: 'range-test-20260619-3572',
    matching_hash: '20b1fb61e0f837c41ec7a04d4cdb8a39593560f7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'acdb00c945d6a8cf3dd2feffe807780f5809f244',
    id: 'range-test-20260619-3573',
    matching_hash: '331305817e05427361f1c92c7b18556d84aeb8a3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'e0161ff9ffe244340ae5e178bd3fd036cf8a0c20',
    id: 'range-test-20260619-3574',
    matching_hash: 'b401676a43f9e0de719ecf053520281bbcb9747a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'b862724c40c13075db5670bca5c93a0bd4dd874d',
    id: 'range-test-20260619-3575',
    matching_hash: 'e928996e6317443052aeb0168f5461326b1c1d9a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '17fb4864400af0a95c4daedbf9b80e3ef4bdca3a',
    id: 'range-test-20260619-3576',
    matching_hash: '6d585f5c441a4bb77dfdc98ec970daefd2ee374a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '65380614cbe15d1ad10cf76abc90b1902d97d04b',
    id: 'range-test-20260619-3577',
    matching_hash: 'ff48ad0cfde46282d0d3fb696470593eb13e2b2b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'd4a85feb76a87c3939f87399a68eaf5cf0579641',
    id: 'range-test-20260619-3578',
    matching_hash: 'fe01ae9e13b5898eb2eb7ba8d06340f66576f2bb',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '95f4575cc5e8e89fafe0925a2f1dec84ec44d9b2',
    id: 'range-test-20260619-3579',
    matching_hash: '22159964f58f6afb0b992a775e1d75b160963df0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '0b76632373d09aec7ad1a5fc7228961626d1a4c4',
    id: 'range-test-20260619-3580',
    matching_hash: 'ec17f1deab789200c5d7faf868ec200f474e5a9e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '6ffdf1a581554f63f1a39c13f0457725ec9936da',
    id: 'range-test-20260619-3581',
    matching_hash: '73a0d08a39b668ace71e937f3dd94ca891b8bcb2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'ee1f463e5cdc6da15dbf83763aab754f17390deb',
    id: 'range-test-20260619-3582',
    matching_hash: 'bdff28ea6beb8ca00ed3134d395bcaee7f6fafb1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '5ee4635af491792db1e910ea449b3038d7709afc',
    id: 'range-test-20260619-3583',
    matching_hash: '9c893bb317a01c387e731f4ec35f86901b7b65d0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '43d5c6b8831c6429e7b0f2a3817abc909eade27f',
    id: 'range-test-20260619-3584',
    matching_hash: '4e048b3ab3bde75abc5f3942b12eadb3bc41d078',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'f32e761ddb28dbe7ac5bbef2827dd87aaae22ba0',
    id: 'range-test-20260619-3585',
    matching_hash: 'a5779ee8913b903dc8180fff436500dfba3e9d8b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '903de9e45834f04c47d9ed3b3292114d06f29ecd',
    id: 'range-test-20260619-3586',
    matching_hash: 'e796c3632957a098b23986155b9b35f016dca3a0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'dd729572c9b831184adff54efe1000fcd1b5e242',
    id: 'range-test-20260619-3587',
    matching_hash: '52f763e9c658ed02b46a7a9c076c8148fd344783',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '5cdb0c7fac0b7ae749b664df165e3cc1f9217fda',
    id: 'range-test-20260619-3588',
    matching_hash: '11c5d8ed244c2ed75867fce9d4fa764a3ef54953',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '99f0990f2dd12bd37ca8474731aa5841d3cca78e',
    id: 'range-test-20260619-3589',
    matching_hash: '6feea5ef189a68015bc6f1de3557a33c5320a356',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'bc707e97b61655c8af4c753d499f689d154e65a7',
    id: 'range-test-20260619-3590',
    matching_hash: '77286ce9a701300d5bac183c65bcdf1107a87be4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'a6d8cec7bf57aef829d6a13e77494c9a4eafa088',
    id: 'range-test-20260619-3591',
    matching_hash: '923bf4037349d3bc63bcf573279ed85f58cc8c90',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'b3047267e45dafdbe688265d9c901c3d61a45023',
    id: 'range-test-20260619-3592',
    matching_hash: 'ae7156b7ab5050f135d30360610031bf777ef274',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '8df77232faa8fb1e4a07c884c3e24641fa1fdf6f',
    id: 'range-test-20260619-3593',
    matching_hash: 'a4b453d333394039d098eff5ae26200491e43e08',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '8b34fa47401ddabbe0dc9899fb06f980bfa52892',
    id: 'range-test-20260619-3594',
    matching_hash: '709a340c0edfbc0983f370d4540af281a2c1c12f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'f083b678405c5748a9ff7b5c25d7b89c54fb009b',
    id: 'range-test-20260619-3595',
    matching_hash: 'baa46c8048490a3e9612931cec0def0a2259ce7a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'bb9381c64aefba769663fba63f2a6e579f5a8c7d',
    id: 'range-test-20260619-3596',
    matching_hash: 'd76f9efa8dfdf8a0788e91ef2ffbe8bc7ea5ef52',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'cbe468625b505afbb80916c7735c83b393dbfa54',
    id: 'range-test-20260619-3597',
    matching_hash: '1ffdcb9cb59f22b39e34de6ddae01b3c2b08d545',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '14e51e6531441bd68a863ac32d79135af9ba94ba',
    id: 'range-test-20260619-3598',
    matching_hash: '8e2a744e65c86ff30b2bdfaea184b06307a65ee7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'a8d9eb25bfee91829450183f6e9e197c7b334910',
    id: 'range-test-20260619-3599',
    matching_hash: 'c2d864255c964507cde1649a67dc189ce8836283',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '938be5ed15a0d53938bac25fc04216147e15f850',
    id: 'range-test-20260619-3600',
    matching_hash: 'fd4fd6bf5756ab8dac7e41bbe84c8af1e2c85a77',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'baf295ad41d91c4f3f93c9a247c171cd4b81f92d',
    id: 'range-test-20260619-3601',
    matching_hash: '6cdb55b5cc77d509a01c4e7a6786942293c5e804',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'e16b1f8b362f9ce0c5b00b34143be865c4bd9b5c',
    id: 'range-test-20260619-3602',
    matching_hash: '8cc3d263bebf7667dd4aaca3757d5bf7f41eace8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '3c53b2329e182d3cc8c78ffe662bf856ab014976',
    id: 'range-test-20260619-3603',
    matching_hash: 'c6dcc61ca486f168c7e637e27be34806f8bee40b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '7fa66a3d139b5e458e78e8fed5c2ed51c852dcf0',
    id: 'range-test-20260619-3604',
    matching_hash: 'ef378dec1ed9b6c7ddddddc56b824ff2f259065b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'fa7182ef5866edce25b7da4f4b6c7f18d530db58',
    id: 'range-test-20260619-3605',
    matching_hash: '818559974ccec06a96b73d0c36b4ae5324fb9843',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'e87949963462e559d8681e1b5ff8e809c9a7bd11',
    id: 'range-test-20260619-3606',
    matching_hash: '6e75ce10f421fe7cfbf888fdc3901dff653d7c88',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'a7024c3e6337e11b879567410a7c88aceab2d1e7',
    id: 'range-test-20260619-3607',
    matching_hash: 'c8d887763cabd7e82504d18d023aa80c8cf4a0a0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'd000d5d4754ead772f138936a3f9257ad299f207',
    id: 'range-test-20260619-3608',
    matching_hash: '9b4fd2e21790641d6f6df5c6c781322fb5fad553',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '4f08f88fe0a073ce56cdadd26a867fc53ace2c4e',
    id: 'range-test-20260619-3609',
    matching_hash: '28a0bef0b89dea54fa8136b7c83ec4ccd6824795',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'ccbbb9e3ca7e648a56c29afc76f1ba7d9f4ea9e3',
    id: 'range-test-20260619-3610',
    matching_hash: '2d967237f2816d123fed28d07d035b226ceb3c07',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '12553160adf08e9504d5cb8baf5820eba09a8242',
    id: 'range-test-20260619-3611',
    matching_hash: 'cb642e36ae66006d0b587b0c0e533c0e153f9ae4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '3de4d38cde0b03eea50454b3f840dcbe1ad9dfba',
    id: 'range-test-20260619-3612',
    matching_hash: 'e8939027f290136198b97cbb50cd362146a2af2f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '43e21a906f407ef27b72343f88d3dc1744dfefa5',
    id: 'range-test-20260619-3613',
    matching_hash: '66db830ffa1cb2d3b4a87e3935defade7a6acf2a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '504a8769d605caa7b17502b575098e04f2470e2e',
    id: 'range-test-20260619-3614',
    matching_hash: 'f5446110eb0177ad4f0383afc030eea8ccf2fdf5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '175861c0a538330f541d79a895134456c4a059ba',
    id: 'range-test-20260619-3615',
    matching_hash: '0da3d1ec023fb6d30df03dc074a891d6fcc415d6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '0174d5a83eab30c5e64eb7956a7605949a4877c6',
    id: 'range-test-20260619-3616',
    matching_hash: 'd449332a9473d511786553bec71735740cde546b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'adbdd07b4bba301527075afe8441b00df221aa57',
    id: 'range-test-20260619-3617',
    matching_hash: '18fc1869fbf2733afe6609c3ba2be815f51dfa55',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'b3755f7d35d4dafa34626f81a95ee74b781d0823',
    id: 'range-test-20260619-3618',
    matching_hash: 'bb34bb8300d8a821c5475fe5a39f5920b4a12753',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '4eb5b215cbb2a14491d1a8e2683ad8852eeb6b27',
    id: 'range-test-20260619-3619',
    matching_hash: '4717ca4af39c0892c0540a6aab9248ebe9e7a36e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '6b646e8f3790e751c813f3069e4946212f4d0cd6',
    id: 'range-test-20260619-3620',
    matching_hash: '827c5ce221aab1e7b9bd6f76c584fadc93df8f5e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'ef40ad0608f3a678ea171807ade9b6ff7db7e22e',
    id: 'range-test-20260619-3621',
    matching_hash: '09dc0500f5e2766ecd3aac326290bffa226739e6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '37824f5e467942cc78ad3dced6179c3e027eb8ca',
    id: 'range-test-20260619-3622',
    matching_hash: '264878a0a6bfcb2d8089edc6f10bbb979921baa3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '6e93de9b93ad40aa16d17a29a8fa5a30e46bf248',
    id: 'range-test-20260619-3623',
    matching_hash: '088cbd3874e096b4ce9b87fd23c9085a82001bed',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '27017b712e281c82ecd019c5033e5a6ef6cde7ad',
    id: 'range-test-20260619-3624',
    matching_hash: '1b24cf5c59fceba3d0b9fa764a79d9521a12be8a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'a56b791a63d48728b50b82d5e19efdda9c6daf14',
    id: 'range-test-20260619-3625',
    matching_hash: 'c61247aff392ff4c1a9698fd5f1e751415118bb3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'febda095736ba26013a438e4ae0071d0dd69813b',
    id: 'range-test-20260619-3626',
    matching_hash: '2e01846f52ff17003e568bd16e8524e67310a1bf',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'bc12ae1abdbf1aa88e43db392e21a9a01bee5d3e',
    id: 'range-test-20260619-3627',
    matching_hash: '41592d4209b6b2c89d7570d7e62fe14ffe66ff03',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'fd640b4ee8a6c608bd238fb532129198351663e1',
    id: 'range-test-20260619-3628',
    matching_hash: 'e171b9f618ca74dc722a802e430617683848cf0c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'bdd00dc8f60bb37eaaf4795fd0bad50d43ff368d',
    id: 'range-test-20260619-3629',
    matching_hash: '896858b8cdf1c3ee134178f762ee98e4f99e801e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '41c546b12f47e05ee3ee3ad60c86a4e7b3866927',
    id: 'range-test-20260619-3630',
    matching_hash: '5557b0b99e62835dc191d652ab3028812eabf04e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'd1e2ad5c730682899bda9e5db712721c8a202596',
    id: 'range-test-20260619-3631',
    matching_hash: '514cb50db8ceeed798dbe2190ca9563266d2432b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'f74a47c019695943c25d675956eaaf82997e60d2',
    id: 'range-test-20260619-3632',
    matching_hash: '1767bb6627a364ffedc2924786b8d72745d45c5b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '411cfd5d0c853830f133867f8352b3713fd620e3',
    id: 'range-test-20260619-3633',
    matching_hash: 'c5d259ecca855822de93d7a200ddeb53f23c4934',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 6.25,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'e9e90ff826bd10ed88d6c6e27dc88077ee7edede',
    id: 'range-test-20260619-3634',
    matching_hash: 'cd71bdfe1e18308086d1e08957bac02443361c7b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 6.25,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '31fe5254f0ace43bc0ffdd71d0c0534d572ff684',
    id: 'range-test-20260619-3635',
    matching_hash: '04845ac4d9ea529d0bc9a3f6eede152f28ebf5cf',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.308871413,
    qx: -0.934161907,
    qy: -0.103260306,
    qz: 0.145867373,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 6.25,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '3ce3638c205ed07a8da7ec12820500c1cb9f735a',
    id: 'range-test-20260619-3636',
    matching_hash: 'f7dab95ba3a881fceb84fd6543aac8fa9cdd76ff',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 6.25,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '5599a769fdad17c02896959ac2e6da64887b34ea',
    id: 'range-test-20260619-3637',
    matching_hash: '657a57cf6869452abfd1fc6b43fcde37d1cc7a30',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 6.25,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'e5fc1271500d815a5e19ade362e9704bd391c179',
    id: 'range-test-20260619-3638',
    matching_hash: '0f2f12630660fc2e39cd0bc4e723521ee9ba2750',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 6.25,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'ad23caf6d00ec3d5c6cf5edbe8f87a77cf29b89e',
    id: 'range-test-20260619-3639',
    matching_hash: '4736ec68e8a2f58fc2996a5d07e5f6b297efe6ab',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 6.25,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '5c865ebd650fc6764a45a6f06e1187816a332bdd',
    id: 'range-test-20260619-3640',
    matching_hash: '998813dad63df7c7a528815ceeea2a6e9e2c6955',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '66241220ed5bb25e49466bd73fd01c9499315963',
    id: 'range-test-20260619-3641',
    matching_hash: '09ef03ce79e178f9fd7322c96b73a370a94a09ce',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '7857572d12be844ec36ed5c49a0927f1f036a583',
    id: 'range-test-20260619-3642',
    matching_hash: '581225a67687122efe09a931a2fca885c7667cba',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '414b85c2f4836531ef3e97c44dff1d252005ec3c',
    id: 'range-test-20260619-3643',
    matching_hash: '55b42379963b7e4f979f79016d4184d9a550a039',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '1aafe70db6a14e08be7173596b3db5020dd91cbe',
    id: 'range-test-20260619-3644',
    matching_hash: '4f62e64e63af9643bfb407ceac5413e97e15a09c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '8f77581b64d1fe292637121d61fa443139b8954d',
    id: 'range-test-20260619-3645',
    matching_hash: '51b2f6584693fee3bcdb4c15e76cd1fa37e822e9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '674869f1777cd3a3a005e4c7020cdb11d2d70339',
    id: 'range-test-20260619-3646',
    matching_hash: 'de9c7d5a021562169464d040ea0ef1625c5154b1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '2f5b8f8a7af13496484c59ab3daf0d9b14955a07',
    id: 'range-test-20260619-3647',
    matching_hash: '07bf755f0ec8ac8aa386a3f07103b8de0631e1d0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '7ba3772ac640076da1834851b22a9a40eef298c2',
    id: 'range-test-20260619-3648',
    matching_hash: 'ce49b9a8da69dd735882fbebe18e278e541f1452',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '17458b393a1f293b1bf1e6b6a7f76d8c59269c83',
    id: 'range-test-20260619-3649',
    matching_hash: 'e14f08345eeb48c61b986e8eafc5d56857a0d5e2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'd2f84966c3d454f0a3a9596f744a0c9bf67e6f3a',
    id: 'range-test-20260619-3650',
    matching_hash: '5b5712e7c56eca06e548fa3b445dd3e8d988c346',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '7a91e6b94117a3618fe41b191fe5c419316903b0',
    id: 'range-test-20260619-3651',
    matching_hash: '7540d5fead1a10d1614b6c3a91a881becbc870aa',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '007c08a66b004bd1d68fa70f269f1de93df3bde1',
    id: 'range-test-20260619-3652',
    matching_hash: '0c0f9e07526a9c3476307469a60b2557a23f7a65',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '3f230be86b47142553c064755b87f18c203857e5',
    id: 'range-test-20260619-3653',
    matching_hash: '317a0dab0fc6e7b87e92768e745064afe16f30f5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '94df2fdb41cb12ab9a75f1b61156dde6b11a596a',
    id: 'range-test-20260619-3654',
    matching_hash: 'bfeb2e4fcd03575d24d67ef5fa74fe840022ec61',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '641e8a5e200b8595a6f0abdc4082701e9f62d7e0',
    id: 'range-test-20260619-3655',
    matching_hash: 'af402ac95226537655db75554d99553169fa7b2a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '14998be94ca54cd43fae7fec6b4c42b664b551c3',
    id: 'range-test-20260619-3656',
    matching_hash: 'c26868adf3d55dd5e8d2be91fc245b7ba0fd6c61',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '8b96510e5476287f280a12142620d8a7e1ab7a4e',
    id: 'range-test-20260619-3657',
    matching_hash: '897e4877a2cb02fda0bd8bf88d63d64517f0403b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '801a2a0aa74e6c187a70fb5e3ccbcf84255d9b2e',
    id: 'range-test-20260619-3658',
    matching_hash: '2d7158068cd6e4192ad724846572af651dbb6b39',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '33586c6819a2925bd9de87089750643257920fb1',
    id: 'range-test-20260619-3659',
    matching_hash: 'f3abdef12d11edc1f15f2edf884cf3a691b47e39',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '7e31a5771fc2657dbe48c9b4430673b64b640d8d',
    id: 'range-test-20260619-3660',
    matching_hash: '62d297795ff8208633165be6664c477c388fa8f3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '9aadb407c970358866fa8df537631d011d602b70',
    id: 'range-test-20260619-3661',
    matching_hash: 'efa084c6261c7b7d5b77f407182d20f3414845df',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '992323476572caa4a1aed86c8ae6f3f3cd4ed309',
    id: 'range-test-20260619-3662',
    matching_hash: 'ebc204f5d8da7195583f209d0518db066a36d9cd',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '46464589849757855549015f0d2ec17165d1b226',
    id: 'range-test-20260619-3663',
    matching_hash: '3ac09f17efd96bd590d7a3fcbcec5eda496aa9e3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'f786a52178bf333082611c90395c24c9044897e4',
    id: 'range-test-20260619-3664',
    matching_hash: '8ec050d5f2c6d80b0a280a567b888d878feed86f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '838d8ba8a662e33fb4e31c8dcb425df171471e69',
    id: 'range-test-20260619-3665',
    matching_hash: '74944bbc3f33cf6fcd72af4c5c00d74d8534af25',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '3a3b0d3de2d9bd627784a834fd1ea63657da0c31',
    id: 'range-test-20260619-3666',
    matching_hash: '0b464d83aff13ab2a49db7d6cf394280c672787b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'd16c4c84d7f570a3be4e3e1fad742b985623aaa2',
    id: 'range-test-20260619-3667',
    matching_hash: '8206ef614f82f5e97f9ca4dfcbd223411adaf450',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '5da3b79c6bdd6f56b0e0e8ae4c0e0d55370f9c89',
    id: 'range-test-20260619-3668',
    matching_hash: 'a1372bd0b6f7cb9efa1ef7d7cfaa236e2acdb07a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '5ea75031c53f46b6a13cb6422a0439a35686820f',
    id: 'range-test-20260619-3669',
    matching_hash: '96d1a799595f8e96f4ed1503069d3ca2d40af371',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '0ec24945932de42685d05caee9a779fcb6e061ec',
    id: 'range-test-20260619-3670',
    matching_hash: '40e3d2ddfd5ed22d5f7bb7f0342906e5090c2c53',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'ad8cfa1cc5d653c4fdc867fec846a26cf178b79e',
    id: 'range-test-20260619-3671',
    matching_hash: '7b1c1baff82b42588254d44fec6779821bbf7412',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '9e3583db71421876f2c773f2cb59b35401e83447',
    id: 'range-test-20260619-3672',
    matching_hash: '11d1da220a8538957ddac4eb740c6967fa8baf9d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'f32f2da7b50b1666536e29430bd97656adb603c5',
    id: 'range-test-20260619-3673',
    matching_hash: '2b83ac4d49f706952809f38f6a43802c24e859d1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '90edcc86ecce93c53f3b68490a2d68c8a3d472fc',
    id: 'range-test-20260619-3674',
    matching_hash: 'cddfab376c14a3ded93e26ab21c8d1782c1973ad',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 4.03125,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '9ad1da016335b017c30692b873f776be3500f0bd',
    id: 'range-test-20260619-3675',
    matching_hash: '0dc26f22b4a310e8656c4c89ef67c6580a5b56f9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '3c52b15f45d279966890c7a1fed9c967babefc27',
    id: 'range-test-20260619-3676',
    matching_hash: '0c27e16c5e53144e31513c973f65c0ce692cbbdd',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '2b2e26f3c76e8f373f93052f7a7ecc95db540d1c',
    id: 'range-test-20260619-3677',
    matching_hash: 'bc9031c449de731f57f5f34f9f7a43140fcfca18',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'bf34afc185421e0dc020fb1dc4c96c76ad3a8efb',
    id: 'range-test-20260619-3678',
    matching_hash: '870b4d8bc34ee7f1de0e2a0f74b20c76e5035cd9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '4a56fc72d46ea89234de87ee7409a2bc25699575',
    id: 'range-test-20260619-3679',
    matching_hash: '76a91bb6f77f16ee72a92cc45ef08fe86dd0a8d7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '8fcfe0cb94bf56c13b42ff992f1e3853242c0fba',
    id: 'range-test-20260619-3680',
    matching_hash: 'fe33f52ade01c919c1bd0232d536068a563f4f48',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '038958a14ae10a8e7bec418043b4b36fc0a224dc',
    id: 'range-test-20260619-3681',
    matching_hash: 'cff442408a9af0059464801349cea1e6615b4780',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '2ccda0a1a659a673bf5929ec73abe4323b4a1370',
    id: 'range-test-20260619-3682',
    matching_hash: '47026f89ade15ef0c7aa357287ec0ce50ac5ebf4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'a0763e167b95b60895fc52c5cd3846042bd2927f',
    id: 'range-test-20260619-3683',
    matching_hash: '49d1bd867812e646cae54a65c9b49e24ea83be28',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'a656fbeeb438a13499396d7b9642f1cae4a35236',
    id: 'range-test-20260619-3684',
    matching_hash: 'd77a5b105b28d12e5a3036a27348c703cc1a5115',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '147d321bf9605d57412c11b830edb33d85f760c9',
    id: 'range-test-20260619-3685',
    matching_hash: 'd07da630d9a10b0668027d330ba801b82a7c4716',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '8143d8d5136d878df7e5af92ae22aa444ca4b8b7',
    id: 'range-test-20260619-3686',
    matching_hash: 'dcc93b95a36ad3fc645c02820ed07aa715c868eb',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '89d1d7d0337e4437605b933751a17387b7436966',
    id: 'range-test-20260619-3687',
    matching_hash: '4e21f0c936ff65a073d21447066254854f30fd17',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'a4d99e69a0190d216597f81ac1a5f7ef2f2bd543',
    id: 'range-test-20260619-3688',
    matching_hash: '015eab4afb089e193c8a0e5b472323d565ebe897',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '1e72953dd695af4b7473e35111fddc50ead13c28',
    id: 'range-test-20260619-3689',
    matching_hash: 'f00e16b7da2e408f5cf6b0db1b88a07d338bace1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '3920f452817b920735873e128dbe66d66d335c07',
    id: 'range-test-20260619-3690',
    matching_hash: '7921f16b2c59360fabd1f65d4227bde56df5f8f3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'd5cff92a980fc1177cfc6bc691913a68167bae2f',
    id: 'range-test-20260619-3691',
    matching_hash: 'ead1b495f2d27000eae0bcfde0424116c7642f25',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '9b8082456ba12d43884dee0ac79af3ce4c184de6',
    id: 'range-test-20260619-3692',
    matching_hash: '20a56f6c56f669719a02070985684a47eb09d53d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '8094f840c4a7b441c68d6e68674a521982907a7e',
    id: 'range-test-20260619-3693',
    matching_hash: 'e8ce55343be694232e951fc8cae3afbd2e41fed9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '32ea7315b54b8e390cda255fa0fa8ba4676ceb37',
    id: 'range-test-20260619-3694',
    matching_hash: 'bdd61ec87041e10e8866304df75e42741e0dea84',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '63d7a3d96e32b5c3d55a8f03c8044952d51a484d',
    id: 'range-test-20260619-3695',
    matching_hash: 'bd25c80b57de239870584ad42d3c7c77d07012e9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '8b55331bac7f1359e8dc77844abc5b5cf662d8ad',
    id: 'range-test-20260619-3696',
    matching_hash: '233af8ae81ef46581ef540e7ce2556f40c3baa1d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'ee3c63ed64d8446d02897de89484469ff29e1f23',
    id: 'range-test-20260619-3697',
    matching_hash: '2acaf0d6434835f89a5780dc491c7a345751a796',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '9ea0d1fa9f5340cc29f580dff9bc01caeb002808',
    id: 'range-test-20260619-3698',
    matching_hash: '89c3b560234b90bc54d28fda88d59d2d767ee049',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '6fb57fd0169add60f6cb4b73c437801471f93f13',
    id: 'range-test-20260619-3699',
    matching_hash: 'b251f4b3b37d80d02bdb26580fcf84fda90ce570',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '780d9d414c71505f9703679ca15e4868fc17adf5',
    id: 'range-test-20260619-3700',
    matching_hash: '937a80721f3e4bf4be93b7668768409750ce1f7d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '8c171df174927dfaf5bf7cbf830264acb433609b',
    id: 'range-test-20260619-3701',
    matching_hash: '5eaafbe81cb7b9628a8fb160cbc1e7c118eef4a6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '9a3aeb12e2e8ca80e87d4952c3a78d03857fa4e1',
    id: 'range-test-20260619-3702',
    matching_hash: 'f344370f2b9f5e159c8bbb05571be13f7293fd8d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '259a70a7dd2f8d8571cde24ff702982268c53e03',
    id: 'range-test-20260619-3703',
    matching_hash: '19707eccc906a98af086b01f80d360482ad688ea',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '6923d782001a5d143f2bfa84391b01e846c90aa9',
    id: 'range-test-20260619-3704',
    matching_hash: 'd432b7d93216e9a4007e3cc1879ca6a7b1c9f5ba',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '1525969ed66dcaf484f58b2009e20d65e596a928',
    id: 'range-test-20260619-3705',
    matching_hash: 'cdf9b5dd155f978c2cb48283358b2563994639c3',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '22eefef961534673a2e542e5b78af095d7d53fc1',
    id: 'range-test-20260619-3706',
    matching_hash: '534d756d95519e082725130908a5cdcb84479b28',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'd2927a00a9dc7f9d02004d355c6de58b2c834c84',
    id: 'range-test-20260619-3707',
    matching_hash: '80872cc9092d04e2fc2672f33adfd3aafceecd0a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'd60b70f0a98538a420ad5888fecfaaa44e196fb6',
    id: 'range-test-20260619-3708',
    matching_hash: '4c8b5a73ee8efe8ab29761d12c1b0f96b5c4ce0b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '37fe2449c633c3246a350d4c6132f9af0a3f3611',
    id: 'range-test-20260619-3709',
    matching_hash: '413bcfa1603439826a69014ad1818e159f549bd6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'ea00b2f57c362ae254ffda9fa3bb2ab01ca940cb',
    id: 'range-test-20260619-3710',
    matching_hash: '2e5d304f85b3f5a4fecccb8901dc0786bfa2fd81',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '745208e340fba4209ba413eeb228022a0bbf4cb5',
    id: 'range-test-20260619-3711',
    matching_hash: 'ad8a60a0a2963a93f56495ce527585a3b8ce151f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '0a8e6772804b4b2b4854d98ebb8335b9fd7954e4',
    id: 'range-test-20260619-3712',
    matching_hash: '0e04f65de27d2ad5ebf5ff07b64e3788c9aa0d48',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'abdb2dbc3157198b2f9213df8360817650bc4c5e',
    id: 'range-test-20260619-3713',
    matching_hash: '2cc1a7398769f9995786a2c27da49f74689aae09',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '4e214f929fdb81815d591d26357f1afaf6f45eb5',
    id: 'range-test-20260619-3714',
    matching_hash: '6c03f3e842be0fe16eb26a4abefb83c1f311793b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '66ca6fa846359454317b5e9334083884f5fef417',
    id: 'range-test-20260619-3715',
    matching_hash: '6d020e52420f20a7353d2415dfa57b00c8046a7b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '39f2f687013426feea123d996ec9a334abca2df3',
    id: 'range-test-20260619-3716',
    matching_hash: '86005596acc2ccfc29e79fab67760a9bfcbdd190',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '2efee204516bb439b51c4b04b9aa1e3ff055a540',
    id: 'range-test-20260619-3717',
    matching_hash: '72feefea6316f962f58d52818474b66ccc6aac4c',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '2e12b5acedf9d033bd4b888dccd35ccca9d55713',
    id: 'range-test-20260619-3718',
    matching_hash: 'd7dbc1bea154cbeb84df652f91828566d7241bc1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'ec7534dd7b1d91b7f99167e00dc3abfad952bb6b',
    id: 'range-test-20260619-3719',
    matching_hash: 'abfeebe84c766c4b3f302364cddb6d59831c4a9f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '4602cac5619e36feecf183626a2ae7323a6437db',
    id: 'range-test-20260619-3720',
    matching_hash: '448d277dce974cf02f66f9233a7009f63beaec95',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '0aacb26dfd8bac388e4204e8df5868f07ecf2ade',
    id: 'range-test-20260619-3721',
    matching_hash: 'f52997849a8aadfff36d63ed74f321a38826b6f6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'ea8aad2ffae0f99112eecd488a77671493aa1b12',
    id: 'range-test-20260619-3722',
    matching_hash: 'a1b1481e85b30df4ffe5a4793aced601516f70b1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '55776aad3500e4dd032c88d83d1987d57bf36c4d',
    id: 'range-test-20260619-3723',
    matching_hash: '65f68e6bc3e03c741aa11a7dda19cfe5a4940833',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '7f5c299bbee7f1d8306cbc226ff7399cf08b6057',
    id: 'range-test-20260619-3724',
    matching_hash: 'ce3598d2647d7eb3896b44eac93720c7cae57357',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '59c59bc17445434a21acf798d6f06f15019b4eca',
    id: 'range-test-20260619-3725',
    matching_hash: 'f879523feb1dddcd5aabb21dc2bec58032ce8296',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '8ce0b43cac9657d6e115f7e7a305763ece229488',
    id: 'range-test-20260619-3726',
    matching_hash: '54d4ff03f06b5b0cde05adda552dcdc59c85915f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'cc8d2db701f30e244073149e5cbaf8161b88afc2',
    id: 'range-test-20260619-3727',
    matching_hash: '39815d98b0a35eebe8d7841ce4173c47065efe94',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'ad42b5eb89edd1c5750449e59093814c92432499',
    id: 'range-test-20260619-3728',
    matching_hash: '82d046196e8e49ac5117097ac114b5eafcc41927',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '48f7c4424e769114fcb1463556b65984ef1df952',
    id: 'range-test-20260619-3729',
    matching_hash: '0fd7949fddc9e775d22ba08c4a93c66b0e5a72ec',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'cc67a97135c07387bbbb2f51d93a15fe3465ad0a',
    id: 'range-test-20260619-3730',
    matching_hash: 'e25af81c358e53556f1ac325cf705351a98eb16e',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '8d467e5e4056b185405cd9258cef7fc2efaa045d',
    id: 'range-test-20260619-3731',
    matching_hash: '88635d95b7123ceeb2a82c3afac5f6b73163b1ae',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'ce785939242b378e8e0de607ae8d825614046b44',
    id: 'range-test-20260619-3732',
    matching_hash: 'dfc0e359729974e20f59ea042d24134ddfb448e8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '007284cb188e59493d79ee89d1cd2a19a5362726',
    id: 'range-test-20260619-3733',
    matching_hash: '037488357bc0c907fc801df796a0455ad5540aef',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '93fe62b41d2a224f383bd4c6a1bb548b1ce11411',
    id: 'range-test-20260619-3734',
    matching_hash: 'a2a1622e80f5f762becc2ed861a10fd74df73586',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'e20dfff02110ce35c23889d2a1983991c4c2e037',
    id: 'range-test-20260619-3735',
    matching_hash: '99c78fc3e54e6bdcb56eabc5dc0274552fe42f58',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'e10a5e614b62ea870f5c6ddccc8454d00eed1572',
    id: 'range-test-20260619-3736',
    matching_hash: '066da971d6d9f7d34125696aaaf2293efaa5bfab',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.558490123,
    qx: -0.49246048,
    qy: 0.370395505,
    qz: 0.555318493,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '69f74fe0456ff3022f4afb09d37a54e92fdb35cb',
    id: 'range-test-20260619-3737',
    matching_hash: '92e4510e7c8b0fee8f2e2a8c9583503cbf10336f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'bb4157e9d2d23a0e7b9c1f20783e07d87d28532c',
    id: 'range-test-20260619-3738',
    matching_hash: 'ed20f1d910279bea6a37c346950d26b9a6588b5f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -3.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '21866f3149966b94ddfedb2908adb5cff450e90f',
    id: 'range-test-20260619-3739',
    matching_hash: 'faaff5568c8af814a3e88d6a5884b561c7aa1aed',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -3.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '93ee4d45f53e6edccaa86f2ed02319347b45b37d',
    id: 'range-test-20260619-3740',
    matching_hash: 'a29cdf02278fc7d8343741a3de6acd04535e0e94',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -3.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '7511be80e5e7685ea3a8464bc5fd3b784481eee9',
    id: 'range-test-20260619-3741',
    matching_hash: '5c1d1a72f000b48192144b8bd58dc356a636c744',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -3.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '35e44206beca5abca1cb770c88efccadb600c404',
    id: 'range-test-20260619-3742',
    matching_hash: '09fc7301d5d39e0bda870027852e8c5659ae3b53',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -3.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '67b155764f1d1f6a1a71327a0e0e695e9f200806',
    id: 'range-test-20260619-3743',
    matching_hash: 'db7d6373991fac455592cbe1293ee11db3e9ae84',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -3.375,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '2566b13af92f55b2ef7b95b0afda6db9a067e42b',
    id: 'range-test-20260619-3744',
    matching_hash: '8f21d555fe52f253fe270c560c6ac77fa113b143',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -3.375,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'e55650c48e363fde546d55ce7fba5ebfb6db6236',
    id: 'range-test-20260619-3745',
    matching_hash: 'c6fe3a53d4144787c360c4e7be252572c0d27786',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '5255192f959ca2dbb40460c4da6717fdafb82cde',
    id: 'range-test-20260619-3746',
    matching_hash: '093c7360edceaca4e08d729b5a21f281803ad9bc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '62a4b019c234fbf83c0471aab4b2e7e6be645861',
    id: 'range-test-20260619-3747',
    matching_hash: '954584c15123805b0b0c8d580557ad49113823a6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'c45154e6a07849a80b2910f3049e0f5bdaa384ba',
    id: 'range-test-20260619-3748',
    matching_hash: 'b2f198636c9be99ba5defefcaf856bd1ffb6cd24',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '2105f582cb9627d753fd4a33eebf73b8c88fe8fd',
    id: 'range-test-20260619-3749',
    matching_hash: '9e112dca6c88febf2af04030580c55affc8859d7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '5474d84bdde3f94b8fe9f03b2e3ac30fa30e200b',
    id: 'range-test-20260619-3750',
    matching_hash: '7aa731a567caee8e68c0913001f024487131d7b6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'da511be992cbf292ef665333bd913afc5407b914',
    id: 'range-test-20260619-3751',
    matching_hash: 'f23272e76e6e6f76e7bcf83a2c3fb35a83e4b70f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '30f46b2fedf1fde70bcbb68d8465209c2b4c0ac3',
    id: 'range-test-20260619-3752',
    matching_hash: '77487c1421799aa11281c497bd587babed301dac',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '0b53b63bd7426ddd70cf2d506ef8bf63bfe9f299',
    id: 'range-test-20260619-3753',
    matching_hash: 'f2e87af7ca0321aa0ebd34786c265195a09a1035',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '6fd33761c2511b683e045b48c6a747d1614ded36',
    id: 'range-test-20260619-3754',
    matching_hash: '54d377fda618b375b8438073d12e80b2c34f528b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '7abee0b84420939d698abdbef49f0b14631f3345',
    id: 'range-test-20260619-3755',
    matching_hash: 'dc379c89871dae53ab4c1673f42d93b4fc7c4c41',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '6763d37cde220c379119e4e209efb3b753284e3b',
    id: 'range-test-20260619-3756',
    matching_hash: '9d9b1985288269fa8a604bf4a87eac6e88c500b8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '600a8a8e43540dccd2d209e3578f0661a4bb83eb',
    id: 'range-test-20260619-3757',
    matching_hash: '6ee7453cde73c5fecd4ab5768241a1d6ac20b177',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'bf72bf481aad3aa9e02e008b8b8755e93afce5a6',
    id: 'range-test-20260619-3758',
    matching_hash: '4839e0d69855036b55e9958ebd6c756884f36174',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '17f0f37571abad7402d137d34276e89c757da84a',
    id: 'range-test-20260619-3759',
    matching_hash: '65481df5f9795ac649bc8d0d2ffd056a5f749a60',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '00c8424658f8f292cfd78bf0118af4692d9f3cbb',
    id: 'range-test-20260619-3760',
    matching_hash: 'e9b168ec9f6c25b0abd98841568167e43b53286d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'cd1ecfe50ded2b6df407beb139edbd689a7c92a0',
    id: 'range-test-20260619-3761',
    matching_hash: '350b01143011ce4c11d8c2b53b888439c554f423',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '33a73d99b4ea02ea0f048883e6a7048717831265',
    id: 'range-test-20260619-3762',
    matching_hash: '18f13fd015df800eeb0a49a847132f795ed89257',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'a8d69cf6a8e621c6f9b298eed3033a62227d5c68',
    id: 'range-test-20260619-3763',
    matching_hash: 'a2cc085227a0c9d079bc7703ae096ccd04d0d39f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'd888cf6686f8bf2d8825e714ecb0a37fd96722c1',
    id: 'range-test-20260619-3764',
    matching_hash: 'f9f1ff866b838fcd6b6bc7759bc1f1ee9da9c5eb',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'a9a2bff169c57400e62c0905171760344cca2082',
    id: 'range-test-20260619-3765',
    matching_hash: '9b50c1f2fc5e05ae872c33ecb55e8ed64dd76a41',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '91156df010cae6c3e8fa7d4489d2cc09dab4b29b',
    id: 'range-test-20260619-3766',
    matching_hash: '88ea67ec6e6cdcd8110124c5283ac8dc0740863a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'dba51cf138a62c96daac807a054c32963da0f3e0',
    id: 'range-test-20260619-3767',
    matching_hash: '0be01319558b620a213e4a5cceb0f135acbaeebc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'd359796c7a626fe22119c91e06d7fd3086f6cc16',
    id: 'range-test-20260619-3768',
    matching_hash: 'dc5952c971daf7ec2c024900585a35379c98a496',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '6e6a9855b1ce23ff8d5338b100747c3d293e39be',
    id: 'range-test-20260619-3769',
    matching_hash: '34b9b64603198a7e9dc6da6c0a4e7d83b8395eb1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '36af9e2d4f435a09e32c02b6482ca0ca33ddf219',
    id: 'range-test-20260619-3770',
    matching_hash: 'daf87c62e84f4ac1120145f34b4554b7b765197a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'f1fc58bcd5a7c88139dc1b0b8b6514259458e98f',
    id: 'range-test-20260619-3771',
    matching_hash: '6a69c0f14ffc048bcfbfb1529d502d78f2747279',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'a38ed8ad8e51b2fdabdbefb989274888ec11b854',
    id: 'range-test-20260619-3772',
    matching_hash: 'aca98f34e64131a1ee3634039f99ae675671f410',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '6400ca029c842a6c7c7ab873467f6ec8f41137df',
    id: 'range-test-20260619-3773',
    matching_hash: '48f768dae532ed0b2150df1a5c848c382792ca61',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '3a2b352a46afe1fae082bff91dc85216c1217d1c',
    id: 'range-test-20260619-3774',
    matching_hash: '66105a19421c23f10431da24e942cdba15b48c39',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '0b1f6a7a0d8951a089a270a59cd6b8fce3e7d6de',
    id: 'range-test-20260619-3775',
    matching_hash: '21aa261e8836dd01284d96b13008fac0ba898614',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '6e11d92852d07f70228d442cc2f43e922bb97bf1',
    id: 'range-test-20260619-3776',
    matching_hash: '844e6cbae206fdf70404e1dad6e1b8c7a12cccc8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '3d0bf3758355275bb6223e9aa5764dbeb2a5cbf4',
    id: 'range-test-20260619-3777',
    matching_hash: '9ce7543f4129598990a93e12a8244971a7488c79',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '910263c6ef30a72d7594349e565fe730d4832e3d',
    id: 'range-test-20260619-3778',
    matching_hash: 'c5308f5cdcc20f00ceb280039a7aaea4e92fdd15',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'df5f3461dce67b784041d2e686fb8231ee8f3878',
    id: 'range-test-20260619-3779',
    matching_hash: 'a971f3f9ef7119f874ba889d1bcb928a86578ada',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'd46b1b377fddd6fd88d732d707ede6d21684e836',
    id: 'range-test-20260619-3780',
    matching_hash: '2b88f40ff8a0005847e6fa04cccbc5c0cbfd56ce',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '9babd6b53fafa6fdbe00ed2d67bc87379962e514',
    id: 'range-test-20260619-3781',
    matching_hash: '4a591c87f756ba6069230ccf0706ea28cc0d497f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '889f49ea3f924dc49528e1805b57a9f1ba603716',
    id: 'range-test-20260619-3782',
    matching_hash: '8713945bae3b218cb27ce9edfc93b10a4642e7d2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '07092820b09bf3583e54009cd98adcc925c6b441',
    id: 'range-test-20260619-3783',
    matching_hash: '909c15945d0d006f3549c1ee415182655580ea91',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'f1be713a5f440b862417e4476a1c26545b550475',
    id: 'range-test-20260619-3784',
    matching_hash: '353c61d31e6781f25d95162a99c9b426171901ad',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '0e5e0fcf6077f6e99db6d63ed52b30bb01d8d9ac',
    id: 'range-test-20260619-3785',
    matching_hash: '14f17ddd3dd3ec67e384491d3c9c07fd0de274de',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'ed093ca2ace9a322e5058048321d49bf703e4568',
    id: 'range-test-20260619-3786',
    matching_hash: 'ad510970a33c466e9d2f28b552c0e971d6550a8f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'e09afee1fed68b271765e6aa921cb3cdd984cdfd',
    id: 'range-test-20260619-3787',
    matching_hash: '2755f453ae6078d38b30797317a1f2d016b9a7c9',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'a84d307b797831442175a57eb3081407e0132c9a',
    id: 'range-test-20260619-3788',
    matching_hash: 'ef927bcf48063ae555b9ac897ef9439abb820107',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '317665dd02f7a458221af4ab12d653960742ab01',
    id: 'range-test-20260619-3789',
    matching_hash: 'bcf0aaa686764ca88239a86b66785a6cfa197d2b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '8f12e2043a8aba00688304d410fad0cd6435a26d',
    id: 'range-test-20260619-3790',
    matching_hash: '750f6210f4330206e91494b887e30071e3f34981',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'cd29aee80e69872f52c00dc767e4e823edf20ba2',
    id: 'range-test-20260619-3791',
    matching_hash: '7e6b3cbe064b0751054e34f8ec0afd811b9065c0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '21bd67d7c8f839ffa9bd311ac8497c1b565468df',
    id: 'range-test-20260619-3792',
    matching_hash: 'f7ec5840c228104de390ec9952d8964d9ba1b176',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '8f5221f389c65a8ccf912763cc7b1e08c31e2de7',
    id: 'range-test-20260619-3793',
    matching_hash: '023767add6b76d8b767aab951d00a3fc533d23c0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'a74a3095b56731c65627ed86ac61dc26f511d9ef',
    id: 'range-test-20260619-3794',
    matching_hash: 'b2caad396df8f94c510d61f9177c61fbf66bb328',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'e37294966baaa0bffbdd6d769fd00f095e9e3a9d',
    id: 'range-test-20260619-3795',
    matching_hash: 'e70801bc0fe32c52035a05ae042a4c4f87a5bdc8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '17bedd724a894c0cbc0f4ad0d69261d1e37178c1',
    id: 'range-test-20260619-3796',
    matching_hash: 'caaf947db70efedc906238832ef9451ffa42adff',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'a90d9ef724c7b5823230ba396f076cc9a72a2b0f',
    id: 'range-test-20260619-3797',
    matching_hash: '8ca60ab4fa77ac14078de1478175b8fad9a82794',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'ddb34bc8e7c359fd5766059885d8c38f0ad94d9a',
    id: 'range-test-20260619-3798',
    matching_hash: 'e43de55904922e51cc9db153a9978826d2f9a1c4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '15df6588674474b11d684d401af69e08986a22fd',
    id: 'range-test-20260619-3799',
    matching_hash: '3d7b45ed165f9c9e115a26281f384c7be6ddf03f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'a27dfb36c1d7a59753f211a339ff36db945b6133',
    id: 'range-test-20260619-3800',
    matching_hash: 'd1b6ab2b168d0afdda5dd20546ce8a86daeb4ab5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'fa0a9085acf99a853219f472ec7868045d66e6b8',
    id: 'range-test-20260619-3801',
    matching_hash: 'e83b0dac0907820968a571ca0d3b480aa79d51ad',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '09fb55c95bbee8862bc6116c6527ea78a191bcdb',
    id: 'range-test-20260619-3802',
    matching_hash: '806be29f6e0a7ada6b3d9519b2ccc7b5ca874991',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '8368f268c838d7fb82f8fc1a0d0ffa092b65046b',
    id: 'range-test-20260619-3803',
    matching_hash: 'f80a26c9a457870fb5e77fba43189afcdb092f06',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '4cf2b9cc19234e1dede69e553f585a7afd6067ff',
    id: 'range-test-20260619-3804',
    matching_hash: 'f74ff5661a4e904b4cd8dadd9dac13dd1dfa1eaf',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '40027b1530f56419d0803c9388f8eb91bd29bc62',
    id: 'range-test-20260619-3805',
    matching_hash: '9709cff10244be967ab25d0d1f4890a96e321ba1',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '13ca3b8f78a6001b7c24a461d00574e08b3c00f3',
    id: 'range-test-20260619-3806',
    matching_hash: 'c2eadf65bff66ec1ded4d70487ce1e8247392151',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '610792863865e3d7e0f261d3e5e2e9f5cc395c69',
    id: 'range-test-20260619-3807',
    matching_hash: '3296949343d63363e642d6cc03160d15a3cf5e89',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '1197a69cbb3b6f05e92a6fdb604841f4eea9ae40',
    id: 'range-test-20260619-3808',
    matching_hash: '812d7165202800fbe7c18c6afd25fa2e5acd1461',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 5.375,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '5824755e9fe4f2bc140ea4bb921273e4674ee34b',
    id: 'range-test-20260619-3809',
    matching_hash: 'd5fabcc08879e5ed1a9b5e3ae30f8b4dcb9d02f7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 5.375,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '45ccf82d404f12c8c5657d92b6409b7d2d2c12c8',
    id: 'range-test-20260619-3810',
    matching_hash: 'c6ddbcf82f33bf9ceddaf9382baea958bc4f93ad',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 5.375,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '1e487454f14bffec81cb48cb0745988943743b01',
    id: 'range-test-20260619-3811',
    matching_hash: 'd03770ed37519e47a11b438d8dd6b02b81e27661',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 5.375,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '97e8e5352263fd15980b768478280bb7edf936df',
    id: 'range-test-20260619-3812',
    matching_hash: '724e609dd8984077c5274123a870b933feaf4ce7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 5.375,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'afacd1599cf88cd38972f9e6683ce328db298b41',
    id: 'range-test-20260619-3813',
    matching_hash: '3e98a521b08aa13082d1a85a601f6057a63b2dee',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 5.375,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '7bd76bcafd22d140893f152f04706466bdef88c2',
    id: 'range-test-20260619-3814',
    matching_hash: 'f1d8a9ab7542ccf35b0f0f9112f7f93194ba80d7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 5.375,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '33bebbdd98198bd5139222bfe3d99177f54c6de6',
    id: 'range-test-20260619-3815',
    matching_hash: 'c6fe3a53d4144787c360c4e7be252572c0d27786',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '98dfd3809cd19d00e5db2e0643c7977e7c01c21c',
    id: 'range-test-20260619-3816',
    matching_hash: '093c7360edceaca4e08d729b5a21f281803ad9bc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '7583ea2ea95a1a07f3dd6951dfc2fb6ecbde77c6',
    id: 'range-test-20260619-3817',
    matching_hash: '954584c15123805b0b0c8d580557ad49113823a6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'f9269bfe9f07d1af7e9487279a857a977eea8086',
    id: 'range-test-20260619-3818',
    matching_hash: 'b2f198636c9be99ba5defefcaf856bd1ffb6cd24',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'dcd96e61d4c879dbcc8fa02a27183980a8b23027',
    id: 'range-test-20260619-3819',
    matching_hash: '9e112dca6c88febf2af04030580c55affc8859d7',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'ec3b8ce55292d74ff51a5563df80e8a04352856d',
    id: 'range-test-20260619-3820',
    matching_hash: '7aa731a567caee8e68c0913001f024487131d7b6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '17b4093cbebc929eef9a5fadca45fa552d0d3722',
    id: 'range-test-20260619-3821',
    matching_hash: 'f23272e76e6e6f76e7bcf83a2c3fb35a83e4b70f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '0aebc68e129459623ec209626408cdff53e090cd',
    id: 'range-test-20260619-3822',
    matching_hash: '77487c1421799aa11281c497bd587babed301dac',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'faf55869129b572ad7a0cba1360bbb670169e14b',
    id: 'range-test-20260619-3823',
    matching_hash: 'f2e87af7ca0321aa0ebd34786c265195a09a1035',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '0107db93dccdcfd8785bcdc8b710c990e7802730',
    id: 'range-test-20260619-3824',
    matching_hash: '54d377fda618b375b8438073d12e80b2c34f528b',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '92dddb35c15258965dbcb371ff2afb632febbbf0',
    id: 'range-test-20260619-3825',
    matching_hash: 'dc379c89871dae53ab4c1673f42d93b4fc7c4c41',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'cde5e65e112bec33244b7271d6ad07b6db3f065d',
    id: 'range-test-20260619-3826',
    matching_hash: '9d9b1985288269fa8a604bf4a87eac6e88c500b8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'c6950479d335bc811fadac5504b098e90fb39fdf',
    id: 'range-test-20260619-3827',
    matching_hash: '6ee7453cde73c5fecd4ab5768241a1d6ac20b177',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '1d24354f858f5c268a4c14002067f28b2218b9ad',
    id: 'range-test-20260619-3828',
    matching_hash: '4839e0d69855036b55e9958ebd6c756884f36174',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '974839905466494e655f4493196e76b8712a1c95',
    id: 'range-test-20260619-3829',
    matching_hash: '65481df5f9795ac649bc8d0d2ffd056a5f749a60',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '32c695d9c36378671c1433947f1e5e2e2702998a',
    id: 'range-test-20260619-3830',
    matching_hash: 'e9b168ec9f6c25b0abd98841568167e43b53286d',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '3d0b8961acca9bfa23403bfe4af066613221b196',
    id: 'range-test-20260619-3831',
    matching_hash: '350b01143011ce4c11d8c2b53b888439c554f423',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '7313e285a9fb0e90b43502d9d1a385fc5dc97a81',
    id: 'range-test-20260619-3832',
    matching_hash: '18f13fd015df800eeb0a49a847132f795ed89257',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '7864767cdb45d31d2817285d1f6a43e7ed87843a',
    id: 'range-test-20260619-3833',
    matching_hash: 'a2cc085227a0c9d079bc7703ae096ccd04d0d39f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '2d1690668b93559544a7f59b441e6949e526ef77',
    id: 'range-test-20260619-3834',
    matching_hash: 'f9f1ff866b838fcd6b6bc7759bc1f1ee9da9c5eb',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'df907da4213398db26aef7fb1e147c912d29b9b6',
    id: 'range-test-20260619-3835',
    matching_hash: '9b50c1f2fc5e05ae872c33ecb55e8ed64dd76a41',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'f7e1303152b5ec0e5c01e7aa81421dfdb525508a',
    id: 'range-test-20260619-3836',
    matching_hash: '88ea67ec6e6cdcd8110124c5283ac8dc0740863a',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'cfad83aa89decddd8e6f05ffa5ad8cdbff52f989',
    id: 'range-test-20260619-3837',
    matching_hash: '0be01319558b620a213e4a5cceb0f135acbaeebc',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.601325652,
    qx: -0.567177527,
    qy: -0.311194338,
    qz: -0.468908516,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '0b4a545425c3c40faf5921d7477a03398e8be47f',
    id: 'range-test-20260619-3838',
    matching_hash: '7ea6415ad55c5917e52f443e0661830cd0fb29a5',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '2ed871062c3e3b4db17676cc8181e78c9f9be124',
    id: 'range-test-20260619-3839',
    matching_hash: '020e85e4db5c07bb1d44f7dd5765a978f9ad38b6',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'ffab8eb2f6d71910dde4a41741f4ee7b3cbddf3e',
    id: 'range-test-20260619-3840',
    matching_hash: '257543ca6b4a893bc35db490e15e84efd1866eb0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'cede4840007ad052c94d8ecd7e6c5538e155f8d9',
    id: 'range-test-20260619-3841',
    matching_hash: 'db14ddbbf693ff2b23af8a9c11551cbf9140399f',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '46538dbf277eaa8ebc9f56847aedf0f8a6061ece',
    id: 'range-test-20260619-3842',
    matching_hash: '0d8095ed57e3eb60d168444b14a129f89ca745c8',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '8c39a0460f8bfdd994a077a574057b068fb20baf',
    id: 'range-test-20260619-3843',
    matching_hash: '1950c2878af1f5bfc789a720e1309d1a7d993da0',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '146407e1563061bc8c801e2d9e612424fd6d9517',
    id: 'range-test-20260619-3844',
    matching_hash: '10f40aa4c4f4acf2888216a8070584b0368ecbb4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'cab2943646e562121157997666fb8f515fcd3c4f',
    id: 'range-test-20260619-3845',
    matching_hash: '690cbb606aaa131bb2619264451427e96c092918',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '9e41dbcc98917c6e2d409e0545e48c2801ff8e3b',
    id: 'range-test-20260619-3846',
    matching_hash: '368816523e4e9fb118ac31f7606b582bfeea5911',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '72683465e3e46983767c72ab04b440053c96538d',
    id: 'range-test-20260619-3847',
    matching_hash: 'c1fbd841ab1020e8266ba3e31851382bc2bab2f2',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '127ca7077d7e58af7d09da3da084524f0a9871fe',
    id: 'range-test-20260619-3848',
    matching_hash: '24375fc9b7eaa32a6c7ed3e217bda8b125398733',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '46e0da78704d9f2f3f230e37a412de3d5193be7e',
    id: 'range-test-20260619-3849',
    matching_hash: '125f2c71b8681d4074827f567960be5a2e81f3b4',
    model_id: '',
    model_key: '',
    px: 2.4,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '85ee1e3114cd2c7ce9188ab08048bce6d2c71625',
    id: 'range-test-20260619-3850',
    matching_hash: '7150ec87932bfc6577ec3273a711d0cc77f4b204',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'a57f7a919cdf8b2218e468191aa6f0a0600ece30',
    id: 'range-test-20260619-3851',
    matching_hash: '5fe6691d59ff3faad1aab86c4d6c603c8c9c4624',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'f3c4b9857013b73bd74ff19005fa47ba13790d4e',
    id: 'range-test-20260619-3852',
    matching_hash: '2e219ec6b29a920917daf6c7581b32b76a0b72b2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '06103163b1585d5013fc979f4f86df4a20df31f4',
    id: 'range-test-20260619-3853',
    matching_hash: '16c9a5052aaeafbeb13e9b5dd05b690981733922',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '09fa299c91373d9de1e4c9cebad87bc1f24a800a',
    id: 'range-test-20260619-3854',
    matching_hash: 'd1e45cbe97ba16f4e60cfb3716a603e0d74c6e64',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '4e4873941b809e5146322db145cc0ea9be7c6c35',
    id: 'range-test-20260619-3855',
    matching_hash: '301965406aadcb24689c6eceb1ea3c222ded468f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'b10a61f8dd1f93b2d5f68374994c2c0b1bebfbaa',
    id: 'range-test-20260619-3856',
    matching_hash: '15981e1271ee1f3684adb5b5a1e775307a5a0d94',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'd5a201785cb77747d32b0045b0dfe0a294d458e3',
    id: 'range-test-20260619-3857',
    matching_hash: '285fe4d4b3169c2a272bd76729c141f551b55820',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '48e73ba6e650d374f00b813ab4689c60ae15b392',
    id: 'range-test-20260619-3858',
    matching_hash: '1abac32a08bd8c63dfa8bb8606c50e093fabad9f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '6ecae2838a595e68050a675aff846e20be768994',
    id: 'range-test-20260619-3859',
    matching_hash: '0e2300de3b5d205c39f0ab5c7069e3149e262c36',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '7254a3a033f26ed5230f9da749d127c99a8bb427',
    id: 'range-test-20260619-3860',
    matching_hash: '43c5f88dbda6339bcc9128c9a20e6561e0b8590b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '0ccf44601f72d563dd5b2cd807e93858cb0d76d5',
    id: 'range-test-20260619-3861',
    matching_hash: 'e4822a10bd6e38d651c76cad5584911f74e4954e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '2d2cc31439713ba6cefed7985ec704ec9f0e13ea',
    id: 'range-test-20260619-3862',
    matching_hash: '5cd37fbdf88bde55c8dac3d63f031ac3aeedf73f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'faa83a3b586de85b6d904e4a9b61416825b58abc',
    id: 'range-test-20260619-3863',
    matching_hash: '41f942d440fc3dcc341e670f2c0f4fc2fb0811d8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'b748f5ed0622c33adb32a76ad557f1af3e3cc08a',
    id: 'range-test-20260619-3864',
    matching_hash: 'f5e259fb335bc3ef9ed1e5bf526bb4ea1dace706',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'bb4a5ca8a1823bffc7c08e0d34ca6d14f8cbf890',
    id: 'range-test-20260619-3865',
    matching_hash: 'a6d8636225d4fddcad1a99bd17c13627b793b2bd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '6a820bf9b301feef1953b2f91ac8a49787cdda53',
    id: 'range-test-20260619-3866',
    matching_hash: '50b668f74c631e9267a576c3bc856d97f9b2aa38',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'b23ab3888fb89a60e12cc7f827c3eb5fe963de5f',
    id: 'range-test-20260619-3867',
    matching_hash: '7dd3c2e426696ebba8d21600d215ce6b646edec6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '6b89f536fd666744c969eeeb50feee8d0bb5348e',
    id: 'range-test-20260619-3868',
    matching_hash: '6b55a3c8bc1a85f525004dda931cfca5780467cb',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '89fdf40f3275ea9bfb2bcabedd8ad7431012b73d',
    id: 'range-test-20260619-3869',
    matching_hash: 'a4ab83bd10c9af3b1078791225582748f8d896bd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '0349487c1e4b62ef04d5629ddddc40487c894571',
    id: 'range-test-20260619-3870',
    matching_hash: 'fb1fb33c691bc3e44422238292faddcd8b67d88a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '33bcb4b978383eabbf5987662c49a6ea45c5413f',
    id: 'range-test-20260619-3871',
    matching_hash: 'd6c0534abffb3df70ed1cc1dbc48029974110296',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '42cdd6ea3dc9fb09c6485d00a6f75048ef2fd2db',
    id: 'range-test-20260619-3872',
    matching_hash: 'f639797e7f42c8d97aad60ba66eceb08e91b6355',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '7cb8acc197ec41bac431261adcdff5bdbf959b6f',
    id: 'range-test-20260619-3873',
    matching_hash: '713bb9a83c38564bf45efe479ac4bf45991644f3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '3098a3596f12127e37a9caac8771f8c9995f0f55',
    id: 'range-test-20260619-3874',
    matching_hash: 'e266d4f61ed6b4010fc00e9cdb7488d45f620489',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '6edf09e87e60451e42d01b917e4cd30f3084e958',
    id: 'range-test-20260619-3875',
    matching_hash: 'bbc7a843ea803e53303e6ce521e4f41c77e3dd6a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '29538e87e103ba4247af4044dca726987ffb0e23',
    id: 'range-test-20260619-3876',
    matching_hash: '7949221614466666c1fc6ef7a5a96c381fe669c3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '460f6590da4faa3ea2b2e08daf8236ff67d198b8',
    id: 'range-test-20260619-3877',
    matching_hash: '76c81bd3dfd9661fb2941b5beead71a35bf3d3e2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '209415d84787b0f003dc94e9969f7d90b9fac7bf',
    id: 'range-test-20260619-3878',
    matching_hash: 'ea5e4bb14783918c4eb9890af26c6da1ce6e24b0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '7540a1c7d5b31b4d6f17a99a54530a95eff1611f',
    id: 'range-test-20260619-3879',
    matching_hash: '174b374ad775a7819ac43f77a22612c33451a45e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'a168a1d1332af6ae5ed06907f65304e56d6196d1',
    id: 'range-test-20260619-3880',
    matching_hash: '3d4fae5bf4ab62a6566995edd41f115153ca9101',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '96c9a3835c1c6d8b3c471ebd7ded772cfda1c9e7',
    id: 'range-test-20260619-3881',
    matching_hash: 'ccfc100fa871be0080367f27ba244ad686560ce3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '5cb158a4bcb6ccba6e4dc17e1804316858a4388c',
    id: 'range-test-20260619-3882',
    matching_hash: '277b062a9c70d23f562252fd6d821de1baae7163',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'f64a04b4b7123b6d5b1f076a3171cba9d06ff221',
    id: 'range-test-20260619-3883',
    matching_hash: '42d78f311c91b3cfa1261841417980d7fc997bf4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '501ff0a8832442ee6b99b159365e2bec441cc23b',
    id: 'range-test-20260619-3884',
    matching_hash: '6dc2731be3497edaac23e9c5334a1107d4d74319',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'd24228e771eed3c7b37fd0284d348dda25382043',
    id: 'range-test-20260619-3885',
    matching_hash: '3752191f3acee86536e4fac24be83da345461158',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '9eb209a5457767c57f8803de22b3d5d7ed7e7952',
    id: 'range-test-20260619-3886',
    matching_hash: '5d47133d61a1e724f31614015ccbdfdb1b323baf',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'f647b366ea7da4a2700c568fde0a3a578781f068',
    id: 'range-test-20260619-3887',
    matching_hash: '6a803fee52cef524694316fa1525b24f3d7edc39',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '021a6ceb70e91cfa8c8213de270a250af703ebef',
    id: 'range-test-20260619-3888',
    matching_hash: 'db66974fd8a1153bafc737c1a116cf119d6625f5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '552d619fce81d70c9ef2e520115f66803957e6f5',
    id: 'range-test-20260619-3889',
    matching_hash: 'ebef0bf38ee6e14c238a8d2ff447540b87698b1d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'a0ada52fa4b5999311ad433810f44160de7f6c98',
    id: 'range-test-20260619-3890',
    matching_hash: 'e6397429b3e255af2056ac5c24229cdf7f017249',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '09cc4cc84d6767471cbc968e558ce1df4a45f03b',
    id: 'range-test-20260619-3891',
    matching_hash: '21ad1b2e8e609c1e1fc36f8711bdd945a64160f7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '7b7551194e7c8d5b913b9a43f5238922b801141a',
    id: 'range-test-20260619-3892',
    matching_hash: '3b62c9f9cbb5663e39ab11cd78c9ca2b0e1a6b42',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '64f52045542a2f561cf8453d86a6cbfe1706029a',
    id: 'range-test-20260619-3893',
    matching_hash: '95d538faad169d4eff12c505a6043555f6adc73e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '172ed21c47e9cf6fed97b712dbe36fd7e457aa77',
    id: 'range-test-20260619-3894',
    matching_hash: '5793b91b607acdf6ac3ad5cb60176393ab9f988e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '5d9a7cbc6d1dd8216dd68d62753952c48d5b78a8',
    id: 'range-test-20260619-3895',
    matching_hash: '950df99d95f333932ecededabea2014f6373564b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '48a3cb615ad5511865619f5ec109a0c90882239d',
    id: 'range-test-20260619-3896',
    matching_hash: 'c7049e18e7f156c1b729f805c76e6e0131744fa0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '118e32d0bf5a56cec4e63a51363462d80e064a0e',
    id: 'range-test-20260619-3897',
    matching_hash: '6faba2d98ef0f02555863c33fa4fb6c298b32432',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '1a5bd61ac3cdc11e6b12123a952575544f499ccd',
    id: 'range-test-20260619-3898',
    matching_hash: '813893430b3bfb823903b7768b2c83653d8dc15e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'e146f3fccb18a938ac49559f0814eddf1959bdad',
    id: 'range-test-20260619-3899',
    matching_hash: '91317e04716753477ba68d2405917bb499519ab6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '2c8a60f20158688bd54782157a28c1b0411ad77c',
    id: 'range-test-20260619-3900',
    matching_hash: '6bbbc254f2c480d174ea5972d8726bc02da77c97',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '1f576b4424961f07677f29e1ad5104b28a7e8914',
    id: 'range-test-20260619-3901',
    matching_hash: '12081a78edd58ecc6bb5a7744a24841c1aef1d3d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '88db4d4102edc5d0f0ab5bad318cc4dcd5ac78f0',
    id: 'range-test-20260619-3902',
    matching_hash: 'a878858d6753326b6e230c8ed0975576acbfe101',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '143d090085bdaee795a796860649deddb29381aa',
    id: 'range-test-20260619-3903',
    matching_hash: 'c4c7145c0c18e04cbd3afa84141185e0d1b234e9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'ea595723239088bea94d638f7bcf824a9e502e3d',
    id: 'range-test-20260619-3904',
    matching_hash: 'd8055181f08889860be38a4b9983fdbb5b04a4a5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '7af30a29e00f76f40616849da2144ab8f0fdc24e',
    id: 'range-test-20260619-3905',
    matching_hash: '5f3851d7257d73894fb37cc715ede9086b936ed2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '9181bfc09e0fb9c23ad7a78951a1bf27f8cda451',
    id: 'range-test-20260619-3906',
    matching_hash: 'f3214dc42d7e715e0ffa8b036d497c0f9975d374',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '9c753be1bf5961a866f988a8bde65ae3ee9fa0df',
    id: 'range-test-20260619-3907',
    matching_hash: '9049f415f228f3a66b17a5375d9255bc99d97585',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'ad0dbedb488a658b77084a328d7a95acbff17025',
    id: 'range-test-20260619-3908',
    matching_hash: '8386b8fe938c1d549301dbf66ecc5c29f733065d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'aaa61934971ed9ab354e5dd8cc0a18885d480af1',
    id: 'range-test-20260619-3909',
    matching_hash: '000bba9a8872010f4df2ba11b4bf890f702bd784',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '161d369e64f412284ae9c6c46c6b11928641c1cf',
    id: 'range-test-20260619-3910',
    matching_hash: 'f5d17baf3c7af1d78319f059d0f4f4ac0dc97d30',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'b8a8cfce36adb04e51e57591993c6beec29aae8d',
    id: 'range-test-20260619-3911',
    matching_hash: '40c65e18f8fd8de1174306157ffd2738857282b9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '55e95309e1c30f80aa97b65ee6a15d3841680490',
    id: 'range-test-20260619-3912',
    matching_hash: '2d2de2e6bab860aed41d7271f986723ec60ddb9f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '2b63af7292c5a0bccf1af8bbdff92b60b19ed6a0',
    id: 'range-test-20260619-3913',
    matching_hash: 'ab34aa16637fa5b30baa1ae89c6513940b61177e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'd9ddb9c4f8a48f98215ec7a4b751535cb3384b62',
    id: 'range-test-20260619-3914',
    matching_hash: '14fd0a23d299f35bff98fe9082d5c7be4c3f5a27',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'c81afbba76b1f6f38105162a162c7ee805bdec9c',
    id: 'range-test-20260619-3915',
    matching_hash: '346e18e9159f0e576bf79d1902b059edbcefb1e3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'dbd37a9afe137edf9d3dca91a404b80b075b8e00',
    id: 'range-test-20260619-3916',
    matching_hash: 'a9da4743e5ea35b0f0da31b49d6c98128b6d2b2d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'a5aa365c67f24e2df315a59be0b2d99e8b3014cf',
    id: 'range-test-20260619-3917',
    matching_hash: 'a4978fa4f6cdbcc862bb6918e7aa4b272a74dbd5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'e49576b7983c913d6d8beb7b5e557d98577f87d2',
    id: 'range-test-20260619-3918',
    matching_hash: '42f6c2c0b76b6f09a494facce531b71c5fd4a578',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '47867f8f3a8beccbe26dec4bc189c7d240fcad0c',
    id: 'range-test-20260619-3919',
    matching_hash: '43999a7b69335b6e6e2939b1bdfa958cffaae061',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '9184f10dd603c41ebad59f6f2ce5b4617785043d',
    id: 'range-test-20260619-3920',
    matching_hash: 'a41961d6491f5df89a6606e989192f42396c0af4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '8a2096fd946401347e380593d19ce4d00d617359',
    id: 'range-test-20260619-3921',
    matching_hash: 'fc30989d3ae316c1321a5c1d2a3c0ed7b20c87ee',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '4132740212b5ed652a794fc249db801d0b3461e9',
    id: 'range-test-20260619-3922',
    matching_hash: '95d0e51ae842b46ad66f7a3c1611c57246440232',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '034d058d1d5787a260b3634707854f6d36e8bd32',
    id: 'range-test-20260619-3923',
    matching_hash: '5b86a83453b1882e410b60d8d86b114fe652d4cd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'f40f1f8490572aff77a746ea08bac0b7cbff84b7',
    id: 'range-test-20260619-3924',
    matching_hash: '693843257819489701d904ab7283d26fcaa73079',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'f4e5518d7318fda73d39414abf714ca2edba9e2b',
    id: 'range-test-20260619-3925',
    matching_hash: '3bb6faa662cb14bcb8e0579288008ae1956f9b99',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '8685e6328f714fb1d92e0000f9008a727213d279',
    id: 'range-test-20260619-3926',
    matching_hash: 'b9b806aad2712d0c6fdb63f63699bd2500a3f337',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '31c44f12ec20ce93e3fa5602fa2176d83d3bc93a',
    id: 'range-test-20260619-3927',
    matching_hash: '1cef544d728738aeb68d909069c62ea6943ece3c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'b439e7a30286e6273192d85ac75cefbddbef67f3',
    id: 'range-test-20260619-3928',
    matching_hash: 'd1ef27c0cc805168985f4e2719e25aeabfa3451b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '167d4ab2e89907d2d7128fc4b96f1c25b07cbf47',
    id: 'range-test-20260619-3929',
    matching_hash: '7c2702e617b1ec9ff4fc688b823125dfbb44f3bb',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '90ac714f724eb0f7c4d728de1a0cfad0798a24eb',
    id: 'range-test-20260619-3930',
    matching_hash: '72f60da242b5d1db26c18336b71430f8e75a9d3c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'c814701d4968456e7a44ea538255627ec34ee239',
    id: 'range-test-20260619-3931',
    matching_hash: '04c058f234663ba51dbc9ec2923aeacf95f2bde8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '22d48ca21ce18020a6847fcbde28ffc78bce6107',
    id: 'range-test-20260619-3932',
    matching_hash: '38c368594c9a06a0a84e92a5dcadc7329f953076',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'fdee309de6b4092ec0f759d923553025ea263c68',
    id: 'range-test-20260619-3933',
    matching_hash: 'daca24c58d2d9819658b758c1ca52e637ba9e31b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '3f3e88c1920363360fbc0f093cbbb8a22f6c2b5f',
    id: 'range-test-20260619-3934',
    matching_hash: '940d28b0dc044327cc6a5a2a7d882cc7e79bd721',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '18d92114992428edd5561f08b7ae837567a925f3',
    id: 'range-test-20260619-3935',
    matching_hash: '8faced4ca9fd7094b9295dbb8d9c94e7aed468e6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'd461e0a51282c91f9c258d01b9c08665a14744a3',
    id: 'range-test-20260619-3936',
    matching_hash: '70f467527e297ba02b214fd31f7c27e9bc9ee478',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '0a9869904a0b5857c3ae446c085440df4de1f678',
    id: 'range-test-20260619-3937',
    matching_hash: '51b122c5e81aa54a8c66de09618d4f3dd6c821a8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'bed5341c6bb3ab741b20e1057be0542dc2fc2110',
    id: 'range-test-20260619-3938',
    matching_hash: '245af419ebc5ef8aa9385488fd059160203b00a9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.894074547,
    qx: -0.328628348,
    qy: 0.073578426,
    qz: -0.295330879,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '8643b59a39b6799cc0c496ab6aed7d95af6be2a9',
    id: 'range-test-20260619-3939',
    matching_hash: '60941a9ea594bfd22e53ce838b9dcff2b0022c74',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '129900e367c12004e897678f3c8f16ef06c2b9c0',
    id: 'range-test-20260619-3940',
    matching_hash: '1478073ff93b020798ffbd2e92e35069104573f7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '1fd8df5b9c160bd6f668d962f691be0fc84076e9',
    id: 'range-test-20260619-3941',
    matching_hash: '2e0be9cbad20313b7db75be757c4d613992d32ad',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '340d7ee18472d5478164eea0e060a2c0aa81301b',
    id: 'range-test-20260619-3942',
    matching_hash: '2aafee2cf5f284e489ec6089270509e96f0f936b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'cde7815e683b1d6b91728693242fd04315c55686',
    id: 'range-test-20260619-3943',
    matching_hash: 'ca9fe29e95e1adf50c19ca09ed32950c4ce33c5f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '831907d4fc0c1c6d8276f85e74ddd5cd86430132',
    id: 'range-test-20260619-3944',
    matching_hash: '3ddb1d0e71b472e2a3640c3c0943a0b2e0676d09',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'ebebbf873ba4cf892c39ab32d6f9644cc92eec77',
    id: 'range-test-20260619-3945',
    matching_hash: '2c901abb12d92ac378bca001cd0208c1cdc4d505',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '537e56fdab1a6fc6b470591cacd858ecd27081df',
    id: 'range-test-20260619-3946',
    matching_hash: '1df29dea299317ff84c9b6cbd9c3dd6a9d9ecb6b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '98b2b05a89d4720ec4f7772d850d2f875787001e',
    id: 'range-test-20260619-3947',
    matching_hash: 'cb2d9b995b919fc5296362399d706d39dd9c93cf',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '276b021d09d3df7c34c4789c8ab036e692d9a5d9',
    id: 'range-test-20260619-3948',
    matching_hash: 'd89f5fee2d24deac310de3138366eaad5844d30d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '25dc801cc9633df0c903f3ae3a267b53dbbf714e',
    id: 'range-test-20260619-3949',
    matching_hash: 'd64f7d184ed3bbeee44d7c5076b2f6d9aa1af635',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '431f996e2234969e354d9088c8d1246c5d2efeee',
    id: 'range-test-20260619-3950',
    matching_hash: '809b63199753424b337f55fa85e142f7c7193a3c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '81a92ab9623308de3b86e8ec1006cc2d8774d3b7',
    id: 'range-test-20260619-3951',
    matching_hash: 'ab76e975c3d823ebf2985b3ba8d729dd7acba35f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'b822d2bb2f935465139d6105d18ea29b5eae5f32',
    id: 'range-test-20260619-3952',
    matching_hash: '28048d24e7d2e4f8215582422dca05cfb14bf1e2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '9e9951973301c8aa44940ef45e3773f2b01ed423',
    id: 'range-test-20260619-3953',
    matching_hash: '44010a8162cdcf231c25099ade0c4e3a77475f96',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '074a0bd071aafbc8d2c3782edc2c1ca37b7e9a08',
    id: 'range-test-20260619-3954',
    matching_hash: '23799ba10281004077ebdb5aea3b9a1ec888278f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '0b2fcd08010f9ebd421d84213a89aa1369d10f48',
    id: 'range-test-20260619-3955',
    matching_hash: '33c156e6759c953fb715aabb411500483d063f74',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'bcb20a0b19d7e6ffbefcf9a4e91f300528d25eeb',
    id: 'range-test-20260619-3956',
    matching_hash: '97dc3cf6be958d290f992cd8d591ff63b74eee9f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'b29f5cff4e8316e026913ac513a4a5a4fac9458f',
    id: 'range-test-20260619-3957',
    matching_hash: '21512850c737c0fa2e2767325e485926531321ed',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '40a5365f7a4102fb2c9e1d64b10e406fcf162b16',
    id: 'range-test-20260619-3958',
    matching_hash: 'dcc98e11f6d15d3ad2eddda05ab7b0d9dec0488b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '43158de0db088f4d2ae36ba42e0de968ed0b1a5e',
    id: 'range-test-20260619-3959',
    matching_hash: 'c1601c7a8dc735b3fdc058c62168969c7decf822',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'fc2bc50853983b90ec278145c9a1229dccbb56fd',
    id: 'range-test-20260619-3960',
    matching_hash: 'd47ae4a3c999153bc306f28f6ba356128052b1a1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'cbe5463c5c6d49595a1c3e1339dea411e393b186',
    id: 'range-test-20260619-3961',
    matching_hash: '798907999e685449c49b2898094b170b0f1bbd2d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '3ea200fa17915fd9abd857978ab3b8cee2888e2e',
    id: 'range-test-20260619-3962',
    matching_hash: 'bcecb7bc64838d3a8c4dde19c86f78cf1c787f57',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'c39ae1de3977606e3ec810f0fc9987c56d2f891e',
    id: 'range-test-20260619-3963',
    matching_hash: '0941b567493826ad00edcb17b156cc953f5b8097',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '4bb4161f8618da518ba3ad29c498c595e9d7466c',
    id: 'range-test-20260619-3964',
    matching_hash: '6ea5cbcad79857a3ec6589a4c2f48ca814c81646',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '9c7d52e6d3e5db1d279e81f532b301225c15adf6',
    id: 'range-test-20260619-3965',
    matching_hash: '1058f9cf8f4074986c2ba262a75d909bafbde4d7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '671b931e6487212f72b78a7e05462d8407e7c837',
    id: 'range-test-20260619-3966',
    matching_hash: 'a654aa1c2971c91e19fc72796ada002d11134d62',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '2a7b9aaeee93fc39514e99a62f5aceff77352460',
    id: 'range-test-20260619-3967',
    matching_hash: '6c7e1a9448fcb7ef3c7e666672615e1a0521b14f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '2bef0e472d04492e9ac2738a7e0341dc5f007f7b',
    id: 'range-test-20260619-3968',
    matching_hash: '1c469bcd16d56714ad02a20c31150d3878784c09',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'cc1741a132aa1ec4887cadbe1de5d857c34f5f9f',
    id: 'range-test-20260619-3969',
    matching_hash: 'a56c2f7de5ff8253f8a67f0ba3c7e586f18e1be6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'a343e400055d75fa4c898dfbd1eacffc40f346e6',
    id: 'range-test-20260619-3970',
    matching_hash: '907c36f3aeb0bf5a5181c2228cad079eb51b4a8b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'd53a40bbc7e304cfc77f486117fa26cb00b43747',
    id: 'range-test-20260619-3971',
    matching_hash: '94e1cdf933ed0953d2dae0e0e8c40b9c69b5165b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '6c1638a5893e8a71cc4a0843f2c0cf24ddff3240',
    id: 'range-test-20260619-3972',
    matching_hash: '0b2f2c2ccfc4938fecc72c5e4fbe6f71bd23e14e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '0c97ccb6085ab1f531673fd6926502c819bbdb53',
    id: 'range-test-20260619-3973',
    matching_hash: '017f2079a1d13f0af039189854d196c4ba63666c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '4140445d5137be3f812544d3b552eba8449af7b9',
    id: 'range-test-20260619-3974',
    matching_hash: 'b52ed7a5ba51212d442e5547738037c3bad53b07',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '2717b00ab47db29e67170a69c4ac4d9400af4bc6',
    id: 'range-test-20260619-3975',
    matching_hash: '33f0142e117cf5e6632da127109a58aa3b54e063',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '033e5066d457bb423de337c49c9c019ad52e7464',
    id: 'range-test-20260619-3976',
    matching_hash: '72720d9cdb1e83bb6e224d14b44c4f2853fb55d6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '6ac64f55a650abd91c9b1bf7faea8c9ed378202d',
    id: 'range-test-20260619-3977',
    matching_hash: '3198919b134a4b2e9612021d09faa37b0167d711',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '03f51dd65b8f4195c0a31797dea6d81d1caf7e95',
    id: 'range-test-20260619-3978',
    matching_hash: 'a774c562cf1c95ab958faaf2b9f384ac823e14b4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '3952fe0b4225a7b57d5de22a94c13dde0b11d668',
    id: 'range-test-20260619-3979',
    matching_hash: '6ef409e5d0bca5fa8aed909b527d6b50be62d4b4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '3fec48721d15bb0ec63612508210b9462e4fa3b0',
    id: 'range-test-20260619-3980',
    matching_hash: 'a621b1f0de70da3210b11d9241f9a5a1cf5cee6b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '0049f109f2ced41fab057870415fff4c2a887745',
    id: 'range-test-20260619-3981',
    matching_hash: 'ef39cb1a7922e3b3fe3f10ec84a63ceadfe3f6aa',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '4e5f51b61e080c37b257a29f55c12c9d181a2622',
    id: 'range-test-20260619-3982',
    matching_hash: '4a27f58e09e545c5ea4e2342bffe611cfd0a4e53',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'c60548e1a7c8284d493b621b18b48686f8d3f3f7',
    id: 'range-test-20260619-3983',
    matching_hash: '7aa8bffdf767e6230226bf3cd654dd64b395bf03',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '0a71581bc60b0fc65ade5170102e6e63f4046ed6',
    id: 'range-test-20260619-3984',
    matching_hash: '06081d14ad72b8b23053d85927b9c3ff2ff2d80e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'f35fb6dbd3c8da46771caef0c9506341fe0c03cc',
    id: 'range-test-20260619-3985',
    matching_hash: '04796019681ec41f6020e97fb1d2bb831785a3d3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '82cbd3efe7fbb2e82ceb1bbf2ef86f6b04df45b9',
    id: 'range-test-20260619-3986',
    matching_hash: '3fc458dfa9e72e5341a41adcdbf6e1cf44a601bf',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'e43574a107db46163760f9a6b68bdc38a2925b7b',
    id: 'range-test-20260619-3987',
    matching_hash: '794e5cc11f101aa3b2e4ce388c88f769df23c688',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'f31ff8ae12bd7d1a43f137454def6087d5d5fb25',
    id: 'range-test-20260619-3988',
    matching_hash: 'c0c099a7ffb181374a17110899decfcc2d7596c7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'cea73b8c6c1d6b49c218a3c26b53b35a89485f65',
    id: 'range-test-20260619-3989',
    matching_hash: '8d1150e385203c952d09bdece84f4d05295e0a67',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'fcb918f602c12ca8e44c9e20b617f83b55ac03aa',
    id: 'range-test-20260619-3990',
    matching_hash: '41e967ab85974628c7d34f9fb31a2e105212d68c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '28d61a006dd99efd4444ddf6dfbc579f8826b78e',
    id: 'range-test-20260619-3991',
    matching_hash: 'f23804cd7c9685901fd7660b41f70704b1cacb01',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '5321e23af14a2541c3a338990ee320f87caae0e2',
    id: 'range-test-20260619-3992',
    matching_hash: '846d1675ea5da36a8ab854f045e3701ddc5c263f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '5b787a9ffcf31f0f6ad7847b6da794537fc64234',
    id: 'range-test-20260619-3993',
    matching_hash: 'baa6ff0d52d4ab1d230e65b524563246b5b754bd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '5203d6c1709ae973aa7072ac331fef1b8d3c9746',
    id: 'range-test-20260619-3994',
    matching_hash: 'afe454c0678644cbe4e696bf46062ba4757c7f0a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'ca9be04c3073d627ec8aff6ce03b5cd532467238',
    id: 'range-test-20260619-3995',
    matching_hash: '54d30a1c527e2324f553f759073adb3d178d2f74',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '5851e17635ff6a3a570bb3bd6d0bf1f1d8b43017',
    id: 'range-test-20260619-3996',
    matching_hash: '3f7e8c5a5b2b1500cffd92a78c77c4cc7061947b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '8610568b1090690435c5431d949f772ab0ee5114',
    id: 'range-test-20260619-3997',
    matching_hash: '440b6fb43cbbed37c45394c7f353b2572df353e2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '4d6b4aa42b53e414f23f13183286f33de072f867',
    id: 'range-test-20260619-3998',
    matching_hash: 'f4fdb049173720a44d41489cdff31e9a5fd50908',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '25f42129df6cd930bbc9f8b53cde1aa70bf61410',
    id: 'range-test-20260619-3999',
    matching_hash: '261284e7acf9e215c60f1bdb095db34564305169',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'fae7c1435a35fb8c377a19768bd8a476e874f429',
    id: 'range-test-20260619-4000',
    matching_hash: '5d1f9f2e435e21d49cc7895d76887c9e4a53fa34',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'ec6345a00e262d7c5962f465bb783bf9fdb67f3f',
    id: 'range-test-20260619-4001',
    matching_hash: '263b94be28ba4f5c43ac71f98726154ff549580b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'c9f6d2e20b97fee67f94cad9b3c0401a76dcd91a',
    id: 'range-test-20260619-4002',
    matching_hash: '552800b3f04d05903aa8b4f899248a132bd75ad0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '558370f76337e90960f5e08a266a709233d8d54c',
    id: 'range-test-20260619-4003',
    matching_hash: '2e78b7b588d281b6ff53c59b60136bbe9004442a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'b1e7f73f708be109b4bf822d08bd5cd799ed5679',
    id: 'range-test-20260619-4004',
    matching_hash: 'db2c309695ef51e24c6b75600049217b23f06d3f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '1ce614645841b27af4303a1e042aea53c4cb2adf',
    id: 'range-test-20260619-4005',
    matching_hash: '95a334c8cd2a8a8832e926d91c87df392da3d6a7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '6883666f758a1dab41e5ab3f0b9bc81eb3a6af50',
    id: 'range-test-20260619-4006',
    matching_hash: '9d8fca0da89f9ab4fe47235f220b01d78fc4d8e7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '16d7eb0ee2b00bc7610e5df9f78bbb5f13bbb275',
    id: 'range-test-20260619-4007',
    matching_hash: '73b4d915c93df57e73f1b465e11e5341ddec215e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '351b3beaee1820225c6ff961bd49b814d2d7a247',
    id: 'range-test-20260619-4008',
    matching_hash: '842c9bf689cd8fbd2dfac05863cc783f07e1639d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '9f66031665ba74d7e2910db7dc1f763365cbeb9a',
    id: 'range-test-20260619-4009',
    matching_hash: '53f1cb7365f6b42ea92c8c11408a727f0c8930b1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'efdbf468e059d05650a1a8a642139a3b2f249ddd',
    id: 'range-test-20260619-4010',
    matching_hash: 'ccaf6efa2ddb8658eee420b2fc49f22e767ea6ff',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'ec6303be27590c69c69747e3212fc7e69d254345',
    id: 'range-test-20260619-4011',
    matching_hash: '423a967d7d64f06e17be01287cd4e004a08771da',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'f9eb44037b5774795ba94ea01fcdb0fb0f7f4271',
    id: 'range-test-20260619-4012',
    matching_hash: '0ceceeffd0e41ee6fa92027341193101e44d9ddf',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'b6fb93f59d75d7d187a83171cf7e9133c4579c2a',
    id: 'range-test-20260619-4013',
    matching_hash: '36372315480734111020551fc3e75d60b0feb0d9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'a3b20bed26f2b3126c939e418410e46cc5243d55',
    id: 'range-test-20260619-4014',
    matching_hash: '77265ab73d757cca812c860c427fd8ad5144a4ab',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '772bb7ae05f87b46b8ae6d024e5eea5b6da1ff4b',
    id: 'range-test-20260619-4015',
    matching_hash: 'a99954d6e7f609b685ce4f9479405b7c935b4561',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '2e0d6f6eaf14856573302d6e79b6dae54ed56880',
    id: 'range-test-20260619-4016',
    matching_hash: 'fd452820e7fc4fcd38c96f06cc8074171f4dd76c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '5d8d9e7240a57ad73383557a315cf5ad4dbe1358',
    id: 'range-test-20260619-4017',
    matching_hash: '0172f817dedaaedc972c66de8fc50511e9267c8f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'c139cc23e677adae2562c82024019d4d1117fb84',
    id: 'range-test-20260619-4018',
    matching_hash: '0e1b1ecd99cc0c70b81ea3de800a73533fc95180',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'ff9f9f8f41d177faa764734ba71d2894e66a92d1',
    id: 'range-test-20260619-4019',
    matching_hash: '59a36b89be7c41c81d9859c8dd5c75fa58e5a851',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '01361713138989394813596768945180d1411bb7',
    id: 'range-test-20260619-4020',
    matching_hash: 'c2a36a1e28b86ed3014a70c40865b879a2c02998',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '17293b5aee44d67882d5d84856355d121ff8aeb7',
    id: 'range-test-20260619-4021',
    matching_hash: 'ed890627d92f9367b81800f2e558f83832275525',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '371834b838a819474e3dedfefad02aed829b2efa',
    id: 'range-test-20260619-4022',
    matching_hash: '9715888b5fed3259cd346ff3fbc6a8208717957d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'a9fbf1d73c049d43ac937a469ef0f20b231cc3f2',
    id: 'range-test-20260619-4023',
    matching_hash: '5ee4a7de428e5cc5c7a2d88f714fd572a3b88d0c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'f9ba138db7a7264d3d49fd31c49849ebd7125250',
    id: 'range-test-20260619-4024',
    matching_hash: 'f1dacda107bcf27086e146de49041d0d3c9980e4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -4.5,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'c2782ce0c3780ee5f6e4b8032190f5262b8bd8b7',
    id: 'range-test-20260619-4025',
    matching_hash: 'be0ae5150d6da43f7d7aecf9f8b67a40825ddfea',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '61a858db165755a06513d7cfea4ff99b2ba33c58',
    id: 'range-test-20260619-4026',
    matching_hash: 'a21618b9df2a94c2039eb8815d63025761aba1bd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '8df6cbe10fb1e08a68b162ab5947545920893416',
    id: 'range-test-20260619-4027',
    matching_hash: 'bf33de72698f7c55b5624369d79dc05ae79121a3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'a9b38c74359065e0c573022768923209a3569ba1',
    id: 'range-test-20260619-4028',
    matching_hash: '0193d496d6b02eb2c1a7f6b10515f4818879de1e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '0a22ef423b84e572bc2ae9b52e09ca39b6a62c8d',
    id: 'range-test-20260619-4029',
    matching_hash: '6709ab379c51b31bbba2b65cac9b1d3785700fb5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'ac232084388677471225d63f7a1f2dad5f3bb1e2',
    id: 'range-test-20260619-4030',
    matching_hash: '9ba3e08e0ae8b0ba28505d5c5776b133e0d7d08d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '05681edba05c3b112d663fff82ab51d7d03a0583',
    id: 'range-test-20260619-4031',
    matching_hash: '544b16fbea6263b21c11fc0741e1b27acbbbc058',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '8ca6638191b1fbc133636b73cf797c5696df4e7e',
    id: 'range-test-20260619-4032',
    matching_hash: '96f1620eee9600c53eb20259f5c994f15f9d9e10',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'f97ff758a21621c8bd04a8024850a1cfe5396fc4',
    id: 'range-test-20260619-4033',
    matching_hash: '687bc33467c51502252f9792ee781711e00e6dfa',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '818679d866994cdbee45530aeb97dab93cc32a66',
    id: 'range-test-20260619-4034',
    matching_hash: '4882a156c056b56f283ee24167c6114455288bec',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '276c96db9d663a2bae36771b3f0c20c492f9da7b',
    id: 'range-test-20260619-4035',
    matching_hash: 'dfde295dfc384192ba33dd21f40273f17fdf560c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '8d8f90ee1f41ed33970cbd94b26380033f576492',
    id: 'range-test-20260619-4036',
    matching_hash: 'b5bb46496ca646a1963973eba26fddca76f40045',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '9e9942928a0ed8a15243b037622354a0294e5006',
    id: 'range-test-20260619-4037',
    matching_hash: 'c8b592eebe2abe98f3aeda8d373ac8af0511711f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '5e43b969d422744bafae974f4a822ae3d59c26a3',
    id: 'range-test-20260619-4038',
    matching_hash: 'c528965cba999aaf5696d3563b086ca8e9f08384',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'e6e0f45db6c1b3428e410f7c2eb340395612e3bd',
    id: 'range-test-20260619-4039',
    matching_hash: '5bc1b348a0591f20d3bbee7bf5f0ea4588665a96',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.991914234,
    qx: -0.057658309,
    qy: 0.010493484,
    qz: -0.112568021,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '50a26d4fdb67bee6e409509b4c08beeabd5f9c23',
    id: 'range-test-20260619-4040',
    matching_hash: '6f0f6bfd517e09a1f453974bb2e2267f65701885',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '29e3d50fbfffb37d24bf928078cf031908214487',
    id: 'range-test-20260619-4041',
    matching_hash: '2dd56862d32057385d3f18501f10775774224001',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'cdfca9b7c2a865ebebba74b88976d5cac2bf3be3',
    id: 'range-test-20260619-4042',
    matching_hash: '8d1529bf1fbe84bc9da330fdeec25f7cd0567efd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'dc23c40fd561a2c4553417f320533cdb7eaf4682',
    id: 'range-test-20260619-4043',
    matching_hash: 'a403458c17eb00fa7b242f10412e863c98465936',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '8bee2554302ea87630ae82b1d6698c72e09efe52',
    id: 'range-test-20260619-4044',
    matching_hash: 'bbee12dd9e5b0d12790764eab86f2598855d1d8b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '554815f55278504c2f8c9980e835bdf064e0c735',
    id: 'range-test-20260619-4045',
    matching_hash: '4b762e111651802c17a5fbc76bd75f118dd6bd17',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '5ee6a1b7afdad066c9110068c9661eed0d86487c',
    id: 'range-test-20260619-4046',
    matching_hash: '77611fa28d22765155eb6e7e79dadb3b2b8bc635',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '0f488ec35940d3a3cea169fe71b7fad7f71ebc36',
    id: 'range-test-20260619-4047',
    matching_hash: 'cc8b47dd3713dcd9bd57e5b2588c6f392d95cc3e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '2119722ee744ccbbbdec56097c529d48cb253155',
    id: 'range-test-20260619-4048',
    matching_hash: 'ee982e8fc1ecdb0585d6c0da26116662b458fc4b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '0386967cc1471f8dcf96bc15d5a6a96690173619',
    id: 'range-test-20260619-4049',
    matching_hash: '353812f2a09452e92f13dbbcdf3853c2d02c8082',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'b44c16cb968ec52ce1241cf7cddbca124d720209',
    id: 'range-test-20260619-4050',
    matching_hash: '4b591284e7388b983f139aceff336e57adb8b5ab',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '6be893e53e006c8cf8258e6e8277975ae4d6f7bf',
    id: 'range-test-20260619-4051',
    matching_hash: '49a098c94c88a0656c109fb25a66197f31d8ad69',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'cb37fb4469f16afddc828f72bc0d2a223fbb1b05',
    id: 'range-test-20260619-4052',
    matching_hash: 'ea3501877a3cdfb195ae286336e963a3130384bf',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'ebb4302329109157ae47bdb9d8a3f76b1857e51f',
    id: 'range-test-20260619-4053',
    matching_hash: '23a8b7f1b6250db8cd87a21a21374b0fcab6cbf7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'ec00fa43fc13debaeeb34edc4feb287b171da0f5',
    id: 'range-test-20260619-4054',
    matching_hash: '54aaede758bd3e562cd69aba74af1bbc4edfa4c4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'a9c127f52ffc7ad5cc9f4c3d949f3cdcaa699bac',
    id: 'range-test-20260619-4055',
    matching_hash: 'b7b5aadf332c88eecfcbcdce4b5e4ea61879ee70',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '34ce55b261a61eba4de29a16789e7778551623db',
    id: 'range-test-20260619-4056',
    matching_hash: 'c7da30b7b1a26d939c60b0755d8e6459d8eefdcd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'b668e610a7e1aabb885d47a918313d9ea02acbce',
    id: 'range-test-20260619-4057',
    matching_hash: '485d81deacd5807046608dbdb2b582648d560ec7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '660990aab6d5d06b69936d1f973cbf67d12082ac',
    id: 'range-test-20260619-4058',
    matching_hash: 'f7431998cc07351b7679737f516191d6698c6e1c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '392294ca725d39375642386b5acfdb3006ec4cf1',
    id: 'range-test-20260619-4059',
    matching_hash: '4d4b7db387af20ac6bd066e224f9d59b89ce9946',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '499bf7d848f581c53fd28b64086402a564f28527',
    id: 'range-test-20260619-4060',
    matching_hash: '0132b465d458e61ee4616080c26db927306c4194',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '440bb94e881660145bdb3a281cd328732af00d29',
    id: 'range-test-20260619-4061',
    matching_hash: '45e9626345781c1b15f49a10e0f7c95e5104efed',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'bab9f34fb2692bbf3865b1f77fcc0ba135e8552e',
    id: 'range-test-20260619-4062',
    matching_hash: '6289cabf8f47e49072db9ea047b9ca2bdfe0d0da',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '17714da448f1d2036618f752eb9b65d4273d3875',
    id: 'range-test-20260619-4063',
    matching_hash: '188e7fbf84881b4e8728c346ad47771059df11ff',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'ba1b1606024028143f5215c361b9a9936e7ea56c',
    id: 'range-test-20260619-4064',
    matching_hash: '6937d664d1c5bd9910b933d1f3e586ca922a4a08',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '9dd56e2dca78609d6b942fe2d59b516f473225e7',
    id: 'range-test-20260619-4065',
    matching_hash: 'd33e8577f6650a98e4798a691f9df4d242966962',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '403d0076a88e91392092d750207a97612628d595',
    id: 'range-test-20260619-4066',
    matching_hash: '886c04eb6d6138eea546364527ec2a657dab9d38',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '147d9dea0afbca65e466f79fdcb96b41877192e0',
    id: 'range-test-20260619-4067',
    matching_hash: 'c6f1f459d08cc1e74df4964570a131aa6cecc606',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '97dc678fc66dc07598363ddd1ac59069e7b11d4a',
    id: 'range-test-20260619-4068',
    matching_hash: '3d5a314e80fa50b02d52c5d4fcd7be2509b1d64c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '660b34e4d36cd77d5a24d87b68c29e0718afdf69',
    id: 'range-test-20260619-4069',
    matching_hash: '4c7db9e055bd60b615900cf16929e7aea51c53e1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'bfde9e3eabc24283c2b8082a6f01b9573e4ff34f',
    id: 'range-test-20260619-4070',
    matching_hash: 'abccca49054a6f803dbb519df8e34c35cf2c54b2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'a4d045970347b9a38f21a1317171427ef9264f78',
    id: 'range-test-20260619-4071',
    matching_hash: 'be2315b6ef4ea66bf6b2cdbb7044ddbf1078180e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '53007f395d2b66f21099b0ce26fc0d245e9cce75',
    id: 'range-test-20260619-4072',
    matching_hash: '297d66c702f85139d22f8cf52033e03ea378bf67',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'e437a6d83a91709b2b7590211946e2a9746a81d6',
    id: 'range-test-20260619-4073',
    matching_hash: '2fe0e8abfb9827a16041099fe371c3c6240d0b12',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'c641d5780036a596cf04ed8728986ddbb566760d',
    id: 'range-test-20260619-4074',
    matching_hash: '0d09e9ebae9d5ac995e0cc6516644080c9d17efa',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '060c0703e68d3194e01efc9ef8c94bd95998045d',
    id: 'range-test-20260619-4075',
    matching_hash: 'ca94b4ec4f295919ed8e6109db7a2026d448d191',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'a4c570abc2e465f2537b8481a5b2d7be97232a3f',
    id: 'range-test-20260619-4076',
    matching_hash: '61bd45f69099a0a3f1fb499136e3ed2efe6e5bb4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '6e090dc0e3b5c2f7feb71f5ab8bb205d08d9199d',
    id: 'range-test-20260619-4077',
    matching_hash: '7507b53594518221aa502952bba57c06e56882ae',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '3976c1858ca4255d6401fa4091aa52140b50838e',
    id: 'range-test-20260619-4078',
    matching_hash: '7dd53571aacddbd280bdbd5630834f45341c7468',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '8eb9a43a692cffc1c110b7ea639ca5f33cf0db03',
    id: 'range-test-20260619-4079',
    matching_hash: 'ecb59e587a85521e88faaa635aea7211baa137f0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '73c2c11218484813f7c22b820e09a1d4a4dbddf4',
    id: 'range-test-20260619-4080',
    matching_hash: '1ea907159b8ba5b76c44abc22edcae2b29e084ee',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '085d62f1e2b355cb08627fb067a3d0f4be3337a1',
    id: 'range-test-20260619-4081',
    matching_hash: 'a52b988ba509f2b1994571f58202caa6f28681fe',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'c997ca674a7f3e50614b360d497e8191319a1c00',
    id: 'range-test-20260619-4082',
    matching_hash: 'a6873959517f258d7fa9b9673735c81a44def5d2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'ea1f6c0fab80cbd9d7b0cd8188c3f5e79b90741e',
    id: 'range-test-20260619-4083',
    matching_hash: 'eaf52b7102a7944fad3dfc85991e8140794f4d3d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '7c7593b8886b26625656210a633a00e462cd58ca',
    id: 'range-test-20260619-4084',
    matching_hash: 'f250ec753c2683ef0904873209d4417a8cf72fd5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'ad89cefbd0a372bdd636e912ed55b3ea0615dcae',
    id: 'range-test-20260619-4085',
    matching_hash: '773c2a9bd5242f398e954fb01b40c5b5aa8c0727',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '96ec59d8ef5e356c5e3e9c47bd44a6280b9b0e9f',
    id: 'range-test-20260619-4086',
    matching_hash: '23b6fb0197efcb7a9d9fc295a2d596f6cc28c25d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '274794893fccd06ad4e4cc814bca7e76f05c8d2e',
    id: 'range-test-20260619-4087',
    matching_hash: '0e8632999bf38a45d8c5822030547d1993992a54',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '1f6785a56d1a7ca0b5578f7cf4450d3060e3eefe',
    id: 'range-test-20260619-4088',
    matching_hash: '96c7ed84dc20f37eacd66fc49ce69ee442883596',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '63f35b56f85e071a7cb1f6302dbe721cd30f4175',
    id: 'range-test-20260619-4089',
    matching_hash: '8f2358b93db53ec718dcf18954e3f84785229653',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '0d42052242241db4ff640cec19d2b00f6fdd2403',
    id: 'range-test-20260619-4090',
    matching_hash: '94c1302b2f7adc98e0fee4e4081bb31b27456ab2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'eb26f5c2da1774dd94a1a340060634c83d1d9fcf',
    id: 'range-test-20260619-4091',
    matching_hash: '180634a6e91f2a54f6a74e94ea664c436f0015ae',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'ad22dd629eecfc8c2b9da33148f491a5494077d5',
    id: 'range-test-20260619-4092',
    matching_hash: '17f0a8a3af684c4a4053323268957457a28d96d1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '200a06beb486f31dd0b7cffa56727ac2e3893818',
    id: 'range-test-20260619-4093',
    matching_hash: '84fcea5f3e82af6c54d6bd7b654c175ef0739c02',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'bc2811858ee1faba122e6077bae68db9051df772',
    id: 'range-test-20260619-4094',
    matching_hash: 'c05286119a8d916395a24fd0d2107499e390a8d5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'ddae02c3cb969f6922a6533cc5df4f07333fa97d',
    id: 'range-test-20260619-4095',
    matching_hash: 'cce18ee4b2f0e36be0270d4484286cf24db27236',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'b88d7b93795a13e1071b91db7bcd378fb7088654',
    id: 'range-test-20260619-4096',
    matching_hash: 'c3b41a67dbfd3ed54dfe32abd9104e3d55906d97',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '41f6060a6a831fd0cfb9632eb96abe6cff1d4c9b',
    id: 'range-test-20260619-4097',
    matching_hash: '18b744dd6f3af53a05675e7f366da25269f5c9dd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '627a6dcadffedeeee0fa39afb31714b72427f2aa',
    id: 'range-test-20260619-4098',
    matching_hash: '2d8d822efd9f21245d3ce47e0aa4507f4049b2f6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'e13ea5a2171afd554eed6469d4d0d3ea93454812',
    id: 'range-test-20260619-4099',
    matching_hash: 'fcc8ce1fb78168b11dae02c643c5e3403743bd2a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '091e04500e0754bff1ff20d0485b63bbf5a6c6ca',
    id: 'range-test-20260619-4100',
    matching_hash: 'c58a5097883ed9afb4e17da18b433ed5d0ac348f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '6fad32d2e9fc7bcb8698ca5abb7031f72fd8bcaf',
    id: 'range-test-20260619-4101',
    matching_hash: '6401d4831c8e5bdcb3000b24e7e682a4ae7e9203',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '51183d0b11cb58de4d82e43bd0ac50cd86a65b3e',
    id: 'range-test-20260619-4102',
    matching_hash: '04bca4b77702f4d374910fb7db7064455b517185',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'd2facb34efbec4f62f16c9f906a4900c15d7b9c4',
    id: 'range-test-20260619-4103',
    matching_hash: 'aa6467c12722415ff92839d3462cfb2c82f6148b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '88e086786c91a41427570e92fafc763a19a901e8',
    id: 'range-test-20260619-4104',
    matching_hash: '1b10e08ca294607f43038eed4df13dea49c2c9e2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '9c024a8f18fc30ad4b0583f594af964b72a837f0',
    id: 'range-test-20260619-4105',
    matching_hash: '9bcbe9d521bad930520809500596f17cd793230c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '002ea05cbf4a48df4f7b164ddb6e57247445cbfa',
    id: 'range-test-20260619-4106',
    matching_hash: '2c62d12961b1bc38c915b32f38b67891eb9a56e4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '39151e687adf7f5c44dcc58be2399456dc05e13a',
    id: 'range-test-20260619-4107',
    matching_hash: '39b6282080881baf1546947cdd7b8d96d3dd2f0e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'f2754a998fd35fe8c128fbb6e78b717f079c283a',
    id: 'range-test-20260619-4108',
    matching_hash: '143e2174f6afd24e4fa5349b550f4e89671f400f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '31efb3131a5e839e6ca7a63e259140b3f225717d',
    id: 'range-test-20260619-4109',
    matching_hash: 'b64ca3cbd2cf2bc1fea1e0584a43c785ffb19c7a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'b2185460dfb69f662502f717db259e8abc0b92fc',
    id: 'range-test-20260619-4110',
    matching_hash: '6f0f6bfd517e09a1f453974bb2e2267f65701885',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '5503ed2e0fad3d8546ce4139905ed8ae6d126ea9',
    id: 'range-test-20260619-4111',
    matching_hash: '2dd56862d32057385d3f18501f10775774224001',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '277199c1c7e0bc3e497e232212c365e6ce914d46',
    id: 'range-test-20260619-4112',
    matching_hash: '8d1529bf1fbe84bc9da330fdeec25f7cd0567efd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '2eb8d143a2bb1eea2dd96506ea6a8ae67510ba1b',
    id: 'range-test-20260619-4113',
    matching_hash: 'a403458c17eb00fa7b242f10412e863c98465936',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'e5c6b996a546ae71b72423ab464882457dfa9472',
    id: 'range-test-20260619-4114',
    matching_hash: 'bbee12dd9e5b0d12790764eab86f2598855d1d8b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'c7932f71c69a81b900bf2d58b60a9a7a2435ff41',
    id: 'range-test-20260619-4115',
    matching_hash: '4b762e111651802c17a5fbc76bd75f118dd6bd17',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '98604c519299650e2e3bd41a9bace52eaa9dc0cb',
    id: 'range-test-20260619-4116',
    matching_hash: '77611fa28d22765155eb6e7e79dadb3b2b8bc635',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '7a7b0b117cb329740a9ac95eed1ee41e6caf90a5',
    id: 'range-test-20260619-4117',
    matching_hash: 'cc8b47dd3713dcd9bd57e5b2588c6f392d95cc3e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '3b43f40805b53ad0099940b34f3a9178bc979051',
    id: 'range-test-20260619-4118',
    matching_hash: 'ee982e8fc1ecdb0585d6c0da26116662b458fc4b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'f44e40611a89d02bb94270ea85509e6d2bac2054',
    id: 'range-test-20260619-4119',
    matching_hash: '353812f2a09452e92f13dbbcdf3853c2d02c8082',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'f085ed3865100c2c46945c58c8fbf67787a22708',
    id: 'range-test-20260619-4120',
    matching_hash: '4b591284e7388b983f139aceff336e57adb8b5ab',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '4aff22fc70159880d9617ac5c78240ea6de9d9f5',
    id: 'range-test-20260619-4121',
    matching_hash: '49a098c94c88a0656c109fb25a66197f31d8ad69',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '202520f8255379f54950c71f04ce75ca9be36517',
    id: 'range-test-20260619-4122',
    matching_hash: 'ea3501877a3cdfb195ae286336e963a3130384bf',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'ed1572a9d05e49b19d822be435dabd7d59ba0423',
    id: 'range-test-20260619-4123',
    matching_hash: '23a8b7f1b6250db8cd87a21a21374b0fcab6cbf7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'cd6e1ef6b5c6d6b5b3d7eb12c99c9c4de584acce',
    id: 'range-test-20260619-4124',
    matching_hash: '54aaede758bd3e562cd69aba74af1bbc4edfa4c4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '4b411cd334c36f325d6e9f2a5ac3131ef5fe349c',
    id: 'range-test-20260619-4125',
    matching_hash: 'b7b5aadf332c88eecfcbcdce4b5e4ea61879ee70',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '76c2ebbb2e4805763f2b2437b99c98e37226b178',
    id: 'range-test-20260619-4126',
    matching_hash: 'c7da30b7b1a26d939c60b0755d8e6459d8eefdcd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '2ebe42a3012ba3a60e8d2326860de4b2e71f4b13',
    id: 'range-test-20260619-4127',
    matching_hash: '485d81deacd5807046608dbdb2b582648d560ec7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '852e558d3f4fc1e0194104a07b8ddfe982b8dbe1',
    id: 'range-test-20260619-4128',
    matching_hash: 'f7431998cc07351b7679737f516191d6698c6e1c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'da18b1343503c4897e77c6c5e53387dcb3f91297',
    id: 'range-test-20260619-4129',
    matching_hash: '4d4b7db387af20ac6bd066e224f9d59b89ce9946',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '1ecbaf5a6f51d0dbc94be4e14a8a99867134b392',
    id: 'range-test-20260619-4130',
    matching_hash: '12a5272032870922caebdd531c133f95e6bb11a6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '5582292564d44a6bf0987a6507f2460eaaf70e2c',
    id: 'range-test-20260619-4131',
    matching_hash: '742d22c670a6a201f7fe055e35ed61ce9e979819',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '59522256cf72037d5b077503e4d983e8d5c3624a',
    id: 'range-test-20260619-4132',
    matching_hash: '0f17351f10b85bb3e7ad582d843306c1eb8e0861',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'bd69ab658eaa380da278a1959009a69649454909',
    id: 'range-test-20260619-4133',
    matching_hash: 'f5ad350ae80d56c78f46ed4cad26fc2e5c2aadc0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '4bce5982cc6ead14f6b92e3151ca9ee7bd050b20',
    id: 'range-test-20260619-4134',
    matching_hash: '69bea282fd71eb916ff9dc57e53706c512cc90dc',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '445dac272f7af0ca1c1306ec6553783f0d1433e5',
    id: 'range-test-20260619-4135',
    matching_hash: 'ab0a003e3f11abced90a08525af9a9200ed0b4e5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '06c1fea7a4f1c00217279a728050029da8830c8f',
    id: 'range-test-20260619-4136',
    matching_hash: '6a958d3fbe5c3822b052b30a8385fef63b997bce',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '0dc19de5a7c266d3f6e308b588437cdb12b249b7',
    id: 'range-test-20260619-4137',
    matching_hash: 'd41cb88de7f2cd167f431bacce14dbbb08e954d0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'f884cbfc9c6471c3eb7a8ee61c2ab76b6cc22c8d',
    id: 'range-test-20260619-4138',
    matching_hash: 'c06500d3c23a7fd5ae79f1cac2a77690566a19d9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'b6377aaf56a01c2fe9c1e4981685f64f9af46009',
    id: 'range-test-20260619-4139',
    matching_hash: 'b88ffa259dbb2097745c0c9cfe6a5ad2b91aab41',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '32f0b0c524590a6d54b384d3bdc6cc752d42f6aa',
    id: 'range-test-20260619-4140',
    matching_hash: '4096c0bf5b33f7e69d8867a0bf672fcc83c39882',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.615463197,
    qx: -0.750269256,
    qy: -0.095599915,
    qz: -0.221724498,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'c3b54bab5b55a27c47b9c0991280d6aa5c9f043e',
    id: 'range-test-20260619-4141',
    matching_hash: '00ee18da88e3fee881ba7e8cb639edfb1eb80f83',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '5bdb43c8919990b62e40b6e3408a2f9b97739ff2',
    id: 'range-test-20260619-4142',
    matching_hash: 'c145c62e3b7c03453938109e576b235108184fc6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '06b9f33563dc9f7c55b07cb9b837f0da4eba6286',
    id: 'range-test-20260619-4143',
    matching_hash: '93b26195ba1abab830f905bbc8ea68038bc6248a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '6e11e73ec7274645a933d6912c118b9f683c661f',
    id: 'range-test-20260619-4144',
    matching_hash: '4780a5c7553d2fd3d6b5cfb82c9b4bde9688bf22',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'fdca1a6df3bac3b1336fb10823b31a990085f8bb',
    id: 'range-test-20260619-4145',
    matching_hash: '0dff89ff2efd6e704bba54fd770f73c4d5789228',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '64e5eaf2b7ed7de22332ba99a4ece8e0c0abb1e7',
    id: 'range-test-20260619-4146',
    matching_hash: '1952b3afccfdc5970cea2c5c01dd72d7b937eebe',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '0f3e8795b81e62cc55c080d2b7275929006c14d0',
    id: 'range-test-20260619-4147',
    matching_hash: 'ad046cb365b58c128b4f89fc985f67ca0ad2a196',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'f7359797718b87c7c11918cd8dba230a7aafff7a',
    id: 'range-test-20260619-4148',
    matching_hash: '6f05e8c87cccda7d8b03c02b8cc608773df397d3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'dd78b139d446380684490670c235f8e4bca3f632',
    id: 'range-test-20260619-4149',
    matching_hash: '7afcd9aed30654f32f0a01e527d626ab394ba6e6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'f370bf178d0b8dfdb51de4687495f477ef001a7c',
    id: 'range-test-20260619-4150',
    matching_hash: '3e04447d55e58b726a2e9db8a4a98d4d922ba462',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'fd6052bc084c8b6d363126f672fbb9961e343d1d',
    id: 'range-test-20260619-4151',
    matching_hash: 'b14b989421a1b5379c52f3d00dc22749a43654d9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'ca63c07679141e29daa2457e67f7d3bf97e51873',
    id: 'range-test-20260619-4152',
    matching_hash: '4a798cfe85d0009697ffe1b521ea1c7b16458d18',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'd171d9a3aa00ff57d48132149fd16a112cfb5db1',
    id: 'range-test-20260619-4153',
    matching_hash: 'e5ca90e5ba4d8277a522c1f8637cafec59f077c5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '3afa842bc6517656d8a5730a2aeb5721026ff0c2',
    id: 'range-test-20260619-4154',
    matching_hash: '5fb46561210a6421ecd9eef201edbff2089e84b1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'b381ece5e7a169cb3969b41fbc9e00c9138c037a',
    id: 'range-test-20260619-4155',
    matching_hash: 'f9ffbf2a954191c1c005e4cbb3d25bfdd3a3bd1b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'f2ee5422f2839880ca900ec9e2b8aaa2dbc53086',
    id: 'range-test-20260619-4156',
    matching_hash: '00e72a904c1eb0d6a516dfd9cfa69d034e4953e7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'b5f93cf8ae1b5d686f47e9a1463822b8394b8762',
    id: 'range-test-20260619-4157',
    matching_hash: '458ab7b6a4e07aa1ab79d67c7dd2f12ca82ef63a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '12de00d7cd4822ef3f96b8fe29f981cf387df25e',
    id: 'range-test-20260619-4158',
    matching_hash: '859541f56b0759f07ac4f6c5923c6620195691e8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '8c9c5beb431ab12eec24179562092eb2546e3f70',
    id: 'range-test-20260619-4159',
    matching_hash: '7585fa14b3c5aad2c45243895426a417894ec9d9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'f8601e19f5f67f9327e5b4770efb6b7577f95066',
    id: 'range-test-20260619-4160',
    matching_hash: 'fe95eda3c3f61a359cd5c19d24ccd626d8e36e1b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'f252f67bbcc84ea22a979c1b2a0b29383d298e3f',
    id: 'range-test-20260619-4161',
    matching_hash: '9e0533ef3f35f78e213d54d62706bfbef5cd7ada',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '62a56edba9a88ac81657f2cf2a937dcfb3875e6e',
    id: 'range-test-20260619-4162',
    matching_hash: '742e9a0a4688984bfaffd1a7fc529019dca91e4c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '2ed61bc5f3a086c9ff8fdedbacb1811699cec273',
    id: 'range-test-20260619-4163',
    matching_hash: '900b94764b78194121fb5b34aa7198963c7ee6d3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '090cc360062137fc7ac80770985992ce87d29360',
    id: 'range-test-20260619-4164',
    matching_hash: 'fc8c31ead0999b8a2d91bdd937f37ea777a0d239',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '7cc1566fea263daea90b416e59580c2800adddbf',
    id: 'range-test-20260619-4165',
    matching_hash: '9a4a589ad0d7530de5d9ef67e9ce192eb68f1008',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'c071bf74ea864d70e902b7a459e34e621c4e3cb2',
    id: 'range-test-20260619-4166',
    matching_hash: '35f1bbb8c47871fcdb566c9f346cea6386ce22af',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '2d066786527159f62cb79d936fa981feeeeac50f',
    id: 'range-test-20260619-4167',
    matching_hash: 'a452735a41bdaca9b9eb0743f9103c09bd42c533',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '5fe7047113426dc125e6449567036ef282e2e1d6',
    id: 'range-test-20260619-4168',
    matching_hash: '7919597a91073ea7a2b1972b82aa3faa9c82b1fa',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'c42c8aff4a52fc291702eb3e10a6bc9f9b4785b7',
    id: 'range-test-20260619-4169',
    matching_hash: '5c7f75bfb3b17b6d732014ce134ecb40fbf19f0f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '6cdfe580ffd2e6f63b763e917348d04f0d2746e6',
    id: 'range-test-20260619-4170',
    matching_hash: '4e31981cc15766c6aaac55fb97b9a5a9874586a5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'fdea756507e38fe529080ffc221ac7da78b9bb81',
    id: 'range-test-20260619-4171',
    matching_hash: '79894d0c98091fc8dbf78c748cfd03481538243f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'e8d662ba7501d9828a6848fb3a6dc0a469fa0761',
    id: 'range-test-20260619-4172',
    matching_hash: '9f426bc85c5d391e64fdbb92e8db54d99faaf499',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'a23caf3b0c90eb7388584e269a0b1d05dfc791e3',
    id: 'range-test-20260619-4173',
    matching_hash: 'ccfb1be6c95a8fb2e9ed4498e6e48398dcbaa976',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '24b1d208e9846d8ce04d94a0a7a61d277fea335d',
    id: 'range-test-20260619-4174',
    matching_hash: '3daf4db94eef6009364bd2adc3b7d51ef1189185',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '7d27e8c8c14ddf12876dd38f0ea75190eef671c9',
    id: 'range-test-20260619-4175',
    matching_hash: 'f8e3576381750d0f2f507cdfef50afc7c658b399',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '3e3f7926a646e19d12f8e011e2ff64c18145aebf',
    id: 'range-test-20260619-4176',
    matching_hash: 'f3c2541fd6feff2a750a171751cedaae661550ae',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'a27fba991aad2ec0694c4db8cf05dfd49e8848e2',
    id: 'range-test-20260619-4177',
    matching_hash: 'bb60f5a5593b21910a1dcbb7bfeebb07687dbd4d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'f23b762c1a6c61f2f5a6cc0cad0e144efec2b1fd',
    id: 'range-test-20260619-4178',
    matching_hash: 'de8d7570de164f7e67088bf1e8ef512896573c6c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'f6eb4c6c2fb0db14fb6e9bbfe36daf12b09624a0',
    id: 'range-test-20260619-4179',
    matching_hash: '9708f95d6999d10fa279428f951ab7acc6a3686d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'b985b5df4202753c5b967889681dd011c3e53829',
    id: 'range-test-20260619-4180',
    matching_hash: 'ff6a8b8434e6360d973bb996903b3e72ee10ce84',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'ed8b68594eba3e2d72d760419ba7ac588e6e9821',
    id: 'range-test-20260619-4181',
    matching_hash: '90e1ed49fb0534926cda6cd2d8e231e94e50409d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '15f7a018f465634a801449800d0505a5359c2969',
    id: 'range-test-20260619-4182',
    matching_hash: 'e2a7333604aa34d244e73b1cfbd5bba7264d5689',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'f5330be4b887b23663ee52fd89525e26f3cac918',
    id: 'range-test-20260619-4183',
    matching_hash: 'f9379e4daea707cf86307f98cf724af3cd7af15f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'ad55ef96e4fbb81363855ec517aa7a56b7592a89',
    id: 'range-test-20260619-4184',
    matching_hash: 'a0ed9281acd74e7e360c2142d7d662d356b61b4e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '178f4f146eefa1efc2ab2b7d46940e7572233252',
    id: 'range-test-20260619-4185',
    matching_hash: '9bfd3d72747b9dc6d702e89481b389991679eb32',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '760c13a4568876ffa69cae4b2df7c9d864b84811',
    id: 'range-test-20260619-4186',
    matching_hash: '8b8542536cc55f728e22b8ceec5ddeac704240c8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'e9ea7b1303c1d5f97e3fd634b40a4e6f1979d413',
    id: 'range-test-20260619-4187',
    matching_hash: 'fb5cf69d9ebbf79339c8b3bd073f2a1f9a3527e4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '2775fc086e1b07fbf6f0879aa4671b1b52e4fe96',
    id: 'range-test-20260619-4188',
    matching_hash: 'bfd447907681c7892947fa838ce9d9764e9493ec',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '17bf833ce645fdbae22870728388c2ba78873a8c',
    id: 'range-test-20260619-4189',
    matching_hash: '12660c084648f4ed689ee1f32954a9ae87e532a5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '41ee2e0de194c6a3c923b7c075a6967a26076e9f',
    id: 'range-test-20260619-4190',
    matching_hash: 'd99744c953086946f3eaaca1da8cdbcdbdcbeb58',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '0a76469963dfe7dc6f417ee286f178c2ce0ef6fc',
    id: 'range-test-20260619-4191',
    matching_hash: 'd793021b41fc91e6b553cbec43e060fc9f428b78',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '424e2468c519f472acd4efef81777f99fe46c1b6',
    id: 'range-test-20260619-4192',
    matching_hash: '003953fe2373c1226ddd9f76d825f3c1b006cc4d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '410c26d06cac44a284611d1c85f1f767d2231b5c',
    id: 'range-test-20260619-4193',
    matching_hash: '091b6be3b16b3ee53038820039da2b9e776273f3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '0bdf0613858bf30b0a7c03aed0b745ecd0f4cf91',
    id: 'range-test-20260619-4194',
    matching_hash: 'e5d13eda18cfb24c129bd566daf5ca4b4cd17e58',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '2b33a0dd918bc61cb63bd1f185ad4b140822ce0c',
    id: 'range-test-20260619-4195',
    matching_hash: '6c836230b368fbf8ad7f6cde1e3c7e200590a137',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '0010d753afa568862b3c7786162d10f6e41d4e94',
    id: 'range-test-20260619-4196',
    matching_hash: '660f7ed5eb192e43ab01955790b108f8c08485bb',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '35510f7505b1fdecdcfcc0289f80c3ea9c7d935f',
    id: 'range-test-20260619-4197',
    matching_hash: '2dcd036cd61971837adde7760ae55236a99089c2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '0a249eddfe90e17c9e3957dd514c5be0a5d65805',
    id: 'range-test-20260619-4198',
    matching_hash: '9d18c6974e242e4c5e621458a94ac55e1de38531',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '156daf23c79feb16df8ecaba356e36ffba8843b8',
    id: 'range-test-20260619-4199',
    matching_hash: 'c7b3ebafe7abc8d05552ce03cd59e8a6e899ba04',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: -1.875,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '25b8ef9ca763e8257da2fe4629d80949e289da57',
    id: 'range-test-20260619-4200',
    matching_hash: 'e80a09b301ecac6c50dbc77afacbd47914053674',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '3d3b49a48b5e52fcf21fef45799d4ddf666f9bba',
    id: 'range-test-20260619-4201',
    matching_hash: '369b69022e67090c30eb84fcb10eedfe773c1c56',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '3ed62e7702938c7fc66ce8ea1c91ceab141303d1',
    id: 'range-test-20260619-4202',
    matching_hash: '67955e0c2a9f1aae8d4e48c1a6c0309c1f8f9070',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'f864fdb0cf360ea749f1eb84970e427accacf9d2',
    id: 'range-test-20260619-4203',
    matching_hash: 'd52d27d5ce5c24b9cb465d4a323fa97850895038',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '0c9045b235006f5572f5e11f2e6deaadb4001379',
    id: 'range-test-20260619-4204',
    matching_hash: 'bd33df81450f2d0696288994dba2faf72845d015',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '47bc28010fbd0123dc2ce34c1f40ff4d11b082eb',
    id: 'range-test-20260619-4205',
    matching_hash: '85f56eae44484eef4fce5906576f9d017a356429',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'dd6101465429a7d6d7db6b64fee27218cebe5193',
    id: 'range-test-20260619-4206',
    matching_hash: '8e67423018c415735dc1a56d462b5114952b9a33',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '6fdcc606a9e59db92358f19da5e15cbdf37a7b1c',
    id: 'range-test-20260619-4207',
    matching_hash: '140676e3fadbd850874590ae94e50733f8ffacff',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'dfde24dd38097545ef024089004eb0e9e2356daf',
    id: 'range-test-20260619-4208',
    matching_hash: '293957aad44dfdea4a0c5fefa149b8f831bcca8e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '375982c33ef736325a37be37175bcad261f17e06',
    id: 'range-test-20260619-4209',
    matching_hash: '8b7b958753b1ac182c853de37dd7a640dfc9aa3b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '149c6b62b369867cd3bc784df280227df4f810b4',
    id: 'range-test-20260619-4210',
    matching_hash: '62102147badf9495d3c9d6d32b92921d78e56570',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '3b96258b37b14bdf3c801e04f4db7d68a5146e93',
    id: 'range-test-20260619-4211',
    matching_hash: '4b24b1a45578ae8ec82068aff2676659b1a01813',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'e2ccc9cf31f396e3e1000fc986808c79318e3251',
    id: 'range-test-20260619-4212',
    matching_hash: '9612ee815c510962b8bd391ae1da4a482917e690',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '255834bd2508dd523cc35fdab3669391930dd7f7',
    id: 'range-test-20260619-4213',
    matching_hash: '02514c689539e3da2cdfaefd16c53097af8691a0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '849d1d7772be6b9cb62780ba1a752ffd76e3827f',
    id: 'range-test-20260619-4214',
    matching_hash: 'bacf7bcb878ef9f5853e3eccc23c31aa47999655',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '2ed00b50bc187a14f3d5bd18c221758d913ba8f7',
    id: 'range-test-20260619-4215',
    matching_hash: '4fa73f798509690f284c5fb136e94961b8bef952',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '4a43407061740bc471de73b72b2bb819208f3869',
    id: 'range-test-20260619-4216',
    matching_hash: '5f5e8717fefeb19da7e2ca182aaa92591436eb95',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '484880d45f8a6a783e6e22ada2beddbfc47d3272',
    id: 'range-test-20260619-4217',
    matching_hash: '9a19c485a4f7de79c9eb3d12212eb7879fe6ff5f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '5f87537119662b6d66104b8430d06e86d3da4e4d',
    id: 'range-test-20260619-4218',
    matching_hash: '88bf69f80e1864919ad7d53f77b85e41216d82e8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'f74d72f5f8784895aecdf2b5f49ebd9a932e3ab4',
    id: 'range-test-20260619-4219',
    matching_hash: '73e92e9a813fa1d16a056e355455606c417e729e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '620df980eb655a2fd5ea7274f0304b4514983685',
    id: 'range-test-20260619-4220',
    matching_hash: '3f8f801b90e9f81c5279e63194d2faf7c39997ae',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '0f2eccb11bcd1e68f19c8489e7e10771efd8c9da',
    id: 'range-test-20260619-4221',
    matching_hash: 'bf6ed876305fb5215dda6686667e2865cc0cda3d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '6e1ccabe9e5100484542217d48318d98cbaf50a9',
    id: 'range-test-20260619-4222',
    matching_hash: '5494bf4f9ff62ee0d77b71d01da595174727f92f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '38cfe15df8e99a8f9e9b8f3804e29b72ca15c4ce',
    id: 'range-test-20260619-4223',
    matching_hash: '00c5daebdf6015ba5de47622ca757fb96efe1c8c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '456f76834d1041694b4ebb5b52124bdffd609468',
    id: 'range-test-20260619-4224',
    matching_hash: 'a5ed4cadb08bad0a583248924455a0f259f5487f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '77ee8fc3c17c6621f1ecd4edc9a2fdd0c9c07fb9',
    id: 'range-test-20260619-4225',
    matching_hash: 'ab2f32c4acd080c8f9bfeb56fd08f4018b44271d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '559b6f3a586b667dc06402d09c5a4f664009b5c3',
    id: 'range-test-20260619-4226',
    matching_hash: 'f2b110e9d8ba2d4e740ab44a71778e673da855ef',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '06639ae6666728420f893cd0aaacd6d19c542165',
    id: 'range-test-20260619-4227',
    matching_hash: '652a53c8f036880de9cfa09e38a435842d0ad3ca',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'de93c0ce289d2ae125607985059c1aee9f14799e',
    id: 'range-test-20260619-4228',
    matching_hash: '805dc5bccab51378cbae2c693cdf6acbb18472a4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'e3f27a39020e4c24e3936f990b8d5fa8378fb92c',
    id: 'range-test-20260619-4229',
    matching_hash: 'bac7ecc57c7d7ad390140cba29aad4e50d3ba797',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'fa545999bdda7c619752bfde7b74444a1b80d428',
    id: 'range-test-20260619-4230',
    matching_hash: '03d50c500b5e71ee9b2f4c993fe2e259d5b8744f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '1044dca68fd7d112711a0dacca9ee80592904cfd',
    id: 'range-test-20260619-4231',
    matching_hash: '162a2fa133dbf211aa739129431b2a58230e8908',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'c070c0eb4c746ceaf6506115908c271ba0d329ec',
    id: 'range-test-20260619-4232',
    matching_hash: '6a8cb83869b93228c98c30bb7a2984e56c03e718',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '56f6918dfce0d071fccdfcf80f67cd28093e2b34',
    id: 'range-test-20260619-4233',
    matching_hash: '524522441457cd1270c1bdf63ae4fcaa0b159bb6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'e50be87f52baf6231858d97b657b7522edd3bf61',
    id: 'range-test-20260619-4234',
    matching_hash: '6cc228c4737fc023ab76d2d3e88511024063e819',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'a3ff3ea2453f4c74014c85cba7c877bd7dd6ea93',
    id: 'range-test-20260619-4235',
    matching_hash: '06bef63c79e223749e8138eb5c5c931f55c36f77',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '389c62cf4c9c6525591dd00ccfbf812fb51b1a69',
    id: 'range-test-20260619-4236',
    matching_hash: '5e2444f7c1d33e32e41e538093931303d9282375',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '4e1513906d93fb9024e0733b472c3e67e1446287',
    id: 'range-test-20260619-4237',
    matching_hash: '8b3953ee7e9b975fc7a8fb546df3a440039e79fe',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '07f03459241541a520c630f8f07be7ea3468c6a2',
    id: 'range-test-20260619-4238',
    matching_hash: '32504766f7be392d965b4a72e58d0e7b802d9cd0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'e457d259ae8a8a3698c615157d6ff15f36ccefb7',
    id: 'range-test-20260619-4239',
    matching_hash: 'a8a8d4677ab8dbf3a90f22ea27891fa18c48ea23',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'ea476bc36d04e68ec80e6ab215a78cd513d89368',
    id: 'range-test-20260619-4240',
    matching_hash: '6d54631ffe750c8fce9e95184e0fdb779d0d1bfd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '1efe2478e4cf7dd4b516913991197a720c1a4a1d',
    id: 'range-test-20260619-4241',
    matching_hash: 'a9d8ee62b9d1089234b189a38cf6049e47410162',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.304799066,
    qx: 0.004588337,
    qy: 0.0046257,
    qz: -0.952394393,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '5b8ec6b8513f2a65992fe3c9b1f5a94da9e60495',
    id: 'range-test-20260619-4242',
    matching_hash: '4ea53db89beeb82db02d5aac94dbd19cc48ccc15',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '2e4c71a9ce5f4c97c5b4d44734ad483ca3feb2c8',
    id: 'range-test-20260619-4243',
    matching_hash: 'c287877d8819e418e26a5afc0164742353f05157',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'd910e117ab543413330676f4860883f001ab9b3b',
    id: 'range-test-20260619-4244',
    matching_hash: '6f2bdb2a5a397b60ecf63718bba016df2ceb792a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '58aba08fac06f1d0efa5379b1365e2d4285b23c0',
    id: 'range-test-20260619-4245',
    matching_hash: '4ce2a8f97f80be9c8d470d3bbd74ef86e97a9ea5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'ba163623f36c9c0d23389b47b36cd29215afca82',
    id: 'range-test-20260619-4246',
    matching_hash: '566503dbc88d3146e7cdc26a945b1b35dfcd6552',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'b7a3f159700ec91b2419bde2a2d204a7c8c9ff03',
    id: 'range-test-20260619-4247',
    matching_hash: 'e84b6cb5d984f0d339eac4385ea511f09cbe516c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '64af6a55c65955dcf1acfc2f110f0315994c0fee',
    id: 'range-test-20260619-4248',
    matching_hash: 'b51d098647bf12e4918ed45b96374ae77314d455',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '5496b685be288df81ba3a4665af33d01d3618b2c',
    id: 'range-test-20260619-4249',
    matching_hash: '22be5bfe18a8b2d27d8c34214d40f08130c7dfe2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '1366c462d1f440328423b3e1018f99f5288ec96b',
    id: 'range-test-20260619-4250',
    matching_hash: 'fe71c8abb6dfc7cb1deda91df48b2f9629850e88',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'c50a26d9762ce11df4dc97c26f34e9d1638b4160',
    id: 'range-test-20260619-4251',
    matching_hash: 'a3ba904f027c292b67f67ef2b97dc1f3686229f2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'd264d219bd8352174d2c8940ca5c86a92a9a681c',
    id: 'range-test-20260619-4252',
    matching_hash: '225ee5e440e01f3d18b693a14a599eb8c69c404b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '74c5e6df0c824dbee9026a63d858b05f586964ee',
    id: 'range-test-20260619-4253',
    matching_hash: 'ac16026e0b1f10bb6e99fb798064d3ab3777080a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '6a7c7fdfc72c7f5af740bec1f8cbce411631c471',
    id: 'range-test-20260619-4254',
    matching_hash: '4f0086d0d0cc2fbe9267de695c441f42928a6e60',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '192b7877146c476459c6c2ccc1e9b063b681b514',
    id: 'range-test-20260619-4255',
    matching_hash: '9a96c1b7e5c58dfb4e1c9e670e2979602a520681',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '3a7786dac52d56147ea4429ac5bfda8b926f79b7',
    id: 'range-test-20260619-4256',
    matching_hash: 'a7bb0445185d26384f4bfbae9d95b96010660c18',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'abec31d05692ca66a7e270cadfa7136792daa18e',
    id: 'range-test-20260619-4257',
    matching_hash: '9aa8b0455cf5c61bb0b0f7a9a0d650fc6d7c74e9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '448ebf7007818ad2c20b843c86cbadf7a8432a52',
    id: 'range-test-20260619-4258',
    matching_hash: 'ddd5d38dc275501929449ebe75aa0bfd6d29cee3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '9662638ad241fe76dbe234cadd20fb829bfebca7',
    id: 'range-test-20260619-4259',
    matching_hash: 'ab3fe892eb590ef6ba84068489d60c97687b70d8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '495d57bbb0c025cf19101cb9ef0318363ffda727',
    id: 'range-test-20260619-4260',
    matching_hash: 'bfb6fb4ff8cb39bcffe74b200e2540905e193705',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'f40cf228c937ee1eeeb450db7a356fadf52ff3a1',
    id: 'range-test-20260619-4261',
    matching_hash: '0c9956ac1113ee2cfe2bcbd4f69cabed672b1487',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'b542e3ff9733dd1d8a321c90301e38b525b8eb24',
    id: 'range-test-20260619-4262',
    matching_hash: '0e5860c744a35e6dd19cf6790bdd230e84318158',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'da2dbbd0d1693941493adaed05529f25e5402fd3',
    id: 'range-test-20260619-4263',
    matching_hash: '2c54e66365a92981a17219acf2961d6a67babb0c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -0.75,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '4fe06a2dcfdbd497f58e78a38a53e3f732855c6d',
    id: 'range-test-20260619-4264',
    matching_hash: 'ee607633f553c30841dea27d63b0a49a642c3d45',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -0.75,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '8d5c68a3b5fac4b41a776decc73f40d8840017e5',
    id: 'range-test-20260619-4265',
    matching_hash: '75fbcf63a156365305b199d4ed37230ec7537497',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -0.75,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '08195015549f559dfbea2db3fc07b98b8dcaef5f',
    id: 'range-test-20260619-4266',
    matching_hash: '2dcd483d3903d3843c1ef50f931b5724fb96f02c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -0.75,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '364f072a0d470e6e062aba40f41cb6de4cc085c8',
    id: 'range-test-20260619-4267',
    matching_hash: '64f25afaac98de996cb6285346f5e81a127a9f15',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -0.75,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '3e345295f32ef6a991ce887e378346553814ac66',
    id: 'range-test-20260619-4268',
    matching_hash: '74473a42f1c262d779f1ba6ae5019ff703a53393',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -0.75,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '8f3da75e8e6e8f7f059958d5d2ef6de77fdad9ba',
    id: 'range-test-20260619-4269',
    matching_hash: '69a817df85708fe82e005b152634fdae728b8c8f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -0.75,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '74be78bfdcbb589616b81c16e0ac61328d254821',
    id: 'range-test-20260619-4270',
    matching_hash: '0670ca5ab102c57bac9c87de39a712ff83d8f5ea',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '37e22db6f76f1d2b7324e59640d4d2816750ad16',
    id: 'range-test-20260619-4271',
    matching_hash: '50f1624e8ab329bfb1116bfd37a872da8e2e49b8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '9331e1a4ce522917edf10b2f7777d3c6efd5a753',
    id: 'range-test-20260619-4272',
    matching_hash: '11b103735b9343fed95fdfb728f39cfaa82447b2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '8379ead54121f2dc9b10f542cdc3f8d8a177efa0',
    id: 'range-test-20260619-4273',
    matching_hash: '9736945260746411ca2a848953d9acb157788759',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '3800849bbeeab9030c73ebc6de4f0d4d0dbbe197',
    id: 'range-test-20260619-4274',
    matching_hash: '8dcd966b94d305209ea9bfa23be17bfdb00f139e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'd9dbd3af4b045363007299876d163768fa875797',
    id: 'range-test-20260619-4275',
    matching_hash: '4374c5d5861ba82042c3c93945525e3e1f8b3a2a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '4895308934aea7be072076ea0053a0d730515062',
    id: 'range-test-20260619-4276',
    matching_hash: 'd369c12755c91ce31a985cff516cfdcfddb4e18e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '3ee7d5deac58bcce2911fd6344d4e6a514b1b982',
    id: 'range-test-20260619-4277',
    matching_hash: '8f6b0b134ff26347265966ceaca6670b0f5a80af',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '633f0d69f3435214df2f7e94d344dd08908b5d07',
    id: 'range-test-20260619-4278',
    matching_hash: '52086d0a12065e24521d94b53716a53eb290aa12',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '67a757262006085db38e5b0883c9cda05bd7e6d5',
    id: 'range-test-20260619-4279',
    matching_hash: '09c54b3b80856c7e088af5ec61410b76ff11b9bd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'ddcd7cd3c2056d858022d855cd400f44cc5564a5',
    id: 'range-test-20260619-4280',
    matching_hash: 'c9ab083c9b9dcba747e1d77a6e4e652315cb32cd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '6747ed7abfbd75b59bd721a2980afb2b39786759',
    id: 'range-test-20260619-4281',
    matching_hash: '77000dcb98d0b581104878115d84970cbc8ef68f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '8fb3aabdf06b67397a168a5c3905ad663661bb1d',
    id: 'range-test-20260619-4282',
    matching_hash: '7bcca47d930debdf9eded4e190bca5aaaf80030d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'bdb1f84716919673c6e3ad524497cbdfcd4637b2',
    id: 'range-test-20260619-4283',
    matching_hash: '0d78f34392a2a1ff43fb66199518da2132c6092e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '3ccb263600fbc60e0251aaa83160e76c82f99109',
    id: 'range-test-20260619-4284',
    matching_hash: 'f62126557aa7bf2a5bd9e21e3c36bd1b55aa4948',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'dfce8ebe0d04a31a05792089a19f175dd04f33a6',
    id: 'range-test-20260619-4285',
    matching_hash: '63a446a3f05ce7a0ada97b72ce85995a9b460b8b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '2e47b152594251372b7507eaccdafbe4912e99dc',
    id: 'range-test-20260619-4286',
    matching_hash: '7926f6c5d32954e8188620f73a2681d6f6c61e73',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '44e68a804cae6b7664b999dab3583895ebb71c55',
    id: 'range-test-20260619-4287',
    matching_hash: 'da21907d02a8996bc95badbfc61aaf1476f620f1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '616c629796193c5d37359c29219ff26c2eefda03',
    id: 'range-test-20260619-4288',
    matching_hash: 'c52e0bdee852a1dedc34a94b0e501f7c0d9ccf42',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '5bb77c48aca8219c072bc79d8b508d28558596cc',
    id: 'range-test-20260619-4289',
    matching_hash: 'b12af19ab3ebd82b6e96b28ae8c84c64eea9617d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'a9f59d876c38a6514581a1bbf0777d1147c6050b',
    id: 'range-test-20260619-4290',
    matching_hash: '5215cdb7da5a08d0e533fca49caacf226062e7a9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'ebf4c29c8141808731b9513bbcb7b2c6f2bee5da',
    id: 'range-test-20260619-4291',
    matching_hash: '70c3d2f7a45367892e62cfbccdee0121a79f9ca2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'fd1048d16c19758ec9c3d43174c556d031e673b8',
    id: 'range-test-20260619-4292',
    matching_hash: '2cf735ad85793b44c0f1d66b4dcb901f2105b7bc',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '67b46f12d834fcf824494c85fa39f84b6cadff79',
    id: 'range-test-20260619-4293',
    matching_hash: 'c0ea636f9cd716342620f7774b8e25cbc59065ab',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '4470a40d7f53f48a75bfee4c2e3a391856336f28',
    id: 'range-test-20260619-4294',
    matching_hash: 'e3cf2660e5a7f4a7ee8712c58da660be3384e989',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '888d5add581c03ba382247a9a07bd3c196957167',
    id: 'range-test-20260619-4295',
    matching_hash: '2bcd38d06f8bf5112fcd167b7ef71c8ffc70f568',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '8be8bb6231b2c528f7631a6c61a487bc827de4c0',
    id: 'range-test-20260619-4296',
    matching_hash: 'c784a95f24b05e2eb133dcb06301504ece75ab13',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'cece4d017a0f4d9c56f1c4adf964c657c834f700',
    id: 'range-test-20260619-4297',
    matching_hash: 'fea43cdd4ecbcc21b3d2b6505c70d8c38883f8ec',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'd9bd2f9b25b51cba468c98e58ee14c8af5624f8e',
    id: 'range-test-20260619-4298',
    matching_hash: '913b3233db8a7088ae56e63c3f2c383802066dd3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '2241f85a6d5ce1023613a60b92adb197d440c803',
    id: 'range-test-20260619-4299',
    matching_hash: '11df6587b024fca4d2e450dc2bbfd6b9bee86df5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '87aa93e35751488ff85c04f7167e90f2f2300621',
    id: 'range-test-20260619-4300',
    matching_hash: '96e7a0a1baeec30d0c9663a9aa649ba919060948',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'a75a11b7d1b7de3a2749b386304b608fe8bfe89f',
    id: 'range-test-20260619-4301',
    matching_hash: '9b1a3b0b691495145186e05ffd30a6b5fe588ac1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '9a1345ccc3324e07ee41a4cec52eff4383e59548',
    id: 'range-test-20260619-4302',
    matching_hash: 'c6b349fb1098447b5c9f760f8cc64d13b09874b8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'e4db7592027c4255b1b10a6c7f846315a2bb5242',
    id: 'range-test-20260619-4303',
    matching_hash: 'ba26859c3153ffa1b0767a3f573ae0121598b465',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'afc5432f62239f68cdfc4ad1ff87277e8106d56d',
    id: 'range-test-20260619-4304',
    matching_hash: '859a825e8515e95b4d12089a0d50ccd06c9a6441',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'b0a8bb965c3de66640f05660bd92b2c98eaa916f',
    id: 'range-test-20260619-4305',
    matching_hash: '07811a28446d438ba533f6228f96970af759ee2c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '062b99fcc41220f0f2161e6505d5229ffee06003',
    id: 'range-test-20260619-4306',
    matching_hash: '89e71000d5eb19ee71b9ad374aa6cd4cad52b0e9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'bd95b300ae2b3b20c4c127907b2a52d8058bd5c1',
    id: 'range-test-20260619-4307',
    matching_hash: '323ee81019f32586993c67a4ef0e302a5428dfc8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '278f2dde907db2d4aad643d4af12ad1dfa3d3311',
    id: 'range-test-20260619-4308',
    matching_hash: 'd5b5d4d265542683abc16c1bf111a87edd7a05b7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'ff65b475967234b3e79631e5a05ac30ec770cef2',
    id: 'range-test-20260619-4309',
    matching_hash: 'cc4daa5bc259223cdea5bbc5f48185649acb2be6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '8b9a6e08f77bf1b5a54202978bd191a687b2c50b',
    id: 'range-test-20260619-4310',
    matching_hash: '8ad985826d0157efba884354307179798ad91bc1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '91b618ccaf5f8f2bc831b4f464fefa8d5f466594',
    id: 'range-test-20260619-4311',
    matching_hash: 'cc3665a3d8e886b25f279d7a784d477f6773181f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '9bad157d9ff0a3b0ab94f2bb82a1a23a6934ab82',
    id: 'range-test-20260619-4312',
    matching_hash: '6060ffdd836b8fb1125ddae0b47af50c51ca475e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'd2d1ed401008b30237a72369a264dc111fd42df1',
    id: 'range-test-20260619-4313',
    matching_hash: 'ac2b53e25babf554456d5738103cdc371be7a036',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '6fbe387751f4f191db983db2285de167ac089c50',
    id: 'range-test-20260619-4314',
    matching_hash: '7e7cdab2f4c0ce35238369caede455bf0f93c324',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'c717445b17eea4bf8445545eb1db4922b615dcd4',
    id: 'range-test-20260619-4315',
    matching_hash: 'ac0db73cb096f55dccd12e6bcb0cbf8a5875deb3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '81d40b7710fe9a620451be357ef06e6a11439b54',
    id: 'range-test-20260619-4316',
    matching_hash: 'ecb7e332ad3483fbd162564c8c2acda31530ba1e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '6de478d5de0c27655708499ff1680de250ec1958',
    id: 'range-test-20260619-4317',
    matching_hash: '2f3af5ce206f8a65c238a8d4879b4b7347784c11',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '3ba8ecc7911c7429d446b97c7157ad967c7153d6',
    id: 'range-test-20260619-4318',
    matching_hash: '07cc9e9198fec7285c973d31e8de0dd425d5214e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '1f4cf19450e7ea7d8e7286443547e48dcb68865f',
    id: 'range-test-20260619-4319',
    matching_hash: '8c9324c91c8343fb73a1d7a034ed7dc781329e76',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '370129ebbf8ae80beb3d9a92c2e068bd35345477',
    id: 'range-test-20260619-4320',
    matching_hash: 'b1284ecbbfb4f8f3af8075eee20298503ee0a935',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'ff28ec7b7013e03984f6b9c5a4aafa7cc0bb6e47',
    id: 'range-test-20260619-4321',
    matching_hash: 'fbb38200b4542877666391dd2e5833ec5163563b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'c84af38fc7cd8fbe803b5f032fcf905bd1f92c90',
    id: 'range-test-20260619-4322',
    matching_hash: '3d3a6c81fb634a7885e0b20342745f159a834198',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '05dfc073500a2e92dea8cd4d33ddd1e6f5334255',
    id: 'range-test-20260619-4323',
    matching_hash: '10e7c0ba1363d426acd04f2881bcf626846c24d0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'd7ca9465e7e20d8d295b2fda8ecf439efdba0341',
    id: 'range-test-20260619-4324',
    matching_hash: '0d2720bbb1c3f42a6a591bcf9b920153116f9a6a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '07e4be3478a7a0057870a6061d94927ff470145e',
    id: 'range-test-20260619-4325',
    matching_hash: 'e5b5ab1a650dd63f84c31c14e687db9dfb6b4fb7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'e5d2a34348b813d3451657993e14032c185311b5',
    id: 'range-test-20260619-4326',
    matching_hash: 'eee974c9360d4d7e16e69685273e368e4c9608a7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'e4e8b01013ff40e13dcaa69a077ac43f4aeb7618',
    id: 'range-test-20260619-4327',
    matching_hash: '513dd6b7817cd39f8c74aff286779783369aaafb',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'a7eaa821ea11676bed62a75eb305859fbbaaae7e',
    id: 'range-test-20260619-4328',
    matching_hash: 'b8191fdde2d8b2495f82016320ed0bc17ac002ae',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '49f538809f7f2bd958aa0eb2128392c02c02afac',
    id: 'range-test-20260619-4329',
    matching_hash: 'a1d701568375bfba6455a13027c5385eeb554600',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'c5fec18d1218f4942bd5c5df102703d1b2f8cd2e',
    id: 'range-test-20260619-4330',
    matching_hash: '6157f14b27546dc8007e2f6aff1a75541d273a35',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'bbd2ec5cf443321029f749e6c433b0200862bfd3',
    id: 'range-test-20260619-4331',
    matching_hash: '6717f5e92ca53ad31755698515115de67556d1ea',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '601150b7f43f6890ec82f9b00dfddba82702697a',
    id: 'range-test-20260619-4332',
    matching_hash: 'd6c4c8feadd4bcc7b3c7bdc2efcf323c86cad38d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'c12cb47f181d35250bf3a30d8f058f7499150185',
    id: 'range-test-20260619-4333',
    matching_hash: 'a51184b40ba7f4b1aff663653ee6bb2d4e87e108',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 2.75,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '3113e41bab435f2cb034bdd2f01ec497bc7c67ea',
    id: 'range-test-20260619-4334',
    matching_hash: '613a958a615306837c5f7dab2090512b34a92988',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 2.75,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'de7b025380c71d743913b52fd0eb82952c185204',
    id: 'range-test-20260619-4335',
    matching_hash: 'fd03c8d0ca853160aa91e68b64225d7e95cb4f4e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 2.75,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'fd5e8c7331472108260a1d1e4cdc663f6b09756f',
    id: 'range-test-20260619-4336',
    matching_hash: 'b5ff844ca8dfc13e54061833160270e44b796687',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 2.75,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'd0e47c6100951ada71bb44cde869d12d0b5d49be',
    id: 'range-test-20260619-4337',
    matching_hash: 'd10739bab44a9dab42fefa8f4a2800e70fd2dbfe',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 2.75,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'c318dcd012d38e26cdcbfd49c6ec6cbfaf6cce08',
    id: 'range-test-20260619-4338',
    matching_hash: '0e9cabe7f29aba4521a0f82c0aeefa854e58733e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 2.75,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '9c7a656625edd74be21636fa80298274a3a08a4e',
    id: 'range-test-20260619-4339',
    matching_hash: '0056270c0be4b513bb15e0249500d20c26f2e311',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 2.75,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'ab33edd23a85c55361e07dda4b570c95ccafa586',
    id: 'range-test-20260619-4340',
    matching_hash: 'bd73fba198fc86fe8a2b2286bb7d0d2fd819ae8c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '473b0b9bba6760eb85313ff1582b9824c98b4538',
    id: 'range-test-20260619-4341',
    matching_hash: 'c7873601df93b65cefe3b799677984f5eb0f40f2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '5ba4cd5fb2f1b40ca1e7ed6005a7e8c4dcf8f299',
    id: 'range-test-20260619-4342',
    matching_hash: '989597b3492d12f7b498f054a6db6323d6fb4fff',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.60868854,
    qx: -0.435591731,
    qy: 0.351273073,
    qz: -0.562463629,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '392dbb6d27fa755f1bd845be660433186f1d28ab',
    id: 'range-test-20260619-4343',
    matching_hash: '1bec316dfd2e87cf132c999771fdb55b893c69f0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'b60e1122477721ad51d1dbdef3e26625e6fbc672',
    id: 'range-test-20260619-4344',
    matching_hash: '1ff1ef2417e3452b560f392d83b3adf7a1438070',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'a50d4642d6ab70eeef1a9cb9d36ec18a2efa7173',
    id: 'range-test-20260619-4345',
    matching_hash: '24c7f7a71bde2c441394df1a6e8a872000388197',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '2c8c723494a077264ca4dc36eb3bfc7494a64609',
    id: 'range-test-20260619-4346',
    matching_hash: '87e517f732f16c1baad26a0ff96cb990e7aa3fa8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '8c3d909e490f8a123e3b0939db6dc793e6e43b73',
    id: 'range-test-20260619-4347',
    matching_hash: 'c46deb8738cda9914a8b9319df3e40f46752b9b9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '1663fba16d5ceb6f9193b5f672dce0fe6a724a2b',
    id: 'range-test-20260619-4348',
    matching_hash: 'fcaf9060c6cc19c69ea985133593673f422ec68f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '2a2bf111d39b777a64da8d4692ed58b78a69c63b',
    id: 'range-test-20260619-4349',
    matching_hash: '7d144a5b0efd4d1a0da783ce07744aa5f6905dea',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '46a3df6ccb23d80533cee085a869c6aeae099603',
    id: 'range-test-20260619-4350',
    matching_hash: '7e9e6ace29f6b19fa5d3adae30ed8ffa38c1d5f8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'ebaf22e6ec628d01bf8ed09ee287a442c168192f',
    id: 'range-test-20260619-4351',
    matching_hash: '2d65dff40d1a983d920f77f9d21e07c9f5e74e35',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '09b953f1419b9f5ca3bea84ab4b52c39203425dd',
    id: 'range-test-20260619-4352',
    matching_hash: 'a36f4c0443fadf4d540271d8ba4226ef4b3a26a5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'e882a840b934d0451a59608c5068a353ad7109ab',
    id: 'range-test-20260619-4353',
    matching_hash: '67cd8f574319aae32e20b39db66b1cefb4061fc2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '9e088948b253989ddb02bcf6727daf555a468ac8',
    id: 'range-test-20260619-4354',
    matching_hash: 'c22d61777747fbf893b207c4b629a80624c9b9fe',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'a47768a063fdddadde91656f8c8e80d4af1906a5',
    id: 'range-test-20260619-4355',
    matching_hash: '94451b37bbabe4b200ab4a5ee149ab39933be52c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'c56fdb854fce08b69987a4c2785a1488e9bb2082',
    id: 'range-test-20260619-4356',
    matching_hash: 'abffe42ee2ebbd0643a67c8382e83e667782908b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '0b70480e927dc4067f7a8dcbfd20da4fe875671b',
    id: 'range-test-20260619-4357',
    matching_hash: '7a407bf9468bcc7e063ce652e3ead6d96f3b65fe',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '05d3aaba6aa31308725abf5fc0b5fd0d31683c9a',
    id: 'range-test-20260619-4358',
    matching_hash: '0e0759a2566337f6faa1711333a9fae9fd4d67f6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'c7300637c2cada09691b952aada2bde0d922caa7',
    id: 'range-test-20260619-4359',
    matching_hash: '9fdb1864bd96ad155a10a0ae5ec0d242ae9e90dc',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '289cd41f61536ed9a3e33d2d5ea717a06c9985b4',
    id: 'range-test-20260619-4360',
    matching_hash: '8dcf70157af08e7add6a10f99f46c284353b4896',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'f0ea00fa1edfb80e2bdf1e8e39a684eafc27e82d',
    id: 'range-test-20260619-4361',
    matching_hash: '32267fe228b17925e30becde92e3a1d1a95721fa',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'cc3692cbbf58b8408fc7e0408b16186537f7e1ad',
    id: 'range-test-20260619-4362',
    matching_hash: '34f009353dd82b45416a21b4e0604ef67d11c1b4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '8818113208cc1f75b8ef5efa372de7badab1d978',
    id: 'range-test-20260619-4363',
    matching_hash: 'e182cb8fe567b19fc456a625312bd1c8f64da310',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '546f9df28b1854548713f4f10c5a6ad8f0367f33',
    id: 'range-test-20260619-4364',
    matching_hash: '9027b8b5dbe049415220ad9a214067df8d125ce1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '592775694bd3442fe3703f82d02f7f2f68c73752',
    id: 'range-test-20260619-4365',
    matching_hash: '824c720a2fe4be27b5f7e3a7b2082ab8fd8f171e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '56cdb3885731a7f07bd31ca052f6265aedeabf8a',
    id: 'range-test-20260619-4366',
    matching_hash: 'ed9d6e17228ab41c15aa9b59df185a75b08612c8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'fd713b2c60ac28e96bcdc9b776c6cb8aec0d664c',
    id: 'range-test-20260619-4367',
    matching_hash: 'e346e5dbcf7e4bd3ece28cbe1f2ec6f4c8fd8bc5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '3f7897b91e5cf4d96e19430725a22a07fcd870c1',
    id: 'range-test-20260619-4368',
    matching_hash: 'b983bd6dff7ba7372574318d56c5d03a856e0f27',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '6839eb0d8b7af44e9ab9d87f402c8f9857aefd8c',
    id: 'range-test-20260619-4369',
    matching_hash: 'c4280e2d3f7f1a25d3e6d43f2ac5212b22b78137',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'acc758948e47d1b26da14621405bfcc71f9e7c3d',
    id: 'range-test-20260619-4370',
    matching_hash: 'eb579650615f0af71116bce7e63af928854193d5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'b737c8c509638471443407e322c8f6e3b13e80f3',
    id: 'range-test-20260619-4371',
    matching_hash: '52067eb238c40b2e6862fc3f4507779648e61b99',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '9e5b55af0c46371a1d0738a96955a40d98b35b3b',
    id: 'range-test-20260619-4372',
    matching_hash: 'c17a8d39e2cbc3e18c2d8fff698d0a33a492cee2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '448f1b78b77638648475512083c14fc5daa98a20',
    id: 'range-test-20260619-4373',
    matching_hash: 'd2e6512eb192afbdd229fd99517b8cb43d31457c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '0c87458d4724ab06bf86d5e6b9454e487edc0ab8',
    id: 'range-test-20260619-4374',
    matching_hash: 'dcfa9f40f97840ed222812511a4b7b2e3a78fef1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 0.75,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'a2273408780874cbbd7099fbc20ff6c507f0bd98',
    id: 'range-test-20260619-4375',
    matching_hash: 'ebb2e8f781b3c98cb3991c4579dc6735792801b6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '4ea233c8e48c6342729818375394ff31f22b969c',
    id: 'range-test-20260619-4376',
    matching_hash: 'f0601449e3df83ead8493251ea91bc3a9420c81f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'c379fdb93a9be97c9d1f43ee46b1f6ac79dc1e8b',
    id: 'range-test-20260619-4377',
    matching_hash: '0fa4ef0b09e46587fa192f70779b09b2b323aa1f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'ed164996af99b87d1a423c7ae5764b2732772be8',
    id: 'range-test-20260619-4378',
    matching_hash: 'b5fd80d3ba4deb4d3d4b19a488b01032cdad226e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'd08581a27736634369655e3bc0a3713e3c0c943b',
    id: 'range-test-20260619-4379',
    matching_hash: '8f3dc9387dcfc1765104f7000f0e5dde7224d543',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '86056017aa367d0397f63d3d4f1a00816949eec3',
    id: 'range-test-20260619-4380',
    matching_hash: '9d0d46974c53257a5a22d8c288c95729edc39f4a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'ca1183072376435a927bbb608a6caab1c8a63148',
    id: 'range-test-20260619-4381',
    matching_hash: 'b609dc66a4faa06fd67007006412edb3a41f8e6d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '27c71c6570bb2ef232bb8f0522971d7d9009a2bc',
    id: 'range-test-20260619-4382',
    matching_hash: '6d8f2694f678502749535b8969a6d607cc1465c8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '80edd01306efad83bc08e75cdc305e31839d0466',
    id: 'range-test-20260619-4383',
    matching_hash: 'c16dded937d78710f7af0116cbb39bad8808fed8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'da358cff6b8f2002a363ef7d46b1ae84423b7d6f',
    id: 'range-test-20260619-4384',
    matching_hash: 'a9a4f04460aef75f448e09ebda184c45d75f6e74',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'd75e7075f0a9950a426e0dfa1f782a544584ee58',
    id: 'range-test-20260619-4385',
    matching_hash: 'e313c4b648801e77c62cd52528683f492db96fdf',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '3319acef762ce1baa8580b217d88215074d7364f',
    id: 'range-test-20260619-4386',
    matching_hash: '9cc289c08be5a3f3ae967663ab8116fc979443da',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'c9be770ee6a82cf7e9987561283e3786746c2d67',
    id: 'range-test-20260619-4387',
    matching_hash: '1052a55c72558c5623c541f141f00d2820720f7c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'bd8dc35b3d7913af68e3ffb1359ab5ec569c25de',
    id: 'range-test-20260619-4388',
    matching_hash: '0506f51492a09a705de4e56974b1b94512507e71',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'b89997b2a1817cc0f4a1fee31aa4bf7e85a9164d',
    id: 'range-test-20260619-4389',
    matching_hash: 'aaf11eb66fd9e0a2c74ddccbfb2ea7cd689eaa35',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '3826b866ee4c59760c1c34da1f10b310e7f16125',
    id: 'range-test-20260619-4390',
    matching_hash: '7a7426c137466fded6279f9e566afbe3786d4dec',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'a7a83648ec8de73deafc3207e4b75a382cbdce06',
    id: 'range-test-20260619-4391',
    matching_hash: '4d4cba5e235e416040f52640fdf97ae6e6323dae',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '2bf4a746d03414853ea80c3290d00e650c9f431c',
    id: 'range-test-20260619-4392',
    matching_hash: 'a5cbf0f472bedec91531ac8b082b9bd30f84a569',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'ad9d3f0e616051f74f17a654ed8794f97b83bcb2',
    id: 'range-test-20260619-4393',
    matching_hash: 'ad35724b862a44a56e468352730ebbd6c7bcac07',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'd45af0ecf9a70938b37436ef4fb9d75545cc51f2',
    id: 'range-test-20260619-4394',
    matching_hash: 'a9f533e56010000e8a8cb96ba0971779208f19b2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '4f57a58ebf7eb522a72cec2208d4e9b48f8c9c5f',
    id: 'range-test-20260619-4395',
    matching_hash: '33d404c503772c357ec94799ece2a4097ccff5cf',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '4fb274a4c054fed1d47dd8346d1dce13a23097b5',
    id: 'range-test-20260619-4396',
    matching_hash: 'a0d8c44b58c4a4bdda8eaf1da66efb59f02cfe57',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'a5999106c7f2ce6c455a3243d78e6d87ad26e47f',
    id: 'range-test-20260619-4397',
    matching_hash: '531b396c5a285e6370115e397207d17587b32cda',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '47f57ca54b918e29f85c58966910af0f5726b1b6',
    id: 'range-test-20260619-4398',
    matching_hash: 'f1c19e56928c96d4b46e72f4dccf07e73ea8ae76',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '68994a843c2733d1cd925447632388a384c6dc1c',
    id: 'range-test-20260619-4399',
    matching_hash: '84b8caf8e74f3a10e2cb99b41df3b0794ed98c31',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '2da984a19c1c33a0b7c3d3b9c1b02e5fd475581c',
    id: 'range-test-20260619-4400',
    matching_hash: '13996a0b990b0344e5dd3afd94bc3168dc1c5620',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '70149324f16fa0210d37b42440910914726685fe',
    id: 'range-test-20260619-4401',
    matching_hash: 'afe9cf9d14b25a6094c1f8a5e3c889ae7c9da058',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'c69ae4ce7f489c21690ba2f48789e96b6e0f7b3e',
    id: 'range-test-20260619-4402',
    matching_hash: '2b67c3a54a78c0935035bd45cb1653c75a2049e3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '678d0a9f799ade2a2ff9dae89d5d10fe8e147808',
    id: 'range-test-20260619-4403',
    matching_hash: '711127a09f419f1f2937398c676a35f843ef5ea6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '7a2b4aa4ba1c9c3793071c0eaae387fbf2565792',
    id: 'range-test-20260619-4404',
    matching_hash: 'c495f581298cbc80d809c88cfdb92f8cf30d8283',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '59a8dccc336678f87a151a7c9e3143c7878f54f6',
    id: 'range-test-20260619-4405',
    matching_hash: 'f7630c29f87de6b6cb8383b0872337f1e167d6a9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'd0f49c6f26284bcd79043e2f76e728215dc0a23e',
    id: 'range-test-20260619-4406',
    matching_hash: 'bba3c81974b99c7318def7cfdbf0a1661a23325d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'fd10a52f57e36efaaebbee1759340b484da44127',
    id: 'range-test-20260619-4407',
    matching_hash: 'f0d27a3d5852e735111541baa12aaeb1b5e21fa3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'a17c57bf933940900e2c010bab57a53167a2ec4e',
    id: 'range-test-20260619-4408',
    matching_hash: 'a033cf31b8036cf29b58fc06c639c603ccbb9d86',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '43b5170b8610ae434cbb75a7c29caa2c0f48555c',
    id: 'range-test-20260619-4409',
    matching_hash: '29d129fda7089daff0b73845b73fdaaf4acec4c8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '5bb4955d59c2fedb4a2f3164d9901d15f9d8233a',
    id: 'range-test-20260619-4410',
    matching_hash: '13fb78fd6c091bb3bce90bdd0777fe54d79eb540',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '0c3158addbaec867644cc2d4886f6a20078bc58e',
    id: 'range-test-20260619-4411',
    matching_hash: 'caadcd393174f291caff1a1ccf7d3728bbf136df',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'd41c08ecb556aa00055894f4cd6b5a53a877c5d8',
    id: 'range-test-20260619-4412',
    matching_hash: '3da277505d6f0fcf0e83b4128418035ee10c91a4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'fde3e2fecba768da2e0557864d9f00bc7e47534e',
    id: 'range-test-20260619-4413',
    matching_hash: '613409857d26e4f905dfd520d11c17e8bebf148c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '02c9a042b63be7be490dfa8f36367281176e62c7',
    id: 'range-test-20260619-4414',
    matching_hash: '2900f13fbbbfdecdafb914150f083a83d127173c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '776eb59be0ddd7d3a7cb02bd358310d80537e426',
    id: 'range-test-20260619-4415',
    matching_hash: '9b5ff4be591e1d72032dbe7ac8867ab22a7d433b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'd7a368f6da579a14ccdcea26ec1fcb2db0ad474a',
    id: 'range-test-20260619-4416',
    matching_hash: '6982678ddee708b3af8b687528bba6da4b6e1575',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '8379cdf3bf33e7a9fb43d175099a4b4d7dcc2f04',
    id: 'range-test-20260619-4417',
    matching_hash: '2f7f84a89dd7c50cff9b5bde0f1b450f1229e17a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '2871fd8df1553d70e7cb7f290f78076bb57e39ec',
    id: 'range-test-20260619-4418',
    matching_hash: '084a8c7d9473a13731bf4b4d2c1e59c8266619e3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '143436f69adb0fb012e0334f7bea369d114787b3',
    id: 'range-test-20260619-4419',
    matching_hash: '980891e0b61dc6d73d151b63dc3167d993f2a168',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'dcf4bdf9e81889cbd72c3a296e04dcd81f7d364d',
    id: 'range-test-20260619-4420',
    matching_hash: '88e88e50046b522e3add21c84866455905b25577',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'e8e81737ed106482b30b9a38a75a65fc4ae7d3c7',
    id: 'range-test-20260619-4421',
    matching_hash: '47bb60e2300e530c970ecb16e68a64e344fe260b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '26a57b4f981aa5b2c92fa9eda5e338a64131235e',
    id: 'range-test-20260619-4422',
    matching_hash: '18314a933be78ffd8f052ad6eaf484e7e4eef121',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '566f430e0f077f18873b924992801857fef189cf',
    id: 'range-test-20260619-4423',
    matching_hash: 'abc4bf982611bc42540aa6a1b9bc32374629b36d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'c87ec7ffdad754bf0bafb03dde9b53738c0e393c',
    id: 'range-test-20260619-4424',
    matching_hash: '3618360cc4f6fd6f3cf7d5cbcccd2613a085f3ba',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '72074310119fba4d57cba89158cdfd0ea889c4fa',
    id: 'range-test-20260619-4425',
    matching_hash: '29361e0fdedb8b3302ddd4913b7e4d52cca65ffb',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '0899af5a25f97a073232878a567c42630473d8d7',
    id: 'range-test-20260619-4426',
    matching_hash: '017219b9d21b8a9aeae415ce9f62901d96a3b6ad',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '0acc084c13826e7176477ba7db59226bfa0edd41',
    id: 'range-test-20260619-4427',
    matching_hash: '356015a9b1c4c36d2b26e424dc0b5d69b1f687b2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'a7e3de0b819a5c95b252ce256aeba25e0c001d70',
    id: 'range-test-20260619-4428',
    matching_hash: '9cc97bbb0bfdcb9413c585e1b03b2e3c5b78badb',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'ea43c2361e9d9d3a898dd871048b2cf0b58bd1d8',
    id: 'range-test-20260619-4429',
    matching_hash: 'ae9ff066e37f69cc18514fc56389fe59e1677877',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '5cfb73df1e844c6cfd966b8967410b6ac17093bc',
    id: 'range-test-20260619-4430',
    matching_hash: '7b0404e5d9f87a893cf747ed88b5e97d512b9bed',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'd3114d8d3ce609cddeed56bc5f57a762b81e79a6',
    id: 'range-test-20260619-4431',
    matching_hash: '86907837bad2c30da95ec9e77ff8e6b791a21460',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '3b24d3ba78fe2fe5f4aaff31122f03cc0cc2f636',
    id: 'range-test-20260619-4432',
    matching_hash: '332235dce2a9bb67145af09656dd9bb8b64b9c7a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'ef22437adc8b7dff24762df118b4f9596a9ab36d',
    id: 'range-test-20260619-4433',
    matching_hash: '1e9f6df32854271ed41909f8228c5d258cb181f3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '1555459605babb8dc4b362c3835115356cdbf7ad',
    id: 'range-test-20260619-4434',
    matching_hash: '1e13742ca5de7928219bfe7c2b4ae6b8b46eba8b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '280d7a9c573e6914a7c7b50b6171f033e744dff2',
    id: 'range-test-20260619-4435',
    matching_hash: '6c9f6b99982f4114fa2561430091e5bcb6291fc0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '742f9540e10f65d9aad808c1ed6fda726e5c966b',
    id: 'range-test-20260619-4436',
    matching_hash: '5748364a0528412b2bf35f184b0a471c15977337',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '48dd514a4338b65200122bc5a0db7076c424f5fb',
    id: 'range-test-20260619-4437',
    matching_hash: 'b84e0625d6a88f301d669d42ebd761023f1ef6aa',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '3876aa9c904b34808172e048c763a91436427e12',
    id: 'range-test-20260619-4438',
    matching_hash: '37fb24de79e3c3aebc4c5e87dd7373d9bc889081',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -1.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'e8dd03634e68db21c2e1e78afe257856bc1dcc2e',
    id: 'range-test-20260619-4439',
    matching_hash: '2fc0b0a966644cf3e010b1c9c40dda01947a9785',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -1.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '42e95d3380f928ff93fda7334f0560db57582762',
    id: 'range-test-20260619-4440',
    matching_hash: 'd536fa4576633ca43e63dd6d4f3bf3bb4c4c2999',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -1.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'ced7ee027679d38be3d4398177bcd01afaa2c7e1',
    id: 'range-test-20260619-4441',
    matching_hash: 'c5d6d50204ad282ccbd677459babb1f3efa4740b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -1.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '05466c7c75c8bc26deb9789d549958aa450951f8',
    id: 'range-test-20260619-4442',
    matching_hash: '2f6e967b8c2b554cd540b32068bab24d120ea66a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -1.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'ae1bcb234c9129ab0e8657aeac2f5f3cee6fdfaf',
    id: 'range-test-20260619-4443',
    matching_hash: '4745637a389c043ddbdfac27a916282683d5805a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.205514392,
    qx: 0.638167914,
    qy: -0.054000923,
    qz: 0.739992871,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -1.625,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '52e2ff9173c7e7b603a95f895474adcc8da4188d',
    id: 'range-test-20260619-4444',
    matching_hash: '7ff9fae45d6293f8efcdf9c66fbc57247afa81bc',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -1.625,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '0fc2ce9d985422899c44788e26913c69e3e97260',
    id: 'range-test-20260619-4445',
    matching_hash: '7abe0533b019b32b9f74072efafd4e047e45b3d7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'dfe74853288b9acf39b26f0e354c3a992c6a1661',
    id: 'range-test-20260619-4446',
    matching_hash: '9c744f372157c63599873838168c76fdc21c15a5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '0e13165c3940ee7b401320c7001afa4081907aa1',
    id: 'range-test-20260619-4447',
    matching_hash: '99e27f523c66273bcca26960b27b9478a96b0c0e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '7bc840380bdbd51dc2a2cb49dfa32a7e98f63688',
    id: 'range-test-20260619-4448',
    matching_hash: '9a1ddf2537a8f2237aadf634bc323803333c611a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '504c9292a90ca6e9aee376e37765b319d27df9d8',
    id: 'range-test-20260619-4449',
    matching_hash: '9fe74fd6a62f5ddf9c3c7582aa9fc3c5716d21bf',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'b13d0e5eeee36080125849e4dbf05de99db38c0c',
    id: 'range-test-20260619-4450',
    matching_hash: '6e6d07fe1b094d192f2aed52e33a9324decb4f68',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '65569257891764a41678101d92d8b21c6db8d524',
    id: 'range-test-20260619-4451',
    matching_hash: '2426f9a960d4d09a0762e334dfa0aaa3e7e1787e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '534013f70b2153a8d80a058582ec3d910b9df3db',
    id: 'range-test-20260619-4452',
    matching_hash: '6f05a33a4252f1abdc33722486444afcefd65c47',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '4e375fb51820635ac1654b704880f7425b68285d',
    id: 'range-test-20260619-4453',
    matching_hash: '27b14c3c7d204588eae618f2a32cb69ff2953351',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '8e797097817d37483e5a97645192322b55c6de1e',
    id: 'range-test-20260619-4454',
    matching_hash: 'a7f7f821174b7c300a9e8b0ead33dd55e74c81f8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '07958a318dc76cfe1f06328746aa65aa31b82266',
    id: 'range-test-20260619-4455',
    matching_hash: '1e8ce5d0dd79928cc8915197f907b4bb441c0c1e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '4185b7e118d3183af9067c3cab95afc2cb5ca5d3',
    id: 'range-test-20260619-4456',
    matching_hash: '85bb386e788a6c2c78c8c46f406105f4747efeaf',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'aa5903813954c9975b478e0125d33b6fb6223ab8',
    id: 'range-test-20260619-4457',
    matching_hash: '6e36ea21065e6ee3546e81ac0014f810b944d297',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '7d8e93dc4a55c35fb5ac7f7dd6e20c4a7f3421ae',
    id: 'range-test-20260619-4458',
    matching_hash: '908281d6ef114feec9ea1a061dfcd3435bd1a9e4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '84e5bae6788b9b8a8d2b2b25ef1d188fcf0c4669',
    id: 'range-test-20260619-4459',
    matching_hash: '1e946552dc694b67ad25eda05010eb5fcecabd09',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'c59fc5155ba051ee49b6481db11253fca49fdbe9',
    id: 'range-test-20260619-4460',
    matching_hash: 'bd0081138d70ba47cb85702d375f0ba211fbffbd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'eec02540dd5492ddcaf15219b4ba349421ae8cc2',
    id: 'range-test-20260619-4461',
    matching_hash: '3de68c99b6c61be261a43d551b90faf004d10908',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '8cd29961e25546ac7168c90773f0c32d6d1571f8',
    id: 'range-test-20260619-4462',
    matching_hash: '4f178b0718c52c00695812970befa35e9ca50290',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '0ecbfc70eb91286b6ac2fbe708b2053ccb2ef78f',
    id: 'range-test-20260619-4463',
    matching_hash: 'd03dd79a4e962fcfa37e0527ec4dad5dcc2c2dad',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '30f74a3b1b887fafd8b2bd30cd6c26e4d7fe9efd',
    id: 'range-test-20260619-4464',
    matching_hash: '8f7e32b033b3d33b785334edf3648491e8eac7bd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'ce2b2bb038dafc238e590a8f63b0ccaffb94d063',
    id: 'range-test-20260619-4465',
    matching_hash: '603856c9d60ec994a7a5c47b58724b5e4ba84492',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '9814d9cdc6fcf5f2fe23caed60446fe6ac93b59e',
    id: 'range-test-20260619-4466',
    matching_hash: 'd2ac290b55173957f6523de09f9108bc87cdfdd6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '2ad0f6257330e23dea5258f7ef5c9f4822b5bf53',
    id: 'range-test-20260619-4467',
    matching_hash: 'c88c70a72b8592183518a8d20800e74e17ff1b53',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'e94ea077714d3883ac63127c50f89a32949208b2',
    id: 'range-test-20260619-4468',
    matching_hash: 'd32193ac9e432dd774be8e4f183d8893a33f80cd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '9d047414bec200a3d5456be0cde7afd5fe5516ef',
    id: 'range-test-20260619-4469',
    matching_hash: '6cbf6f1f3093f34d6729a18b9bc7cdb90f774fe1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'bc1fdbee2f7d8a825c1cef21a54bf29fdde4064e',
    id: 'range-test-20260619-4470',
    matching_hash: 'efb901e76faa9f90f61ba863d5ba36d139e65185',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '3d584799314a4357002b11fdfc8e91b818a1b6e9',
    id: 'range-test-20260619-4471',
    matching_hash: '2982139f4eeee47e015b77ec3f68eb0639790977',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'e920fa1031c4c20ad89823a77c6bf1505b147b30',
    id: 'range-test-20260619-4472',
    matching_hash: 'a38df4745c10785fa42bd8a4689e5dd6f5b62b68',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'e8727f66248b46d410d0207ebe8fc78712064025',
    id: 'range-test-20260619-4473',
    matching_hash: 'e6ad38842b4e53b818f13402c6f52f1c8d2fcc5d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '2834d4ba9ef972e6504ab684f9255144baca4d2c',
    id: 'range-test-20260619-4474',
    matching_hash: '4b80aebfd8ddf90810175c130359de3e92d99948',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '5d8ba8dfa824816f8ec77015caa2728db495123e',
    id: 'range-test-20260619-4475',
    matching_hash: 'fdf2b595b1d60a443d4f57ebd7f117c22e1efa8d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'b4510259cb7a81123c8968fbd466e984966d117e',
    id: 'range-test-20260619-4476',
    matching_hash: '232ffad85f7162b2bca6a29edc8dd5b4bf9fcd43',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '4d4f9b1921e5a37f4b05ab853eb2846c846d0207',
    id: 'range-test-20260619-4477',
    matching_hash: '083a8ed5fcb1dee367514fc84d69590a80326879',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'dda6e956fb1494867bf09c4cec5a93700c362a35',
    id: 'range-test-20260619-4478',
    matching_hash: '98e2625d595799b3a9f675139d5ad2379792d807',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'cfca01b38c8522edc175920432221551864377fc',
    id: 'range-test-20260619-4479',
    matching_hash: '6e31016a26ecb2b47b11aa1210abc12c99885a74',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '2fd759df143e1075acf1f0e98fdccb9daac960bc',
    id: 'range-test-20260619-4480',
    matching_hash: '087fc2cbc9052a7ecd7acd2b634ad626d672dfcb',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '1a6acc6c0c6d1675592522f9c3203f2483f07772',
    id: 'range-test-20260619-4481',
    matching_hash: '841b8cdb2b829469ca4b7f735f95e437200ee23f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'ff0f1af95757288cb485e4f0e1036e7847d97d07',
    id: 'range-test-20260619-4482',
    matching_hash: 'd8b10ccc0962adde6bfc4033a2445e9d116d954a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'c0202f0abcbde5b4b845414a781e22a82552957a',
    id: 'range-test-20260619-4483',
    matching_hash: '63061b6b2ccb54b5efb0c37e9e42b979d4ffee67',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '1c15c5040684c6ae58440cba77d4fd1af8f2c100',
    id: 'range-test-20260619-4484',
    matching_hash: '87b80c9c76e256c9f7fe666a47a751c94ed81596',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '94b79378ebfdf432a0327fad013f041b5be787aa',
    id: 'range-test-20260619-4485',
    matching_hash: '78ea2b82a32b3f20fdbfef4ba715dc4dab8b7615',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'b578e52453439e777f68494f840806a66f4c3ff8',
    id: 'range-test-20260619-4486',
    matching_hash: '76d0a1f9d552ecd259c9093826ec515d9b477ffb',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'fbe391c2dd60bf9f1cd779198ab636b56246c941',
    id: 'range-test-20260619-4487',
    matching_hash: '197df54c2e77aecc73453cb8a55c7fc0504c389e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '17356fd36095332ad02ccb7b05a8574b3c6b67ce',
    id: 'range-test-20260619-4488',
    matching_hash: '63604742fef138a612b9e87d9ef0a144de88271f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '30b3ba55f454045fdf5324e9705bd76955d34b19',
    id: 'range-test-20260619-4489',
    matching_hash: '52b873a93aeceb23aad7e6b420f584f055c6d4b4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '96aad936d4988beef23ccfe8edaee82f5b84d4c4',
    id: 'range-test-20260619-4490',
    matching_hash: '06c10622b4126087449161be99952ad8b4601da1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '81faa64aa48b3d4bd9159b78a0c42ea8fc2a6614',
    id: 'range-test-20260619-4491',
    matching_hash: '18c94e833601f9add508f4632875864d9fa0a6f2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'c4432366e55f75b0c8e3301dbd49d794c67f0459',
    id: 'range-test-20260619-4492',
    matching_hash: '4b3f3a5b17437f9d9e7d2490de0a23c15c7e4e88',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'c52689cb9db4e33a7367a2e9c1dcf796ebfb83ce',
    id: 'range-test-20260619-4493',
    matching_hash: '449194e6eda72943a1812b089e1a795846fcedfd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '7b1b0e9c5660e08ccba3905e8c17110196cb8d9c',
    id: 'range-test-20260619-4494',
    matching_hash: 'd5304802209f27cfe5197221ce1976e79435f76f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '9e0a898f864f4f43d4a2ac11990f8c1801e8fb29',
    id: 'range-test-20260619-4495',
    matching_hash: 'fe601c2e18b6aaace933a5c2f66aac22d7fd33bb',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '3f587e2d8b5d14445a86f2fc50fcae1f3d06d8f2',
    id: 'range-test-20260619-4496',
    matching_hash: '862fea00fb5b47d0c01c76f5dee0c4d10428151d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '6639fce42f72eaa74fc6dbcda364b0f4fcaebffa',
    id: 'range-test-20260619-4497',
    matching_hash: '3332ad32b59fa99375d6dae164d8f974be9390e8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '47e9f876fa5b8917e0fe65e5036759a3160309d3',
    id: 'range-test-20260619-4498',
    matching_hash: '6070088e192b41436a6f52735f5d581f23f3456c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '52a14667fb12aa0d2b12fa5b70745c66ca50442b',
    id: 'range-test-20260619-4499',
    matching_hash: '46d03f1a8f6f1ab33796b47a14bc09cae5dd3a2a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '8cef0c5bbb87da9456e7c1a1507d20d09500f641',
    id: 'range-test-20260619-4500',
    matching_hash: '000f8e3ebf3ba42b5ecb3e076ee184036fc1c041',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '87cc387c1b46e97aa68cfa32e9fa17033ad17547',
    id: 'range-test-20260619-4501',
    matching_hash: '53a05d97d4320d0ddc639900791ffb25d46aed4f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '854ece3f0f41351d4176ebf157943717243f64e5',
    id: 'range-test-20260619-4502',
    matching_hash: '3291d3c4e9782596ebb2fac7fda6af59890efab4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'cb7e3dfc851546762f9b45c4574d1c5f9ee74775',
    id: 'range-test-20260619-4503',
    matching_hash: '09a561aaa0655dec47cb78883628bbc3d5df37e2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '9dab050a07816214d054661681129972d0bb2679',
    id: 'range-test-20260619-4504',
    matching_hash: '49b3767e31310dd0ec0d35f7828686517d1b2170',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '923d8977a96d571953c79da42b7a924a55cb8c3d',
    id: 'range-test-20260619-4505',
    matching_hash: 'c22002a34c558eebf6d30cc030f455750fc8045c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '4b44be67aea27116ce164cbf3e20538fd4b91e3b',
    id: 'range-test-20260619-4506',
    matching_hash: '48fe472ee103dbed271e89e1822ef5c84882375b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '52903b5e02ed935ce6f8430e3c51a4c075566787',
    id: 'range-test-20260619-4507',
    matching_hash: '1bca3f2d341c669c63dcd694c8749b6ba53194ec',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'd883c74b9c32818423c3335f1097f8222b3250fa',
    id: 'range-test-20260619-4508',
    matching_hash: 'd2f880f100a01fa1aa2e4f53cbe12a85cbde7f97',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '1195837e08d87ba7d3c5e5915a1a310af38af9bc',
    id: 'range-test-20260619-4509',
    matching_hash: '693ba6e320c4cc8a04126d0649f873b9a5977e12',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '13c6f0de28604fbdf255aabd12ead205496efb0d',
    id: 'range-test-20260619-4510',
    matching_hash: '13ac52bcf050c56c9342f946c5f50ef84b54e27a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'dd2012e912bb88910ee5e28ad8083342acbaa64f',
    id: 'range-test-20260619-4511',
    matching_hash: 'd50fed8b0490d19374c389008970b45836f1a7e1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'cb9432e9cfa89e0f29a648510b988e7134d2e153',
    id: 'range-test-20260619-4512',
    matching_hash: '40d324ed35e43c79cbee23f730d31e8233fc267c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '0ef3c345e60d38a40a24672d55546cec384c05b6',
    id: 'range-test-20260619-4513',
    matching_hash: '6a001dcf72130d16e4616231dd04c8f3360e11a8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 3.625,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '0014679939731d5412bb742f8406b79b5c63c692',
    id: 'range-test-20260619-4514',
    matching_hash: '9df3eafe28b7664b06aa6fdbf5f987383f2f12f7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 3.625,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'dd4bf068e848d3f0dcf55f9221e895081b1b5a20',
    id: 'range-test-20260619-4515',
    matching_hash: 'd53abff9f0b3efb99cb10a07ef9d8047d1edd82e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'bd17d1f015370872cb93f965a33bd6503f481ad8',
    id: 'range-test-20260619-4516',
    matching_hash: '993a7fb971f61839f11a7303b5af3e7bfa15b9bc',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '313b1a9f189955c01a03e76ada8dfb9c70e532b4',
    id: 'range-test-20260619-4517',
    matching_hash: '8cc8d988e1c2ed27640d2493d489154f671f2406',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'c77a9da8ff392cb404740741533c2aa0c9637cd8',
    id: 'range-test-20260619-4518',
    matching_hash: 'e93919080aa2eba5645823e5163317a403337b9d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '6a05e8f1a8e15254de7b2c536e3fe0c9b832056e',
    id: 'range-test-20260619-4519',
    matching_hash: 'e1b26ec6c112cb0ac568a43e11fc43d602fd1115',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'fc8e75d9a565b015fc1b2a1903bd4c9a9167f468',
    id: 'range-test-20260619-4520',
    matching_hash: '92b4244b14de7a4d8274cf0606bb15d8aab2a798',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'e321cb4b6dce52f6fd5b5aa96e94501ee8153b56',
    id: 'range-test-20260619-4521',
    matching_hash: 'fa0fc71a7620d02657b06faacb4a9a15a9af7986',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'e641e1c5a870d011c156b9f2e8d8ded8749818c7',
    id: 'range-test-20260619-4522',
    matching_hash: 'dc00d31a6bcd503abde288a39e19ad710ad6abc2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '8d4c4183e85ec924510065d2c1a966bff73fb2f9',
    id: 'range-test-20260619-4523',
    matching_hash: '20ca97e1d1cea313c4fd48b5f9dd7560db493623',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '8060471d9747d883a908a5c413d4dd05999df84c',
    id: 'range-test-20260619-4524',
    matching_hash: '3960390cdaae8f1e02f2ee2c968161f19dba2373',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'a51f299ab3eb46833b5390e73b24b46a21b4c718',
    id: 'range-test-20260619-4525',
    matching_hash: 'f6b96d84b5fa3f70c35dfbe3d20ffef5eafc988f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '62f83ffed243907b73eb4e48abab619734db9eb9',
    id: 'range-test-20260619-4526',
    matching_hash: '9c004d2e4d2a3931762087315e9594f10dd48aa1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'cd5a495d06d162b97b20b9a980443fa8958e97f4',
    id: 'range-test-20260619-4527',
    matching_hash: 'b601c44a285a89d755859fb90f1fe86715263a04',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '8c0c0961cf23814a76ed5eed242189cdd2c08dfd',
    id: 'range-test-20260619-4528',
    matching_hash: 'be62476cb50a65415edc9a2e204a130ba82d5261',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '6aadf3cc7db09bb14d7e7dce61611ed5cd31edb3',
    id: 'range-test-20260619-4529',
    matching_hash: '4759f292ef102fb7fa20173dcb6fc8b3b91043b0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '08699afed8f5089f9688fb4579c254c51e6eb25f',
    id: 'range-test-20260619-4530',
    matching_hash: '3ef18b03973607c4c410a014c1012254f57955f8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '52a6abcba2b81d4aaa3d7cfc1af728cc448c0cba',
    id: 'range-test-20260619-4531',
    matching_hash: '587d39cfcbc3ffa2cdf563d2f260195c864e9be6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'dc8957a5557f44e5e15a594e129777d474b7828a',
    id: 'range-test-20260619-4532',
    matching_hash: '591c4fcfa7da51af52bb45d7a14bc9f1f6df7655',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'd52b4e43df9295c08e52340235ff2ad8af3df0a4',
    id: 'range-test-20260619-4533',
    matching_hash: 'a71c0ddf83ef817c8a07f034cf0ae968eb7d9a00',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '608b8f7fad29e7529165a18e6b903e4daeb848b5',
    id: 'range-test-20260619-4534',
    matching_hash: 'cac8fc438b82746065a9fdde907ad05993fecc72',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'a133d4a721be23b9bd74e6a4dadb70dac7c888ac',
    id: 'range-test-20260619-4535',
    matching_hash: '8015ad69194dd21da6d820ed79e49996c65adbfa',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '0e805d239712af9d339623be4af861762d10c0a4',
    id: 'range-test-20260619-4536',
    matching_hash: '0158e2a005852dca2784a32f9f834981c443ead7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '42629f5f78bfa7dbc37e6ead3e239237413a1d48',
    id: 'range-test-20260619-4537',
    matching_hash: 'ba649598018180196338b20d206755b33f5faed4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '856a92c0185c7af0b9889f5c149230a5dc125135',
    id: 'range-test-20260619-4538',
    matching_hash: 'a4935e30ad00e4f8918c4cefdcf6de5187d993a1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '155b2ac21fab74e193eb76cdcbfca1476068d1af',
    id: 'range-test-20260619-4539',
    matching_hash: '642d4432d9ace9667a4b0bfc2dd5de87b6f45f56',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '9fdc12ff4050d16f2208f3408e51b764a0a5f9e7',
    id: 'range-test-20260619-4540',
    matching_hash: '9da351c9d2ebabf82bd61d96a7adb3cb2f3102b1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'a296b94824d587c0d40d123b06724e7c237789f8',
    id: 'range-test-20260619-4541',
    matching_hash: '4792e007d776b693d737b2dba1ebda8ec126d88a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '1dd1de55d4c880ccdcf1f90d84692e1cd55dd048',
    id: 'range-test-20260619-4542',
    matching_hash: 'c38d51e31c63d95aa1ddd0a0e3fc8d77ecce0d82',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '043b43e9757fca745087fb4c044c9a81c3154794',
    id: 'range-test-20260619-4543',
    matching_hash: '9f81167c2bddb56a039976bf1c22fcdb9c8b3d19',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '6013b0ab692309b376c12fab5660436a3b0f435a',
    id: 'range-test-20260619-4544',
    matching_hash: '011e62570d817d470f3fd10b99c256f9cafbfbe9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.464640823,
    qx: -0.801396255,
    qy: -0.312820343,
    qz: -0.209800814,
    tilt: 3.375,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '1665d29fc5985abd9e6b759c6922052b637e7be9',
    id: 'range-test-20260619-4545',
    matching_hash: 'f58f1333844a7469225e162c7fc615c84bb66de9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 3.375,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'b21671b6c8dbe4813cf8f2cad050bf4e257f9e65',
    id: 'range-test-20260619-4546',
    matching_hash: 'a38be6dc6b1619f3155ee4467010390c4843e399',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 3.375,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '4a04d7b148fe3ce5c9955bcf17e252e93c81a0df',
    id: 'range-test-20260619-4547',
    matching_hash: '42d6f0fd9e1771f91d7004a448c5c30cecef27ef',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 3.375,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '7fe13e819b42a638478d28a4612e2474a5d7b00c',
    id: 'range-test-20260619-4548',
    matching_hash: '35622af252c5aae3b338b569a0d088ddc65f820b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 3.375,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '83ae588a277f9b98fc72272b69c1a5e755ddb3b6',
    id: 'range-test-20260619-4549',
    matching_hash: 'e57057d734d1f430b5ef611df4c0a6ab2c639cd0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 3.375,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '334698ed8f89cc3cc30150f80ba370e8a081fb78',
    id: 'range-test-20260619-4550',
    matching_hash: '302e528b21a2114d08561cd784d7bf24072158ce',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'c14e43401bd7dc72fb9ef4a13b9129b26a52529e',
    id: 'range-test-20260619-4551',
    matching_hash: 'e17eb5529e868be318c59afd93806fe0930ce501',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '46412f6db13a058cea2346cdb73ed3f795c413ff',
    id: 'range-test-20260619-4552',
    matching_hash: '521e27a4d0c125b226444afdea4c23531cc64972',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'a60dcd425c2ff5484d7e6c102bd7a14067908a53',
    id: 'range-test-20260619-4553',
    matching_hash: '73d43b6ee60f0afbd31e5cff85c5b9adcad24cf9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'acfdbeb85e3c5932093ac91e1d059d681b5e96f2',
    id: 'range-test-20260619-4554',
    matching_hash: 'dae686d249165e82895f59a9c67200b1ebdc0881',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '4a6f72d3afa4e94cd498449c3b7f53e966d576f8',
    id: 'range-test-20260619-4555',
    matching_hash: '6bef57a2595cd2f107939c870409df5fe916d5cb',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '35d42fd1fe4278af80e3387fe46bdc2e6dab9f26',
    id: 'range-test-20260619-4556',
    matching_hash: '0a29a4ef440d7ebc7ba5cfeadabec4ee33cbd0ee',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '2c38d3228e70e4aaf6f419083262d8d5c181d5e2',
    id: 'range-test-20260619-4557',
    matching_hash: 'fbd51bfda56d8910aec846e9fc1a1fea1da53376',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'c08865b0216f3c8d486ba02aa87fbb572f5912b0',
    id: 'range-test-20260619-4558',
    matching_hash: '5d80d09f6430ab6d1ad7e99d10f9ddc3c7617d03',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '0105a8d1d2e45f6f888db2991ffde7ad482d3f8b',
    id: 'range-test-20260619-4559',
    matching_hash: '048b993be575ec4537257c463f89f002219bb653',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'b38bc96f3e97e0630c34d994952e8eb4748b0da8',
    id: 'range-test-20260619-4560',
    matching_hash: '6bcae5db8f74180377a78a2b81b1b7a36e9cb426',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'ea36ad5ca87b72fc36f144f751fc557f5a073b64',
    id: 'range-test-20260619-4561',
    matching_hash: '0c1244cfa22e7b372edcf12fb24b9e8aa92dad8f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '493aeb0f7b519eae742ba8d88133972e0713da02',
    id: 'range-test-20260619-4562',
    matching_hash: 'ea7acf0cd2b278387e3eb0efc469a2c2217cf771',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '79210e5b5484c18a8350f9840ba9f2cb49fc9bfb',
    id: 'range-test-20260619-4563',
    matching_hash: '392f479705963529620656ce8e40889b4ef3b8d4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '9232859322a512a7efd9a8a16a7e162b10a49463',
    id: 'range-test-20260619-4564',
    matching_hash: '29ff1098a498c28c6f5388d4f19117a2d46b16b7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '6c38001f146fce45aa259d2e88d15f3ff31728eb',
    id: 'range-test-20260619-4565',
    matching_hash: '34d8d377f823ae7e3220ff53f6e910a679e1b127',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '4aa2a2a627153d5d0702a986dc2658c7aab7c519',
    id: 'range-test-20260619-4566',
    matching_hash: '73464e84a020786f8dccb69d4d42742e1bc1d613',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'e90fb677ecee860881119ef30a22f6027345e385',
    id: 'range-test-20260619-4567',
    matching_hash: '1e610b19d35a3749ad4f936c35d29cbb851fe555',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'e0b04cc254a34b06433224154f9a0f54fa747f5c',
    id: 'range-test-20260619-4568',
    matching_hash: '3fed8ac0122e333832f3ce2278d02a4fd05b551c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '6d43b382e30d8d41801a4e4cb7ff6e211c55ff47',
    id: 'range-test-20260619-4569',
    matching_hash: '29040f87be24ee81975e8ed29b5a0d2d25b4632d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '24e06b03f9d1cc0b8923fa1f0defd07821cceeaa',
    id: 'range-test-20260619-4570',
    matching_hash: '86f928984c4edfb36ec6590fff7a44630a290f69',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '2a1e741a6717655d8e343683f5a4761413114a38',
    id: 'range-test-20260619-4571',
    matching_hash: 'c3184c96af8a182e24d77d592d18b022c8fe923f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '3c80d9e50338573c1e6ff209ce75a011b608aeca',
    id: 'range-test-20260619-4572',
    matching_hash: '3cf441af03ea3a7e6a2247eb9b6aa564dc20006b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '4ec16b7d95a0581682df5a63edef41dea90d60e7',
    id: 'range-test-20260619-4573',
    matching_hash: '8cb26034dd5665f8cd7fa8e1d1e2c304dfa6a5d6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '9e54fb8580c7c7fe2a262aa78ac7be97a53c3211',
    id: 'range-test-20260619-4574',
    matching_hash: 'a94b3a70c5572ab578d29663fe98724cd52ec635',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '1f180032fcbc878cd4c3cc5293f1fec8994f0ba9',
    id: 'range-test-20260619-4575',
    matching_hash: 'c53c89775b52c879a8405d7686428e202b4fc313',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '5bbb4551385b1068f8903ffd5938da4a1f054a60',
    id: 'range-test-20260619-4576',
    matching_hash: '1a004b4fab97207fe1b9e87e17b792e2c8dbb81e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'a4d13630d057b2a78ccfd8c42209faad72b196a8',
    id: 'range-test-20260619-4577',
    matching_hash: 'e9c7b363e8b88f80f5bb70f679925b63a8400c5f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'c6d15584d1365fcf11a8b30a8c85c8c43a286fcd',
    id: 'range-test-20260619-4578',
    matching_hash: '2a629fb893ec25233097e3ac5999f28b554bc87f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'b79d05d3bfc49e0dbc10bad929dc6f695edf3e8c',
    id: 'range-test-20260619-4579',
    matching_hash: 'b6252b36d07d429bb711c8438925cd4af9c03f45',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'ccb11a84485798cd895b55ad571c006f076af78e',
    id: 'range-test-20260619-4580',
    matching_hash: '4701da6b613224510792af4f5f0f105b701348b1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '4803ad230f32e8453b0045d50d51227d3e515f8b',
    id: 'range-test-20260619-4581',
    matching_hash: '24b00b0d11977989d6b0893cff939b5d681a904b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'e9b4a56c04f694da03f598ab10d16a9fe9f6d0ea',
    id: 'range-test-20260619-4582',
    matching_hash: '957236b7b9027e3e55b445234ebb01c4bfc9ee77',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '2ae53125741208c02b39ce3864a5646800dc310f',
    id: 'range-test-20260619-4583',
    matching_hash: '5e6855289a87629532c327bdba84ca96234d71a3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -6,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'd5fb9d02d65f1ed3ba8698384e68a96e9985e8fd',
    id: 'range-test-20260619-4584',
    matching_hash: '20430c6bf80c735920c96b41ef6e645d5f26ff4e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -6,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'a344d4abbcd68eeba9fe97935e4de47b52a7f065',
    id: 'range-test-20260619-4585',
    matching_hash: 'ea3825cd527620b22de824ec88fa832229bd4453',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '9bee69e3bd41fd90b9cc26086695e4be29127354',
    id: 'range-test-20260619-4586',
    matching_hash: '00732011783667f777a529512304f35cbd2325b1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '748d4772cf5155eda990376d2c2ba52199774c4d',
    id: 'range-test-20260619-4587',
    matching_hash: '855a312ae3c2e529375999e3fd6ccc8d572911e9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '9649b837a5dca964ed38599d3d300340fcf4fef2',
    id: 'range-test-20260619-4588',
    matching_hash: '003b6306d669937a043ea9b3b8316aba44aa4275',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '445fe076fc618eb0255592a4df6843ff859bd899',
    id: 'range-test-20260619-4589',
    matching_hash: 'fcbd8cdd1c3e9d1a7d1cd74187b5fbcb0664e883',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'af413ec7f1d8baa956b1e94a5262268525a253fd',
    id: 'range-test-20260619-4590',
    matching_hash: '73329b536bad275036f78b4c54813c4dcb1fb630',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'a532e0432380e9379924785a61ed8a44d3b78128',
    id: 'range-test-20260619-4591',
    matching_hash: 'c73291108457f86f2d74f74f8ff460b772c5416c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '6bb5075e79c9d86d5a1d015b4d378e4792171bfe',
    id: 'range-test-20260619-4592',
    matching_hash: '4c9f40fae85067f8696f201040daa0126b84c299',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '1e808619dde89c8ca16a5808cb543a43c130f457',
    id: 'range-test-20260619-4593',
    matching_hash: '2c9dfba5a7d574d3241fcf752e8edd6354dab51f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'b72d83688de2a65c850300a0e98a1db6377137f6',
    id: 'range-test-20260619-4594',
    matching_hash: '7cb3bb70f08b33600001844f66166245e947721f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '46a45269cf39e17072bf705931a0aa0f8e5fa5f9',
    id: 'range-test-20260619-4595',
    matching_hash: '8a9aea20e8e112556fc15ad6f00ec6956cf0304a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '4edb793a13ed71b6a9a20bbdd34fce458c4bbe52',
    id: 'range-test-20260619-4596',
    matching_hash: 'a5be086194e21ded33d7fd34aad3e51e1a8a5a21',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'c9315c52de2fa81081bd38751130fb80f8238f06',
    id: 'range-test-20260619-4597',
    matching_hash: '13a1583dbb59760a85b767e849d823496aed1bf4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '631de0c14ea82c72a7216681673e85c481676e33',
    id: 'range-test-20260619-4598',
    matching_hash: '1b2c3f79b34e40c4ea9c1da1e593aaa17adae840',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'f50853c3e610d9acdb9245332f7cf6b53845f5a3',
    id: 'range-test-20260619-4599',
    matching_hash: '290d3d6e3fb6588e0fe0d3dc2f9b3ce165810a91',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '7b1c7a7dc2f5edf2b7cb6bbb6b97c028ee199b6f',
    id: 'range-test-20260619-4600',
    matching_hash: 'd4ce45017e4b5682d836a70afb322981e7933804',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '5023d178d19e1a2174cacbd916e9d2fe919c0a30',
    id: 'range-test-20260619-4601',
    matching_hash: 'dd2c17fd3325de0fa54df3fe25b9dfc7f4133af5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'a0d3275b0f3d21ba0a724f4e5ccfd38c399122d9',
    id: 'range-test-20260619-4602',
    matching_hash: 'fbb7b4120f94c6f75629a71c4bf53ecce8f49c40',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'd70ce94c3535399973ee9cb056feca0461f5dabf',
    id: 'range-test-20260619-4603',
    matching_hash: 'd0bdc51561ae4cec4240f3c2cb4af928ecdb4fd7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'a800f7f0bf30e36fb0aca2d8910d6f93fe17731d',
    id: 'range-test-20260619-4604',
    matching_hash: 'd161d60b40435c6c02701de7c696a53c5bb3db71',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'a924710f5e81b756b4c38c8cb4a8f12554452e81',
    id: 'range-test-20260619-4605',
    matching_hash: 'ec44b92db41ccdc0b6fbc12d4ab9383eaba983ad',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'f79e97841464a0f5a6e422f43cc66d5800028b5d',
    id: 'range-test-20260619-4606',
    matching_hash: '7623c5b08278e8574a26e3d65963694b64531cc6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '252ad1db3de77f55497d36a00875e1975dc0d9d2',
    id: 'range-test-20260619-4607',
    matching_hash: 'c1950ab4202f6838da5663cf891712315c30ca29',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '6b44512f63cd75eb7fdb85c0b74a13b289d044eb',
    id: 'range-test-20260619-4608',
    matching_hash: '00e6b12bad6274f3ff524cfa810e22bd48273543',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '6f94584e886c3cda9bf01d2b841a5b945a5156dc',
    id: 'range-test-20260619-4609',
    matching_hash: '5da5f9b4db4fc77344e89f99a77da0c628822a6f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '542157225c3672969e827b66ebd30445fcca9c06',
    id: 'range-test-20260619-4610',
    matching_hash: 'bf2112fdc923bf47c7967cc4e57b32c4bb91097b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '658969bb78c3696b45080e88aea8bb18f53a5dbe',
    id: 'range-test-20260619-4611',
    matching_hash: '5d93408474f0fcbe0614e24066f618430783b686',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '5c0e745917dcffd1e56f2a769be4d17fc06698ce',
    id: 'range-test-20260619-4612',
    matching_hash: 'e9a8577b1d64bd5ec25c15a65b66179a8301d22b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '4ec0b2eadce2037b4d1302c8573f3815e16141e1',
    id: 'range-test-20260619-4613',
    matching_hash: '15d518debc500d4968b6d7b6af7594197030fcfb',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: -2.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'b54f65a63dfcbe502c9eff4d1a3745b75a086522',
    id: 'range-test-20260619-4614',
    matching_hash: '2770cde9093bf46399a41c7858e733b0c3d62362',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: -2.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '5aadf34c0637d2481088b51198daba1b0c820d06',
    id: 'range-test-20260619-4615',
    matching_hash: '897d655d061d3bbd7bf15da732fcc9d560759a84',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: -2.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'fb5c22aa458a6a7f4af3c064a1b0d630673e2cac',
    id: 'range-test-20260619-4616',
    matching_hash: '22eb4ffb2a82f6882903e9feae0c03c3be7a0536',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: -2.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '5c55d8ef96e49d8b8fce600fc11b77087977febc',
    id: 'range-test-20260619-4617',
    matching_hash: '903cf7a39bc5b8aef2a0c2261efda8d3cc954f90',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: -2.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'a8216ab440747c0febde0dd66effe80a2b0162bc',
    id: 'range-test-20260619-4618',
    matching_hash: '1b20389ba106f0fec55a66346862530df5316a7b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: -2.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'd0eab310080623ae95403c7f4df92965c19719d3',
    id: 'range-test-20260619-4619',
    matching_hash: '24136bc362b2e4b64ce51b74c367a6cbd35b5e66',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: -2.5,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '3a2e57e151033fd2899824b6d15a39af64006019',
    id: 'range-test-20260619-4620',
    matching_hash: '0b4fc3d834daf55ae3069229e9084e881e1cd86f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'aab645cdaa6b53b11a69508b48b74efa188a56ec',
    id: 'range-test-20260619-4621',
    matching_hash: 'cec90f4360ef17003a7e028e5556f45a9a4ceb12',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'c5f4c4f93efb556486f1c1a31b77270d7e43f409',
    id: 'range-test-20260619-4622',
    matching_hash: '2356a760779f2a873f44ae279a01fd407cfefa61',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'e1020e37be50872e02285562e6918780a3e1b8f1',
    id: 'range-test-20260619-4623',
    matching_hash: '7393f575b65cacc36a65fb57c1e5c576e7c409a4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: '8bb528321b0e4b7d11375a4b0164592dd428bbc4',
    id: 'range-test-20260619-4624',
    matching_hash: '35bb66f2c6c0646010b10c47520cbafeefac1ebd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'a002188607cfb6b3933923e11091cabf5db3fb54',
    id: 'range-test-20260619-4625',
    matching_hash: '27847179deda0ce9f07bb78cd5cf3d24a9815402',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -16,
    a2: -16,
    a3: -16,
    ball_type: BallType.Misc,
    full_hash: 'c276d5db0ee21d0f71e1c9c51ba23dbab30eac51',
    id: 'range-test-20260619-4626',
    matching_hash: '8ced79e65110d53f8d028e4992da9dddcdd29efa',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '9dce768cb19318269479b9d0df78ddd34099963f',
    id: 'range-test-20260619-4627',
    matching_hash: '6180c46db407fc40f8f827a6b0cdb24b9746ec29',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '4a168cbaeabf894f6b897dc657dcd8e5163afc3a',
    id: 'range-test-20260619-4628',
    matching_hash: '5e7ba8ffddf22fd34373e94c5a91ac5b867e93f4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '7db1e7007a0f7d2b8a34a448348fe812176d6e52',
    id: 'range-test-20260619-4629',
    matching_hash: 'd435f2235c778f2c6d7c47d3d123b31d4032eb9a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '1194895acf642ac18febd2bb612f577d4c51a5f9',
    id: 'range-test-20260619-4630',
    matching_hash: '43d907d53459878142cb851dc8d6462c2d31486a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'daa68e29ccc2bc703af98e82b55d41c6999bde14',
    id: 'range-test-20260619-4631',
    matching_hash: 'f40d21c0aea00e07e77b2030977b4e670f4782eb',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: '2835ecfa671109be5b2b1a8b219df43bb2df86d5',
    id: 'range-test-20260619-4632',
    matching_hash: '39e225eec60e8b4a7cb94eb4296c6941a8248f2e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: -6,
    a2: -6,
    a3: -6,
    ball_type: BallType.Misc,
    full_hash: 'a40b3420a02439cc7833fb84d0343cf0af537b66',
    id: 'range-test-20260619-4633',
    matching_hash: '6db3b681a93b173a8b85246d1f29632dce804818',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '50213e7ca921abe1c76ce2e11ea5b5465d73e22a',
    id: 'range-test-20260619-4634',
    matching_hash: 'e1ecada75864dc3b9e872e8decee73a1dab9e637',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'eb8f19b517bf63e4556083ece3799011efd358af',
    id: 'range-test-20260619-4635',
    matching_hash: '58aa38339b221bce1bd52a6c8ec7a484d27fc479',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '67c90704ce73ea20595083089c72692d22d54d6c',
    id: 'range-test-20260619-4636',
    matching_hash: '2d16c62a012b54ab04590f34cc8d5bea0838a4a1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '82fa3af29d6ff909f561b138e8de4f795b1c2855',
    id: 'range-test-20260619-4637',
    matching_hash: '769a94e07f944b5decf830a10f5827ee7bfb791e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'b8cd3e4e4180632a654dee084bbcdb7822ee741c',
    id: 'range-test-20260619-4638',
    matching_hash: '6529e067673a0f3bcf7f7f3a69d890b2a464bf25',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: 'b9284805271e6a68e7431fadfa52f590d2e35fa8',
    id: 'range-test-20260619-4639',
    matching_hash: 'b2b2dd36cba3e076bf2f3cf4465486c73f6ee835',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 4,
    a2: 4,
    a3: 4,
    ball_type: BallType.Misc,
    full_hash: '5bb6843bf2cb5836bc89c0b7d71f4221cc9e4112',
    id: 'range-test-20260619-4640',
    matching_hash: '4a3aff78efa1c4daa869d5ef0a878fe6ab79c3d3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '7d421fbdf9836d92a174f2b93f66027d230baaad',
    id: 'range-test-20260619-4641',
    matching_hash: 'aee508a5d220bf3d861ae24c73e3487161513c03',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '874067a127a6ad6b870e23e26268b1da0b81fea2',
    id: 'range-test-20260619-4642',
    matching_hash: 'e82063d054bf5710491872c890095b831b536c71',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '65271553a6057e78fdb7a2d681edc08ab21f355c',
    id: 'range-test-20260619-4643',
    matching_hash: '4f873361b3b578aa53435d1a09ddc760f21d3bc1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '6f8e15275c82b0f66da381902660ad33f462c2e3',
    id: 'range-test-20260619-4644',
    matching_hash: '3284363350e7eacd8b50593bf9fc89cd9578c321',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '8a2c376be482615cf6b669e64704f08ea19436c9',
    id: 'range-test-20260619-4645',
    matching_hash: 'c1cecbcdf090f15215cea979a2de8622d587bab0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.87763788,
    qx: -0.325039345,
    qy: 0.330439033,
    qz: 0.122111514,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: 'c152ab7054345d6d901bb5e1ecb4f2a169a784de',
    id: 'range-test-20260619-4646',
    matching_hash: '15fe253f4855a71f494ea0421b57dc8ff06483ec',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 14,
    a2: 14,
    a3: 14,
    ball_type: BallType.Misc,
    full_hash: '2845b814f494758f6aec436a01fc94158b71bf2c',
    id: 'range-test-20260619-4647',
    matching_hash: '25026d6ef29ffc24317d2558e35ae3212616cace',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'eb2c8a8d86fa94b3153976372ee23b8afb586613',
    id: 'range-test-20260619-4648',
    matching_hash: 'f0fa93d6aa0c99b08f11b080e563c42fa2470521',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 1,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '22a8e5be5e47073162f3fd3bc828bb572e1d168f',
    id: 'range-test-20260619-4649',
    matching_hash: '0729542e699599c78d369c5d2a32e872828cd270',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 1,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'f3a75ace70851de05246d21bb4f99b7e2926098c',
    id: 'range-test-20260619-4650',
    matching_hash: '56001deed293763fea0b5be88189878462a91e9a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 1,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '81e21296173ed725bbcef447b23deb18eb215f23',
    id: 'range-test-20260619-4651',
    matching_hash: '3a434bf7c28327f7fa286e7e8969f0dc9e1dc1b7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 1,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'ed0ca0c2dcaec0d7141eaf60e6109d1d4912a4a7',
    id: 'range-test-20260619-4652',
    matching_hash: '8dfac577a029eb4d6f2e52bfab0d80806bb2d8c8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 1,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: '4de8c4f399e450bd278233b49147b89f3fa720d2',
    id: 'range-test-20260619-4653',
    matching_hash: 'f027971df1ec059ec1f9a2b6d91b70b30182262c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 1,
  },
  {
    a1: 24,
    a2: 24,
    a3: 24,
    ball_type: BallType.Misc,
    full_hash: 'fdbc58345dbbbc405c76322c5f9d1d632385edfa',
    id: 'range-test-20260619-4654',
    matching_hash: 'b17f5b3cc7da096c61a50ebe3926bf765bfc4a5a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 1,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'cde8c38ae3f583559077101cc96c58227fedadf7',
    id: 'range-test-20260619-4655',
    matching_hash: '4585cba5ed02e7086ba0e1c4dd5765d381203ba9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '55ba4d184e239ec77005fde21320d1aa49472689',
    id: 'range-test-20260619-4656',
    matching_hash: 'a7b4ed174e1d1eddeaeb9143421a07b6faf68823',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '8dd98b7f3b338feb1aadec927af3aaf20e622bf9',
    id: 'range-test-20260619-4657',
    matching_hash: '543f8280768ab50cc1ffef14a97c00fbefe9e466',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: '31c4e9815a3786a7f84d7f3ba542150416438ca7',
    id: 'range-test-20260619-4658',
    matching_hash: '23fce5160af83c1bc5a21a1c6de2cd27fb278b5f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'c86a2b033f6ddc75a0e4b97256bf90c1eb752de2',
    id: 'range-test-20260619-4659',
    matching_hash: '1e833fd3cab704a52aaced1a493af27301a8590d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'b6aed384d7d14b1efbf6221a5a7ff507e6c4fa7d',
    id: 'range-test-20260619-4660',
    matching_hash: '27ad7441657db6253c2e2b98695330bae2b65115',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -17,
    a2: -17,
    a3: -17,
    ball_type: BallType.Misc,
    full_hash: 'cc081c9a86985f72fc24485d01ebb8d56bff6aee',
    id: 'range-test-20260619-4661',
    matching_hash: '7b63df663c8dbe77e4f6adce3ec0bcdfcea4a624',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '38669e885d81908cd7a21734652d70f31182b9e4',
    id: 'range-test-20260619-4662',
    matching_hash: 'a766fa8ff952dca0ca4dbc8fb1705defff60788d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'e63245d7612991f10cdf41e538f7057ab8508962',
    id: 'range-test-20260619-4663',
    matching_hash: '6a18be9f7b4e5f45f5efaf1dbe79a95fea778a31',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'e90610e8c026469ed478385a95c20c8af2049105',
    id: 'range-test-20260619-4664',
    matching_hash: '867ea1b02419b079100d77f00b6458aafce9a1ff',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '260dbb96fc1c0bfbd6e0ccf95c55f07ee9f309d5',
    id: 'range-test-20260619-4665',
    matching_hash: '2f76f0d20c0722f280159a585168973228a53525',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'af2c141be45aa642c2b49df388ccdf646b64a18c',
    id: 'range-test-20260619-4666',
    matching_hash: 'b1af1d8ae912cc5952c6079e83f06fbf571e1f52',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: '4b3638f5bfc179c4f6d1d65de3be1aa0babd32ae',
    id: 'range-test-20260619-4667',
    matching_hash: '92e395c1f02f8a23711938b07723e6c3fe3899a0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: -7,
    a2: -7,
    a3: -7,
    ball_type: BallType.Misc,
    full_hash: 'd3d29896d8890a38078ad9bbb2fad8a7cea6c172',
    id: 'range-test-20260619-4668',
    matching_hash: '6a8e51c07b012394d5151068e48ff039ba79bb21',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '0e510a40e19018f2b7b35bcb6ea371fa534d86ee',
    id: 'range-test-20260619-4669',
    matching_hash: '917f84b6dfca65f4ce94bac5983564b95854bc08',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'd70a5d68b0a1ffabec1037a664c8384d0f72438f',
    id: 'range-test-20260619-4670',
    matching_hash: '9dade78e55a204211ddc75d126ba3d5a59f77242',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '215a602bb7d3020c85a79fc6935d4d2bbc7cdcf1',
    id: 'range-test-20260619-4671',
    matching_hash: '82919e9de44c544d105049f70bf415e88e540996',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '488abe64c06df401dbbd3d5341391b03c4bbc9aa',
    id: 'range-test-20260619-4672',
    matching_hash: 'bda36737a4bd01c5f56f7ab0b7ed5baca72809bc',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '01cc2f104aa211ac447f8680d68f7424ba5120cb',
    id: 'range-test-20260619-4673',
    matching_hash: '09855a18385477b64a42c229373782ecfd421cd0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: '748567930a5e23e1ea266ab32e10144d00af7258',
    id: 'range-test-20260619-4674',
    matching_hash: '21dfc80bb490a3d416f119bc7df1d3572f5af458',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 3,
    a2: 3,
    a3: 3,
    ball_type: BallType.Misc,
    full_hash: 'c70d458688ac716aa5307f3c501da0f952dde7ee',
    id: 'range-test-20260619-4675',
    matching_hash: '3b5726c00c2c8d30c89be2ab52602828c7ab6fd6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'c0e6c24cc98705a714af75212fbb483b2e2662d7',
    id: 'range-test-20260619-4676',
    matching_hash: '1ffdbfd065ce1baa0653a3be17863fd510c5fa2b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '18acb431b2a04eb637859c6cbff71ad6e85c64f7',
    id: 'range-test-20260619-4677',
    matching_hash: '7aeb9a769a9a313a016643bc346415d0229a825e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '14e5f2eb772566342b1e994c09bfff327a0dc33f',
    id: 'range-test-20260619-4678',
    matching_hash: 'db75b24d0ad3a21e6d1f81d628b2708a3fecbe7c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '19b923e4d925ac67f75ef497a3e4913fea5fe9d8',
    id: 'range-test-20260619-4679',
    matching_hash: 'a184e3d07dec363a870007d8bd4a91c32de8f285',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'a8bbb6dcc57894352fa40910653b87ea5e9871b2',
    id: 'range-test-20260619-4680',
    matching_hash: 'f75fe72be8e9ef19c2ccf1c69f9561fe51a34d80',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: '5a4a8f6eebb6131fb0cca5057c0d2bfdebfbeeef',
    id: 'range-test-20260619-4681',
    matching_hash: '0f3bc8ae451a349b2e94bec93d05f24a58e4b860',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 13,
    a2: 13,
    a3: 13,
    ball_type: BallType.Misc,
    full_hash: 'a6a348bf382040a78bacd97fabf7ddbf6d8f0f37',
    id: 'range-test-20260619-4682',
    matching_hash: '91f46e42f4711c9c2beab3056ef4fdc2fd518448',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '258beb7bcb24ab9b7641e093030245961cc74eb1',
    id: 'range-test-20260619-4683',
    matching_hash: '9b3da1dd6ac6510514a34eccf2dda5cb5e783307',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 4.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '36e9d5add7d93018688eb36e37b6c7e7f0ad411e',
    id: 'range-test-20260619-4684',
    matching_hash: 'c154a67078d2245d315e1d5292db05ba5ee5b297',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 4.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: 'e1d865785efb5a3738ab1b659a2a8e0ba6ed2355',
    id: 'range-test-20260619-4685',
    matching_hash: '87e6be8c822d9a9254171fe45e4e992b0fcbd9e4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 4.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '0d5c11b87fe2ea23e1283d6b311f929ecabc5f2a',
    id: 'range-test-20260619-4686',
    matching_hash: '2d8aee54b7cfe92519f659c8ef0472b5a2b8bd41',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 4.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '9855808c100a1a0226c458fd2ecf36114ae156f5',
    id: 'range-test-20260619-4687',
    matching_hash: 'b08e4047de4d696cd57e6eceebe6dbd35f68ffe1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 4.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '3e66ac3428ad391aebbe27f48de60516732a26a2',
    id: 'range-test-20260619-4688',
    matching_hash: '98f6a534bcd0792c99e769413585138e88dc5387',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 4.5,
  },
  {
    a1: 23,
    a2: 23,
    a3: 23,
    ball_type: BallType.Misc,
    full_hash: '52fd32be64db90bd55fa652d3a644be9aa71c54c',
    id: 'range-test-20260619-4689',
    matching_hash: '80e6269a5743521de5f1668fba782ab10c8a26aa',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 4.5,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'adef57f6bbd6531dba7cbc2ba2cb264bd54258f4',
    id: 'range-test-20260619-4690',
    matching_hash: '3f5d114ab09f4fb924e2a5e8a74799ed0c1cdaf8',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '868c09b07e512dbd79b23b94d28fcd240ab3fccf',
    id: 'range-test-20260619-4691',
    matching_hash: '3b11439656c85ee6ca889f4a3a08479047d9a354',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '1f8720f4d2b1a425616926f548d4faa5067d6bb9',
    id: 'range-test-20260619-4692',
    matching_hash: 'c76c3ee9b1f4945600c33f61dfe17f5cc4dcbaf4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '7b6225ad051b57bdc3c7976d3ade5e2682b7b0f6',
    id: 'range-test-20260619-4693',
    matching_hash: '7ab95167e930ba6bde1e2838430a8421a22c7353',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'e7666eccb9b407128cdef40659fc377dc08ad217',
    id: 'range-test-20260619-4694',
    matching_hash: '87df16a7c39fb8cd57a94d775237cea35c774144',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: 'c24133877422dd8d704ccda20ea21ebcc337cc29',
    id: 'range-test-20260619-4695',
    matching_hash: '5c26cc9e34c217eb696e09860515cb29cea08741',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -18,
    a2: -18,
    a3: -18,
    ball_type: BallType.Misc,
    full_hash: '9c9de2f5c6bbb829fca5041ee7068291a04c1cd7',
    id: 'range-test-20260619-4696',
    matching_hash: '5969d45c5ffb5646852f492ad472f4c9135834d2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'cce84427ac41f25e2b8e8cfef186a2db9a1bc07e',
    id: 'range-test-20260619-4697',
    matching_hash: '53790b1bac646eb6d2ba2977b9c38ec4bbea4f84',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'a217c5259542d44b68d865a8c578e7c6d61d4ee8',
    id: 'range-test-20260619-4698',
    matching_hash: '9af87226b8781718a67779da8d13dab1d67eeae5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '75ea36fb031df1c697df1ed32a0add21cacd50b6',
    id: 'range-test-20260619-4699',
    matching_hash: 'fb3854266e7911cdb367c5cc340c1b06a77e5ce0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'b3e5d192e7178554e1194e560b02fdde61ac1d10',
    id: 'range-test-20260619-4700',
    matching_hash: '01bee3533ff2962335f124bd96364f06caa1f2ea',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '3b944cdf02e098d74386e63d2e2df41366025255',
    id: 'range-test-20260619-4701',
    matching_hash: '570ad94717be5d77bae32badf7d993b0e0a8100b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: '3840764a8d6df7c5931bba489ea6182f45524b47',
    id: 'range-test-20260619-4702',
    matching_hash: '3e747c43559106e128b255d7f029cd1ac44e666d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: -8,
    a2: -8,
    a3: -8,
    ball_type: BallType.Misc,
    full_hash: 'd4cde9e80a5c43f5823a4be1c8c467b388a42137',
    id: 'range-test-20260619-4703',
    matching_hash: 'dc8cff09e1121f23bf2fc8c558e62163ce4b9ce2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '89e72381e8385fe998b5c01a760a9059f022c5d0',
    id: 'range-test-20260619-4704',
    matching_hash: 'ade9fb9675810fe06a840946866f20ceb7699409',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'aba2ce7d6e2aad7389bfe03fbb95a889d1509c66',
    id: 'range-test-20260619-4705',
    matching_hash: 'fffea2b036222801c74060f378197409e4a54eb4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'bc10a47d6c8bcf775772a748f14d1c85e601049c',
    id: 'range-test-20260619-4706',
    matching_hash: '92e71b7a2670394802240747c5cd156983876285',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '6f67ef212b42ab6ac6a41a0cee3426f4548f1217',
    id: 'range-test-20260619-4707',
    matching_hash: '3a5eacec0f0af618a4c57b930b86810440823688',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: 'd61fb133ecf4fd07d5d0ce04fcce9e7eb1a41895',
    id: 'range-test-20260619-4708',
    matching_hash: '31103eb81e162417969244e95d48156499d9edcd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '10f36fab4715f0ff6ab81b07b44afc16c3c10160',
    id: 'range-test-20260619-4709',
    matching_hash: '0979eaee141732553278be90551271c97d9c8fe3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 2,
    a2: 2,
    a3: 2,
    ball_type: BallType.Misc,
    full_hash: '7b359596ebbaa3d988111723bd04012fed3e21a3',
    id: 'range-test-20260619-4710',
    matching_hash: 'bb9dbd85735a8f6fbcf5d00c923613e2d2f7d572',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'be80e995bc78d276ebf48233f0a8f1b5772cc3f3',
    id: 'range-test-20260619-4711',
    matching_hash: 'f49eb2b4959dbfbd20abad8535b548f0a2a6b5c6',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '67caeb97b1543787e08eecef66665d94dac7ae40',
    id: 'range-test-20260619-4712',
    matching_hash: 'ef5059b87f18a5d5cf7e78984a5a16272be79b5c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '5b32d3651a61d067fcb64188d369150747a472a0',
    id: 'range-test-20260619-4713',
    matching_hash: 'f088e0179fc9a84098ee0000a334d3060cb5ed76',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '896e164d92c078961487bb728c68945261731525',
    id: 'range-test-20260619-4714',
    matching_hash: '7692f7ebf914f4cca0979b043fd3d9e8f1db6a1f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '586abf381aea765d37afdc6b0ae6e2f39d8c99f9',
    id: 'range-test-20260619-4715',
    matching_hash: '8580cfa87b730c7092486c88beb83c2ad3ecde85',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: '788386a656ed073c5d6cdbe758154f96de385f34',
    id: 'range-test-20260619-4716',
    matching_hash: '6756564d77c91fb96e7115028c042f4c2c9d0f70',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 12,
    a2: 12,
    a3: 12,
    ball_type: BallType.Misc,
    full_hash: 'c332b288ed12b48b8ec8710ea5fc1b7a6c33d028',
    id: 'range-test-20260619-4717',
    matching_hash: '1c316579211f220c66121f61ee3c635c8785ccf1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '36b13f02d1d2623ab7f9f0a4e9e12b618b999643',
    id: 'range-test-20260619-4718',
    matching_hash: '07122e8a1f1743a9e60cdb794197b144ec9ba2dd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '4da9336ddb036071eb10bd38179cb0e8aa744c22',
    id: 'range-test-20260619-4719',
    matching_hash: '3da3e1e4336c6b5c2f2cf09bb8346e8482c8eba4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'da30100c5c12664da182b143bacedf4b5f0222cb',
    id: 'range-test-20260619-4720',
    matching_hash: '417182886555be7575dff3c67db1f5cc6c87e9c3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '84a4272f9b6e892498f7db078e6d04b59bb527b9',
    id: 'range-test-20260619-4721',
    matching_hash: '6b50ebc30528c1948a574c0922bb544c4cf20acd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: 'd12a453fd1248851ae8f646decb0610dcbb1d39d',
    id: 'range-test-20260619-4722',
    matching_hash: 'ab87b1491e6f02a3848506f79d03aad267ac0ef9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '13e72a9e0b96a0049d83e265a1513748f48069b5',
    id: 'range-test-20260619-4723',
    matching_hash: 'b4363553a349bd35945a82255ab0393b51895a8f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 8,
  },
  {
    a1: 22,
    a2: 22,
    a3: 22,
    ball_type: BallType.Misc,
    full_hash: '7954b1deba628c8fe459b67f9dc2a75fcc786f2c',
    id: 'range-test-20260619-4724',
    matching_hash: 'fecdab1ad1bf3d66c64cb8abe46f983e910db498',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 5.5,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 6,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 8,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '939eb25bbf36978c71181586c14ebbc83b8f3646',
    id: 'range-test-20260619-4725',
    matching_hash: '1a18c0afc3275bb589c31f766eb09622c68d57e7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '6e20bb180a632a8cdbbf8c55366b168bcf6815a7',
    id: 'range-test-20260619-4726',
    matching_hash: '04c8ef359487e727cf674fe78747e9e8adf84a11',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '588ad64dc8ae9d11ac8a636df1e779cc1d8ca5cd',
    id: 'range-test-20260619-4727',
    matching_hash: 'de35c4cd8ed2dd048308c0828b01a993d8a6bddf',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: 'dfd159b8919406d2ccce9c2361912aea5ae89de1',
    id: 'range-test-20260619-4728',
    matching_hash: '1922808dc331d2fe85710d91989a089971f8d8b9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '1dddefc25a2698734b4ebcbd49833d47be81b851',
    id: 'range-test-20260619-4729',
    matching_hash: '322035ecdce1e11733d5d488b13fcb9dccb66847',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '707797c7a8599355fd5516927493bb2369f0da68',
    id: 'range-test-20260619-4730',
    matching_hash: '851482e4cb142a973bd1bc5f4a0de6f47b27113e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -19,
    a2: -19,
    a3: -19,
    ball_type: BallType.Misc,
    full_hash: '7a41f3bb3b4fe229e672d942ce34598c9c8e222e',
    id: 'range-test-20260619-4731',
    matching_hash: '8522b88204d86126394f50513a2c0f9f9728cec4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'e47efb63d5962878b6f09f4044e9954b50b6f0bd',
    id: 'range-test-20260619-4732',
    matching_hash: 'fdcb39a2524933f600f7098d52afe217174bcf5f',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'b244a0f07eda08d7483d9c23613c24334e72a945',
    id: 'range-test-20260619-4733',
    matching_hash: '9391f87288f9244530c4b5b1a1a094304b10976a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '89cd087d4c1939d8b4d1fb07e39742dc9b0f0bfb',
    id: 'range-test-20260619-4734',
    matching_hash: '519c06e10bd6ca640c302738ef8bf74727d83738',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: 'bce28d415a52f47ae923a9722ba426cb60f85ccf',
    id: 'range-test-20260619-4735',
    matching_hash: '3dae36520493012d1bb2650e769f256d5eea06a8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '046a28f4f7f0b90c50beaeea8cbea1da8bccac91',
    id: 'range-test-20260619-4736',
    matching_hash: 'a57dca719e9ea7b34409ec32c33a9d022550c61c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '8cb4f828448a40f4b7b25c4bf78737a70efd3656',
    id: 'range-test-20260619-4737',
    matching_hash: '5f2c68aee8cd6aa89eff09323d15cb56ae55941a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -9,
    a2: -9,
    a3: -9,
    ball_type: BallType.Misc,
    full_hash: '0bc74b05071d19cfb65467848ab86008f164a2e5',
    id: 'range-test-20260619-4738',
    matching_hash: '8d3c278d353834fe05eaa45e5f4ee1772493d3af',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '95c9685547d63a0e825500775d821a541d0e86e3',
    id: 'range-test-20260619-4739',
    matching_hash: '00682318bd45b4f8d159cf24ce5fe2746acaf366',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '89430daedd6ead58f404f64db128cd67742100e1',
    id: 'range-test-20260619-4740',
    matching_hash: 'afe94f8c80f575c51bf25a325928ed2f425b1cf3',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '8a794593d6505878e2956fab326400730bebcf2b',
    id: 'range-test-20260619-4741',
    matching_hash: '0448659e038edcb3c19f28f13c28446f025b221a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'f879980c28c85502c7918a5baa9889a51eeeb182',
    id: 'range-test-20260619-4742',
    matching_hash: 'dc3db24bae5d8790ffb768d85a7cd62f3cddcb8e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: '5a1729a5f8c569635b657b5b5a3a148aaf087b60',
    id: 'range-test-20260619-4743',
    matching_hash: '6fca795fb2e0bd719f4d5626ab61c7e85cec13ae',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'af5e7f416120a479ae5b9e1d886167417ae5148f',
    id: 'range-test-20260619-4744',
    matching_hash: 'b32a0a39c68f5d24738762650f7b1a693f22c6b4',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 1,
    a2: 1,
    a3: 1,
    ball_type: BallType.Misc,
    full_hash: 'e6bf6e8e9efce5351e8c2c276746445cb9d027a4',
    id: 'range-test-20260619-4745',
    matching_hash: 'd28e42cbe79701fe77b57ebf3da71645b9503d88',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '683f9a497c7a6988ff2994389068d88b952aa3d3',
    id: 'range-test-20260619-4746',
    matching_hash: 'cc3d9653b548b41518d69b555663066732e58037',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.282605854,
    qx: -0.030444356,
    qy: 0.368207855,
    qz: -0.885228811,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'f2d543cf7e7f128b9fdd9e7865d8e48996deb1a9',
    id: 'range-test-20260619-4747',
    matching_hash: '1b86253fed969c6ea2a8c4c24382e6312009993d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'f89ff243e16a53bd5d1d751e472bdc931d712fa0',
    id: 'range-test-20260619-4748',
    matching_hash: '7a4b93f3be14b1b221629dffcbb69eed4b12ace7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: '2af7a3de7d2d023f520bca90c6cf4c0299c2cb33',
    id: 'range-test-20260619-4749',
    matching_hash: 'b08066d68c4e088483e86889eae62bc85590359e',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'cf4dc6ceb3e7d8a723ff2c5bcd5299e8ace4ed60',
    id: 'range-test-20260619-4750',
    matching_hash: 'a3a97588e48e69fffe6be154cbbcab0b46de41f2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'ab79c0ef08bee5899f93ec83622f7928f31fbab3',
    id: 'range-test-20260619-4751',
    matching_hash: '99f3317aaa28fb3b5147a80b699c427f9479dafd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 11,
    a2: 11,
    a3: 11,
    ball_type: BallType.Misc,
    full_hash: 'b7ff061a55db271840be44041b1913b038cad522',
    id: 'range-test-20260619-4752',
    matching_hash: 'b27cfca03d00044783900e24bb12700d0a555cd5',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'f790a7ebff3f856e4577ede75978a040a5414227',
    id: 'range-test-20260619-4753',
    matching_hash: '3c593b337f2af5b7efe4150339cace550003071a',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'bfca06d2a4121842e41dc8f9b0b670178f8b3ed8',
    id: 'range-test-20260619-4754',
    matching_hash: '84ec4b449befa0b1786e819ea5934ef90d7ced41',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '1126a27fdf4c87c140c5c4c30618bc933665884d',
    id: 'range-test-20260619-4755',
    matching_hash: '6344eecdce7ad92911640f01f3f184f86b3c43e7',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '7f5e04b80b3a14f9427b82fac1c95c77c2796f0b',
    id: 'range-test-20260619-4756',
    matching_hash: '405ce8819ae2ced2eb84eaf98fa4b9040bbc69b2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'ff2478e16d2cdc84e4f9cdca044511fe6ede8983',
    id: 'range-test-20260619-4757',
    matching_hash: 'eb2cab5c1721cde4749e0a3ad98500f93cb49129',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: 'af1dd17f065ba3715831629f992903984c809ade',
    id: 'range-test-20260619-4758',
    matching_hash: 'e9a23f30c1f7f401b180c6e52a606e71b9084a23',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 21,
    a2: 21,
    a3: 21,
    ball_type: BallType.Misc,
    full_hash: '30bb9046671d6452d33e10170ec8a18cca42e379',
    id: 'range-test-20260619-4759',
    matching_hash: 'b28ac3cdf6ece8d8577ba83d27b417ebe9f3ea33',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '42da0bd38e10fca3426cfd0c5295640b47e667c2',
    id: 'range-test-20260619-4760',
    matching_hash: '0e1537708c4eb3ba042b68773d0c0d3bd8b91f8d',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '4b7c22d2ac2b78e75c601aaddbafad0db89447b9',
    id: 'range-test-20260619-4761',
    matching_hash: 'd3cfca075b824e97adbaa296b83c9538e2f305ce',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '883b5707e190c3e479020a6464a16b5361dbc905',
    id: 'range-test-20260619-4762',
    matching_hash: 'f9e7c611407ae9c17c5ff939ab773464f65aba34',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '2189b90012b3fce855a98a84b4f1c95ef9b59849',
    id: 'range-test-20260619-4763',
    matching_hash: '3556bcec4afefd5b28420b98c31a034bc8f4be52',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '8bc4c38af686c064e270823f3452bcb25c8bc1ec',
    id: 'range-test-20260619-4764',
    matching_hash: '9317d302f3cb5fc69c449c3d47416a72eb81e6d6',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'c954dbb7c328ca3565796ac2486ef5ced11a05ad',
    id: 'range-test-20260619-4765',
    matching_hash: '5b704871ef292521efee02e1b107b9a0edb44a2a',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '1e6b2130fa5e27df7f55d137f2808e20a856ae55',
    id: 'range-test-20260619-4766',
    matching_hash: 'f470821c4bdb6f93262dceb685cc4c835f622a5c',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'afebe388102d51dddf2969f6e0ff746d2590ffcf',
    id: 'range-test-20260619-4767',
    matching_hash: '3c90a197a346ec565667ee9217cfd0f715c0fed1',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '7a6bd7d817452f39587535edccd4c18c712670dd',
    id: 'range-test-20260619-4768',
    matching_hash: 'ba1001fca338ff6671fed6636959946459d0130d',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '52325f3a4f8e4236b1b535d02d47ac6c387601b2',
    id: 'range-test-20260619-4769',
    matching_hash: 'c6e38bd2c582fd3efb3e0be6d82082c7d55d823d',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '9411906ec4c1044ffa10701bcfb6b88630260060',
    id: 'range-test-20260619-4770',
    matching_hash: '744a5d58f60708966b9fa39e73566153859f7dbd',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '4f4f4b1477e849b13da6c7bfdb1e9abaed9982da',
    id: 'range-test-20260619-4771',
    matching_hash: '386b151b669760509f71d4feda9180796cce7420',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '05bfc2ba31c7dbbb4adb561b64d1ea5882523fb5',
    id: 'range-test-20260619-4772',
    matching_hash: '26c56944c6bfc9fd234a2f563d660d23e009f9b2',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'c53e6c2bc702c198b3342b7e63a65273221a5584',
    id: 'range-test-20260619-4773',
    matching_hash: 'ba10f8e413e4e590a655072ad0c71138e1402b5b',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '4c7ed71c457c03253126c9c8f98dfd2e9b306fd2',
    id: 'range-test-20260619-4774',
    matching_hash: 'ad3a1318bb21766ed49f2ab6713886137c92b8bf',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'afe43fcd4353457df272b89dda6e9d9fa3ec0fab',
    id: 'range-test-20260619-4775',
    matching_hash: 'f6101adf103c5090681720e95071ef15d068a472',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: 'a9aa838e5f6973f1e76caaa170fbc9cc591ae418',
    id: 'range-test-20260619-4776',
    matching_hash: '07f7f5c9b45800ea6e1b64a1d20e9b77d16a1024',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '4f7c301986f7eb196e8e9893ce7e702596f81ef6',
    id: 'range-test-20260619-4777',
    matching_hash: '495b279fe30292c18d1d1aacbfedf024762be26b',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '06d249c188d5c329ee5ec024b9952c5e4fd27d76',
    id: 'range-test-20260619-4778',
    matching_hash: '03545571837be756e1f24d551212666d4fe8dbd2',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '37d1ed0ef97e85108db088bb14ebcd70a6937a0d',
    id: 'range-test-20260619-4779',
    matching_hash: '57269849efcb6f62834a3bb6e5135520c85c3bd3',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '9f4c26c04c0295d02331107a939106c4c21a25f3',
    id: 'range-test-20260619-4780',
    matching_hash: 'a5c9c92f7cdee83a280ea66d73b6eaceb0d9bc37',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '9171470b0d7e0ba30b55915101b163130645d924',
    id: 'range-test-20260619-4781',
    matching_hash: 'a57e6be9b2d8d2e4d188161cec8a34e3f7e8b045',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'ca662607a68e41b779de845be9226ae41b87e66e',
    id: 'range-test-20260619-4782',
    matching_hash: '9eae8b50982480cb022b150a7a70a147553a49e7',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '531144fd7f8d59e1e5072bbae70f988bbb3e31ec',
    id: 'range-test-20260619-4783',
    matching_hash: '3be1c02eefaad2267e151e7fdfeb8c5498c1c845',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '487442da68f38acefd6adf8a5eb65c0b4e09aff6',
    id: 'range-test-20260619-4784',
    matching_hash: '16e613d5f7d8142050b279e2dcd0cca852c8017a',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '22a6f3e829a14837e66b4f5aea18af9ba2e04caa',
    id: 'range-test-20260619-4785',
    matching_hash: '942e21a6c3d353990735fa5e64652e73dbc504a5',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '3be1685222ac09fc5b550efc425f2d6e8eadf542',
    id: 'range-test-20260619-4786',
    matching_hash: '7016b821e0ba01901e2418adde9f7171551454b4',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '348ed955932f37ae0e4e5348d62579feeb933b41',
    id: 'range-test-20260619-4787',
    matching_hash: '3c0ba23dd5a71e3b652bee17c2322ca4376144ac',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '9513b57ef92b38cfabc2d55c0e0f656792bbed89',
    id: 'range-test-20260619-4788',
    matching_hash: 'ad67a606ecab32edc9483aa81aadb60b116c1526',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'c9a64e8465d2b53c355a747e5d3ad41163ddb124',
    id: 'range-test-20260619-4789',
    matching_hash: '902678621adb77d02e335c35926e0d2f7e070aa3',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '456ab94265c61ffacbbdbe180cbbb15a23b6b287',
    id: 'range-test-20260619-4790',
    matching_hash: '9b41cb5492a3d03cea864b216876bd7de3430137',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'b0ba651d45c5b43c2e0cd68e425d72725d960511',
    id: 'range-test-20260619-4791',
    matching_hash: '410ffa703b8c4d28b05f11c477fd1c994db25a34',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'e53b73edeedd6be80f110f8b440def81ff759feb',
    id: 'range-test-20260619-4792',
    matching_hash: '38e483ee48ca382a055eee3702f7ee95a4be9bcd',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '5441aab2aa5b16ac6457a37953b67464c3e5035d',
    id: 'range-test-20260619-4793',
    matching_hash: '3dbc102dad10dc6bac14c8402d0f5c245cfbe1b6',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'bc7709bb4a2da164eab7f607887b72f65b1a8622',
    id: 'range-test-20260619-4794',
    matching_hash: 'ac90a867ca181e35d693cd1dd12f118233b90b01',
    model_id: '',
    model_key: '',
    px: -2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '18c02bf7b68a0e2cfcf6b37ed8b5567e753cbd65',
    id: 'range-test-20260619-4795',
    matching_hash: 'ae1d641c9f20efa8ab9b8539705e0924dec5b7e0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '7fac09b7d9b92f27f61f55cbb85ff24b135215e2',
    id: 'range-test-20260619-4796',
    matching_hash: '0604934a0be433de620e7430ce34197c26e44285',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'db979d4b90f14f18e2a14e94461b300f3d48de19',
    id: 'range-test-20260619-4797',
    matching_hash: '61c1ef3a813b3b312d2d46397030059706128778',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '984195192e20cf2e5d0a8ebfe16e0931fdfb4cac',
    id: 'range-test-20260619-4798',
    matching_hash: '7cf34649f2fe96c0eb7a831f715602879886149f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '9595484d2ccec79bbdfd3025578a40692ef548e8',
    id: 'range-test-20260619-4799',
    matching_hash: '9b5891439b9cc3422d0cad355793724fd2e664e0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '56a7437aaaac80822fe061a7a5801eecb6c85f97',
    id: 'range-test-20260619-4800',
    matching_hash: '2c3ccfbf123c66e40074f7cc60306183c2b80c27',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '36adaec6398579cb268b0deda73fea3f0d093fc3',
    id: 'range-test-20260619-4801',
    matching_hash: '4976f7f44859a6bbbccde598219dd6adecfd3f3a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '8573a9a302378af366e712e6ff13235aebb36317',
    id: 'range-test-20260619-4802',
    matching_hash: '6ee46fc5917b11345e7413d26b66b4d0c5426610',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'a4e93451bf90f66b5321fd50124c7d8dad6b4eb8',
    id: 'range-test-20260619-4803',
    matching_hash: 'c5cee50d75b43d2539f20f576a09b84213589efc',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '164262ebe2aeaeea416822efd29effe3705dfafc',
    id: 'range-test-20260619-4804',
    matching_hash: 'aa6078d5504eaa3024617ab957cc808cf44e1bb4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'c48debd3766c872d66931b98b6ed8ddd3d58ba36',
    id: 'range-test-20260619-4805',
    matching_hash: '9f2502ce063eb82d4e3e2aab7c4eeca1440b4081',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'd1f9be50ac506cb1e9f3b35fb81205aff68494ec',
    id: 'range-test-20260619-4806',
    matching_hash: '32e504f2b63b432a85672ea54caa079d0d2a77d8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'f4101e6006957d88d095db42740f8f795b58dc85',
    id: 'range-test-20260619-4807',
    matching_hash: '3b6a1a6db21f4812404dbb6b8a8823c0cb93e059',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '618ddc32b724655d8344c708acf8b2f2d96a769e',
    id: 'range-test-20260619-4808',
    matching_hash: 'f0a7f2622cb8bb62795fde258604a695fad6ed08',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '5de916cdabec5ad379e63ec81dd9c12fa2395155',
    id: 'range-test-20260619-4809',
    matching_hash: '17ab8612113d4d2b15a87a1214d0fe4cb4ad3e40',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '4a4554cf1345d321071167fdc59e95d44656e697',
    id: 'range-test-20260619-4810',
    matching_hash: '084c9a5d33f0f28df51d2d37c78d80cee2fbbad6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '735ba13f5340a2260a269fae11e0f71496a62d1b',
    id: 'range-test-20260619-4811',
    matching_hash: 'a9b4862692230ff5208da4e62d16fbdcf5d931fe',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '1f378aa6fc5891ebd46c65fe21e414338697a6e7',
    id: 'range-test-20260619-4812',
    matching_hash: '44810f96c97236523adce4cae6c93eb169ec2d21',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '8a668cdd36ae0c162c33484f21aee4f75e1632d2',
    id: 'range-test-20260619-4813',
    matching_hash: '5be5e17e4bae530be5f02b587a6daca0ee01b464',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '2187af7d1312b4aca84db9b8edce1f1569edadd3',
    id: 'range-test-20260619-4814',
    matching_hash: '27e8ee9cd1f57bb5eb44c0d5103b1bf9f40a10a7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '2c26d757ae646c6d460ab902be25c6d7d0db8d00',
    id: 'range-test-20260619-4815',
    matching_hash: '9a375eee02c07633db649e83b3e8efebde07cc99',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'a2f05acf8d30df4ede2ea92c9a9728775ceb52c9',
    id: 'range-test-20260619-4816',
    matching_hash: 'a85cd9cfe0058b0e40af34179dfb7f6b7a30e7a0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'a2bc99cb2b5d9cefea2a27e1e38a8f466dc4204d',
    id: 'range-test-20260619-4817',
    matching_hash: '6b9514f389a1723ddb979f960c0f285cb1a49223',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'f9ebad6de6b16c08c21bc7fadec4827902ba1652',
    id: 'range-test-20260619-4818',
    matching_hash: '0e76698bed76c71e764cce39eb64306934bd7af6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'f225b94249878d703640a6b4e287f60e2eb9eff6',
    id: 'range-test-20260619-4819',
    matching_hash: 'd36158fa37f8aed7016d520e252c7afeec69a3a5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '005036660df4b2e465daa0758502184a8a207b62',
    id: 'range-test-20260619-4820',
    matching_hash: 'e86f743c03206aa623d62b0d0b06268e8a4cb41d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'b1ab2b1a14c11c106f5073b3a1df0d7c056c8ac6',
    id: 'range-test-20260619-4821',
    matching_hash: 'e1d8ef3c51e8075bde6483226b9a611e8b3cf392',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '3c659e9788e6df218ff7fd569922088ccad2876a',
    id: 'range-test-20260619-4822',
    matching_hash: 'cb6eb465f667f62f1cfc0b4c870f51ae30dd438c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'e9e6fed384cff6795740ab4ee11e9e7804c8fc37',
    id: 'range-test-20260619-4823',
    matching_hash: '6019008f34a565753ef1006dc8fd8fb707ccbd8d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'f590451c8753f97c7fb93166cac0eca9584b0f34',
    id: 'range-test-20260619-4824',
    matching_hash: '41affa59e096396e77b78dae0c275bd06f7faac6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '2d1b92a13dca61a13c228270fc8b008852709d67',
    id: 'range-test-20260619-4825',
    matching_hash: '1109b3f70a56e8f0f1282baba59678cf962c3582',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '1252183d301ba87da2d288ac43bec9619f95e5dd',
    id: 'range-test-20260619-4826',
    matching_hash: 'cc4312686cf934fcb254428c6223e33629a8b7cb',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '9c9ba3dde0b9d91d57be4f2b7fafca3b4d60bd10',
    id: 'range-test-20260619-4827',
    matching_hash: '0f7dfc3e359c3cf2b763f138611f56abce0048c7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'a90ac132662befe024230277491f24a32f30b817',
    id: 'range-test-20260619-4828',
    matching_hash: '99768813f0b53ed3cf7f8062dfec2698c1941f83',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '3c256a0020d3d668850b13c879bbc9025b77a45c',
    id: 'range-test-20260619-4829',
    matching_hash: '2a15e5973dfa281b7a9be2dd46f1fa2624fd323f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'c9c4ab66649af2a4f63e1875f759a1056dc421ef',
    id: 'range-test-20260619-4830',
    matching_hash: '7421f05ae41e9ea689a67c768caf766ed6d38d2d',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'aed3b434ff988f4ba5e5a1ef3c5ed40393c57090',
    id: 'range-test-20260619-4831',
    matching_hash: '2f6090bcbd099c56e2efd81065aa2fa61668737b',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '08851d1e4583c8b34682d7e1c5957a8ded9ce279',
    id: 'range-test-20260619-4832',
    matching_hash: '8744a9bf93e970317f1aadaa47018bf796eb5ab9',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'cb2a730c20dd8d74154a5651d8123a31a2d94403',
    id: 'range-test-20260619-4833',
    matching_hash: 'ed023c139ef53fb42ff96beb3d7b82bec71e4cb5',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '102d3a3e409ee9d5e1ff9f406eeb9bc973a3b307',
    id: 'range-test-20260619-4834',
    matching_hash: '9c2615f807c4f5fae9badbd34430041ee1496b51',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '5d264e40cd568e4d5dcb57a95e1e575c54733839',
    id: 'range-test-20260619-4835',
    matching_hash: '325df37c992f1ff31d37e775da3785d344e512db',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '7359f2f8a11ffe5ee1c87f983a4a1fb6fe24837d',
    id: 'range-test-20260619-4836',
    matching_hash: '5fb382c8bf9cf8ec5033ac6e223c18429df06307',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'c78afcc1fa9528602827a8c42158318c57f9e15a',
    id: 'range-test-20260619-4837',
    matching_hash: 'ab2a81ecc330aca012ab6fdc718daa9859439802',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'a4845ec283d4f2b5345c55de9773b68ebb570d88',
    id: 'range-test-20260619-4838',
    matching_hash: '93cc07e53ca93ca30035e9a8b572600365b42de7',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '6a03fd03485adf677e558d481e7bc076fe227073',
    id: 'range-test-20260619-4839',
    matching_hash: 'bf4dc9363e7f2ef3f0d8d711d5dff28d23d9729a',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '24eb1c193b85bb4790b96464afabe607a1a7e222',
    id: 'range-test-20260619-4840',
    matching_hash: '3ee90fa102c48abc408e5717f3a42abae1ae3207',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'ee101eba36db22e03beae8305dcebdabbc05a3ae',
    id: 'range-test-20260619-4841',
    matching_hash: '40858e38672a17c61758eb73e1e976d29e46a19e',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '913730433c848a9c8f70523f75394d0dd73c0780',
    id: 'range-test-20260619-4842',
    matching_hash: '16a7e62828d4853dda7342eda10d92d150392503',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '6b2d750108b403df7d504de6c4cd57ab1c8b38af',
    id: 'range-test-20260619-4843',
    matching_hash: 'b088aef77ef19a53a3884e0f04a6271c1853a478',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '789adb7a1e5c6c699636cc22f998c67c261fd5df',
    id: 'range-test-20260619-4844',
    matching_hash: 'd848cabdb557f402efddbbb763db75fe175d3191',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '4ff68799d14f8cd39c4ac735787a2aab6aeadd23',
    id: 'range-test-20260619-4845',
    matching_hash: 'd4660722cac83545c38870dc0f428bb0c9629a95',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '48fddd11b6c91c63073ba95642266ca0b2e7545e',
    id: 'range-test-20260619-4846',
    matching_hash: 'fbe327b51af4d698a60c5c7ff3d2363f0441dad6',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '5751f93eb31d66cfd704017eaaff13c47744313e',
    id: 'range-test-20260619-4847',
    matching_hash: '3d68f1284ebc6c3444ebe755277aab41d2aec3cd',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.552060118,
    qx: -0.62290634,
    qy: 0.18008624,
    qz: -0.524200596,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'c267822ae435287ff92cc7397f0f50d9ed42e5b2',
    id: 'range-test-20260619-4848',
    matching_hash: '675bd8169c1179e6438e939a1ef7a9cb991425ca',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '473be55a3dca66a93eb5ce4bcab7e21a406645ef',
    id: 'range-test-20260619-4849',
    matching_hash: '14584dc6a00fbc37be172883d788154a64b1ad3a',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'fbcb8497eff2501b6eca6ece7ed7a7923d783f10',
    id: 'range-test-20260619-4850',
    matching_hash: '5fb490cb5e6ca4e9ec209fa1596bbdb413d1a1e3',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'b34ab7d17b7e886bf2ca21e9d295c75d9fe131c6',
    id: 'range-test-20260619-4851',
    matching_hash: '9aad2e22b98409c36cea2ae771627cdf08c7fbff',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'd2caf800893bb18926abaea2ba75de5dc391ba3b',
    id: 'range-test-20260619-4852',
    matching_hash: 'c9424094784465cf25d5f9c6948859ca04c1f785',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'ff47c51837845ffc97fca6bdfe26219a7a8024e2',
    id: 'range-test-20260619-4853',
    matching_hash: '84b47beaa0c2148477629c1ad6cf27b9fd9f9dd5',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'a6d8d17732c73a091e8a89ecaa32cf0ced7e3b74',
    id: 'range-test-20260619-4854',
    matching_hash: '6617b51f5ea69103000456b2d3e16b8d8bc43dbe',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '87c342420b14a86bde603ecfd847c413d1b4d3da',
    id: 'range-test-20260619-4855',
    matching_hash: '96403c4b9dfad16fc19c5259b56132b1f127654c',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '9aeb8fab2fc0c794295f51b960e892dcbd76e3d2',
    id: 'range-test-20260619-4856',
    matching_hash: '38acb9e13816e67c1d6e229510b0328a8ceba6ee',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'a2b2237b3515acfd090547056311c849dbac28c6',
    id: 'range-test-20260619-4857',
    matching_hash: '252de7fec181537317505e6d107920fad88859f7',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'f4746436f72d4f3d7b55a3fa2a981a6eb1ed3531',
    id: 'range-test-20260619-4858',
    matching_hash: '5a742f2c11740964373247e3b90c06a9e0a2f2ae',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'fbbfd7660db61f11912e78bdb62c4308d77412a1',
    id: 'range-test-20260619-4859',
    matching_hash: 'f110ad40eeb0a726aad21d7813dca5cf1b62adc7',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'c9eb92cb30059ab49761fe1f50812106e063df6e',
    id: 'range-test-20260619-4860',
    matching_hash: 'c0d84a718c08851786fb0774737260607e0dd8e4',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '78d011f4ede30e6b689d07d25dc0e550edf3acf7',
    id: 'range-test-20260619-4861',
    matching_hash: '1c38878069b2b0b7ac1980b51127b46040116cfb',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'da9b10156db41d5276459d436d3d245b8f206f3a',
    id: 'range-test-20260619-4862',
    matching_hash: '4139d89a8bf6b3771193b82b46a0d7247e14364f',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '5db3787078bfd0cc27da014229d75b0536a1fcd0',
    id: 'range-test-20260619-4863',
    matching_hash: 'ef7269f0a9c42610ce23d7fd84d235beb307bb8e',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '14ae0f488a4b01c209476467708cd36f997fcabd',
    id: 'range-test-20260619-4864',
    matching_hash: 'e513c0da63583625d64e68bf3290c90792f42ea7',
    model_id: '',
    model_key: '',
    px: 2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'e3b0cce8747033a13dfd3ccd1b1eb5f2a7cba358',
    id: 'range-test-20260619-4865',
    matching_hash: 'f90e5114388986d352494ef2d774ca2c50cfa041',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '9341517df2599cebfcf988084384a1ad13fd9ea5',
    id: 'range-test-20260619-4866',
    matching_hash: '9c4907e23c789d3649cc83411c1f714c6cd03cce',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '9751407e5ab109f97de0a4ec01b6703a8625d48c',
    id: 'range-test-20260619-4867',
    matching_hash: 'e1ac983abcc1c32e6b50f12e6e28fc32b23e32d3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '153d1ca00e5d4e0d205663a85a157097195dee0f',
    id: 'range-test-20260619-4868',
    matching_hash: '6215ab798a503dadcefbf31cfa209b495c79c3cd',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '12b1b241ec0bc4664dda696f16e930c14e2f8c3a',
    id: 'range-test-20260619-4869',
    matching_hash: 'de4d396050b7361fb1667a4f9575e558428bb3c7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'db13a8681b8aea79b5748610cfabea0c50fbb7a0',
    id: 'range-test-20260619-4870',
    matching_hash: '6a4172865b0c6b0623c3151982a7b06d69e9e6fa',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'e9369ffef265edaacfc170e206c37950acf9d545',
    id: 'range-test-20260619-4871',
    matching_hash: 'cd34eff60848f50845e2b909020ad3b9ea1c986e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '4ffe90c21920f1771e728767c9174c53192dc72d',
    id: 'range-test-20260619-4872',
    matching_hash: 'bb340786b720afc00c5679bf349bed070c3d8ba0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'b9914b463db9fdd11ad2ff94d0f7219f7edc919b',
    id: 'range-test-20260619-4873',
    matching_hash: 'c3cc002e862e88b9b563e27af1faa809df96a0a2',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '520d8dda632de495a372adea8605d0f41c1b3c99',
    id: 'range-test-20260619-4874',
    matching_hash: 'ef0edf2bbd236cfc6e07c3a8d07d7f8edc75f11d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'ce146f60f1ded5c47a63d1378dd9e79cfee0c7e3',
    id: 'range-test-20260619-4875',
    matching_hash: '6fd5631e6ced6434dd5b4c168610c49d1789da74',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: 'd5154eb33459a25737ac776bc72b153dd5039b8c',
    id: 'range-test-20260619-4876',
    matching_hash: '4b6c0692bbc0a9aa5abbac28a829ac4d4bede214',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '186ee83d8a9949ca55f3b885f496fa9214b1bd47',
    id: 'range-test-20260619-4877',
    matching_hash: 'b76e5e4136b635c640c8b4ddef9210d74c482d77',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '2842e032be37e7b0c06d6e286dd2d464a51b51bb',
    id: 'range-test-20260619-4878',
    matching_hash: 'c13bd3b3c2083313b8f9bfe77b18c2bec0e5673a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'bf1f32b5903cddc6b07005632f69da5928ca2192',
    id: 'range-test-20260619-4879',
    matching_hash: '4d291efda25851d3a302e961ba87c445255116d9',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '50d536baf6d77d85153e5e02d5dc8218e6a285c8',
    id: 'range-test-20260619-4880',
    matching_hash: 'ef4d6e211a65233df3c7d015381a7af4f66da615',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'f631e796bf2013f5bbbd4edf38320287a7f532ec',
    id: 'range-test-20260619-4881',
    matching_hash: '0b218ba265298f13f8d14fd05d52ef0f7c5a3d7a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '98a273de843ae7b250cbae44e4336488aa4c6b31',
    id: 'range-test-20260619-4882',
    matching_hash: 'c5e532f508e8eaaf1395bac259ead303e87190cf',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '7cc1da6ca8cac6187277d33a911d90ec2de2d157',
    id: 'range-test-20260619-4883',
    matching_hash: '09580749be04ae07d2caa35c0cf8053ae792fb0f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'd75a0eae79abcccfe335a24f8d90704774e03a5b',
    id: 'range-test-20260619-4884',
    matching_hash: '8cc3474d87937099394f5aae1c4fa007ccf9791e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'df22913e3a336a6d63e3804a3e487476bc6592d1',
    id: 'range-test-20260619-4885',
    matching_hash: 'ebf7d0111b7afe3db32f56bd3a54171f7c8d39a1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'aced984416c63c1252c5a174cf953ec7947f9d03',
    id: 'range-test-20260619-4886',
    matching_hash: 'dc4c543d0fb2619775edb12b5500c8681ecdac25',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '6c94f2273168f1027d5fdf1d8eb913f18aaa13ff',
    id: 'range-test-20260619-4887',
    matching_hash: '80a278b584449204ff89acf074659d4a78b0e589',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'c58da4806700174bd3a9a2e2a554572b79326c84',
    id: 'range-test-20260619-4888',
    matching_hash: '7ea1abb1bb7abc80b25e92806a2048451cf3c905',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '69034e47e37b0431ab2fa40fb305069feab111ee',
    id: 'range-test-20260619-4889',
    matching_hash: '342ff92a99c1a74ab65339118598407ed55adadc',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '2ceec0af35a363929052ec23ac7da0cec1ae2a67',
    id: 'range-test-20260619-4890',
    matching_hash: 'fc51a4cf7ca5ba30f6f91da8830a56ef32cdfae5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '0b854756fa4fe4310980cc843dd33d0cb6859adc',
    id: 'range-test-20260619-4891',
    matching_hash: 'bd9e790188b17bf9994f486fd37ceb5130b47167',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '8e55abeef35f56e21accae1eb0cf4c84303d4a08',
    id: 'range-test-20260619-4892',
    matching_hash: '805f7709d19481e688e7b8e0405d337138cc98be',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '39f6f9ee059e393a89e451607be9a30ccdf25d64',
    id: 'range-test-20260619-4893',
    matching_hash: '09a9479e12c078021b306cff0f679fc6f6d90ed4',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '34f7b06c4d04b15123ca4a68cae94c9a44734ab7',
    id: 'range-test-20260619-4894',
    matching_hash: 'c5f4fa52ef999fcec04953cc9fea274140aa1c7e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'ff415907e8367d3c19008eb1bfd9486f62b0d546',
    id: 'range-test-20260619-4895',
    matching_hash: 'ac9133c9b7def3385d672d6a0497d5a8c9f75d8d',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'a3e46982232c9844a190cfd7e96c9df531ff5857',
    id: 'range-test-20260619-4896',
    matching_hash: '96f340acde96a73c8deb3427bf5b3c5550d16955',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'f35d6456506497594aaa20dee404ab8f808d15f1',
    id: 'range-test-20260619-4897',
    matching_hash: '96f6a1a08d964d15d3f43c65ade7ebcd116170d5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '1491861cb06d837628683878aab4fe903465820a',
    id: 'range-test-20260619-4898',
    matching_hash: '176ca834684ae4d9df413128d39b4559699e22ff',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'ab78d0cb9c9d21ebf0b6727b2b8c7230eff39f0e',
    id: 'range-test-20260619-4899',
    matching_hash: '008b81871449a7fbb9a96100fe6d9b831a7f59f5',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 6.25,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '3b0c47a5ce7c9c8ac904e88a6192343c6e9b0893',
    id: 'range-test-20260619-4900',
    matching_hash: 'd00cbafc1ed5e56ee779a41aaa46d61bb1b78ee9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '2484c93b6c2e7db6cb557bb2dff0e0e8027a8b50',
    id: 'range-test-20260619-4901',
    matching_hash: '26f7b24b0c4d1162f7cd4b6bb351316e32f0896d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: 'c0b858369a7b4604907acceacece2aa9bb661eae',
    id: 'range-test-20260619-4902',
    matching_hash: '160618b6649b433fc0798b984c7a33f239e97285',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '05ae24fe37b5595e4285c0e5b3b687443a622d1a',
    id: 'range-test-20260619-4903',
    matching_hash: 'd9261a6fbf8327cffdda1e33983f42a814b375fb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '568c976d696b10c54bba4eb63057707045b98b95',
    id: 'range-test-20260619-4904',
    matching_hash: '909f29bd3dc7bd6fb4c10b817b4814bf342f6e0c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '517cc7a77cf892d9c02b38e1b38130374d08bf56',
    id: 'range-test-20260619-4905',
    matching_hash: '241f45c56bd44deedd426182948288b81ec5f4c0',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -24,
    a2: -24,
    a3: -24,
    ball_type: BallType.Misc,
    full_hash: '14d5d6e5645d8ece3d22f0107a23e3a953c181ac',
    id: 'range-test-20260619-4906',
    matching_hash: '5b1ef5e7e52fe8096685d865fa67c065e9c8e806',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'a5591dc3d6ec54364a1eaca4afd2ab9d287ced8e',
    id: 'range-test-20260619-4907',
    matching_hash: '143943b759ad4f3fd3585c69fdea342f607a3a0d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '634c48210ae42064704affa09fd9a1cf7587c296',
    id: 'range-test-20260619-4908',
    matching_hash: 'ae7100e2248214a7544c79823147b65e252055cd',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'a27a09b81f09011976e576f3422613e7ecd58aac',
    id: 'range-test-20260619-4909',
    matching_hash: '524ec44ed56c98ee1480a36882c7b80f9a0a5818',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'cc5358af3e5e5bdc72333d65c60a21345508bd5e',
    id: 'range-test-20260619-4910',
    matching_hash: 'd917d9c99624d9408de7f0d62796afb6747af0d2',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: 'daeb3f4b5f0107bf8eb04a6e343c415be37ba8f9',
    id: 'range-test-20260619-4911',
    matching_hash: 'd24230f2ace257df96d0e5f37721a14a2ab76d14',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '335b71a734942ab4f3f6141c21b8505ccbfdc5fa',
    id: 'range-test-20260619-4912',
    matching_hash: 'ea23a51d173542a00bbb69c49372b7d3759bec67',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -14,
    a2: -14,
    a3: -14,
    ball_type: BallType.Misc,
    full_hash: '7dce8b4fb94fbf6c453457e960c94e5199f68915',
    id: 'range-test-20260619-4913',
    matching_hash: '56c3cc65bcb9fa4f8cd34b4cb4ed1a0f0e40756d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '3262b02598b22aca4743d7eaa0b7294613123f74',
    id: 'range-test-20260619-4914',
    matching_hash: 'e2863ce0426dbc00ded084d0a5c819865a3da5fe',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '686586150290b08efc10e718856376dc146b8f4c',
    id: 'range-test-20260619-4915',
    matching_hash: '2903c374d91836c1d6d9e1731745fc41aba2dd30',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'fb81eb8a0bbfdd5ef612eb424125d5b36da2842d',
    id: 'range-test-20260619-4916',
    matching_hash: '81e257cdde685e6be2a61a2e5754d488d1ce93e8',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'fd2454e338deaf673489ca5355906dd558305f22',
    id: 'range-test-20260619-4917',
    matching_hash: 'd717040045103d62aef1baae2f0c403d0207fda9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: 'e948eeae844095a878fa2ce25107ffaac3281fd4',
    id: 'range-test-20260619-4918',
    matching_hash: 'ebd9e06d7918804db48e1b923b0c5b3d620c3c18',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '85b5a20d865358ef6549adaed8aa2bac7f9cc68d',
    id: 'range-test-20260619-4919',
    matching_hash: 'c65c739bc863cb7ee7e60b8e138645ff6d1b1adb',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -4,
    a2: -4,
    a3: -4,
    ball_type: BallType.Misc,
    full_hash: '40e0f0c58cee79da07ff3f6046bb1487500ed2de',
    id: 'range-test-20260619-4920',
    matching_hash: 'c839e9b85880574d881ea84f1bda64753088e3d9',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'ab1957b15430f17db96c1fb7a1b2578f1248c483',
    id: 'range-test-20260619-4921',
    matching_hash: 'ec7850e434c5dc0f7c4f2162461f6792c4a45339',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'dd8e8c80bcbd8160058d2b31d6e438b62a58d871',
    id: 'range-test-20260619-4922',
    matching_hash: '38d526e7f3b3bea68f623727a5ef5c825e6c6058',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '3235a70fedbf83da34470f13d81597f738928af3',
    id: 'range-test-20260619-4923',
    matching_hash: 'c657228eda2c67532f2b1b209e51a6d0726e14db',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '26887e7d7d55daaa1195e5655447192e73c4d453',
    id: 'range-test-20260619-4924',
    matching_hash: 'd0636291bdfab6bb61b2e79f08aa7dfe57c4ae73',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: 'f9ab04496f90c6d11ec9a363870a1ee5ac9f2207',
    id: 'range-test-20260619-4925',
    matching_hash: '533fee10950ec613dbf65e845574bac34678c54c',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '76a2f53ad5c6a4099180b25bd0f8bdcb363453e5',
    id: 'range-test-20260619-4926',
    matching_hash: '7dd03f86c0061b4a00efd58162b3b269cba7200b',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 6,
    a2: 6,
    a3: 6,
    ball_type: BallType.Misc,
    full_hash: '82fa4d6972c38fd156c2d0d1c6843832dd6d7b99',
    id: 'range-test-20260619-4927',
    matching_hash: 'e186035968a3f20afc42a8c6d154153304090115',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'cf596f17867d86a5791c112a1748d56f1d4cba7b',
    id: 'range-test-20260619-4928',
    matching_hash: '03dff148a0f1a26104986f335c9360852a2b048d',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '20ddbaa2f12ca32b922c3b5843d966e4ad9a29c8',
    id: 'range-test-20260619-4929',
    matching_hash: 'be322f033c289ea88864d132d08da00d58704d92',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'c1f6a774af05922378a680de843ebdc454aac309',
    id: 'range-test-20260619-4930',
    matching_hash: '53cf7ef63ee4d11416816d8df417989f6abe8c42',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '997e3cc1092206918ce04eada233da0b7a245ca4',
    id: 'range-test-20260619-4931',
    matching_hash: '14c380a0217a70827350c7758547e563d6e24c34',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '32c8e0d69093cc70d3e9e2602699a605bef6d07b',
    id: 'range-test-20260619-4932',
    matching_hash: 'af8774ec4c09663a6757c4aa9a7292615f5c6847',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: '68776c7000d1c303b057c27c5646973aa632945e',
    id: 'range-test-20260619-4933',
    matching_hash: '7e796c984186f62e091f753e2b2bcfd327842d02',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 16,
    a2: 16,
    a3: 16,
    ball_type: BallType.Misc,
    full_hash: 'c2b5e75e2463c823044826560160480c212f5bfe',
    id: 'range-test-20260619-4934',
    matching_hash: 'c014a9f25485cdb02893447cc442d0dfb4122771',
    model_id: '',
    model_key: '',
    px: -3.2,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'c32a9cd72c0a34763e5a6537d9c35b4e9880b7cc',
    id: 'range-test-20260619-4935',
    matching_hash: 'f90e5114388986d352494ef2d774ca2c50cfa041',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '69593a25a92d87c397c6db80f34c5000c144ee66',
    id: 'range-test-20260619-4936',
    matching_hash: '9c4907e23c789d3649cc83411c1f714c6cd03cce',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '7bff494287d016d4ba828583c814e43d90223f2c',
    id: 'range-test-20260619-4937',
    matching_hash: 'e1ac983abcc1c32e6b50f12e6e28fc32b23e32d3',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '7ea3842cfca482d99bd78009dddaa03a45af1c8f',
    id: 'range-test-20260619-4938',
    matching_hash: '6215ab798a503dadcefbf31cfa209b495c79c3cd',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '0f2d41d2b4b82e2f5cc754df9ff787b7518cf589',
    id: 'range-test-20260619-4939',
    matching_hash: 'de4d396050b7361fb1667a4f9575e558428bb3c7',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: 'af33d7167331615b30c0a8b07a340c2c3939a670',
    id: 'range-test-20260619-4940',
    matching_hash: '6a4172865b0c6b0623c3151982a7b06d69e9e6fa',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -23,
    a2: -23,
    a3: -23,
    ball_type: BallType.Misc,
    full_hash: '3c3674cebc91ca70a3f2a62fc471202d43ba1e6d',
    id: 'range-test-20260619-4941',
    matching_hash: 'cd34eff60848f50845e2b909020ad3b9ea1c986e',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '9d0e6a868e9326f9b29dd557dad5e9f3258b4e30',
    id: 'range-test-20260619-4942',
    matching_hash: 'bb340786b720afc00c5679bf349bed070c3d8ba0',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '56eab3fc5100288f25ce4c3778edbc17cd309543',
    id: 'range-test-20260619-4943',
    matching_hash: 'c3cc002e862e88b9b563e27af1faa809df96a0a2',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '43b7ed741d82df335e3ee7aa22893fbaff08077b',
    id: 'range-test-20260619-4944',
    matching_hash: 'ef0edf2bbd236cfc6e07c3a8d07d7f8edc75f11d',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '99c14e638ae03c222a1154f111a1cefedfd08721',
    id: 'range-test-20260619-4945',
    matching_hash: '6fd5631e6ced6434dd5b4c168610c49d1789da74',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '2af4d03163ea2540e4b2404f8785f878e325f780',
    id: 'range-test-20260619-4946',
    matching_hash: '4b6c0692bbc0a9aa5abbac28a829ac4d4bede214',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '007c138e28088c0483a598f28999343d92a9b305',
    id: 'range-test-20260619-4947',
    matching_hash: 'b76e5e4136b635c640c8b4ddef9210d74c482d77',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -13,
    a2: -13,
    a3: -13,
    ball_type: BallType.Misc,
    full_hash: '985f4998b3fbeb78c25ca51ce07e0e3326d44249',
    id: 'range-test-20260619-4948',
    matching_hash: 'c13bd3b3c2083313b8f9bfe77b18c2bec0e5673a',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.871702274,
    qx: 0.289168659,
    qy: 0.05640758,
    qz: -0.391579898,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'c3012b557fff2b45685a50046997a978d1bd424e',
    id: 'range-test-20260619-4949',
    matching_hash: '1cbace29b8e733d09f3248efd572fbdb1a500010',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'e3f0484367af266a0b63ad8efeede832083a73ae',
    id: 'range-test-20260619-4950',
    matching_hash: 'ef2e7e1e28da00909e69c5e2a51c4c782f527b95',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '44581e0754568ec718bfb6e935c2750795a8567c',
    id: 'range-test-20260619-4951',
    matching_hash: '2f1996a6d741af30e2aad05c777e20f21f987bfd',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '1c584354a496533f6bdab396a12bbf4c85ec8154',
    id: 'range-test-20260619-4952',
    matching_hash: '9362ce217dff94e66c71abb584929ab60b1c694b',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'd1ff8215986927ae8f0cee45820a748e14f97916',
    id: 'range-test-20260619-4953',
    matching_hash: '706e1f7d0b28097006afa97a99e5b483a1717908',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: '7fc5a2161beb9bda946e3e9fd28a62e5e56f74ff',
    id: 'range-test-20260619-4954',
    matching_hash: '2c37513078d025de8baa805d4dcdf4a3eac93add',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -3,
    a2: -3,
    a3: -3,
    ball_type: BallType.Misc,
    full_hash: 'f6cc3d0cd8bc3dc63689c3efa066484ec8e7abfe',
    id: 'range-test-20260619-4955',
    matching_hash: '4eb2d6f7576c4eead451a663b93e17215f81901b',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '65ad198f0018280db4b7bbf6a1a31fb97bfa4b2e',
    id: 'range-test-20260619-4956',
    matching_hash: '3772e9b221b1c0f6aeb0e802405e50449d463c2d',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '565404a604d9ef91e2a30e9cf1b670eb3da84064',
    id: 'range-test-20260619-4957',
    matching_hash: '88b500f8b147ffa7b83a7ce753dc35d79710558e',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '55cb69b8d5134b2d7fcd1da7cf8f6c1483cdd777',
    id: 'range-test-20260619-4958',
    matching_hash: 'a0044e5b8df6948b217f7c3e3d8ff7723d699def',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '9dc5c7e807e632b61e39d13abc31370b167de345',
    id: 'range-test-20260619-4959',
    matching_hash: '97a46c66b83b4498719b7b4dcfe7e9ed287ef4d2',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '2aac3770e7b62a9e882f89df9e6e9859c264ed3d',
    id: 'range-test-20260619-4960',
    matching_hash: 'd6b7f41f5e2596fe667ec15db40ebd9ffe7c7c0b',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: '7b93dad13bdc39d870014ef38f3fd496783e0b72',
    id: 'range-test-20260619-4961',
    matching_hash: '6c954f77d45d11214aefdc8eebc2095681c23edb',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 7,
    a2: 7,
    a3: 7,
    ball_type: BallType.Misc,
    full_hash: 'e7203eceb8187ce1a628eba184b882cb0bedcd3d',
    id: 'range-test-20260619-4962',
    matching_hash: '09ff10d6c4966bafa443d677163713139cacd672',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'f57c2427e9df34ba991e5bf2ac82e74fb77f5152',
    id: 'range-test-20260619-4963',
    matching_hash: 'e5a5ff9f732e9bb91795076462fad2135c626137',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '30021cac129e57cf9416bc1611cb1a1efafac474',
    id: 'range-test-20260619-4964',
    matching_hash: '7712256f4c053b59c5817db77571b5eef56ce7f1',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'd3407561ed67bfbbf6a3796bcbb2c81a84ff9d3e',
    id: 'range-test-20260619-4965',
    matching_hash: 'b90c4838945beb28fde98c15170df4ff8dbaafee',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: 'b18c5d5f0a43eb4cd4d862eee3312b7049fd998c',
    id: 'range-test-20260619-4966',
    matching_hash: '0ec97780fc85f43d39db1bed0eeb18bf7d03ece0',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '86be4c50c84a4606561852eacdf216289ab338d0',
    id: 'range-test-20260619-4967',
    matching_hash: 'edcbf5937c91465f39b169fe32a4bb0007d825b9',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '9a8b184d6f6c5a066644bca42f0622049e64682a',
    id: 'range-test-20260619-4968',
    matching_hash: '4b8017ff9f541d9227b38335d73dec2cbdd949ca',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 17,
    a2: 17,
    a3: 17,
    ball_type: BallType.Misc,
    full_hash: '68e3148329c1ecfc00fc0adf140d7ba36b2bac08',
    id: 'range-test-20260619-4969',
    matching_hash: 'd17713096d2ea7778295267f528f8b17eb773e1e',
    model_id: '',
    model_key: '',
    px: -1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '89eeea84719518a930e4df1655eb3354703db69d',
    id: 'range-test-20260619-4970',
    matching_hash: '25fa1860ab770b64b9ab0a39a2a09d902c09c42c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '4f01e9eb426b35166faed5d39312fba4db43a72b',
    id: 'range-test-20260619-4971',
    matching_hash: 'e35b2c8078bff0ae41de1b66d493c76182b9fbaf',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '4011cdef06b394cbe8fa7dab4486dab6a52c65a7',
    id: 'range-test-20260619-4972',
    matching_hash: 'da657f33a2d7afb78fd70fb5c4383b7f879d35f4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'b4fd970d567ea5a0faca16aa2ff17a72a2340ce2',
    id: 'range-test-20260619-4973',
    matching_hash: 'eb999302c7b7d160c68c4f54de255f8584d00d5f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: 'a57d775147927cc762efbc52d4095b294d766da9',
    id: 'range-test-20260619-4974',
    matching_hash: '2bb2366eb136901ac5b74f839dfb113759c4514a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '09929e0f7daf451d7256b227bef893d2fcef247d',
    id: 'range-test-20260619-4975',
    matching_hash: '09c78ada9655bcfc3e6ede6c638ddb536ca802c6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -22,
    a2: -22,
    a3: -22,
    ball_type: BallType.Misc,
    full_hash: '124f8cdfd50b04f539ea29d16325d9c06733f55e',
    id: 'range-test-20260619-4976',
    matching_hash: 'df1900ac8a82a468fc7cec36335bda3975889955',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '7f3f321974f15654a96c90c2d6cc4254695af91a',
    id: 'range-test-20260619-4977',
    matching_hash: '1fccfe22838a4952821fd834924323f81dd56dce',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '4cca4d32e7390d0fc80693f16d164756fbfe34d5',
    id: 'range-test-20260619-4978',
    matching_hash: 'cd12a8f2363ec4ad624355638654227f8e9d1f89',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '27701789078d3fe297bce0902f22e295a5774141',
    id: 'range-test-20260619-4979',
    matching_hash: '8b157d0a8c4f25049a7b19829a121ff22883ccc8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '0926b01828cd81498489a744b1f4f56e572d5705',
    id: 'range-test-20260619-4980',
    matching_hash: 'e48dc70cf93ebd20606ad0b0bdd65acf1f95074d',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '8eab1758fc05e07a1d14bc5c1d3b7dd9256380f6',
    id: 'range-test-20260619-4981',
    matching_hash: 'cd6f9127bc1490390b403839a98f0725076cc488',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: 'adbb239acc5b0c27730109f500178d32355cd3b1',
    id: 'range-test-20260619-4982',
    matching_hash: 'e92d8ba82ef2065c7167ff6e1c6bc26a428a03f7',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -12,
    a2: -12,
    a3: -12,
    ball_type: BallType.Misc,
    full_hash: '385f67421b83ae18c0505b76e6cc1bb88ba9711d',
    id: 'range-test-20260619-4983',
    matching_hash: '75de85274f04350e57c4a1d21030d3b006eec3ba',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '5e8022185cb98a393ae128d3e43e865446ebef95',
    id: 'range-test-20260619-4984',
    matching_hash: 'd950c4a058ca74a7a99cc5c94552e8c17a690bda',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '57460390dfa7d69c10691437b043e6ecbc96e79f',
    id: 'range-test-20260619-4985',
    matching_hash: '3d26682eefe81ad56056ac57382d06e5361b4cd4',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'df71ed4c6d46a2de0ea6331e59b71312405037e0',
    id: 'range-test-20260619-4986',
    matching_hash: '33e4788bb1911ab9558a254114b2944a219b60ad',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '97d91cb6344b55945a6592cb3c29587479ac1935',
    id: 'range-test-20260619-4987',
    matching_hash: 'a014fe947a98721ccce6d91ff96aa71319b746e8',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: 'b43c35767bc5b1840c42e9d1e33582e7f5588d74',
    id: 'range-test-20260619-4988',
    matching_hash: '9f4b701d07474f85b0763f072e8e555fe1f9bb8b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '492f267abddfc61855f68aedba24122a4fff6e17',
    id: 'range-test-20260619-4989',
    matching_hash: '5d6fd8dae6aa9c05d04036af3ac63c756f39dc4c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -2,
    a2: -2,
    a3: -2,
    ball_type: BallType.Misc,
    full_hash: '881fd03d290fe55619201f4e17851b0c01ed60cb',
    id: 'range-test-20260619-4990',
    matching_hash: '636b701ce5a3e1a707d2e71e041f27a3ca2c968c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'fe9c34bbc564edac342f45bb861cb97696f934bc',
    id: 'range-test-20260619-4991',
    matching_hash: 'ffb9d19e3558b5e6b8dace4a2988edd9029b657f',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '539ab1f6ad40cb5db464ee3aa4e36ca0be61d0d4',
    id: 'range-test-20260619-4992',
    matching_hash: 'e52e188deb643e77effd7febdb5c7a8de7aff55b',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '28950e41ce704587e1b17496843b032370f22e9c',
    id: 'range-test-20260619-4993',
    matching_hash: 'd1d5f5501f5bb38bfc7683bd70f2a326ebc85fb9',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'f1b8cd3401094ced88e396cbf86231fd22629ef0',
    id: 'range-test-20260619-4994',
    matching_hash: 'c3f821a182f7c87c3eb01b9563f267fb303fde76',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '9374267dcda075bc0886387c647f5ec15efa968a',
    id: 'range-test-20260619-4995',
    matching_hash: '2b8866801f2f3d6f7b84aa5f283b93c7a573dea3',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: '1f77d9270a8ed239b92fb6fae92e9a2dd88705fc',
    id: 'range-test-20260619-4996',
    matching_hash: '10dce8d6883ae77a073fb15cb5dee5a1dc2c02e6',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 8,
    a2: 8,
    a3: 8,
    ball_type: BallType.Misc,
    full_hash: 'd701910a3f68f25556c98aeb6fd49fe45874fbd3',
    id: 'range-test-20260619-4997',
    matching_hash: 'cae5a7eeff59604699257f79c82e597f21f00626',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '0414b9a5b23f3ca68db6f894171f8acd1d9fe00a',
    id: 'range-test-20260619-4998',
    matching_hash: '1176c9069be0d4d4a70935996898b6d18edd918e',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '359af7fa79bb9af343f3b1c933aa8cc675e83316',
    id: 'range-test-20260619-4999',
    matching_hash: '8d844f83434a79ae661b3d1b4319d02c744d3f1a',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'c82172b476fba33b2a1d52804cd59f9e0a5259c9',
    id: 'range-test-20260619-5000',
    matching_hash: '56342443e97e034e968d37c5d59f4ce1687c47e5',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '0f4e60fd98bb6fb4a457dd90eba667c8bee051b5',
    id: 'range-test-20260619-5001',
    matching_hash: '726d3c058659770d539223020a4cbb510857bc5c',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: 'd23587b1eb9de94b6d13d4ac2423b142a19f4df5',
    id: 'range-test-20260619-5002',
    matching_hash: '060d035911d19760fe69b7aec2bc7c4e0f80c3d0',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '548dc57a5a3075751b4d6441e24ba4499bf4d0d9',
    id: 'range-test-20260619-5003',
    matching_hash: '6103117ecbba532918a774f230e1ac9dadf57da2',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 18,
    a2: 18,
    a3: 18,
    ball_type: BallType.Misc,
    full_hash: '3512f508330340937c858940635f38497dbcaf7b',
    id: 'range-test-20260619-5004',
    matching_hash: '6973024a4c6f3c844fba1de48428fe6113d5f855',
    model_id: '',
    model_key: '',
    px: 0,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '0caa7bf545eb5df29bb873bbcb0efba9235a2323',
    id: 'range-test-20260619-5005',
    matching_hash: 'ee9a95448bcb5bb7a93c0bb8092e36aee5a0d8b7',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'c7ea50a6e9cad52bb775953e47b14bc80c8b593f',
    id: 'range-test-20260619-5006',
    matching_hash: '3fc44fc1685fccd8e58e67e2169287445263b10e',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '1323f2f0bb9bd9544162fb66cb22c2f7e17cc28d',
    id: 'range-test-20260619-5007',
    matching_hash: '8d5ed2b7af234da9d5d80193feba7356d4379904',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: '3665102220a6242794ad4afe38a734a49a0da88e',
    id: 'range-test-20260619-5008',
    matching_hash: '81f9afab1b7f8e342d28e867c752953c76312b07',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'b908bbe1f30290b67cf3f34ab0183bfbddef7ecd',
    id: 'range-test-20260619-5009',
    matching_hash: '82811561cec6cbd2c19f89cff25c9acf4625a6a4',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'c03b7c7552f2cdc17b69d1ede7e7e4c691528c15',
    id: 'range-test-20260619-5010',
    matching_hash: '8a814962e1952a41f51ca9837d434747ffd7b4b5',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -21,
    a2: -21,
    a3: -21,
    ball_type: BallType.Misc,
    full_hash: 'df8946e2067f30c9c1de6e0bdeaebb6b8eceec9a',
    id: 'range-test-20260619-5011',
    matching_hash: 'b26108b90342bd5702ea8c2b40e399869f8b654e',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'fd80031a0ade320c8b0e84556a19aff3394b1545',
    id: 'range-test-20260619-5012',
    matching_hash: 'f75146e8c0f63e04db9c94603825641748b4ea9d',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '2ec45f8ed70bb4b8ed2ddc5ced8efc4be30faf4e',
    id: 'range-test-20260619-5013',
    matching_hash: '61dc353a2a962977a2cf16240842a2a2f1194ba5',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'd97fd7700310b9424d6bba96f985db974d1332c0',
    id: 'range-test-20260619-5014',
    matching_hash: '82301f070dffe1580abaf1d4f0de2a9a3832559a',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'c5de4783b14d8b925d70b737746b2f7a40026ee1',
    id: 'range-test-20260619-5015',
    matching_hash: '44d42fabacc6b4835b7519ba29d7174498f11534',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'cb51879a775dc57a6620ebd35511f634d4c1b76a',
    id: 'range-test-20260619-5016',
    matching_hash: '1aef731ba9c603f1a3a5abb936ac766b84f86fc9',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: '8fd05c2cd54d9273da6e977d2a5e6e76025c19a9',
    id: 'range-test-20260619-5017',
    matching_hash: '147116b5d05c8c5e55464f61d3a17dd9c426ed0d',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -11,
    a2: -11,
    a3: -11,
    ball_type: BallType.Misc,
    full_hash: 'a61fefd37c461676e0dd34682e2dd3e750edf9f4',
    id: 'range-test-20260619-5018',
    matching_hash: 'efa2365cee8aaf8e50c2fc0ad7b59fa0c75482ca',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '2aac00837cebb9f5c1d673e5f8b17d42855c59ea',
    id: 'range-test-20260619-5019',
    matching_hash: 'cd2bdfd6f082120ec64c72c0715ff45c35263001',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'a21628945478b15b403e35181b7e5ce2733e643a',
    id: 'range-test-20260619-5020',
    matching_hash: 'de7e11121af1b3675d500fdabece33826e9db1d8',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '1a921e349da69ecdc17aae074bd51a1c92c1897a',
    id: 'range-test-20260619-5021',
    matching_hash: '57d79e1ebaae2fe83d562a8d40c8d74968b97ccf',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '68f6b57cb94c2c02a2b266876c6c8106907aca1f',
    id: 'range-test-20260619-5022',
    matching_hash: '701361e1c65318d6a1cd54b73342b781e0c0b9c2',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '23642b6406c9ce4ad77b5c9a9b4fa89f03e5d691',
    id: 'range-test-20260619-5023',
    matching_hash: '76d76e2edb2ca26afbd080a72a3a65aee753836f',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: 'caba66ddad1085770d4168b37408b3f559afc131',
    id: 'range-test-20260619-5024',
    matching_hash: '6b00f2760a0c6da480fddad37251ce15d04b6af1',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -1,
    a2: -1,
    a3: -1,
    ball_type: BallType.Misc,
    full_hash: '689e0e72b7ac949ed306ed8cdcfb2e3037ab0c54',
    id: 'range-test-20260619-5025',
    matching_hash: 'da660f37b35b6de4a29fcf6b4bb176d0fc7632ab',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '9be97379d91ba01f4ad8d74673325d28d2f30f9e',
    id: 'range-test-20260619-5026',
    matching_hash: '7b5729e5f2346b5a8ece06e400329bdd1ca553a2',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'be41595023e1f79ae0cf8c2a1a1563e469ae309c',
    id: 'range-test-20260619-5027',
    matching_hash: '585a2c2f419607d0c931e53c5b719ee54ecd262b',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'd82b4641a6a99379184c8e4615b23640fd8bfaae',
    id: 'range-test-20260619-5028',
    matching_hash: '0c632d85ffd76bbcd8f584492985f729fb9df4dd',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '79df6fdeb86da5651f5d0990009810660042b853',
    id: 'range-test-20260619-5029',
    matching_hash: '5aabae371bf5bd15a9646945bc03502d5bcad2c7',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '8758eacdd0da1c9f336cf92f5e3d447cb0f0969e',
    id: 'range-test-20260619-5030',
    matching_hash: '0239dc22ccbb020fa35563316dee59e0f9162ab9',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: '9a568b6c72f5304ed5e8e3df5d63a2dd92cd6056',
    id: 'range-test-20260619-5031',
    matching_hash: 'd90d7d12182f398ec93a2182221d2acaf6c03a6d',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 9,
    a2: 9,
    a3: 9,
    ball_type: BallType.Misc,
    full_hash: 'f6c4e358a020f4ba9de13dd14aceb11e889f55c7',
    id: 'range-test-20260619-5032',
    matching_hash: '02a27725d54bc6ea07066025ac9b5ae075cd705b',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '7b36026bdb91ce3b24e9182f248631b2a2cdb06e',
    id: 'range-test-20260619-5033',
    matching_hash: '78dc369637906ff607f1a36fa79f8ee63569b896',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '1e46c1d6e44fdcb39b84b2d0f1e49e1757dc11b6',
    id: 'range-test-20260619-5034',
    matching_hash: '875eb749781d4e5655d5526a254774f791c962dd',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '5ac387a8b29b8485e4a7a93ac1b2a9785fcf6254',
    id: 'range-test-20260619-5035',
    matching_hash: '434f623defb5ce05edf8b384a72b93cfdb46d428',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '10dfd463ff26e846c8c32751fbbf28b33be0a828',
    id: 'range-test-20260619-5036',
    matching_hash: 'c984cb4d8c37f25e1a92dacb23acef3a949a236e',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: '11c4ceb514826532dca214466a37532e18472745',
    id: 'range-test-20260619-5037',
    matching_hash: '3273330fb8097a307e73541591cf46363dfe15c8',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'e7ec7d7494943a63a41bb7f8dea79e3253769c9c',
    id: 'range-test-20260619-5038',
    matching_hash: 'e52a76f21cb8ca90566fb452e0749d4757d36e0e',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 19,
    a2: 19,
    a3: 19,
    ball_type: BallType.Misc,
    full_hash: 'd282085bd44ba6d60a6f5608b56e2aa0125b8888',
    id: 'range-test-20260619-5039',
    matching_hash: '34522074a00a07f17b8a3724c7f187db6a8a7f44',
    model_id: '',
    model_key: '',
    px: 1.6,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '8cebfd14c4c0ecea3f240f0a82d9a96da6f41b55',
    id: 'range-test-20260619-5040',
    matching_hash: '223ee647911d923eb80ff2df2b1c408a2b2b7bc3',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '1d6e50cb0eb282bf9d2174eb0daf8a60f4db345b',
    id: 'range-test-20260619-5041',
    matching_hash: '38298cae545345031ea1e541422bb52c87f07f5c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'e5d4475399878cb761ea992475bea3a579d3f2f0',
    id: 'range-test-20260619-5042',
    matching_hash: '03721c37b6e86f21ba88c8b7cac5ef481e74d1bc',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '290b0de55b2edfd267b3514251b0ca562606a135',
    id: 'range-test-20260619-5043',
    matching_hash: '560840e2308bb09309ff3b6704e9c06b7bff9009',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '3209c29ec90e2cfd2680c1eeec28e3f8b8e5ceab',
    id: 'range-test-20260619-5044',
    matching_hash: '15321b7e9018465c64e09c5e0ab21d2e4ce6295e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: 'db00dbbdc6eddc26c72cdfc373d6fb209259fcee',
    id: 'range-test-20260619-5045',
    matching_hash: '8bafe8ba72424cc3acc3e89e562104aa1f386523',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -20,
    a2: -20,
    a3: -20,
    ball_type: BallType.Misc,
    full_hash: '38bd6bfcc17c662caddb95c00b2d12a08a648291',
    id: 'range-test-20260619-5046',
    matching_hash: 'ef8bfdd1bb2fa41d93765ef1422165fc4299d24b',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: '472a90e910705fc1a714ff155d50cdb1859401fd',
    id: 'range-test-20260619-5047',
    matching_hash: '98ee033e2d3c8535deaae4b3b408967aa14bc76f',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'cb07ca15ad97be98a593811089216e48b3d459bd',
    id: 'range-test-20260619-5048',
    matching_hash: 'e40d84e70da7162b3f69f68e11f2a06198b3c01e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'e45cbb96ed76b25da52330e34f2b9a5cbf4f344d',
    id: 'range-test-20260619-5049',
    matching_hash: 'e8b1c2af2441212b956d69732220ff1655c4d19a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'b3b3637aae7b273f60702f960383d197043f644a',
    id: 'range-test-20260619-5050',
    matching_hash: '9a5949fb9fdb4f5ebce1694824097d2c6593ec03',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'adbbc1f626ac3ee12bf310cb51c471440d5c2a87',
    id: 'range-test-20260619-5051',
    matching_hash: '745378dfc6274f946c669871bcedebc5aac7f733',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'b7a25b5229c20e692f0086f840f2f972cff51613',
    id: 'range-test-20260619-5052',
    matching_hash: '79eb3c5e2ac9f7343d36f6ef1ee36ac5bfca3102',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: -10,
    a2: -10,
    a3: -10,
    ball_type: BallType.Misc,
    full_hash: 'ac32581b1a2d2a3e2b8c6d76e5c678b0ae83efda',
    id: 'range-test-20260619-5053',
    matching_hash: 'd8562d1782eb422c8aebe254b7bc9dc3e96940ec',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '7426e0839d4c8ced42c8faa2fcc8b1df39632fce',
    id: 'range-test-20260619-5054',
    matching_hash: '91ca0afdf6d3c9e0a76c8aa35f6138d3104ae897',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '5965ad4c258a021c704c44c6baa28246bab04edf',
    id: 'range-test-20260619-5055',
    matching_hash: 'cd58e48fe1f59bad53cf8086b04035bfb8967e99',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '8605c3cebee4800fc35fdeee8a7c3c4649a4533a',
    id: 'range-test-20260619-5056',
    matching_hash: '3fcc3765e7171f6b709232faa310c160e23fc465',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '4f72a33c40301eda9142d0a5a6a928aa2753aaad',
    id: 'range-test-20260619-5057',
    matching_hash: '147278d7dd767dbe8f408f05815ffff51982b478',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '1c861276e00d22b73e146d8bd7625ca496f5fdc7',
    id: 'range-test-20260619-5058',
    matching_hash: 'ec59bdca9cd6f353f81d912b7d29481a6e07a66a',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '5a13b6dd0d1f4f6ae2aa92137385bdc2d01d4d69',
    id: 'range-test-20260619-5059',
    matching_hash: 'b12127933cf07dab48f16e866feb5fed0343c9e1',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 0,
    a2: 0,
    a3: 0,
    ball_type: BallType.Misc,
    full_hash: '1c46b9f9e7046f38c8f8e14933a6fdebefa2c1d3',
    id: 'range-test-20260619-5060',
    matching_hash: '8b4133afd9b2f52d7042fe3caab9bd129408bc12',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '3eeb972ccf647b3222493afa69bc10afd7a9ce88',
    id: 'range-test-20260619-5061',
    matching_hash: 'd9fd1c790c64641ce9b57b549aab7003df2d85b0',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '3cc9829536235b91cf55b243761e51d847039946',
    id: 'range-test-20260619-5062',
    matching_hash: 'b8eed715ffbf7b6a8218d8458e72fca4e58890c7',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '6a5d6bd8588bbc7b84201adaf6f58d00fcd92c5d',
    id: 'range-test-20260619-5063',
    matching_hash: '89cc6eb0a7f722a73c925e078662c7d9b383b86c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '8133853e4d0d6ec5b4c64eb7d4351360ec81e9aa',
    id: 'range-test-20260619-5064',
    matching_hash: '48b9a44ff960cf04e33ed0719f8a5aa6129d786c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'd8798448a34db95009887c476e4d4ab61bf27ce6',
    id: 'range-test-20260619-5065',
    matching_hash: '5f8acdca5415928f5c2ad432a91df45f9c62e569',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: '0769c3673f2ef91c85aa90273bce1dfa4001a070',
    id: 'range-test-20260619-5066',
    matching_hash: 'd6b18b3bc72327aae00bf86b72eae6c3e298f12c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 10,
    a2: 10,
    a3: 10,
    ball_type: BallType.Misc,
    full_hash: 'b0df7bffe7e45cf2a1c2a75fa9b1f91ef2bafa63',
    id: 'range-test-20260619-5067',
    matching_hash: 'f30c524874c14c2b7cd6089b34a3c76114d4714c',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '5f6615179b34426e4965818693a6e5af3cab4418',
    id: 'range-test-20260619-5068',
    matching_hash: 'bbbc4b5f870f285feb6d0e9916ca6be4a09f230e',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1400,
    w2: 1400,
    w3: 1400,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'd72a5ad48305c89515366d173dccd3f66e389dbe',
    id: 'range-test-20260619-5069',
    matching_hash: 'bf44046d60bdbedacb48c001f6d83eb2c53cf991',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1600,
    w2: 1600,
    w3: 1600,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '0929663a2379601df80688067d52837df227590b',
    id: 'range-test-20260619-5070',
    matching_hash: '3604257055989464cd20b1d74038a04f874a7771',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 1800,
    w2: 1800,
    w3: 1800,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '22a0e0819824c8204aa60667280df323f398cc5f',
    id: 'range-test-20260619-5071',
    matching_hash: 'a16d089eb3aa756b0eaeb75e7bcf496ebaa50d02',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2000,
    w2: 2000,
    w3: 2000,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '8f1ce5b2df9e932a5046ef4aa76a53bb4d019667',
    id: 'range-test-20260619-5072',
    matching_hash: '0a82bfb365f466e39aab832335d63a324a1f2dde',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2200,
    w2: 2200,
    w3: 2200,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: '3f9ec4c51afc10db06ab7399a2be95735532d4f1',
    id: 'range-test-20260619-5073',
    matching_hash: 'bc7d166d1531bbdf63075d462deb5203c77c09db',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2400,
    w2: 2400,
    w3: 2400,
    yaw: 0,
  },
  {
    a1: 20,
    a2: 20,
    a3: 20,
    ball_type: BallType.Misc,
    full_hash: 'd1be3c6f66aa31da6fef234c319115eeb2bc2908',
    id: 'range-test-20260619-5074',
    matching_hash: '354715f6869dca26588f642593b9242a3c3fbb01',
    model_id: '',
    model_key: '',
    px: 3.2,
    py: 55,
    pz: 7,
    qw: 0.912044708,
    qx: -0.284738208,
    qy: 0.015508177,
    qz: 0.294716982,
    tilt: 0,
    training: false,
    w1: 2500,
    w2: 2500,
    w3: 2500,
    yaw: 0,
  },
];
